
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/ag-grid-community/src/localEventService.ts
var $437b23f6a393c3bf$export$820da7696a401cdc = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) (async ? this.allAsyncListeners : this.allSyncListeners).delete(eventType);
    }
    addGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        this.getGlobalListeners(async).delete(listener);
    }
    dispatchEvent(event) {
        const agEvent = event;
        this.dispatchToListeners(agEvent, true);
        this.dispatchToListeners(agEvent, false);
        this.firedEvents[agEvent.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const { frameworkOverrides: frameworkOverrides } = this;
        const runCallback = (func)=>{
            const callback = frameworkOverrides ? ()=>frameworkOverrides.wrapIncoming(func) : func;
            if (async) this.dispatchAsync(callback);
            else callback();
        };
        const originalListeners = this.getListeners(eventType, async, false);
        if ((originalListeners?.size ?? 0) > 0) {
            const listeners = new Set(originalListeners);
            for (const listener of listeners){
                if (!originalListeners?.has(listener)) continue;
                runCallback(()=>listener(event));
            }
        }
        const globalListenersSrc = this.getGlobalListeners(async);
        if (globalListenersSrc.size > 0) {
            const globalListeners = new Set(globalListenersSrc);
            for (const listener of globalListeners)runCallback(()=>listener(eventType, event));
        }
    }
    getGlobalListeners(async) {
        return async ? this.globalAsyncListeners : this.globalSyncListeners;
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            const flush = ()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            };
            this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(flush) : flush();
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        queueCopy.forEach((func)=>func());
    }
};
// packages/ag-grid-community/src/misc/locale/localeUtils.ts
function $437b23f6a393c3bf$var$defaultLocaleTextFunc(_key, defaultValue) {
    return defaultValue;
}
function $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc) {
    return localeSvc?.getLocaleTextFunc() ?? $437b23f6a393c3bf$var$defaultLocaleTextFunc;
}
// packages/ag-grid-community/src/utils/aria.ts
function $437b23f6a393c3bf$var$_toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute);
    else $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value);
}
function $437b23f6a393c3bf$var$_setAriaAttribute(element, attribute, value) {
    element.setAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute), value.toString());
}
function $437b23f6a393c3bf$var$_removeAriaAttribute(element, attribute) {
    element.removeAttribute($437b23f6a393c3bf$var$_ariaAttributeName(attribute));
}
function $437b23f6a393c3bf$var$_ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function $437b23f6a393c3bf$export$f8d01fa01787902(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function $437b23f6a393c3bf$var$_getAriaSortState(sortDirection) {
    let sort;
    if (sortDirection === "asc") sort = "ascending";
    else if (sortDirection === "desc") sort = "descending";
    else if (sortDirection === "mixed") sort = "other";
    else sort = "none";
    return sort;
}
function $437b23f6a393c3bf$export$70c3a20563598672(element) {
    return parseInt(element.getAttribute("aria-posinset"), 10);
}
function $437b23f6a393c3bf$var$_getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, label) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "label", label);
}
function $437b23f6a393c3bf$export$84233c40c4c74001(element, labelledBy) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "labelledby", labelledBy);
}
function $437b23f6a393c3bf$export$3c2bc877474a7797(element, describedby) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "describedby", describedby);
}
function $437b23f6a393c3bf$var$_setAriaLive(element, live) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "live", live);
}
function $437b23f6a393c3bf$var$_setAriaAtomic(element, atomic) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "atomic", atomic);
}
function $437b23f6a393c3bf$var$_setAriaRelevant(element, relevant) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "relevant", relevant);
}
function $437b23f6a393c3bf$export$9eaf1f20171625e8(element, level) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "level", level);
}
function $437b23f6a393c3bf$export$7ed376f43c6f2bbd(element, disabled) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "disabled", disabled);
}
function $437b23f6a393c3bf$export$ee52c2b3744c455d(element, hidden) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "hidden", hidden);
}
function $437b23f6a393c3bf$export$5db804730c3c8346(element, descendantId) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "activedescendant", descendantId);
}
function $437b23f6a393c3bf$export$3ad3518dddf15485(element, expanded) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "expanded", expanded);
}
function $437b23f6a393c3bf$export$2254dfb132f01330(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "expanded");
}
function $437b23f6a393c3bf$export$3d494c2007bbcac1(element, setsize) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "setsize", setsize);
}
function $437b23f6a393c3bf$export$c3d3aede41065a84(element, position) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "posinset", position);
}
function $437b23f6a393c3bf$var$_setAriaMultiSelectable(element, multiSelectable) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "multiselectable", multiSelectable);
}
function $437b23f6a393c3bf$export$1ad8496b26b660f8(element, rowCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowcount", rowCount);
}
function $437b23f6a393c3bf$export$ba731dedf9d88615(element, rowIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowindex", rowIndex);
}
function $437b23f6a393c3bf$var$_setAriaRowSpan(element, spanCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "rowspan", spanCount);
}
function $437b23f6a393c3bf$export$56744a26086b5898(element, colCount) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colcount", colCount);
}
function $437b23f6a393c3bf$export$84b73ecd0b234e89(element, colIndex) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colindex", colIndex);
}
function $437b23f6a393c3bf$export$371d80f0281454ce(element, colSpan) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "colspan", colSpan);
}
function $437b23f6a393c3bf$export$c8dd030b968c6fd2(element, sort) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "sort", sort);
}
function $437b23f6a393c3bf$export$26c7aa61eda05134(element) {
    $437b23f6a393c3bf$var$_removeAriaAttribute(element, "sort");
}
function $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "selected", selected);
}
function $437b23f6a393c3bf$export$43b4d6c0ec0fa4c7(element, checked) {
    $437b23f6a393c3bf$var$_setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function $437b23f6a393c3bf$export$26fd6a3f123d4e67(controllerElement, controlledElement) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(controllerElement, "controls", controlledElement.id);
    $437b23f6a393c3bf$export$84233c40c4c74001(controlledElement, controllerElement.id);
}
function $437b23f6a393c3bf$export$668d180e9cbef6da(element, hasPopup) {
    $437b23f6a393c3bf$var$_toggleAriaAttribute(element, "haspopup", hasPopup === false ? null : hasPopup);
}
function $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// packages/ag-grid-community/src/utils/browser.ts
var $437b23f6a393c3bf$var$isSafari;
var $437b23f6a393c3bf$var$isFirefox;
var $437b23f6a393c3bf$var$isMacOs;
var $437b23f6a393c3bf$var$isIOS;
var $437b23f6a393c3bf$var$invisibleScrollbar;
var $437b23f6a393c3bf$var$browserScrollbarWidth;
var $437b23f6a393c3bf$var$maxDivHeight;
function $437b23f6a393c3bf$var$_isBrowserSafari() {
    if ($437b23f6a393c3bf$var$isSafari === void 0) $437b23f6a393c3bf$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isSafari;
}
function $437b23f6a393c3bf$var$_isBrowserFirefox() {
    if ($437b23f6a393c3bf$var$isFirefox === void 0) $437b23f6a393c3bf$var$isFirefox = /(firefox)/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isFirefox;
}
function $437b23f6a393c3bf$var$_isMacOsUserAgent() {
    if ($437b23f6a393c3bf$var$isMacOs === void 0) $437b23f6a393c3bf$var$isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return $437b23f6a393c3bf$var$isMacOs;
}
function $437b23f6a393c3bf$export$6b6034a68325bd8a() {
    if ($437b23f6a393c3bf$var$isIOS === void 0) $437b23f6a393c3bf$var$isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $437b23f6a393c3bf$var$isIOS;
}
function $437b23f6a393c3bf$var$_getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !$437b23f6a393c3bf$var$_isBrowserFirefox())) return null;
    return numberTabIndex.toString();
}
function $437b23f6a393c3bf$var$_getMaxDivHeight() {
    if ($437b23f6a393c3bf$var$maxDivHeight !== void 0) return $437b23f6a393c3bf$var$maxDivHeight;
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = $437b23f6a393c3bf$var$_isBrowserFirefox() ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    document.body.removeChild(div);
    $437b23f6a393c3bf$var$maxDivHeight = res;
    return res;
}
function $437b23f6a393c3bf$var$_getScrollbarWidth() {
    if ($437b23f6a393c3bf$var$browserScrollbarWidth == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$browserScrollbarWidth;
}
function $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.parentNode.removeChild(div);
    if (width != null) {
        $437b23f6a393c3bf$var$browserScrollbarWidth = width;
        $437b23f6a393c3bf$var$invisibleScrollbar = width === 0;
    }
}
function $437b23f6a393c3bf$var$_isInvisibleScrollbar() {
    if ($437b23f6a393c3bf$var$invisibleScrollbar == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$invisibleScrollbar;
}
// packages/ag-grid-community/src/utils/dom.ts
function $437b23f6a393c3bf$export$605571c1b2992cfe(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function $437b23f6a393c3bf$var$_isFocusableFormField(element) {
    const matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    const inputSelector = "input, select, button, textarea";
    const isFocusable = matches.call(element, inputSelector);
    const isNotFocusable = matches.call(element, $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE);
    const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(element);
    const focusable = isFocusable && !isNotFocusable && isElementVisible;
    return focusable;
}
function $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !displayed);
}
function $437b23f6a393c3bf$export$a6c2c477cd60daa8(element, visible, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) $437b23f6a393c3bf$export$ee52c2b3744c455d(element, !visible);
}
function $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    const inputs = element.querySelectorAll("input") ?? [];
    for (const input of inputs)addOrRemoveDisabledAttribute(input);
}
function $437b23f6a393c3bf$var$_isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function $437b23f6a393c3bf$var$_getElementSize(el) {
    const { height: height, width: width, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, boxSizing: boxSizing } = window.getComputedStyle(el);
    return {
        height: parseFloat(height || "0"),
        width: parseFloat(width || "0"),
        borderTopWidth: parseFloat(borderTopWidth || "0"),
        borderRightWidth: parseFloat(borderRightWidth || "0"),
        borderBottomWidth: parseFloat(borderBottomWidth || "0"),
        borderLeftWidth: parseFloat(borderLeftWidth || "0"),
        paddingTop: parseFloat(paddingTop || "0"),
        paddingRight: parseFloat(paddingRight || "0"),
        paddingBottom: parseFloat(paddingBottom || "0"),
        paddingLeft: parseFloat(paddingLeft || "0"),
        marginTop: parseFloat(marginTop || "0"),
        marginRight: parseFloat(marginRight || "0"),
        marginBottom: parseFloat(marginBottom || "0"),
        marginLeft: parseFloat(marginLeft || "0"),
        boxSizing: boxSizing
    };
}
function $437b23f6a393c3bf$export$c20e968103d9c16e(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom;
    return size.height;
}
function $437b23f6a393c3bf$export$cc615e4191ec3e0c(el) {
    const size = $437b23f6a393c3bf$var$_getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight;
    return size.width;
}
function $437b23f6a393c3bf$export$d23c22492e0f7c0c(el) {
    const { height: height, marginBottom: marginBottom, marginTop: marginTop } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(height + marginBottom + marginTop);
}
function $437b23f6a393c3bf$export$642efcb17474eb51(el) {
    const { width: width, marginLeft: marginLeft, marginRight: marginRight } = $437b23f6a393c3bf$var$_getElementSize(el);
    return Math.floor(width + marginLeft + marginRight);
}
function $437b23f6a393c3bf$var$_getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = $437b23f6a393c3bf$var$_getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function $437b23f6a393c3bf$var$_getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) scrollLeft = Math.abs(scrollLeft);
    return scrollLeft;
}
function $437b23f6a393c3bf$var$_setScrollLeft(element, value, rtl) {
    if (rtl) value *= -1;
    element.scrollLeft = value;
}
function $437b23f6a393c3bf$export$69e6e10709eabd91(el) {
    while(el && el.firstChild)el.removeChild(el.firstChild);
}
function $437b23f6a393c3bf$export$dd4d52e41fb4cef5(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
}
function $437b23f6a393c3bf$var$_isInDOM(element) {
    return !!element.offsetParent;
}
function $437b23f6a393c3bf$export$2badf4aa566524cb(element) {
    const el = element;
    if (el.checkVisibility) return el.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !$437b23f6a393c3bf$var$_isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function $437b23f6a393c3bf$export$b1f57d075ca6d5fb(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function $437b23f6a393c3bf$var$_ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (!eContainer.firstChild) eContainer.appendChild(eChild);
    else if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function $437b23f6a393c3bf$var$_setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function $437b23f6a393c3bf$var$_camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
function $437b23f6a393c3bf$var$_addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const key of Object.keys(styles)){
        const value = styles[key];
        if (!key || !key.length || value == null) continue;
        const parsedKey = $437b23f6a393c3bf$var$_camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function $437b23f6a393c3bf$var$_isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function $437b23f6a393c3bf$var$_isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function $437b23f6a393c3bf$var$_setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
}
function $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width) {
    width = $437b23f6a393c3bf$var$_formatSize(width);
    element.style.width = width;
    element.style.maxWidth = width;
    element.style.minWidth = width;
}
function $437b23f6a393c3bf$var$_setFixedHeight(element, height) {
    height = $437b23f6a393c3bf$var$_formatSize(height);
    element.style.height = height;
    element.style.maxHeight = height;
    element.style.minHeight = height;
}
function $437b23f6a393c3bf$var$_formatSize(size) {
    return typeof size === "number" ? `${size}px` : size;
}
function $437b23f6a393c3bf$export$6e6303ef478b0c94(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, name, value) {
    if (value == null || value === "") element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function $437b23f6a393c3bf$export$9aef8476630687be(beans, element, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    const ResizeObserverImpl = win.ResizeObserver;
    const resizeObserver = ResizeObserverImpl ? new ResizeObserverImpl(callback) : null;
    resizeObserver?.observe(element);
    return ()=>resizeObserver?.disconnect();
}
function $437b23f6a393c3bf$var$_getTextSelectionRanges(beans) {
    const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
    const selection = "getSelection" in rootNode ? rootNode.getSelection() : null;
    const ranges = [];
    for(let i = 0; i < (selection?.rangeCount ?? 0); i++){
        const range = selection?.getRangeAt(i);
        if (range) ranges.push(range);
    }
    return {
        selection: selection,
        ranges: ranges
    };
}
function $437b23f6a393c3bf$export$13e15fa0b6986f21(beans, fn) {
    const enableCellTextSelection = beans.gos.get("enableCellTextSelection");
    if (!enableCellTextSelection) return fn();
    if (!$437b23f6a393c3bf$var$_isBrowserFirefox() && !$437b23f6a393c3bf$var$_isBrowserSafari()) return fn();
    const { selection: selection, ranges: ranges } = $437b23f6a393c3bf$var$_getTextSelectionRanges(beans);
    fn();
    selection?.removeAllRanges();
    for (const range of ranges)selection?.addRange(range);
}
function $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, callback) {
    const win = $437b23f6a393c3bf$var$_getWindow(beans);
    if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
    else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
    else win.setTimeout(callback, 0);
}
var $437b23f6a393c3bf$var$DataRefAttribute = "data-ref";
var $437b23f6a393c3bf$var$whitespaceNode;
function $437b23f6a393c3bf$var$getWhitespaceNode() {
    $437b23f6a393c3bf$var$whitespaceNode ?? ($437b23f6a393c3bf$var$whitespaceNode = document.createTextNode(" "));
    return $437b23f6a393c3bf$var$whitespaceNode.cloneNode();
}
function $437b23f6a393c3bf$export$a232bb0480ae674a(params) {
    const { attrs: attrs, children: children, cls: cls, ref: ref, role: role, tag: tag } = params;
    const element = document.createElement(tag);
    if (cls) element.className = cls;
    if (ref) element.setAttribute($437b23f6a393c3bf$var$DataRefAttribute, ref);
    if (role) element.setAttribute("role", role);
    if (attrs) for (const key of Object.keys(attrs))element.setAttribute(key, attrs[key]);
    if (children) {
        if (typeof children === "string") element.textContent = children;
        else {
            let addFirstWhitespace = true;
            for (const child of children)if (child) {
                if (typeof child === "string") {
                    element.appendChild(document.createTextNode(child));
                    addFirstWhitespace = false;
                } else {
                    if (addFirstWhitespace) {
                        element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                        addFirstWhitespace = false;
                    }
                    element.append($437b23f6a393c3bf$export$a232bb0480ae674a(child));
                    element.appendChild($437b23f6a393c3bf$var$getWhitespaceNode());
                }
            }
        }
    }
    return element;
}
// packages/ag-grid-community/src/utils/function.ts
var $437b23f6a393c3bf$var$doOnceFlags = {};
function $437b23f6a393c3bf$export$e150fb6ea3b45c0d(func, key) {
    if ($437b23f6a393c3bf$var$doOnceFlags[key]) return;
    func();
    $437b23f6a393c3bf$var$doOnceFlags[key] = true;
}
function $437b23f6a393c3bf$var$_logIfDebug(gos, message, ...args) {
    if (gos.get("debug")) console.log("AG Grid: " + message, ...args);
}
function $437b23f6a393c3bf$export$2cf41453020eef66(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.warn("AG Grid: " + msg, ...args), msg + args?.join(""));
}
function $437b23f6a393c3bf$var$_errorOnce(msg, ...args) {
    $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>console.error("AG Grid: " + msg, ...args), msg + args?.join(""));
}
var $437b23f6a393c3bf$var$batchedCallsSetTimeout = {
    pending: false,
    funcs: []
};
var $437b23f6a393c3bf$var$batchedCallsRaf = {
    pending: false,
    funcs: []
};
function $437b23f6a393c3bf$export$8ea55376d0d59592(func, mode = "setTimeout", beans) {
    const batch = mode === "raf" ? $437b23f6a393c3bf$var$batchedCallsRaf : $437b23f6a393c3bf$var$batchedCallsSetTimeout;
    batch.funcs.push(func);
    if (batch.pending) return;
    batch.pending = true;
    const runBatch = ()=>{
        const funcsCopy = batch.funcs.slice();
        batch.funcs.length = 0;
        batch.pending = false;
        funcsCopy.forEach((func2)=>func2());
    };
    if (mode === "raf") $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, runBatch);
    else window.setTimeout(runBatch, 0);
}
function $437b23f6a393c3bf$export$cf7e39bfb94de6e(bean, func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            if (bean.isAlive()) func.apply(context, args);
        }, delay);
    };
}
function $437b23f6a393c3bf$var$_throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = Date.now();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function $437b23f6a393c3bf$export$b863e7aac7884b8(condition, callback, timeout = 100, timeoutMessage) {
    const timeStamp = Date.now();
    let interval = null;
    let executed = false;
    const internalCallback = ()=>{
        const reachedTimeout = Date.now() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            if (interval != null) {
                window.clearInterval(interval);
                interval = null;
            }
            if (reachedTimeout && timeoutMessage) $437b23f6a393c3bf$export$2cf41453020eef66(timeoutMessage);
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
// packages/ag-grid-community/src/utils/generic.ts
function $437b23f6a393c3bf$export$4978424c4f7b5fc0(value) {
    if (value == null || value === "") return null;
    return value;
}
function $437b23f6a393c3bf$export$25d27f17d3af40f7(value) {
    return value != null && value !== "";
}
function $437b23f6a393c3bf$export$672d9e47bc342bac(value) {
    return !$437b23f6a393c3bf$export$25d27f17d3af40f7(value);
}
function $437b23f6a393c3bf$export$2a74c29220d5c88e(value) {
    return value != null && typeof value.toString === "function" ? value.toString() : null;
}
function $437b23f6a393c3bf$export$dbc2068cc90f5875(val1, val2) {
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
}
function $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, accentedCompare = false) {
    const valueAMissing = valueA == null;
    const valueBMissing = valueB == null;
    if (valueA && valueA.toNumber) valueA = valueA.toNumber();
    if (valueB && valueB.toNumber) valueB = valueB.toNumber();
    if (valueAMissing && valueBMissing) return 0;
    if (valueAMissing) return -1;
    if (valueBMissing) return 1;
    function doQuickCompare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    if (typeof valueA !== "string") return doQuickCompare(valueA, valueB);
    if (!accentedCompare) return doQuickCompare(valueA, valueB);
    try {
        return valueA.localeCompare(valueB);
    } catch (e) {
        return doQuickCompare(valueA, valueB);
    }
}
// packages/ag-grid-community/src/baseUrl.ts
var $437b23f6a393c3bf$var$BASE_URL = "https://www.ag-grid.com";
// packages/ag-grid-community/src/version.ts
var $437b23f6a393c3bf$var$VERSION = "33.3.2";
// packages/ag-grid-community/src/validation/logging.ts
var $437b23f6a393c3bf$var$MAX_URL_LENGTH = 2e3;
var $437b23f6a393c3bf$var$MIN_PARAM_LENGTH = 100;
var $437b23f6a393c3bf$var$VERSION_PARAM_NAME = "_version_";
var $437b23f6a393c3bf$var$validation = null;
var $437b23f6a393c3bf$var$suppressAllLogging = false;
var $437b23f6a393c3bf$var$baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/javascript-data-grid`;
function $437b23f6a393c3bf$var$provideValidationServiceLogger(logger) {
    $437b23f6a393c3bf$var$validation = logger;
}
function $437b23f6a393c3bf$var$setValidationDocLink(docLink) {
    $437b23f6a393c3bf$var$baseDocLink = docLink;
}
function $437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage) {
    return $437b23f6a393c3bf$var$validation?.getConsoleMessage(id, args) ?? [
        $437b23f6a393c3bf$var$minifiedLog(id, args, defaultMessage)
    ];
}
function $437b23f6a393c3bf$var$getMsgOrDefault(logger, id, args, defaultMessage) {
    if ($437b23f6a393c3bf$var$suppressAllLogging) return;
    logger(`error #${id}`, ...$437b23f6a393c3bf$var$getErrorParts(id, args, defaultMessage));
}
function $437b23f6a393c3bf$var$stringifyObject(inputObj) {
    if (!inputObj) return String(inputObj);
    const object = {};
    for (const prop of Object.keys(inputObj))if (typeof inputObj[prop] !== "object" && typeof inputObj[prop] !== "function") object[prop] = inputObj[prop];
    return JSON.stringify(object);
}
function $437b23f6a393c3bf$var$stringifyValue(value) {
    let output = value;
    if (value instanceof Error) output = value.toString();
    else if (typeof value === "object") output = $437b23f6a393c3bf$var$stringifyObject(value);
    return output;
}
function $437b23f6a393c3bf$var$toStringWithNullUndefined(str) {
    return str === void 0 ? "undefined" : str === null ? "null" : str;
}
function $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params) {
    return `${baseUrl}?${params.toString()}`;
}
function $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, maxLength) {
    const sortedParams = Array.from(params.entries()).sort((a, b)=>b[1].length - a[1].length);
    let url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    for (const [key, value] of sortedParams){
        if (key === $437b23f6a393c3bf$var$VERSION_PARAM_NAME) continue;
        const excessLength = url.length - maxLength;
        if (excessLength <= 0) break;
        const ellipse = "...";
        const truncateAmount = excessLength + ellipse.length;
        const truncatedValue = value.length - truncateAmount > $437b23f6a393c3bf$var$MIN_PARAM_LENGTH ? value.slice(0, value.length - truncateAmount) + ellipse : value.slice(0, $437b23f6a393c3bf$var$MIN_PARAM_LENGTH) + ellipse;
        params.set(key, truncatedValue);
        url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    }
    return url;
}
function $437b23f6a393c3bf$var$getErrorLink(errorNum, args) {
    const params = new URLSearchParams();
    params.append($437b23f6a393c3bf$var$VERSION_PARAM_NAME, $437b23f6a393c3bf$var$VERSION);
    if (args) for (const key of Object.keys(args))params.append(key, $437b23f6a393c3bf$var$stringifyValue(args[key]));
    const baseUrl = `${$437b23f6a393c3bf$var$baseDocLink}/errors/${errorNum}`;
    const url = $437b23f6a393c3bf$var$getParamsUrl(baseUrl, params);
    return url.length <= $437b23f6a393c3bf$var$MAX_URL_LENGTH ? url : $437b23f6a393c3bf$var$truncateUrl(baseUrl, params, $437b23f6a393c3bf$var$MAX_URL_LENGTH);
}
var $437b23f6a393c3bf$var$minifiedLog = (errorNum, args, defaultMessage)=>{
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorNum, args);
    return `${defaultMessage ? defaultMessage + " \n" : ""}Visit ${errorLink}${defaultMessage ? "" : " \n  Alternatively register the ValidationModule to see the full message in the console."}`;
};
function $437b23f6a393c3bf$export$545083624300f13d(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$export$2cf41453020eef66, args[0], args[1]);
}
function $437b23f6a393c3bf$export$a20c7248650823a9(...args) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, args[0], args[1]);
}
function $437b23f6a393c3bf$var$_logPreInitErr(id, args, defaultMessage) {
    $437b23f6a393c3bf$var$getMsgOrDefault($437b23f6a393c3bf$var$_errorOnce, id, args, defaultMessage);
}
function $437b23f6a393c3bf$var$getErrMsg(defaultMessage, args) {
    const id = args[0];
    return `error #${id} ` + $437b23f6a393c3bf$var$getErrorParts(id, args[1], defaultMessage).join(" ");
}
function $437b23f6a393c3bf$export$680bb5102fca525e(...args) {
    return $437b23f6a393c3bf$var$getErrMsg(void 0, args);
}
function $437b23f6a393c3bf$export$d73cab7876c2c868(...args) {
    return $437b23f6a393c3bf$var$getErrMsg("\n", args);
}
// packages/ag-grid-community/src/gridOptionsUtils.ts
function $437b23f6a393c3bf$var$isRowModelType(gos, rowModelType) {
    return gos.get("rowModelType") === rowModelType;
}
function $437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "clientSide");
}
function $437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel) {
    return $437b23f6a393c3bf$var$isRowModelType(gos, "serverSide");
}
function $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, domLayout) {
    return gos.get("domLayout") === domLayout;
}
function $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) {
    return $437b23f6a393c3bf$export$80b6607444b3274f(gos) !== void 0;
}
function $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos) {
    return typeof gos.get("getRowHeight") === "function";
}
function $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(gos, isPivotColumns) {
    if (isPivotColumns) return !gos.get("enableStrictPivotColumnOrder");
    return gos.get("maintainColumnOrder");
}
function $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate = false, defaultRowHeight) {
    const { gos: gos, environment: environment } = beans;
    if (defaultRowHeight == null) defaultRowHeight = environment.getDefaultRowHeight();
    if ($437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(gos)) {
        if (allowEstimate) return {
            height: defaultRowHeight,
            estimated: true
        };
        const params = {
            node: rowNode,
            data: rowNode.data
        };
        const height = gos.getCallback("getRowHeight")(params);
        if ($437b23f6a393c3bf$var$isNumeric(height)) {
            if (height === 0) $437b23f6a393c3bf$export$545083624300f13d(23);
            return {
                height: Math.max(1, height),
                estimated: false
            };
        }
    }
    if (rowNode.detail && gos.get("masterDetail")) return $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos);
    const gridOptionsRowHeight = gos.get("rowHeight");
    const rowHeight = gridOptionsRowHeight && $437b23f6a393c3bf$var$isNumeric(gridOptionsRowHeight) ? gridOptionsRowHeight : defaultRowHeight;
    return {
        height: rowHeight,
        estimated: false
    };
}
function $437b23f6a393c3bf$var$getMasterDetailRowHeight(gos) {
    if (gos.get("detailRowAutoHeight")) return {
        height: 1,
        estimated: false
    };
    const defaultRowHeight = gos.get("detailRowHeight");
    if ($437b23f6a393c3bf$var$isNumeric(defaultRowHeight)) return {
        height: defaultRowHeight,
        estimated: false
    };
    return {
        height: 300,
        estimated: false
    };
}
function $437b23f6a393c3bf$export$8966875adec41e5b(beans) {
    const { environment: environment, gos: gos } = beans;
    const gridOptionsRowHeight = gos.get("rowHeight");
    if (!gridOptionsRowHeight || $437b23f6a393c3bf$export$672d9e47bc342bac(gridOptionsRowHeight)) return environment.getDefaultRowHeight();
    const rowHeight = environment.refreshRowHeightVariable();
    if (rowHeight !== -1) return rowHeight;
    $437b23f6a393c3bf$export$545083624300f13d(24);
    return environment.getDefaultRowHeight();
}
function $437b23f6a393c3bf$var$isNumeric(value) {
    return !isNaN(value) && typeof value === "number" && isFinite(value);
}
function $437b23f6a393c3bf$var$_getDomData(gos, element, key) {
    const domData = element[gos.getDomDataKey()];
    return domData ? domData[key] : void 0;
}
function $437b23f6a393c3bf$var$_setDomData(gos, element, key, value) {
    const domDataKey = gos.getDomDataKey();
    let domData = element[domDataKey];
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(domData)) {
        domData = {};
        element[domDataKey] = domData;
    }
    domData[key] = value;
}
function $437b23f6a393c3bf$export$f63d0991874c6f81(beans) {
    const { gos: gos, eGridDiv: eGridDiv } = beans;
    let result = null;
    const gridOptionsGetDocument = gos.get("getDocument");
    if (gridOptionsGetDocument && $437b23f6a393c3bf$export$25d27f17d3af40f7(gridOptionsGetDocument)) result = gridOptionsGetDocument();
    else if (eGridDiv) result = eGridDiv.ownerDocument;
    if (result && $437b23f6a393c3bf$export$25d27f17d3af40f7(result)) return result;
    return document;
}
function $437b23f6a393c3bf$var$_getWindow(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    return eDocument.defaultView || window;
}
function $437b23f6a393c3bf$export$1911dd00c79744c0(beans) {
    return beans.eGridDiv.getRootNode();
}
function $437b23f6a393c3bf$export$16bc98d422315038(beans) {
    return $437b23f6a393c3bf$export$1911dd00c79744c0(beans).activeElement;
}
function $437b23f6a393c3bf$export$50c54e860701cf22(beans) {
    let rootNode = null;
    let targetEl = null;
    try {
        rootNode = $437b23f6a393c3bf$export$f63d0991874c6f81(beans).fullscreenElement;
    } catch (e) {} finally{
        if (!rootNode) rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(beans);
        const body = rootNode.querySelector("body");
        if (body) targetEl = body;
        else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
        else if (rootNode instanceof Document) targetEl = rootNode?.documentElement;
        else targetEl = rootNode;
    }
    return targetEl;
}
function $437b23f6a393c3bf$var$_getBodyWidth(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientWidth ?? (window.innerHeight || -1);
}
function $437b23f6a393c3bf$var$_getBodyHeight(beans) {
    const body = $437b23f6a393c3bf$export$50c54e860701cf22(beans);
    return body?.clientHeight ?? (window.innerHeight || -1);
}
function $437b23f6a393c3bf$export$3ce6b987cf48b8c2(element, mouseMoveEvent, beans) {
    const eRect = element.getBoundingClientRect();
    const height = eRect.height;
    const browserWidth = $437b23f6a393c3bf$var$_getBodyWidth(beans) - 2;
    const browserHeight = $437b23f6a393c3bf$var$_getBodyHeight(beans) - 2;
    const offsetParent = element.offsetParent;
    if (!offsetParent) return;
    const offsetParentSize = $437b23f6a393c3bf$var$_getElementRectWithOffset(element.offsetParent);
    const { clientY: clientY, clientX: clientX } = mouseMoveEvent;
    let top = clientY - offsetParentSize.top - height / 2;
    let left = clientX - offsetParentSize.left - 10;
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    const win = eDocument.defaultView || window;
    const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
    const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
    if (browserWidth > 0 && left + element.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - element.clientWidth;
    if (left < 0) left = 0;
    if (browserHeight > 0 && top + element.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - element.clientHeight;
    if (top < 0) top = 0;
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
}
function $437b23f6a393c3bf$export$8ff9eef09a45371f(beans) {
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    return activeEl === null || activeEl === $437b23f6a393c3bf$export$f63d0991874c6f81(beans).body;
}
function $437b23f6a393c3bf$export$27adf74cf591fd1e(gos) {
    if (gos.get("ensureDomOrder")) return false;
    return gos.get("animateRows");
}
function $437b23f6a393c3bf$export$d5f33aacea6a0849(gos) {
    if (gos.get("paginateChildRows") || gos.get("groupHideOpenParents") || $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) return false;
    return true;
}
function $437b23f6a393c3bf$export$96c51c2547b81aed(gos) {
    const autoGroupColumnDef = gos.get("autoGroupColumnDef");
    return !autoGroupColumnDef?.comparator && !gos.get("treeData");
}
function $437b23f6a393c3bf$export$3708afee0330994(gos) {
    const userValue = gos.get("groupAggFiltering");
    if (typeof userValue === "function") return gos.getCallback("groupAggFiltering");
    if (userValue === true) return ()=>true;
    return void 0;
}
function $437b23f6a393c3bf$export$c6fad27ed643a862(gos) {
    return gos.get("grandTotalRow");
}
function $437b23f6a393c3bf$export$713d6cabeaa7f2a5(gos) {
    const userValue = gos.get("groupTotalRow");
    if (typeof userValue === "function") return gos.getCallback("groupTotalRow");
    return ()=>userValue ?? void 0;
}
function $437b23f6a393c3bf$export$7122eb216a66bef2(gos) {
    const isHideOpenParents = !!gos.get("groupHideOpenParents");
    if (isHideOpenParents) return true;
    return gos.get("groupDisplayType") === "multipleColumns";
}
function $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode) {
    if (pivotMode) return false;
    return gos.get("groupDisplayType") === "groupRows";
}
function $437b23f6a393c3bf$export$410912a9c501b8cc(gos, node, pivotMode) {
    return !!node.group && !node.footer && $437b23f6a393c3bf$export$b911c5b172d227b4(gos, pivotMode);
}
function $437b23f6a393c3bf$export$57c3bb2f89b59a89(gos) {
    const getRowId = gos.getCallback("getRowId");
    if (getRowId === void 0) return getRowId;
    return (params)=>{
        let id = getRowId(params);
        if (typeof id !== "string") {
            $437b23f6a393c3bf$export$e150fb6ea3b45c0d(()=>$437b23f6a393c3bf$export$545083624300f13d(25, {
                    id: id
                }), "getRowIdString");
            id = String(id);
        }
        return id;
    };
}
function $437b23f6a393c3bf$export$2f5892ff24cc879d(gos, node) {
    const isSkippingGroups = gos.get("groupHideParentOfSingleChild");
    if (isSkippingGroups === true) return true;
    if (isSkippingGroups === "leafGroupsOnly" && node.leafGroup) return true;
    if (gos.get("groupRemoveSingleChildren")) return true;
    if (gos.get("groupRemoveLowestSingleChildren") && node.leafGroup) return true;
    return false;
}
function $437b23f6a393c3bf$export$efae4c751fa7cc4d(gos) {
    const res = gos.get("maxConcurrentDatasourceRequests");
    return res > 0 ? res : void 0;
}
function $437b23f6a393c3bf$export$d80073cdfb810fa8(gos, isGrouped) {
    const preventVisibilityChanges = gos.get("suppressGroupChangesColumnVisibility");
    if (preventVisibilityChanges === true) return false;
    if (isGrouped && preventVisibilityChanges === "suppressHideOnGroup") return false;
    if (!isGrouped && preventVisibilityChanges === "suppressShowOnUngroup") return false;
    const legacySuppressOnGroup = gos.get("suppressRowGroupHidesColumns");
    if (isGrouped && legacySuppressOnGroup === true) return false;
    const legacySuppressOnUngroup = gos.get("suppressMakeColumnVisibleAfterUnGroup");
    if (!isGrouped && legacySuppressOnUngroup === true) return false;
    return true;
}
function $437b23f6a393c3bf$export$6df3a55606bca6ae(selection) {
    return selection?.checkboxes ?? true;
}
function $437b23f6a393c3bf$export$e92e75627785d7a4(selection) {
    return selection?.mode === "multiRow" && (selection.headerCheckbox ?? true);
}
function $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection) {
    if (typeof rowSelection !== "object") return void 0;
    return rowSelection.checkboxLocation ?? "selectionColumn";
}
function $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(selection) {
    return selection?.hideDisabledCheckboxes ?? false;
}
function $437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection !== "string";
}
function $437b23f6a393c3bf$export$63600d24670d494d(gos) {
    return gos.get("cellSelection") !== void 0;
}
function $437b23f6a393c3bf$export$93073c0b97dd7eba(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return gos.get("suppressMultiRangeSelection");
    return typeof selection !== "boolean" ? selection?.suppressMultiRanges ?? false : false;
}
function $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    return useNewAPI ? !!selection : gos.get("enableRangeSelection");
}
function $437b23f6a393c3bf$export$c96ba82819c56957(gos) {
    const selection = gos.get("cellSelection");
    const useNewAPI = selection !== void 0;
    if (!useNewAPI) return {
        mode: "fill",
        setFillValue: gos.get("fillOperation"),
        direction: gos.get("fillHandleDirection"),
        suppressClearOnFillReduction: gos.get("suppressClearOnFillReduction")
    };
    return typeof selection !== "boolean" && selection.handle?.mode === "fill" ? selection.handle : void 0;
}
function $437b23f6a393c3bf$var$_getEnableClickSelection(gos) {
    const selection = gos.get("rowSelection") ?? "single";
    if (typeof selection === "string") {
        const suppressRowClickSelection = gos.get("suppressRowClickSelection");
        const suppressRowDeselection = gos.get("suppressRowDeselection");
        if (suppressRowClickSelection && suppressRowDeselection) return false;
        else if (suppressRowClickSelection) return "enableDeselection";
        else if (suppressRowDeselection) return "enableSelection";
        else return true;
    }
    return selection.mode === "singleRow" || selection.mode === "multiRow" ? selection.enableClickSelection ?? false : false;
}
function $437b23f6a393c3bf$var$_getEnableSelection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableSelection";
}
function $437b23f6a393c3bf$var$_getEnableDeselection(gos) {
    const enableClickSelection = $437b23f6a393c3bf$var$_getEnableClickSelection(gos);
    return enableClickSelection === true || enableClickSelection === "enableDeselection";
}
function $437b23f6a393c3bf$export$351959be716b3b33(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("isRowSelectable");
    return selection?.isRowSelectable;
}
function $437b23f6a393c3bf$export$80b6607444b3274f(arg) {
    const selection = "beanName" in arg && arg.beanName === "gos" ? arg.get("rowSelection") : arg.rowSelection;
    if (typeof selection === "string") switch(selection){
        case "multiple":
            return "multiRow";
        case "single":
            return "singleRow";
        default:
            return;
    }
    switch(selection?.mode){
        case "multiRow":
        case "singleRow":
            return selection.mode;
        default:
            return;
    }
}
function $437b23f6a393c3bf$export$7bd8c52ebc4117d6(arg) {
    const mode = $437b23f6a393c3bf$export$80b6607444b3274f(arg);
    return mode === "multiRow";
}
function $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") return gos.get("rowMultiSelectWithClick");
    return selection?.enableSelectionWithoutKeys ?? false;
}
function $437b23f6a393c3bf$export$673080972d8c733e(gos) {
    const selection = gos.get("rowSelection");
    if (typeof selection === "string") {
        const groupSelectsChildren = gos.get("groupSelectsChildren");
        const groupSelectsFiltered = gos.get("groupSelectsFiltered");
        if (groupSelectsChildren && groupSelectsFiltered) return "filteredDescendants";
        else if (groupSelectsChildren) return "descendants";
        else return "self";
    }
    return selection?.mode === "multiRow" ? selection.groupSelects : void 0;
}
function $437b23f6a393c3bf$var$_getSelectAll(gos, defaultValue = true) {
    const rowSelection = gos.get("rowSelection");
    if (typeof rowSelection !== "object") return defaultValue ? "all" : void 0;
    return rowSelection.mode === "multiRow" ? rowSelection.selectAll : "all";
}
function $437b23f6a393c3bf$export$460e5745f0e6a40d(gos) {
    const groupSelection = $437b23f6a393c3bf$export$673080972d8c733e(gos);
    return groupSelection === "descendants" || groupSelection === "filteredDescendants";
}
function $437b23f6a393c3bf$var$_getMasterSelects(gos) {
    const rowSelection = gos.get("rowSelection");
    return typeof rowSelection === "object" && rowSelection.masterSelects || "self";
}
function $437b23f6a393c3bf$var$_isSetFilterByDefault(gos) {
    return gos.isModuleRegistered("SetFilter") && !gos.get("suppressSetFilterByDefault");
}
function $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos) {
    return gos.get("columnMenu") === "legacy";
}
function $437b23f6a393c3bf$export$cfe4cf52f3717a7b(gos) {
    return !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
}
function $437b23f6a393c3bf$export$2badf35af69344c1(eventName) {
    if (!eventName || eventName.length < 2) return eventName;
    return "on" + eventName[0].toUpperCase() + eventName.substring(1);
}
function $437b23f6a393c3bf$export$bfe37fc2d3c03134(gridOptions, component, gridOptionsKeys) {
    if (typeof gridOptions !== "object") gridOptions = {};
    const mergedOptions = {
        ...gridOptions
    };
    gridOptionsKeys.forEach((key)=>{
        const value = component[key];
        if (typeof value !== "undefined") mergedOptions[key] = value;
    });
    return mergedOptions;
}
function $437b23f6a393c3bf$export$52208033bd24c2b2(changes, api) {
    if (!changes) return;
    const gridChanges = {};
    let hasChanges = false;
    Object.keys(changes).forEach((key)=>{
        gridChanges[key] = changes[key];
        hasChanges = true;
    });
    if (!hasChanges) return;
    const internalUpdateEvent = {
        type: "gridOptionsChanged",
        options: gridChanges
    };
    api.dispatchEvent(internalUpdateEvent);
    const event = {
        type: "componentStateChanged",
        ...gridChanges
    };
    api.dispatchEvent(event);
}
function $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, params) {
    return gos.addGridCommonParams(params);
}
function $437b23f6a393c3bf$export$e9780a3033a82b4f(gos) {
    if (gos.get("treeData")) {
        if (gos.get("treeDataParentIdField")) return "treeSelfRef";
        if (gos.get("treeDataChildrenField")) return "treeNested";
        return "treePath";
    }
    return "group";
}
// packages/ag-grid-community/src/utils/event.ts
var $437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
var $437b23f6a393c3bf$var$PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS = [
    "wheel"
];
var $437b23f6a393c3bf$var$supports = {};
function $437b23f6a393c3bf$export$456c40e80134d72a(event) {
    event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] = true;
}
function $437b23f6a393c3bf$export$9a48e23524c6d58(event) {
    return event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] === true;
}
var $437b23f6a393c3bf$var$_isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof $437b23f6a393c3bf$var$supports[eventName] === "boolean") return $437b23f6a393c3bf$var$supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return $437b23f6a393c3bf$var$supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = $437b23f6a393c3bf$var$_getDomData(gos, sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
function $437b23f6a393c3bf$export$b5446458166e97b4(element, event) {
    if (!event || !element) return false;
    return $437b23f6a393c3bf$var$_getEventPath(event).indexOf(element) >= 0;
}
function $437b23f6a393c3bf$var$_createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function $437b23f6a393c3bf$var$_getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return $437b23f6a393c3bf$var$_createEventPath(eventNoType);
}
function $437b23f6a393c3bf$var$_addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
    const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(event);
    let options;
    if (passive != null) options = {
        passive: passive
    };
    if (frameworkOverrides && frameworkOverrides.addEventListener) frameworkOverrides.addEventListener(eElement, event, listener, options);
}
var $437b23f6a393c3bf$var$getPassiveStateForEvent = (event)=>{
    const isPassive = $437b23f6a393c3bf$var$PASSIVE_EVENTS.includes(event);
    const isNonPassive = $437b23f6a393c3bf$var$NON_PASSIVE_EVENTS.includes(event);
    if (isPassive) return true;
    if (isNonPassive) return false;
};
// packages/ag-grid-community/src/context/beanStub.ts
var $437b23f6a393c3bf$export$2032c8ef3788dfbd = class {
    constructor(){
        // not named context to allow children to use 'context' as a variable name
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        this.propertyListenerId = 0;
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in GridOptionsUtils.ts _processOnChange
        this.lastChangeSetIdLookup = {};
        this.isAlive = ()=>!this.destroyed;
    }
    preWireBeans(beans) {
        this.beans = beans;
        this.stubContext = beans.context;
        this.eventSvc = beans.eventSvc;
        this.gos = beans.gos;
    }
    // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
    // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
    // points to a bean or component that was not properly disposed of.
    // constructor() {
    //     setTimeout(()=> {
    //         if (this.isAlive()) {
    //             let prototype: any = Object.getPrototypeOf(this);
    //             const constructor: any = prototype.constructor;
    //             const constructorString = constructor.toString();
    //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
    //             console.log('is alive ' + beanName);
    //         }
    //     }, 5000);
    // }
    destroy() {
        const { destroyFunctions: destroyFunctions } = this;
        for(let i = 0; i < destroyFunctions.length; i++)destroyFunctions[i]();
        destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchLocalEvent({
            type: "destroyed"
        });
    }
    // The typing of AgEventListener<any, any, any> is not ideal, but it's the best we can do at the moment to enable
    // eventSvc to have the best typing at the expense of BeanStub local events
    /** Add a local event listener against this BeanStub */ addEventListener(eventType, listener, async) {
        if (!this.localEventService) this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.localEventService.addEventListener(eventType, listener, async);
    }
    /** Remove a local event listener from this BeanStub */ removeEventListener(eventType, listener, async) {
        this.localEventService?.removeEventListener(eventType, listener, async);
    }
    dispatchLocalEvent(event) {
        this.localEventService?.dispatchEvent(event);
    }
    addManagedElementListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    addManagedEventListeners(handlers) {
        return this._setupListeners(this.eventSvc, handlers);
    }
    addManagedListeners(object, handlers) {
        return this._setupListeners(object, handlers);
    }
    _setupListeners(object, handlers) {
        const destroyFuncs = [];
        for (const k of Object.keys(handlers)){
            const handler = handlers[k];
            if (handler) destroyFuncs.push(this._setupListener(object, k, handler));
        }
        return destroyFuncs;
    }
    _setupListener(object, event, listener) {
        if (this.destroyed) return ()=>null;
        let destroyFunc;
        if ($437b23f6a393c3bf$var$isAgEventEmitter(object)) {
            object.__addEventListener(event, listener);
            destroyFunc = ()=>{
                object.__removeEventListener(event, listener);
                return null;
            };
        } else {
            if (object instanceof HTMLElement) $437b23f6a393c3bf$var$_addSafePassiveEventListener(this.beans.frameworkOverrides, object, event, listener);
            else object.addEventListener(event, listener);
            destroyFunc = ()=>{
                object.removeEventListener(event, listener);
                return null;
            };
        }
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the GridOptionsService is destroyed.
   */ setupGridOptionListener(event, listener) {
        const { gos: gos } = this;
        gos.addPropertyEventListener(event, listener);
        const destroyFunc = ()=>{
            gos.removePropertyEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupGridOptionListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "gridPropertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        events.forEach((event)=>this.setupGridOptionListener(event, wrappedListener));
    }
    getLocaleTextFunc() {
        return $437b23f6a393c3bf$export$cc0bf4adff5b95e7(this.beans.localeSvc);
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    /** doesn't throw an error if `bean` is undefined */ createOptionalManagedBean(bean, context) {
        return bean ? this.createManagedBean(bean, context) : void 0;
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.stubContext).createBean(bean, afterPreCreateCallback);
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean, context) {
        return (context || this.stubContext).destroyBean(bean);
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans, context) {
        return (context || this.stubContext).destroyBeans(beans);
    }
};
function $437b23f6a393c3bf$var$isAgEventEmitter(object) {
    return object.__addEventListener !== void 0;
}
// packages/ag-grid-community/src/utils/object.ts
var $437b23f6a393c3bf$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $437b23f6a393c3bf$var$_iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const key of Object.keys(object))callback(key, object[key]);
}
function $437b23f6a393c3bf$export$8ade6bd474fcde42(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(source)) return;
    $437b23f6a393c3bf$var$_iterateObject(source, (key, sourceValue)=>{
        if ($437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) return;
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const doNotCopyAsSourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                if (doNotCopyAsSourceIsSimpleObject) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if ($437b23f6a393c3bf$var$_isNonNullObject(sourceValue) && $437b23f6a393c3bf$var$_isNonNullObject(destValue) && !Array.isArray(destValue)) $437b23f6a393c3bf$export$8ade6bd474fcde42(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function $437b23f6a393c3bf$var$_getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
function $437b23f6a393c3bf$var$_isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// packages/ag-grid-community/src/utils/string.ts
var $437b23f6a393c3bf$var$reUnescapedHtml = /[&<>"']/g;
var $437b23f6a393c3bf$var$HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape) {
    return toEscape?.toString().toString() ?? null;
}
function $437b23f6a393c3bf$export$3df06b741968da82(toEscape) {
    return $437b23f6a393c3bf$export$a16cfb6652fe466f(toEscape)?.replace($437b23f6a393c3bf$var$reUnescapedHtml, (chr)=>$437b23f6a393c3bf$var$HTML_ESCAPES[chr]) ?? null;
}
// packages/ag-grid-community/src/entities/agColumn.ts
var $437b23f6a393c3bf$var$COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var $437b23f6a393c3bf$var$instanceIdSequence = 0;
function $437b23f6a393c3bf$var$getNextColInstanceId() {
    return $437b23f6a393c3bf$var$instanceIdSequence++;
}
function $437b23f6a393c3bf$export$891484e65a02ec71(col) {
    return col instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2;
}
var $437b23f6a393c3bf$export$a8da3e2b83e5ddf2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colDef, userProvidedColDef, colId, primary){
        super();
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.isColumn = true;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.moving = false;
        this.menuVisible = false;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.colEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.flex = null;
        this.colIdSanitised = $437b23f6a393c3bf$export$3df06b741968da82(colId);
    }
    destroy() {
        super.destroy();
        this.beans.rowSpanSvc?.deregister(this);
    }
    getInstanceId() {
        return this.instanceId;
    }
    setState() {
        const { colDef: colDef, beans: { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } } = this;
        sortSvc?.initCol(this);
        const hide = colDef.hide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !colDef.initialHide;
        pinnedCols?.initCol(this);
        colFlex?.initCol(this);
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        const colSpanChanged = colDef.spanRows !== this.colDef.spanRows;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        if (colSpanChanged) {
            this.beans.rowSpanSvc?.deregister(this);
            this.initRowSpan();
        }
        this.dispatchColEvent("colDefChanged", source);
    }
    getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    getParent() {
        return this.parent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    // this is done after constructor as it uses gridOptionsService
    postConstruct() {
        this.setState();
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
        this.initRowSpan();
    }
    initDotNotation() {
        const { gos: gos, colDef: { field: field, tooltipField: tooltipField } } = this;
        const suppressDotNotation = gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(field) && field.indexOf(".") >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = $437b23f6a393c3bf$export$25d27f17d3af40f7(tooltipField) && tooltipField.indexOf(".") >= 0 && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        const colDef = this.colDef;
        this.minWidth = colDef.minWidth ?? this.beans.environment.getDefaultColumnMinWidth();
        this.maxWidth = colDef.maxWidth ?? Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.beans.tooltipSvc?.initCol(this);
    }
    initRowSpan() {
        if (this.colDef.spanRows) this.beans.rowSpanSvc?.register(this);
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        let width;
        const colDefWidth = colDef.width;
        const colDefInitialWidth = colDef.initialWidth;
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, this.maxWidth), this.minWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        return this.beans.showRowGroupCols?.isRowGroupDisplayed(this, colId) ?? false;
    }
    isPrimary() {
        return this.primary;
    }
    isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    getHighlighted() {
        return this.highlighted;
    }
    __addEventListener(eventType, listener) {
        this.colEventSvc.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.colEventSvc);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.colEventSvc.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.colEventSvc.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        return this.beans.cellNavigation?.isSuppressNavigable(this, rowNode) ?? false;
    }
    isCellEditable(rowNode) {
        return this.beans.editSvc?.isCellEditable(this, rowNode) ?? false;
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.beans.selectionSvc?.isCellCheckboxSelection(this, rowNode) ?? false;
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef?.suppressPaste ?? null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        return this.colDef[key] ?? $437b23f6a393c3bf$var$COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    createColumnEvent(type, source) {
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            column: this,
            columns: [
                this
            ],
            source: source
        });
    }
    isMoving() {
        return this.moving;
    }
    getSort() {
        return this.sort;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    /** @deprecated v32 use col.getSort() === 'asc */ isSortAscending() {
        return this.sort === "asc";
    }
    /** @deprecated v32 use col.getSort() === 'desc */ isSortDescending() {
        return this.sort === "desc";
    }
    /** @deprecated v32 use col.getSort() === undefined */ isSortNone() {
        return $437b23f6a393c3bf$export$672d9e47bc342bac(this.sort);
    }
    /** @deprecated v32 use col.getSort() !== undefined */ isSorting() {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.sort);
    }
    getSortIndex() {
        return this.sortIndex;
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchColEvent("leftChanged", source);
        }
    }
    isFilterActive() {
        return this.filterActive;
    }
    /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */ isHovered() {
        $437b23f6a393c3bf$export$545083624300f13d(261);
        return !!this.beans.colHover?.isHovered(this);
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.dispatchColEvent("firstRightPinnedChanged", source);
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.dispatchColEvent("lastLeftPinnedChanged", source);
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.dispatchColEvent("visibleChanged", source);
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent || !parent.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents: numberOfParents,
            isSpanningTotal: isSpanningTotal
        };
    }
    getColDef() {
        return this.colDef;
    }
    getDefinition() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    getColId() {
        return this.colId;
    }
    getId() {
        return this.colId;
    }
    getUniqueId() {
        return this.colId;
    }
    getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        actualWidth = Math.max(actualWidth, this.minWidth);
        actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex != null && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.dispatchColEvent("widthChanged", source);
    }
    isGreaterThanMax(width) {
        return width > this.maxWidth;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex;
    }
    isRowGroupActive() {
        return this.rowGroupActive;
    }
    isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    dispatchColEvent(type, source, additionalEventAttributes) {
        const colEvent = this.createColumnEvent(type, source);
        if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(colEvent, additionalEventAttributes);
        this.colEventSvc.dispatchEvent(colEvent);
    }
    dispatchStateUpdatedEvent(key) {
        this.colEventSvc.dispatchEvent({
            type: "columnStateUpdated",
            key: key
        });
    }
};
// packages/ag-grid-community/src/entities/agProvidedColumnGroup.ts
function $437b23f6a393c3bf$export$bb4bfad2b594b78e(col) {
    return col instanceof $437b23f6a393c3bf$export$7ff27642a6ecc1cf;
}
var $437b23f6a393c3bf$export$7ff27642a6ecc1cf = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(colGroupDef, groupId, padding, level){
        super();
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.padding = padding;
        this.level = level;
        this.isColumn = false;
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.expanded = !!colGroupDef?.openByDefault;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
        super.destroy();
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        this.dispatchLocalEvent({
            type: "expandedChanged"
        });
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    forEachLeafColumn(callback) {
        if (!this.children) return;
        for (const child of this.children){
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) callback(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.forEachLeafColumn(callback);
        }
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        this.children.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.addLeafColumns(leafColumns);
        });
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        this.getLeafColumns().forEach((col)=>col.__addEventListener("visibleChanged", listener));
        this.expandableListenerRemoveCallback = ()=>{
            this.getLeafColumns().forEach((col)=>col.__removeEventListener("visibleChanged", listener));
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            this.dispatchLocalEvent({
                type: "expandableChanged"
            });
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            items.forEach((item)=>{
                const skipBecausePadding = $437b23f6a393c3bf$export$bb4bfad2b594b78e(item) && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            });
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
};
// packages/ag-grid-community/src/entities/defaultColumnTypes.ts
var $437b23f6a393c3bf$var$DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupUtils.ts
function $437b23f6a393c3bf$var$createMergedColGroupDef(beans, colGroupDef, groupId) {
    const colGroupDefMerged = {};
    const gos = beans.gos;
    Object.assign(colGroupDefMerged, gos.get("defaultColGroupDef"));
    Object.assign(colGroupDefMerged, colGroupDef);
    gos.validateColDef(colGroupDefMerged, groupId);
    return colGroupDefMerged;
}
// packages/ag-grid-community/src/columns/columnKeyCreator.ts
var $437b23f6a393c3bf$export$f67d1427302c96a3 = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys) {
        for(let i = 0; i < keys.length; i++)this.existingKeys[keys[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = $437b23f6a393c3bf$export$2a74c29220d5c88e(colId);
        let count = 0;
        while(true){
            let idToTry = colId ?? colField;
            if (idToTry) {
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                const usedId = String(idToTry);
                if (colId && count > 0) $437b23f6a393c3bf$export$545083624300f13d(273, {
                    providedId: colId,
                    usedId: usedId
                });
                this.existingKeys[usedId] = true;
                return usedId;
            }
            count++;
        }
    }
};
// packages/ag-grid-community/src/utils/array.ts
var $437b23f6a393c3bf$export$c758d9371030a6ac = Object.freeze([]);
function $437b23f6a393c3bf$export$236389741107357f(arr) {
    if (!arr?.length) return;
    return arr[arr.length - 1];
}
function $437b23f6a393c3bf$export$893967cdb9833fdd(a, b, comparator) {
    if (a == null && b == null) return true;
    return a != null && b != null && a.length === b.length && a.every((value, index)=>comparator ? comparator(value, b[index]) : b[index] === value);
}
function $437b23f6a393c3bf$var$_forAll(array, callback) {
    if (!array) return;
    for (const value of array)callback(value);
}
function $437b23f6a393c3bf$export$83a881c8b5120679(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function $437b23f6a393c3bf$var$_moveInArray(array, objectsToMove, toIndex) {
    for(let i = 0; i < objectsToMove.length; i++)$437b23f6a393c3bf$export$83a881c8b5120679(array, objectsToMove[i]);
    for(let i = objectsToMove.length - 1; i >= 0; i--)array.splice(toIndex, 0, objectsToMove[i]);
}
function $437b23f6a393c3bf$export$5e3f39c5068e375d(arrays) {
    return [].concat.apply([], arrays);
}
// packages/ag-grid-community/src/columns/columnUtils.ts
var $437b23f6a393c3bf$export$a7016588c430dba6 = "ag-Grid-AutoColumn";
var $437b23f6a393c3bf$export$dd05e5f089eb2421 = "ag-Grid-SelectionColumn";
var $437b23f6a393c3bf$export$f55c01dfb205b029 = "ag-Grid-RowNumbersColumn";
function $437b23f6a393c3bf$export$42da2aea8fab5b(rootColumns) {
    const result = [];
    const recursiveFindColumns = (childColumns)=>{
        for(let i = 0; i < childColumns.length; i++){
            const child = childColumns[i];
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) result.push(child);
            else if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) recursiveFindColumns(child.getChildren());
        }
    };
    recursiveFindColumns(rootColumns);
    return result;
}
function $437b23f6a393c3bf$var$getWidthOfColsInList(columnList) {
    return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
}
function $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, oldTree, newTree) {
    const oldObjectsById = {};
    if (!oldTree) return;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = child;
    });
    if (newTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, newTree, (child)=>{
        oldObjectsById[child.getInstanceId()] = null;
    });
    const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
    beans.context.destroyBeans(colsToDestroy);
}
function $437b23f6a393c3bf$export$61b34611dc010a97(col) {
    const colId = col.getId();
    return colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
}
function $437b23f6a393c3bf$export$f6074a9792015c5d(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$dd05e5f089eb2421) ?? false;
}
function $437b23f6a393c3bf$export$3d3e7d751f0445eb(col) {
    const id = typeof col === "string" ? col : "getColId" in col ? col.getColId() : col.colId;
    return id?.startsWith($437b23f6a393c3bf$export$f55c01dfb205b029) ?? false;
}
function $437b23f6a393c3bf$var$convertColumnTypes(type) {
    let typeKeys = [];
    if (type instanceof Array) typeKeys = type;
    else if (typeof type === "string") typeKeys = type.split(",");
    return typeKeys;
}
function $437b23f6a393c3bf$export$f56e341a1fe35ed4(colsA, colsB) {
    return $437b23f6a393c3bf$export$893967cdb9833fdd(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
}
function $437b23f6a393c3bf$export$c82fd63ff1738bed(cols) {
    cols.map = {};
    cols.list.forEach((col)=>cols.map[col.getId()] = col);
}
function $437b23f6a393c3bf$export$eb2a92b6162267d1(source) {
    return source === "gridOptionsUpdated" ? "gridOptionsChanged" : source;
}
function $437b23f6a393c3bf$export$f5687d41c39fa1b3(column, key) {
    const columnMatches = column === key;
    const colDefMatches = column.getColDef() === key;
    const idMatches = column.getColId() == key;
    return columnMatches || colDefMatches || idMatches;
}
var $437b23f6a393c3bf$var$getValueFactory = (stateItem, defaultState)=>(key1, key2)=>{
        const obj = {
            value1: void 0,
            value2: void 0
        };
        let calculated = false;
        if (stateItem) {
            if (stateItem[key1] !== void 0) {
                obj.value1 = stateItem[key1];
                calculated = true;
            }
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && stateItem[key2] !== void 0) {
                obj.value2 = stateItem[key2];
                calculated = true;
            }
        }
        if (!calculated && defaultState) {
            if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
        }
        return obj;
    };
// packages/ag-grid-community/src/columns/columnFactoryUtils.ts
function $437b23f6a393c3bf$export$575b8d8234793d75(beans, defs = null, primaryColumns, existingTree, source) {
    const { existingCols: existingCols, existingGroups: existingGroups } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    const colIdMap = new Map(existingCols.map((col)=>[
            col.getId(),
            col
        ]));
    const colGroupIdMap = new Map(existingGroups.map((group)=>[
            group.getId(),
            group
        ]));
    let maxDepth = 0;
    const recursivelyProcessColDef = (def, level)=>{
        maxDepth = Math.max(maxDepth, level);
        if ($437b23f6a393c3bf$var$isColumnGroupDef(def)) {
            if (!beans.colGroupSvc) return null;
            const groupId = def.groupId;
            const group = colGroupIdMap.get(groupId);
            const colGroupDef = $437b23f6a393c3bf$var$createMergedColGroupDef(beans, def, groupId);
            const newGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDef, groupId, false, level);
            beans.context.createBean(newGroup);
            if (group) newGroup.setExpanded(group.isExpanded());
            newGroup.setChildren(def.children.map((child)=>recursivelyProcessColDef(child, level + 1)));
            return newGroup;
        }
        const colId = def.colId;
        let column = colIdMap.get(colId);
        if (!column) {
            const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, def, colId);
            column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, def, colId, primaryColumns);
            beans.context.createBean(column);
        } else {
            const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, def, column.getColId());
            column.setColDef(colDefMerged, def, source);
            $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
        }
        beans.dataTypeSvc?.addColumnListeners(column);
        return column;
    };
    const root = defs?.map((def)=>recursivelyProcessColDef(def, 0)) ?? [];
    let counter = 0;
    const keyCreator = {
        getUniqueKey: (_colId, _field)=>String(++counter)
    };
    const columnTree = beans.colGroupSvc ? beans.colGroupSvc.balanceColumnTree(root, 0, maxDepth, keyCreator) : root;
    const depthFirstCallback = (child, parent)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
        child.originalParent = parent;
    };
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: maxDepth
    };
}
function $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, defs = null, primaryColumns, existingTree, source) {
    const columnKeyCreator = new $437b23f6a393c3bf$export$f67d1427302c96a3();
    const { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys } = $437b23f6a393c3bf$var$extractExistingTreeData(existingTree);
    columnKeyCreator.addExistingKeys(existingColKeys);
    const unbalancedTree = $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
    const { colGroupSvc: colGroupSvc } = beans;
    const treeDepth = colGroupSvc?.findMaxDepth(unbalancedTree, 0) ?? 0;
    const columnTree = colGroupSvc ? colGroupSvc.balanceColumnTree(unbalancedTree, 0, treeDepth, columnKeyCreator) : unbalancedTree;
    const depthFirstCallback = (child, parent)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) child.setupExpandable();
        child.originalParent = parent;
    };
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, depthFirstCallback);
    return {
        columnTree: columnTree,
        treeDepth: treeDepth
    };
}
function $437b23f6a393c3bf$var$extractExistingTreeData(existingTree) {
    const existingCols = [];
    const existingGroups = [];
    const existingColKeys = [];
    if (existingTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(item)) {
            const group = item;
            existingGroups.push(group);
        } else {
            const col = item;
            existingColKeys.push(col.getId());
            existingCols.push(col);
        }
    });
    return {
        existingCols: existingCols,
        existingGroups: existingGroups,
        existingColKeys: existingColKeys
    };
}
function $437b23f6a393c3bf$var$_recursivelyCreateColumns(beans, defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
    if (!defs) return [];
    const { colGroupSvc: colGroupSvc } = beans;
    const result = new Array(defs.length);
    for(let i = 0; i < result.length; i++){
        const def = defs[i];
        if (colGroupSvc && $437b23f6a393c3bf$var$isColumnGroupDef(def)) result[i] = colGroupSvc.createProvidedColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
        else result[i] = $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, def, existingColsCopy, columnKeyCreator, source);
    }
    return result;
}
function $437b23f6a393c3bf$var$createColumn(beans, primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
    const existingColAndIndex = $437b23f6a393c3bf$var$findExistingColumn(colDef, existingColsCopy);
    if (existingColAndIndex) existingColsCopy?.splice(existingColAndIndex.idx, 1);
    let column = existingColAndIndex?.column;
    if (!column) {
        const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId);
        column = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDefMerged, colDef, colId, primaryColumns);
        beans.context.createBean(column);
    } else {
        const colDefMerged = $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, column.getColId());
        column.setColDef(colDefMerged, colDef, source);
        $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDefMerged, source);
    }
    beans.dataTypeSvc?.addColumnListeners(column);
    return column;
}
function $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, hide, sort, sortIndex, pinned, flex, source) {
    const { sortSvc: sortSvc, pinnedCols: pinnedCols, colFlex: colFlex } = beans;
    if (hide !== void 0) column.setVisible(!hide, source);
    if (sortSvc) {
        sortSvc.updateColSort(column, sort, source);
        if (sortIndex !== void 0) sortSvc.setColSortIndex(column, sortIndex);
    }
    if (pinned !== void 0) pinnedCols?.setColPinned(column, pinned);
    if (flex !== void 0) colFlex?.setColFlex(column, flex);
}
function $437b23f6a393c3bf$export$ee3812d6139e74d4(beans, column, colDef, source) {
    $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, colDef.hide, colDef.sort, colDef.sortIndex, colDef.pinned, colDef.flex, source);
    const colFlex = column.getFlex();
    if (colFlex != null && colFlex > 0) return;
    if (colDef.width != null) column.setActualWidth(colDef.width, source);
    else {
        const widthBeforeUpdate = column.getActualWidth();
        column.setActualWidth(widthBeforeUpdate, source);
    }
}
function $437b23f6a393c3bf$var$findExistingColumn(newColDef, existingColsCopy) {
    if (!existingColsCopy) return void 0;
    for(let i = 0; i < existingColsCopy.length; i++){
        const def = existingColsCopy[i].getUserProvidedColDef();
        if (!def) continue;
        const newHasId = newColDef.colId != null;
        if (newHasId) {
            if (existingColsCopy[i].getId() === newColDef.colId) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        const newHasField = newColDef.field != null;
        if (newHasField) {
            if (def.field === newColDef.field) return {
                idx: i,
                column: existingColsCopy[i]
            };
            continue;
        }
        if (def === newColDef) return {
            idx: i,
            column: existingColsCopy[i]
        };
    }
    return void 0;
}
function $437b23f6a393c3bf$export$310bdd432cb2279e(beans, colDef, colId, isAutoCol) {
    const { gos: gos, dataTypeSvc: dataTypeSvc } = beans;
    const res = {};
    const defaultColDef = gos.get("defaultColDef");
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, defaultColDef, false, true);
    const columnType = $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, res, colDef, colId);
    if (columnType) $437b23f6a393c3bf$var$assignColumnTypes(beans, columnType, res);
    $437b23f6a393c3bf$export$8ade6bd474fcde42(res, colDef, false, true);
    const autoGroupColDef = gos.get("autoGroupColumnDef");
    const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
    if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) $437b23f6a393c3bf$export$8ade6bd474fcde42(res, {
        sort: autoGroupColDef.sort,
        initialSort: autoGroupColDef.initialSort
    }, false, true);
    dataTypeSvc?.validateColDef(res);
    gos.validateColDef(res, colId, isAutoCol);
    return res;
}
function $437b23f6a393c3bf$var$updateColDefAndGetColumnType(beans, colDef, userColDef, colId) {
    const dataTypeDefinitionColumnType = beans.dataTypeSvc?.updateColDefAndGetColumnType(colDef, userColDef, colId);
    const columnTypes = userColDef.type ?? dataTypeDefinitionColumnType ?? colDef.type;
    colDef.type = columnTypes;
    return columnTypes ? $437b23f6a393c3bf$var$convertColumnTypes(columnTypes) : void 0;
}
function $437b23f6a393c3bf$var$assignColumnTypes(beans, typeKeys, colDefMerged) {
    if (!typeKeys.length) return;
    const allColumnTypes = Object.assign({}, $437b23f6a393c3bf$var$DefaultColumnTypes);
    const userTypes = beans.gos.get("columnTypes") || {};
    for (const key of Object.keys(userTypes)){
        const value = userTypes[key];
        if (key in allColumnTypes) $437b23f6a393c3bf$export$545083624300f13d(34, {
            key: key
        });
        else {
            const colType = value;
            if (colType.type) $437b23f6a393c3bf$export$545083624300f13d(35);
            allColumnTypes[key] = value;
        }
    }
    typeKeys.forEach((t)=>{
        const typeColDef = allColumnTypes[t.trim()];
        if (typeColDef) $437b23f6a393c3bf$export$8ade6bd474fcde42(colDefMerged, typeColDef, false, true);
        else $437b23f6a393c3bf$export$545083624300f13d(36, {
            t: t
        });
    });
}
function $437b23f6a393c3bf$var$isColumnGroupDef(abstractColDef) {
    return abstractColDef.children !== void 0;
}
function $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// packages/ag-grid-community/src/columnMove/columnMoveUtils.ts
function $437b23f6a393c3bf$var$placeLockedColumns(cols, gos) {
    const left = [];
    const normal = [];
    const right = [];
    cols.forEach((col)=>{
        const position = col.getColDef().lockPosition;
        if (position === "right") right.push(col);
        else if (position === "left" || position === true) left.push(col);
        else normal.push(col);
    });
    const isRtl = gos.get("enableRtl");
    if (isRtl) return [
        ...right,
        ...normal,
        ...left
    ];
    return [
        ...left,
        ...normal,
        ...right
    ];
}
function $437b23f6a393c3bf$var$doesMovePassMarryChildren(allColumnsCopy, gridBalancedTree) {
    let rulePassed = true;
    $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (child)=>{
        if (!$437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) return;
        const columnGroup = child;
        const colGroupDef = columnGroup.getColGroupDef();
        const marryChildren = colGroupDef && colGroupDef.marryChildren;
        if (!marryChildren) return;
        const newIndexes = [];
        columnGroup.getLeafColumns().forEach((col)=>{
            const newColIndex = allColumnsCopy.indexOf(col);
            newIndexes.push(newColIndex);
        });
        const maxIndex = Math.max.apply(Math, newIndexes);
        const minIndex = Math.min.apply(Math, newIndexes);
        const spread = maxIndex - minIndex;
        const maxSpread = columnGroup.getLeafColumns().length - 1;
        if (spread > maxSpread) rulePassed = false;
    });
    return rulePassed;
}
// packages/ag-grid-community/src/columns/columnEventUtils.ts
function $437b23f6a393c3bf$var$getCommonValue(cols, valueGetter) {
    if (!cols || cols.length == 0) return void 0;
    const firstValue = valueGetter(cols[0]);
    for(let i = 1; i < cols.length; i++){
        if (firstValue !== valueGetter(cols[i])) return void 0;
    }
    return firstValue;
}
function $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const pinned = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.getPinned());
    eventSvc.dispatchEvent({
        type: "columnPinned",
        // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
        pinned: pinned != null ? pinned : null,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, changedColumns, source) {
    if (!changedColumns.length) return;
    const column = changedColumns.length === 1 ? changedColumns[0] : null;
    const visible = $437b23f6a393c3bf$var$getCommonValue(changedColumns, (col)=>col.isVisible());
    eventSvc.dispatchEvent({
        type: "columnVisible",
        visible: visible,
        columns: changedColumns,
        column: column,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, type, columns, source) {
    eventSvc.dispatchEvent({
        type: type,
        columns: columns,
        column: columns && columns.length == 1 ? columns[0] : null,
        source: source
    });
}
function $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, columns, finished, source, flexColumns = null) {
    if (columns?.length) eventSvc.dispatchEvent({
        type: "columnResized",
        columns: columns,
        column: columns.length === 1 ? columns[0] : null,
        flexColumns: flexColumns,
        finished: finished,
        source: source
    });
}
// packages/ag-grid-community/src/columns/columnStateUtils.ts
function $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, source) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, colAnimation: colAnimation, visibleCols: visibleCols, pivotResultCols: pivotResultCols, environment: environment, valueColsSvc: valueColsSvc, eventSvc: eventSvc, gos: gos } = beans;
    const providedCols = colModel.getColDefCols() ?? [];
    const selectionCols = selectionColSvc?.getColumns();
    if (!providedCols?.length && !selectionCols?.length) return false;
    if (params?.state && !params.state.forEach) {
        $437b23f6a393c3bf$export$545083624300f13d(32);
        return false;
    }
    const syncColumnWithStateItem = (column, stateItem, rowGroupIndexes, pivotIndexes, autoCol)=>{
        if (!column) return;
        const getValue = $437b23f6a393c3bf$var$getValueFactory(stateItem, params.defaultState);
        const flex = getValue("flex").value1;
        $437b23f6a393c3bf$var$updateSomeColumnState(beans, column, getValue("hide").value1, getValue("sort").value1, getValue("sortIndex").value1, getValue("pinned").value1, flex, source);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                const minColWidth = column.getColDef().minWidth ?? environment.getDefaultColumnMinWidth();
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        if (autoCol || !column.isPrimary()) return;
        valueColsSvc?.syncColumnWithState(column, source, getValue);
        rowGroupColsSvc?.syncColumnWithState(column, source, getValue, rowGroupIndexes);
        pivotColsSvc?.syncColumnWithState(column, source, getValue, pivotIndexes);
    };
    const applyStates = (states, existingColumns, getById2)=>{
        const dispatchEventsFunc = $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source);
        const columnsWithNoState = existingColumns.slice();
        const rowGroupIndexes = {};
        const pivotIndexes = {};
        const autoColStates = [];
        const selectionColStates = [];
        const unmatchedAndAutoStates2 = [];
        let unmatchedCount2 = 0;
        const previousRowGroupCols = rowGroupColsSvc?.columns.slice() ?? [];
        const previousPivotCols = pivotColsSvc?.columns.slice() ?? [];
        states.forEach((state)=>{
            const colId = state.colId;
            const isAutoGroupColumn = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
            if (isAutoGroupColumn) {
                autoColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                return;
            }
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(colId)) {
                selectionColStates.push(state);
                unmatchedAndAutoStates2.push(state);
                return;
            }
            const column = getById2(colId);
            if (!column) {
                unmatchedAndAutoStates2.push(state);
                unmatchedCount2 += 1;
            } else {
                syncColumnWithStateItem(column, state, rowGroupIndexes, pivotIndexes, false);
                $437b23f6a393c3bf$export$83a881c8b5120679(columnsWithNoState, column);
            }
        });
        const applyDefaultsFunc = (col)=>syncColumnWithStateItem(col, null, rowGroupIndexes, pivotIndexes, false);
        columnsWithNoState.forEach(applyDefaultsFunc);
        rowGroupColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(rowGroupColsSvc, rowGroupIndexes, previousRowGroupCols));
        pivotColsSvc?.sortColumns($437b23f6a393c3bf$var$comparatorByIndex.bind(pivotColsSvc, pivotIndexes, previousPivotCols));
        colModel.refreshCols(false);
        const syncColStates = (getCol, colStates, columns = [])=>{
            colStates.forEach((stateItem)=>{
                const col = getCol(stateItem.colId);
                $437b23f6a393c3bf$export$83a881c8b5120679(columns, col);
                syncColumnWithStateItem(col, stateItem, null, null, true);
            });
            columns.forEach(applyDefaultsFunc);
        };
        syncColStates((colId)=>autoColSvc?.getColumn(colId) ?? null, autoColStates, autoColSvc?.getColumns()?.slice());
        syncColStates((colId)=>selectionColSvc?.getColumn(colId) ?? null, selectionColStates, selectionColSvc?.getColumns()?.slice());
        $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos);
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        dispatchEventsFunc();
        return {
            unmatchedAndAutoStates: unmatchedAndAutoStates2,
            unmatchedCount: unmatchedCount2
        };
    };
    colAnimation?.start();
    let { unmatchedAndAutoStates: unmatchedAndAutoStates, unmatchedCount: unmatchedCount } = applyStates(params.state || [], providedCols, (id)=>colModel.getColDefCol(id));
    if (unmatchedAndAutoStates.length > 0 || $437b23f6a393c3bf$export$25d27f17d3af40f7(params.defaultState)) {
        const pivotResultColsList = pivotResultCols?.getPivotResultCols()?.list ?? [];
        unmatchedCount = applyStates(unmatchedAndAutoStates, pivotResultColsList, (id)=>pivotResultCols?.getPivotResultCol(id) ?? null).unmatchedCount;
    }
    colAnimation?.finish();
    return unmatchedCount === 0;
}
function $437b23f6a393c3bf$export$96a6cbc000255060(beans, source) {
    const { colModel: colModel, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc } = beans;
    const primaryCols = colModel.getColDefCols();
    if (!primaryCols?.length) return;
    const primaryColumnTree = colModel.getColDefColTree();
    const primaryColumns = $437b23f6a393c3bf$export$42da2aea8fab5b(primaryColumnTree);
    const columnStates = [];
    let letRowGroupIndex = 1e3;
    let letPivotIndex = 1e3;
    const addColState = (col)=>{
        const stateItem = $437b23f6a393c3bf$var$getColumnStateFromColDef(col);
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
        columnStates.push(stateItem);
    };
    autoColSvc?.getColumns()?.forEach(addColState);
    selectionColSvc?.getColumns()?.forEach(addColState);
    primaryColumns?.forEach(addColState);
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: columnStates
    }, source);
    const autoCols = autoColSvc?.getColumns() ?? [];
    const selectionCols = selectionColSvc?.getColumns() ?? [];
    const orderedCols = [
        ...selectionCols,
        ...autoCols,
        ...primaryCols
    ];
    const orderedColState = orderedCols.map((col)=>({
            colId: col.colId
        }));
    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
        state: orderedColState,
        applyOrder: true
    }, source);
}
function $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) {
    const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, colModel: colModel, sortSvc: sortSvc, eventSvc: eventSvc } = beans;
    const startState = {
        rowGroupColumns: rowGroupColsSvc?.columns.slice() ?? [],
        pivotColumns: pivotColsSvc?.columns.slice() ?? [],
        valueColumns: valueColsSvc?.columns.slice() ?? []
    };
    const columnStateBefore = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
    const columnStateBeforeMap = {};
    columnStateBefore.forEach((col)=>{
        columnStateBeforeMap[col.colId] = col;
    });
    return ()=>{
        const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
            const beforeList = colsBefore.map(idMapper);
            const afterList = colsAfter.map(idMapper);
            const unchanged = $437b23f6a393c3bf$export$893967cdb9833fdd(beforeList, afterList);
            if (unchanged) return;
            const changes = new Set(colsBefore);
            colsAfter.forEach((id)=>{
                if (!changes.delete(id)) changes.add(id);
            });
            const changesArr = [
                ...changes
            ];
            eventSvc.dispatchEvent({
                type: eventType,
                columns: changesArr,
                column: changesArr.length === 1 ? changesArr[0] : null,
                source: source
            });
        };
        const getChangedColumns = (changedPredicate)=>{
            const changedColumns2 = [];
            colModel.forAllCols((column)=>{
                const colStateBefore = columnStateBeforeMap[column.getColId()];
                if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
            });
            return changedColumns2;
        };
        const columnIdMapper = (c)=>c.getColId();
        dispatchWhenListsDifferent("columnRowGroupChanged", startState.rowGroupColumns, rowGroupColsSvc?.columns ?? [], columnIdMapper);
        dispatchWhenListsDifferent("columnPivotChanged", startState.pivotColumns, pivotColsSvc?.columns ?? [], columnIdMapper);
        const valueChangePredicate = (cs, c)=>{
            const oldActive = cs.aggFunc != null;
            const activeChanged = oldActive != c.isValueActive();
            const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
            return activeChanged || aggFuncChanged;
        };
        const changedValues = getChangedColumns(valueChangePredicate);
        if (changedValues.length > 0) $437b23f6a393c3bf$var$dispatchColumnChangedEvent(eventSvc, "columnValueChanged", changedValues, source);
        const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(eventSvc, getChangedColumns(resizeChangePredicate), true, source);
        const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
        $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(eventSvc, getChangedColumns(pinnedChangePredicate), source);
        const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
        $437b23f6a393c3bf$var$dispatchColumnVisibleEvent(eventSvc, getChangedColumns(visibilityChangePredicate), source);
        const sortChangePredicate = (cs, c)=>cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
        const changedColumns = getChangedColumns(sortChangePredicate);
        if (changedColumns.length > 0) sortSvc?.dispatchSortChangedEvents(source, changedColumns);
        const colStateAfter = $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
        $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(columnStateBefore, colStateAfter, source, colModel, eventSvc);
    };
}
function $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans) {
    const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = beans;
    const primaryCols = colModel.getColDefCols();
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(primaryCols) || !colModel.isAlive()) return [];
    const rowGroupColumns = rowGroupColsSvc?.columns;
    const pivotColumns = pivotColsSvc?.columns;
    const res = [];
    const createStateItemFromColumn = (column)=>{
        const rowGroupIndex = column.isRowGroupActive() && rowGroupColumns ? rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() && pivotColumns ? pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sort = column.getSort() != null ? column.getSort() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        res.push({
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort: sort,
            sortIndex: sortIndex,
            aggFunc: aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex: rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex: pivotIndex,
            flex: column.getFlex() ?? null
        });
    };
    colModel.forAllCols((col)=>createStateItemFromColumn(col));
    const colIdToGridIndexMap = new Map(colModel.getCols().map((col, index)=>[
            col.getColId(),
            index
        ]));
    res.sort((itemA, itemB)=>{
        const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
        const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
        return posA - posB;
    });
    return res;
}
function $437b23f6a393c3bf$var$getColumnStateFromColDef(column) {
    const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
    const colDef = column.getColDef();
    const sort = getValueOrNull(colDef.sort, colDef.initialSort);
    const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
    const hide = getValueOrNull(colDef.hide, colDef.initialHide);
    const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
    const width = getValueOrNull(colDef.width, colDef.initialWidth);
    const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
    let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
    let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
    if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
        rowGroupIndex = null;
        rowGroup = null;
    }
    let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
    let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
    if (pivotIndex == null && (pivot == null || pivot == false)) {
        pivotIndex = null;
        pivot = null;
    }
    const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
    return {
        colId: column.getColId(),
        sort: sort,
        sortIndex: sortIndex,
        hide: hide,
        pinned: pinned,
        width: width,
        flex: flex,
        rowGroup: rowGroup,
        rowGroupIndex: rowGroupIndex,
        pivot: pivot,
        pivotIndex: pivotIndex,
        aggFunc: aggFunc
    };
}
function $437b23f6a393c3bf$var$orderLiveColsLikeState(params, colModel, gos) {
    if (!params.applyOrder || !params.state) return;
    const colIds = [];
    params.state.forEach((item)=>{
        if (item.colId != null) colIds.push(item.colId);
    });
    $437b23f6a393c3bf$var$sortColsLikeKeys(colModel.cols, colIds, colModel, gos);
}
function $437b23f6a393c3bf$var$sortColsLikeKeys(cols, colIds, colModel, gos) {
    if (cols == null) return;
    let newOrder = [];
    const processedColIds = {};
    colIds.forEach((colId)=>{
        if (processedColIds[colId]) return;
        const col = cols.map[colId];
        if (col) {
            newOrder.push(col);
            processedColIds[colId] = true;
        }
    });
    let autoGroupInsertIndex = 0;
    cols.list.forEach((col)=>{
        const colId = col.getColId();
        const alreadyProcessed = processedColIds[colId] != null;
        if (alreadyProcessed) return;
        const isAutoGroupCol = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
        if (isAutoGroupCol) newOrder.splice(autoGroupInsertIndex++, 0, col);
        else newOrder.push(col);
    });
    newOrder = $437b23f6a393c3bf$var$placeLockedColumns(newOrder, gos);
    if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(newOrder, colModel.getColTree())) {
        $437b23f6a393c3bf$export$545083624300f13d(39);
        return;
    }
    cols.list = newOrder;
}
function $437b23f6a393c3bf$var$normaliseColumnMovedEventForColumnState(colStateBefore, colStateAfter, source, colModel, eventSvc) {
    const colStateAfterMapped = {};
    colStateAfter.forEach((s)=>colStateAfterMapped[s.colId] = s);
    const colsIntersectIds = {};
    colStateBefore.forEach((s)=>{
        if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
    });
    const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
    const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
    const movedColumns = [];
    afterFiltered.forEach((csAfter, index)=>{
        const csBefore = beforeFiltered && beforeFiltered[index];
        if (csBefore && csBefore.colId !== csAfter.colId) {
            const gridCol = colModel.getCol(csBefore.colId);
            if (gridCol) movedColumns.push(gridCol);
        }
    });
    if (!movedColumns.length) return;
    eventSvc.dispatchEvent({
        type: "columnMoved",
        columns: movedColumns,
        column: movedColumns.length === 1 ? movedColumns[0] : null,
        finished: true,
        source: source
    });
}
var $437b23f6a393c3bf$var$comparatorByIndex = (indexes, oldList, colA, colB)=>{
    const indexA = indexes[colA.getId()];
    const indexB = indexes[colB.getId()];
    const aHasIndex = indexA != null;
    const bHasIndex = indexB != null;
    if (aHasIndex && bHasIndex) return indexA - indexB;
    if (aHasIndex) return -1;
    if (bHasIndex) return 1;
    const oldIndexA = oldList.indexOf(colA);
    const oldIndexB = oldList.indexOf(colB);
    const aHasOldIndex = oldIndexA >= 0;
    const bHasOldIndex = oldIndexB >= 0;
    if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
    if (aHasOldIndex) return -1;
    return 1;
};
// packages/ag-grid-community/src/columns/columnModel.ts
var $437b23f6a393c3bf$var$ColumnModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colModel";
        // if pivotMode is on, however pivot results are NOT shown if no pivot columns are set
        this.pivotMode = false;
        this.ready = false;
        this.changeEventsDispatching = false;
    }
    postConstruct() {
        this.pivotMode = this.gos.get("pivotMode");
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents"
        ], (event)=>this.refreshAll($437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "defaultColGroupDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], this.recreateColumnDefs.bind(this));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source)));
    }
    // called from SyncService, when grid has finished initialising
    createColsFromColDefs(source) {
        const { beans: beans } = this;
        const { valueCache: valueCache, colAutosize: colAutosize, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc, valueColsSvc: valueColsSvc, visibleCols: visibleCols, colViewport: colViewport, eventSvc: eventSvc } = beans;
        const dispatchEventsFunc = this.colDefs ? $437b23f6a393c3bf$var$_compareColumnStatesAndDispatchEvents(beans, source) : void 0;
        valueCache?.expire();
        const oldCols = this.colDefCols?.list;
        const oldTree = this.colDefCols?.tree;
        const newTree = $437b23f6a393c3bf$export$e03b26088dedc2ab(beans, this.colDefs, true, oldTree, source);
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(beans, this.colDefCols?.tree, newTree.columnTree);
        const tree = newTree.columnTree;
        const treeDepth = newTree.treeDepth;
        const list = $437b23f6a393c3bf$export$42da2aea8fab5b(tree);
        const map = {};
        list.forEach((col)=>map[col.getId()] = col);
        this.colDefCols = {
            tree: tree,
            treeDepth: treeDepth,
            list: list,
            map: map
        };
        rowGroupColsSvc?.extractCols(source, oldCols);
        pivotColsSvc?.extractCols(source, oldCols);
        valueColsSvc?.extractCols(source, oldCols);
        this.ready = true;
        this.refreshCols(true);
        visibleCols.refresh(source);
        colViewport.checkViewportColumns();
        eventSvc.dispatchEvent({
            type: "columnEverythingChanged",
            source: source
        });
        if (dispatchEventsFunc) {
            this.changeEventsDispatching = true;
            dispatchEventsFunc();
            this.changeEventsDispatching = false;
        }
        eventSvc.dispatchEvent({
            type: "newColumnsLoaded",
            source: source
        });
        if (source === "gridInitializing") colAutosize?.applyAutosizeStrategy();
    }
    // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
    // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
    // setPivotMode, applyColumnState,
    // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
    // pivotResultCols.setPivotResultCols
    refreshCols(newColDefs) {
        if (!this.colDefCols) return;
        const prevColTree = this.cols?.tree;
        this.saveColOrder();
        const { autoColSvc: autoColSvc, selectionColSvc: selectionColSvc, rowNumbersSvc: rowNumbersSvc, quickFilter: quickFilter, pivotResultCols: pivotResultCols, showRowGroupCols: showRowGroupCols, rowAutoHeight: rowAutoHeight, visibleCols: visibleCols, colViewport: colViewport, eventSvc: eventSvc } = this.beans;
        const cols = this.selectCols(pivotResultCols, this.colDefCols);
        this.createColumnsForService([
            autoColSvc,
            selectionColSvc,
            rowNumbersSvc
        ], cols);
        const shouldSortNewColDefs = $437b23f6a393c3bf$var$_shouldMaintainColumnOrder(this.gos, this.showingPivotResult);
        if (!newColDefs || shouldSortNewColDefs) this.restoreColOrder(cols);
        this.positionLockedCols(cols);
        showRowGroupCols?.refresh();
        quickFilter?.refreshCols();
        this.setColSpanActive();
        rowAutoHeight?.setAutoHeightActive(cols);
        visibleCols.clear();
        colViewport.clear();
        const dispatchChangedEvent = !$437b23f6a393c3bf$export$893967cdb9833fdd(prevColTree, this.cols.tree);
        if (dispatchChangedEvent) eventSvc.dispatchEvent({
            type: "gridColumnsChanged"
        });
    }
    createColumnsForService(services, cols) {
        for (const service of services){
            if (!service) continue;
            service.createColumns(cols, (updateOrder)=>{
                this.lastOrder = updateOrder(this.lastOrder);
                this.lastPivotOrder = updateOrder(this.lastPivotOrder);
            });
            service.addColumns(cols);
        }
    }
    selectCols(pivotResultColsSvc, colDefCols) {
        const pivotResultCols = pivotResultColsSvc?.getPivotResultCols() ?? null;
        this.showingPivotResult = pivotResultCols != null;
        const { map: map, list: list, tree: tree, treeDepth: treeDepth } = pivotResultCols ?? colDefCols;
        this.cols = {
            list: list.slice(),
            map: {
                ...map
            },
            tree: tree.slice(),
            treeDepth: treeDepth
        };
        if (pivotResultCols) {
            const hasSameColumns = pivotResultCols.list.some((col)=>this.cols?.map[col.getColId()] !== void 0);
            if (!hasSameColumns) this.lastPivotOrder = null;
        }
        return this.cols;
    }
    getColsToShow() {
        if (!this.cols) return [];
        const showAutoGroupAndValuesOnly = this.isPivotMode() && !this.showingPivotResult;
        const valueColumns = this.beans.valueColsSvc?.columns;
        const res = this.cols.list.filter((col)=>{
            const isAutoGroupCol = $437b23f6a393c3bf$export$61b34611dc010a97(col);
            if (showAutoGroupAndValuesOnly) {
                const isValueCol = valueColumns?.includes(col);
                return isAutoGroupCol || isValueCol;
            } else return isAutoGroupCol || col.isVisible();
        });
        return res;
    }
    // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
    refreshAll(source) {
        if (!this.ready) return;
        this.refreshCols(false);
        this.beans.visibleCols.refresh(source);
    }
    setColsVisible(keys, visible = false, source) {
        $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: keys.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    /**
   * Restores provided columns order to the previous order in this.lastPivotOrder / this.lastOrder
   * If columns are not in the last order:
   *  - Check column groups, and apply column after the last column in the lowest shared group
   *  - If no sibling is found, apply the column at the end of the cols
   */ restoreColOrder(cols) {
        const lastOrder = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
        if (!lastOrder) return;
        const preservedOrder = lastOrder.filter((col)=>cols.map[col.getId()] != null);
        if (preservedOrder.length === 0) return;
        if (preservedOrder.length === cols.list.length) {
            cols.list = preservedOrder;
            return;
        }
        const hasSiblings = (col)=>{
            const ancestor = col.getOriginalParent();
            if (!ancestor) return false;
            const children = ancestor.getChildren();
            if (children.length > 1) return true;
            return hasSiblings(ancestor);
        };
        if (!preservedOrder.some((col)=>hasSiblings(col))) {
            const preservedOrderSet = new Set(preservedOrder);
            for (const col of cols.list)if (!preservedOrderSet.has(col)) preservedOrder.push(col);
            cols.list = preservedOrder;
            return;
        }
        const colPositionMap = /* @__PURE__ */ new Map();
        for(let i = 0; i < preservedOrder.length; i++){
            const col = preservedOrder[i];
            colPositionMap.set(col, i);
        }
        const additionalCols = cols.list.filter((col)=>!colPositionMap.has(col));
        if (additionalCols.length === 0) {
            cols.list = preservedOrder;
            return;
        }
        const getPreviousSibling = (col, group)=>{
            const parent = group ? group.getOriginalParent() : col.getOriginalParent();
            if (!parent) return null;
            let highestIdx = null;
            let highestSibling = null;
            for (const child of parent.getChildren()){
                if (child === group || child === col) continue;
                if (child instanceof $437b23f6a393c3bf$export$a8da3e2b83e5ddf2) {
                    const colIdx = colPositionMap.get(child);
                    if (colIdx == null) continue;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = child;
                    }
                    continue;
                }
                child.forEachLeafColumn((leafCol)=>{
                    const colIdx = colPositionMap.get(leafCol);
                    if (colIdx == null) return;
                    if (highestIdx == null || highestIdx < colIdx) {
                        highestIdx = colIdx;
                        highestSibling = leafCol;
                    }
                });
            }
            if (highestSibling == null) return getPreviousSibling(col, parent);
            return highestSibling;
        };
        const noSiblingsAvailable = [];
        const previousSiblingPosMap = /* @__PURE__ */ new Map();
        for (const col of additionalCols){
            const prevSiblingIdx = getPreviousSibling(col, null);
            if (prevSiblingIdx == null) {
                noSiblingsAvailable.push(col);
                continue;
            }
            const prev = previousSiblingPosMap.get(prevSiblingIdx);
            if (prev === void 0) previousSiblingPosMap.set(prevSiblingIdx, col);
            else if (Array.isArray(prev)) prev.push(col);
            else previousSiblingPosMap.set(prevSiblingIdx, [
                prev,
                col
            ]);
        }
        const result = new Array(cols.list.length);
        let resultPointer = result.length - 1;
        for(let i = noSiblingsAvailable.length - 1; i >= 0; i--)result[resultPointer--] = noSiblingsAvailable[i];
        for(let i = preservedOrder.length - 1; i >= 0; i--){
            const nextCol = preservedOrder[i];
            const extraCols = previousSiblingPosMap.get(nextCol);
            if (extraCols) {
                if (Array.isArray(extraCols)) for(let x = extraCols.length - 1; x >= 0; x--){
                    const col = extraCols[x];
                    result[resultPointer--] = col;
                }
                else result[resultPointer--] = extraCols;
            }
            result[resultPointer--] = nextCol;
        }
        cols.list = result;
    }
    positionLockedCols(cols) {
        cols.list = $437b23f6a393c3bf$var$placeLockedColumns(cols.list, this.gos);
    }
    saveColOrder() {
        if (this.showingPivotResult) this.lastPivotOrder = this.cols?.list ?? null;
        else this.lastOrder = this.cols?.list ?? null;
    }
    getColumnDefs() {
        return this.colDefCols ? this.beans.colDefFactory?.getColumnDefs(this.colDefCols.list, this.showingPivotResult, this.lastOrder, this.cols?.list ?? []) : void 0;
    }
    setColSpanActive() {
        this.colSpanActive = !!this.cols?.list.some((col)=>col.getColDef().colSpan != null);
    }
    isPivotMode() {
        return this.pivotMode;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode) return;
        this.pivotMode = pivotMode;
        if (!this.ready) return;
        this.refreshCols(false);
        const { visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        visibleCols.refresh(source);
        eventSvc.dispatchEvent({
            type: "columnPivotModeChanged"
        });
    }
    // + clientSideRowModel
    isPivotActive() {
        const pivotColumns = this.beans.pivotColsSvc?.columns;
        return this.pivotMode && !!pivotColumns?.length;
    }
    // called when dataTypes change
    recreateColumnDefs(e) {
        if (!this.cols) return;
        this.beans.autoColSvc?.updateColumns(e);
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(e.source);
        this.createColsFromColDefs(source);
    }
    setColumnDefs(columnDefs, source) {
        this.colDefs = columnDefs;
        this.createColsFromColDefs(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.colDefCols?.tree);
        super.destroy();
    }
    getColTree() {
        return this.cols?.tree ?? [];
    }
    // + columnSelectPanel
    getColDefColTree() {
        return this.colDefCols?.tree ?? [];
    }
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getColDefCols() {
        return this.colDefCols?.list ?? null;
    }
    // + moveColumnController
    getCols() {
        return this.cols?.list ?? [];
    }
    forAllCols(callback) {
        const { pivotResultCols: pivotResultCols, autoColSvc: autoColSvc, selectionColSvc: selectionColSvc } = this.beans;
        $437b23f6a393c3bf$var$_forAll(this.colDefCols?.list, callback);
        $437b23f6a393c3bf$var$_forAll(autoColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(selectionColSvc?.columns?.list, callback);
        $437b23f6a393c3bf$var$_forAll(pivotResultCols?.getPivotResultCols()?.list, callback);
    }
    getColsForKeys(keys) {
        if (!keys) return [];
        return keys.map((key)=>this.getCol(key)).filter((col)=>col != null);
    }
    getColDefCol(key) {
        if (!this.colDefCols?.list) return null;
        return this.getColFromCollection(key, this.colDefCols);
    }
    getCol(key) {
        if (key == null) return null;
        return this.getColFromCollection(key, this.cols);
    }
    /**
   * Get column exclusively by ID.
   *
   * Note getCol/getColFromCollection have poor performance when col has been removed.
   */ getColById(key) {
        return this.cols?.map[key] ?? null;
    }
    getColFromCollection(key, cols) {
        if (cols == null) return null;
        const { map: map, list: list } = cols;
        if (typeof key == "string" && map[key]) return map[key];
        for(let i = 0; i < list.length; i++){
            if ($437b23f6a393c3bf$export$f5687d41c39fa1b3(list[i], key)) return list[i];
        }
        return this.beans.autoColSvc?.getColumn(key) ?? this.beans.selectionColSvc?.getColumn(key) ?? null;
    }
};
// packages/ag-grid-community/src/columns/baseColsService.ts
var $437b23f6a393c3bf$export$3687f0f5678a5df3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dispatchColumnChangedEvent = $437b23f6a393c3bf$var$dispatchColumnChangedEvent;
        this.columns = [];
        this.columnIndexMap = {};
        this.updateIndexMap = ()=>{
            this.columnIndexMap = {};
            this.columns.forEach((col, index)=>this.columnIndexMap[col.getId()] = index);
        };
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.aggFuncSvc = beans.aggFuncSvc;
        this.visibleCols = beans.visibleCols;
    }
    sortColumns(compareFn) {
        this.columns.sort(compareFn);
        this.updateIndexMap();
    }
    setColumns(colKeys, source) {
        this.setColList(colKeys, this.columns, this.eventName, true, true, this.columnProcessors.set, source);
    }
    addColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, true, true, this.columnProcessors.add, this.eventName, source);
    }
    removeColumns(colKeys, source) {
        this.updateColList(colKeys, this.columns, false, true, this.columnProcessors.remove, this.eventName, source);
    }
    getColumnIndex(colId) {
        return this.columnIndexMap[colId];
    }
    setColList(colKeys = [], masterList, eventName, detectOrderChange, autoGroupsNeedBuilding, columnCallback, source) {
        const gridColumns = this.colModel.getCols();
        if (!gridColumns || gridColumns.length === 0) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(colKeys)) colKeys.forEach((key)=>{
            const column = this.colModel.getColDefCol(key);
            if (column) masterList.push(column);
        });
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        this.updateIndexMap();
        const primaryCols = this.colModel.getColDefCols();
        (primaryCols || []).forEach((column)=>{
            const added = masterList.indexOf(column) >= 0;
            columnCallback(column, added, source);
        });
        autoGroupsNeedBuilding && this.colModel.refreshCols(false);
        this.visibleCols.refresh(source);
        this.dispatchColumnChangedEvent(this.eventSvc, eventName, [
            ...changes.keys()
        ], source);
    }
    updateColList(keys = [], masterList, actionIsAdd, autoGroupsNeedBuilding, columnCallback, eventType, source) {
        if (!keys || keys.length === 0) return;
        let atLeastOne = false;
        const updatedCols = /* @__PURE__ */ new Set();
        keys.forEach((key)=>{
            if (!key) return;
            const columnToAdd = this.colModel.getColDefCol(key);
            if (!columnToAdd) return;
            updatedCols.add(columnToAdd);
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) return;
                masterList.push(columnToAdd);
            } else {
                const currentIndex = masterList.indexOf(columnToAdd);
                if (currentIndex < 0) return;
                for(let i = currentIndex + 1; i < masterList.length; i++)updatedCols.add(masterList[i]);
                $437b23f6a393c3bf$export$83a881c8b5120679(masterList, columnToAdd);
            }
            columnCallback(columnToAdd, actionIsAdd, source);
            atLeastOne = true;
        });
        if (!atLeastOne) return;
        this.updateIndexMap();
        if (autoGroupsNeedBuilding) this.colModel.refreshCols(false);
        this.visibleCols.refresh(source);
        const eventColumns = Array.from(updatedCols);
        this.eventSvc.dispatchEvent({
            type: eventType,
            columns: eventColumns,
            column: eventColumns.length === 1 ? eventColumns[0] : null,
            source: source
        });
    }
    extractCols(source, oldProvidedCols = []) {
        const previousCols = this.columns;
        const colsWithIndex = [];
        const colsWithValue = [];
        const { setFlagFunc: setFlagFunc, getIndexFunc: getIndexFunc, getInitialIndexFunc: getInitialIndexFunc, getValueFunc: getValueFunc, getInitialValueFunc: getInitialValueFunc } = this.columnExtractors;
        const primaryCols = this.colModel.getColDefCols() || [];
        primaryCols.forEach((col)=>{
            const colIsNew = oldProvidedCols.indexOf(col) < 0;
            const colDef = col.getColDef();
            const value = getValueFunc(colDef);
            const initialValue = getInitialValueFunc(colDef);
            const index = getIndexFunc(colDef);
            const initialIndex = getInitialIndexFunc(colDef);
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        });
        const getIndexForCol = (col)=>{
            const index = getIndexFunc(col.getColDef());
            const defaultIndex = getInitialIndexFunc(col.getColDef());
            return index != null ? index : defaultIndex;
        };
        colsWithIndex.sort((colA, colB)=>{
            const indexA = getIndexForCol(colA);
            const indexB = getIndexForCol(colB);
            if (indexA === indexB) return 0;
            if (indexA < indexB) return -1;
            return 1;
        });
        const res = [].concat(colsWithIndex);
        previousCols.forEach((col)=>{
            if (colsWithValue.indexOf(col) >= 0) res.push(col);
        });
        colsWithValue.forEach((col)=>{
            if (res.indexOf(col) < 0) res.push(col);
        });
        previousCols.forEach((col)=>{
            if (res.indexOf(col) < 0) setFlagFunc(col, false, source);
        });
        res.forEach((col)=>{
            if (previousCols.indexOf(col) < 0) setFlagFunc(col, true, source);
        });
        this.columns = res;
        this.updateIndexMap();
        return this.columns;
    }
    restoreColumnOrder(columnStateAccumulator, incomingColumnState) {
        const colList = this.columns;
        const primaryCols = this.colModel.getColDefCols();
        if (!colList.length || !primaryCols) return columnStateAccumulator;
        const updatedColIdArray = Object.keys(incomingColumnState);
        const updatedColIds = new Set(updatedColIdArray);
        const newColIds = new Set(updatedColIdArray);
        const allColIds = new Set(colList.map((column)=>{
            const colId = column.getColId();
            newColIds.delete(colId);
            return colId;
        }).concat(updatedColIdArray));
        const colIdsInOriginalOrder = [];
        const originalOrderMap = {};
        let orderIndex = 0;
        for(let i = 0; i < primaryCols.length; i++){
            const colId = primaryCols[i].getColId();
            if (allColIds.has(colId)) {
                colIdsInOriginalOrder.push(colId);
                originalOrderMap[colId] = orderIndex++;
            }
        }
        let index = 1e3;
        let hasAddedNewCols = false;
        let lastIndex = 0;
        const enableProp = this.columnOrdering.enableProp;
        const initialEnableProp = this.columnOrdering.initialEnableProp;
        const indexProp = this.columnOrdering.indexProp;
        const initialIndexProp = this.columnOrdering.initialIndexProp;
        const processPrecedingNewCols = (colId)=>{
            const originalOrderIndex = originalOrderMap[colId];
            for(let i = lastIndex; i < originalOrderIndex; i++){
                const newColId = colIdsInOriginalOrder[i];
                if (newColIds.has(newColId)) {
                    incomingColumnState[newColId][indexProp] = index++;
                    newColIds.delete(newColId);
                }
            }
            lastIndex = originalOrderIndex;
        };
        colList.forEach((column)=>{
            const colId = column.getColId();
            if (updatedColIds.has(colId)) {
                processPrecedingNewCols(colId);
                incomingColumnState[colId][indexProp] = index++;
            } else {
                const colDef = column.getColDef();
                const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                if (missingIndex) {
                    if (!hasAddedNewCols) {
                        const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                        if (propEnabled) processPrecedingNewCols(colId);
                        else {
                            newColIds.forEach((newColId)=>{
                                incomingColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                            });
                            index += colIdsInOriginalOrder.length;
                            hasAddedNewCols = true;
                        }
                    }
                    if (!columnStateAccumulator[colId]) columnStateAccumulator[colId] = {
                        colId: colId
                    };
                    columnStateAccumulator[colId][indexProp] = index++;
                }
            }
        });
        return columnStateAccumulator;
    }
};
// packages/ag-grid-community/src/columns/groupInstanceIdCreator.ts
var $437b23f6a393c3bf$export$b3b24737a74261fb = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// packages/ag-grid-community/src/components/emptyBean.ts
var $437b23f6a393c3bf$export$4f8bbae47c6ad8d2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
};
function $437b23f6a393c3bf$var$setupCompBean(ctrl, ctx, compBean) {
    if (compBean) ctrl.addDestroyFunc(()=>ctx.destroyBean(compBean));
    return compBean ?? ctrl;
}
// packages/ag-grid-community/src/rendering/cssClassManager.ts
var $437b23f6a393c3bf$export$a7053cb7eb605bd2 = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    toggleCss(className, addOrRemove) {
        if (!className) return;
        if (className.indexOf(" ") >= 0) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                list.forEach((cls)=>this.toggleCss(cls, addOrRemove));
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            this.getGui()?.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// packages/ag-grid-community/src/widgets/component.ts
var $437b23f6a393c3bf$var$compIdSequence = 0;
var $437b23f6a393c3bf$export$6c811454646ed8be = null;
var $437b23f6a393c3bf$export$16fa2f45be04daa8 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(templateOrParams, componentSelectors){
        super();
        this.suppressDataRefValidation = false;
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = $437b23f6a393c3bf$var$compIdSequence++;
        this.cssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>this.eGui);
        this.componentSelectors = new Map((componentSelectors ?? []).map((comp)=>[
                comp.selector,
                comp
            ]));
        if (templateOrParams) this.setTemplate(templateOrParams);
    }
    preConstruct() {
        this.wireTemplate(this.getGui());
        const debugId = "component-" + Object.getPrototypeOf(this)?.constructor?.name;
        this.css?.forEach((css)=>this.beans.environment.addGlobalCSS(css, debugId));
    }
    wireTemplate(element, paramsMap) {
        if (element && this.gos) {
            this.applyElementsToComponent(element);
            this.createChildComponentsFromTags(element, paramsMap);
        }
    }
    getCompId() {
        return this.compId;
    }
    getDataRefAttribute(element) {
        if (element.getAttribute) return element.getAttribute($437b23f6a393c3bf$var$DataRefAttribute);
        return null;
    }
    applyElementsToComponent(element, elementRef, paramsMap, newComponent = null) {
        if (elementRef === void 0) elementRef = this.getDataRefAttribute(element);
        if (elementRef) {
            const current = this[elementRef];
            if (current === $437b23f6a393c3bf$export$6c811454646ed8be) this[elementRef] = newComponent ?? element;
            else {
                const usedAsParamRef = paramsMap && paramsMap[elementRef];
                if (!this.suppressDataRefValidation && !usedAsParamRef) throw new Error(`data-ref: ${elementRef} on ${this.constructor.name} with ${current}`);
            }
        }
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = [];
        for (const childNode of parentNode.childNodes ?? [])childNodeList.push(childNode);
        childNodeList.forEach((childNode)=>{
            if (!(childNode instanceof HTMLElement)) return;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) for (const attr of childNode.attributes ?? [])childGui.setAttribute(attr.name, attr.value);
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        });
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const elementRef = this.getDataRefAttribute(element);
        const isAgGridComponent = key.indexOf("AG-") === 0;
        const componentSelector = isAgGridComponent ? this.componentSelectors.get(key) : null;
        let newComponent = null;
        if (componentSelector) {
            const componentParams = paramsMap && elementRef ? paramsMap[elementRef] : void 0;
            newComponent = new componentSelector.component(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
        } else if (isAgGridComponent) throw new Error(`selector: ${key}`);
        this.applyElementsToComponent(element, elementRef, paramsMap, newComponent);
        return newComponent;
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
    }
    activateTabIndex(elements) {
        const tabIndex = this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        elements.forEach((el)=>el.setAttribute("tabindex", tabIndex.toString()));
    }
    setTemplate(templateOrParams, componentSelectors, paramsMap) {
        let eGui;
        if (typeof templateOrParams === "string" || templateOrParams == null) eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb(templateOrParams);
        else eGui = $437b23f6a393c3bf$export$a232bb0480ae674a(templateOrParams);
        this.setTemplateFromElement(eGui, componentSelectors, paramsMap);
    }
    setTemplateFromElement(element, components, paramsMap, suppressDataRefValidation = false) {
        this.eGui = element;
        this.suppressDataRefValidation = suppressDataRefValidation;
        if (components) for(let i = 0; i < components.length; i++){
            const component = components[i];
            this.componentSelectors.set(component.selector, component);
        }
        this.wireTemplate(element, paramsMap);
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    getContainerAndElement(newChild, container) {
        let parent = container;
        if (newChild == null) return null;
        if (!parent) parent = this.eGui;
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) return {
            element: newChild,
            parent: parent
        };
        return {
            element: newChild.getGui(),
            parent: parent
        };
    }
    prependChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.insertAdjacentElement("afterbegin", element);
    }
    appendChild(newChild, container) {
        const { element: element, parent: parent } = this.getContainerAndElement(newChild, container) || {};
        if (!element || !parent) return;
        parent.appendChild(element);
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$a6c2c477cd60daa8(this.eGui, visible, {
                skipAriaHidden: skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eGui, displayed, {
                skipAriaHidden: skipAriaHidden
            });
            const event = {
                type: "displayChanged",
                visible: this.displayed
            };
            this.dispatchLocalEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCss(className) {
        this.cssManager.toggleCss(className, true);
    }
    removeCss(className) {
        this.cssManager.toggleCss(className, false);
    }
    toggleCss(className, addOrRemove) {
        this.cssManager.toggleCss(className, addOrRemove);
    }
    registerCSS(css) {
        this.css || (this.css = []);
        this.css.push(css);
    }
};
// packages/ag-grid-community/src/utils/promise.ts
function $437b23f6a393c3bf$export$2395b9dc826192b2(fn) {
    if (typeof fn.then === "function") return true;
    return false;
}
var $437b23f6a393c3bf$export$30ec7836a4847721 = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return promises.length ? new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        }) : _AgPromise.resolve();
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        this.waiters.forEach((waiter)=>waiter(value));
    }
    onReject(_) {}
};
// packages/ag-grid-community/src/components/framework/userComponentFactory.ts
function $437b23f6a393c3bf$var$doesImplementIComponent(candidate) {
    if (!candidate) return false;
    return candidate.prototype && "getGui" in candidate.prototype;
}
function $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, defObject, type, params) {
    const { name: name } = type;
    let compName;
    let jsComp;
    let fwComp;
    let paramsFromSelector;
    let popupFromSelector;
    let popupPositionFromSelector;
    if (defObject) {
        const defObjectAny = defObject;
        const selectorFunc = defObjectAny[name + "Selector"];
        const selectorRes = selectorFunc ? selectorFunc(params) : null;
        const assignComp = (providedJsComp)=>{
            if (typeof providedJsComp === "string") compName = providedJsComp;
            else if (providedJsComp != null && providedJsComp !== true) {
                const isFwkComp = frameworkOverrides.isFrameworkComponent(providedJsComp);
                if (isFwkComp) fwComp = providedJsComp;
                else jsComp = providedJsComp;
            }
        };
        if (selectorRes) {
            assignComp(selectorRes.component);
            paramsFromSelector = selectorRes.params;
            popupFromSelector = selectorRes.popup;
            popupPositionFromSelector = selectorRes.popupPosition;
        } else assignComp(defObjectAny[name]);
    }
    return {
        compName: compName,
        jsComp: jsComp,
        fwComp: fwComp,
        paramsFromSelector: paramsFromSelector,
        popupFromSelector: popupFromSelector,
        popupPositionFromSelector: popupPositionFromSelector
    };
}
var $437b23f6a393c3bf$var$UserComponentFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "userCompFactory";
    }
    wireBeans(beans) {
        this.agCompUtils = beans.agCompUtils;
        this.registry = beans.registry;
        this.frameworkCompWrapper = beans.frameworkCompWrapper;
        this.gridOptions = beans.gridOptions;
    }
    getCompDetailsFromGridOptions(type, defaultName, params, mandatory = false) {
        return this.getCompDetails(this.gridOptions, type, defaultName, params, mandatory);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { name: name, cellRenderer: cellRenderer } = type;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp, paramsFromSelector: paramsFromSelector, popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = $437b23f6a393c3bf$var$_getUserCompKeys(this.beans.frameworkOverrides, defObject, type, params);
        let defaultCompParams;
        const lookupFromRegistry = (key)=>{
            const item = this.registry.getUserComponent(name, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
                defaultCompParams = item.params;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !$437b23f6a393c3bf$var$doesImplementIComponent(jsComp)) jsComp = this.agCompUtils?.adaptFunction(type, jsComp);
        if (!jsComp && !fwComp) {
            const { validation: validation2 } = this.beans;
            if (mandatory && (compName !== defaultName || !defaultName)) {
                if (compName) {
                    if (!validation2?.isProvidedUserComp(compName)) $437b23f6a393c3bf$export$a20c7248650823a9(50, {
                        compName: compName
                    });
                } else {
                    if (defaultName) {
                        if (!validation2) $437b23f6a393c3bf$export$a20c7248650823a9(260, {
                            ...this.gos.getModuleErrorParams(),
                            propName: name,
                            compName: defaultName
                        });
                    } else $437b23f6a393c3bf$export$a20c7248650823a9(216, {
                        name: name
                    });
                }
            } else if (defaultName && !validation2) $437b23f6a393c3bf$export$a20c7248650823a9(146, {
                comp: defaultName
            });
            return;
        }
        const paramsMerged = this.mergeParams(defObject, type, params, paramsFromSelector, defaultCompParams);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ?? fwComp;
        return {
            componentFromFramework: componentFromFramework,
            componentClass: componentClass,
            params: paramsMerged,
            type: type,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else instance = this.frameworkCompWrapper.wrap(ComponentClass, type.mandatoryMethods, type.optionalMethods, type);
        this.createBean(instance);
        const deferredInit = instance.init?.(params);
        if (deferredInit == null) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    /**
   * merges params with application provided params
   * used by Floating Filter
   */ mergeParams(defObject, type, paramsFromGrid, paramsFromSelector = null, defaultCompParams) {
        const params = {
            ...paramsFromGrid,
            ...defaultCompParams
        };
        const defObjectAny = defObject;
        const userParams = defObjectAny && defObjectAny[type.name + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParamsFromFunc);
        } else if (typeof userParams === "object") $437b23f6a393c3bf$export$8ade6bd474fcde42(params, userParams);
        $437b23f6a393c3bf$export$8ade6bd474fcde42(params, paramsFromSelector);
        return params;
    }
};
// packages/ag-grid-community/src/components/framework/userCompUtils.ts
var $437b23f6a393c3bf$var$DateComponent = {
    name: "dateComponent",
    mandatoryMethods: [
        "getDate",
        "setDate"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "setInputPlaceholder",
        "setInputAriaLabel",
        "setDisabled",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent = {
    name: "dragAndDropImageComponent",
    mandatoryMethods: [
        "setIcon",
        "setLabel"
    ]
};
var $437b23f6a393c3bf$var$HeaderComponent = {
    name: "headerComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$InnerHeaderComponent = {
    name: "innerHeaderComponent"
};
var $437b23f6a393c3bf$var$InnerHeaderGroupComponent = {
    name: "innerHeaderGroupComponent"
};
var $437b23f6a393c3bf$var$HeaderGroupComponent = {
    name: "headerGroupComponent"
};
var $437b23f6a393c3bf$var$InnerCellRendererComponent = {
    name: "innerRenderer",
    cellRenderer: true,
    optionalMethods: [
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$CellRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$EditorRendererComponent = {
    name: "cellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ]
};
var $437b23f6a393c3bf$var$LoadingCellRendererComponent = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$CellEditorComponent = {
    name: "cellEditor",
    mandatoryMethods: [
        "getValue"
    ],
    optionalMethods: [
        "isPopup",
        "isCancelBeforeStart",
        "isCancelAfterEnd",
        "getPopupPosition",
        "focusIn",
        "focusOut",
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent = {
    name: "loadingOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent = {
    name: "noRowsOverlayComponent",
    optionalMethods: [
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$TooltipComponent = {
    name: "tooltipComponent"
};
var $437b23f6a393c3bf$var$FilterComponent = {
    name: "filter",
    mandatoryMethods: [
        "isFilterActive",
        "doesFilterPass",
        "getModel",
        "setModel"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "afterGuiDetached",
        "onNewRowsLoaded",
        "getModelAsString",
        "onFloatingFilterChanged",
        "onAnyFilterChanged",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FloatingFilterComponent = {
    name: "floatingFilterComponent",
    mandatoryMethods: [
        "onParentModelChanged"
    ],
    optionalMethods: [
        "afterGuiAttached",
        "refresh"
    ]
};
var $437b23f6a393c3bf$var$FullWidth = {
    name: "fullWidthCellRenderer",
    optionalMethods: [
        "refresh",
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthLoading = {
    name: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthGroup = {
    name: "groupRowRenderer",
    optionalMethods: [
        "afterGuiAttached"
    ],
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthDetail = {
    name: "detailCellRenderer",
    optionalMethods: [
        "refresh"
    ],
    cellRenderer: true
};
function $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$DragAndDropImageComponent, "agDragAndDropImage", params, true);
}
function $437b23f6a393c3bf$export$c3f4e745c2fdf1c0(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$InnerCellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderCompDetails(userCompFactory, colDef, params) {
    return userCompFactory.getCompDetails(colDef, $437b23f6a393c3bf$var$HeaderComponent, "agColumnHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, headerCompParams, params) {
    return userCompFactory.getCompDetails(headerCompParams, $437b23f6a393c3bf$var$InnerHeaderComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params) {
    const colGroupDef = params.columnGroup.getColGroupDef();
    return userCompFactory.getCompDetails(colGroupDef, $437b23f6a393c3bf$var$HeaderGroupComponent, "agColumnGroupHeader", params);
}
function $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, headerGroupCompParams, params) {
    return userCompFactory.getCompDetails(headerGroupCompParams, $437b23f6a393c3bf$var$InnerHeaderGroupComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidth, void 0, params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthLoading, "agLoadingCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthGroup, "agGroupRowRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$FullWidthDetail, "agDetailCellRenderer", params, true);
}
function $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$export$85a10ea90cfc8a53(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$EditorRendererComponent, void 0, params);
}
function $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
}
function $437b23f6a393c3bf$var$_getCellEditorDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$CellEditorComponent, "agCellEditor", params, true);
}
function $437b23f6a393c3bf$export$e6db9a2d59456da0(userCompFactory, def, params, defaultFilter) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FilterComponent, defaultFilter, params, true);
}
function $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, def, params) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$DateComponent, "agDateInput", params, true);
}
function $437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$LoadingOverlayComponent, "agLoadingOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetailsFromGridOptions($437b23f6a393c3bf$var$NoRowsOverlayComponent, "agNoRowsOverlay", params, true);
}
function $437b23f6a393c3bf$var$_getTooltipCompDetails(userCompFactory, params) {
    return userCompFactory.getCompDetails(params.colDef, $437b23f6a393c3bf$var$TooltipComponent, "agTooltipComponent", params, true);
}
function $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, def, params, defaultFloatingFilter) {
    return userCompFactory.getCompDetails(def, $437b23f6a393c3bf$var$FloatingFilterComponent, defaultFloatingFilter, params);
}
function $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def) {
    return $437b23f6a393c3bf$var$_getUserCompKeys(frameworkOverrides, def, $437b23f6a393c3bf$var$FilterComponent);
}
function $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, defObject, paramsFromGrid) {
    return userCompFactory.mergeParams(defObject, $437b23f6a393c3bf$var$FilterComponent, paramsFromGrid);
}
// packages/ag-grid-community/src/components/framework/unwrapUserComp.ts
function $437b23f6a393c3bf$export$213d4c63c3df47e4(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny != null && compAsAny.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
// packages/ag-grid-community/src/modules/moduleRegistry.ts
var $437b23f6a393c3bf$var$allRegisteredModules = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$globalModulesMap = {};
var $437b23f6a393c3bf$var$gridModulesMap = {};
var $437b23f6a393c3bf$var$currentModuleVersion;
var $437b23f6a393c3bf$var$userHasRegistered = false;
var $437b23f6a393c3bf$var$areGridScopedModules = false;
var $437b23f6a393c3bf$var$isUmd = false;
function $437b23f6a393c3bf$var$isValidModuleVersion(module) {
    const [moduleMajor, moduleMinor] = module.version.split(".") || [];
    const [currentModuleMajor, currentModuleMinor] = $437b23f6a393c3bf$var$currentModuleVersion.split(".") || [];
    return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
}
function $437b23f6a393c3bf$var$runVersionChecks(module) {
    if (!$437b23f6a393c3bf$var$currentModuleVersion) $437b23f6a393c3bf$var$currentModuleVersion = module.version;
    const errorMsg = (details)=>`You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${details} Please update all modules to the same version.`;
    if (!module.version) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is incompatible.`));
    else if (!$437b23f6a393c3bf$var$isValidModuleVersion(module)) $437b23f6a393c3bf$var$_errorOnce(errorMsg(`'${module.moduleName}' is version ${module.version} but the other modules are version ${$437b23f6a393c3bf$var$currentModuleVersion}.`));
    if (module.validate) {
        const result = module.validate();
        if (!result.isValid) {
            const errorResult = result;
            $437b23f6a393c3bf$var$_errorOnce(`${errorResult.message}`);
        }
    }
}
function $437b23f6a393c3bf$export$d0b008fbcc09e577(module, gridId, isInternalRegistration = false) {
    if (!isInternalRegistration) $437b23f6a393c3bf$var$userHasRegistered = true;
    $437b23f6a393c3bf$var$runVersionChecks(module);
    const rowModels = module.rowModels ?? [
        "all"
    ];
    $437b23f6a393c3bf$var$allRegisteredModules.add(module);
    let moduleStore;
    if (gridId !== void 0) {
        $437b23f6a393c3bf$var$areGridScopedModules = true;
        if ($437b23f6a393c3bf$var$gridModulesMap[gridId] === void 0) $437b23f6a393c3bf$var$gridModulesMap[gridId] = {};
        moduleStore = $437b23f6a393c3bf$var$gridModulesMap[gridId];
    } else moduleStore = $437b23f6a393c3bf$var$globalModulesMap;
    rowModels.forEach((rowModel)=>{
        if (moduleStore[rowModel] === void 0) moduleStore[rowModel] = {};
        moduleStore[rowModel][module.moduleName] = module;
    });
    if (module.dependsOn) module.dependsOn.forEach((dependency)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(dependency, gridId, isInternalRegistration));
}
function $437b23f6a393c3bf$var$_unRegisterGridModules(gridId) {
    delete $437b23f6a393c3bf$var$gridModulesMap[gridId];
}
function $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, gridId, rowModel) {
    const isRegisteredForRowModel = (model)=>!!$437b23f6a393c3bf$var$globalModulesMap[model]?.[moduleName] || !!$437b23f6a393c3bf$var$gridModulesMap[gridId]?.[model]?.[moduleName];
    return isRegisteredForRowModel(rowModel) || isRegisteredForRowModel("all");
}
function $437b23f6a393c3bf$var$_areModulesGridScoped() {
    return $437b23f6a393c3bf$var$areGridScopedModules;
}
function $437b23f6a393c3bf$var$_getRegisteredModules(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap["all"] ?? {}),
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values($437b23f6a393c3bf$var$globalModulesMap[rowModel] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_getAllRegisteredModules() {
    return new Set($437b23f6a393c3bf$var$allRegisteredModules);
}
function $437b23f6a393c3bf$export$7c244c452cd4b417(gridId, rowModel) {
    const gridModules = $437b23f6a393c3bf$var$gridModulesMap[gridId] ?? {};
    return [
        ...Object.values(gridModules["all"] ?? {}),
        ...Object.values(gridModules[rowModel] ?? {})
    ];
}
function $437b23f6a393c3bf$var$_hasUserRegistered() {
    return $437b23f6a393c3bf$var$userHasRegistered;
}
function $437b23f6a393c3bf$var$_isUmd() {
    return $437b23f6a393c3bf$var$isUmd;
}
function $437b23f6a393c3bf$export$8bf1e03cfb50cab5() {
    $437b23f6a393c3bf$var$isUmd = true;
}
var $437b23f6a393c3bf$export$dc053975cc7f6c11 = class {
    /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */ static register(module) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        modules.forEach((module)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(module, void 0));
    }
};
// packages/ag-grid-community/src/context/genericContext.ts
var $437b23f6a393c3bf$var$GenericContext = class {
    constructor(params){
        this.beans = {};
        this.createdBeans = [];
        this.destroyed = false;
        if (!params || !params.beanClasses) return;
        this.beanDestroyComparator = params.beanDestroyComparator;
        this.init(params);
    }
    init(params) {
        for (const beanName of Object.keys(params.providedBeanInstances))this.beans[beanName] = params.providedBeanInstances[beanName];
        params.beanClasses.forEach((BeanClass)=>{
            const instance = new BeanClass();
            if (instance.beanName) this.beans[instance.beanName] = instance;
            else console.error(`Bean ${BeanClass.name} is missing beanName`);
            this.createdBeans.push(instance);
        });
        params.derivedBeans?.forEach((beanFunc)=>{
            const { beanName: beanName, bean: bean } = beanFunc(this);
            this.beans[beanName] = bean;
            this.createdBeans.push(bean);
        });
        if (params.beanInitComparator) this.createdBeans.sort(params.beanInitComparator);
        this.initBeans(this.createdBeans);
    }
    getBeanInstances() {
        return Object.values(this.beans);
    }
    createBean(bean, afterPreCreateCallback) {
        if (!bean) throw Error("null bean");
        this.initBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    initBeans(beanInstances, afterPreCreateCallback) {
        beanInstances.forEach((instance)=>{
            instance.preWireBeans?.(this.beans);
            instance.wireBeans?.(this.beans);
        });
        beanInstances.forEach((instance)=>instance.preConstruct?.());
        if (afterPreCreateCallback) beanInstances.forEach(afterPreCreateCallback);
        beanInstances.forEach((instance)=>instance.postConstruct?.());
    }
    getBeans() {
        return this.beans;
    }
    getBean(name) {
        return this.beans[name];
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const beanInstances = this.getBeanInstances();
        if (this.beanDestroyComparator) beanInstances.sort(this.beanDestroyComparator);
        this.destroyBeans(beanInstances);
        this.beans = {};
        this.createdBeans = [];
    }
    /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */ destroyBean(bean) {
        bean?.destroy?.();
    }
    /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */ destroyBeans(beans) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i]);
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
};
// packages/ag-grid-community/src/context/context.ts
var $437b23f6a393c3bf$var$Context = class extends $437b23f6a393c3bf$var$GenericContext {
    init(params) {
        this.gridId = params.gridId;
        this.beans.context = this;
        this.destroyCallback = params.destroyCallback;
        super.init(params);
    }
    destroy() {
        super.destroy();
        $437b23f6a393c3bf$var$_unRegisterGridModules(this.gridId);
        this.destroyCallback?.();
    }
    getGridId() {
        return this.gridId;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/cssClassApplier.ts
var $437b23f6a393c3bf$var$CSS_FIRST_COLUMN = "ag-column-first";
var $437b23f6a393c3bf$var$CSS_LAST_COLUMN = "ag-column-last";
function $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$export$1784132bab54c462(abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(abstractColDef)) return [];
    return $437b23f6a393c3bf$var$getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
}
function $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, presentedColsService) {
    comp.toggleCss($437b23f6a393c3bf$var$CSS_FIRST_COLUMN, presentedColsService.isColAtEdge(column, "first"));
    comp.toggleCss($437b23f6a393c3bf$var$CSS_LAST_COLUMN, presentedColsService.isColAtEdge(column, "last"));
}
function $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        // bad naming, as colDef here can be a group or a column,
        // however most people won't appreciate the difference,
        // so keeping it as colDef to avoid confusion.
        colDef: abstractColDef,
        column: column,
        columnGroup: columnGroup
    });
}
function $437b23f6a393c3bf$var$getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(classesOrFunc)) return [];
    let classToUse;
    if (typeof classesOrFunc === "function") {
        const params = $437b23f6a393c3bf$var$getClassParams(abstractColDef, gos, column, columnGroup);
        classToUse = classesOrFunc(params);
    } else classToUse = classesOrFunc;
    if (typeof classToUse === "string") return [
        classToUse
    ];
    if (Array.isArray(classToUse)) return [
        ...classToUse
    ];
    return [];
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowUtils.ts
function $437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) {
    return !!(rowNode.rowPinned && rowNode.pinnedSibling);
}
function $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, end) {
    const isTop = float === "top";
    if (!start) return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, isTop ? rowModel.getPinnedTopRow(0) : rowModel.getPinnedBottomRow(0), end);
    if (!end) {
        const count = isTop ? rowModel.getPinnedTopRowCount() : rowModel.getPinnedBottomRowCount();
        return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(rowModel, float, start, isTop ? rowModel.getPinnedTopRow(count - 1) : rowModel.getPinnedBottomRow(count - 1));
    }
    let started = false;
    let finished = false;
    const range = [];
    rowModel.forEachPinnedRow(float, (node)=>{
        if (node === start && !started) {
            started = true;
            range.push(node);
            return;
        }
        if (started && node === end) {
            finished = true;
            range.push(node);
            return;
        }
        if (started && !finished) range.push(node);
    });
    return range;
}
// packages/ag-grid-community/src/constants/keyCode.ts
var $437b23f6a393c3bf$export$e9e0d96f49f57c33 = {
    BACKSPACE: "Backspace",
    TAB: "Tab",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: " ",
    LEFT: "ArrowLeft",
    UP: "ArrowUp",
    RIGHT: "ArrowRight",
    DOWN: "ArrowDown",
    DELETE: "Delete",
    F2: "F2",
    PAGE_UP: "PageUp",
    PAGE_DOWN: "PageDown",
    PAGE_HOME: "Home",
    PAGE_END: "End",
    // these should be used with `event.code` instead of `event.key`
    // as `event.key` changes when non-latin keyboards are used
    A: "KeyA",
    C: "KeyC",
    D: "KeyD",
    V: "KeyV",
    X: "KeyX",
    Y: "KeyY",
    Z: "KeyZ"
};
// packages/ag-grid-community/src/utils/focus.ts
var $437b23f6a393c3bf$var$keyboardModeActive = false;
var $437b23f6a393c3bf$var$instanceCount = 0;
function $437b23f6a393c3bf$var$addKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.addEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.addEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$removeKeyboardModeEvents(doc) {
    if ($437b23f6a393c3bf$var$instanceCount > 0) return;
    doc.removeEventListener("keydown", $437b23f6a393c3bf$var$toggleKeyboardMode);
    doc.removeEventListener("mousedown", $437b23f6a393c3bf$var$toggleKeyboardMode);
}
function $437b23f6a393c3bf$var$toggleKeyboardMode(event) {
    const isKeyboardActive = $437b23f6a393c3bf$var$keyboardModeActive;
    const isKeyboardEvent = event.type === "keydown";
    if (isKeyboardEvent) {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
    }
    if (isKeyboardActive === isKeyboardEvent) return;
    $437b23f6a393c3bf$var$keyboardModeActive = isKeyboardEvent;
}
function $437b23f6a393c3bf$var$_registerKeyboardFocusEvents(beans) {
    const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
    $437b23f6a393c3bf$var$addKeyboardModeEvents(eDocument);
    $437b23f6a393c3bf$var$instanceCount++;
    return ()=>{
        $437b23f6a393c3bf$var$instanceCount--;
        $437b23f6a393c3bf$var$removeKeyboardModeEvents(eDocument);
    };
}
function $437b23f6a393c3bf$export$e4c8c227337b7f23() {
    return $437b23f6a393c3bf$var$keyboardModeActive;
}
function $437b23f6a393c3bf$export$8865b8c867776648(beans, comp, eGui) {
    comp.addManagedElementListeners(eGui, {
        keydown: (e)=>{
            if (!e.defaultPrevented && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) {
                const backwards = e.shiftKey;
                if (!$437b23f6a393c3bf$export$83fc12531358bd28(beans, eGui, false, backwards)) {
                    if ($437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) e.preventDefault();
                }
            }
        }
    });
}
function $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, exclude, onlyUnmanaged = false) {
    const focusableString = $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR;
    let excludeString = $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE;
    if (exclude) excludeString += ", " + exclude;
    if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
    const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
        return $437b23f6a393c3bf$export$2badf4aa566524cb(node);
    });
    const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
    if (!excludeNodes.length) return nodes;
    const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
    return diff(nodes, excludeNodes);
}
function $437b23f6a393c3bf$export$8598088d375f416f(rootNode, up = false, onlyUnmanaged = false, excludeTabGuards = false) {
    const focusableElements = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, excludeTabGuards ? ".ag-tab-guard" : null, onlyUnmanaged);
    const toFocus = up ? $437b23f6a393c3bf$export$236389741107357f(focusableElements) : focusableElements[0];
    if (toFocus) {
        toFocus.focus({
            preventScroll: true
        });
        return true;
    }
    return false;
}
function $437b23f6a393c3bf$export$83fc12531358bd28(beans, rootNode, onlyManaged, backwards) {
    const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
    const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
    let currentIndex;
    if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
    else currentIndex = focusable.indexOf(activeEl);
    const nextIndex = currentIndex + (backwards ? -1 : 1);
    if (nextIndex < 0 || nextIndex >= focusable.length) return null;
    return focusable[nextIndex];
}
function $437b23f6a393c3bf$export$c4c49c776025d475(node, limit = 5) {
    let counter = 0;
    while(node && $437b23f6a393c3bf$var$_getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
    if ($437b23f6a393c3bf$var$_getTabIndex(node) === null) return null;
    return node;
}
function $437b23f6a393c3bf$export$b3beea4db79d8bb3(beans, fromBottom) {
    return beans.ctrlsSvc.get("gridCtrl").focusInnerElement(fromBottom);
}
function $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) {
    return beans.gos.get("suppressHeaderFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) {
    return beans.gos.get("suppressCellFocus") || !!beans.overlays?.isExclusive();
}
function $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, forceOut = false) {
    const gridCtrl = beans.ctrlsSvc.get("gridCtrl");
    if (!forceOut && gridCtrl.focusNextInnerContainer(backwards)) return true;
    if (forceOut || !backwards && !gridCtrl.isDetailGrid()) gridCtrl.forceFocusOutOfContainer(backwards);
    return false;
}
// packages/ag-grid-community/src/rendering/cell/cellKeyboardListenerFeature.ts
function $437b23f6a393c3bf$var$_isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) return $437b23f6a393c3bf$var$_isMacOsUserAgent();
    return false;
}
var $437b23f6a393c3bf$var$CellKeyboardListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, rowNode, rowCtrl){
        super();
        this.cellCtrl = cellCtrl;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.beans = beans;
    }
    init() {
        this.eGui = this.cellCtrl.eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2:
                this.onF2KeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        if (this.cellCtrl.editing) return;
        if (event.shiftKey && this.cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else {
            const currentCellPosition = this.cellCtrl.getFocusedCellPosition();
            this.beans.navigation?.navigateToNextCell(event, key, currentCellPosition, true);
        }
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        const { rangeSvc: rangeSvc, navigation: navigation } = this.beans;
        if (!rangeSvc) return;
        const endCell = rangeSvc.extendLatestRangeInDirection(event);
        if (endCell) navigation?.ensureCellVisible(endCell);
    }
    onTabKeyDown(event) {
        this.beans.navigation?.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        const { cellCtrl: cellCtrl, beans: beans, rowNode: rowNode } = this;
        const { gos: gos, rangeSvc: rangeSvc, eventSvc: eventSvc } = beans;
        if (cellCtrl.editing) return;
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellStart"
        });
        if ($437b23f6a393c3bf$var$_isDeleteKey(key, gos.get("enableCellEditingOnBackspace"))) {
            if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) rangeSvc.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const { column: column } = cellCtrl;
                const emptyValue = this.beans.valueSvc.getDeleteValue(column, rowNode);
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else beans.editSvc?.startRowOrCellEdit(cellCtrl, key, event);
        eventSvc.dispatchEvent({
            type: "keyShortcutChangedCellEnd"
        });
    }
    onEnterKeyDown(e) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (cellCtrl.editing || this.rowCtrl.editing) this.beans.editSvc?.stopRowOrCellEdit(cellCtrl, false, false, e.shiftKey);
        else if (beans.gos.get("enterNavigatesVertically")) {
            const key = e.shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            beans.navigation?.navigateToNextCell(null, key, cellCtrl.cellPosition, false);
        } else {
            beans.editSvc?.startRowOrCellEdit(cellCtrl, $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER, e);
            if (cellCtrl.editing) e.preventDefault();
        }
    }
    onF2KeyDown(event) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (!cellCtrl.editing) beans.editSvc?.startRowOrCellEdit(cellCtrl, $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2, event);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onEscapeKeyDown(event) {
        const { cellCtrl: cellCtrl, beans: beans } = this;
        if (cellCtrl.editing) beans.editSvc?.stopRowOrCellEdit(cellCtrl, true);
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        if (eventOnChildComponent || this.cellCtrl.editing) return;
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.onSpaceKeyDown(event);
        else if (this.beans.editSvc?.startRowOrCellEdit(this.cellCtrl, key, event)) event.preventDefault();
    }
    onSpaceKeyDown(event) {
        const { gos: gos } = this.beans;
        if (!this.cellCtrl.editing && $437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) this.beans.selectionSvc?.handleSelectionEvent(event, this.rowNode, "spaceKey");
        event.preventDefault();
    }
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$CellMouseListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans, column){
        super();
        this.cellCtrl = cellCtrl;
        this.column = column;
        this.beans = beans;
    }
    onMouseEvent(eventName, mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(mouseEvent) {
        if (this.beans.touchSvc?.handleCellDoubleClick(this, mouseEvent)) return;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, gos: gos, editSvc: editSvc } = this.beans;
        const isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
        if (rangeSvc && isMultiKey) {
            if (rangeSvc.getCellRangeCount(this.cellCtrl.cellPosition) > 1) rangeSvc.intersectLastRange(true);
        }
        const cellClickedEvent = this.cellCtrl.createEvent(mouseEvent, "cellClicked");
        eventSvc.dispatchEvent(cellClickedEvent);
        const colDef = this.column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        const editOnSingleClick = (gos.get("singleClickEdit") || colDef.singleClickEdit) && !gos.get("suppressClickEdit");
        if (editOnSingleClick && !(mouseEvent.shiftKey && rangeSvc?.getCellRanges().length != 0)) editSvc?.startRowOrCellEdit(this.cellCtrl, void 0, mouseEvent);
    }
    onCellDoubleClicked(mouseEvent) {
        const { column: column, beans: beans, cellCtrl: cellCtrl } = this;
        const { eventSvc: eventSvc, frameworkOverrides: frameworkOverrides, gos: gos, editSvc: editSvc } = beans;
        const colDef = column.getColDef();
        const cellDoubleClickedEvent = cellCtrl.createEvent(mouseEvent, "cellDoubleClicked");
        eventSvc.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        const editOnDoubleClick = !gos.get("singleClickEdit") && !gos.get("suppressClickEdit");
        if (editOnDoubleClick) editSvc?.startRowOrCellEdit(cellCtrl, null, mouseEvent);
    }
    onMouseDown(mouseEvent) {
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { eventSvc: eventSvc, rangeSvc: rangeSvc, rowNumbersSvc: rowNumbersSvc, focusSvc: focusSvc, gos: gos } = beans;
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const hasRanges = rangeSvc && !rangeSvc.isEmpty();
        const containsWidget = this.containsWidget(target);
        const { cellPosition: cellPosition } = cellCtrl;
        const isRowNumberColumn = $437b23f6a393c3bf$export$3d3e7d751f0445eb(cellPosition.column);
        if (rowNumbersSvc && isRowNumberColumn && !rowNumbersSvc.handleMouseDownOnCell(cellPosition, mouseEvent)) {
            if (rangeSvc) mouseEvent.preventDefault();
            mouseEvent.stopImmediatePropagation();
            return;
        }
        if (!shiftKey || !hasRanges) {
            const isEnableCellTextSelection = gos.get("enableCellTextSelection");
            const shouldFocus = isEnableCellTextSelection && mouseEvent.defaultPrevented;
            const forceBrowserFocus = ($437b23f6a393c3bf$var$_isBrowserSafari() || shouldFocus) && !cellCtrl.editing && !$437b23f6a393c3bf$var$_isFocusableFormField(target) && !containsWidget;
            cellCtrl.focusCell(forceBrowserFocus);
        }
        if (shiftKey && hasRanges && !focusSvc.isCellFocused(cellPosition)) {
            mouseEvent.preventDefault();
            const focusedCellPosition = focusSvc.getFocusedCell();
            if (focusedCellPosition) {
                const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellPosition;
                const focusedRowCtrl = beans.rowRenderer.getRowByPosition({
                    rowIndex: rowIndex,
                    rowPinned: rowPinned
                });
                const focusedCellCtrl = focusedRowCtrl?.getCellCtrl(column);
                if (focusedCellCtrl?.editing) focusedCellCtrl.stopEditing();
                focusSvc.setFocusedCell({
                    column: column,
                    rowIndex: rowIndex,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            }
        }
        if (containsWidget) return;
        if (rangeSvc) {
            if (isRowNumberColumn) mouseEvent.preventDefault();
            if (shiftKey) rangeSvc.extendLatestRangeToCell(cellPosition);
            else {
                const isMultiKey = ctrlKey || metaKey;
                rangeSvc.setRangeToCell(cellPosition, isMultiKey);
            }
        }
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseDown"));
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeSvc: rangeSvc } = this.beans;
        if (rangeSvc) {
            const cellInRange = rangeSvc.isCellInAnyRange(this.cellCtrl.cellPosition);
            const isRightClick = mouseEvent.button === 2 || mouseEvent.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-selection-checkbox", 3) || $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-drag-handle", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOut"));
        colHover?.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const { eventSvc: eventSvc, colHover: colHover } = this.beans;
        eventSvc.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, "cellMouseOver"));
        colHover?.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eCell = this.cellCtrl.eGui;
        const cellContainsTarget = eCell.contains(e.target);
        const cellContainsRelatedTarget = eCell.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellPositionFeature.ts
var $437b23f6a393c3bf$var$CellPositionFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.beans = beans;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: ()=>this.onNewColumnsLoaded()
        });
    }
    init() {
        this.eSetLeft = this.cellCtrl.getRootElement();
        this.eContent = this.cellCtrl.eGui;
        const cellSpan = this.cellCtrl.getCellSpan();
        if (!cellSpan) {
            this.setupColSpan();
            this.setupRowSpan();
        }
        this.onLeftChanged();
        this.onWidthChanged();
        if (!cellSpan) this._legacyApplyRowSpan();
        if (cellSpan) {
            const refreshSpanHeight = this.refreshSpanHeight.bind(this, cellSpan);
            refreshSpanHeight();
            this.addManagedListeners(this.beans.eventSvc, {
                paginationChanged: refreshSpanHeight,
                recalculateRowBounds: refreshSpanHeight,
                pinnedHeightChanged: refreshSpanHeight
            });
        }
    }
    refreshSpanHeight(cellSpan) {
        const spanHeight = cellSpan.getCellHeight();
        if (spanHeight != null) this.eContent.style.height = `${spanHeight}px`;
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this._legacyApplyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListeners(this.beans.eventSvc, {
            // because we are col spanning, a reorder of the cols can change what cols we are spanning over
            displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
            // because we are spanning over multiple cols, we check for width any time any cols width changes.
            // this is expensive - really we should be explicitly checking only the cols we are spanning over
            // instead of every col, however it would be tricky code to track the cols we are spanning over, so
            // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
            displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
        });
    }
    onWidthChanged() {
        if (!this.eContent) return;
        const width = this.getCellWidth();
        this.eContent.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const { column: column, rowNode: rowNode } = this;
        const colSpan = column.getColSpan(rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(column);
        else {
            let pointer = column;
            const pinned = column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.visibleCols.getColAfter(pointer);
                if (!pointer || $437b23f6a393c3bf$export$672d9e47bc342bac(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eSetLeft) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eSetLeft.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = $437b23f6a393c3bf$export$236389741107357f(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.printLayout || this.column.getPinned() === "left") return leftPosition;
        const { visibleCols: visibleCols } = this.beans;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    _legacyApplyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eContent.style.height = `${totalRowHeight}px`;
        this.eContent.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/cell/cellCtrl.ts
var $437b23f6a393c3bf$var$CSS_CELL = "ag-cell";
var $437b23f6a393c3bf$var$CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var $437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var $437b23f6a393c3bf$var$CSS_CELL_FOCUS = "ag-cell-focus";
var $437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var $437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
function $437b23f6a393c3bf$export$b5bf61dcea514250(gos, eventTarget) {
    return $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, eventTarget, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL);
}
var $437b23f6a393c3bf$var$instanceIdSequence2 = 0;
var $437b23f6a393c3bf$var$CellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.column = column;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
        this.rangeFeature = void 0;
        this.rowResizeFeature = void 0;
        this.positionFeature = void 0;
        this.customStyleFeature = void 0;
        this.tooltipFeature = void 0;
        this.mouseListener = void 0;
        this.keyboardListener = void 0;
        this.suppressRefreshCell = false;
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        this.focusEventWhileNotReady = null;
        // if cell has been focused, check if it's focused when destroyed
        this.hasBeenFocused = false;
        this.beans = beans;
        const { colId: colId } = column;
        this.instanceId = colId + "-" + $437b23f6a393c3bf$var$instanceIdSequence2++;
        this.createCellPosition();
        this.updateAndFormatValue(false);
    }
    addFeatures() {
        const { beans: beans } = this;
        this.positionFeature = new $437b23f6a393c3bf$var$CellPositionFeature(this, beans);
        this.customStyleFeature = beans.cellStyles?.createCellCustomStyleFeature(this, beans);
        this.mouseListener = new $437b23f6a393c3bf$var$CellMouseListenerFeature(this, beans, this.column);
        this.keyboardListener = new $437b23f6a393c3bf$var$CellKeyboardListenerFeature(this, beans, this.rowNode, this.rowCtrl);
        if (this.column.isTooltipEnabled()) this.enableTooltipFeature();
        const { rangeSvc: rangeSvc } = beans;
        const cellSelectionEnabled = rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(beans.gos);
        if (cellSelectionEnabled) this.rangeFeature = rangeSvc.createCellRangeFeature(beans, this);
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) this.rowResizeFeature = this.beans.rowNumbersSvc.createRowNumbersRowResizerFeature(beans, this);
    }
    isCellSpanning() {
        return false;
    }
    getCellSpan() {
        return void 0;
    }
    removeFeatures() {
        const context = this.beans.context;
        this.positionFeature = context.destroyBean(this.positionFeature);
        this.customStyleFeature = context.destroyBean(this.customStyleFeature);
        this.mouseListener = context.destroyBean(this.mouseListener);
        this.keyboardListener = context.destroyBean(this.keyboardListener);
        this.rangeFeature = context.destroyBean(this.rangeFeature);
        this.rowResizeFeature = context.destroyBean(this.rowResizeFeature);
        this.disableTooltipFeature();
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.enableCellTooltipFeature(this, value, shouldDisplayTooltip);
    }
    disableTooltipFeature() {
        this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
    }
    setComp(comp, eCell, _eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.comp = comp;
        this.eGui = eCell;
        this.printLayout = printLayout;
        compBean ?? (compBean = this);
        this.addDomData(compBean);
        this.addFeatures();
        compBean.addDestroyFunc(()=>this.removeFeatures());
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.setupFocus();
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper, compBean);
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
        this.positionFeature?.init();
        this.customStyleFeature?.setComp(comp);
        this.tooltipFeature?.refreshTooltip();
        this.keyboardListener?.init();
        this.rangeFeature?.setComp(comp);
        this.rowResizeFeature?.refreshRowResizer();
        if (startEditing && this.isCellEditable()) this.beans.editSvc?.startEditing(this);
        else this.showValue(false, true);
        if (this.onCompAttachedFuncs.length) {
            this.onCompAttachedFuncs.forEach((func)=>func());
            this.onCompAttachedFuncs = [];
        }
    }
    setupAutoHeight(eCellWrapper, compBean) {
        this.isAutoHeight = this.beans.rowAutoHeight?.setupCellAutoHeight(this, eCellWrapper, compBean) ?? false;
    }
    getCellAriaRole() {
        return this.column.getColDef().cellAriaRole ?? "gridcell";
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        return this.valueFormatted ?? this.value;
    }
    showValue(forceNewCellRendererInstance, skipRangeHandleRefresh) {
        const { beans: beans, column: column, rowNode: rowNode, rangeFeature: rangeFeature } = this;
        const { userCompFactory: userCompFactory } = beans;
        const valueToDisplay = this.getValueToDisplay();
        let compDetails;
        const isSsrmLoading = rowNode.stub && rowNode.groupData?.[column.getId()] == null;
        const colDef = column.getColDef();
        if (isSsrmLoading || this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            if (!isSsrmLoading || $437b23f6a393c3bf$export$3d3e7d751f0445eb(column)) compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, colDef, params);
            else compDetails = $437b23f6a393c3bf$var$_getLoadingCellRendererDetails(userCompFactory, colDef, params);
        }
        if (!compDetails && !isSsrmLoading && beans.findSvc?.isMatch(rowNode, column)) {
            const params = this.createCellRendererParams();
            compDetails = $437b23f6a393c3bf$export$1f172e021e4d8401(userCompFactory, {
                ...column.getColDef(),
                cellRenderer: "agFindCellRenderer"
            }, params);
        }
        this.comp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        if (!skipRangeHandleRefresh && rangeFeature) $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>rangeFeature?.refreshHandle());
        this.rowResizeFeature?.refreshRowResizer();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.comp.setIncludeSelection(this.includeSelection);
        this.comp.setIncludeDndSource(this.includeDndSource);
        this.comp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
    }
    /**
   * Wrapper providing general conditions under which control elements (e.g. checkboxes and drag handles)
   * are rendered for a particular cell.
   * @param value Whether to render the control in the specific context of the caller
   * @param allowManuallyPinned Whether manually pinned rows are permitted this form of control element
   */ // eslint-disable-next-line @typescript-eslint/ban-types
    isIncludeControl(value, allowManuallyPinned = false) {
        const rowUnpinned = this.rowNode.rowPinned == null;
        return (rowUnpinned || allowManuallyPinned && $437b23f6a393c3bf$var$_isManualPinnedRow(this.rowNode)) && !!value;
    }
    isCheckboxSelection(colDef) {
        const { rowSelection: rowSelection, groupDisplayType: groupDisplayType } = this.beans.gridOptions;
        const checkboxLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
        const isSelectionColumn = $437b23f6a393c3bf$export$f6074a9792015c5d(this.column);
        if (groupDisplayType === "custom" && checkboxLocation !== "selectionColumn" && isSelectionColumn) return false;
        return colDef.checkboxSelection || isSelectionColumn && typeof rowSelection === "object" && $437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(colDef), true);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    onPopupEditorClosed() {
        if (!this.editing) return;
        this.beans.editSvc?.stopRowOrCellEdit(this);
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        return this.beans.editSvc?.stopEditing(this, cancel) ?? false;
    }
    createCellRendererParams() {
        const { value: value, valueFormatted: valueFormatted, column: column, rowNode: rowNode, comp: comp, eGui: eGui, beans: { valueSvc: valueSvc, gos: gos } } = this;
        const res = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            value: value,
            valueFormatted: valueFormatted,
            getValue: ()=>valueSvc.getValueForDisplay(column, rowNode).value,
            setValue: (value2)=>valueSvc.setValue(rowNode, column, value2),
            formatValue: this.formatValue.bind(this),
            data: rowNode.data,
            node: rowNode,
            pinned: column.getPinned(),
            colDef: column.getColDef(),
            column: column,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: eGui,
            eParentOfValue: comp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value2, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value2, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value2, shouldDisplayTooltip);
                this.tooltipFeature?.refreshTooltip();
            }
        });
        return res;
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        if (this.refreshShouldDestroy()) this.rowCtrl?.recreateCell(this);
        else this.refreshCell(params);
    }
    // + stop editing {forceRefresh: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell(params) {
        if (this.suppressRefreshCell || this.editing) return;
        const colDef = this.column.getColDef();
        const newData = params != null && !!params.newData;
        const suppressFlash = params != null && !!params.suppressFlash;
        const noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
        const forceRefresh = params && params.forceRefresh || noValueProvided || newData;
        const isCellCompReady = !!this.comp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(newData, false);
            const processingFilterChange = this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && colDef.enableCellChangeFlash;
            if (flashCell) this.beans.cellFlashSvc?.flashCell(this);
            this.customStyleFeature?.applyUserStyles();
            this.customStyleFeature?.applyClassesFromColDef();
        }
        this.tooltipFeature?.refreshTooltip();
        this.customStyleFeature?.applyCellClassRules();
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    formatValue(value) {
        return this.callValueFormatter(value) ?? value;
    }
    callValueFormatter(value) {
        return this.beans.valueSvc.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode, true);
        this.value = value;
        this.valueFormatted = valueFormatted;
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    addDomData(compBean) {
        const element = this.eGui;
        $437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(this.beans.gos, element, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const { rowNode: rowNode, column: column, value: value, beans: beans } = this;
        const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            type: eventType,
            node: rowNode,
            data: rowNode.data,
            value: value,
            column: column,
            colDef: column.getColDef(),
            rowPinned: rowNode.rowPinned,
            event: domEvent,
            rowIndex: rowNode.rowIndex
        });
        return event;
    }
    processCharacter(event) {
        this.keyboardListener?.processCharacter(event);
    }
    onKeyDown(event) {
        this.keyboardListener?.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        this.mouseListener?.onMouseEvent(eventName, mouseEvent);
    }
    getColSpanningList() {
        return this.positionFeature.getColSpanningList();
    }
    onLeftChanged() {
        if (!this.comp) return;
        this.positionFeature?.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { comp: comp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.visibleCols.getAriaColIndex(this.column);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(this.eGui, colIdx);
    }
    onWidthChanged() {
        return this.positionFeature?.onWidthChanged();
    }
    getRowPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.cellPosition;
        return {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.comp) return;
        this.rangeFeature?.updateRangeBordersIfRangeCount();
    }
    onCellSelectionChanged() {
        if (!this.comp) return;
        this.rangeFeature?.onCellSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.rangeFeature != null;
    }
    focusCell(forceBrowserFocus = false) {
        this.beans.focusSvc.setFocusedCell({
            ...this.getFocusedCellPosition(),
            forceBrowserFocus: forceBrowserFocus
        });
    }
    /**
   * Restores focus to the cell, if it should have it
   * @param waitForRender if the cell has just setComp, it may not be rendered yet, so we wait for the next render
   */ restoreFocus(waitForRender = false) {
        if (!this.comp || this.editing || !this.isCellFocused() || !this.beans.focusSvc.shouldTakeFocus()) return;
        const focus = ()=>{
            if (!this.isAlive()) return;
            const focusableElement = this.comp.getFocusableElement();
            if (this.isCellFocused()) focusableElement.focus({
                preventScroll: true
            });
        };
        if (waitForRender) {
            setTimeout(focus, 0);
            return;
        }
        focus();
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        this.restoreFocus();
        this.rangeFeature?.onCellSelectionChanged();
        this.rowResizeFeature?.refreshRowResizer();
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const element = this.eGui;
        if (!element) return;
        if ($437b23f6a393c3bf$export$3d3e7d751f0445eb(this.column)) suppressCellFocus = true;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(element, "tabindex", suppressCellFocus ? void 0 : -1);
    }
    onFirstRightPinnedChanged() {
        if (!this.comp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.comp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    /**
   * Returns whether cell is focused by the focusSvc, overridden by spannedCellCtrl
   */ checkCellFocused() {
        return this.beans.focusSvc.isCellFocused(this.cellPosition);
    }
    isCellFocused() {
        const isFocused = this.checkCellFocused();
        this.hasBeenFocused || (this.hasBeenFocused = isFocused);
        return isFocused;
    }
    setupFocus() {
        this.restoreFocus(true);
        this.onCellFocused(this.focusEventWhileNotReady ?? void 0);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) return;
        if (!this.comp) {
            if (event) this.focusEventWhileNotReady = event;
            return;
        }
        const cellFocused = this.isCellFocused();
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event && event.forceBrowserFocus) {
            let focusEl = this.comp.getFocusableElement();
            if (this.editing) {
                const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(focusEl, null, true);
                if (focusableEls.length) focusEl = focusableEls[0];
            }
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        const fullRowEdit = beans.gos.get("editType") === "fullRow";
        if (!cellFocused && !fullRowEdit && this.editing) beans.editSvc?.stopRowOrCellEdit(this);
        if (cellFocused) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = this.rowNode;
        this.cellPosition = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: this.column
        };
    }
    setInlineEditingCss() {
        this.beans.editSvc?.setInlineEditingCss(this.rowCtrl);
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        const { comp: comp } = this;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL, true);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        comp.toggleCss($437b23f6a393c3bf$var$CSS_AUTO_HEIGHT, autoHeight);
        comp.toggleCss($437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        this.beans.colHover?.onCellColumnHover(this.column, this.comp);
    }
    onColDefChanged() {
        if (!this.comp) return;
        if (this.column.isTooltipEnabled()) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (!this.editing) this.refreshOrDestroyCell({
            forceRefresh: true,
            suppressFlash: true
        });
        else this.beans.editSvc?.handleColDefChanged(this);
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.comp.toggleCss($437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, "cellContextMenu");
        const { beans: beans } = this;
        beans.eventSvc.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.comp?.getCellRenderer() ?? null;
    }
    destroy() {
        this.onCompAttachedFuncs = [];
        this.onEditorAttachedFuncs = [];
        if (this.isCellFocused() && this.hasBrowserFocus()) this.beans.focusSvc.attemptToRecoverFocus();
        super.destroy();
    }
    hasBrowserFocus() {
        return this.eGui?.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) ?? false;
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = this.beans.selectionSvc?.createCheckboxSelectionComponent();
        if (!cbSelectionComponent) return void 0;
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = this.beans.registry.createDynamicBean("dndSourceComp", false, this.rowNode, this.column, this.eGui);
        if (dndSourceComp) this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, suppressVisibilityChange) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
        }
    }
    createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForCell(this.rowNode, this.column, ()=>this.value, customElement, dragStartPixels, suppressVisibilityChange);
        if (!rowDragComp) return void 0;
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
    cellEditorAttached() {
        this.onEditorAttachedFuncs.forEach((func)=>func());
        this.onEditorAttachedFuncs = [];
    }
    setFocusedCellPosition(_cellPosition) {}
    getFocusedCellPosition() {
        return this.cellPosition;
    }
    // used by spannedCellCtrl
    refreshAriaRowIndex() {}
    /**
   * Returns the root element of the cell, could be a span container rather than the cell element.
   * @returns The root element of the cell.
   */ getRootElement() {
        return this.eGui;
    }
};
// packages/ag-grid-community/src/gridBodyComp/mouseEventUtils.ts
var $437b23f6a393c3bf$var$GRID_DOM_KEY = "__ag_grid_instance";
function $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(gos, eGridDiv) {
    eGridDiv[$437b23f6a393c3bf$var$GRID_DOM_KEY] = gos.gridInstanceId;
}
function $437b23f6a393c3bf$var$_isEventFromThisGrid(gos, event) {
    const res = $437b23f6a393c3bf$var$_isElementInThisGrid(gos, event.target);
    return res;
}
function $437b23f6a393c3bf$var$_isElementInThisGrid(gos, element) {
    let pointer = element;
    while(pointer){
        const instanceId = pointer[$437b23f6a393c3bf$var$GRID_DOM_KEY];
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(instanceId)) {
            const eventFromThisGrid = instanceId === gos.gridInstanceId;
            return eventFromThisGrid;
        }
        pointer = pointer.parentElement;
    }
    return false;
}
function $437b23f6a393c3bf$export$d85fcb0e6e51242(gos, event) {
    return $437b23f6a393c3bf$export$b5bf61dcea514250(gos, event.target)?.getFocusedCellPosition() ?? null;
}
function $437b23f6a393c3bf$export$530c24bdfacb8cd1(beans, event) {
    const gridPanelHasScrolls = $437b23f6a393c3bf$export$aa3ea9d0da61306f(beans.gos, "normal");
    const e = event;
    let x;
    let y;
    if (e.clientX != null || e.clientY != null) {
        x = e.clientX;
        y = e.clientY;
    } else {
        x = e.x;
        y = e.y;
    }
    const { pageFirstPixel: pageFirstPixel } = beans.pageBounds.getCurrentPagePixelRange();
    y += pageFirstPixel;
    if (gridPanelHasScrolls) {
        const scrollFeature = beans.ctrlsSvc.getScrollFeature();
        const vRange = scrollFeature.getVScrollPosition();
        const hRange = scrollFeature.getHScrollPosition();
        x += hRange.left;
        y += vRange.top;
    }
    return {
        x: x,
        y: y
    };
}
// packages/ag-grid-community/src/dragAndDrop/dragAndDropService.ts
var $437b23f6a393c3bf$export$46ba5a92125911d9 = /* @__PURE__ */ ((DragSourceType2)=>{
    DragSourceType2[DragSourceType2["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType2[DragSourceType2["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType2[DragSourceType2["RowDrag"] = 2] = "RowDrag";
    DragSourceType2[DragSourceType2["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType2[DragSourceType2["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType2;
})($437b23f6a393c3bf$export$46ba5a92125911d9 || {});
var $437b23f6a393c3bf$var$DragAndDropService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dragAndDrop";
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.dragSvc = beans.dragSvc;
        this.environment = beans.environment;
        this.userCompFactory = beans.userCompFactory;
    }
    addDragSource(dragSource, allowTouch = false) {
        const params = {
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragCancel: this.onDragCancel.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push({
            params: params,
            dragSource: dragSource
        });
        this.dragSvc.addDragSource(params);
    }
    getDragAndDropImageComponent() {
        const { dragAndDropImageComp: dragAndDropImageComp } = this;
        if (!dragAndDropImageComp || !dragAndDropImageComp.comp) return null;
        return dragAndDropImageComp.comp;
    }
    removeDragSource(dragSource) {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dragSvc: dragSvc } = this;
        const sourceAndParams = dragSourceAndParamsList.find((item)=>item.dragSource === dragSource);
        if (sourceAndParams) {
            dragSvc.removeDragSource(sourceAndParams.params);
            $437b23f6a393c3bf$export$83a881c8b5120679(dragSourceAndParamsList, sourceAndParams);
        }
    }
    destroy() {
        const { dragSourceAndParamsList: dragSourceAndParamsList, dragSvc: dragSvc, dropTargets: dropTargets } = this;
        dragSourceAndParamsList.forEach((sourceAndParams)=>dragSvc.removeDragSource(sourceAndParams.params));
        dragSourceAndParamsList.length = 0;
        dropTargets.length = 0;
        this.clearDragAndDropProperties();
        super.destroy();
    }
    nudge() {
        if (this.dragging) this.onDragging(this.eventLastTime, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragItem = dragSource.getDragItem();
        dragSource.onDragStarted?.();
        this.createDragAndDropImageComponent();
    }
    onDragStop(mouseEvent) {
        this.dragSource?.onDragStopped?.();
        const { lastDropTarget: lastDropTarget } = this;
        if (lastDropTarget?.onDragStop) {
            const draggingEvent = this.createDropTargetEvent(lastDropTarget, mouseEvent, null, null, false);
            lastDropTarget.onDragStop(draggingEvent);
        }
        this.clearDragAndDropProperties();
    }
    onDragCancel() {
        const { dragSource: dragSource, lastDropTarget: lastDropTarget } = this;
        dragSource?.onDragCancelled?.();
        if (lastDropTarget?.onDragCancel) lastDropTarget.onDragCancel(this.createDropTargetEvent(lastDropTarget, this.eventLastTime, null, null, false));
        this.clearDragAndDropProperties();
    }
    clearDragAndDropProperties() {
        this.eventLastTime = null;
        this.dragging = false;
        this.lastDropTarget = void 0;
        this.dragItem = null;
        this.dragSource = null;
        this.removeDragAndDropImageComponent();
    }
    onDragging(mouseEvent, fromNudge = false) {
        const hDirection = this.getHorizontalDirection(mouseEvent);
        const vDirection = this.getVerticalDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionDragAndDropImageComp(mouseEvent);
        const validDropTargets = this.dropTargets.filter((target)=>this.isMouseOnDropTarget(mouseEvent, target));
        const dropTarget = this.findCurrentDropTarget(mouseEvent, validDropTargets);
        const { lastDropTarget: lastDropTarget, dragSource: dragSource, dragAndDropImageComp: dragAndDropImageComp, dragItem: dragItem } = this;
        if (dropTarget !== lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            if (lastDropTarget !== null && dropTarget === null) dragSource?.onGridExit?.(dragItem);
            if (lastDropTarget === null && dropTarget !== null) dragSource?.onGridEnter?.(dragItem);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            if (dropTarget && dragAndDropImageComp) {
                const { comp: comp, promise: promise } = dragAndDropImageComp;
                if (comp) comp.setIcon(dropTarget.getIconName ? dropTarget.getIconName() : null, false);
                else promise.then((resolvedComponent)=>{
                    if (resolvedComponent) resolvedComponent.setIcon(dropTarget.getIconName ? dropTarget.getIconName() : null, false);
                });
            }
            this.lastDropTarget = dropTarget;
        } else if (dropTarget && dropTarget.onDragging) {
            const draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    }
    getAllContainersFromDropTarget(dropTarget) {
        const secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        const containers = [
            [
                dropTarget.getContainer()
            ]
        ];
        return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        const allContainersIntersect = (mouseEvent2, containers)=>{
            for (const container of containers){
                const { width: width, height: height, left: left, right: right, top: top, bottom: bottom } = container.getBoundingClientRect();
                if (width === 0 || height === 0) return false;
                const horizontalFit = mouseEvent2.clientX >= left && mouseEvent2.clientX < right;
                const verticalFit = mouseEvent2.clientY >= top && mouseEvent2.clientY < bottom;
                if (!horizontalFit || !verticalFit) return false;
            }
            return true;
        };
        for (const currentContainers of allContainersFromDropTarget)if (allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        const { eElement: eElement, type: type } = this.dragSource;
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(type, eElement);
    }
    findCurrentDropTarget(mouseEvent, validDropTargets) {
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for (const el of elementStack)for (const dropTarget of validDropTargets){
            const containers = this.getAllContainersFromDropTarget(dropTarget).flatMap((a)=>a);
            if (containers.indexOf(el) !== -1) return dropTarget;
        }
        return null;
    }
    enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) return;
        if (dropTarget.onDragEnter) {
            const dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragEnter(dragEnterEvent);
        }
    }
    leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge) {
        const { lastDropTarget: lastDropTarget } = this;
        if (!lastDropTarget) return;
        if (lastDropTarget.onDragLeave) {
            const dragLeaveEvent = this.createDropTargetEvent(lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            lastDropTarget.onDragLeave(dragLeaveEvent);
        }
        const dragAndDropImageComponent = this.getDragAndDropImageComponent();
        if (dragAndDropImageComponent) dragAndDropImageComponent.setIcon(null, false);
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
    }
    removeDropTarget(dropTarget) {
        this.dropTargets = this.dropTargets.filter((target)=>target.getContainer() !== dropTarget.getContainer());
    }
    hasExternalDropZones() {
        return this.dropTargets.some((zones)=>zones.external);
    }
    findExternalZone(params) {
        const externalTargets = this.dropTargets.filter((target)=>target.external);
        return externalTargets.find((zone)=>zone.getContainer() === params.getContainer()) || null;
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        const gridBodyCon = this.ctrlsSvc.getGridBodyCtrl();
        const gridGui = gridBodyCon.eGridBody;
        const { dropZoneTarget: dropZoneTarget } = draggingEvent;
        return gridGui.contains(dropZoneTarget);
    }
    getHorizontalDirection(event) {
        const clientX = this.eventLastTime?.clientX;
        const eClientX = event.clientX;
        if (clientX === eClientX) return null;
        return clientX > eClientX ? "left" : "right";
    }
    getVerticalDirection(event) {
        const clientY = this.eventLastTime?.clientY;
        const eClientY = event.clientY;
        if (clientY === eClientY) return null;
        return clientY > eClientY ? "up" : "down";
    }
    createDropTargetEvent(dropTarget, event, hDirection, vDirection, fromNudge) {
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { dragItem: dragItem, dragSource: dragSource, gos: gos } = this;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            event: event,
            x: x,
            y: y,
            vDirection: vDirection,
            hDirection: hDirection,
            dragSource: dragSource,
            fromNudge: fromNudge,
            dragItem: dragItem,
            dropZoneTarget: dropZoneTarget
        });
    }
    positionDragAndDropImageComp(event) {
        const dragAndDropImageComponent = this.getDragAndDropImageComponent();
        if (!dragAndDropImageComponent) return;
        $437b23f6a393c3bf$export$3ce6b987cf48b8c2(dragAndDropImageComponent.getGui(), event, this.beans);
    }
    removeDragAndDropImageComponent() {
        const { dragAndDropImageComp: dragAndDropImageComp } = this;
        if (dragAndDropImageComp) {
            const { comp: comp } = dragAndDropImageComp;
            if (comp) {
                const eGui = comp.getGui();
                this.dragAndDropImageParent?.removeChild(eGui);
                this.destroyBean(comp);
            }
        }
        this.dragAndDropImageComp = null;
    }
    createDragAndDropImageComponent() {
        const { dragSource: dragSource, gos: gos, userCompFactory: userCompFactory } = this;
        if (!dragSource) return;
        const userCompDetails = $437b23f6a393c3bf$var$_getDragAndDropImageCompDetails(userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            dragSource: dragSource
        }));
        if (!userCompDetails) return;
        const promise = userCompDetails.newAgStackInstance();
        this.dragAndDropImageComp = {
            promise: promise
        };
        promise.then((comp)=>{
            if (!comp || !this.isAlive()) return;
            this.processDragAndDropImageComponent(comp);
            this.dragAndDropImageComp.comp = comp;
        });
    }
    processDragAndDropImageComponent(dragAndDropImageComponent) {
        const { dragSource: dragSource, environment: environment } = this;
        if (!dragSource) return;
        const eGui = dragAndDropImageComponent.getGui();
        eGui.style.setProperty("position", "absolute");
        eGui.style.setProperty("z-index", "9999");
        $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(this.gos, eGui);
        environment.applyThemeClasses(eGui);
        dragAndDropImageComponent.setIcon(null, false);
        let { dragItemName: dragItemName } = dragSource;
        if (typeof dragItemName === "function") dragItemName = dragItemName();
        dragAndDropImageComponent.setLabel(dragItemName || "");
        eGui.style.top = "20px";
        eGui.style.left = "20px";
        const targetEl = $437b23f6a393c3bf$export$50c54e860701cf22(this.beans);
        this.dragAndDropImageParent = targetEl;
        if (!targetEl) $437b23f6a393c3bf$export$545083624300f13d(54);
        else targetEl.appendChild(eGui);
    }
    registerGridDropTarget(elementFn, ctrl) {
        const dropTarget = {
            getContainer: elementFn,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>"notAllowed"
        };
        this.addDropTarget(dropTarget);
        ctrl.addDestroyFunc(()=>this.removeDropTarget(dropTarget));
    }
};
// packages/ag-grid-community/src/autoScrollService.ts
var $437b23f6a393c3bf$export$c66bdc3d55a4f95 = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.indexOf("x") !== -1;
        this.scrollVertically = params.scrollAxis.indexOf("y") !== -1;
        this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        const tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// packages/ag-grid-community/src/entities/positionUtils.ts
function $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellPosition) {
    const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
    return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
}
function $437b23f6a393c3bf$export$be3973033c2c5267(cellA, cellB) {
    const colsMatch = cellA.column === cellB.column;
    const floatingMatch = cellA.rowPinned === cellB.rowPinned;
    const indexMatch = cellA.rowIndex === cellB.rowIndex;
    return colsMatch && floatingMatch && indexMatch;
}
function $437b23f6a393c3bf$export$6cce97428a227a31(rowA, rowB) {
    switch(rowA.rowPinned){
        case "top":
            if (rowB.rowPinned !== "top") return true;
            break;
        case "bottom":
            if (rowB.rowPinned !== "bottom") return false;
            break;
        default:
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowB.rowPinned)) return rowB.rowPinned !== "top";
            break;
    }
    return rowA.rowIndex < rowB.rowIndex;
}
function $437b23f6a393c3bf$export$de6f9fa10e9f4188(rowA, rowB) {
    if (!rowA && !rowB) return true;
    if (rowA && !rowB || !rowA && rowB) return false;
    return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
}
function $437b23f6a393c3bf$var$_getFirstRow(beans) {
    let rowIndex = 0;
    let rowPinned;
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel, pageBounds: pageBounds } = beans;
    if (pinnedRowModel?.getPinnedTopRowCount()) rowPinned = "top";
    else if (rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getFirstRow();
    } else if (pinnedRowModel?.getPinnedBottomRowCount()) rowPinned = "bottom";
    return rowPinned === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$var$_getLastRow(beans) {
    let rowIndex;
    let rowPinned = null;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    const pinnedBottomCount = pinnedRowModel?.getPinnedBottomRowCount();
    const pinnedTopCount = pinnedRowModel?.getPinnedTopRowCount();
    if (pinnedBottomCount) {
        rowPinned = "bottom";
        rowIndex = pinnedBottomCount - 1;
    } else if (beans.rowModel.getRowCount()) {
        rowPinned = null;
        rowIndex = pageBounds.getLastRow();
    } else if (pinnedTopCount) {
        rowPinned = "top";
        rowIndex = pinnedTopCount - 1;
    }
    return rowIndex === void 0 ? null : {
        rowIndex: rowIndex,
        rowPinned: rowPinned
    };
}
function $437b23f6a393c3bf$export$d4675a60917db7b0(beans, gridRow) {
    switch(gridRow.rowPinned){
        case "top":
            return beans.pinnedRowModel?.getPinnedTopRow(gridRow.rowIndex);
        case "bottom":
            return beans.pinnedRowModel?.getPinnedBottomRow(gridRow.rowIndex);
        default:
            return beans.rowModel.getRow(gridRow.rowIndex);
    }
}
function $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, cellPosition) {
    const spannedCellCtrl = beans.spannedRowRenderer?.getCellByPosition(cellPosition);
    if (spannedCellCtrl) return spannedCellCtrl;
    const rowCtrl = beans.rowRenderer.getRowByPosition(cellPosition);
    if (!rowCtrl) return null;
    return rowCtrl.getCellCtrl(cellPosition.column);
}
function $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, rowPosition) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if (index === 0) {
        if (pinned === "top") return null;
        if (pinned === "bottom" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getLastRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("top") ? {
            rowIndex: pinnedRowModel.getPinnedTopRowCount() - 1,
            rowPinned: "top"
        } : null;
    }
    const rowNode = pinned ? void 0 : rowModel.getRow(index);
    return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, true) ?? {
        rowIndex: index - 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$export$3077f3bcabdc5ad1(beans, rowPosition) {
    const { rowIndex: index, rowPinned: pinned } = rowPosition;
    const { pageBounds: pageBounds, pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    if ($437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition)) {
        if (pinned === "bottom") return null;
        if (pinned === "top" && rowModel.isRowsToRender()) return {
            rowIndex: pageBounds.getFirstRow(),
            rowPinned: null
        };
        return pinnedRowModel?.isRowsToRender("bottom") ? {
            rowIndex: 0,
            rowPinned: "bottom"
        } : null;
    }
    const rowNode = pinned ? void 0 : rowModel.getRow(index);
    return $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode) ?? {
        rowIndex: index + 1,
        rowPinned: pinned
    };
}
function $437b23f6a393c3bf$var$getNextStickyPosition(beans, rowNode, up) {
    const { gos: gos, rowRenderer: rowRenderer } = beans;
    if (!rowNode?.sticky || !$437b23f6a393c3bf$export$d5f33aacea6a0849(gos)) return;
    const stickyRowCtrls = up ? rowRenderer.getStickyTopRowCtrls() : rowRenderer.getStickyBottomRowCtrls();
    let nextCtrl;
    for(let i = 0; i < stickyRowCtrls.length; i++)if (stickyRowCtrls[i].rowNode.rowIndex === rowNode.rowIndex) {
        nextCtrl = stickyRowCtrls[i + (up ? -1 : 1)];
        break;
    }
    return nextCtrl ? {
        rowIndex: nextCtrl.rowNode.rowIndex,
        rowPinned: null
    } : void 0;
}
function $437b23f6a393c3bf$var$isLastRowInContainer(beans, rowPosition) {
    const { rowPinned: rowPinned, rowIndex: rowIndex } = rowPosition;
    const { pinnedRowModel: pinnedRowModel, pageBounds: pageBounds } = beans;
    if (rowPinned === "top") {
        const lastTopIndex = (pinnedRowModel?.getPinnedTopRowCount() ?? 0) - 1;
        return lastTopIndex <= rowIndex;
    }
    if (rowPinned === "bottom") {
        const lastBottomIndex = (pinnedRowModel?.getPinnedBottomRowCount() ?? 0) - 1;
        return lastBottomIndex <= rowIndex;
    }
    const lastBodyIndex = pageBounds.getLastRow();
    return lastBodyIndex <= rowIndex;
}
// packages/ag-grid-community/src/utils/changedPath.ts
var $437b23f6a393c3bf$export$cb4d9114a9732e85 = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations).
        // can be set inactive by:
        // a) ClientSideRowModel, if no transactions or
        // b) PivotService, if secondary columns changed
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        const { rowNode: rowNode, children: children } = pathItem;
        if (children) for(let i = 0; i < children.length; ++i)this.depthFirstSearchChangedPath(children[i], callback);
        callback(rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        const childrenAfterGroup = rowNode.childrenAfterGroup;
        if (childrenAfterGroup) for(let i = 0, len = childrenAfterGroup.length; i < len; ++i){
            const childNode = childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(childNode, callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            columns.forEach((col)=>this.nodeIdsToColumns[pointer.id][col.getId()] = true);
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragFeature.ts
var $437b23f6a393c3bf$var$RowDragFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { rowModel: rowModel, gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        ctrlsSvc.whenReady(this, (p)=>{
            const gridBodyCon = p.gridBodyCtrl;
            this.autoScrollService = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
                scrollContainer: gridBodyCon.eBodyViewport,
                scrollAxis: "y",
                getVerticalPosition: ()=>gridBodyCon.scrollFeature.getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCon.scrollFeature.setVerticalScrollPosition(position),
                onScrollCallback: ()=>{
                    this.onDragging(this.lastDraggingEvent);
                }
            });
        });
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName() {
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return "notAllowed";
        return "move";
    }
    shouldPreventRowMove() {
        const { rowGroupColsSvc: rowGroupColsSvc, filterManager: filterManager, sortSvc: sortSvc } = this.beans;
        const rowGroupCols = rowGroupColsSvc?.columns ?? [];
        if (rowGroupCols.length) return true;
        const isFilterPresent = filterManager?.isAnyFilterPresent();
        if (isFilterPresent) return true;
        const isSortActive = sortSvc?.isSortActive();
        if (isSortActive) return true;
        return false;
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (isRowDragMultiRow) {
            const selectedNodes = [
                ...this.beans.selectionSvc?.getSelectedNodes() ?? []
            ].sort((a, b)=>{
                if (a.rowIndex == null || b.rowIndex == null) return 0;
                return this.getRowIndexNumber(a) - this.getRowIndexNumber(b);
            });
            if (selectedNodes.indexOf(currentNode) !== -1) return selectedNodes;
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        draggingEvent.dragItem.rowNodes = this.getRowNodes(draggingEvent);
        this.dispatchGridEvent("rowDragEnter", draggingEvent);
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            this.setRowNodeDragging(rowNode, true);
        });
        this.onEnterOrDragging(draggingEvent);
    }
    onDragging(draggingEvent) {
        this.onEnterOrDragging(draggingEvent);
    }
    isFromThisGrid(draggingEvent) {
        const { dragSourceDomDataKey: dragSourceDomDataKey } = draggingEvent.dragSource;
        return dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    onEnterOrDragging(draggingEvent) {
        this.dispatchGridEvent("rowDragMove", draggingEvent);
        this.lastDraggingEvent = draggingEvent;
        if (this.gos.get("rowDragManaged")) this.doManagedDrag(draggingEvent);
        this.autoScrollService.check(draggingEvent.event);
    }
    doManagedDrag(draggingEvent) {
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        const isFromThisGrid = this.isFromThisGrid(draggingEvent);
        const managedDrag = gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return;
        if (gos.get("suppressMoveWhenRowDragging") || !isFromThisGrid) {
            if (dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) {
                const clientSideRowModel = this.clientSideRowModel;
                const rowsDrop = this.getRowsDrop(draggingEvent);
                const target = rowsDrop?.target;
                if (target) clientSideRowModel.highlightRow(target, rowsDrop.delta < 0 ? "Above" : "Below");
                else clientSideRowModel.clearHighlight();
            }
        } else {
            const rowsDrop = this.getRowsDrop(draggingEvent);
            if (rowsDrop) this.dropRows(rowsDrop);
        }
    }
    getRowIndexNumber(rowNode) {
        const rowIndexStr = rowNode.getRowIndexString();
        return parseInt($437b23f6a393c3bf$export$236389741107357f(rowIndexStr.split("-")), 10);
    }
    getRowsDrop(draggingEvent) {
        const { rowNode: rowNode, rowNodes: rows } = draggingEvent.dragItem;
        const rowsLen = rows?.length;
        const sameGrid = this.isFromThisGrid(draggingEvent);
        const source = rowsLen && (rowNode ?? rows[0]);
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(this.beans, draggingEvent).y;
        const clientSideRowModel = this.clientSideRowModel;
        const targetRowIndex = clientSideRowModel.getRowIndexAtPixel(y);
        let target = clientSideRowModel.getRow(targetRowIndex);
        let delta = 0;
        if (!source) return null;
        if (sameGrid) {
            if (!target || target === source) return null;
            delta = targetRowIndex - source.rowIndex;
            if (rows.includes(target)) target = (delta < 0 ? this.getPrevOrNext(-1, rows[0]) : this.getPrevOrNext(1, $437b23f6a393c3bf$export$236389741107357f(rows))) ?? target;
        }
        if (target && (!sameGrid || delta < -1 || delta > 1)) delta = y - target.rowTop - target.rowHeight / 2;
        return {
            sameGrid: sameGrid,
            delta: delta,
            target: target,
            rows: rows
        };
    }
    /** When dragging multiple rows, we want the user to be able to drag to the prev or next in the group if dragging on one of the selected rows. */ getPrevOrNext(increment, initialRow) {
        const clientSideRowModel = this.clientSideRowModel;
        const rowCount = clientSideRowModel.getRowCount();
        let rowIndex = initialRow.rowIndex + increment;
        while(rowIndex >= 0 && rowIndex < rowCount){
            const row = clientSideRowModel.getRow(rowIndex);
            if (row.sourceRowIndex >= 0) return row;
            rowIndex += increment;
        }
        return void 0;
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            $437b23f6a393c3bf$export$545083624300f13d(55);
            return;
        }
        const dragAndDrop = this.beans.dragAndDrop;
        if (dragAndDrop.findExternalZone(params)) {
            $437b23f6a393c3bf$export$545083624300f13d(56);
            return;
        }
        let processedParams = {
            getContainer: params.getContainer
        };
        if (params.fromGrid) processedParams = params;
        else {
            if (params.onDragEnter) processedParams.onDragEnter = (e)=>{
                params.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", e));
            };
            if (params.onDragLeave) processedParams.onDragLeave = (e)=>{
                params.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", e));
            };
            if (params.onDragging) processedParams.onDragging = (e)=>{
                params.onDragging(this.draggingToRowDragEvent("rowDragMove", e));
            };
            if (params.onDragStop) processedParams.onDragStop = (e)=>{
                params.onDragStop(this.draggingToRowDragEvent("rowDragEnd", e));
            };
            if (params.onDragCancel) processedParams.onDragCancel = (e)=>{
                params.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", e));
            };
        }
        const dropTarget = {
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>"move",
            external: true,
            ...processedParams
        };
        dragAndDrop.addDropTarget(dropTarget);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(dropTarget));
    }
    getRowDropZone(events) {
        const getContainer = this.getContainer.bind(this);
        const onDragEnter = this.onDragEnter.bind(this);
        const onDragLeave = this.onDragLeave.bind(this);
        const onDragging = this.onDragging.bind(this);
        const onDragStop = this.onDragStop.bind(this);
        const onDragCancel = this.onDragCancel.bind(this);
        let params;
        if (!events) params = {
            getContainer: getContainer,
            onDragEnter: onDragEnter,
            onDragLeave: onDragLeave,
            onDragging: onDragging,
            onDragStop: onDragStop,
            onDragCancel: onDragCancel,
            /* @private */ fromGrid: true
        };
        else params = {
            getContainer: getContainer,
            onDragEnter: events.onDragEnter ? (e)=>{
                onDragEnter(e);
                events.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", e));
            } : onDragEnter,
            onDragLeave: events.onDragLeave ? (e)=>{
                onDragLeave(e);
                events.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", e));
            } : onDragLeave,
            onDragging: events.onDragging ? (e)=>{
                onDragging(e);
                events.onDragging(this.draggingToRowDragEvent("rowDragMove", e));
            } : onDragging,
            onDragStop: events.onDragStop ? (e)=>{
                onDragStop(e);
                events.onDragStop(this.draggingToRowDragEvent("rowDragEnd", e));
            } : onDragStop,
            onDragCancel: events.onDragCancel ? (e)=>{
                onDragCancel(e);
                events.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", e));
            } : onDragCancel,
            fromGrid: true
        };
        return params;
    }
    draggingToRowDragEvent(type, draggingEvent) {
        const beans = this.beans;
        const { pageBounds: pageBounds, rowModel: rowModel, gos: gos } = beans;
        const y = $437b23f6a393c3bf$export$530c24bdfacb8cd1(this.beans, draggingEvent).y;
        const mouseIsPastLastRow = y > pageBounds.getCurrentPagePixelRange().pageLastPixel;
        let overIndex = -1;
        let overNode;
        if (!mouseIsPastLastRow) {
            overIndex = rowModel.getRowIndexAtPixel(y);
            overNode = rowModel.getRow(overIndex);
        }
        const event = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            type: type,
            event: draggingEvent.event,
            node: draggingEvent.dragItem.rowNode,
            nodes: draggingEvent.dragItem.rowNodes,
            overIndex: overIndex,
            overNode: overNode,
            y: y,
            vDirection: draggingEvent.vDirection
        });
        return event;
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.draggingToRowDragEvent(type, draggingEvent);
        this.eventSvc.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent("rowDragLeave", draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged")) this.clientSideRowModel.clearHighlight();
    }
    onDragStop(draggingEvent) {
        this.dispatchGridEvent("rowDragEnd", draggingEvent);
        this.stopDragging(draggingEvent);
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        if (gos.get("rowDragManaged") && (gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) {
            const rowsDrop = this.getRowsDrop(draggingEvent);
            if (rowsDrop) this.dropRows(rowsDrop);
            this.clientSideRowModel.clearHighlight();
        }
    }
    onDragCancel(draggingEvent) {
        this.dispatchGridEvent("rowDragCancel", draggingEvent);
        this.stopDragging(draggingEvent);
        const { dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        if (gos.get("rowDragManaged") && (gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) this.clientSideRowModel.clearHighlight();
    }
    stopDragging(draggingEvent) {
        this.autoScrollService.ensureCleared();
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            this.setRowNodeDragging(rowNode, false);
        });
    }
    setRowNodeDragging(rowNode, dragging) {
        if (rowNode.dragging !== dragging) {
            rowNode.dragging = dragging;
            rowNode.dispatchRowEvent("draggingChanged");
        }
    }
    /** Drag and drop. Returns false if at least a row was moved, otherwise true */ dropRows(rowsDrop) {
        return rowsDrop.sameGrid ? this.moveRows(rowsDrop) : this.addRows(rowsDrop);
    }
    addRows({ delta: delta, target: target, rows: rows }) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const clientSideRowModel = this.clientSideRowModel;
        const add = rows.filter(({ data: data, rowPinned: rowPinned })=>!clientSideRowModel.getRowNode(getRowIdFunc?.({
                data: data,
                level: 0,
                rowPinned: rowPinned
            }) ?? data.id)).map(({ data: data })=>data);
        if (add.length === 0) return false;
        const addIndex = target && target.sourceRowIndex + (delta < 0 ? 0 : 1);
        clientSideRowModel.updateRowData({
            add: add,
            addIndex: addIndex
        });
        return true;
    }
    moveRows({ delta: delta, target: target, rows: rows }) {
        const rowsToMoveSet = this.getValidRowsToMove(rows);
        const focusSvc = this.beans.focusSvc;
        const cellPosition = focusSvc.getFocusedCell();
        const cellCtrl = cellPosition && $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (!this.reorderLeafChildren(rowsToMoveSet, ...this.getMoveRowsBounds(rowsToMoveSet, target, delta))) return false;
        this.clientSideRowModel.refreshModel({
            step: "group",
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedPath: new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.clientSideRowModel.rootNode),
            rowNodesOrderChanged: true
        });
        if (cellCtrl) cellCtrl.focusCell();
        else focusSvc.clearFocusedCell();
        return true;
    }
    /** Creates a set of valid rows to move, filtering out rows that are not leafs or are not in the current model (deleted) */ getValidRowsToMove(rows) {
        const clientSideRowModel = this.clientSideRowModel;
        const rowsSet = /* @__PURE__ */ new Set();
        for (const row of rows)if (row.sourceRowIndex >= 0 && (row.rowTop !== null || row === clientSideRowModel.getRowNode(row.id))) rowsSet.add(row);
        return rowsSet;
    }
    /** For reorderLeafChildren, returns min index of the rows to move, the target index and the max index of the rows to move. */ getMoveRowsBounds(rows, target, delta) {
        const totalRows = this.clientSideRowModel.rootNode?.allLeafChildren.length ?? 0;
        let targetPositionIdx = target?.sourceRowIndex ?? -1;
        if (targetPositionIdx < 0 || targetPositionIdx >= totalRows) targetPositionIdx = totalRows;
        else if (delta >= 0) ++targetPositionIdx;
        let firstAffectedLeafIdx = targetPositionIdx;
        let lastAffectedLeafIndex = Math.min(targetPositionIdx, totalRows - 1);
        for (const { sourceRowIndex: sourceRowIndex } of rows){
            if (sourceRowIndex < firstAffectedLeafIdx) firstAffectedLeafIdx = sourceRowIndex;
            if (sourceRowIndex > lastAffectedLeafIndex) lastAffectedLeafIndex = sourceRowIndex;
        }
        return [
            firstAffectedLeafIdx,
            targetPositionIdx,
            lastAffectedLeafIndex
        ];
    }
    /** Reorders the children of the root node, so that the rows to move are in the correct order.
   * @param rowsToMoveSet The valid set of rows to move, as returned by getValidRowsToMove
   * @param firstAffectedLeafIdx The first index of the rows to move
   * @param targetPositionIdx The target index, where the rows will be moved
   * @param lastAffectedLeafIndex The last index of the rows to move
   * @returns True if the order of the rows changed, false otherwise
   */ reorderLeafChildren(rowsToMoveSet, firstAffectedLeafIdx, targetPositionIdx, lastAffectedLeafIndex) {
        let orderChanged = false;
        const allLeafChildren = this.clientSideRowModel.rootNode?.allLeafChildren;
        if (!rowsToMoveSet.size || !allLeafChildren) return false;
        let writeIdxLeft = firstAffectedLeafIdx;
        for(let readIdx = firstAffectedLeafIdx; readIdx < targetPositionIdx; ++readIdx){
            const row = allLeafChildren[readIdx];
            if (!rowsToMoveSet.has(row)) {
                if (row.sourceRowIndex !== writeIdxLeft) {
                    row.sourceRowIndex = writeIdxLeft;
                    allLeafChildren[writeIdxLeft] = row;
                    orderChanged = true;
                }
                ++writeIdxLeft;
            }
        }
        let writeIdxRight = lastAffectedLeafIndex;
        for(let readIdx = lastAffectedLeafIndex; readIdx >= targetPositionIdx; --readIdx){
            const row = allLeafChildren[readIdx];
            if (!rowsToMoveSet.has(row)) {
                if (row.sourceRowIndex !== writeIdxRight) {
                    row.sourceRowIndex = writeIdxRight;
                    allLeafChildren[writeIdxRight] = row;
                    orderChanged = true;
                }
                --writeIdxRight;
            }
        }
        for (const row of rowsToMoveSet){
            if (row.sourceRowIndex !== writeIdxLeft) {
                row.sourceRowIndex = writeIdxLeft;
                allLeafChildren[writeIdxLeft] = row;
                orderChanged = true;
            }
            ++writeIdxLeft;
        }
        return orderChanged;
    }
};
// packages/ag-grid-community/src/utils/mouse.ts
function $437b23f6a393c3bf$var$_areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
// packages/ag-grid-community/src/dragAndDrop/dragService.ts
var $437b23f6a393c3bf$var$DragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dragSvc";
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    destroy() {
        const { dragSources: dragSources } = this;
        dragSources.forEach(this.removeListener.bind(this));
        dragSources.length = 0;
        super.destroy();
    }
    removeListener(dragSourceAndListener) {
        const element = dragSourceAndListener.dragSource.eElement;
        const mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener("mousedown", mouseDownListener);
        if (dragSourceAndListener.touchEnabled) {
            const touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener("touchstart", touchStartListener, {
                passive: true
            });
        }
    }
    removeDragSource(params) {
        const { dragSources: dragSources } = this;
        const dragSourceAndListener = dragSources.find((item)=>item.dragSource === params);
        if (!dragSourceAndListener) return;
        this.removeListener(dragSourceAndListener);
        $437b23f6a393c3bf$export$83a881c8b5120679(dragSources, dragSourceAndListener);
    }
    addDragSource(params) {
        const mouseListener = this.onMouseDown.bind(this, params);
        const { eElement: eElement, includeTouch: includeTouch, stopPropagationForTouch: stopPropagationForTouch } = params;
        eElement.addEventListener("mousedown", mouseListener);
        let touchListener = null;
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            touchListener = (touchEvent)=>{
                if ($437b23f6a393c3bf$var$_isFocusableFormField(touchEvent.target)) return;
                if (stopPropagationForTouch) touchEvent.stopPropagation();
                this.onTouchStart(params, touchEvent);
            };
            eElement.addEventListener("touchstart", touchListener, {
                passive: false
            });
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: !!includeTouch
        });
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        this.currentDragParams = params;
        this.dragging = false;
        const touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        const touchMoveEvent = (e)=>this.onTouchMove(e, params.eElement);
        const touchEndEvent = (e)=>this.onTouchUp(e, params.eElement);
        const documentTouchMove = (e)=>{
            if (e.cancelable) e.preventDefault();
        };
        const target = touchEvent.target;
        const events = [
            // Prevents the page document from moving while we are dragging items around.
            // preventDefault needs to be called in the touchmove listener and never inside the
            // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
            {
                target: $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans),
                type: "touchmove",
                listener: documentTouchMove,
                options: {
                    passive: false
                }
            },
            {
                target: target,
                type: "touchmove",
                listener: touchMoveEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchend",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchcancel",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onCommonMove(touch, this.touchStart, params.eElement);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        const e = mouseEvent;
        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) return;
        if (e._alreadyProcessedByDragService) return;
        e._alreadyProcessedByDragService = true;
        if (mouseEvent.button !== 0) return;
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseStartEvent = mouseEvent;
        this.startTarget = mouseEvent.target;
        const mouseMoveEvent = (event)=>this.onMouseMove(event, params.eElement);
        const mouseUpEvent = (event)=>this.onMouseUp(event, params.eElement);
        const contextEvent = (event)=>event.preventDefault();
        const keydownEvent = (event)=>{
            if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE) this.cancelDrag(params.eElement);
        };
        const target = $437b23f6a393c3bf$export$1911dd00c79744c0(this.beans);
        const events = [
            {
                target: target,
                type: "mousemove",
                listener: mouseMoveEvent
            },
            {
                target: target,
                type: "mouseup",
                listener: mouseUpEvent
            },
            {
                target: target,
                type: "contextmenu",
                listener: contextEvent
            },
            {
                target: target,
                type: "keydown",
                listener: keydownEvent
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onMouseMove(mouseEvent, params.eElement);
    }
    addTemporaryEvents(events) {
        events.forEach((currentEvent)=>{
            const { target: target, type: type, listener: listener, options: options } = currentEvent;
            target.addEventListener(type, listener, options);
        });
        this.dragEndFunctions.push(()=>{
            events.forEach((currentEvent)=>{
                const { target: target, type: type, listener: listener, options: options } = currentEvent;
                target.removeEventListener(type, listener, options);
            });
        });
    }
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    isEventNearStartEvent(currentEvent, startEvent) {
        const { dragStartPixels: dragStartPixels } = this.currentDragParams;
        const requiredPixelDiff = $437b23f6a393c3bf$export$25d27f17d3af40f7(dragStartPixels) ? dragStartPixels : 4;
        return $437b23f6a393c3bf$var$_areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    }
    getFirstActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === this.touchStart.identifier) return touchList[i];
        }
        return null;
    }
    onCommonMove(currentEvent, startEvent, el) {
        if (!this.dragging) {
            if (this.isEventNearStartEvent(currentEvent, startEvent)) return;
            this.dragging = true;
            this.eventSvc.dispatchEvent({
                type: "dragStarted",
                target: el
            });
            this.currentDragParams.onDragStart(startEvent);
            if (!this.currentDragParams) {
                this.dragging = false;
                return;
            }
            this.currentDragParams.onDragging(startEvent);
        }
        this.currentDragParams?.onDragging(currentEvent);
    }
    onTouchMove(touchEvent, el) {
        const touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) return;
        this.onCommonMove(touch, this.touchStart, el);
    }
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    onMouseMove(mouseEvent, el) {
        if ($437b23f6a393c3bf$var$_isBrowserSafari()) {
            const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
            eDocument.getSelection()?.removeAllRanges();
        }
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
    }
    shouldPreventMouseEvent(mouseEvent) {
        const { gos: gos } = this;
        const isEnableCellTextSelect = gos.get("enableCellTextSelection");
        const isMouseMove = mouseEvent.type === "mousemove";
        const isOverFormFieldElement = (mouseEvent2)=>{
            const el = mouseEvent2.target;
            const tagName = el?.tagName.toLocaleLowerCase();
            return !!tagName?.match("^a$|textarea|input|select|button");
        };
        return(// when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        isEnableCellTextSelect && isMouseMove && mouseEvent.cancelable && $437b23f6a393c3bf$var$_isEventFromThisGrid(gos, mouseEvent) && !isOverFormFieldElement(mouseEvent));
    }
    onTouchUp(touchEvent, el) {
        let touch = this.getFirstActiveTouch(touchEvent.changedTouches);
        if (!touch) touch = this.touchLastTime;
        this.onUpCommon(touch, el);
    }
    onMouseUp(mouseEvent, el) {
        this.onUpCommon(mouseEvent, el);
    }
    onUpCommon(eventOrTouch, el) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            this.eventSvc.dispatchEvent({
                type: "dragStopped",
                target: el
            });
        }
        this.resetDragProperties();
    }
    cancelDrag(el) {
        this.eventSvc.dispatchEvent({
            type: "dragCancelled",
            target: el
        });
        this.currentDragParams?.onDragCancel?.();
        this.resetDragProperties();
    }
    resetDragProperties() {
        this.mouseStartEvent = null;
        this.startTarget = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        const { dragEndFunctions: dragEndFunctions } = this;
        dragEndFunctions.forEach((func)=>func());
        dragEndFunctions.length = 0;
    }
};
// packages/ag-grid-community/src/entities/agColumnGroup.ts
function $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId) {
    return groupId + "_" + instanceId;
}
function $437b23f6a393c3bf$export$1f44a60fc23f9028(col) {
    return col instanceof $437b23f6a393c3bf$export$273c80940a54c770;
}
var $437b23f6a393c3bf$export$273c80940a54c770 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(providedColumnGroup, groupId, partId, pinned){
        super();
        this.providedColumnGroup = providedColumnGroup;
        this.groupId = groupId;
        this.partId = partId;
        this.pinned = pinned;
        this.isColumn = false;
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.parent = null;
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    getUniqueId() {
        return $437b23f6a393c3bf$var$createUniqueColumnGroupId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        this.displayedChildren.forEach((child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.checkLeft();
        });
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = $437b23f6a393c3bf$export$236389741107357f(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.dispatchLocalEvent({
                type: "leftChanged"
            });
        }
    }
    getPinned() {
        return this.pinned;
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        this.displayedChildren?.forEach((child)=>{
            groupActualWidth += child.getActualWidth();
        });
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        this.displayedChildren.forEach((child)=>{
            if (child.isResizable()) result = true;
        });
        return result;
    }
    getMinWidth() {
        let result = 0;
        this.displayedChildren.forEach((groupChild)=>{
            result += groupChild.getMinWidth();
        });
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    isAutoHeaderHeight() {
        return !!this.getColGroupDef()?.autoHeaderHeight;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    addDisplayedLeafColumns(leafColumns) {
        this.displayedChildren.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addDisplayedLeafColumns(leafColumns);
        });
    }
    addLeafColumns(leafColumns) {
        this.children.forEach((child)=>{
            if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) leafColumns.push(child);
            else if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.addLeafColumns(leafColumns);
        });
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent || !parent.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion != null && parentWithExpansion.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.getProvidedColumnGroup().isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.dispatchLocalEvent({
                type: "displayedChildrenChanged"
            });
            return;
        }
        this.children.forEach((child)=>{
            const emptyGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(child) && (!child.displayedChildren || !child.displayedChildren.length);
            if (emptyGroup) return;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.getProvidedColumnGroup().isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        });
        this.dispatchLocalEvent({
            type: "displayedChildrenChanged"
        });
    }
};
// packages/ag-grid-community/src/entities/rowNode.ts
var $437b23f6a393c3bf$export$cb038fdaa8338d9f = "row-group-";
var $437b23f6a393c3bf$export$27b0e4a919abc336 = "t-";
var $437b23f6a393c3bf$export$5f755686e611c1ea = "b-";
var $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE = 0;
var $437b23f6a393c3bf$export$6af91cd58ec2edf9 = class {
    constructor(beans){
        /** `true` if this row is a master row, part of master / detail (ie row can be expanded to show detail) */ this.master = false;
        /** `true` if this row is a detail row, part of master / detail (ie child row of an expanded master row)*/ this.detail = void 0;
        /** The current row index. If the row is filtered out or in a collapsed group, this value will be `null`. */ this.rowIndex = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /**
     * The index of the row in the source rowData array including any updates via transactions.
     * It does not change when sorting, filtering, grouping, pivoting or any other UI related operations.
     * If this is a filler node (a visual row created by AG Grid in tree data or grouping) the value will be `-1`.
     *
     * Generally readonly. It is modified only by:
     * - ClientSideNodeManager, cast to ClientSideNodeManagerRowNode
     * - ClientSideRowModel, cast to ClientSideRowModelRowNode
     */ this.sourceRowIndex = -1;
        /**
     * Children mapped by the pivot columns.
     *
     * TODO: this field is currently used only by the GroupStrategy and Pivot.
     * TreeStrategy does not use it, and pivot cannot be enabled with tree data.
     * Creating a new object for every row when not pivoting and not grouping
     * consumes memory unnecessarily. Setting it to null however currently breaks
     * transactional updates in groups so this requires a deeper investigation on GroupStrategy.
     */ this.childrenMapped = {};
        /** The TreeNode associated to this row. Used only with tree data. */ this.treeNode = null;
        /** The flags associated to this node. Used only with tree data. */ this.treeNodeFlags = 0;
        /**
     * This will be `true` if it has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /**
     * Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers.
     * If re-naming this property, you must also update `IGNORED_SIBLING_PROPERTIES`
     */ this.__objectId = $437b23f6a393c3bf$var$OBJECT_ID_SEQUENCE++;
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.highlighted = null;
        this.hovered = false;
        this.__selected = false;
        this.beans = beans;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const { valueCache: valueCache, selectionSvc: selectionSvc, eventSvc: eventSvc } = this.beans;
        const oldData = this.data;
        this.data = data;
        valueCache?.onDataChanged();
        this.updateDataOnDetailNode();
        selectionSvc?.updateRowSelectable(this);
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.__localEventService?.dispatchEvent(event);
        if (this.sibling) {
            this.sibling.data = data;
            const event2 = this.sibling.createDataChangedEvent(data, oldData, update);
            this.sibling.__localEventService?.dispatchEvent(event2);
        }
        eventSvc.dispatchEvent({
            type: "rowNodeDataChanged",
            node: this
        });
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            pinnedSibling.data = data;
            pinnedSibling.__localEventService?.dispatchEvent(pinnedSibling.createDataChangedEvent(data, oldData, update));
            eventSvc.dispatchEvent({
                type: "rowNodeDataChanged",
                node: pinnedSibling
            });
        }
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        if (this.detailNode) this.detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: "dataChanged",
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    }
    getRowIndexString() {
        if (this.rowIndex == null) {
            $437b23f6a393c3bf$export$a20c7248650823a9(13);
            return null;
        }
        if (this.rowPinned === "top") return $437b23f6a393c3bf$export$27b0e4a919abc336 + this.rowIndex;
        if (this.rowPinned === "bottom") return $437b23f6a393c3bf$export$5f755686e611c1ea + this.rowIndex;
        return this.rowIndex.toString();
    }
    setDataAndId(data, id) {
        const { selectionSvc: selectionSvc } = this.beans;
        const oldNode = selectionSvc?.createDaemonNode?.(this);
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        if (selectionSvc) {
            selectionSvc.updateRowSelectable(this);
            selectionSvc.syncInRowNode(this, oldNode);
        }
        const event = this.createDataChangedEvent(data, oldData, false);
        this.__localEventService?.dispatchEvent(event);
    }
    setId(id) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.beans.gos);
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.parent?.getRoute() ?? [];
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level,
                    rowPinned: this.rowPinned
                });
                if (this.id.startsWith($437b23f6a393c3bf$export$cb038fdaa8338d9f)) $437b23f6a393c3bf$export$a20c7248650823a9(14, {
                    groupPrefix: $437b23f6a393c3bf$export$cb038fdaa8338d9f
                });
            } else this.id = void 0;
        } else this.id = id;
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        this.dispatchRowEvent("topChanged");
        this.setDisplayed(rowTop !== null);
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setHovered(hovered) {
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        this.dispatchRowEvent("heightChanged");
    }
    setExpanded(expanded, e, forceSync) {
        this.beans.expansionSvc?.setExpanded(this, expanded, e, forceSync);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid will refresh the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const { colModel: colModel, valueSvc: valueSvc, gos: gos, selectionSvc: selectionSvc } = this.beans;
        const column = typeof colKey !== "string" ? colKey : colModel.getCol(colKey) ?? colModel.getColDefCol(colKey);
        if (!column) return false;
        const oldValue = valueSvc.getValueForDisplay(column, this).value;
        if (gos.get("readOnlyEdit")) {
            const { beans: { eventSvc: eventSvc }, data: data, rowIndex: rowIndex, rowPinned: rowPinned } = this;
            eventSvc.dispatchEvent({
                type: "cellEditRequest",
                event: null,
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column,
                colDef: column.colDef,
                data: data,
                node: this,
                oldValue: oldValue,
                newValue: newValue,
                value: newValue,
                source: eventSource
            });
            return false;
        }
        const valueChanged = valueSvc.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        const selectable = selectionSvc?.updateRowSelectable(this);
        const pinnedSibling = this.pinnedSibling;
        if (pinnedSibling) {
            if (valueChanged) pinnedSibling.dispatchCellChangedEvent(column, newValue, oldValue);
            pinnedSibling.selectable = selectable ?? true;
        }
        return valueChanged;
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
        const { rowChildrenSvc: rowChildrenSvc } = this.beans;
        if (rowChildrenSvc) newValue = rowChildrenSvc.getHasChildrenValue(this);
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            this.dispatchRowEvent("hasChildrenChanged");
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: "cellChanged",
            node: this,
            column: column,
            newValue: newValue,
            oldValue: oldValue
        };
        this.__localEventService?.dispatchEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */ isExpandable() {
        return this.beans.expansionSvc?.isExpandable(this) ?? false;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        if (this.rowPinned && this.pinnedSibling) return this.pinnedSibling.isSelected();
        return this.__selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        this.childrenAfterGroup?.forEach((child)=>child.depthFirstSearch(callback));
        callback(this);
    }
    dispatchRowEvent(type) {
        this.__localEventService?.dispatchEvent({
            type: type,
            node: this
        });
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that will appear in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        this.beans.selectionSvc?.setNodesSelected({
            nodes: [
                this
            ],
            newValue: newValue,
            clearSelection: clearSelection,
            source: source
        });
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return !!this.rowPinned;
    }
    __addEventListener(eventType, listener) {
        if (!this.__localEventService) this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.__localEventService.addEventListener(eventType, listener);
    }
    __removeEventListener(eventType, listener) {
        this.removeLocalListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ addEventListener(eventType, userListener) {
        this.beans.validation?.checkRowEvents(eventType);
        if (!this.__localEventService) this.__localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.frameworkEventListenerService = this.beans.frameworkOverrides.createLocalEventListenerWrapper?.(this.frameworkEventListenerService, this.__localEventService);
        const listener = this.frameworkEventListenerService?.wrap(eventType, userListener) ?? userListener;
        this.__localEventService.addEventListener(eventType, listener);
    }
    /**
   * PUBLIC USE ONLY: for internal use within AG Grid use the `__addEventListener` and `__removeEventListener` methods.
   */ removeEventListener(eventType, userListener) {
        const listener = this.frameworkEventListenerService?.unwrap(eventType, userListener) ?? userListener;
        this.removeLocalListener(eventType, listener);
    }
    removeLocalListener(eventType, listener) {
        this.__localEventService?.removeEventListener(eventType, listener);
        if (this.__localEventService?.noRegisteredListenersExist()) this.__localEventService = null;
    }
    /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        $437b23f6a393c3bf$export$545083624300f13d(61);
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */ getRoute() {
        if (this.level === -1) return [];
        if (this.key == null) return void 0;
        const res = [];
        let pointer = this;
        while(pointer && pointer.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    setFirstChild(firstChild) {
        if (this.firstChild !== firstChild) {
            this.firstChild = firstChild;
            this.dispatchRowEvent("firstChildChanged");
        }
    }
    setDisplayed(displayed) {
        if (this.displayed !== displayed) {
            this.displayed = displayed;
            this.dispatchRowEvent("displayedChanged");
        }
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex !== rowIndex) {
            this.rowIndex = rowIndex;
            this.dispatchRowEvent("rowIndexChanged");
        }
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount !== allChildrenCount) {
            this.allChildrenCount = allChildrenCount;
            this.dispatchRowEvent("allChildrenCountChanged");
        }
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel !== uiLevel) {
            this.uiLevel = uiLevel;
            this.dispatchRowEvent("uiLevelChanged");
        }
    }
    getFirstChild() {
        if (this.childStore) return this.childStore.getFirstNode();
        return this.childrenAfterSort?.[0] ?? null;
    }
};
// packages/ag-grid-community/src/entities/rowNodeUtils.ts
function $437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, gos, type) {
    return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        type: type,
        node: rowNode,
        data: rowNode.data,
        rowIndex: rowNode.rowIndex,
        rowPinned: rowNode.rowPinned
    });
}
var $437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES = /* @__PURE__ */ new Set([
    "__localEventService",
    "__objectId",
    "sticky",
    "__autoHeights",
    "__checkAutoHeightsDebounced",
    "childStore"
]);
function $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans) {
    const sibling = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
    Object.keys(rowNode).forEach((key)=>{
        if ($437b23f6a393c3bf$var$IGNORED_SIBLING_PROPERTIES.has(key)) return;
        sibling[key] = rowNode[key];
    });
    sibling.oldRowTop = null;
    return sibling;
}
// packages/ag-grid-community/src/filter/filterWrapperComp.ts
var $437b23f6a393c3bf$var$FilterWrapperElement = {
    tag: "div",
    cls: "ag-filter"
};
var $437b23f6a393c3bf$export$70acaf0e0e30e7d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, source){
        super($437b23f6a393c3bf$var$FilterWrapperElement);
        this.column = column;
        this.source = source;
        this.filterWrapper = null;
    }
    postConstruct() {
        this.createFilter(true);
        this.addManagedEventListeners({
            filterDestroyed: this.onFilterDestroyed.bind(this)
        });
    }
    hasFilter() {
        return !!this.filterWrapper;
    }
    getFilter() {
        return this.filterWrapper?.filterPromise ?? null;
    }
    afterInit() {
        return this.filterWrapper?.filterPromise?.then(()=>{}) ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    afterGuiAttached(params) {
        this.filterWrapper?.filterPromise?.then((filter)=>{
            filter?.afterGuiAttached?.(params);
        });
    }
    afterGuiDetached() {
        this.filterWrapper?.filterPromise?.then((filter)=>{
            filter?.afterGuiDetached?.();
        });
    }
    createFilter(init) {
        const { column: column, source: source } = this;
        this.filterWrapper = this.beans.filterManager?.getOrCreateFilterWrapper(column) ?? null;
        if (!this.filterWrapper?.filterPromise) return;
        this.filterWrapper.filterPromise.then((filter)=>{
            const guiFromFilter = filter.getGui();
            if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(guiFromFilter)) $437b23f6a393c3bf$export$545083624300f13d(69, {
                guiFromFilter: guiFromFilter
            });
            this.appendChild(guiFromFilter);
            if (init) this.eventSvc.dispatchEvent({
                type: "filterOpened",
                column: column,
                source: source,
                eGui: this.getGui()
            });
        });
    }
    onFilterDestroyed(event) {
        if ((event.source === "api" || event.source === "paramsUpdated") && event.column.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column)) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
            this.createFilter();
        }
    }
    destroy() {
        this.filterWrapper = null;
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/features/positionableFeature.ts
var $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var $437b23f6a393c3bf$var$makeDiv = (dataRefPrefix, classSuffix)=>({
        tag: "div",
        ref: `${dataRefPrefix}Resizer`,
        cls: `ag-resizer ag-resizer-${classSuffix}`
    });
var $437b23f6a393c3bf$var$RESIZE_TEMPLATE = {
    tag: "div",
    cls: $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE,
    children: [
        $437b23f6a393c3bf$var$makeDiv("eTopLeft", "topLeft"),
        $437b23f6a393c3bf$var$makeDiv("eTop", "top"),
        $437b23f6a393c3bf$var$makeDiv("eTopRight", "topRight"),
        $437b23f6a393c3bf$var$makeDiv("eRight", "right"),
        $437b23f6a393c3bf$var$makeDiv("eBottomRight", "bottomRight"),
        $437b23f6a393c3bf$var$makeDiv("eBottom", "bottom"),
        $437b23f6a393c3bf$var$makeDiv("eBottomLeft", "bottomLeft"),
        $437b23f6a393c3bf$var$makeDiv("eLeft", "left")
    ]
};
var $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = Object.assign({}, {
            popup: false
        }, config);
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.dragSvc = beans.dragSvc;
    }
    center() {
        const { clientHeight: clientHeight, clientWidth: clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y);
    }
    initialisePosition() {
        if (this.positioned) return;
        const { centered: centered, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent, minWidth: minWidth, width: width, minHeight: minHeight, height: height, x: x, y: y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = $437b23f6a393c3bf$export$2badf4aa566524cb(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center();
        else if (x || y) this.offsetElement(x, y);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = parseFloat(boundaryEl.style.top);
                const left = parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragSvc?.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragSvc?.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        Object.keys(resizable).forEach((side)=>{
            const resizableStructure = resizable;
            const isSideResizable = !!resizableStructure[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragSvc?.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        });
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height: height, width: width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup: popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.indexOf("%") !== -1) {
            $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            height = $437b23f6a393c3bf$export$d23c22492e0f7c0c(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (!isPercent) {
            if (popup) $437b23f6a393c3bf$var$_setFixedHeight(eGui, height);
            else {
                eGui.style.height = `${height}px`;
                eGui.style.flex = "0 0 auto";
                this.lastSize.height = typeof height === "number" ? height : parseFloat(height);
            }
        } else {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        }
    }
    getAvailableHeight() {
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight: clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom: bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup: popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.indexOf("%") !== -1) {
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            width = $437b23f6a393c3bf$export$642efcb17474eb51(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth: clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (!isPercent) {
            if (this.config.popup) $437b23f6a393c3bf$export$ce98ba7f5cfe7725(eGui, width);
            else {
                eGui.style.width = `${width}px`;
                eGui.style.flex = " unset";
                this.lastSize.width = typeof width === "number" ? width : parseFloat(width);
            }
        } else {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        }
    }
    offsetElement(x = 0, y = 0) {
        const { forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupSvc?.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x: x,
                    y: y
                })
        });
        this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain && this.popupSvc) this.resizeObserverSubscriber = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.popupSvc?.getPopupParent(), applyMaxHeightToElement);
        else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x: x,
            y: y
        };
    }
    calculateMouseMovement(params) {
        const { e: e, isLeft: isLeft, isTop: isTop, anywhereWithin: anywhereWithin, topBuffer: topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX: movementX,
            movementY: movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const getElement = (ref)=>({
                element: this.element.querySelector(`[data-ref=${ref}Resizer]`)
            });
        this.resizerMap = {
            topLeft: getElement("eTopLeft"),
            top: getElement("eTop"),
            topRight: getElement("eTopRight"),
            right: getElement("eRight"),
            bottomRight: getElement("eBottomRight"),
            bottom: getElement("eBottom"),
            bottomLeft: getElement("eBottomLeft"),
            left: getElement("eLeft")
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        eGui.appendChild($437b23f6a393c3bf$export$a232bb0480ae674a($437b23f6a393c3bf$var$RESIZE_TEMPLATE));
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}`);
        if (resizerEl) this.element.removeChild(resizerEl);
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for(let i = 0; i < siblings.length; i++){
            const currentEl = siblings[i];
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height: height,
            width: width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const { isTop: isTop, isRight: isRight, isBottom: isBottom, isLeft: isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isLeft: isLeft,
            isTop: isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchLocalEvent({
            type: "resize"
        });
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x: x, y: y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isTop: true,
            anywhereWithin: true,
            topBuffer: topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent && this.popupSvc) this.offsetParent = this.popupSvc.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragSvc?.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragSvc?.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
// packages/ag-grid-community/src/widgets/managedFocusFeature.ts
var $437b23f6a393c3bf$export$e24a3eb8593af8d8 = "ag-focus-managed";
var $437b23f6a393c3bf$export$5510e53ed3962582 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eFocusable, callbacks = {}){
        super();
        this.eFocusable = eFocusable;
        this.callbacks = callbacks;
        this.callbacks = {
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusable, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            },
            ...callbacks
        };
    }
    postConstruct() {
        const { eFocusable: eFocusable, callbacks: { onFocusIn: onFocusIn, onFocusOut: onFocusOut } } = this;
        eFocusable.classList.add($437b23f6a393c3bf$export$e24a3eb8593af8d8);
        this.addKeyDownListeners(eFocusable);
        if (onFocusIn) this.addManagedElementListeners(eFocusable, {
            focusin: onFocusIn
        });
        if (onFocusOut) this.addManagedElementListeners(eFocusable, {
            focusout: onFocusOut
        });
    }
    addKeyDownListeners(eGui) {
        this.addManagedElementListeners(eGui, {
            keydown: (e)=>{
                if (e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
                const { callbacks: callbacks } = this;
                if (callbacks.shouldStopEventPropagation(e)) {
                    $437b23f6a393c3bf$export$456c40e80134d72a(e);
                    return;
                }
                if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) callbacks.onTabKeyDown(e);
                else if (callbacks.handleKeyDown) callbacks.handleKeyDown(e);
            }
        });
    }
};
// packages/ag-grid-community/src/filter/filterLocaleText.ts
var $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd"
};
// packages/ag-grid-community/src/filter/floating/provided/providedFilterUtils.ts
function $437b23f6a393c3bf$var$getDebounceMs(params, debounceDefault) {
    const { debounceMs: debounceMs } = params;
    if ($437b23f6a393c3bf$var$isUseApplyButton(params)) {
        if (debounceMs != null) $437b23f6a393c3bf$export$545083624300f13d(71);
        return 0;
    }
    return debounceMs ?? debounceDefault;
}
function $437b23f6a393c3bf$var$isUseApplyButton(params) {
    return (params.buttons?.indexOf("apply") ?? -1) >= 0;
}
// packages/ag-grid-community/src/filter/provided/providedFilter.ts
var $437b23f6a393c3bf$export$a927a1327c2cc7f0 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(filterNameKey){
        super();
        this.filterNameKey = filterNameKey;
        this.applyActive = false;
        this.hidePopup = null;
        this.debouncePending = false;
        // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
        // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
        // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
        // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
        // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
        // not active) then this appliedModel will be null/undefined.
        this.appliedModel = null;
        this.eFilterBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.buttonListeners = [];
        // subclasses can override this to provide alternative debounce defaults
        this.defaultDebounceMs = 0;
    }
    postConstruct() {
        this.resetTemplate();
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        });
        this.createBean(this.positionableFeature);
    }
    // override
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handleKeyDown(e) {}
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    isFilterActive() {
        return !!this.appliedModel;
    }
    resetTemplate(paramsMap) {
        let eGui = this.getGui();
        eGui?.removeEventListener("submit", this.onFormSubmit);
        const element = {
            tag: "form",
            cls: "ag-filter-wrapper",
            children: [
                {
                    tag: "div",
                    ref: "eFilterBody",
                    cls: `ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper`,
                    children: [
                        this.createBodyTemplate()
                    ]
                }
            ]
        };
        this.setTemplate(element, this.getAgComponents(), paramsMap);
        eGui = this.getGui();
        eGui?.addEventListener("submit", this.onFormSubmit);
    }
    isReadOnly() {
        return !!this.params.readOnly;
    }
    init(params) {
        this.setParams(params);
        this.resetUiToDefaults(true).then(()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    setParams(params) {
        this.params = params;
        this.applyActive = $437b23f6a393c3bf$var$isUseApplyButton(params);
        this.resetButtonsPanel(params);
    }
    updateParams(params) {
        this.params = params;
        this.applyActive = $437b23f6a393c3bf$var$isUseApplyButton(params);
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    resetButtonsPanel(newParams, oldParams) {
        const { buttons: oldButtons, readOnly: oldReadOnly } = oldParams ?? {};
        const { buttons: buttons, readOnly: readOnly } = newParams;
        if (oldReadOnly === readOnly && $437b23f6a393c3bf$export$dbc2068cc90f5875(oldButtons, buttons)) return;
        const hasButtons = buttons && buttons.length > 0 && !this.isReadOnly();
        if (!this.eButtonsPanel) {
            if (hasButtons) this.eButtonsPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-filter-apply-panel"
            });
        } else {
            $437b23f6a393c3bf$export$69e6e10709eabd91(this.eButtonsPanel);
            this.buttonListeners.forEach((destroyFunc)=>destroyFunc());
            this.buttonListeners = [];
        }
        if (!hasButtons) {
            if (this.eButtonsPanel) $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eButtonsPanel);
            return;
        }
        const fragment = document.createDocumentFragment();
        const addButton = (type)=>{
            let clickListener;
            const text = type ? this.translate(`${type}Filter`) : void 0;
            switch(type){
                case "apply":
                    clickListener = (e)=>this.onBtApply(false, false, e);
                    break;
                case "clear":
                    clickListener = ()=>this.onBtClear();
                    break;
                case "reset":
                    clickListener = ()=>this.onBtReset();
                    break;
                case "cancel":
                    clickListener = (e)=>{
                        this.onBtCancel(e);
                    };
                    break;
                default:
                    $437b23f6a393c3bf$export$545083624300f13d(75);
                    return;
            }
            const buttonType = type === "apply" ? "submit" : "button";
            const button = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "button",
                attrs: {
                    type: buttonType
                },
                ref: `${type}FilterButton`,
                cls: "ag-button ag-standard-button ag-filter-apply-panel-button",
                children: text
            });
            this.buttonListeners.push(...this.addManagedElementListeners(button, {
                click: clickListener
            }));
            fragment.append(button);
        };
        buttons.forEach((type)=>addButton(type));
        this.eButtonsPanel.append(fragment);
        this.getGui().appendChild(this.eButtonsPanel);
    }
    setupOnBtApplyDebounce() {
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(this.params, this.defaultDebounceMs);
        const debounceFunc = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.checkApplyDebounce.bind(this), debounceMs);
        this.onBtApplyDebounce = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.onBtApply();
        }
    }
    getModel() {
        return this.appliedModel ?? null;
    }
    setModel(model) {
        const promise = model != null ? this.setModelIntoUi(model) : this.resetUiToDefaults();
        return promise.then(()=>{
            this.updateUiVisibility();
            this.applyModel("api");
        });
    }
    onBtCancel(e) {
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.handleCancelEnd(e);
        });
    }
    handleCancelEnd(e) {
        if (this.params.closeOnApply) this.close(e);
    }
    resetUiToActiveModel(currentModel, afterUiUpdatedFunc) {
        const afterAppliedFunc = ()=>{
            this.onUiChanged(false, "prevent");
            afterUiUpdatedFunc?.();
        };
        if (currentModel != null) this.setModelIntoUi(currentModel).then(afterAppliedFunc);
        else this.resetUiToDefaults().then(afterAppliedFunc);
    }
    onBtClear() {
        this.resetUiToDefaults().then(()=>this.onUiChanged());
    }
    onBtReset() {
        this.onBtClear();
        this.onBtApply();
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    applyModel(source = "api") {
        const newModel = this.getModelFromUi();
        if (!this.isModelValid(newModel)) return false;
        const previousModel = this.appliedModel;
        this.appliedModel = newModel;
        return !this.areModelsEqual(previousModel, newModel);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isModelValid(model) {
        return true;
    }
    onFormSubmit(e) {
        e.preventDefault();
    }
    onBtApply(afterFloatingFilter = false, afterDataChange = false, e) {
        if (e) e.preventDefault();
        if (this.applyModel(afterDataChange ? "rowDataUpdated" : "ui")) {
            const source = "columnFilter";
            this.params.filterChangedCallback({
                afterFloatingFilter: afterFloatingFilter,
                afterDataChange: afterDataChange,
                source: source
            });
        }
        const { closeOnApply: closeOnApply } = this.params;
        if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) this.close(e);
    }
    onNewRowsLoaded() {}
    close(e) {
        if (!this.hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent && keyboardEvent.key;
        let params;
        if (key === "Enter" || key === "Space") params = {
            keyboardEvent: keyboardEvent
        };
        this.hidePopup(params);
        this.hidePopup = null;
    }
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(fromFloatingFilter = false, apply) {
        this.updateUiVisibility();
        this.params.filterModifiedCallback();
        if (this.applyActive && !this.isReadOnly()) {
            const isValid = this.isModelValid(this.getModelFromUi());
            const applyFilterButton = this.queryForHtmlElement(`[data-ref="applyFilterButton"]`);
            if (applyFilterButton) $437b23f6a393c3bf$export$b6b4f08392e9bfaf(applyFilterButton, !isValid);
        }
        if (fromFloatingFilter && !apply || apply === "immediately") this.onBtApply(fromFloatingFilter);
        else if (!this.applyActive && !apply || apply === "debounce") this.onBtApplyDebounce();
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
        this.refreshFilterResizer(params?.container);
    }
    refreshFilterResizer(containerType) {
        const { positionableFeature: positionableFeature, gos: gos } = this;
        if (!positionableFeature || containerType === "toolPanel") return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            positionableFeature.removeSizeFromEl();
            positionableFeature.setResizable(false);
        }
        positionableFeature.constrainSizeToAvailableHeight(true);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        this.positionableFeature?.constrainSizeToAvailableHeight(false);
    }
    refresh(newParams) {
        const oldParams = this.params;
        this.params = newParams;
        this.resetButtonsPanel(newParams, oldParams);
        return true;
    }
    destroy() {
        const eGui = this.getGui();
        if (eGui) eGui.removeEventListener("submit", this.onFormSubmit);
        this.hidePopup = null;
        if (this.positionableFeature) this.positionableFeature = this.destroyBean(this.positionableFeature);
        this.appliedModel = null;
        super.destroy();
    }
    translate(key) {
        return this.getLocaleTextFunc()(key, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT[key]);
    }
    getCellValue(rowNode) {
        return this.params.getValue(rowNode);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.eFilterBody;
    }
};
// packages/ag-grid-community/src/filter/floating/floatingFilterMapper.ts
function $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, def, getFromDefault) {
    if (def == null) return null;
    let defaultFloatingFilterType = null;
    const { compName: compName, jsComp: jsComp, fwComp: fwComp } = $437b23f6a393c3bf$var$_getFilterCompKeys(frameworkOverrides, def);
    if (compName) {
        const floatingFilterTypeMap = {
            agSetColumnFilter: "agSetColumnFloatingFilter",
            agMultiColumnFilter: "agMultiColumnFloatingFilter",
            agGroupColumnFilter: "agGroupColumnFloatingFilter",
            agNumberColumnFilter: "agNumberColumnFloatingFilter",
            agDateColumnFilter: "agDateColumnFloatingFilter",
            agTextColumnFilter: "agTextColumnFloatingFilter"
        };
        defaultFloatingFilterType = floatingFilterTypeMap[compName];
    } else {
        const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
        if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
    }
    return defaultFloatingFilterType;
}
// packages/ag-grid-community/src/styling/layoutFeature.ts
var $437b23f6a393c3bf$var$LayoutCssClasses = {
    AUTO_HEIGHT: "ag-layout-auto-height",
    NORMAL: "ag-layout-normal",
    PRINT: "ag-layout-print"
};
var $437b23f6a393c3bf$var$LayoutFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.gos.get("domLayout");
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? $437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT : params.print ? $437b23f6a393c3bf$var$LayoutCssClasses.PRINT : $437b23f6a393c3bf$var$LayoutCssClasses.NORMAL;
        this.view.updateLayoutClasses(cssClass, params);
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyScrollFeature.ts
var $437b23f6a393c3bf$var$VIEWPORT = "Viewport";
var $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR = "fakeVScrollComp";
var $437b23f6a393c3bf$var$HORIZONTAL_SOURCES = [
    "fakeHScrollComp",
    "centerHeader",
    "topCenter",
    "bottomCenter",
    "stickyTopCenter",
    "stickyBottomCenter"
];
var $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT = 100;
var $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT = 150;
var $437b23f6a393c3bf$var$GridBodyScrollFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eBodyViewport){
        super();
        // listeners for when ensureIndexVisible is waiting for SSRM data to load
        this.clearRetryListenerFncs = [];
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.lastIsHorizontalScrollShowing = false;
        this.scrollTimer = 0;
        this.isVerticalPositionInvalidated = true;
        this.isHorizontalPositionInvalidated = true;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[1 /* Horizontal */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
        this.resetLastVScrollDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.lastScrollSource[0 /* Vertical */ ] = null, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.animationFrameSvc = beans.animationFrameSvc;
        this.visibleCols = beans.visibleCols;
    }
    destroy() {
        super.destroy();
        this.clearRetryListenerFncs = [];
        window.clearTimeout(this.scrollTimer);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        const invalidateVerticalScroll = this.invalidateVerticalScroll.bind(this);
        const invalidateHorizontalScroll = this.invalidateHorizontalScroll.bind(this);
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
            gridSizeChanged: invalidateVerticalScroll,
            // We only invalidate horizontal scrolling when the viewport switches
            // between scrollable and non-scrollable, avoiding unnecessary
            // invalidation on every gridSizeChanged event. If more properties
            // require invalidation, read/write DOM cycles may be needed.
            scrollGapChanged: invalidateHorizontalScroll
        });
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: invalidateVerticalScroll
        });
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    invalidateHorizontalScroll() {
        this.isHorizontalPositionInvalidated = true;
    }
    invalidateVerticalScroll() {
        this.isVerticalPositionInvalidated = true;
    }
    addScrollListener() {
        this.addHorizontalScrollListeners();
        this.addVerticalScrollListeners();
    }
    addHorizontalScrollListeners() {
        this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
            scroll: this.onHScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT)
        });
        for (const source of $437b23f6a393c3bf$var$HORIZONTAL_SOURCES){
            const scrollPartner = this.ctrlsSvc.get(source);
            this.registerScrollPartner(scrollPartner, this.onHScroll.bind(this, source));
        }
    }
    addVerticalScrollListeners() {
        const fakeVScrollComp = this.ctrlsSvc.get("fakeVScrollComp");
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$VIEWPORT);
        const onFakeVScroll = isDebounce ? $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR), $437b23f6a393c3bf$var$SCROLL_DEBOUNCE_TIMEOUT) : this.onVScroll.bind(this, $437b23f6a393c3bf$var$FAKE_V_SCROLLBAR);
        this.addManagedElementListeners(this.eBodyViewport, {
            scroll: onVScroll
        });
        this.registerScrollPartner(fakeVScrollComp, onFakeVScroll);
    }
    registerScrollPartner(comp, callback) {
        comp.onScrollCallback(callback);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        this.setScrollLeftForAllContainersExceptCurrent(Math.abs(scrollLeft));
    }
    setScrollLeftForAllContainersExceptCurrent(scrollLeft) {
        for (const container of [
            ...$437b23f6a393c3bf$var$HORIZONTAL_SOURCES,
            $437b23f6a393c3bf$var$VIEWPORT
        ]){
            if (this.lastScrollSource[1 /* Horizontal */ ] === container) continue;
            const viewport = this.getViewportForSource(container);
            $437b23f6a393c3bf$var$_setScrollLeft(viewport, scrollLeft, this.enableRtl);
        }
    }
    getViewportForSource(source) {
        if (source === $437b23f6a393c3bf$var$VIEWPORT) return this.centerRowsCtrl.eViewport;
        return this.ctrlsSvc.get(source).eViewport;
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            if (direction === 0 /* Vertical */ ) this.lastScrollSource[0] = source;
            else this.lastScrollSource[1] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onHScroll(source) {
        if (!this.isControllingScroll(source, 1 /* Horizontal */ )) return;
        const centerContainerViewport = this.centerRowsCtrl.eViewport;
        const { scrollLeft: scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        const newScrollLeft = $437b23f6a393c3bf$var$_getScrollLeft(this.getViewportForSource(source), this.enableRtl);
        this.doHorizontalScroll(newScrollLeft);
        this.resetLastHScrollDebounced();
    }
    onVScroll(source) {
        if (!this.isControllingScroll(source, 0 /* Vertical */ )) return;
        let scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        const { animationFrameSvc: animationFrameSvc } = this;
        animationFrameSvc?.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === $437b23f6a393c3bf$var$VIEWPORT) this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (animationFrameSvc?.active) animationFrameSvc.schedule();
        else this.scrollGridIfNeeded(true);
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: "bodyScroll",
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.eventSvc.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(()=>{
            this.scrollTimer = 0;
            this.eventSvc.dispatchEvent({
                ...bodyScrollEvent,
                type: "bodyScrollEnd"
            });
        }, $437b23f6a393c3bf$var$SCROLL_END_TIMEOUT);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !$437b23f6a393c3bf$export$6b6034a68325bd8a()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(this.eBodyViewport);
        const { scrollHeight: scrollHeight } = this.eBodyViewport;
        if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) return true;
        return false;
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth: scrollWidth } = this.centerRowsCtrl.eViewport;
        if (this.enableRtl) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        if (Math.abs(scrollTo) + clientWidth > scrollWidth) return true;
        return false;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        if (this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft()) this.onHScroll($437b23f6a393c3bf$var$VIEWPORT);
    }
    scrollGridIfNeeded(suppressedAnimationFrame = false) {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            if (suppressedAnimationFrame) this.invalidateVerticalScroll();
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        $437b23f6a393c3bf$var$_setScrollLeft(this.centerRowsCtrl.eViewport, Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.invalidateVerticalScroll();
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        if (!this.isVerticalPositionInvalidated) {
            const { lastOffsetHeight: lastOffsetHeight, lastScrollTop: lastScrollTop } = this;
            return {
                top: lastScrollTop,
                bottom: lastScrollTop + lastOffsetHeight
            };
        }
        this.isVerticalPositionInvalidated = false;
        const { scrollTop: scrollTop, offsetHeight: offsetHeight } = this.eBodyViewport;
        this.lastScrollTop = scrollTop;
        this.lastOffsetHeight = offsetHeight;
        return {
            top: scrollTop,
            bottom: scrollTop + offsetHeight
        };
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        if (this.isHorizontalPositionInvalidated) {
            this.lastIsHorizontalScrollShowing = this.centerRowsCtrl.isHorizontalScrollShowing();
            this.isHorizontalPositionInvalidated = false;
        }
        return this.lastIsHorizontalScrollShowing;
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.eViewport.scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.eViewport.scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position, retry = 0) {
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print")) return;
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            $437b23f6a393c3bf$export$545083624300f13d(88, {
                index: index
            });
            return;
        }
        this.clearRetryListeners();
        const { frameworkOverrides: frameworkOverrides, pageBounds: pageBounds, rowContainerHeight: heightScaler, rowRenderer: rowRenderer } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            const gridBodyCtrl = this.ctrlsSvc.getGridBodyCtrl();
            const rowNode = rowModel.getRow(index);
            let rowGotShiftedDuringOperation;
            let stickyHeightsChanged;
            let attempt = 0;
            this.invalidateVerticalScroll();
            do {
                const { stickyTopHeight: stickyTopHeight, stickyBottomHeight: stickyBottomHeight } = gridBodyCtrl;
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = pageBounds.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = heightScaler.divStretchOffset;
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop - stickyTopHeight;
                else if (position === "bottom") newScrollPosition = pxBottom + stickyBottomHeight;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) newScrollPosition = pxBottom + stickyBottomHeight;
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
                stickyHeightsChanged = stickyTopHeight !== gridBodyCtrl.stickyTopHeight || stickyBottomHeight !== gridBodyCtrl.stickyBottomHeight;
                attempt++;
            }while ((rowGotShiftedDuringOperation || stickyHeightsChanged) && attempt < 10);
            this.animationFrameSvc?.flushAllFrames();
            if (retry < 10 && (rowNode?.stub || !this.beans.rowAutoHeight?.areRowsMeasured())) {
                const scrollTop = this.getVScrollPosition().top;
                this.clearRetryListenerFncs = this.addManagedEventListeners({
                    bodyScroll: ()=>{
                        const newScrollTop = this.getVScrollPosition().top;
                        if (scrollTop === newScrollTop) return;
                        this.clearRetryListeners();
                    },
                    modelUpdated: ()=>{
                        this.clearRetryListeners();
                        if (index >= rowModel.getRowCount()) return;
                        this.ensureIndexVisible(index, position, retry + 1);
                    }
                });
            }
        });
    }
    clearRetryListeners() {
        this.clearRetryListenerFncs.forEach((callback)=>callback());
        this.clearRetryListenerFncs = [];
    }
    ensureColumnVisible(key, position = "auto") {
        const { colModel: colModel, frameworkOverrides: frameworkOverrides } = this.beans;
        const column = colModel.getCol(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.visibleCols.isColDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        frameworkOverrides.wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameSvc?.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart: columnBeforeStart, columnAfterEnd: columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft: colLeft, colMiddle: colMiddle, colRight: colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft: colLeft, colRight: colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart: columnBeforeStart,
            columnAfterEnd: columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.visibleCols.bodyWidth;
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
// packages/ag-grid-community/src/gridBodyComp/centerWidthFeature.ts
var $437b23f6a393c3bf$var$CenterWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedEventListeners({
            columnContainerWidthChanged: listener,
            displayedColumnsChanged: listener,
            leftPinnedWidthChanged: listener
        });
        if (this.addSpacer) this.addManagedEventListeners({
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
        this.setWidth();
    }
    setWidth() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const { visibleCols: visibleCols, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const centerWidth = visibleCols.bodyWidth;
        const leftWidth = visibleCols.getColsLeftWidth();
        const rightWidth = visibleCols.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && scrollVisibleSvc.verticalScrollShowing) totalWidth += scrollVisibleSvc.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
// packages/ag-grid-community/src/gridBodyComp/viewportSizeFeature.ts
var $437b23f6a393c3bf$var$ViewportSizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    wireBeans(beans) {
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedEventListeners({
            scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this)
        });
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const { beans: beans, centerContainerCtrl: centerContainerCtrl, gridBodyCtrl: gridBodyCtrl } = this;
        const listener = ()=>{
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                this.onCenterViewportResized();
            });
        };
        centerContainerCtrl.registerViewportResizeListener(listener);
        gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        this.scrollVisibleSvc.updateScrollGap();
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            const { pinnedCols: pinnedCols, colFlex: colFlex } = this.beans;
            pinnedCols?.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                colFlex?.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.scrollFeature.checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyHeight = $437b23f6a393c3bf$export$c20e968103d9c16e(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            this.eventSvc.dispatchEvent({
                type: "bodyHeightChanged"
            });
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        const params = {
            horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleSvc.setScrollsVisible(params);
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition);
    }
};
// packages/ag-grid-community/src/styling/stylingUtils.ts
function $437b23f6a393c3bf$var$processClassRules(expressionSvc, previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
    if (classRules == null && previousClassRules == null) return;
    const classesToApply = {};
    const classesToRemove = {};
    const forEachSingleClass = (className, callback)=>{
        className.split(" ").forEach((singleClass)=>{
            if (singleClass.trim() == "") return;
            callback(singleClass);
        });
    };
    if (classRules) {
        const classNames = Object.keys(classRules);
        for(let i = 0; i < classNames.length; i++){
            const className = classNames[i];
            const rule = classRules[className];
            let resultOfRule;
            if (typeof rule === "string") resultOfRule = expressionSvc ? expressionSvc.evaluate(rule, params) : true;
            else if (typeof rule === "function") resultOfRule = rule(params);
            forEachSingleClass(className, (singleClass)=>{
                resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
            });
        }
    }
    if (previousClassRules && onNotApplicableClass) Object.keys(previousClassRules).forEach((className)=>forEachSingleClass(className, (singleClass)=>{
            if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
        }));
    if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
    Object.keys(classesToApply).forEach(onApplicableClass);
}
// packages/ag-grid-community/src/styling/rowStyleService.ts
function $437b23f6a393c3bf$var$calculateRowLevel(rowNode) {
    if (rowNode.group) return rowNode.level;
    const parent = rowNode.parent;
    return parent ? parent.level + 1 : 0;
}
var $437b23f6a393c3bf$var$RowStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowStyleSvc";
    }
    processClassesFromGridOptions(classes, rowNode) {
        const gos = this.gos;
        const process = (rowCls)=>{
            if (typeof rowCls === "string") classes.push(rowCls);
            else if (Array.isArray(rowCls)) rowCls.forEach((e)=>classes.push(e));
        };
        const rowClass = gos.get("rowClass");
        if (rowClass) process(rowClass);
        const rowClassFunc = gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
    }
    preProcessRowClassRules(classes, rowNode) {
        this.processRowClassRules(rowNode, (className)=>{
            classes.push(className);
        }, ()=>{});
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const { gos: gos, expressionSvc: expressionSvc } = this.beans;
        const rowClassParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        $437b23f6a393c3bf$var$processClassRules(expressionSvc, void 0, gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    processStylesFromGridOptions(rowNode) {
        const gos = this.gos;
        const rowStyle = gos.get("rowStyle");
        const rowStyleFunc = gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return void 0;
    }
};
// packages/ag-grid-community/src/rendering/row/rowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence3 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var $437b23f6a393c3bf$var$RowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.rowNode = rowNode;
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        /** sanitised */ this.businessKey = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.paginationPage = beans.pagination?.getCurrentPage() ?? 0;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + $437b23f6a393c3bf$var$instanceIdSequence3++;
        this.rowId = $437b23f6a393c3bf$export$3df06b741968da82(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKey = $437b23f6a393c3bf$export$3df06b741968da82(businessKey);
    }
    updateGui(containerType, gui) {
        if (containerType === "left") this.leftGui = gui;
        else if (containerType === "right") this.rightGui = gui;
        else if (containerType === "fullWidth") this.fullWidthGui = gui;
        else this.centerGui = gui;
    }
    setComp(rowComp, element, containerType, compBean) {
        const { context: context, focusSvc: focusSvc } = this.beans;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        const gui = {
            rowComp: rowComp,
            element: element,
            containerType: containerType,
            compBean: compBean
        };
        this.allRowGuis.push(gui);
        this.updateGui(containerType, gui);
        this.initialiseRowComp(gui);
        const rowNode = this.rowNode;
        const isSsrmLoadingRow = this.rowType === "FullWidthLoading" || rowNode.stub;
        const isIrmLoadingRow = !rowNode.data && this.beans.rowModel.getType() === "infinite";
        if (!isSsrmLoadingRow && !isIrmLoadingRow && !rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
        const focusableElement = this.fullWidthGui?.element;
        if (focusableElement) {
            if (!this.editing && focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned) && focusSvc.shouldTakeFocus()) setTimeout(()=>focusableElement.focus({
                    preventScroll: true
                }), 0);
        }
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        this.updateGui(containerType, void 0);
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        this.allRowGuis.forEach((rg)=>rg.element.style.display = displayValue);
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus"));
        this.listenOnDomOrder(gui);
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if ($437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos) && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        initialRowClasses.forEach((name)=>comp.toggleCss(name, true));
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) $437b23f6a393c3bf$export$3ad3518dddf15485(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        $437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, this);
        gui.compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, gui.element, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.createTask(this.addHoverFunctionality.bind(this, gui), this.rowNode.rowIndex, "p2", false);
        else this.addHoverFunctionality(gui);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameSvc.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.toggleCss("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKey == null) return;
        comp.setRowBusinessKey(this.businessKey);
    }
    setRowCompRowId(comp) {
        const rowId = $437b23f6a393c3bf$export$3df06b741968da82(this.rowNode.id);
        this.rowId = rowId;
        if (rowId == null) return;
        comp.setRowId(rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType: containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            $437b23f6a393c3bf$export$8ea55376d0d59592(()=>{
                gui.rowComp.toggleCss("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        const rowDragComp = this.beans.rowDragSvc?.createRowDragCompForRow(this.rowNode, gui.element);
        if (!rowDragComp) return;
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
        gui.compBean.addDestroyFunc(()=>{
            this.rowDragComps = this.rowDragComps.filter((r)=>r !== rowDragBean);
            this.destroyBean(rowDragBean, this.beans.context);
        });
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    getFullWidthCellRenderers() {
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>gui?.rowComp?.getFullWidthCellRenderer());
        return [
            this.fullWidthGui?.rowComp?.getFullWidthCellRenderer()
        ];
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const { leftGui: leftGui, centerGui: centerGui, rightGui: rightGui, beans: { visibleCols: visibleCols } } = this;
        const isLeftReady = !!leftGui || !visibleCols.isPinningLeft();
        const isCenterReady = !!centerGui;
        const isRightReady = !!rightGui || !visibleCols.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    isNodeFullWidthCell() {
        if (this.rowNode.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this.rowNode
        }) : false;
    }
    setRowType() {
        const isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents");
        const isFullWidthCell = this.isNodeFullWidthCell();
        const isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
        const pivotMode = this.beans.colModel.isPivotMode();
        const isFullWidthGroup = $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, this.rowNode, pivotMode);
        if (isStub) this.rowType = "FullWidthLoading";
        else if (isDetailCell) this.rowType = "FullWidthDetail";
        else if (isFullWidthCell) this.rowType = "FullWidth";
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup";
        else this.rowType = "Normal";
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        const noAnimation = !animationFrameSvc?.active || suppressAnimationFrame || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        animationFrameSvc.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "p1", false);
        this.updateColumnListsPending = true;
    }
    /**
   * Overridden by SpannedRowCtrl
   */ getNewCellCtrl(col) {
        const isCellSpan = this.beans.rowSpanSvc?.isCellSpanning(col, this.rowNode);
        if (isCellSpan) return void 0;
        return new $437b23f6a393c3bf$var$CellCtrl(col, this.rowNode, this.beans, this);
    }
    /**
   * Overridden by SpannedRowCtrl, if span context changes cell needs rebuilt
   */ isCorrectCtrlForSpan(cell) {
        return !this.beans.rowSpanSvc?.isCellSpanning(cell.column, this.rowNode);
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl, index)=>{
            if (index != null) res.list.splice(index, 0, cellCtrl);
            else res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        const colsFromPrev = [];
        for (const col of cols){
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (cellCtrl && !this.isCorrectCtrlForSpan(cellCtrl)) {
                cellCtrl.destroy();
                cellCtrl = void 0;
            }
            if (!cellCtrl) cellCtrl = this.getNewCellCtrl(col);
            if (!cellCtrl) continue;
            addCell(colInstanceId, cellCtrl);
        }
        for (const prevCellCtrl of prev.list){
            const colInstanceId = prevCellCtrl.column.getInstanceId();
            const cellInResult = res.map[colInstanceId] != null;
            if (cellInResult) continue;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) colsFromPrev.push([
                colInstanceId,
                prevCellCtrl
            ]);
            else prevCellCtrl.destroy();
        }
        if (colsFromPrev.length) for (const [colInstanceId, cellCtrl] of colsFromPrev){
            const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
            const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
            addCell(colInstanceId, cellCtrl, normalisedIndex);
        }
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (focusedCell && focusedCell.column.getPinned() == pinned) {
            const focusedColInstanceId = focusedCell.column.getInstanceId();
            const focusedCellCtrl = res.map[focusedColInstanceId];
            if (!focusedCellCtrl && visibleCols.allCols.includes(focusedCell.column)) {
                const cellCtrl = this.createFocusedCellCtrl();
                if (cellCtrl) {
                    const index = res.list.findIndex((ctrl)=>ctrl.column.getLeft() > cellCtrl.column.getLeft());
                    const normalisedIndex = index === -1 ? void 0 : Math.max(index - 1, 0);
                    addCell(focusedColInstanceId, cellCtrl, normalisedIndex);
                }
            }
        }
        return res;
    }
    /**
   * Creates a new cell ctrl for the focused cell, if this is the correct row ctrl.
   * @returns a CellCtrl for the focused cell, if required.
   */ createFocusedCellCtrl() {
        const { focusSvc: focusSvc, rowSpanSvc: rowSpanSvc } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return void 0;
        const focusedSpan = rowSpanSvc?.getCellSpan(focusedCell.column, this.rowNode);
        if (focusedSpan) {
            if (focusedSpan.firstNode !== this.rowNode || !focusedSpan.doesSpanContain(focusedCell)) return void 0;
        } else {
            if (!focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned)) return void 0;
        }
        return this.getNewCellCtrl(focusedCell.column);
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        this.allRowGuis.forEach((item)=>{
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        });
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left":
                return this.leftCellCtrls.list;
            case "right":
                return this.rightCellCtrls.list;
            case "fullWidth":
                return [];
            case "center":
                return this.centerCellCtrls.list;
        }
    }
    createAllCellCtrls() {
        const colViewport = this.beans.colViewport;
        const presentedColsService = this.beans.visibleCols;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, presentedColsService.allCols);
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = colViewport.getColsWithinViewport(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = presentedColsService.getLeftColsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = presentedColsService.getRightColsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const { column: column } = cellCtrl;
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        if (!this.isCorrectCtrlForSpan(cellCtrl)) return REMOVE_CELL;
        const { editing: editing } = cellCtrl;
        const { visibleCols: visibleCols } = this.beans;
        const focused = cellCtrl.isCellFocused();
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const displayedColumns = visibleCols.allCols;
            const cellStillDisplayed = displayedColumns.indexOf(column) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        gui.compBean.addManagedPropertyListeners([
            "domLayout",
            "ensureDomOrder"
        ], listener);
    }
    setAnimateFlags(animateIn) {
        if (this.rowNode.sticky || !animateIn) return;
        const oldRowTopExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.rowNode.oldRowTop);
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        if (oldRowTopExists) {
            const { slideInAnimation: slideInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                slideInAnimation.fullWidth = true;
                return;
            }
            slideInAnimation.center = true;
            slideInAnimation.left = pinningLeft;
            slideInAnimation.right = pinningRight;
        } else {
            const { fadeInAnimation: fadeInAnimation } = this;
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                fadeInAnimation.fullWidth = true;
                return;
            }
            fadeInAnimation.center = true;
            fadeInAnimation.left = pinningLeft;
            fadeInAnimation.right = pinningRight;
        }
    }
    isFullWidth() {
        return this.rowType !== "Normal";
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        this.addManagedListeners(this.rowNode, {
            heightChanged: ()=>this.onRowHeightChanged(),
            rowSelected: ()=>this.onRowSelected(),
            rowIndexChanged: this.onRowIndexChanged.bind(this),
            topChanged: this.onTopChanged.bind(this),
            ...this.beans.expansionSvc?.getRowExpandedListeners(this) ?? {}
        });
        if (this.rowNode.detail) this.addManagedListeners(this.rowNode.parent, {
            dataChanged: this.onRowNodeDataChanged.bind(this)
        });
        this.addManagedListeners(this.rowNode, {
            dataChanged: this.onRowNodeDataChanged.bind(this),
            cellChanged: this.postProcessCss.bind(this),
            rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
            draggingChanged: this.postProcessRowDragging.bind(this),
            uiLevelChanged: this.onUiLevelChanged.bind(this),
            rowPinned: this.onRowPinned.bind(this)
        });
        this.addManagedListeners(this.beans.eventSvc, {
            paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
            heightScaleChanged: this.onTopChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
            cellFocused: this.onCellFocusChanged.bind(this),
            cellFocusCleared: this.onCellFocusChanged.bind(this),
            paginationChanged: this.onPaginationChanged.bind(this),
            modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
            columnMoved: ()=>this.updateColumnLists()
        });
        if (this.beans.rowSpanSvc) this.addManagedListeners(this.beans.rowSpanSvc, {
            spannedCellsUpdated: ({ pinned: pinned })=>{
                if (pinned && !this.rowNode.rowPinned) return;
                this.updateColumnLists();
            }
        });
        this.addDestroyFunc(()=>{
            this.rowDragComps = this.destroyBeans(this.rowDragComps, this.beans.context);
            this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context);
        });
        this.addManagedPropertyListeners([
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules"
        ], this.postProcessCss.bind(this));
        this.addManagedPropertyListener("rowDragEntireRow", ()=>{
            const useRowDragEntireRow = this.gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                this.allRowGuis.forEach((gui)=>{
                    this.addRowDraggerToRow(gui);
                });
                return;
            }
            this.rowDragComps = this.destroyBeans(this.rowDragComps, this.beans.context);
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListeners(this.rowNode, {
            rowIndexChanged: ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRowIndexChanged());
            },
            cellChanged: (event)=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellChanged(event));
            }
        });
    }
    /** Should only ever be triggered on source rows (i.e. not on pinned siblings) */ onRowPinned() {
        for (const gui of this.allRowGuis)gui.rowComp.toggleCss("ag-row-pinned-source", !!this.rowNode.pinnedSibling);
    }
    onRowNodeDataChanged(event) {
        const fullWidthChanged = this.isFullWidth() !== !!this.isNodeFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.refreshCell({
                suppressFlash: !event.update,
                newData: !event.update
            }));
        this.allRowGuis.forEach((gui)=>{
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        });
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const highlighted = this.rowNode.highlighted;
        this.allRowGuis.forEach((gui)=>{
            const aboveOn = highlighted === "Above";
            const belowOn = highlighted === "Below";
            gui.rowComp.toggleCss("ag-row-highlight-above", aboveOn);
            gui.rowComp.toggleCss("ag-row-highlight-below", belowOn);
        });
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-dragging", dragging));
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        this.beans.rowAutoHeight?.requestCheckAutoHeight();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const groupInfo = this.findFullWidthInfoForEvent(keyboardEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const currentFullWidthContainer = rowGui.element;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const lastFocusedCell = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell?.column ?? column
        };
        navigation?.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        let isDetailGridCellFocused = false;
        if (currentFullWidthContainer && activeEl) isDetailGridCellFocused = currentFullWidthContainer.contains(activeEl) && activeEl.classList.contains("ag-cell");
        let nextEl = null;
        if (!isFullWidthContainerFocused && !isDetailGridCellFocused) nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigation?.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        const displayedEl = this.allRowGuis.find((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.element))?.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        const tabIndex = this.isFullWidth() && suppressCellFocus ? void 0 : -1;
        this.allRowGuis.forEach((gui)=>{
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(gui.element, "tabindex", tabIndex);
        });
    }
    onFullWidthRowFocused(event) {
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        let element;
        if (this.fullWidthGui) element = this.fullWidthGui.element;
        else {
            const column = this.beans.colModel.getCol(event?.column);
            const pinned = column?.pinned;
            if (pinned) element = pinned === "right" ? this.rightGui?.element : this.leftGui?.element;
            else element = this.centerGui?.element;
        }
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused && event?.forceBrowserFocus) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        prev.list.forEach((cellCtrl)=>{
            if (cellCtrl === cellCtrlToRemove) return;
            res.list.push(cellCtrl);
            res.map[cellCtrl.column.getInstanceId()] = cellCtrl;
        });
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        const { rowNode: rowNode } = this;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            type: type,
            node: rowNode,
            data: rowNode.data,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if ($437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        this.beans.eventSvc.dispatchEvent(this.createRowEventWithSource("rowDoubleClicked", mouseEvent));
    }
    findFullWidthInfoForEvent(event) {
        if (!event) return;
        const rowGui = this.findFullWidthRowGui(event.target);
        const column = this.getColumnForFullWidth(rowGui);
        if (!rowGui || !column) return;
        return {
            rowGui: rowGui,
            column: column
        };
    }
    findFullWidthRowGui(target) {
        return this.allRowGuis.find((c)=>c.element.contains(target));
    }
    getColumnForFullWidth(fullWidthRowGui) {
        const { visibleCols: visibleCols } = this.beans;
        switch(fullWidthRowGui?.containerType){
            case "center":
                return visibleCols.centerCols[0];
            case "left":
                return visibleCols.leftCols[0];
            case "right":
                return visibleCols.rightCols[0];
            default:
                return visibleCols.allCols[0];
        }
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = $437b23f6a393c3bf$var$_isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth()) return;
        const node = this.rowNode;
        const { rangeSvc: rangeSvc, focusSvc: focusSvc } = this.beans;
        rangeSvc?.removeAllCellRanges();
        const groupInfo = this.findFullWidthInfoForEvent(mouseEvent);
        if (!groupInfo) return;
        const { rowGui: rowGui, column: column } = groupInfo;
        const element = rowGui.element;
        const target = mouseEvent.target;
        let forceBrowserFocus = mouseEvent.defaultPrevented || $437b23f6a393c3bf$var$_isBrowserSafari();
        if (element && element.contains(target) && $437b23f6a393c3bf$var$_isFocusableFormField(target)) forceBrowserFocus = false;
        focusSvc.setFocusedCell({
            rowIndex: node.rowIndex,
            column: column,
            rowPinned: node.rowPinned,
            forceBrowserFocus: forceBrowserFocus
        });
    }
    onRowClick(mouseEvent) {
        const stop = $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const { eventSvc: eventSvc, selectionSvc: selectionSvc } = this.beans;
        eventSvc.dispatchEvent(this.createRowEventWithSource("rowClicked", mouseEvent));
        selectionSvc?.handleSelectionEvent(mouseEvent, this.rowNode, "rowClicked");
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail") return;
        this.beans.masterDetailSvc?.setupDetailRowAutoHeight(this, eDetailGui);
    }
    createFullWidthCompDetails(eRow, pinned) {
        const { gos: gos, rowNode: rowNode } = this;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            fullWidth: true,
            data: rowNode.data,
            node: rowNode,
            value: rowNode.key,
            valueFormatted: rowNode.key,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            // This is not on the type of ICellRendererParams
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.refreshRowTooltip(value, shouldDisplayTooltip);
            }
        });
        const compFactory = this.beans.userCompFactory;
        switch(this.rowType){
            case "FullWidthDetail":
                return $437b23f6a393c3bf$var$_getFullWidthDetailCellRendererDetails(compFactory, params);
            case "FullWidthGroup":
                {
                    const { value: value, valueFormatted: valueFormatted } = this.beans.valueSvc.getValueForDisplay(void 0, this.rowNode, true);
                    params.value = value;
                    params.valueFormatted = valueFormatted;
                    return $437b23f6a393c3bf$var$_getFullWidthGroupCellRendererDetails(compFactory, params);
                }
            case "FullWidthLoading":
                return $437b23f6a393c3bf$var$_getFullWidthLoadingCellRendererDetails(compFactory, params);
            default:
                return $437b23f6a393c3bf$var$_getFullWidthCellRendererDetails(compFactory, params);
        }
    }
    refreshRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        this.tooltipFeature = this.beans.tooltipSvc?.refreshRowTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", suppressVisibilityChange) {
        const { rowDragSvc: rowDragSvc, context: context } = this.beans;
        if (!rowDragSvc || !this.isFullWidth()) return;
        const rowDragComp = rowDragSvc.createRowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
        this.createBean(rowDragComp, context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, context);
        });
    }
    onUiLevelChanged() {
        const newLevel = $437b23f6a393c3bf$var$calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            this.allRowGuis.forEach((gui)=>{
                gui.rowComp.toggleCss(classToAdd, true);
                gui.rowComp.toggleCss(classToRemove, false);
            });
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-first", newFirst));
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-row-last", newLast));
        }
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = [];
        this.beans.rowStyleSvc?.processClassesFromGridOptions(cssClasses, this.rowNode);
        if (!cssClasses.length) return;
        cssClasses.forEach((classStr)=>{
            this.allRowGuis.forEach((c)=>c.rowComp.toggleCss(classStr, true));
        });
    }
    postProcessRowClassRules() {
        this.beans.rowStyleSvc?.processRowClassRules(this.rowNode, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss(className, true));
        }, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss(className, false));
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        if (rowContainerType === "left" || rowContainerType === "right") return rowContainerType;
        return null;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const fullWidthRow = this.isFullWidth();
        const { rowNode: rowNode, beans: beans } = this;
        const classes = [];
        classes.push("ag-row");
        classes.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (this.fadeInAnimation[rowContainerType]) classes.push("ag-opacity-zero");
        classes.push(rowNode.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd");
        if (rowNode.isRowPinned()) {
            classes.push("ag-row-pinned");
            if (beans.pinnedRowModel?.isManual()) classes.push("ag-row-pinned-manual");
        }
        if (!rowNode.isRowPinned() && rowNode.pinnedSibling) classes.push("ag-row-pinned-source");
        if (rowNode.isSelected()) classes.push("ag-row-selected");
        if (rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + this.rowLevel);
        if (rowNode.stub) classes.push("ag-row-loading");
        if (fullWidthRow) classes.push("ag-full-width-row");
        beans.expansionSvc?.addExpandedCss(classes, rowNode);
        if (rowNode.dragging) classes.push("ag-row-dragging");
        const { rowStyleSvc: rowStyleSvc } = beans;
        if (rowStyleSvc) {
            rowStyleSvc.processClassesFromGridOptions(classes, rowNode);
            rowStyleSvc.preProcessRowClassRules(classes, rowNode);
        }
        classes.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (this.isFirstRowOnPage()) classes.push("ag-row-first");
        if (this.isLastRowOnPage()) classes.push("ag-row-last");
        if (fullWidthRow) {
            if (pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processStylesFromGridOptions() {
        return this.beans.rowStyleSvc?.processStylesFromGridOptions(this.rowNode) ?? this.emptyStyle;
    }
    onRowSelected(gui) {
        this.beans.selectionSvc?.onRowCtrlSelected(this, (gui2)=>{
            if (gui2 === this.centerGui || gui2 === this.fullWidthGui) this.announceDescription();
        }, gui);
    }
    announceDescription() {
        this.beans.selectionSvc?.announceAriaRowSelection(this.rowNode);
    }
    addHoverFunctionality(eGui) {
        if (!this.active) return;
        const { element: element, compBean: compBean } = eGui;
        const { rowNode: rowNode, beans: beans, gos: gos } = this;
        compBean.addManagedListeners(element, {
            mouseenter: ()=>rowNode.dispatchRowEvent("mouseEnter"),
            mouseleave: ()=>rowNode.dispatchRowEvent("mouseLeave")
        });
        compBean.addManagedListeners(rowNode, {
            mouseEnter: ()=>{
                if (!beans.dragSvc?.dragging && !gos.get("suppressRowHoverHighlight")) {
                    element.classList.add("ag-row-hover");
                    rowNode.setHovered(true);
                }
            },
            mouseLeave: ()=>{
                this.resetHoveredStatus(element);
            }
        });
    }
    resetHoveredStatus(el) {
        const elements = el ? [
            el
        ] : this.allRowGuis.map((gui)=>gui.element);
        for (const element of elements)element.classList.remove("ag-row-hover");
        this.rowNode.setHovered(false);
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else this.allRowGuis.forEach(callback);
    }
    isRowRendered() {
        return this.allRowGuis.length > 0;
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = $437b23f6a393c3bf$export$f0ddd2d4ccc7fed8(this.gos);
        const heightFromFunc = isHeightFromFunc ? $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        const { rowNode: rowNode } = this;
        if (!suppressAnimation && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowNode.sticky) {
            const rowStillVisibleJustNotInViewport = rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(rowNode.rowTop);
                this.setRowTop(rowTop);
            } else this.allRowGuis.forEach((gui)=>gui.rowComp.toggleCss("ag-opacity-zero", true));
        }
        if (this.fullWidthGui?.element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) this.beans.focusSvc.attemptToRecoverFocus();
        rowNode.setHovered(false);
        const event = this.createRowEvent("virtualRowRemoved");
        this.dispatchLocalEvent(event);
        this.beans.eventSvc.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        this.beans.editSvc?.stopRowEditing(this);
        const destroyCellCtrls = (ctrls)=>{
            ctrls.list.forEach((c)=>c.destroy());
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-focus", this.rowFocused);
            gui2.rowComp.toggleCss("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const { focusSvc: focusSvc, editSvc: editSvc } = this.beans;
        const rowFocused = focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
        if (!rowFocused && this.editing) editSvc?.stopRowEditing(this, false);
    }
    onPaginationChanged() {
        const currentPage = this.beans.pagination?.getCurrentPage() ?? 0;
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.pageBounds.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        const rowNode = this.rowNode;
        let rowTop;
        if (rowNode.sticky) rowTop = rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(rowNode.oldRowTop) : rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeight.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        this.allRowGuis.forEach((gui)=>this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`));
    }
    getCellCtrl(column, skipColSpanSearch = false) {
        let res = null;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.column == column) res = cellCtrl;
        });
        if (res != null || skipColSpanSearch) return res;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        });
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        if (rowIndexStr === null) return;
        const headerRowCount = (this.beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.beans.filterManager?.getHeaderRowCount() ?? 0);
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.toggleCss("ag-row-even", rowIsEven);
            c.rowComp.toggleCss("ag-row-odd", !rowIsEven);
            $437b23f6a393c3bf$export$ba731dedf9d88615(c.element, ariaRowIndex);
        });
    }
};
// packages/ag-grid-community/src/utils/keyboard.ts
function $437b23f6a393c3bf$export$33ecd6e270298858(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key?.length === 1;
    return printableCharacter;
}
function $437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
        event: keyboardEvent,
        editing: editing,
        column: column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
// packages/ag-grid-community/src/utils/selection.ts
function $437b23f6a393c3bf$export$57896ee3d2f5a3d(beans) {
    const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = beans;
    const [isEmptyPinnedTop, isEmptyPinnedBottom] = [
        pinnedRowModel?.isEmpty("top") ?? true,
        pinnedRowModel?.isEmpty("bottom") ?? true
    ];
    const floatingStart = isEmptyPinnedTop ? null : "top";
    let floatingEnd;
    let rowEnd;
    if (isEmptyPinnedBottom) {
        floatingEnd = null;
        rowEnd = rowModel.getRowCount() - 1;
    } else {
        floatingEnd = "bottom";
        rowEnd = pinnedRowModel?.getPinnedBottomRowCount() ?? -1;
    }
    const { visibleCols: visibleCols, rangeSvc: rangeSvc } = beans;
    const allDisplayedColumns = visibleCols.allCols;
    if (!rangeSvc || !allDisplayedColumns?.length) return;
    rangeSvc.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: floatingStart,
        rowEndIndex: rowEnd,
        rowEndPinned: floatingEnd
    });
}
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var $437b23f6a393c3bf$var$A_KEYCODE = 65;
var $437b23f6a393c3bf$var$C_KEYCODE = 67;
var $437b23f6a393c3bf$var$V_KEYCODE = 86;
var $437b23f6a393c3bf$var$D_KEYCODE = 68;
var $437b23f6a393c3bf$var$Z_KEYCODE = 90;
var $437b23f6a393c3bf$var$Y_KEYCODE = 89;
function $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode: keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case $437b23f6a393c3bf$var$A_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.A;
            break;
        case $437b23f6a393c3bf$var$C_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
            break;
        case $437b23f6a393c3bf$var$V_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.V;
            break;
        case $437b23f6a393c3bf$var$D_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.D;
            break;
        case $437b23f6a393c3bf$var$Z_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z;
            break;
        case $437b23f6a393c3bf$var$Y_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
var $437b23f6a393c3bf$var$RowContainerEventsFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.beans.touchSvc?.mockRowContextMenu(this);
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedElementListeners(this.element, {
            [eventName]: listener
        });
    }
    addMouseListeners() {
        const mouseDownEvent = $437b23f6a393c3bf$var$_isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        eventNames.forEach((eventName)=>{
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedElementListeners(this.element, {
                [eventName]: listener
            });
        });
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, mouseEvent) || $437b23f6a393c3bf$export$9a48e23524c6d58(mouseEvent)) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(mouseEvent.target);
        if (eventName === "contextmenu") {
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(mouseEvent);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(mouseEvent, void 0, rowCtrl, cellCtrl);
        } else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowCtrl) rowCtrl.onMouseEvent(eventName, mouseEvent);
        }
    }
    getControlsForEventTarget(target) {
        const { gos: gos } = this;
        return {
            cellCtrl: $437b23f6a393c3bf$export$b5bf61dcea514250(gos, target),
            rowCtrl: $437b23f6a393c3bf$var$_getCtrlForEventTarget(gos, target, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl && rowCtrl.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const { rowNode: rowNode, column: column, editing: editing } = cellCtrl;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.beans.navigation?.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, cellCtrl.editing);
                if ($437b23f6a393c3bf$export$33ecd6e270298858(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(cellCtrl.createEvent(keyboardEvent, "cellKeyDown"));
    }
    processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent) {
        const { rowNode: rowNode } = rowCtrl;
        const { focusSvc: focusSvc, navigation: navigation } = this.beans;
        const focusedCell = focusSvc.getFocusedCell();
        const column = focusedCell && focusedCell.column;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                    navigation?.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    if (!this.gos.get("embedFullWidthRows")) break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    rowCtrl.onKeyboardNavigate(keyboardEvent);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                    rowCtrl.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") this.eventSvc.dispatchEvent(rowCtrl.createRowEvent("cellKeyDown", keyboardEvent));
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, keyboardEvent)) return;
        const keyCode = $437b23f6a393c3bf$var$_normaliseQwertyAzerty(keyboardEvent);
        const { clipboardSvc: clipboardSvc, undoRedo: undoRedo } = this.beans;
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C) return this.onCtrlAndC(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.D) return this.onCtrlAndD(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.V) return this.onCtrlAndV(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.X) return this.onCtrlAndX(clipboardSvc, keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y) return this.onCtrlAndY(undoRedo);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z) return this.onCtrlAndZ(undoRedo, keyboardEvent);
    }
    onCtrlAndA(event) {
        const { beans: { rowModel: rowModel, rangeSvc: rangeSvc, selectionSvc: selectionSvc }, gos: gos } = this;
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) && rowModel.isRowsToRender()) $437b23f6a393c3bf$export$57896ee3d2f5a3d(this.beans);
        else if (selectionSvc) selectionSvc?.selectAllRowNodes({
            source: "keyboardSelectAll",
            selectAll: $437b23f6a393c3bf$var$_getSelectAll(gos)
        });
        event.preventDefault();
    }
    onCtrlAndC(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if (cellCtrl?.editing || rowCtrl?.editing) return;
        event.preventDefault();
        clipboardSvc.copyToClipboard();
    }
    onCtrlAndX(clipboardSvc, event) {
        if (!clipboardSvc || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if (cellCtrl?.editing || rowCtrl?.editing) return;
        event.preventDefault();
        clipboardSvc.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(clipboardSvc, event) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if (cellCtrl?.editing || rowCtrl?.editing) return;
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.pasteFromClipboard();
    }
    onCtrlAndD(clipboardSvc, event) {
        if (clipboardSvc && !this.gos.get("suppressClipboardPaste")) clipboardSvc.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(undoRedo, event) {
        if (!this.gos.get("undoRedoCellEditing") || !undoRedo) return;
        event.preventDefault();
        if (event.shiftKey) undoRedo.redo("ui");
        else undoRedo.undo("ui");
    }
    onCtrlAndY(undoRedo) {
        undoRedo?.redo("ui");
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setHeightFeature.ts
var $437b23f6a393c3bf$var$SetHeightFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
        });
    }
    onHeightChanged(maxDivHeightScaler) {
        const height = maxDivHeightScaler.uiContainerHeight;
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var $437b23f6a393c3bf$var$getTopRowCtrls = (r)=>r.topRowCtrls;
var $437b23f6a393c3bf$var$getStickyTopRowCtrls = (r)=>r.getStickyTopRowCtrls();
var $437b23f6a393c3bf$var$getStickyBottomRowCtrls = (r)=>r.getStickyBottomRowCtrls();
var $437b23f6a393c3bf$var$getBottomRowCtrls = (r)=>r.bottomRowCtrls;
var $437b23f6a393c3bf$var$getCentreRowCtrls = (r)=>r.allRowCtrls;
var $437b23f6a393c3bf$var$getSpannedTopRowCtrls = (r)=>r.getCtrls("top");
var $437b23f6a393c3bf$var$getSpannedCenterRowCtrls = (r)=>r.getCtrls("center");
var $437b23f6a393c3bf$var$getSpannedBottomRowCtrls = (r)=>r.getCtrls("bottom");
var $437b23f6a393c3bf$var$ContainerCssClasses = {
    center: {
        type: "center",
        name: "center-cols",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    left: {
        type: "left",
        name: "pinned-left-cols",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    right: {
        type: "right",
        name: "pinned-right-cols",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedCenterRowCtrls
    },
    fullWidth: {
        type: "fullWidth",
        name: "full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getCentreRowCtrls
    },
    topCenter: {
        type: "center",
        name: "floating-top",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topLeft: {
        type: "left",
        name: "pinned-left-floating",
        container: "ag-pinned-left-floating-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topRight: {
        type: "right",
        name: "pinned-right-floating",
        container: "ag-pinned-right-floating-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedTopRowCtrls
    },
    topFullWidth: {
        type: "fullWidth",
        name: "floating-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getTopRowCtrls
    },
    stickyTopCenter: {
        type: "center",
        name: "sticky-top",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopLeft: {
        type: "left",
        name: "pinned-left-sticky-top",
        container: "ag-pinned-left-sticky-top",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopRight: {
        type: "right",
        name: "pinned-right-sticky-top",
        container: "ag-pinned-right-sticky-top",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyTopFullWidth: {
        type: "fullWidth",
        name: "sticky-top-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyTopRowCtrls
    },
    stickyBottomCenter: {
        type: "center",
        name: "sticky-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomLeft: {
        type: "left",
        name: "pinned-left-sticky-bottom",
        container: "ag-pinned-left-sticky-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomRight: {
        type: "right",
        name: "pinned-right-sticky-bottom",
        container: "ag-pinned-right-sticky-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    stickyBottomFullWidth: {
        type: "fullWidth",
        name: "sticky-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getStickyBottomRowCtrls
    },
    bottomCenter: {
        type: "center",
        name: "floating-bottom",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomLeft: {
        type: "left",
        name: "pinned-left-floating-bottom",
        container: "ag-pinned-left-floating-bottom",
        pinnedType: "left",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomRight: {
        type: "right",
        name: "pinned-right-floating-bottom",
        container: "ag-pinned-right-floating-bottom",
        pinnedType: "right",
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls,
        getSpannedRowCtrls: $437b23f6a393c3bf$var$getSpannedBottomRowCtrls
    },
    bottomFullWidth: {
        type: "fullWidth",
        name: "floating-bottom-full-width",
        fullWidth: true,
        getRowCtrls: $437b23f6a393c3bf$var$getBottomRowCtrls
    }
};
function $437b23f6a393c3bf$export$65619730ec980d6a(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-viewport`;
}
function $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return options.container ?? `ag-${options.name}-container`;
}
function $437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name) {
    const options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    return `ag-${options.name}-spanned-cells-container`;
}
function $437b23f6a393c3bf$export$a46aad9f8c79261f(name) {
    return $437b23f6a393c3bf$var$ContainerCssClasses[name];
}
var $437b23f6a393c3bf$var$allTopNoFW = [
    "topCenter",
    "topLeft",
    "topRight"
];
var $437b23f6a393c3bf$var$allBottomNoFW = [
    "bottomCenter",
    "bottomLeft",
    "bottomRight"
];
var $437b23f6a393c3bf$var$allMiddleNoFW = [
    "center",
    "left",
    "right"
];
var $437b23f6a393c3bf$var$allMiddle = [
    "center",
    "left",
    "right",
    "fullWidth"
];
var $437b23f6a393c3bf$var$allCenter = [
    "stickyTopCenter",
    "stickyBottomCenter",
    "center",
    "topCenter",
    "bottomCenter"
];
var $437b23f6a393c3bf$var$allLeft = [
    "left",
    "bottomLeft",
    "topLeft",
    "stickyTopLeft",
    "stickyBottomLeft"
];
var $437b23f6a393c3bf$var$allRight = [
    "right",
    "bottomRight",
    "topRight",
    "stickyTopRight",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyTopNoFW = [
    "stickyTopCenter",
    "stickyTopLeft",
    "stickyTopRight"
];
var $437b23f6a393c3bf$var$allStickyBottomNoFW = [
    "stickyBottomCenter",
    "stickyBottomLeft",
    "stickyBottomRight"
];
var $437b23f6a393c3bf$var$allStickyContainers = [
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    "stickyTopFullWidth",
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW,
    "stickyBottomFullWidth"
];
var $437b23f6a393c3bf$var$allNoFW = [
    ...$437b23f6a393c3bf$var$allTopNoFW,
    ...$437b23f6a393c3bf$var$allBottomNoFW,
    ...$437b23f6a393c3bf$var$allMiddleNoFW,
    ...$437b23f6a393c3bf$var$allStickyTopNoFW,
    ...$437b23f6a393c3bf$var$allStickyBottomNoFW
];
var $437b23f6a393c3bf$export$2d4385f6f566fe5e = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(name){
        super();
        this.name = name;
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(name);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center"
        ], ()=>{
            this.viewportSizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ViewportSizeFeature(this));
            this.addManagedEventListeners({
                stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
            });
        });
    }
    onStickyTopOffsetChanged(event) {
        this.comp.setOffsetTop(`${event.offset}px`);
    }
    registerWithCtrlsService() {
        if (this.options.fullWidth) return;
        this.beans.ctrlsSvc.register(this.name, this);
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    setComp(view, eContainer, eSpannedContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eSpannedContainer = eSpannedContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new $437b23f6a393c3bf$var$RowContainerEventsFeature(this.eViewport ?? this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        const { pinnedCols: pinnedCols, rangeSvc: rangeSvc } = this.beans;
        const pinnedWidthChanged = ()=>this.onPinnedWidthChanged();
        this.forContainers($437b23f6a393c3bf$var$allLeft, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(true, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                leftPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allRight, ()=>{
            this.pinnedWidthFeature = this.createOptionalManagedBean(pinnedCols?.createPinnedWidthFeature(false, this.eContainer, this.eSpannedContainer));
            this.addManagedEventListeners({
                rightPinnedWidthChanged: pinnedWidthChanged
            });
        });
        this.forContainers($437b23f6a393c3bf$var$allMiddle, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer, this.name === "center" ? eViewport : void 0)));
        if (rangeSvc) this.forContainers($437b23f6a393c3bf$var$allNoFW, ()=>this.createManagedBean(rangeSvc.createDragListenerFeature(this.eContainer)));
        this.forContainers($437b23f6a393c3bf$var$allCenter, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.visible = this.isContainerVisible();
        this.addListeners();
        this.registerWithCtrlsService();
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    addListeners() {
        const { spannedRowRenderer: spannedRowRenderer, gos: gos } = this.beans;
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: onDisplayedColumnsChanged,
            displayedColumnsWidthChanged: onDisplayedColumnsChanged,
            displayedRowsChanged: (params)=>this.onDisplayedRowsChanged(params.afterScroll)
        });
        onDisplayedColumnsChanged();
        this.onDisplayedRowsChanged();
        if (spannedRowRenderer && this.options.getSpannedRowCtrls && gos.get("enableCellSpan")) this.addManagedListeners(spannedRowRenderer, {
            spannedRowsUpdated: ()=>{
                const spannedCtrls = this.options.getSpannedRowCtrls(spannedRowRenderer);
                if (!spannedCtrls) return;
                this.comp.setSpannedRowCtrls(spannedCtrls, false);
            }
        });
    }
    listenOnDomOrder() {
        const isStickContainer = $437b23f6a393c3bf$var$allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center"
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const { dragSvc: dragSvc } = this.beans;
        if (!dragSvc) return;
        const preventScroll = (e)=>{
            if (dragSvc.dragging) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.beans.colViewport.setScrollPosition(scrollWidth, scrollPosition, afterScroll);
    }
    hasHorizontalScrollGap() {
        return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
    }
    hasVerticalScrollGap() {
        return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
    }
    getCenterWidth() {
        return $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return $437b23f6a393c3bf$var$_isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || $437b23f6a393c3bf$var$_isHorizontalScrollShowing(this.eViewport);
    }
    setHorizontalScroll(offset) {
        this.comp.setHorizontalScroll(offset);
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = this.options.pinnedType != null;
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.options.getRowCtrls(this.beans.rowRenderer);
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.options.fullWidth ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyCtrl.ts
var $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var $437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var $437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var $437b23f6a393c3bf$export$8bebc3145b40d221 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colModel = beans.colModel;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.filterManager = beans.filterManager;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.eCenterColsViewport = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$65619730ec980d6a("center")}`);
        this.eFullWidthContainer = eBodyViewport.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("fullWidth")}`);
        this.eStickyTopFullWidthContainer = eStickyTop.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyTopFullWidth")}`);
        this.eStickyBottomFullWidthContainer = eStickyBottom.querySelector(`.${$437b23f6a393c3bf$export$35e1b2dddf7fc6e9("stickyBottomFullWidth")}`);
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.comp));
        this.scrollFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GridBodyScrollFeature(eBodyViewport));
        this.beans.rowDragSvc?.setupRowDrag(eBodyViewport, this);
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.setGridRootRole();
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.updateScrollingClasses();
        this.filterManager?.setupAdvFilterHeaderComp(eTop);
        this.ctrlsSvc.register("gridBodyCtrl", this);
    }
    addEventListeners() {
        const setFloatingHeights = this.setFloatingHeights.bind(this);
        const setGridRootRole = this.setGridRootRole.bind(this);
        const toggleRowResizeStyle = this.toggleRowResizeStyles.bind(this);
        this.addManagedEventListeners({
            gridColumnsChanged: this.onGridColumnsChanged.bind(this),
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
            scrollGapChanged: this.updateScrollingClasses.bind(this),
            pinnedRowDataChanged: setFloatingHeights,
            pinnedHeightChanged: setFloatingHeights,
            pinnedRowsChanged: setFloatingHeights,
            headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
            columnRowGroupChanged: setGridRootRole,
            columnPivotChanged: setGridRootRole,
            rowResizeStarted: toggleRowResizeStyle,
            rowResizeEnded: toggleRowResizeStyle
        });
        this.addManagedPropertyListener("treeData", setGridRootRole);
    }
    toggleRowResizeStyles(params) {
        const isResizingRow = params.type === "rowResizeStarted";
        this.eBodyViewport.classList.toggle("ag-prevent-animation", isResizingRow);
    }
    onGridColumnsChanged() {
        const columns = this.beans.colModel.getCols();
        this.comp.setColumnCount(columns.length);
    }
    onScrollVisibilityChanged() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this;
        const visible = scrollVisibleSvc.verticalScrollShowing;
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const pad = $437b23f6a393c3bf$var$_isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.comp.setBodyViewportWidth(width));
        this.updateScrollingClasses();
    }
    setGridRootRole() {
        const { rowGroupColsSvc: rowGroupColsSvc, colModel: colModel } = this;
        let isTreeGrid = this.gos.get("treeData");
        if (!isTreeGrid) {
            const isPivotActive = colModel.isPivotMode();
            const rowGroupColumnLen = !rowGroupColsSvc ? 0 : rowGroupColsSvc.columns.length;
            const columnsNeededForGrouping = isPivotActive ? 2 : 1;
            isTreeGrid = rowGroupColumnLen >= columnsNeededForGrouping;
        }
        this.comp.setGridRootRole(isTreeGrid ? "treegrid" : "grid");
    }
    addFocusListeners(elements) {
        elements.forEach((element)=>{
            this.addManagedElementListeners(element, {
                focusin: (e)=>{
                    const { target: target } = e;
                    const isFocusedElementNested = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                    element.classList.toggle("ag-has-focus", !isFocusedElementNested);
                },
                focusout: (e)=>{
                    const { target: target, relatedTarget: relatedTarget } = e;
                    const gridContainRelatedTarget = element.contains(relatedTarget);
                    const isNestedRelatedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(relatedTarget, "ag-root", element);
                    const isNestedTarget = $437b23f6a393c3bf$var$_isElementChildOfClass(target, "ag-root", element);
                    if (isNestedTarget) return;
                    if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
                }
            });
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss($437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss($437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    updateScrollingClasses() {
        const { eGridBody: { classList: classList }, scrollVisibleSvc: scrollVisibleSvc } = this;
        classList.toggle("ag-body-vertical-content-no-gap", !scrollVisibleSvc.verticalScrollGap);
        classList.toggle("ag-body-horizontal-content-no-gap", !scrollVisibleSvc.horizontalScrollGap);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedElementListeners(this.eGridBody, {
            dragstart: (event)=>{
                if (event.target instanceof HTMLImageElement) {
                    event.preventDefault();
                    return false;
                }
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        this.beans.editSvc?.addStopEditingWhenGridLosesFocus([
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ]);
    }
    updateRowCount() {
        const headerCount = (this.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0) + (this.filterManager?.getHeaderRowCount() ?? 0);
        const { rowModel: rowModel } = this.beans;
        const rowCount = rowModel.isLastRowIndexKnown() ? rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && $437b23f6a393c3bf$var$_isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const { rowContainerHeight: rowContainerHeight, environment: environment } = this.beans;
        let initialSizeMeasurementComplete = environment.sizesMeasured;
        const updateAnimationClass = ()=>{
            const animateRows = initialSizeMeasurementComplete && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos) && !rowContainerHeight.stretching;
            const animateRowsCssClass = animateRows ? "ag-row-animation" : "ag-row-no-animation";
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        updateAnimationClass();
        this.addManagedEventListeners({
            heightScaleChanged: updateAnimationClass
        });
        this.addManagedPropertyListener("animateRows", updateAnimationClass);
        this.addManagedEventListeners({
            gridStylesChanged: ()=>{
                if (!initialSizeMeasurementComplete && environment.sizesMeasured) {
                    initialSizeMeasurementComplete = true;
                    updateAnimationClass();
                }
            }
        });
    }
    addBodyViewportListener() {
        const { eBodyViewport: eBodyViewport, eStickyTop: eStickyTop, eStickyBottom: eStickyBottom, eTop: eTop, eBottom: eBottom, beans: { popupSvc: popupSvc, touchSvc: touchSvc } } = this;
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedElementListeners(eBodyViewport, {
            contextmenu: listener
        });
        touchSvc?.mockBodyContextMenu(this, listener);
        this.addManagedElementListeners(eBodyViewport, {
            wheel: this.onBodyViewportWheel.bind(this, popupSvc)
        });
        const onStickyWheel = this.onStickyWheel.bind(this);
        for (const container of [
            eStickyTop,
            eStickyBottom,
            eTop,
            eBottom
        ])this.addManagedElementListeners(container, {
            wheel: onStickyWheel
        });
        const onHorizontalWheel = this.onHorizontalWheel.bind(this);
        for (const container of [
            "left",
            "right",
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight"
        ])this.addManagedElementListeners(this.ctrlsSvc.get(container).eContainer, {
            wheel: onHorizontalWheel
        });
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        this.addManagedElementListeners(this.eFullWidthContainer, {
            wheel: (e)=>this.onFullWidthContainerWheel(e)
        });
    }
    onFullWidthContainerWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (isHorizontalScroll && $437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, e)) this.scrollGridBodyToMatchEvent(e);
    }
    onStickyWheel(e) {
        const { deltaY: deltaY } = e;
        e.preventDefault();
        this.scrollVertically(deltaY);
    }
    onHorizontalWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = e;
        const isHorizontalScroll = shiftKey || Math.abs(deltaX) > Math.abs(deltaY);
        if (!isHorizontalScroll) return;
        this.scrollGridBodyToMatchEvent(e);
    }
    scrollGridBodyToMatchEvent(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        e.preventDefault();
        this.eCenterColsViewport.scrollBy({
            left: deltaX || deltaY
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target: target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsSvc.get("center").eViewport) this.beans.contextMenuSvc?.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            value: null,
            anchorToElement: this.eGridBody,
            source: "ui"
        });
    }
    onBodyViewportWheel(popupSvc, e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (popupSvc?.hasAnchoredPopup()) e.preventDefault();
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.scrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    setFloatingHeights() {
        const { pinnedRowModel: pinnedRowModel, beans: { environment: environment } } = this;
        const floatingTopHeight = pinnedRowModel?.getPinnedTopTotalHeight();
        const floatingBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight();
        const pinnedBorderWidth = environment.getPinnedRowBorderWidth();
        const rowBorderWidth = environment.getRowBorderWidth();
        const additionalHeight = pinnedBorderWidth - rowBorderWidth;
        const normalisedFloatingTopHeight = !floatingTopHeight ? 0 : additionalHeight + floatingTopHeight;
        const normalisedFloatingBottomHeight = !floatingBottomHeight ? 0 : additionalHeight + floatingBottomHeight;
        this.comp.setTopHeight(normalisedFloatingTopHeight);
        this.comp.setBottomHeight(normalisedFloatingBottomHeight);
        this.comp.setTopInvisible(normalisedFloatingTopHeight <= 0);
        this.comp.setBottomInvisible(normalisedFloatingBottomHeight <= 0);
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsSvc.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.headerHeight + (this.filterManager?.getHeaderHeight() ?? 0);
        const pinnedTopHeight = this.pinnedRowModel?.getPinnedTopTotalHeight() ?? 0;
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const { pinnedRowModel: pinnedRowModel, scrollVisibleSvc: scrollVisibleSvc, comp: comp } = this;
        const pinnedBottomHeight = pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        const hScrollShowing = scrollVisibleSvc.horizontalScrollShowing;
        const scrollbarWidth = hScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        comp.setStickyBottomBottom(`${height}px`);
    }
};
// packages/ag-grid-community/src/gridBodyComp/abstractFakeScrollComp.ts
var $437b23f6a393c3bf$var$AbstractFakeScrollComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, direction){
        super();
        this.direction = direction;
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.hideTimeout = 0;
        this.setTemplate(template);
    }
    postConstruct() {
        this.addManagedEventListeners({
            scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
        });
        this.onScrollVisibilityChanged();
        this.toggleCss("ag-apple-scrollbar", $437b23f6a393c3bf$var$_isMacOsUserAgent() || $437b23f6a393c3bf$export$6b6034a68325bd8a());
    }
    destroy() {
        super.destroy();
        window.clearTimeout(this.hideTimeout);
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = $437b23f6a393c3bf$var$_isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const eGui = this.getGui();
        const onActivate = ()=>this.toggleCss("ag-scrollbar-active", true);
        const onDeactivate = ()=>this.toggleCss("ag-scrollbar-active", false);
        this.addManagedListeners(eGui, {
            mouseenter: onActivate,
            mousedown: onActivate,
            touchstart: onActivate,
            mouseleave: onDeactivate,
            touchend: onDeactivate
        });
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedEventListeners({
            bodyScroll: (params)=>{
                if (params.direction === this.direction) {
                    if (this.hideTimeout) {
                        window.clearTimeout(this.hideTimeout);
                        this.hideTimeout = 0;
                    }
                    this.toggleCss("ag-scrollbar-scrolling", true);
                }
            },
            bodyScrollEnd: ()=>{
                this.hideTimeout = window.setTimeout(()=>{
                    this.toggleCss("ag-scrollbar-scrolling", false);
                    this.hideTimeout = 0;
                }, 400);
            }
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.eViewport;
        $437b23f6a393c3bf$export$b863e7aac7884b8(()=>$437b23f6a393c3bf$export$2badf4aa566524cb(viewport), ()=>this.setScrollPosition(value), 100);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
};
// packages/ag-grid-community/src/gridBodyComp/fakeHScrollComp.ts
var $437b23f6a393c3bf$var$FakeHScrollElement = {
    tag: "div",
    cls: "ag-body-horizontal-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eLeftSpacer",
            cls: "ag-horizontal-left-spacer"
        },
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-horizontal-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-horizontal-scroll-container"
                }
            ]
        },
        {
            tag: "div",
            ref: "eRightSpacer",
            cls: "ag-horizontal-right-spacer"
        }
    ]
};
var $437b23f6a393c3bf$export$8f252e09ef6be2d3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeHScrollElement, "horizontal");
        this.eLeftSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eRightSpacer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.setScrollVisibleDebounce = 0;
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.scrollVisibleSvc = beans.scrollVisibleSvc;
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: spacerWidthsListener,
            displayedColumnsWidthChanged: spacerWidthsListener,
            pinnedRowDataChanged: this.refreshCompBottom.bind(this)
        });
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.beans.ctrlsSvc.register("fakeHScrollComp", this);
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    destroy() {
        window.clearTimeout(this.setScrollVisibleDebounce);
        super.destroy();
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.beans.pinnedRowModel?.getPinnedBottomTotalHeight() ?? 0;
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleSvc.verticalScrollShowing;
        let rightSpacing = this.visibleCols.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.scrollVisibleSvc.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.visibleCols.getColsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleSvc.horizontalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        const apply = ()=>{
            this.setScrollVisibleDebounce = 0;
            this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
            $437b23f6a393c3bf$var$_setFixedHeight(this.getGui(), scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eViewport, scrollContainerSize);
            $437b23f6a393c3bf$var$_setFixedHeight(this.eContainer, scrollContainerSize);
            if (!scrollContainerSize) this.eContainer.style.setProperty("min-height", "1px");
            this.setVisible(hScrollShowing, {
                skipAriaHidden: true
            });
        };
        window.clearTimeout(this.setScrollVisibleDebounce);
        if (!hScrollShowing) apply();
        else this.setScrollVisibleDebounce = window.setTimeout(apply, 100);
    }
    getScrollPosition() {
        return $437b23f6a393c3bf$var$_getScrollLeft(this.eViewport, this.enableRtl);
    }
    setScrollPosition(value) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        $437b23f6a393c3bf$var$_setScrollLeft(this.eViewport, value, this.enableRtl);
    }
};
var $437b23f6a393c3bf$var$FakeHScrollSelector = {
    selector: "AG-FAKE-HORIZONTAL-SCROLL",
    component: $437b23f6a393c3bf$export$8f252e09ef6be2d3
};
// packages/ag-grid-community/src/gridBodyComp/fakeVScrollComp.ts
var $437b23f6a393c3bf$var$FakeVScrollElement = {
    tag: "div",
    cls: "ag-body-vertical-scroll",
    attrs: {
        "aria-hidden": "true"
    },
    children: [
        {
            tag: "div",
            ref: "eViewport",
            cls: "ag-body-vertical-scroll-viewport",
            children: [
                {
                    tag: "div",
                    ref: "eContainer",
                    cls: "ag-body-vertical-scroll-container"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$f496fc30dbebdfa3 = class extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super($437b23f6a393c3bf$var$FakeVScrollElement, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer));
        const { ctrlsSvc: ctrlsSvc } = this.beans;
        ctrlsSvc.register("fakeVScrollComp", this);
        this.addManagedEventListeners({
            rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, ctrlsSvc)
        });
    }
    setScrollVisible() {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const vScrollShowing = scrollVisibleSvc.verticalScrollShowing;
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? scrollVisibleSvc.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.toggleCss("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eViewport, adjustedScrollbarWidth);
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged(ctrlsSvc) {
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.eBodyViewport;
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.eViewport.scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !$437b23f6a393c3bf$export$2badf4aa566524cb(this.eViewport)) this.attemptSettingScrollPosition(value);
        this.eViewport.scrollTop = value;
    }
};
var $437b23f6a393c3bf$var$FakeVScrollSelector = {
    selector: "AG-FAKE-VERTICAL-SCROLL",
    component: $437b23f6a393c3bf$export$f496fc30dbebdfa3
};
// packages/ag-grid-community/src/headerRendering/headerUtils.ts
function $437b23f6a393c3bf$export$4861f2356b3fc2d7(colModel) {
    return colModel.cols ? colModel.cols.treeDepth + 1 : -1;
}
function $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans) {
    return beans.ctrlsSvc.getHeaderRowContainerCtrl()?.getRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getGroupRowsHeight(beans) {
    const heights = [];
    const headerRowContainerCtrls = beans.ctrlsSvc.getHeaderRowContainerCtrls();
    for (const headerRowContainerCtrl of headerRowContainerCtrls){
        if (!headerRowContainerCtrl) continue;
        const groupRowCount = headerRowContainerCtrl.getGroupRowCount() || 0;
        for(let i = 0; i < groupRowCount; i++){
            const headerRowCtrl = headerRowContainerCtrl.getGroupRowCtrlAtIndex(i);
            const currentHeightAtPos = heights[i];
            if (headerRowCtrl) {
                const newHeight = $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl);
                if (currentHeightAtPos == null || newHeight > currentHeightAtPos) heights[i] = newHeight;
            }
        }
    }
    return heights;
}
function $437b23f6a393c3bf$var$getColumnGroupHeaderRowHeight(beans, headerRowCtrl) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) : $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    const headerRowCellCtrls = headerRowCtrl.getHeaderCellCtrls();
    for (const headerCellCtrl of headerRowCellCtrls){
        const { column: column } = headerCellCtrl;
        const height = column.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && column.isAutoHeaderHeight()) maxDisplayedHeight = height;
    }
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans) {
    const defaultHeight = beans.colModel.isPivotMode() ? $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) : $437b23f6a393c3bf$var$getHeaderHeight(beans);
    let maxDisplayedHeight = defaultHeight;
    beans.colModel.forAllCols((col)=>{
        const height = col.getAutoHeaderHeight();
        if (height != null && height > maxDisplayedHeight && col.isAutoHeaderHeight()) maxDisplayedHeight = height;
    });
    return maxDisplayedHeight;
}
function $437b23f6a393c3bf$var$getHeaderHeight(beans) {
    return beans.gos.get("headerHeight") ?? beans.environment.getDefaultHeaderHeight();
}
function $437b23f6a393c3bf$export$b52d5533bf5be44(beans) {
    return beans.gos.get("floatingFiltersHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getGroupHeaderHeight(beans) {
    return beans.gos.get("groupHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotHeaderHeight(beans) {
    return beans.gos.get("pivotHeaderHeight") ?? $437b23f6a393c3bf$var$getHeaderHeight(beans);
}
function $437b23f6a393c3bf$var$getPivotGroupHeaderHeight(beans) {
    return beans.gos.get("pivotGroupHeaderHeight") ?? $437b23f6a393c3bf$var$getGroupHeaderHeight(beans);
}
// packages/ag-grid-community/src/headerRendering/gridHeaderCtrl.ts
var $437b23f6a393c3bf$export$20b300eb69ca4d09 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, touchSvc: touchSvc, ctrlsSvc: ctrlsSvc } = beans;
        if (headerNavigation) this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedEventListeners({
            columnPivotModeChanged: this.onPivotModeChanged.bind(this, beans),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, beans)
        });
        this.onPivotModeChanged(beans);
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedElementListeners(this.eGui, {
            contextmenu: listener
        });
        touchSvc?.mockHeaderContextMenu(this, listener);
        ctrlsSvc.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], listener);
        this.addManagedEventListeners({
            displayedColumnsChanged: listener,
            columnHeaderHeightChanged: listener,
            // add this to the animation frame to avoid a feedback loop
            columnGroupHeaderHeightChanged: ()=>$437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>listener()),
            gridStylesChanged: listener,
            advancedFilterEnabledChanged: listener
        });
    }
    setHeaderHeight() {
        const { beans: beans } = this;
        let totalHeaderHeight = 0;
        const groupHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(beans).reduce((prev, curr)=>prev + curr, 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (beans.filterManager?.hasFloatingFilters()) totalHeaderHeight += $437b23f6a393c3bf$export$b52d5533bf5be44(beans);
        totalHeaderHeight += groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventSvc.dispatchEvent({
            type: "headerHeightChanged"
        });
    }
    onPivotModeChanged(beans) {
        const pivotMode = beans.colModel.isPivotMode();
        this.comp.toggleCss("ag-pivot-on", pivotMode);
        this.comp.toggleCss("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged(beans) {
        const columns = beans.visibleCols.allCols;
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.toggleCss("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const backwards = e.shiftKey;
        const direction = backwards !== isRtl ? "LEFT" : "RIGHT";
        const { beans: beans } = this;
        const { headerNavigation: headerNavigation, focusSvc: focusSvc } = beans;
        if (headerNavigation.navigateHorizontally(direction, true, e) || !backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards, true)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        const { headerNavigation: headerNavigation } = this.beans;
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                direction = "LEFT";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "RIGHT";
                if (headerNavigation.navigateHorizontally(direction, false, e)) e.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                direction = "UP";
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(direction)) direction = "DOWN";
                if (headerNavigation.navigateVertically(direction, null, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget: relatedTarget } = e;
        const { eGui: eGui, beans: beans } = this;
        if (!relatedTarget && eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
        if (!eGui.contains(relatedTarget)) beans.focusSvc.focusedHeader = null;
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        const { menuSvc: menuSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!mouseEvent && !touchEvent || !menuSvc?.isHeaderContextMenuEnabled()) return;
        const { target: target } = mouseEvent ?? touch;
        if (target === this.eGui || target === ctrlsSvc.getHeaderRowContainerCtrl()?.eViewport) menuSvc.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var $437b23f6a393c3bf$var$AbstractHeaderCellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellComp.ts
var $437b23f6a393c3bf$var$HeaderCellElement = {
    tag: "div",
    cls: "ag-header-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderCellElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerCompVersion = 0;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        setAttribute("col-id", this.ctrl.column.getColId());
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setAriaSort: (sort)=>sort ? $437b23f6a393c3bf$export$c8dd030b968c6fd2(eGui, sort) : $437b23f6a393c3bf$export$26c7aa61eda05134(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0);
        const selectAllGui = this.ctrl.getSelectAllGui();
        if (selectAllGui) this.eResize.insertAdjacentElement("afterend", selectAllGui);
    }
    destroy() {
        this.destroyHeaderComp();
        super.destroy();
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.eHeaderCompWrapper.removeChild(this.headerCompGui);
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCompElement = {
    tag: "div",
    cls: "ag-header-group-cell",
    role: "columnheader",
    children: [
        {
            tag: "div",
            ref: "eHeaderCompWrapper",
            cls: "ag-header-cell-comp-wrapper",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eResize",
            cls: "ag-header-cell-resize",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderGroupCellCompElement, ctrl);
        this.eResize = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eHeaderCompWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        eGui.setAttribute("col-id", this.ctrl.column.getUniqueId());
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            setHeaderWrapperHidden: (hidden)=>{
                if (hidden) this.eHeaderCompWrapper.style.setProperty("display", "none");
                else this.eHeaderCompWrapper.style.removeProperty("display");
            },
            setHeaderWrapperMaxHeight: (value)=>{
                if (value != null) this.eHeaderCompWrapper.style.setProperty("max-height", `${value}px`);
                else this.eHeaderCompWrapper.style.removeProperty("max-height");
                this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", value != null);
            },
            setResizableDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize, this.eHeaderCompWrapper, void 0);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        this.eHeaderCompWrapper.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
    addOrRemoveHeaderWrapperStyle(style, value) {
        const { eHeaderCompWrapper: eHeaderCompWrapper } = this;
        if (value) eHeaderCompWrapper.style.setProperty(style, value);
        else eHeaderCompWrapper.style.removeProperty(style);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCompElement = {
    tag: "div",
    cls: "ag-header-cell ag-floating-filter",
    role: "gridcell",
    children: [
        {
            tag: "div",
            ref: "eFloatingFilterBody",
            role: "presentation"
        },
        {
            tag: "div",
            ref: "eButtonWrapper",
            cls: "ag-floating-filter-button ag-hidden",
            role: "presentation",
            children: [
                {
                    tag: "button",
                    ref: "eButtonShowMainFilter",
                    cls: "ag-button ag-floating-filter-button-button",
                    attrs: {
                        type: "button",
                        tabindex: "-1"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderFilterCellComp = class extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super($437b23f6a393c3bf$var$HeaderFilterCellCompElement, ctrl);
        this.eFloatingFilterBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eButtonShowMainFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(eGui, styles),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>$437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroy() {
        this.destroyFloatingFilterComp();
        super.destroy();
    }
    destroyFloatingFilterComp() {
        if (this.floatingFilterComp) {
            this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui());
            this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
        }
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        if (comp.afterGuiAttached) comp.afterGuiAttached();
    }
};
// packages/ag-grid-community/src/headerRendering/row/headerRowComp.ts
var $437b23f6a393c3bf$var$HeaderRowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl){
        super({
            tag: "div",
            cls: ctrl.headerRowClass,
            role: "row"
        });
        this.ctrl = ctrl;
        this.headerComps = {};
    }
    postConstruct() {
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width
        };
        this.ctrl.setComp(compProxy, void 0);
    }
    destroy() {
        this.setHeaderCtrls([], false);
        super.destroy();
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        ctrls.forEach((ctrl)=>{
            const id = ctrl.instanceId;
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        });
        Object.values(oldComps).forEach((comp)=>{
            this.getGui().removeChild(comp.getGui());
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = Object.values(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().column.getLeft();
                const leftB = b.getCtrl().column.getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.type){
            case "group":
                result = new $437b23f6a393c3bf$var$HeaderGroupCellComp(headerCtrl);
                break;
            case "filter":
                result = new $437b23f6a393c3bf$var$HeaderFilterCellComp(headerCtrl);
                break;
            default:
                result = new $437b23f6a393c3bf$var$HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
// packages/ag-grid-community/src/rendering/features/setLeftFeature.ts
var $437b23f6a393c3bf$var$SetLeftFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.colsSpanning = colsSpanning;
        this.columnOrGroup = columnOrGroup;
        this.ariaEl = eCell.querySelector("[role=columnheader]") || eCell;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        const { beans: beans, colsSpanning: colsSpanning } = this;
        if (beans.gos.get("enableRtl") && colsSpanning) return $437b23f6a393c3bf$export$236389741107357f(colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        const onLeftChanged = this.onLeftChanged.bind(this);
        this.addManagedListeners(this.columnOrGroup, {
            leftChanged: onLeftChanged
        });
        this.setLeftFirstTime();
        this.addManagedEventListeners({
            displayedColumnsWidthChanged: onLeftChanged
        });
        this.addManagedPropertyListener("domLayout", onLeftChanged);
    }
    setLeftFirstTime() {
        const { gos: gos, colAnimation: colAnimation } = this.beans;
        const suppressMoveAnimation = gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = $437b23f6a393c3bf$export$25d27f17d3af40f7(this.columnOrGroup.getOldLeft());
        const animateColumnMove = colAnimation?.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getOldLeft());
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, colOrGroup.getLeft());
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.colAnimation.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = visibleCols.getColsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = visibleCols.bodyWidth;
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) this.eCell.style.left = `${value}px`;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(this.columnOrGroup)) {
            const children = this.columnOrGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) $437b23f6a393c3bf$export$371d80f0281454ce(this.ariaEl, children.length);
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence4 = 0;
var $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
var $437b23f6a393c3bf$var$AbstractHeaderCellCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowCtrl){
        super();
        this.column = column;
        this.rowCtrl = rowCtrl;
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.instanceId = column.getUniqueId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence4++;
    }
    postConstruct() {
        const refreshTabIndex = this.refreshTabIndex.bind(this);
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], refreshTabIndex);
        this.addManagedEventListeners({
            overlayExclusiveChanged: refreshTabIndex
        });
    }
    shouldStopEventPropagation(event) {
        const { headerRowIndex: headerRowIndex, column: column } = this.beans.focusSvc.focusedHeader;
        const colDef = column.getDefinition();
        const colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(colDefFunc)) return false;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            colDef: colDef,
            column: column,
            headerRowIndex: headerRowIndex,
            event: event
        });
        return !!colDefFunc(params);
    }
    getWrapperHasFocus() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return activeEl === this.eGui;
    }
    setGui(eGui, compBean) {
        this.eGui = eGui;
        this.addDomData(compBean);
        compBean.addManagedListeners(this.beans.eventSvc, {
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
        });
        compBean.addManagedElementListeners(this.eGui, {
            focus: this.onGuiFocus.bind(this)
        });
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    refreshHeaderStyles() {
        const colDef = this.column.getDefinition();
        if (!colDef) return;
        const { headerStyle: headerStyle } = colDef;
        let styles;
        if (typeof headerStyle === "function") {
            const cellStyleParams = this.getHeaderClassParams();
            styles = headerStyle(cellStyleParams);
        } else styles = headerStyle;
        if (styles) this.comp.setUserStyles(styles);
    }
    onGuiFocus() {
        this.eventSvc.dispatchEvent({
            type: "headerFocused",
            column: this.column
        });
    }
    setupAutoHeight(params) {
        const { wrapperElement: wrapperElement, checkMeasuringCallback: checkMeasuringCallback, compBean: compBean } = params;
        const { beans: beans } = this;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(this.eGui);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc || !doc.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    $437b23f6a393c3bf$export$8ea55376d0d59592(()=>measureHeight(timesCalled + 1), "raf", beans);
                    return;
                }
            }
            this.setColHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            measureHeight(0);
            this.comp.toggleCss("ag-header-cell-auto-height", true);
            stopResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.toggleCss("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        compBean.addDestroyFunc(()=>stopMeasuring());
        compBean.addManagedListeners(this.column, {
            widthChanged: ()=>isMeasuring && measureHeight(0)
        });
        compBean.addManagedEventListeners({
            sortChanged: ()=>{
                if (isMeasuring) window.setTimeout(()=>measureHeight(0));
            }
        });
        if (checkMeasuringCallback) checkMeasuringCallback(checkMeasuring);
    }
    onDisplayedColumnsChanged() {
        const { comp: comp, column: column, beans: beans, eGui: eGui } = this;
        if (!comp || !column || !eGui) return;
        $437b23f6a393c3bf$var$refreshFirstAndLastStyles(comp, column, beans.visibleCols);
        $437b23f6a393c3bf$export$84b73ecd0b234e89(eGui, beans.visibleCols.getAriaColIndex(column));
    }
    addResizeAndMoveKeyboardListeners(compBean) {
        compBean.addManagedListeners(this.eGui, {
            keydown: this.onGuiKeyDown.bind(this),
            keyup: this.onGuiKeyUp.bind(this)
        });
    }
    refreshTabIndex() {
        const suppressHeaderFocus = $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans);
        if (this.eGui) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eGui, "tabindex", suppressHeaderFocus ? null : "-1");
    }
    onGuiKeyDown(e) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const isLeftOrRight = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (!isLeftOrRight) return;
        const isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const direction = isLeft ? "left" : "right";
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            this.resizeFeature?.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    moveHeader(hDirection) {
        this.beans.colMoves?.moveHeader(hDirection, this.eGui, this.column, this.rowCtrl.pinned, this);
    }
    getViewportAdjustedResizeDiff(e) {
        const diff = this.getResizeDiff(e);
        const { pinnedCols: pinnedCols } = this.beans;
        return pinnedCols ? pinnedCols.getHeaderResizeDiff(diff, this.column) : diff;
    }
    getResizeDiff(e) {
        const { gos: gos, column: column } = this;
        let isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== gos.get("enableRtl");
        const pinned = column.getPinned();
        const isRtl = gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = window.setTimeout(()=>{
            this.resizeFeature?.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData(compBean) {
        const key = $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL;
        const { eGui: eGui, gos: gos } = this;
        $437b23f6a393c3bf$var$_setDomData(gos, eGui, key, this);
        compBean.addDestroyFunc(()=>$437b23f6a393c3bf$var$_setDomData(gos, eGui, key, null));
    }
    focus(event) {
        const { eGui: eGui } = this;
        if (!eGui) return false;
        this.lastFocusEvent = event || null;
        eGui.focus();
        return true;
    }
    focusThis() {
        this.beans.focusSvc.focusedHeader = {
            headerRowIndex: this.rowCtrl.rowIndex,
            column: this.column
        };
    }
    removeDragSource() {
        if (this.dragSource) {
            this.beans.dragAndDrop?.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent ?? touchEvent;
        const { menuSvc: menuSvc, gos: gos } = this.beans;
        if (gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        if (menuSvc?.isHeaderContextMenuEnabled(column)) menuSvc.showHeaderContextMenu(column, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent("columnHeaderContextMenu", column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        this.eventSvc.dispatchEvent({
            type: eventType,
            column: column
        });
    }
    setColHeaderHeight(col, height) {
        if (!col.setAutoHeaderHeight(height)) return;
        const { eventSvc: eventSvc } = this;
        if (col.isColumn) eventSvc.dispatchEvent({
            type: "columnHeaderHeightChanged",
            column: col,
            columns: [
                col
            ],
            source: "autosizeColumnHeaderHeight"
        });
        else eventSvc.dispatchEvent({
            type: "columnGroupHeaderHeightChanged",
            columnGroup: col,
            source: "autosizeColumnGroupHeaderHeight"
        });
    }
    clearComponent() {
        this.removeDragSource();
        this.resizeFeature = null;
        this.comp = null;
        this.eGui = null;
    }
    destroy() {
        super.destroy();
        this.column = null;
        this.lastFocusEvent = null;
        this.rowCtrl = null;
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.refreshFunctions = {};
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBeanInput) {
        this.comp = comp;
        const { rowCtrl: rowCtrl, column: column, beans: beans } = this;
        const { colResize: colResize, context: context, colHover: colHover, rangeSvc: rangeSvc } = beans;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBeanInput);
        this.setGui(eGui, compBean);
        this.updateState();
        this.setupWidth(compBean);
        this.setupMovingCss(compBean);
        this.setupMenuClass(compBean);
        this.setupSortableClass(compBean);
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            checkMeasuringCallback: (checkMeasuring)=>this.setRefreshFunction("measuring", checkMeasuring),
            compBean: compBean
        });
        this.addColumnHoverListener(compBean);
        this.setupFilterClass(compBean);
        this.setupStylesFromColDef();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners(compBean);
        this.setupSelectAll(compBean);
        this.setupUserComp();
        this.refreshAria();
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createResizeFeature(rowCtrl.pinned, column, eResize, comp, this));
        else $437b23f6a393c3bf$export$9405f1cbb4e2383f(eResize, false);
        colHover?.createHoverFeature(compBean, [
            column
        ], eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader",
            "enableAdvancedFilter"
        ], ()=>this.refresh());
        compBean.addManagedListeners(column, {
            colDefChanged: ()=>this.refresh()
        });
        compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onHeaderHighlightChanged.bind(this)
        });
        const listener = ()=>this.checkDisplayName();
        compBean.addManagedEventListeners({
            columnValueChanged: listener,
            columnRowGroupChanged: listener,
            columnPivotChanged: listener,
            headerHeightChanged: this.onHeaderHeightChanged.bind(this)
        });
        compBean.addDestroyFunc(()=>{
            this.refreshFunctions = {};
            this.selectAllFeature = null;
            this.dragSourceElement = void 0;
            this.userCompDetails = null;
            this.userHeaderClasses.clear();
            this.ariaDescriptionProperties.clear();
            this.clearComponent();
        });
    }
    resizeHeader(delta, shiftKey) {
        this.beans.colResize?.resizeHeader(this.column, delta, shiftKey);
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: false
        });
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return $437b23f6a393c3bf$var$_getHeaderCompDetails(this.beans.userCompFactory, colDef, params);
    }
    createParams() {
        const { menuSvc: menuSvc, sortSvc: sortSvc, colFilter: colFilter, gos: gos } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && !!menuSvc?.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !!colFilter && (!this.openFilterEnabled || $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)),
            showColumnMenu: (buttonElement, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    positionBy: "button",
                    onClosedCallback: onClosedCallback
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>{
                menuSvc?.showColumnMenu({
                    column: this.column,
                    mouseEvent: mouseEvent,
                    positionBy: "mouse",
                    onClosedCallback: onClosedCallback
                });
            },
            showFilter: (buttonElement)=>{
                menuSvc?.showFilterMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                sortSvc?.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                sortSvc?.setSortForColumn(this.column, sort, !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.eGui,
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll(compBean) {
        const { selectionSvc: selectionSvc } = this.beans;
        if (!selectionSvc) return;
        this.selectAllFeature = compBean.createManagedBean(selectionSvc.createSelectAllFeature(this.column));
        this.selectAllFeature.setComp(this);
    }
    getSelectAllGui() {
        return this.selectAllFeature?.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.selectAllFeature?.onSpaceKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) this.onEnterKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        if (e.ctrlKey || e.metaKey) this.showMenuOnKeyPress(e, true);
        else if (this.sortable) this.beans.sortSvc?.progressSort(this.column, e.shiftKey, "uiColumnSorted");
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!$437b23f6a393c3bf$var$isHeaderComp(headerComp)) return;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) e.preventDefault();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            this.focusThis();
            this.announceAriaDescription();
        }
        if ($437b23f6a393c3bf$export$e4c8c227337b7f23()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.eGui.contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupStylesFromColDef() {
        this.setRefreshFunction("headerStyles", this.refreshHeaderStyles.bind(this));
        this.refreshHeaderStyles();
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            classes.forEach((c)=>{
                if (oldClasses.has(c)) oldClasses.delete(c);
                else this.comp.toggleCss(c, true);
            });
            oldClasses.forEach((c)=>this.comp.toggleCss(c, false));
        };
        this.setRefreshFunction("headerClasses", refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eSource, this.column, this.displayName) ?? null;
    }
    updateState() {
        const { menuSvc: menuSvc } = this.beans;
        this.menuEnabled = !!menuSvc?.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = !!menuSvc?.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    setRefreshFunction(name, func) {
        this.refreshFunctions[name] = func;
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        Object.values(this.refreshFunctions).forEach((f)=>f());
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        if (!newCompDetails) return;
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.colNames.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupMovingCss(compBean) {
        const listener = ()=>{
            this.comp.toggleCss("ag-header-cell-moving", this.column.isMoving());
        };
        compBean.addManagedListeners(this.column, {
            movingChanged: listener
        });
        listener();
    }
    setupMenuClass(compBean) {
        const listener = ()=>{
            this.comp?.toggleCss("ag-column-menu-visible", this.column.isMenuVisible());
        };
        compBean.addManagedListeners(this.column, {
            menuVisibleChanged: listener
        });
        listener();
    }
    setupSortableClass(compBean) {
        const updateSortableCssClass = ()=>{
            this.comp.toggleCss("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.setRefreshFunction("updateSortable", updateSortableCssClass);
        compBean.addManagedEventListeners({
            sortChanged: this.refreshAriaSort.bind(this)
        });
    }
    setupFilterClass(compBean) {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.toggleCss("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        compBean.addManagedListeners(this.column, {
            filterActiveChanged: listener
        });
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.toggleCss("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.setRefreshFunction("wrapText", listener);
    }
    onHeaderHighlightChanged() {
        const highlighted = this.column.getHighlighted();
        const beforeOn = highlighted === 0 /* Before */ ;
        const afterOn = highlighted === 1 /* After */ ;
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui: eGui, column: column, comp: comp, beans: beans } = this;
        const groupHeaderHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        const isZeroGroupHeight = groupHeaderHeight.reduce((total, next)=>total += next, 0) === 0;
        comp.toggleCss("ag-header-parent-hidden", isZeroGroupHeight);
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.toggleCss("ag-header-span-height", false);
            comp.toggleCss("ag-header-span-total", false);
            return;
        }
        const { numberOfParents: numberOfParents, isSpanningTotal: isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.toggleCss("ag-header-span-height", numberOfParents > 0);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(beans);
        if (numberOfParents === 0) {
            comp.toggleCss("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.toggleCss("ag-header-span-total", isSpanningTotal);
        let extraHeight = 0;
        for(let i = 0; i < numberOfParents; i++)extraHeight += groupHeaderHeight[groupHeaderHeight.length - 1 - i];
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    refreshAriaSort() {
        if (this.sortable) {
            const translate = this.getLocaleTextFunc();
            const sort = this.beans.sortSvc?.getDisplaySortForColumn(this.column) || null;
            this.comp.setAriaSort($437b23f6a393c3bf$var$_getAriaSortState(sort));
            this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
        } else {
            this.comp.setAriaSort();
            this.setAriaDescriptionProperty("sort", null);
        }
    }
    refreshAriaMenu() {
        if (this.menuEnabled) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
        } else this.setAriaDescriptionProperty("menu", null);
    }
    refreshAriaFilterButton() {
        if (this.openFilterEnabled && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos)) {
            const translate = this.getLocaleTextFunc();
            this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
        } else this.setAriaDescriptionProperty("filterButton", null);
    }
    refreshAriaFiltered() {
        const translate = this.getLocaleTextFunc();
        const isFilterActive = this.column.isFilterActive();
        if (isFilterActive) this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
        else this.setAriaDescriptionProperty("filter", null);
    }
    setAriaDescriptionProperty(property, value) {
        if (value != null) this.ariaDescriptionProperties.set(property, value);
        else this.ariaDescriptionProperties.delete(property);
    }
    announceAriaDescription() {
        if (!this.eGui.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) return;
        const ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>this.ariaDescriptionProperties.get(key)).join(". ");
        this.beans.ariaAnnounce?.announceValue(ariaDescription, "columnHeader");
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
    }
    addColumnHoverListener(compBean) {
        this.beans.colHover?.addHeaderColumnHoverListener(compBean, this.comp, this.column);
    }
    addActiveHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>{
            this.setActiveHeader(true);
            this.dispatchColumnMouseEvent("columnHeaderClicked", this.column);
        };
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column
        });
    }
    setActiveHeader(active) {
        this.comp.toggleCss("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if ($437b23f6a393c3bf$var$isHeaderComp(headerComp)) return headerComp.getAnchorElementForMenu(isFilter);
        return this.eGui;
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$isHeaderComp(headerComp) {
    return typeof headerComp?.getAnchorElementForMenu === "function" && typeof headerComp.onMenuKeyboardShortcut === "function";
}
// packages/ag-grid-community/src/headerRendering/row/headerRowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence5 = 0;
var $437b23f6a393c3bf$var$HeaderRowCtrl = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowIndex, pinned, type){
        super();
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        this.instanceId = $437b23f6a393c3bf$var$instanceIdSequence5++;
        this.allCtrls = [];
        const typeClass = type == "group" ? `ag-header-row-column-group` : type == "filter" ? `ag-header-row-column-filter` : `ag-header-row-column`;
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    postConstruct() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */ areCellsRendered() {
        if (!this.comp) return false;
        return this.allCtrls.every((ctrl)=>ctrl.eGui != null);
    }
    /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, compBean, initCompState = true) {
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBean);
        if (initCompState) {
            this.onRowHeightChanged();
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners(compBean);
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners(compBean) {
        const onHeightChanged = this.onRowHeightChanged.bind(this);
        const onDisplayedColumnsChanged = this.onDisplayedColumnsChanged.bind(this);
        compBean.addManagedEventListeners({
            columnResized: this.setWidth.bind(this),
            displayedColumnsChanged: onDisplayedColumnsChanged,
            virtualColumnsChanged: (params)=>this.onVirtualColumnsChanged(params.afterScroll),
            columnGroupHeaderHeightChanged: onHeightChanged,
            columnHeaderHeightChanged: onHeightChanged,
            gridStylesChanged: onHeightChanged,
            advancedFilterEnabledChanged: onHeightChanged
        });
        compBean.addManagedPropertyListener("domLayout", onDisplayedColumnsChanged);
        compBean.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        compBean.addManagedPropertyListeners([
            "headerHeight",
            "pivotHeaderHeight",
            "groupHeaderHeight",
            "pivotGroupHeaderHeight",
            "floatingFiltersHeight"
        ], onHeightChanged);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    setWidth() {
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { visibleCols: visibleCols } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return visibleCols.getContainerWidth("right") + visibleCols.getContainerWidth("left") + visibleCols.getContainerWidth(null);
        }
        return visibleCols.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        const { topOffset: topOffset, rowHeight: rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        const { filterManager: filterManager } = this.beans;
        const sizes = [];
        const groupHeadersHeight = $437b23f6a393c3bf$var$getGroupRowsHeight(this.beans);
        const headerHeight = $437b23f6a393c3bf$var$getColumnHeaderRowHeight(this.beans);
        sizes.push(...groupHeadersHeight);
        sizes.push(headerHeight);
        if (filterManager?.hasFloatingFilters()) sizes.push($437b23f6a393c3bf$export$b52d5533bf5be44(this.beans));
        let topOffset = 0;
        for(let i = 0; i < this.rowIndex; i++)topOffset += sizes[i];
        const rowHeight = sizes[this.rowIndex];
        return {
            topOffset: topOffset,
            rowHeight: rowHeight
        };
    }
    onVirtualColumnsChanged(afterScroll = false) {
        const ctrlsToDisplay = this.getUpdatedHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    /**
   * Recycles the header cell ctrls and creates new ones for the columns in the viewport
   * @returns The updated header cell ctrls
   */ getUpdatedHeaderCtrls() {
        const oldCtrls = this.ctrlsById;
        this.ctrlsById = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, this.ctrlsById, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
            const isFocused = focusSvc.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = visibleCols.isVisible(ctrl.column);
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.ctrlsById.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        this.allCtrls = Array.from(this.ctrlsById.values());
        return this.allCtrls;
    }
    /** Get the current header cell ctrls */ getHeaderCellCtrls() {
        return this.allCtrls;
    }
    recycleAndCreateHeaderCtrls(headerColumn, currCtrls, oldCtrls) {
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.column != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerFilterCellCtrl", true, headerColumn, this));
                break;
            case "group":
                headerCtrl = this.createBean(this.beans.registry.createDynamicBean("headerGroupCellCtrl", true, headerColumn, this));
                break;
            default:
                headerCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderCellCtrl(headerColumn, this));
                break;
        }
        currCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }
    getColumnsInViewportPrintLayout() {
        if (this.pinned != null) return [];
        let viewportColumns = [];
        const actualDepth = this.getActualDepth();
        const { colViewport: colViewport } = this.beans;
        [
            "left",
            null,
            "right"
        ].forEach((pinned)=>{
            const items = colViewport.getHeadersToRender(pinned, actualDepth);
            viewportColumns = viewportColumns.concat(items);
        });
        return viewportColumns;
    }
    getActualDepth() {
        return this.type == "filter" ? this.rowIndex - 1 : this.rowIndex;
    }
    getColumnsInViewportNormalLayout() {
        return this.beans.colViewport.getHeadersToRender(this.pinned, this.getActualDepth());
    }
    focusHeader(column, event) {
        const ctrl = this.allCtrls.find((ctrl2)=>ctrl2.column == column);
        if (!ctrl) return false;
        const focused = ctrl.focus(event);
        return focused;
    }
    destroy() {
        this.allCtrls = this.destroyBeans(this.allCtrls);
        this.ctrlsById = void 0;
        super.destroy();
    }
};
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var $437b23f6a393c3bf$export$1e864ee88f54e7b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colModel: colModel, colMoves: colMoves, filterManager: filterManager } = this.beans;
        this.setupCenterWidth();
        pinnedCols?.setupHeaderPinnedWidth(this);
        this.setupDragAndDrop(colMoves, this.eViewport);
        const onDisplayedColsChanged = this.onDisplayedColumnsChanged.bind(this, filterManager);
        this.addManagedEventListeners({
            gridColumnsChanged: this.onGridColumnsChanged.bind(this),
            displayedColumnsChanged: onDisplayedColsChanged,
            advancedFilterEnabledChanged: onDisplayedColsChanged
        });
        const headerType = `${typeof this.pinned === "string" ? this.pinned : "center"}Header`;
        ctrlsSvc.register(headerType, this);
        if (colModel.ready) this.refresh();
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    refresh(keepColumns = false) {
        const { focusSvc: focusSvc, colModel: colModel, filterManager: filterManager } = this.beans;
        let sequence = 0;
        const focusedHeaderPosition = focusSvc.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = $437b23f6a393c3bf$export$4861f2356b3fc2d7(colModel) - 1;
            this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
            for(let i = 0; i < groupRowCount; i++){
                const ctrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(sequence++, this.pinned, "group"));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence++;
            const needNewInstance = !this.hidden && (this.columnsRowCtrl == null || !keepColumns || this.columnsRowCtrl.rowIndex !== rowIndex);
            const shouldDestroyInstance = needNewInstance || this.hidden;
            if (shouldDestroyInstance) this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
            if (needNewInstance) this.columnsRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "column"));
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = !!filterManager?.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            const rowIndex = sequence++;
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.rowIndex !== rowIndex;
                if (!keepColumns || rowIndexMismatch) destroyPreviousComp();
            }
            if (!this.filtersRowCtrl) this.filtersRowCtrl = this.createBean(new $437b23f6a393c3bf$var$HeaderRowCtrl(rowIndex, this.pinned, "filter"));
        };
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusSvc, focusedHeaderPosition);
    }
    getHeaderCtrlForColumn(column) {
        const findCtrl = (ctrl)=>ctrl?.getHeaderCellCtrls().find((ctrl2)=>ctrl2.column === column);
        if ($437b23f6a393c3bf$export$891484e65a02ec71(column)) return findCtrl(this.columnsRowCtrl);
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = findCtrl(this.groupsRowCtrls[i]);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        return this.getHeaderCtrlForColumn(column)?.eGui ?? null;
    }
    getRowType(rowIndex) {
        return this.getAllCtrls()[rowIndex]?.type;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getGroupRowCount() {
        return this.groupsRowCtrls.length;
    }
    getGroupRowCtrlAtIndex(index) {
        return this.groupsRowCtrls[index];
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    onScrollCallback(fn) {
        this.addManagedElementListeners(this.eViewport, {
            scroll: fn
        });
    }
    destroy() {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
    setupDragAndDrop(colMoves, dropContainer) {
        const bodyDropTarget = colMoves?.createBodyDropTarget(this.pinned, dropContainer);
        if (bodyDropTarget) this.createManagedBean(bodyDropTarget);
    }
    restoreFocusOnHeader(focusSvc, position) {
        if (!position) return;
        const { column: column } = position;
        if (column.getPinned() != this.pinned) return;
        focusSvc.focusHeaderPosition({
            headerPosition: position
        });
    }
    // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh
    onGridColumnsChanged() {
        this.refresh(true);
    }
    onDisplayedColumnsChanged(filterManager) {
        const includeFloatingFilter = !!filterManager?.hasFloatingFilters() && !this.hidden;
        if (this.includeFloatingFilter !== includeFloatingFilter) this.refresh(true);
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
};
// packages/ag-grid-community/src/misc/menu/menuService.ts
var $437b23f6a393c3bf$var$MenuService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "menuSvc";
    }
    postConstruct() {
        const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory } = this.beans;
        this.activeMenuFactory = enterpriseMenuFactory ?? filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        const { enterpriseMenuFactory: enterpriseMenuFactory, filterMenuFactory: filterMenuFactory } = this.beans;
        const menuFactory = enterpriseMenuFactory && $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) ? enterpriseMenuFactory : filterMenuFactory;
        this.showColumnMenuCommon(menuFactory, params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory?.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    hidePopupMenu() {
        this.beans.contextMenuSvc?.hideActiveMenu();
        this.activeMenuFactory?.hideActiveMenu();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressHeaderMenuButton: suppressHeaderMenuButton } = column.getColDef();
        return !suppressHeaderMenuButton && !!this.activeMenuFactory?.isMenuEnabled(column) && ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) || !!this.beans.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && !!this.beans.filterManager?.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        const colDef = column && $437b23f6a393c3bf$export$891484e65a02ec71(column) ? column.getColDef() : column?.getColGroupDef();
        return !colDef?.suppressHeaderContextMenu && this.gos.get("columnMenu") === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = $437b23f6a393c3bf$export$6b6034a68325bd8a() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return !!this.beans.filterManager?.isFilterAllowed(column) && !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos) && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFloatingFilterButtonEnabled(column) {
        return !column.getColDef().suppressFloatingFilterButton;
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const gos = this.gos;
        const suppressMenuHide = gos.get("suppressMenuHide");
        if ($437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos)) return gos.exists("suppressMenuHide") ? suppressMenuHide : false;
        return suppressMenuHide;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { positionBy: positionBy, onClosedCallback: onClosedCallback } = params;
        const column = params.column;
        if (positionBy === "button") {
            const { buttonElement: buttonElement } = params;
            menuFactory?.showMenuAfterButtonClick(column, buttonElement, containerType, onClosedCallback, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent: mouseEvent } = params;
            menuFactory?.showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback, filtersOnly);
        } else if (column) {
            const beans = this.beans;
            const ctrlsSvc = beans.ctrlsSvc;
            ctrlsSvc.getScrollFeature().ensureColumnVisible(column, "auto");
            $437b23f6a393c3bf$export$7b1f5bd01973c897(beans, ()=>{
                const headerCellCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned())?.getHeaderCtrlForColumn(column);
                if (headerCellCtrl) menuFactory?.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, onClosedCallback, filtersOnly);
            });
        }
    }
};
function $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, visible, source) {
    if (column.menuVisible !== visible) {
        column.menuVisible = visible;
        column.dispatchColEvent("menuVisibleChanged", source);
    }
}
// packages/ag-grid-community/src/rendering/overlays/overlayComponent.ts
var $437b23f6a393c3bf$var$OverlayComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
};
// packages/ag-grid-community/src/rendering/overlays/loadingOverlayComponent.ts
var $437b23f6a393c3bf$var$LoadingOverlayElement = {
    tag: "span",
    cls: "ag-overlay-loading-center",
    attrs: {
        "aria-live": "polite",
        "aria-atomic": "true"
    }
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayLoadingTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$LoadingOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("loadingOoo", "Loading...");
            });
        }
    }
};
// packages/ag-grid-community/src/rendering/overlays/noRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$NoRowsOverlayElement = {
    tag: "span",
    cls: "ag-overlay-no-rows-center"
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent2 = class extends $437b23f6a393c3bf$var$OverlayComponent {
    init() {
        const customTemplate = $437b23f6a393c3bf$export$4978424c4f7b5fc0(this.gos.get("overlayNoRowsTemplate")?.trim());
        this.setTemplate(customTemplate ?? $437b23f6a393c3bf$var$NoRowsOverlayElement);
        if (!customTemplate) {
            const localeTextFunc = this.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("noRowsToShow", "No Rows To Show");
            });
        }
    }
};
// packages/ag-grid-community/src/utils/icon.ts
function $437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, beans, column) {
    const iconContents = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column);
    if (iconContents) {
        const { className: className } = iconContents;
        if (typeof className === "string" && className.indexOf("ag-icon") > -1 || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = $437b23f6a393c3bf$export$a232bb0480ae674a({
        tag: "span"
    });
    eResult.appendChild(iconContents);
    return eResult;
}
function $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, beans, column) {
    let userProvidedIcon = null;
    if (iconName === "smallDown") $437b23f6a393c3bf$export$545083624300f13d(262);
    else if (iconName === "smallLeft") $437b23f6a393c3bf$export$545083624300f13d(263);
    else if (iconName === "smallRight") $437b23f6a393c3bf$export$545083624300f13d(264);
    const icons = column && column.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (beans.gos && !userProvidedIcon) {
        const optionsIcons = beans.gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else {
            $437b23f6a393c3bf$export$545083624300f13d(38, {
                iconName: iconName
            });
            return void 0;
        }
        if (typeof rendererResult === "string") return $437b23f6a393c3bf$export$b1f57d075ca6d5fb(rendererResult);
        if ($437b23f6a393c3bf$export$6e6303ef478b0c94(rendererResult)) return rendererResult;
        $437b23f6a393c3bf$export$545083624300f13d(133, {
            iconName: iconName
        });
        return void 0;
    } else {
        const iconValue = beans.registry.getIcon(iconName);
        if (!iconValue) beans.validation?.validateIcon(iconName);
        return $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: `ag-icon ag-icon-${iconValue ?? iconName}`,
            role: "presentation",
            attrs: {
                unselectable: "on"
            }
        });
    }
}
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$dragAndDropImageComponentCSS = /*css*/ `.ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}`;
// packages/ag-grid-community/src/dragAndDrop/dragAndDropImageComponent.ts
var $437b23f6a393c3bf$var$DragAndDropElement = {
    tag: "div",
    children: [
        {
            tag: "div",
            ref: "eGhost",
            cls: "ag-dnd-ghost ag-unselectable",
            children: [
                {
                    tag: "span",
                    ref: "eIcon",
                    cls: "ag-dnd-ghost-icon ag-shake-left-to-right"
                },
                {
                    tag: "div",
                    ref: "eLabel",
                    cls: "ag-dnd-ghost-label"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$DragAndDropImageComponent2 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.dragSource = null;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGhost = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$dragAndDropImageComponentCSS);
    }
    postConstruct() {
        const create = (iconName)=>$437b23f6a393c3bf$export$f4e9fbdaadc5e5c1(iconName, this.beans, null);
        this.dropIconMap = {
            pinned: create("columnMovePin"),
            hide: create("columnMoveHide"),
            move: create("columnMoveMove"),
            left: create("columnMoveLeft"),
            right: create("columnMoveRight"),
            group: create("columnMoveGroup"),
            aggregate: create("columnMoveValue"),
            pivot: create("columnMovePivot"),
            notAllowed: create("dropNotAllowed")
        };
    }
    init(params) {
        this.dragSource = params.dragSource;
        this.setTemplate($437b23f6a393c3bf$var$DragAndDropElement);
        this.beans.environment.applyThemeClasses(this.eGhost);
    }
    destroy() {
        this.dragSource = null;
        super.destroy();
    }
    setIcon(iconName, shake) {
        const { eIcon: eIcon, dragSource: dragSource, dropIconMap: dropIconMap, gos: gos } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eIcon);
        let eIconChild = null;
        if (!iconName) iconName = dragSource?.getDefaultIconName ? dragSource.getDefaultIconName() : "notAllowed";
        eIconChild = dropIconMap[iconName];
        eIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIconChild === dropIconMap["hide"] && gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIconChild) eIcon.appendChild(eIconChild);
    }
    setLabel(label) {
        this.eLabel.textContent = label;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractLabel.css-GENERATED.ts
var $437b23f6a393c3bf$var$agAbstractLabelCSS = /*css*/ `.ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}`;
// packages/ag-grid-community/src/widgets/agAbstractLabel.ts
var $437b23f6a393c3bf$export$d72ea6e1c340e03b = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config, template, components){
        super(template, components);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
        this.registerCSS($437b23f6a393c3bf$var$agAbstractLabelCSS);
    }
    postConstruct() {
        this.addCss("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator: labelSeparator, label: label, labelWidth: labelWidth, labelAlignment: labelAlignment, disabled: disabled } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        const { label: label, eLabel: eLabel } = this;
        $437b23f6a393c3bf$export$69e6e10709eabd91(eLabel);
        if (typeof label === "string") eLabel.innerText = label + this.labelSeparator;
        else if (label) eLabel.appendChild(label);
        if (label === "") {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, false);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, "presentation");
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eLabel, true);
            $437b23f6a393c3bf$export$f8d01fa01787902(eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        const eLabel = this.eLabel;
        eLabel.id = eLabel.id || `ag-${this.getCompId()}-label`;
        return eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        $437b23f6a393c3bf$var$_setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractField.ts
var $437b23f6a393c3bf$var$AgAbstractField = class extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config, template, components, className){
        super(config, template, components);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width: width, value: value, onValueChange: onValueChange } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (this.className) this.addCss(this.className);
        this.refreshAriaLabelledBy();
    }
    setLabel(label) {
        super.setLabel(label);
        this.refreshAriaLabelledBy();
        return this;
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        const label = this.getLabel();
        if (label == null || label == "" || $437b23f6a393c3bf$var$_getAriaLabel(ariaEl) !== null) $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, "");
        else $437b23f6a393c3bf$export$84233c40c4c74001(ariaEl, labelId ?? "");
    }
    setAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListeners(this, {
            fieldValueChanged: ()=>callbackFn(this.getValue())
        });
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        $437b23f6a393c3bf$export$ce98ba7f5cfe7725(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        return this;
    }
};
// packages/ag-grid-community/src/widgets/agAbstractInputField.ts
function $437b23f6a393c3bf$var$buildTemplate(displayFieldTag) {
    return {
        tag: "div",
        role: "presentation",
        children: [
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-input-field-label"
            },
            {
                tag: "div",
                ref: "eWrapper",
                cls: "ag-wrapper ag-input-wrapper",
                role: "presentation",
                children: [
                    {
                        tag: displayFieldTag,
                        ref: "eInput",
                        cls: "ag-input-field-input"
                    }
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$export$9671f513d4aa42e3 = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, config?.template ?? $437b23f6a393c3bf$var$buildTemplate(displayFieldTag), [], className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType();
        const { eLabel: eLabel, eWrapper: eWrapper, eInput: eInput, className: className } = this;
        eLabel.classList.add(`${className}-label`);
        eWrapper.classList.add(`${className}-input-wrapper`);
        eInput.classList.add(`${className}-input`);
        this.addCss("ag-input-field");
        eInput.id = eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName: inputName, inputWidth: inputWidth } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        this.addInputListeners();
        this.activateTabIndex([
            eInput
        ]);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            input: (e)=>this.setValue(e.target.value)
        });
    }
    setInputType() {
        if (this.displayFieldTag === "input") this.eInput.setAttribute("type", this.inputType);
    }
    getInputElement() {
        return this.eInput;
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
// packages/ag-grid-community/src/widgets/agCheckbox.ts
var $437b23f6a393c3bf$export$b00c508c1ae18d07 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly: readOnly, passive: passive } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
    }
    addInputListeners() {
        this.addManagedElementListeners(this.eInput, {
            click: this.onCheckboxClick.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            click: this.toggle.bind(this)
        });
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        const eInput = this.eInput;
        eInput.checked = selected;
        eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchLocalEvent({
            type: "fieldValueChanged",
            selected: selected,
            previousValue: previousValue,
            event: event
        });
        const input = this.getInputElement();
        this.eventSvc.dispatchEvent({
            type: "checkboxChanged",
            id: input.id,
            name: input.name,
            selected: selected,
            previousValue: previousValue
        });
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        const classList = this.eWrapper.classList;
        classList.toggle("ag-checked", value === true);
        classList.toggle("ag-indeterminate", value == null);
    }
};
var $437b23f6a393c3bf$export$2e2c317d2e31f2ca = {
    selector: "AG-CHECKBOX",
    component: $437b23f6a393c3bf$export$b00c508c1ae18d07
};
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxCellRendererCSS = /*css*/ `.ag-checkbox-cell{height:100%}`;
// packages/ag-grid-community/src/rendering/cellRenderers/checkboxCellRenderer.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-checkbox-cell",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellRendererElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$checkboxCellRendererCSS);
    }
    init(params) {
        this.refresh(params);
        const { eCheckbox: eCheckbox, beans: beans } = this;
        const inputEl = eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        $437b23f6a393c3bf$var$_setAriaLive(inputEl, "polite");
        this.addManagedListeners(inputEl, {
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                if (eCheckbox.isDisabled()) return;
                const isSelected = eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
            },
            dblclick: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
            }
        });
        this.addManagedElementListeners(params.eGridCell, {
            keydown: (event)=>{
                if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE && !eCheckbox.isDisabled()) {
                    if (params.eGridCell === $437b23f6a393c3bf$export$16bc98d422315038(beans)) eCheckbox.toggle();
                    const isSelected = eCheckbox.getValue();
                    this.onCheckboxChanged(isSelected);
                    event.preventDefault();
                }
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        let isSelected;
        let displayed = true;
        const { value: value, column: column, node: node } = params;
        if (node.group && column) {
            if (typeof value === "boolean") isSelected = value;
            else {
                const colId = column.getColId();
                if (colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6)) isSelected = value == null || value === "" ? void 0 : value === "true";
                else if (node.aggData && node.aggData[colId] !== void 0) isSelected = value ?? void 0;
                else displayed = false;
            }
        } else isSelected = value ?? void 0;
        const { eCheckbox: eCheckbox } = this;
        if (!displayed) {
            eCheckbox.setDisplayed(false);
            return;
        }
        eCheckbox.setValue(isSelected);
        const disabled = params.disabled ?? !column?.isCellEditable(node);
        eCheckbox.setDisabled(disabled);
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { eventSvc: eventSvc, params: params } = this;
        const { column: column, node: node, value: value } = params;
        const sharedEventParams = {
            column: column,
            colDef: column.getColDef(),
            data: node.data,
            node: node,
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            value: value
        };
        eventSvc.dispatchEvent({
            type: "cellEditingStarted",
            ...sharedEventParams
        });
        const valueChanged = node.setDataValue(column, isSelected, "edit");
        eventSvc.dispatchEvent({
            type: "cellEditingStopped",
            ...sharedEventParams,
            oldValue: value,
            newValue: isSelected,
            valueChanged: valueChanged
        });
        if (!valueChanged) this.updateCheckbox(params);
    }
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowUtils.ts
var $437b23f6a393c3bf$var$PinnedRows = class {
    constructor(beans, floating){
        this.beans = beans;
        this.floating = floating;
        /** Canonical set of pinned nodes */ this.all = /* @__PURE__ */ new Set();
        /**
     * Set of nodes that should currently be visible given the context of the grid.
     * This is currently used for hiding leaf nodes in pivot mode and filtered nodes.
     */ this.visible = /* @__PURE__ */ new Set();
        /** Ordering of nodes in the pinned area */ this.order = [];
        /** IDs of nodes that need to be pinned once they are available from the row model (SSRM) */ this.queued = /* @__PURE__ */ new Set();
    }
    size() {
        return this.visible.size;
    }
    add(node) {
        const { all: all, visible: visible, order: order } = this;
        if (all.has(node)) return;
        all.add(node);
        visible.add(node);
        order.push(node);
        this.sort();
    }
    delete(item) {
        this.all.delete(item);
        this.visible.delete(item);
        this.queued.delete(item.id);
        $437b23f6a393c3bf$export$83a881c8b5120679(this.order, item);
    }
    has(item) {
        return this.visible.has(item);
    }
    forEach(fn) {
        this.order.forEach(fn);
    }
    getByIndex(i) {
        return this.order[i];
    }
    getById(id) {
        for (const node of this.visible){
            if (node.id == id) return node;
        }
    }
    clear() {
        const { all: all, visible: visible, order: order, queued: queued } = this;
        all.clear();
        queued.clear();
        visible.clear();
        order.length = 0;
    }
    sort() {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter } = this.beans;
        const sortOptions = sortSvc?.getSortOptions() ?? [];
        const grandTotalNode = $437b23f6a393c3bf$var$_removeGrandTotalRow(this.order);
        this.order.sort((a, b)=>(a.pinnedSibling?.rowIndex ?? 0) - (b.pinnedSibling?.rowIndex ?? 0));
        this.order = rowNodeSorter?.doFullSort(this.order, sortOptions) ?? this.order;
        if (!grandTotalNode) return;
        const grandTotalRow = this.beans.gos.get("grandTotalRow");
        if (grandTotalRow === "bottom" || grandTotalRow === "pinnedBottom") this.order.push(grandTotalNode);
        else this.order.unshift(grandTotalNode);
    }
    hide(shouldHide) {
        const { all: all, visible: visible } = this;
        all.forEach((node)=>shouldHide(node) ? visible.delete(node) : visible.add(node));
        this.order = Array.from(visible);
        this.sort();
    }
    queue(id) {
        this.queued.add(id);
    }
    unqueue(id) {
        this.queued.delete(id);
    }
    forEachQueued(fn) {
        this.queued.forEach(fn);
    }
};
function $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node) {
    if (node.level === -1) return true;
    const parent = node.parent;
    if (parent?.childrenAfterSort?.some((child)=>child == node)) return $437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(parent);
    return false;
}
function $437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node) {
    const { gos: gos, rowModel: rowModel, filterManager: filterManager } = beans;
    if ($437b23f6a393c3bf$export$cf1bac0013650216(gos, rowModel)) return !rowModel.getRowNode(node.id);
    if (filterManager?.isAnyFilterPresent()) return !$437b23f6a393c3bf$var$_isDisplayedAfterFilterCSRM(node);
    if (gos.get("pivotMode")) return !node.group;
    return false;
}
function $437b23f6a393c3bf$var$_isNodeGrandTotal(node) {
    return !!node.footer && node.level === -1;
}
function $437b23f6a393c3bf$var$_isPinnedNodeGrandTotal(node) {
    return !!node.pinnedSibling && $437b23f6a393c3bf$var$_isNodeGrandTotal(node.pinnedSibling);
}
function $437b23f6a393c3bf$var$_removeGrandTotalRow(order) {
    const index = order.findIndex($437b23f6a393c3bf$var$_isPinnedNodeGrandTotal);
    if (index > -1) return order.splice(index, 1)?.[0];
}
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRowModel.ts
var $437b23f6a393c3bf$var$ManualPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.top = new $437b23f6a393c3bf$var$PinnedRows(beans, "top");
        this.bottom = new $437b23f6a393c3bf$var$PinnedRows(beans, "bottom");
        const shouldHide = (node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(beans, node.pinnedSibling);
        const runIsRowPinned = ()=>{
            const isRowPinned = gos.get("isRowPinned");
            if (isRowPinned) beans.rowModel.forEachNode((node)=>this.pinRow(node, isRowPinned(node)), true);
            this.refreshRowPositions();
            this.dispatchRowPinnedEvents();
        };
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            modelUpdated: ()=>{
                this.tryToEmptyQueues();
                this.pinGrandTotalRow();
                this.forContainers((container)=>container.hide(shouldHide));
                this.refreshRowPositions();
                this.dispatchRowPinnedEvents();
            },
            columnRowGroupChanged: ()=>{
                this.forContainers($437b23f6a393c3bf$var$removeGroupRows);
                this.refreshRowPositions();
            },
            rowNodeDataChanged: ({ node: node })=>{
                const isRowPinnable = gos.get("isRowPinnable");
                const pinnable = isRowPinnable?.(node) ?? true;
                if (!pinnable) this.pinRow(node, null);
            },
            firstDataRendered: runIsRowPinned
        });
        this.addManagedPropertyListener("pivotMode", ()=>{
            this.forContainers((container)=>container.hide(shouldHide));
            this.dispatchRowPinnedEvents();
        });
        this.addManagedPropertyListener("grandTotalRow", ({ currentValue: currentValue })=>{
            this._grandTotalPinned = currentValue === "pinnedBottom" ? "bottom" : currentValue === "pinnedTop" ? "top" : null;
        });
        this.addManagedPropertyListener("isRowPinned", runIsRowPinned);
    }
    destroy() {
        this.reset(false);
        super.destroy();
    }
    reset(dispatch = true) {
        this.forContainers((container)=>{
            const nodesToUnpin = [];
            container.forEach((n)=>nodesToUnpin.push(n));
            nodesToUnpin.forEach((n)=>this.pinRow(n, null));
            container.clear();
        });
        if (dispatch) this.dispatchRowPinnedEvents();
    }
    pinRow(rowNode, float, column) {
        if (rowNode.footer && rowNode.level > -1) return;
        if (rowNode.footer && rowNode.level === -1) {
            this._grandTotalPinned = float;
            if ($437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, this.beans.rowModel)) this.beans.rowModel.refreshModel({
                step: "map"
            });
            return;
        }
        const currentFloat = rowNode.rowPinned ?? rowNode.pinnedSibling?.rowPinned;
        const switching = currentFloat != null && float != null && float != currentFloat;
        if (switching) {
            const pinned = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const source = rowNode.rowPinned ? rowNode.pinnedSibling : rowNode;
            this.pinRow(pinned, null, column);
            this.pinRow(source, float, column);
            return;
        }
        const spannedRows = column && $437b23f6a393c3bf$var$getSpannedRows(this.beans, rowNode, column);
        if (spannedRows) {
            spannedRows.forEach((node)=>this.pinRow(node, float));
            return;
        }
        if (float == null) {
            const node = rowNode.rowPinned ? rowNode : rowNode.pinnedSibling;
            const found = this.findPinnedRowNode(node);
            if (!found) return;
            found.delete(node);
            const source = node.pinnedSibling;
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(node);
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(source);
        } else {
            const sibling = $437b23f6a393c3bf$var$_createPinnedSibling(this.beans, rowNode, float);
            const container = this.getContainer(float);
            container.add(sibling);
            if ($437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, rowNode)) container.hide((node)=>$437b23f6a393c3bf$var$_shouldHidePinnedRows(this.beans, node.pinnedSibling));
            this.refreshRowPositions(float);
            this.dispatchRowPinnedEvents(rowNode);
        }
    }
    isManual() {
        return true;
    }
    isEmpty(floating) {
        return this.getContainer(floating).size() === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        this.bottom.forEach(updateRowHeight);
        rowTop = 0;
        this.top.forEach(updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    getPinnedTopTotalHeight() {
        const size = this.top.size();
        if (size === 0) return 0;
        const node = this.top.getByIndex(size - 1);
        if (node === void 0) return 0;
        return node.rowTop + node.rowHeight;
    }
    getPinnedBottomTotalHeight() {
        const size = this.bottom.size();
        if (size === 0) return 0;
        const node = this.bottom.getByIndex(size - 1);
        if (node === void 0) return 0;
        return node.rowTop + node.rowHeight;
    }
    getPinnedTopRowCount() {
        return this.top.size();
    }
    getPinnedBottomRowCount() {
        return this.bottom.size();
    }
    getPinnedTopRow(index) {
        return this.top.getByIndex(index);
    }
    getPinnedBottomRow(index) {
        return this.bottom.getByIndex(index);
    }
    getPinnedRowById(id, floating) {
        return this.getContainer(floating).getById(id);
    }
    forEachPinnedRow(floating, callback) {
        this.getContainer(floating).forEach(callback);
    }
    getPinnedState() {
        const buildState = (floating)=>{
            const list = [];
            this.forEachPinnedRow(floating, (node)=>list.push(node.pinnedSibling.id));
            return list;
        };
        return {
            top: buildState("top"),
            bottom: buildState("bottom")
        };
    }
    setPinnedState(state) {
        this.forContainers((pinned, floating)=>{
            for (const id of state[floating]){
                const node = this.beans.rowModel.getRowNode(id);
                if (node) this.pinRow(node, floating);
                else pinned.queue(id);
            }
        });
    }
    getGrandTotalPinned() {
        return this._grandTotalPinned;
    }
    setGrandTotalPinned(value) {
        this._grandTotalPinned = value;
    }
    tryToEmptyQueues() {
        this.forContainers((pinned, container)=>{
            const nodesToPin = /* @__PURE__ */ new Set();
            pinned.forEachQueued((id)=>{
                const node = this.beans.rowModel.getRowNode(id);
                if (node) nodesToPin.add(node);
            });
            for (const node of nodesToPin){
                pinned.unqueue(node.id);
                this.pinRow(node, container);
            }
        });
    }
    pinGrandTotalRow() {
        const rowModel = this.beans.rowModel;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, rowModel)) return;
        const sibling = rowModel.rootNode?.sibling;
        if (!sibling) return;
        const float = this._grandTotalPinned;
        const pinnedSibling = sibling.pinnedSibling;
        const container = pinnedSibling && this.findPinnedRowNode(pinnedSibling);
        if (!float) {
            if (!container) return;
            container.delete(pinnedSibling);
            $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
        } else {
            if (container && container.floating !== float) {
                container.delete(pinnedSibling);
                $437b23f6a393c3bf$var$_destroyRowNodeSibling(pinnedSibling);
            }
            if (!container || container.floating !== float) {
                const newPinnedSibling = $437b23f6a393c3bf$var$_createPinnedSibling(this.beans, sibling, float);
                this.getContainer(float).add(newPinnedSibling);
            }
        }
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            const estimateRowHeight = (rowNode)=>{
                rowNode.setRowHeight(rowNode.rowHeight, true);
            };
            this.forContainers((container)=>container.forEach(estimateRowHeight));
        }
    }
    getContainer(floating) {
        return floating === "top" ? this.top : this.bottom;
    }
    findPinnedRowNode(node) {
        if (this.top.has(node)) return this.top;
        if (this.bottom.has(node)) return this.bottom;
    }
    refreshRowPositions(floating) {
        const refreshAll = (pinned)=>$437b23f6a393c3bf$var$refreshRowPositions(this.beans, pinned);
        return floating == null ? this.forContainers(refreshAll) : refreshAll(this.getContainer(floating));
    }
    forContainers(fn) {
        fn(this.top, "top");
        fn(this.bottom, "bottom");
    }
    dispatchRowPinnedEvents(node) {
        this.eventSvc.dispatchEvent({
            type: "pinnedRowsChanged"
        });
        node?.dispatchRowEvent("rowPinned");
    }
};
function $437b23f6a393c3bf$var$refreshRowPositions(beans, container) {
    let rowTop = 0;
    container.forEach((node, index)=>{
        node.setRowTop(rowTop);
        if (node.rowHeightEstimated || node.rowHeight == null) node.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, node).height);
        node.setRowIndex(index);
        rowTop += node.rowHeight;
    });
}
function $437b23f6a393c3bf$var$_createPinnedSibling(beans, rowNode, floating) {
    if (rowNode.pinnedSibling) return rowNode.pinnedSibling;
    const sibling = $437b23f6a393c3bf$export$48fabbbfcde9fe36(rowNode, beans);
    sibling.setRowTop(null);
    sibling.setRowIndex(null);
    sibling.rowPinned = floating;
    const prefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
    sibling.id = `${prefix}${floating}-${rowNode.id}`;
    sibling.pinnedSibling = rowNode;
    rowNode.pinnedSibling = sibling;
    return sibling;
}
function $437b23f6a393c3bf$var$_destroyRowNodeSibling(rowNode) {
    if (!rowNode.pinnedSibling) return;
    rowNode.rowPinned = null;
    rowNode.setRowTop(null);
    rowNode.setRowIndex(null);
    const mainNode = rowNode.pinnedSibling;
    rowNode.pinnedSibling = void 0;
    if (mainNode) {
        mainNode.pinnedSibling = void 0;
        mainNode.rowPinned = null;
    }
}
function $437b23f6a393c3bf$var$removeGroupRows(set) {
    const rowsToRemove = /* @__PURE__ */ new Set();
    set.forEach((node)=>{
        if (node.group) rowsToRemove.add(node);
    });
    rowsToRemove.forEach((node)=>{
        set.delete(node);
    });
}
function $437b23f6a393c3bf$var$getSpannedRows(beans, rowNode, column) {
    const { rowSpanSvc: rowSpanSvc } = beans;
    const isCellSpanning = (column && rowSpanSvc?.isCellSpanning(column, rowNode)) ?? false;
    if (column && isCellSpanning) {
        const span = rowSpanSvc?.getCellSpan(column, rowNode);
        if (span) return Array.from(span.spannedNodes);
    }
}
// packages/ag-grid-community/src/pinnedRowModel/staticPinnedRowModel.ts
var $437b23f6a393c3bf$var$StaticPinnedRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.pinnedTopRows = {
            cache: {},
            order: []
        };
        this.pinnedBottomRows = {
            cache: {},
            order: []
        };
    }
    postConstruct() {
        const gos = this.gos;
        this.setPinnedRowData(gos.get("pinnedTopRowData"), "top");
        this.setPinnedRowData(gos.get("pinnedBottomRowData"), "bottom");
        this.addManagedPropertyListener("pinnedTopRowData", (e)=>this.setPinnedRowData(e.currentValue, "top"));
        this.addManagedPropertyListener("pinnedBottomRowData", (e)=>this.setPinnedRowData(e.currentValue, "bottom"));
        this.addManagedEventListeners({
            gridStylesChanged: this.onGridStylesChanges.bind(this)
        });
    }
    reset() {}
    isEmpty(floating) {
        return this.getCache(floating).order.length === 0;
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    isManual() {
        return false;
    }
    pinRow(_node, _container) {}
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            const estimateRowHeight = (rowNode)=>{
                rowNode.setRowHeight(rowNode.rowHeight, true);
            };
            $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, estimateRowHeight);
            $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, estimateRowHeight);
        }
    }
    ensureRowHeightsValid() {
        let anyChange = false;
        let rowTop = 0;
        const updateRowHeight = (rowNode)=>{
            if (rowNode.rowHeightEstimated) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                rowNode.setRowTop(rowTop);
                rowNode.setRowHeight(rowHeight.height);
                rowTop += rowHeight.height;
                anyChange = true;
            }
        };
        $437b23f6a393c3bf$var$forEach(this.pinnedBottomRows, updateRowHeight);
        rowTop = 0;
        $437b23f6a393c3bf$var$forEach(this.pinnedTopRows, updateRowHeight);
        this.eventSvc.dispatchEvent({
            type: "pinnedHeightChanged"
        });
        return anyChange;
    }
    setPinnedRowData(rowData, floating) {
        this.updateNodesFromRowData(rowData, floating);
        this.eventSvc.dispatchEvent({
            type: "pinnedRowDataChanged"
        });
    }
    /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */ updateNodesFromRowData(allData, floating) {
        const nodes = this.getCache(floating);
        if (allData === void 0) {
            nodes.order.length = 0;
            nodes.cache = {};
            return;
        }
        const getRowId = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const idPrefix = floating === "top" ? $437b23f6a393c3bf$export$27b0e4a919abc336 : $437b23f6a393c3bf$export$5f755686e611c1ea;
        const nodesToRemove = new Set(nodes.order);
        const newOrder = [];
        const dataIds = /* @__PURE__ */ new Set();
        let nextRowTop = 0;
        let i = -1;
        for (const data of allData){
            const id = getRowId?.({
                data: data,
                level: 0,
                rowPinned: floating
            }) ?? idPrefix + this.nextId++;
            if (dataIds.has(id)) {
                $437b23f6a393c3bf$export$545083624300f13d(96, {
                    id: id,
                    data: data
                });
                continue;
            }
            i++;
            dataIds.add(id);
            newOrder.push(id);
            const existingNode = $437b23f6a393c3bf$var$getById(nodes, id);
            if (existingNode !== void 0) {
                if (existingNode.data !== data) existingNode.updateData(data);
                nextRowTop += this.setRowTopAndRowIndex(existingNode, nextRowTop, i);
                nodesToRemove.delete(id);
            } else {
                const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                rowNode.id = id;
                rowNode.data = data;
                rowNode.rowPinned = floating;
                nextRowTop += this.setRowTopAndRowIndex(rowNode, nextRowTop, i);
                nodes.cache[id] = rowNode;
                nodes.order.push(id);
            }
        }
        nodesToRemove.forEach((id)=>{
            $437b23f6a393c3bf$var$getById(nodes, id)?.clearRowTopAndRowIndex();
            delete nodes.cache[id];
        });
        nodes.order = newOrder;
    }
    setRowTopAndRowIndex(rowNode, rowTop, rowIndex) {
        rowNode.setRowTop(rowTop);
        rowNode.setRowHeight($437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode).height);
        rowNode.setRowIndex(rowIndex);
        return rowNode.rowHeight;
    }
    getPinnedTopTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.pinnedTopRows);
    }
    getPinnedBottomTotalHeight() {
        return $437b23f6a393c3bf$var$getTotalHeight(this.pinnedBottomRows);
    }
    getPinnedTopRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedTopRows);
    }
    getPinnedBottomRowCount() {
        return $437b23f6a393c3bf$var$getSize(this.pinnedBottomRows);
    }
    getPinnedTopRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedTopRows, index);
    }
    getPinnedBottomRow(index) {
        return $437b23f6a393c3bf$var$getByIndex(this.pinnedBottomRows, index);
    }
    getPinnedRowById(id, floating) {
        return $437b23f6a393c3bf$var$getById(this.getCache(floating), id);
    }
    forEachPinnedRow(floating, callback) {
        return $437b23f6a393c3bf$var$forEach(this.getCache(floating), callback);
    }
    getCache(floating) {
        return floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
    }
    getPinnedState() {
        return {
            top: [],
            bottom: []
        };
    }
    setPinnedState() {}
    getGrandTotalPinned() {
        return;
    }
    setGrandTotalPinned() {}
};
function $437b23f6a393c3bf$var$getTotalHeight(rowNodes) {
    const size = $437b23f6a393c3bf$var$getSize(rowNodes);
    if (size === 0) return 0;
    const node = $437b23f6a393c3bf$var$getByIndex(rowNodes, size - 1);
    if (node === void 0) return 0;
    return node.rowTop + node.rowHeight;
}
function $437b23f6a393c3bf$var$getById(cache, id) {
    return cache.cache[id];
}
function $437b23f6a393c3bf$var$getByIndex(cache, i) {
    return $437b23f6a393c3bf$var$getById(cache, cache.order[i]);
}
function $437b23f6a393c3bf$var$forEach(cache, callback) {
    cache.order.forEach((id, index)=>{
        const node = $437b23f6a393c3bf$var$getById(cache, id);
        node && callback(node, index);
    });
}
function $437b23f6a393c3bf$var$getSize(cache) {
    return cache.order.length;
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModel.ts
var $437b23f6a393c3bf$export$d44126a5f53c99d9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedRowModel";
    }
    postConstruct() {
        const initialiseRowModel = ()=>{
            const enableRowPinning = this.gos.get("enableRowPinning");
            if (this.inner) this.destroyBean(this.inner);
            this.inner = this.createManagedBean(enableRowPinning ? new $437b23f6a393c3bf$var$ManualPinnedRowModel() : new $437b23f6a393c3bf$var$StaticPinnedRowModel());
        };
        this.addManagedPropertyListener("enableRowPinning", initialiseRowModel);
        initialiseRowModel();
    }
    reset() {
        return this.inner.reset();
    }
    isEmpty(container) {
        return this.inner.isEmpty(container);
    }
    isManual() {
        return this.inner.isManual();
    }
    isRowsToRender(container) {
        return this.inner.isRowsToRender(container);
    }
    pinRow(node, container, column) {
        return this.inner.pinRow(node, container, column);
    }
    ensureRowHeightsValid() {
        return this.inner.ensureRowHeightsValid();
    }
    getPinnedRowById(id, container) {
        return this.inner.getPinnedRowById(id, container);
    }
    getPinnedTopTotalHeight() {
        return this.inner.getPinnedTopTotalHeight();
    }
    getPinnedBottomTotalHeight() {
        return this.inner.getPinnedBottomTotalHeight();
    }
    getPinnedTopRowCount() {
        return this.inner.getPinnedTopRowCount();
    }
    getPinnedBottomRowCount() {
        return this.inner.getPinnedBottomRowCount();
    }
    getPinnedTopRow(index) {
        return this.inner.getPinnedTopRow(index);
    }
    getPinnedBottomRow(index) {
        return this.inner.getPinnedBottomRow(index);
    }
    forEachPinnedRow(container, callback) {
        return this.inner.forEachPinnedRow(container, callback);
    }
    getPinnedState() {
        return this.inner.getPinnedState();
    }
    setPinnedState(state) {
        return this.inner.setPinnedState(state);
    }
    setGrandTotalPinned(value) {
        return this.inner.setGrandTotalPinned(value);
    }
    getGrandTotalPinned() {
        return this.inner.getGrandTotalPinned();
    }
};
// packages/ag-grid-community/src/clientSideRowModel/abstractClientSideNodeManager.ts
var $437b23f6a393c3bf$var$ROOT_NODE_ID = "ROOT_NODE_ID";
var $437b23f6a393c3bf$export$4d7e4be6cbba058c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.nextId = 0;
        this.allNodesMap = {};
        this.rootNode = null;
    }
    get treeData() {
        return false;
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    extractRowData() {
        return this.rootNode?.allLeafChildren?.map((node)=>node.data);
    }
    activate(rootNode) {
        this.rootNode = rootNode;
        rootNode.group = true;
        rootNode.level = -1;
        rootNode.id = $437b23f6a393c3bf$var$ROOT_NODE_ID;
        rootNode.allLeafChildren = [];
        rootNode.childrenAfterGroup = [];
        rootNode.childrenAfterSort = [];
        rootNode.childrenAfterAggFilter = [];
        rootNode.childrenAfterFilter = [];
        this.updateRootSiblingArrays(rootNode);
    }
    deactivate() {
        if (this.rootNode) {
            this.allNodesMap = {};
            this.rootNode = null;
        }
    }
    destroy() {
        super.destroy();
        this.allNodesMap = {};
        this.rootNode = null;
    }
    setNewRowData(rowData) {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        this.dispatchRowDataUpdateStartedEvent(rowData);
        rootNode.childrenAfterFilter = null;
        rootNode.childrenAfterGroup = null;
        rootNode.childrenAfterAggFilter = null;
        rootNode.childrenAfterSort = null;
        rootNode.childrenMapped = null;
        rootNode.updateHasChildren();
        this.allNodesMap = {};
        this.nextId = 0;
        this.loadNewRowData(rowData);
        this.updateRootSiblingArrays(rootNode);
    }
    updateRootSiblingArrays(rootNode) {
        const sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterFilter = rootNode.childrenAfterFilter;
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
            sibling.childrenAfterSort = rootNode.childrenAfterSort;
            sibling.childrenMapped = rootNode.childrenMapped;
            sibling.allLeafChildren = rootNode.allLeafChildren;
        }
    }
    loadNewRowData(rowData) {
        this.rootNode.allLeafChildren = rowData?.map((dataItem, index)=>this.createRowNode(dataItem, index)) ?? [];
    }
    setImmutableRowData(params, rowData) {
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const reorder = !this.gos.get("suppressMaintainUnsortedOrder");
        const changedRowNodes = params.changedRowNodes;
        const processedNodes = /* @__PURE__ */ new Set();
        const rootNode = this.rootNode;
        const oldAllLeafChildren = rootNode.allLeafChildren;
        const oldAllLeafChildrenLen = oldAllLeafChildren.length;
        let nodesAdded = false;
        let nodesRemoved = false;
        let nodesUpdated = false;
        let orderChanged = false;
        for(let i = 0, prevSourceRowIndex = -1, len = rowData.length; i < len; i++){
            const data = rowData[i];
            let node = this.getRowNode(getRowIdFunc({
                data: data,
                level: 0
            }));
            if (!node) {
                nodesAdded = true;
                node = this.createRowNode(data, -1);
                changedRowNodes.add(node);
            } else {
                if (reorder) {
                    const sourceRowIndex = node.sourceRowIndex;
                    orderChanged || (orderChanged = sourceRowIndex <= prevSourceRowIndex || // A node was moved up, so order changed
                    nodesAdded);
                    prevSourceRowIndex = sourceRowIndex;
                }
                if (node.data !== data) {
                    nodesUpdated = true;
                    node.updateData(data);
                    changedRowNodes.update(node);
                }
            }
            processedNodes.add(node);
        }
        const nodesToUnselect = [];
        for(let i = 0; i < oldAllLeafChildrenLen; i++){
            const node = oldAllLeafChildren[i];
            if (!processedNodes.has(node)) {
                nodesRemoved = true;
                if (node.isSelected()) nodesToUnselect.push(node);
                if (node.pinnedSibling) this.beans.pinnedRowModel?.pinRow(node.pinnedSibling, null);
                this.rowNodeDeleted(node);
                changedRowNodes.remove(node);
            }
        }
        if (nodesAdded || nodesRemoved || orderChanged) {
            const newAllLeafChildren = new Array(processedNodes.size);
            let writeIdx = 0;
            if (!reorder) for(let i = 0; i < oldAllLeafChildrenLen; ++i){
                const node = oldAllLeafChildren[i];
                if (processedNodes.delete(node)) {
                    node.sourceRowIndex = writeIdx;
                    newAllLeafChildren[writeIdx++] = node;
                }
            }
            for (const node of processedNodes){
                node.sourceRowIndex = writeIdx;
                newAllLeafChildren[writeIdx++] = node;
            }
            rootNode.allLeafChildren = newAllLeafChildren;
            const sibling = rootNode.sibling;
            if (sibling) sibling.allLeafChildren = newAllLeafChildren;
            params.rowNodesOrderChanged || (params.rowNodesOrderChanged = orderChanged);
        }
        if (nodesAdded || nodesRemoved || orderChanged || nodesUpdated) {
            this.deselectNodes(nodesToUnselect);
            params.rowDataUpdated = true;
        }
    }
    /** Called when a node needs to be deleted */ rowNodeDeleted(node) {
        node.clearRowTopAndRowIndex();
        const id = node.id;
        const allNodesMap = this.allNodesMap;
        if (allNodesMap[id] === node) delete allNodesMap[id];
    }
    updateRowData(rowDataTran, changedRowNodes) {
        this.dispatchRowDataUpdateStartedEvent(rowDataTran.add);
        const updateRowDataResult = {
            changedRowNodes: changedRowNodes,
            rowNodeTransaction: {
                remove: [],
                update: [],
                add: []
            },
            rowsInserted: false
        };
        const nodesToUnselect = [];
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        this.executeRemove(getRowIdFunc, rowDataTran, updateRowDataResult, nodesToUnselect);
        this.executeUpdate(getRowIdFunc, rowDataTran, updateRowDataResult, nodesToUnselect);
        this.executeAdd(rowDataTran, updateRowDataResult);
        this.deselectNodes(nodesToUnselect);
        return updateRowDataResult;
    }
    executeAdd(rowDataTran, result) {
        const add = rowDataTran.add;
        if (!add?.length) return;
        let allLeafChildren = this.rootNode.allLeafChildren;
        let addIndex = allLeafChildren.length;
        if (typeof rowDataTran.addIndex === "number") {
            addIndex = this.sanitizeAddIndex(rowDataTran.addIndex);
            if (addIndex > 0) {
                const getDataPath = this.gos.get("treeData") && this.gos.get("getDataPath");
                if (getDataPath) for(let i = 0; i < allLeafChildren.length; i++){
                    const node = allLeafChildren[i];
                    if (node?.rowIndex == addIndex - 1) {
                        addIndex = i + 1;
                        break;
                    }
                }
            }
        }
        const addLength = add.length;
        const changedRowNodes = result.changedRowNodes;
        const newNodes = new Array(addLength);
        for(let i = 0; i < addLength; i++){
            const newNode = this.createRowNode(add[i], addIndex + i);
            changedRowNodes.add(newNode);
            newNodes[i] = newNode;
        }
        const rootNode = this.rootNode;
        if (addIndex < allLeafChildren.length) {
            const nodesBeforeIndex = allLeafChildren.slice(0, addIndex);
            const nodesAfterIndex = allLeafChildren.slice(addIndex, allLeafChildren.length);
            const nodesAfterIndexFirstIndex = nodesBeforeIndex.length + newNodes.length;
            for(let index = 0, length = nodesAfterIndex.length; index < length; ++index)nodesAfterIndex[index].sourceRowIndex = nodesAfterIndexFirstIndex + index;
            allLeafChildren = [
                ...nodesBeforeIndex,
                ...newNodes,
                ...nodesAfterIndex
            ];
            result.rowsInserted = true;
        } else allLeafChildren = allLeafChildren.concat(newNodes);
        rootNode.allLeafChildren = allLeafChildren;
        const sibling = rootNode.sibling;
        if (sibling) sibling.allLeafChildren = allLeafChildren;
        result.rowNodeTransaction.add = newNodes;
    }
    executeRemove(getRowIdFunc, rowDataTran, { changedRowNodes: changedRowNodes, rowNodeTransaction: rowNodeTransaction }, nodesToUnselect) {
        const { remove: remove } = rowDataTran;
        if (!remove?.length) return;
        const rowIdsRemoved = {};
        remove.forEach((item)=>{
            const rowNode = this.lookupRowNode(getRowIdFunc, item);
            if (!rowNode) return;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            if (rowNode.pinnedSibling) this.beans.pinnedRowModel?.pinRow(rowNode.pinnedSibling, null);
            rowNode.clearRowTopAndRowIndex();
            rowIdsRemoved[rowNode.id] = true;
            delete this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
            changedRowNodes.remove(rowNode);
        });
        const rootNode = this.rootNode;
        rootNode.allLeafChildren = rootNode.allLeafChildren?.filter((rowNode)=>!rowIdsRemoved[rowNode.id]) ?? null;
        rootNode.allLeafChildren?.forEach((node, idx)=>{
            node.sourceRowIndex = idx;
        });
        const sibling = rootNode.sibling;
        if (sibling) sibling.allLeafChildren = rootNode.allLeafChildren;
    }
    executeUpdate(getRowIdFunc, rowDataTran, { changedRowNodes: changedRowNodes, rowNodeTransaction: rowNodeTransaction }, nodesToUnselect) {
        const { update: update } = rowDataTran;
        if (!update?.length) return;
        update.forEach((item)=>{
            const rowNode = this.lookupRowNode(getRowIdFunc, item);
            if (!rowNode) return;
            rowNode.updateData(item);
            if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNodeTransaction.update.push(rowNode);
            changedRowNodes.update(rowNode);
        });
    }
    dispatchRowDataUpdateStartedEvent(rowData) {
        this.eventSvc.dispatchEvent({
            type: "rowDataUpdateStarted",
            firstRowData: rowData?.length ? rowData[0] : null
        });
    }
    deselectNodes(nodesToUnselect) {
        const source = "rowDataChanged";
        const selectionSvc = this.beans.selectionSvc;
        const selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) selectionSvc?.setNodesSelected({
            newValue: false,
            nodes: nodesToUnselect,
            suppressFinishActions: true,
            source: source
        });
        selectionSvc?.updateGroupsFromChildrenSelections?.(source);
        if (selectionChanged) this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: selectionSvc?.getSelectedNodes() ?? null,
            serverSideState: null
        });
    }
    sanitizeAddIndex(addIndex) {
        const allChildrenCount = this.rootNode.allLeafChildren?.length ?? 0;
        if (addIndex < 0 || addIndex >= allChildrenCount || Number.isNaN(addIndex)) return allChildrenCount;
        return Math.ceil(addIndex);
    }
    createRowNode(data, sourceRowIndex) {
        const node = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        node.parent = this.rootNode;
        node.level = 0;
        node.group = false;
        node.expanded = false;
        node.sourceRowIndex = sourceRowIndex;
        node.setDataAndId(data, String(this.nextId));
        if (this.allNodesMap[node.id]) $437b23f6a393c3bf$export$545083624300f13d(2, {
            nodeId: node.id
        });
        this.allNodesMap[node.id] = node;
        this.nextId++;
        return node;
    }
    lookupRowNode(getRowIdFunc, data) {
        let rowNode;
        if (getRowIdFunc) {
            const id = getRowIdFunc({
                data: data,
                level: 0
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                $437b23f6a393c3bf$export$a20c7248650823a9(4, {
                    id: id
                });
                return null;
            }
        } else {
            rowNode = this.rootNode?.allLeafChildren?.find((node)=>node.data === data);
            if (!rowNode) {
                $437b23f6a393c3bf$export$a20c7248650823a9(5, {
                    data: data
                });
                return null;
            }
        }
        return rowNode || null;
    }
};
// packages/ag-grid-community/src/interfaces/serverSideTransaction.ts
var $437b23f6a393c3bf$export$58e95be8934cbc38 = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})($437b23f6a393c3bf$export$58e95be8934cbc38 || {});
// packages/ag-grid-community/src/selection/checkboxSelectionComponent.ts
var $437b23f6a393c3bf$var$CheckboxSelectionComponentElement = {
    tag: "div",
    cls: "ag-selection-checkbox",
    role: "presentation",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxSelectionComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxSelectionComponentElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    getCheckboxId() {
        return this.eCheckbox.getInputElement().id;
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.getLocaleTextFunc();
        const { rowNode: rowNode, eCheckbox: eCheckbox } = this;
        const state = rowNode.isSelected();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        eCheckbox.setValue(state, true);
        eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListeners(this.eCheckbox.getInputElement(), {
            // we don't want double click on this icon to open a group
            dblclick: $437b23f6a393c3bf$export$456c40e80134d72a,
            click: (event)=>{
                $437b23f6a393c3bf$export$456c40e80134d72a(event);
                this.beans.selectionSvc?.handleSelectionEvent(event, this.rowNode, "checkboxSelected");
            }
        });
        this.addManagedListeners(this.rowNode, {
            rowSelected: this.onSelectionChanged.bind(this),
            dataChanged: this.onDataChanged.bind(this),
            selectableChanged: this.onSelectableChanged.bind(this)
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const curr = typeof currentValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(currentValue) : void 0;
            const prev = typeof previousValue === "object" ? $437b23f6a393c3bf$var$_getHideDisabledCheckboxes(previousValue) : void 0;
            if (curr !== prev) this.onSelectableChanged();
        });
        const isRowSelectableFunc = $437b23f6a393c3bf$export$351959be716b3b33(this.gos);
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedEventListeners({
                displayedColumnsChanged: showOrHideSelectListener
            });
            this.addManagedListeners(this.rowNode, {
                dataChanged: showOrHideSelectListener,
                cellChanged: showOrHideSelectListener
            });
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    showOrHideSelect() {
        const { column: column, rowNode: rowNode, overrides: overrides, gos: gos } = this;
        let selectable = rowNode.selectable;
        const isVisible = this.getIsVisible();
        if (selectable) {
            if (typeof isVisible === "function") {
                const extraParams = overrides?.callbackParams;
                if (!column) selectable = isVisible({
                    ...extraParams,
                    node: rowNode,
                    data: rowNode.data
                });
                else {
                    const params = column.createColumnFunctionCallbackParams(rowNode);
                    selectable = isVisible({
                        ...extraParams,
                        ...params
                    });
                }
            } else selectable = isVisible ?? false;
        }
        const so = gos.get("rowSelection");
        const disableInsteadOfHide = so && typeof so !== "string" ? !$437b23f6a393c3bf$var$_getHideDisabledCheckboxes(so) : column?.getColDef().showDisabledCheckboxes;
        if (disableInsteadOfHide) {
            this.eCheckbox.setDisabled(!selectable);
            this.setVisible(true);
            this.setDisplayed(true);
            return;
        }
        if (overrides?.removeHidden) {
            this.setDisplayed(selectable);
            return;
        }
        this.setVisible(selectable);
    }
    getIsVisible() {
        const overrides = this.overrides;
        if (overrides) return overrides.isVisible;
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") return $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
        return this.column?.getColDef()?.checkboxSelection;
    }
};
// packages/ag-grid-community/src/selection/rowRangeSelectionContext.ts
var $437b23f6a393c3bf$var$RowRangeSelectionContext = class {
    constructor(rowModel, pinnedRowModel){
        this.rowModel = rowModel;
        this.pinnedRowModel = pinnedRowModel;
        /** Whether the user is currently selecting all nodes either via the header checkbox or API */ this.selectAll = false;
        this.rootId = null;
        /**
     * Note that the "end" `RowNode` may come before or after the "root" `RowNode` in the
     * actual grid.
     */ this.endId = null;
        this.cachedRange = [];
    }
    reset() {
        this.rootId = null;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setRoot(node) {
        this.rootId = node.id;
        this.endId = null;
        this.cachedRange.length = 0;
    }
    setEndRange(end) {
        this.endId = end.id;
        this.cachedRange.length = 0;
    }
    getRange() {
        if (this.cachedRange.length === 0) {
            const root = this.getRoot();
            const end = this.getEnd();
            if (root == null || end == null) return this.cachedRange;
            this.cachedRange = this.getNodesInRange(root, end) ?? [];
        }
        return this.cachedRange;
    }
    isInRange(node) {
        if (this.rootId === null) return false;
        return this.getRange().some((nodeInRange)=>nodeInRange.id === node.id);
    }
    getRoot(fallback) {
        if (this.rootId) return this.getRowNode(this.rootId);
        if (fallback) {
            this.setRoot(fallback);
            return fallback;
        }
    }
    getEnd() {
        if (this.endId) return this.getRowNode(this.endId);
    }
    getRowNode(id) {
        let node;
        const { rowModel: rowModel, pinnedRowModel: pinnedRowModel } = this;
        node ?? (node = rowModel.getRowNode(id));
        if (pinnedRowModel?.isManual()) {
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "top"));
            node ?? (node = pinnedRowModel.getPinnedRowById(id, "bottom"));
        }
        return node;
    }
    /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ truncate(node) {
        const range = this.getRange();
        if (range.length === 0) return {
            keep: [],
            discard: []
        };
        const discardAfter = range[0].id === this.rootId;
        const idx = range.findIndex((rowNode)=>rowNode.id === node.id);
        if (idx > -1) {
            const above = range.slice(0, idx);
            const below = range.slice(idx + 1);
            this.setEndRange(node);
            return discardAfter ? {
                keep: above,
                discard: below
            } : {
                keep: below,
                discard: above
            };
        } else return {
            keep: range,
            discard: []
        };
    }
    /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */ extend(node, groupSelectsChildren = false) {
        const root = this.getRoot();
        if (root == null) {
            const keep = this.getRange().slice();
            if (groupSelectsChildren) node.depthFirstSearch((node2)=>!node2.group && keep.push(node2));
            keep.push(node);
            this.setRoot(node);
            return {
                keep: keep,
                discard: []
            };
        }
        const newRange = this.getNodesInRange(root, node);
        if (!newRange) {
            this.setRoot(node);
            return {
                keep: [
                    node
                ],
                discard: []
            };
        }
        if (newRange.find((newRangeNode)=>newRangeNode.id === this.endId)) {
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: []
            };
        } else {
            const discard = this.getRange().slice();
            this.setEndRange(node);
            return {
                keep: this.getRange(),
                discard: discard
            };
        }
    }
    getNodesInRange(start, end) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this;
        if (!pinnedRowModel?.isManual()) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            return pinnedRange.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), end) ?? []);
        }
        if (start.rowPinned === "bottom" && !end.rowPinned) {
            const pinnedRange = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const count = rowModel.getRowCount();
            const lastMain = rowModel.getRow(count - 1);
            return (rowModel.getNodesInRangeForSelection(end, lastMain) ?? []).concat(pinnedRange);
        }
        if (!start.rowPinned && !end.rowPinned) return rowModel.getNodesInRangeForSelection(start, end);
        if (start.rowPinned === "top" && end.rowPinned === "top") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, end);
        if (start.rowPinned === "bottom" && end.rowPinned === "top") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, start);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (!start.rowPinned && end.rowPinned === "top") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", end, void 0);
            return pinned.concat(rowModel.getNodesInRangeForSelection(rowModel.getRow(0), start) ?? []);
        }
        if (start.rowPinned === "top" && end.rowPinned === "bottom") {
            const top = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "top", start, void 0);
            const bottom = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const first = rowModel.getRow(0);
            const last = rowModel.getRow(rowModel.getRowCount() - 1);
            return top.concat(rowModel.getNodesInRangeForSelection(first, last) ?? []).concat(bottom);
        }
        if (start.rowPinned === "bottom" && end.rowPinned === "bottom") return $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", start, end);
        if (!start.rowPinned && end.rowPinned === "bottom") {
            const pinned = $437b23f6a393c3bf$var$_getNodesInRangeForSelection(pinnedRowModel, "bottom", void 0, end);
            const last = rowModel.getRow(rowModel.getRowCount());
            return (rowModel.getNodesInRangeForSelection(start, last) ?? []).concat(pinned);
        }
        return null;
    }
};
// packages/ag-grid-community/src/selection/selectAllFeature.ts
var $437b23f6a393c3bf$var$SelectAllFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        const cbSelectAll = this.createManagedBean(new $437b23f6a393c3bf$export$b00c508c1ae18d07());
        this.cbSelectAll = cbSelectAll;
        cbSelectAll.addCss("ag-header-select-all");
        $437b23f6a393c3bf$export$f8d01fa01787902(cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        const updateStateOfCheckbox = this.updateStateOfCheckbox.bind(this);
        this.addManagedEventListeners({
            newColumnsLoaded: ()=>this.showOrHideSelectAll(),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            selectionChanged: updateStateOfCheckbox,
            paginationChanged: updateStateOfCheckbox,
            modelUpdated: updateStateOfCheckbox
        });
        this.addManagedPropertyListener("rowSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            const getSelectAll = (rowSelection)=>typeof rowSelection === "string" || !rowSelection || rowSelection.mode === "singleRow" ? void 0 : rowSelection.selectAll;
            if (getSelectAll(currentValue) !== getSelectAll(previousValue)) this.showOrHideSelectAll();
            this.updateStateOfCheckbox();
        });
        this.addManagedListeners(cbSelectAll, {
            fieldValueChanged: this.onCbSelectAll.bind(this)
        });
        cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onDisplayedColumnsChanged(e) {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll(e.source === "uiColumnMoved");
    }
    showOrHideSelectAll(fromColumnMoved = false) {
        const cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAllVisible = cbSelectAllVisible;
        this.cbSelectAll.setDisplayed(cbSelectAllVisible);
        if (cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel(fromColumnMoved);
    }
    updateStateOfCheckbox() {
        if (!this.cbSelectAllVisible || this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const selectAllMode = this.getSelectAllMode();
        const selectionSvc = this.beans.selectionSvc;
        const cbSelectAll = this.cbSelectAll;
        const allSelected = selectionSvc.getSelectAllState(selectAllMode);
        cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = selectionSvc.hasNodesToSelect(selectAllMode);
        cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel(fromColumnMoved = false) {
        const translate = this.getLocaleTextFunc();
        const { headerCellCtrl: headerCellCtrl, cbSelectAll: cbSelectAll, cbSelectAllVisible: cbSelectAllVisible } = this;
        const checked = cbSelectAll.getValue();
        const ariaStatus = checked ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        headerCellCtrl.setAriaDescriptionProperty("selectAll", cbSelectAllVisible ? `${ariaLabel} (${ariaStatus})` : null);
        cbSelectAll.setInputAriaLabel(translate("ariaHeaderSelection", "Column with Header Selection"));
        if (!fromColumnMoved) headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
        if (!isMultiSelect) {
            $437b23f6a393c3bf$export$545083624300f13d(128, {
                feature: feature
            });
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        const rowModelMatches = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) || $437b23f6a393c3bf$export$cf1bac0013650216(gos);
        if (!rowModelMatches) {
            $437b23f6a393c3bf$export$545083624300f13d(129, {
                feature: feature,
                rowModel: rowModel.getType()
            });
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const selectAll2 = this.getSelectAllMode();
        let source = "uiSelectAll";
        if (selectAll2 === "currentPage") source = "uiSelectAllCurrentPage";
        else if (selectAll2 === "filtered") source = "uiSelectAllFiltered";
        const params = {
            source: source,
            selectAll: selectAll2
        };
        const selectionSvc = this.beans.selectionSvc;
        if (value) selectionSvc.selectAllRowNodes(params);
        else selectionSvc.deselectAllRowNodes(params);
    }
    /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */ isCheckboxSelection() {
        const { column: column, gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        const colDef = column.getColDef();
        const { headerCheckboxSelection: headerCheckboxSelection } = colDef;
        let result = false;
        const newHeaderCheckbox = typeof rowSelection === "object";
        if (newHeaderCheckbox) {
            const isSelectionCol = $437b23f6a393c3bf$export$f6074a9792015c5d(column);
            const isAutoCol = $437b23f6a393c3bf$export$61b34611dc010a97(column);
            const location = $437b23f6a393c3bf$export$8fb5d781b5c28347(rowSelection);
            if (location === "autoGroupColumn" && isAutoCol || isSelectionCol && beans.selectionColSvc?.isSelectionColumnEnabled()) result = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
        } else if (typeof headerCheckboxSelection === "function") result = headerCheckboxSelection($437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            column: column,
            colDef: colDef
        }));
        else result = !!headerCheckboxSelection;
        const featureName = newHeaderCheckbox ? "headerCheckbox" : "headerCheckboxSelection";
        return result && this.checkRightRowModelType(featureName) && this.checkSelectionType(featureName);
    }
    getSelectAllMode() {
        const selectAll2 = $437b23f6a393c3bf$var$_getSelectAll(this.gos, false);
        if (selectAll2) return selectAll2;
        const { headerCheckboxSelectionCurrentPageOnly: headerCheckboxSelectionCurrentPageOnly, headerCheckboxSelectionFilteredOnly: headerCheckboxSelectionFilteredOnly } = this.column.getColDef();
        if (headerCheckboxSelectionCurrentPageOnly) return "currentPage";
        if (headerCheckboxSelectionFilteredOnly) return "filtered";
        return "all";
    }
};
// packages/ag-grid-community/src/selection/baseSelectionService.ts
var $437b23f6a393c3bf$export$3d7b168c0c9c2a78 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const { gos: gos, beans: beans } = this;
        this.selectionCtx = new $437b23f6a393c3bf$var$RowRangeSelectionContext(beans.rowModel, beans.pinnedRowModel);
        this.addManagedPropertyListeners([
            "isRowSelectable",
            "rowSelection"
        ], ()=>{
            const callback = $437b23f6a393c3bf$export$351959be716b3b33(gos);
            if (callback !== this.isRowSelectable) {
                this.isRowSelectable = callback;
                this.updateSelectable();
            }
        });
        this.isRowSelectable = $437b23f6a393c3bf$export$351959be716b3b33(gos);
    }
    destroy() {
        super.destroy();
        this.selectionCtx.reset();
    }
    createCheckboxSelectionComponent() {
        return new $437b23f6a393c3bf$var$CheckboxSelectionComponent();
    }
    createSelectAllFeature(column) {
        return new $437b23f6a393c3bf$var$SelectAllFeature(column);
    }
    isMultiSelect() {
        return $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos);
    }
    onRowCtrlSelected(rowCtrl, hasFocusFunc, gui) {
        const selected = !!rowCtrl.rowNode.isSelected();
        rowCtrl.forEachGui(gui, (gui2)=>{
            gui2.rowComp.toggleCss("ag-row-selected", selected);
            const element = gui2.element;
            $437b23f6a393c3bf$export$c22e3722e8a33469(element, selected);
            const hasFocus = element.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans));
            if (hasFocus) hasFocusFunc(gui2);
        });
    }
    announceAriaRowSelection(rowNode) {
        if (this.isRowSelectionBlocked(rowNode)) return;
        const selected = rowNode.isSelected();
        if (!rowNode.selectable) return;
        const translate = this.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row`);
        this.beans.ariaAnnounce?.announceValue(label, "rowSelection");
    }
    isRowSelectionBlocked(rowNode) {
        return !rowNode.selectable || rowNode.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(rowNode) || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos);
    }
    updateRowSelectable(rowNode, suppressSelectionUpdate) {
        const selectable = this.isRowSelectable?.(rowNode) ?? true;
        this.setRowSelectable(rowNode, selectable, suppressSelectionUpdate);
        return selectable;
    }
    setRowSelectable(rowNode, newVal, suppressSelectionUpdate) {
        if (rowNode.selectable !== newVal) {
            rowNode.selectable = newVal;
            rowNode.dispatchRowEvent("selectableChanged");
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: selected ?? false,
                    source: "selectableChanged"
                });
                return;
            }
            if (rowNode.isSelected() && !rowNode.selectable) this.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    calculateSelectedFromChildren(rowNode) {
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        if (!rowNode.childrenAfterGroup?.length) return rowNode.selectable ? rowNode.__selected : null;
        for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const child = rowNode.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = this.calculateSelectedFromChildren(child);
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    return void 0;
            }
        }
        if (atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!rowNode.selectable) return null;
        return rowNode.__selected;
    }
    selectRowNode(rowNode, newValue, e, source = "api") {
        const selectionNotAllowed = !rowNode.selectable && newValue;
        const selectionNotChanged = rowNode.__selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        rowNode.__selected = newValue;
        rowNode.dispatchRowEvent("rowSelected");
        const sibling = rowNode.sibling;
        if (sibling && sibling.footer && sibling.__localEventService) sibling.dispatchRowEvent("rowSelected");
        const pinnedSibling = rowNode.pinnedSibling;
        if (pinnedSibling && pinnedSibling.rowPinned && pinnedSibling.__localEventService) pinnedSibling.dispatchRowEvent("rowSelected");
        this.eventSvc.dispatchEvent({
            ...$437b23f6a393c3bf$export$5c5bd6257397e1bc(rowNode, this.gos, "rowSelected"),
            event: e || null,
            source: source
        });
        return true;
    }
    isCellCheckboxSelection(column, rowNode) {
        const so = this.gos.get("rowSelection");
        if (so && typeof so !== "string") {
            const checkbox = $437b23f6a393c3bf$export$f6074a9792015c5d(column) && $437b23f6a393c3bf$export$6df3a55606bca6ae(so);
            return column.isColumnFunc(rowNode, checkbox);
        } else return column.isColumnFunc(rowNode, column.colDef.checkboxSelection);
    }
    inferNodeSelections(node, shiftKey, metaKey, source) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        const currentSelection = node.isSelected();
        const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        const enableClickSelection = $437b23f6a393c3bf$var$_getEnableSelection(gos);
        const enableDeselection = $437b23f6a393c3bf$var$_getEnableDeselection(gos);
        const isMultiSelect = this.isMultiSelect();
        const isRowClicked = source === "rowClicked";
        if (isRowClicked && !(enableClickSelection || enableDeselection)) return null;
        if (shiftKey && metaKey && isMultiSelect) {
            const root = selectionCtx.getRoot();
            if (!root) return null;
            else if (!root.isSelected()) {
                const partition = selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    select: [],
                    deselect: partition.keep,
                    reset: false
                };
            } else {
                const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
                return {
                    deselect: partition.discard,
                    select: partition.keep,
                    reset: false
                };
            }
        } else if (shiftKey && isMultiSelect) {
            const fallback = selectionCtx.selectAll ? this.beans.rowModel.getRow(0) : void 0;
            const root = selectionCtx.getRoot(fallback);
            const partition = selectionCtx.isInRange(node) ? selectionCtx.truncate(node) : selectionCtx.extend(node, groupSelectsDescendants);
            return {
                select: partition.keep,
                deselect: partition.discard,
                reset: selectionCtx.selectAll || !!(root && !root.isSelected())
            };
        } else if (metaKey) {
            if (isRowClicked) {
                const newValue = !currentSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                if (selectingWhenDisabled || deselectingWhenDisabled) return null;
                selectionCtx.setRoot(node);
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: false
                };
            }
            selectionCtx.setRoot(node);
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect
            };
        } else {
            selectionCtx.setRoot(node);
            const enableSelectionWithoutKeys = $437b23f6a393c3bf$var$_getEnableSelectionWithoutKeys(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            const shouldClear = isRowClicked && (!enableSelectionWithoutKeys || !enableClickSelection);
            if (groupSelectsFiltered && currentSelection === void 0 && $437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return {
                node: node,
                newValue: false,
                clearSelection: !isMultiSelect || shouldClear
            };
            if (isRowClicked) {
                const newValue = currentSelection ? !enableSelectionWithoutKeys : enableClickSelection;
                const selectingWhenDisabled = newValue && !enableClickSelection;
                const deselectingWhenDisabled = !newValue && !enableDeselection;
                const wouldStateBeUnchanged = newValue === currentSelection && !shouldClear;
                if (wouldStateBeUnchanged || selectingWhenDisabled || deselectingWhenDisabled) return null;
                return {
                    node: node,
                    newValue: newValue,
                    clearSelection: !isMultiSelect || shouldClear,
                    keepDescendants: node.group && groupSelectsDescendants
                };
            }
            return {
                node: node,
                newValue: !currentSelection,
                clearSelection: !isMultiSelect || shouldClear
            };
        }
    }
};
// packages/ag-grid-community/src/widgets/agRadioButton.ts
var $437b23f6a393c3bf$export$5caa9ea96bbb722 = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedEventListeners({
            checkboxChanged: this.onChange.bind(this)
        });
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        const eInput = this.eInput;
        if (event.selected && event.name && eInput.name && eInput.name === event.name && event.id && eInput.id !== event.id) this.setValue(false, true);
    }
};
// packages/ag-grid-community/src/widgets/agToggleButton.css-GENERATED.ts
var $437b23f6a393c3bf$var$agToggleButtonCSS = /*css*/ `.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}`;
// packages/ag-grid-community/src/widgets/agToggleButton.ts
var $437b23f6a393c3bf$export$167b21bf245ce0bf = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-toggle-button");
        this.registerCSS($437b23f6a393c3bf$var$agToggleButtonCSS);
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.toggleCss("ag-selected", this.getValue());
        return this;
    }
};
var $437b23f6a393c3bf$export$b825a5135f318030 = {
    selector: "AG-TOGGLE-BUTTON",
    component: $437b23f6a393c3bf$export$167b21bf245ce0bf
};
// packages/ag-grid-community/src/widgets/agInputTextField.ts
var $437b23f6a393c3bf$export$8c027679838afd47 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        const eInput = this.eInput;
        if (eInput.value !== value) eInput.value = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!$437b23f6a393c3bf$export$33ecd6e270298858(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListeners(this.eInput, {
            keydown: preventCharacters,
            paste: (e)=>{
                const text = e.clipboardData?.getData("text");
                if (text && text.split("").some((c)=>!pattern.test(c))) e.preventDefault();
            }
        });
    }
};
var $437b23f6a393c3bf$export$31e2985be4ee06ab = {
    selector: "AG-INPUT-TEXT-FIELD",
    component: $437b23f6a393c3bf$export$8c027679838afd47
};
// packages/ag-grid-community/src/widgets/agInputTextArea.ts
var $437b23f6a393c3bf$export$fd677433260ffbc8 = class extends $437b23f6a393c3bf$export$9671f513d4aa42e3 {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
var $437b23f6a393c3bf$var$AgInputTextAreaSelector = {
    selector: "AG-INPUT-TEXT-AREA",
    component: $437b23f6a393c3bf$export$fd677433260ffbc8
};
// packages/ag-grid-community/src/widgets/agInputNumberField.ts
var $437b23f6a393c3bf$export$c8aa0be99738aee = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        const eInput = this.eInput;
        this.addManagedListeners(eInput, {
            blur: ()=>{
                const floatedValue = parseFloat(eInput.value);
                const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
                if (this.value !== value) this.setValue(value);
            },
            wheel: this.onWheel.bind(this)
        });
        eInput.step = "any";
        const { precision: precision, min: min, max: max, step: step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        const val = parseFloat(value);
        const { min: min, max: max } = this;
        if (min != null && val < min) value = min.toString();
        else if (max != null && val > max) value = max.toString();
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        const precision = this.precision;
        if (precision == null) return value;
        if (isScientificNotation) {
            const floatString = parseFloat(value).toFixed(precision);
            return parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= precision) return value;
            else if (precision > 0) return `${parts[0]}.${parts[1].slice(0, precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue() {
        const eInput = this.eInput;
        if (!eInput.validity.valid) return void 0;
        const inputValue = eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
var $437b23f6a393c3bf$export$c18153c9c909b7d7 = {
    selector: "AG-INPUT-NUMBER-FIELD",
    component: $437b23f6a393c3bf$export$c8aa0be99738aee
};
// packages/ag-grid-community/src/utils/date.ts
function $437b23f6a393c3bf$var$_padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function $437b23f6a393c3bf$export$3d7fedfb21962874(date, includeTime = true, separator = "-") {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(separator);
    if (includeTime) serialised += " " + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>$437b23f6a393c3bf$var$_padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
var $437b23f6a393c3bf$var$calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
function $437b23f6a393c3bf$var$_dateToFormattedString(date, format = "YYYY-MM-DD") {
    const fullYear = $437b23f6a393c3bf$var$_padStartWidthZeros(date.getFullYear(), 4);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>months[date.getMonth()],
        MMM: ()=>months[date.getMonth()].slice(0, 3),
        MM: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${$437b23f6a393c3bf$var$calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDate())}`,
        DD: ()=>$437b23f6a393c3bf$var$_padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>days[date.getDay()],
        ddd: ()=>days[date.getDay()].slice(0, 3),
        dd: ()=>days[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function $437b23f6a393c3bf$export$26ded2d88c01b527(value) {
    if (!value) return null;
    const [dateStr, timeStr] = value.split(" ");
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    return date;
}
// packages/ag-grid-community/src/widgets/agInputDateField.ts
var $437b23f6a393c3bf$export$9e01ec8ba43de612 = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        const usingSafari = $437b23f6a393c3bf$var$_isBrowserSafari();
        this.addManagedListeners(this.eInput, {
            wheel: this.onWheel.bind(this),
            mousedown: ()=>{
                if (this.isDisabled() || usingSafari) return;
                this.eInput.focus();
            }
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if ($437b23f6a393c3bf$export$16bc98d422315038(this.beans) === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        const min = minDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(minDate ?? null, false) ?? void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        const max = maxDate instanceof Date ? $437b23f6a393c3bf$export$3d7fedfb21962874(maxDate ?? null, false) ?? void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$_addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    getDate() {
        if (!this.eInput.validity.valid) return void 0;
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.getValue()) ?? void 0;
    }
    setDate(date, silent) {
        this.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date ?? null, false), silent);
    }
};
var $437b23f6a393c3bf$var$AgInputDateFieldSelector = {
    selector: "AG-INPUT-DATE-FIELD",
    component: $437b23f6a393c3bf$export$9e01ec8ba43de612
};
// packages/ag-grid-community/src/tooltip/tooltipStateManager.ts
var $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF = 1e3;
var $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
var $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY = 100;
var $437b23f6a393c3bf$var$lastTooltipHideTime;
var $437b23f6a393c3bf$var$isLocked = false;
var $437b23f6a393c3bf$var$TooltipStateManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(tooltipCtrl, getTooltipValue){
        super();
        this.tooltipCtrl = tooltipCtrl;
        this.getTooltipValue = getTooltipValue;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
        this.userCompFactory = beans.userCompFactory;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.tooltipCtrl.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) this.addManagedListeners(el, {
            mouseenter: this.onMouseEnter.bind(this),
            mouseleave: this.onMouseLeave.bind(this)
        });
        if (this.tooltipTrigger === 1 /* FOCUS */ ) this.addManagedListeners(el, {
            focusin: this.onFocusIn.bind(this),
            focusout: this.onFocusOut.bind(this)
        });
        this.addManagedListeners(el, {
            mousemove: this.onMouseMove.bind(this)
        });
        if (!this.interactionEnabled) this.addManagedListeners(el, {
            mousedown: this.onMouseDown.bind(this),
            keydown: this.onKeyDown.bind(this)
        });
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        if (type === "show") return this.tooltipCtrl.getTooltipShowDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return this.tooltipCtrl.getTooltipHideDelayOverride?.() ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if ($437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        if ($437b23f6a393c3bf$var$isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.tooltipCtrl.getGui();
        const tooltipGui = this.tooltipComp?.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && tooltipGui?.contains(relatedTarget)) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        if (this.isInteractingWithTooltip) this.isInteractingWithTooltip = false;
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || $437b23f6a393c3bf$var$isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = Date.now();
        const then = $437b23f6a393c3bf$var$lastTooltipHideTime;
        return now - then < $437b23f6a393c3bf$var$SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing(fromHideTooltip) {
        if (!fromHideTooltip && this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        if (this.onColumnMovedEventCallback) {
            this.onColumnMovedEventCallback();
            this.onColumnMovedEventCallback = void 0;
        }
        if (this.onDocumentKeyDownCallback) {
            this.onDocumentKeyDownCallback();
            this.onDocumentKeyDownCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const value = this.getTooltipValue();
        const ctrl = this.tooltipCtrl;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) || ctrl.shouldDisplayTooltip && !ctrl.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        const rowNode = ctrl.getRowNode?.();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            location: ctrl.getLocation?.() ?? "UNKNOWN",
            //'cell',
            colDef: ctrl.getColDef?.(),
            column: ctrl.getColumn?.(),
            rowIndex: ctrl.getRowIndex?.(),
            node: rowNode,
            data: rowNode?.data,
            value: value,
            valueFormatted: ctrl.getValueFormatted?.(),
            hideTooltipCallback: ()=>this.hideTooltip(true),
            ...ctrl.getAdditionalParams?.() ?? {}
        });
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        const userDetails = $437b23f6a393c3bf$var$_getTooltipCompDetails(this.userCompFactory, params);
        userDetails?.newAgStackInstance().then(callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            $437b23f6a393c3bf$var$lastTooltipHideTime = Date.now();
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipHide",
            parentGui: this.tooltipCtrl.getGui()
        });
        if (forceHide) this.isInteractingWithTooltip = false;
        this.setToDoNothing(true);
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.getLocaleTextFunc();
        const addPopupRes = this.popupSvc?.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            const listener = ()=>this.setToDoNothing();
            [this.onBodyScrollEventCallback, this.onColumnMovedEventCallback] = this.addManagedEventListeners({
                bodyScroll: listener,
                columnMoved: listener
            });
        }
        if (this.interactionEnabled) {
            [this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(eGui, {
                mouseenter: this.onTooltipMouseEnter.bind(this),
                mouseleave: this.onTooltipMouseLeave.bind(this)
            });
            [this.onDocumentKeyDownCallback] = this.addManagedElementListeners($437b23f6a393c3bf$export$f63d0991874c6f81(this.beans), {
                keydown: (e)=>{
                    if (!eGui.contains(e?.target)) this.onKeyDown();
                }
            });
            if (this.tooltipTrigger === 1 /* FOCUS */ ) [this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(eGui, {
                focusin: this.onTooltipFocusIn.bind(this),
                focusout: this.onTooltipFocusOut.bind(this)
            });
        }
        this.eventSvc.dispatchEvent({
            type: "tooltipShow",
            tooltipGui: eGui,
            parentGui: this.tooltipCtrl.getGui()
        });
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    isTooltipFocused() {
        const tooltipGui = this.tooltipComp?.getGui();
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!tooltipGui && tooltipGui.contains(activeEl);
    }
    onTooltipFocusOut(e) {
        const parentGui = this.tooltipCtrl.getGui();
        if (this.isTooltipFocused()) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(e.relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupSvc?.positionPopupUnderMouseEvent({
            ...params,
            mouseEvent: this.lastMouseEvent
        });
        else this.popupSvc?.positionPopupByComponent({
            ...params,
            eventSource: this.tooltipCtrl.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        });
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? $437b23f6a393c3bf$var$FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ].forEach((listener)=>{
            if (listener) listener();
        });
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        $437b23f6a393c3bf$var$isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, $437b23f6a393c3bf$var$INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        $437b23f6a393c3bf$var$isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
// packages/ag-grid-community/src/tooltip/tooltipFeature.ts
function $437b23f6a393c3bf$export$58660753196c7cdf(gos) {
    return gos.get("tooltipShowMode") === "whenTruncated";
}
function $437b23f6a393c3bf$export$75f51ed61a5271e6(gos, getElement) {
    return $437b23f6a393c3bf$export$58660753196c7cdf(gos) ? $437b23f6a393c3bf$export$6682c04fc19b3e5e(getElement) : void 0;
}
function $437b23f6a393c3bf$export$6682c04fc19b3e5e(getElement) {
    return ()=>{
        const element = getElement();
        if (!element) return true;
        return element.scrollWidth > element.clientWidth;
    };
}
var $437b23f6a393c3bf$export$e5073a590d24815c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshTooltip();
    }
    setBrowserTooltip(tooltip) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && tooltip != "") eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        const { getTooltipValue: getTooltipValue } = this.ctrl;
        if (getTooltipValue) this.tooltip = getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        if (this.tooltipManager == null) this.tooltipManager = this.createBean(new $437b23f6a393c3bf$var$TooltipStateManager(this.ctrl, ()=>this.tooltip), this.beans.context);
    }
    setTooltipAndRefresh(tooltip) {
        this.tooltip = tooltip;
        this.refreshTooltip();
    }
    refreshTooltip() {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(null);
            this.createTooltipFeatureIfNeeded();
        }
    }
    destroy() {
        this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/agList.ts
var $437b23f6a393c3bf$var$AgList = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cssIdentifier = "default", unFocusable = false){
        super({
            tag: "div",
            cls: `ag-list ag-${cssIdentifier}-list`
        });
        this.cssIdentifier = cssIdentifier;
        this.unFocusable = unFocusable;
        this.activeClass = "ag-active-item";
        this.options = [];
        this.itemEls = [];
    }
    postConstruct() {
        const eGui = this.getGui();
        this.addManagedElementListeners(eGui, {
            mouseleave: ()=>this.clearHighlighted()
        });
        if (this.unFocusable) return;
        this.addManagedElementListeners(eGui, {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (!this.highlightedEl) this.setValue(this.getValue());
                else {
                    const pos = this.itemEls.indexOf(this.highlightedEl);
                    this.setValueByIndex(pos);
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    navigate(key) {
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let itemToHighlight;
        const { itemEls: itemEls, highlightedEl: highlightedEl } = this;
        if (!highlightedEl) itemToHighlight = itemEls[isDown ? 0 : itemEls.length - 1];
        else {
            const currentIdx = itemEls.indexOf(highlightedEl);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), itemEls.length - 1);
            itemToHighlight = itemEls[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        const { itemEls: itemEls, highlightedEl: highlightedEl } = this;
        if (!highlightedEl || itemEls.length === 0) return;
        const currentIdx = itemEls.indexOf(highlightedEl);
        const rowCount = this.options.length - 1;
        const itemHeight = itemEls[0].clientHeight;
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(itemEls[newIndex]);
    }
    addOptions(listOptions) {
        listOptions.forEach((listOption)=>this.addOption(listOption));
        return this;
    }
    addOption(listOption) {
        const { value: value, text: text } = listOption;
        const valueToRender = text ?? value;
        this.options.push({
            value: value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        this.itemEls.forEach((itemEl)=>{
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(itemEl);
        });
        this.itemEls = [];
        this.refreshAriaRole();
    }
    refreshAriaRole() {
        const eGui = this.getGui();
        $437b23f6a393c3bf$export$f8d01fa01787902(eGui, this.options.length === 0 ? "presentation" : "listbox");
    }
    updateIndices() {
        const options = this.getGui().querySelectorAll(".ag-list-item");
        this.refreshAriaRole();
        options.forEach((option, idx)=>{
            $437b23f6a393c3bf$export$c3d3aede41065a84(option, idx + 1);
            $437b23f6a393c3bf$export$3d494c2007bbcac1(option, options.length);
        });
    }
    renderOption(value, text) {
        const itemEl = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-list-item ag-${this.cssIdentifier}-list-item`,
            attrs: {
                role: "option"
            }
        });
        const span = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            children: text
        });
        itemEl.appendChild(span);
        if (!this.unFocusable) itemEl.tabIndex = -1;
        this.itemEls.push(itemEl);
        this.addManagedListeners(itemEl, {
            mouseover: ()=>this.highlightItem(itemEl),
            mousedown: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.setValue(value);
            }
        });
        this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            getTooltipValue: ()=>text,
            getGui: ()=>itemEl,
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        }));
        this.getGui().appendChild(itemEl);
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.itemEls[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.itemEls[idx]);
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    highlightItem(el) {
        if (!$437b23f6a393c3bf$export$2badf4aa566524cb(el)) return;
        this.clearHighlighted();
        this.highlightedEl = el;
        el.classList.add(this.activeClass);
        $437b23f6a393c3bf$export$c22e3722e8a33469(el, true);
        const eGui = this.getGui();
        const { scrollTop: scrollTop, clientHeight: clientHeight } = eGui;
        const { offsetTop: offsetTop, offsetHeight: offsetHeight } = el;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) el.scrollIntoView({
            block: "nearest"
        });
        if (!this.unFocusable) el.focus();
    }
    clearHighlighted() {
        const highlightedEl = this.highlightedEl;
        if (!highlightedEl || !$437b23f6a393c3bf$export$2badf4aa566524cb(highlightedEl)) return;
        highlightedEl.classList.remove(this.activeClass);
        $437b23f6a393c3bf$export$c22e3722e8a33469(highlightedEl, false);
        this.highlightedEl = null;
    }
    fireChangeEvent() {
        this.dispatchLocalEvent({
            type: "fieldValueChanged"
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchLocalEvent({
            type: "selectedItem"
        });
    }
};
// packages/ag-grid-community/src/widgets/agPickerField.css-GENERATED.ts
var $437b23f6a393c3bf$var$agPickerFieldCSS = /*css*/ `.ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-picker-button-background-color);border:var(--ag-picker-button-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:disabled{opacity:.5}&.ag-picker-has-focus,&:focus-within{background-color:var(--ag-picker-button-focus-background-color);border:var(--ag-picker-button-focus-border);box-shadow:var(--ag-focus-shadow)}}`;
// packages/ag-grid-community/src/widgets/agPickerField.ts
var $437b23f6a393c3bf$var$AgPickerFieldElement = {
    tag: "div",
    cls: "ag-picker-field",
    role: "presentation",
    children: [
        {
            tag: "div",
            ref: "eLabel"
        },
        {
            tag: "div",
            ref: "eWrapper",
            cls: "ag-wrapper ag-picker-field-wrapper ag-picker-collapsed",
            children: [
                {
                    tag: "div",
                    ref: "eDisplayField",
                    cls: "ag-picker-field-display"
                },
                {
                    tag: "div",
                    ref: "eIcon",
                    cls: "ag-picker-field-icon",
                    attrs: {
                        "aria-hidden": "true"
                    }
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$export$1f14489b6fdeb99b = class extends $437b23f6a393c3bf$var$AgAbstractField {
    constructor(config){
        super(config, config?.template || $437b23f6a393c3bf$var$AgPickerFieldElement, config?.agComponents || [], config?.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDisplayField = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eIcon = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.registerCSS($437b23f6a393c3bf$var$agPickerFieldCSS);
        this.ariaRole = config?.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap: pickerGap, maxPickerHeight: maxPickerHeight, variableWidth: variableWidth, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedElementListeners(ariaEl, {
            keydown: this.onKeyDown.bind(this)
        });
        this.addManagedElementListeners(this.eLabel, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        this.addManagedElementListeners(this.eWrapper, {
            mousedown: this.onLabelOrWrapperMouseDown.bind(this)
        });
        const { pickerIcon: pickerIcon, inputWidth: inputWidth } = this.config;
        if (pickerIcon) {
            const icon = $437b23f6a393c3bf$export$d8feba07bf373edb(pickerIcon, this.beans);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, false);
        if (this.ariaRole) $437b23f6a393c3bf$export$f8d01fa01787902(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && e?.target === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) [this.destroyMouseWheelFunc] = this.addManagedEventListeners({
            bodyScroll: ()=>{
                this.hidePicker();
            }
        });
        const translate = this.getLocaleTextFunc();
        const { config: { pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, modalPicker: modalPicker = true }, maxPickerHeight: maxPickerHeight, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth, variableWidth: variableWidth, beans: beans, eWrapper: eWrapper } = this;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const shouldRestoreFocus = $437b23f6a393c3bf$export$8ff9eef09a45371f(beans);
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue),
            anchorToElement: eWrapper
        };
        ePicker.style.position = "absolute";
        const popupSvc = beans.popupSvc;
        const addPopupRes = popupSvc.addPopup(popupParams);
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = $437b23f6a393c3bf$var$_formatSize($437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else $437b23f6a393c3bf$var$_setElementWidth(ePicker, maxPickerWidth ?? $437b23f6a393c3bf$export$642efcb17474eb51(eWrapper));
        const maxHeight = maxPickerHeight ?? `${$437b23f6a393c3bf$export$c20e968103d9c16e(popupSvc.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerGap: pickerGap, config: { pickerType: pickerType }, beans: { popupSvc: popupSvc, gos: gos }, eWrapper: eWrapper, pickerComponent: pickerComponent } = this;
        const alignSide = gos.get("enableRtl") ? "right" : "left";
        popupSvc.positionPopupByComponent({
            type: pickerType,
            eventSource: eWrapper,
            ePopup: pickerComponent.getGui(),
            position: "under",
            alignSide: alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        $437b23f6a393c3bf$export$3ad3518dddf15485(ariaEl, expanded);
        const classList = this.eWrapper.classList;
        classList.toggle("ag-picker-expanded", expanded);
        classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        if (!this.pickerComponent?.getGui().contains(e.relatedTarget)) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        this.hideCurrentPicker?.();
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$_setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/agSelect.css-GENERATED.ts
var $437b23f6a393c3bf$var$agSelectCSS = /*css*/ `.ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}`;
// packages/ag-grid-community/src/widgets/agSelect.ts
var $437b23f6a393c3bf$export$6f9c460854d56032 = class extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        super({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "selectOpen",
            ariaRole: "combobox",
            ...config
        });
        this.registerCSS($437b23f6a393c3bf$var$agSelectCSS);
    }
    postConstruct() {
        this.tooltipFeature = this.createOptionalManagedBean(this.beans.registry.createDynamicBean("tooltipFeature", false, {
            shouldDisplayTooltip: $437b23f6a393c3bf$export$6682c04fc19b3e5e(()=>this.eDisplayField),
            getGui: ()=>this.getGui()
        }));
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options: options, value: value, placeholder: placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedElementListeners(this.eWrapper, {
            focusout: this.onWrapperFocusOut.bind(this)
        });
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        const listComponent = this.createBean(new $437b23f6a393c3bf$var$AgList("select", true));
        this.listComponent = listComponent;
        listComponent.setParentComponent(this);
        const eListAriaEl = listComponent.getAriaElement();
        const listId = `ag-select-list-${listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        $437b23f6a393c3bf$export$26fd6a3f123d4e67(this.getAriaElement(), eListAriaEl);
        listComponent.addManagedElementListeners(listComponent.getGui(), {
            mousedown: (e)=>{
                e?.preventDefault();
            }
        });
        listComponent.addManagedListeners(listComponent, {
            selectedItem: ()=>{
                this.hidePicker();
                this.dispatchLocalEvent({
                    type: "selectedItem"
                });
            },
            fieldValueChanged: ()=>{
                if (!this.listComponent) return;
                this.setValue(this.listComponent.getValue(), false, true);
                this.hidePicker();
            }
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    onKeyDown(e) {
        const { key: key } = e;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.hidePicker();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) this.listComponent?.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                if (this.isPickerDisplayed) e.preventDefault();
                else super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        const listComponent = this.listComponent;
        if (!listComponent) return;
        super.showPicker();
        listComponent.refreshHighlighted();
    }
    addOptions(options) {
        options.forEach((option)=>this.addOption(option));
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        this.listComponent?.clearOptions();
        this.setValue(void 0, true);
        return this;
    }
    setValue(value, silent, fromPicker) {
        const { listComponent: listComponent, config: { placeholder: placeholder }, eDisplayField: eDisplayField, tooltipFeature: tooltipFeature } = this;
        if (this.value === value || !listComponent) return this;
        if (!fromPicker) listComponent.setValue(value, true);
        const newValue = listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = listComponent.getDisplayValue();
        if (displayValue == null && placeholder) displayValue = placeholder;
        eDisplayField.textContent = displayValue;
        tooltipFeature?.setTooltipAndRefresh(displayValue ?? null);
        return super.setValue(value, silent);
    }
    destroy() {
        this.listComponent = this.destroyBean(this.listComponent);
        super.destroy();
    }
};
var $437b23f6a393c3bf$export$e32612175ad118ef = {
    selector: "AG-SELECT",
    component: $437b23f6a393c3bf$export$6f9c460854d56032
};
// packages/ag-grid-community/src/widgets/tabGuardCtrl.ts
var $437b23f6a393c3bf$export$3be5727576441c72 = {
    TAB_GUARD: "ag-tab-guard",
    TAB_GUARD_TOP: "ag-tab-guard-top",
    TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
};
var $437b23f6a393c3bf$export$3074753638c3772c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        // Used when `isFocusableContainer` enabled
        this.allowFocus = false;
        const { comp: comp, eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, focusTrapActive: focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer, focusInnerElement: focusInnerElement, onFocusIn: onFocusIn, onFocusOut: onFocusOut, shouldStopEventPropagation: shouldStopEventPropagation, onTabKeyDown: onTabKeyDown, handleKeyDown: handleKeyDown, isEmpty: isEmpty, eFocusableElement: eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.isFocusableContainer = !!isFocusableContainer;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
        this.providedIsEmpty = isEmpty;
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eFocusableElement, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        [
            this.eTopGuard,
            this.eBottomGuard
        ].forEach((guard)=>this.addManagedElementListeners(guard, {
                focus: this.onFocus.bind(this)
            }));
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget)) {
            if (!this.allowFocus) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.providedIsEmpty ? this.providedIsEmpty() : $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget)) return;
        const fromBottom = e.target === this.eBottomGuard;
        const hasFocusedInnerElement = this.providedFocusInnerElement ? this.providedFocusInnerElement(fromBottom) : this.focusInnerElement(fromBottom);
        if (!hasFocusedInnerElement && this.forceFocusOutWhenTabGuardsAreEmpty) this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const focusableEls = $437b23f6a393c3bf$export$7acf44f59625b1f6(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = parseInt(a.getAttribute("tabindex") || "0");
            const indexB = parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0]?.focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive || this.forcingFocusOut) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        if (!this.isFocusableContainer) this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = $437b23f6a393c3bf$export$7acf44f59625b1f6(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(focusable.length - 1, 1);
        }
        if (!focusable.length) return false;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
        return true;
    }
    getNextFocusableElement(backwards) {
        return $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element, bottom) {
        return element === this.eTopGuard && !bottom || element === this.eBottomGuard && (bottom ?? true);
    }
    setAllowFocus(allowFocus) {
        this.allowFocus = allowFocus;
    }
};
// packages/ag-grid-community/src/widgets/tabGuardFeature.ts
var $437b23f6a393c3bf$export$299cbf451479e921 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp){
        super();
        this.comp = comp;
    }
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.comp.getFocusableElement();
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, eFocusableElement: eFocusableElement } = this;
        const tabGuards = [
            eTopGuard,
            eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                tabGuards.forEach((tabGuard)=>tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex"));
            }
        };
        this.addTabGuards(eTopGuard, eBottomGuard);
        const { focusTrapActive: focusTrapActive = false, onFocusIn: onFocusIn, onFocusOut: onFocusOut, focusInnerElement: focusInnerElement, handleKeyDown: handleKeyDown, onTabKeyDown: onTabKeyDown, shouldStopEventPropagation: shouldStopEventPropagation, isEmpty: isEmpty, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, isFocusableContainer: isFocusableContainer } = params;
        this.tabGuardCtrl = this.createManagedBean(new $437b23f6a393c3bf$export$3074753638c3772c({
            comp: compProxy,
            focusTrapActive: focusTrapActive,
            eTopGuard: eTopGuard,
            eBottomGuard: eBottomGuard,
            eFocusableElement: eFocusableElement,
            onFocusIn: onFocusIn,
            onFocusOut: onFocusOut,
            focusInnerElement: focusInnerElement,
            handleKeyDown: handleKeyDown,
            onTabKeyDown: onTabKeyDown,
            shouldStopEventPropagation: shouldStopEventPropagation,
            isEmpty: isEmpty,
            forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
            isFocusableContainer: isFocusableContainer
        }));
    }
    getTabGuardCtrl() {
        return this.tabGuardCtrl;
    }
    createTabGuard(side) {
        const tabGuard = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans).createElement("div");
        const cls = side === "top" ? $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_TOP : $437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD_BOTTOM;
        tabGuard.classList.add($437b23f6a393c3bf$export$3be5727576441c72.TAB_GUARD, cls);
        $437b23f6a393c3bf$export$f8d01fa01787902(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        const eFocusableElement = this.eFocusableElement;
        eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
        eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.comp.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(appendChild, newChild, container) {
        if (!$437b23f6a393c3bf$export$6e6303ef478b0c94(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
        else appendChild(newChild, container);
    }
    destroy() {
        const { eTopGuard: eTopGuard, eBottomGuard: eBottomGuard } = this;
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eTopGuard);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(eBottomGuard);
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/tabGuardComp.ts
var $437b23f6a393c3bf$export$5a26e3abd1c845b6 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    initialiseTabGuard(params) {
        this.tabGuardFeature = this.createManagedBean(new $437b23f6a393c3bf$export$299cbf451479e921(this));
        this.tabGuardFeature.initialiseTabGuard(params);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardFeature.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        this.tabGuardFeature.appendChild(super.appendChild.bind(this), newChild, container);
    }
};
// packages/ag-grid-community/src/widgets/popupComponent.ts
var $437b23f6a393c3bf$export$9fac2d040f3ed438 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCss("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp && parentComp.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// packages/ag-grid-community/src/widgets/touchListener.ts
var $437b23f6a393c3bf$export$7b2e93987414b382 = class {
    constructor(eElement, preventMouseClick = false){
        this.DOUBLE_TAP_MILLIS = 500;
        this.destroyFuncs = [];
        this.touching = false;
        this.localEventService = new $437b23f6a393c3bf$export$820da7696a401cdc();
        this.preventMouseClick = preventMouseClick;
        const startListener = this.onTouchStart.bind(this);
        const moveListener = this.onTouchMove.bind(this);
        const endListener = this.onTouchEnd.bind(this);
        eElement.addEventListener("touchstart", startListener, {
            passive: true
        });
        eElement.addEventListener("touchmove", moveListener, {
            passive: true
        });
        eElement.addEventListener("touchend", endListener, {
            passive: false
        });
        this.destroyFuncs.push(()=>{
            eElement.removeEventListener("touchstart", startListener, {
                passive: true
            });
            eElement.removeEventListener("touchmove", moveListener, {
                passive: true
            });
            eElement.removeEventListener("touchend", endListener, {
                passive: false
            });
        });
    }
    getActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            const matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) return touchList[i];
        }
        return null;
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touching) return;
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        const touchStartCopy = this.touchStart;
        window.setTimeout(()=>{
            const touchesMatch = this.touchStart === touchStartCopy;
            if (this.touching && touchesMatch && !this.moved) {
                this.moved = true;
                const event = {
                    type: "longTap",
                    touchStart: this.touchStart,
                    touchEvent: touchEvent
                };
                this.localEventService.dispatchEvent(event);
            }
        }, 500);
    }
    onTouchMove(touchEvent) {
        if (!this.touching) return;
        const touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) return;
        const eventIsFarAway = !$437b23f6a393c3bf$var$_areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) this.moved = true;
    }
    onTouchEnd(touchEvent) {
        if (!this.touching) return;
        if (!this.moved) {
            const event = {
                type: "tap",
                touchStart: this.touchStart
            };
            this.localEventService.dispatchEvent(event);
            this.checkForDoubleTap();
        }
        if (this.preventMouseClick && touchEvent.cancelable) touchEvent.preventDefault();
        this.touching = false;
    }
    checkForDoubleTap() {
        const now = Date.now();
        if (this.lastTapTime && this.lastTapTime > 0) {
            const interval = now - this.lastTapTime;
            if (interval > this.DOUBLE_TAP_MILLIS) {
                const event = {
                    type: "doubleTap",
                    touchStart: this.touchStart
                };
                this.localEventService.dispatchEvent(event);
                this.lastTapTime = null;
            } else this.lastTapTime = now;
        } else this.lastTapTime = now;
    }
    destroy() {
        this.destroyFuncs.forEach((func)=>func());
    }
};
// packages/ag-grid-community/src/interfaces/IRangeService.ts
var $437b23f6a393c3bf$export$162bc75b85f28397 = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})($437b23f6a393c3bf$export$162bc75b85f28397 || {});
// packages/ag-grid-community/src/vanillaFrameworkOverrides.ts
var $437b23f6a393c3bf$export$8174ad74937c6482 = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.batchFrameworkComps = false;
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
        this.baseDocLink = `${$437b23f6a393c3bf$var$BASE_URL}/${this.frameworkName}-data-grid`;
        $437b23f6a393c3bf$var$setValidationDocLink(this.baseDocLink);
    }
    setInterval(action, timeout) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            resolve(window.setInterval(action, timeout));
        });
    }
    // for Vanilla JS, we just add the event to the element
    addEventListener(element, type, listener, options) {
        let eventListenerOptions = {};
        if (typeof options === "object") eventListenerOptions = options;
        else if (typeof options === "boolean") eventListenerOptions = {
            capture: options
        };
        if (eventListenerOptions.passive == null) {
            const passive = $437b23f6a393c3bf$var$getPassiveStateForEvent(type);
            if (passive != null) eventListenerOptions.passive = passive;
        }
        element.addEventListener(type, listener, eventListenerOptions);
    }
    frameworkComponent(_) {
        return null;
    }
    isFrameworkComponent(_) {
        return false;
    }
    getDocLink(path) {
        return `${this.baseDocLink}${path ? `/${path}` : ""}`;
    }
};
// packages/ag-grid-community/src/api/apiUtils.ts
function $437b23f6a393c3bf$var$createGridApi(context) {
    return {
        beanName: "gridApi",
        bean: context.getBean("apiFunctionSvc").api
    };
}
// packages/ag-grid-community/src/context/gridBeanComparator.ts
var $437b23f6a393c3bf$var$orderedCoreBeans = [
    // Validate license first
    "licenseManager",
    // core beans only
    "environment",
    "eventSvc",
    "gos",
    "paginationAutoPageSizeSvc",
    "apiFunctionSvc",
    "gridApi",
    "registry",
    "agCompUtils",
    "userCompFactory",
    "rowContainerHeight",
    "horizontalResizeSvc",
    "localeSvc",
    "pinnedRowModel",
    "dragSvc",
    "colGroupSvc",
    "visibleCols",
    "popupSvc",
    "selectionSvc",
    "colFilter",
    "quickFilter",
    "filterManager",
    "colModel",
    "headerNavigation",
    "pageBounds",
    "pagination",
    "pageBoundsListener",
    "rowSpanSvc",
    "stickyRowSvc",
    "rowRenderer",
    "expressionSvc",
    "alignedGridsSvc",
    "navigation",
    "valueCache",
    "valueSvc",
    "autoWidthCalc",
    "filterMenuFactory",
    "dragAndDrop",
    "focusSvc",
    "cellNavigation",
    "cellStyles",
    "scrollVisibleSvc",
    "sortSvc",
    "colHover",
    "colAnimation",
    "autoColSvc",
    "selectionColSvc",
    "changeDetectionSvc",
    "animationFrameSvc",
    "undoRedo",
    "colDefFactory",
    "rowStyleSvc",
    "rowNodeBlockLoader",
    "rowNodeSorter",
    "ctrlsSvc",
    "pinnedCols",
    "dataTypeSvc",
    "syncSvc",
    "overlays",
    "stateSvc",
    "expansionSvc",
    "apiEventSvc",
    "ariaAnnounce",
    "menuSvc",
    "colMoves",
    "colAutosize",
    "colFlex",
    "colResize",
    "pivotColsSvc",
    "valueColsSvc",
    "rowGroupColsSvc",
    "funcColsSvc",
    "colNames",
    "colViewport",
    "pivotResultCols",
    "showRowGroupCols",
    "validation"
];
var $437b23f6a393c3bf$var$beanNamePosition = Object.fromEntries($437b23f6a393c3bf$var$orderedCoreBeans.map((beanName, index)=>[
        beanName,
        index
    ]));
function $437b23f6a393c3bf$var$gridBeanInitComparator(bean1, bean2) {
    const index1 = (bean1.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean1.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    const index2 = (bean2.beanName ? $437b23f6a393c3bf$var$beanNamePosition[bean2.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
    return index1 - index2;
}
function $437b23f6a393c3bf$var$gridBeanDestroyComparator(bean1, bean2) {
    if (bean1?.beanName === "gridDestroySvc") return -1;
    if (bean2?.beanName === "gridDestroySvc") return 1;
    return 0;
}
// packages/ag-grid-community/src/headerRendering/rowContainer/headerRowContainerComp.ts
var $437b23f6a393c3bf$var$PinnedLeftElement = {
    tag: "div",
    cls: "ag-pinned-left-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$PinnedRightElement = {
    tag: "div",
    cls: "ag-pinned-right-header",
    role: "rowgroup"
};
var $437b23f6a393c3bf$var$CenterElement = {
    tag: "div",
    cls: "ag-header-viewport",
    role: "presentation",
    attrs: {
        tabindex: "-1"
    },
    children: [
        {
            tag: "div",
            ref: "eCenterContainer",
            cls: "ag-header-container",
            role: "rowgroup"
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderRowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(pinned){
        super();
        this.eCenterContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    postConstruct() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$1e864ee88f54e7b(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? $437b23f6a393c3bf$var$PinnedLeftElement : pinnedRight ? $437b23f6a393c3bf$var$PinnedRightElement : $437b23f6a393c3bf$var$CenterElement;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer !== $437b23f6a393c3bf$export$6c811454646ed8be ? this.eCenterContainer : this.getGui();
    }
    destroy() {
        this.setCtrls([]);
        super.destroy();
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        this.eRowContainer.removeChild(rowComp.getGui());
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) $437b23f6a393c3bf$var$_ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        ctrls.forEach((ctrl)=>{
            const ctrlId = ctrl.instanceId;
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new $437b23f6a393c3bf$var$HeaderRowComp(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        });
        Object.values(oldRowComps).forEach((c)=>this.destroyRowComp(c));
    }
};
// packages/ag-grid-community/src/headerRendering/gridHeaderComp.ts
var $437b23f6a393c3bf$var$GridHeaderElement = {
    tag: "div",
    cls: "ag-header",
    role: "presentation"
};
var $437b23f6a393c3bf$var$GridHeaderComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$GridHeaderElement);
    }
    postConstruct() {
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.toggleCss(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$20b300eb69ca4d09());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("left"));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp(null));
        addContainer(new $437b23f6a393c3bf$var$HeaderRowContainerComp("right"));
    }
};
var $437b23f6a393c3bf$var$GridHeaderSelector = {
    selector: "AG-HEADER-ROOT",
    component: $437b23f6a393c3bf$var$GridHeaderComp
};
// packages/ag-grid-community/src/rendering/cell/cellComp.ts
var $437b23f6a393c3bf$var$CellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(beans, cellCtrl, printLayout, eRow, editingRow){
        super();
        this.cellCtrl = cellCtrl;
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.column = cellCtrl.column;
        this.rowNode = cellCtrl.rowNode;
        this.eRow = eRow;
        const cellDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: cellCtrl.getCellAriaRole(),
            attrs: {
                "comp-id": `${this.getCompId()}`,
                "col-id": cellCtrl.column.colIdSanitised
            }
        });
        this.eCell = cellDiv;
        let wrapperDiv;
        if (cellCtrl.isCellSpanning()) {
            wrapperDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-spanned-cell-wrapper",
                role: "presentation"
            });
            wrapperDiv.appendChild(cellDiv);
            this.setTemplateFromElement(wrapperDiv);
        } else this.setTemplateFromElement(cellDiv);
        this.cellCssManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>cellDiv);
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const compProxy = {
            toggleCss: (cssClassName, on)=>this.cellCssManager.toggleCss(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(cellDiv, styles),
            getFocusableElement: ()=>cellDiv,
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue()
        };
        cellCtrl.setComp(compProxy, cellDiv, wrapperDiv, this.eCellWrapper, printLayout, editingRow, void 0);
    }
    getParentOfValue() {
        return this.eCellValue ?? this.eCellWrapper ?? this.eCell;
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        const context = this.beans.context;
        this.checkboxSelectionComp = context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            this.eCellWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-cell-wrapper",
                role: "presentation"
            });
            this.eCell.appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.cellCssManager.toggleCss("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            this.eCellValue = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "span",
                cls: "ag-cell-value",
                role: "presentation"
            });
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing && providingControls) this.addControls();
        return templateChanged;
    }
    addControls() {
        const { cellCtrl: cellCtrl, eCellWrapper: eCellWrapper, eCellValue: eCellValue, includeRowDrag: includeRowDrag, includeDndSource: includeDndSource, includeSelection: includeSelection } = this;
        const insertBefore = (comp)=>{
            if (comp) eCellWrapper.insertBefore(comp.getGui(), eCellValue);
        };
        if (includeRowDrag && this.rowDraggingComp == null) {
            this.rowDraggingComp = cellCtrl.createRowDragComp();
            insertBefore(this.rowDraggingComp);
        }
        if (includeDndSource && this.dndSourceComp == null) {
            this.dndSourceComp = cellCtrl.createDndSource();
            insertBefore(this.dndSourceComp);
        }
        if (includeSelection && this.checkboxSelectionComp == null) {
            this.checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            insertBefore(this.checkboxSelectionComp);
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        const { params: params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = $437b23f6a393c3bf$export$672d9e47bc342bac(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
        const escapedValue = $437b23f6a393c3bf$export$a16cfb6652fe466f(valueToDisplay);
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyRenderer() {
        const { context: context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context: context } = this.beans;
        const recoverFocus = this.cellEditorPopupWrapper?.getGui().contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans)) || this.cellCtrl.hasBrowserFocus();
        if (recoverFocus) this.eCell.focus({
            preventScroll: true
        });
        this.hideEditorPopup?.();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.cellEditorGui);
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer?.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const displayComponentVersionCopy = this.rendererVersion;
        const { componentClass: componentClass } = compDetails;
        const createCellRendererFunc = ()=>{
            const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
            if (staleTask) return;
            const componentPromise = compDetails.newAgStackInstance();
            const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, componentClass);
            componentPromise?.then(callback);
        };
        const { animationFrameSvc: animationFrameSvc } = this.beans;
        if (animationFrameSvc?.active && this.firstRender) animationFrameSvc.createTask(createCellRendererFunc, this.rowNode.rowIndex, "p2", compDetails.componentFromFramework);
        else createCellRendererFunc();
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        const cellGui = cellRenderer.getGui();
        this.cellRendererGui = cellGui;
        if (cellGui != null) {
            const eParent = this.getParentOfValue();
            $437b23f6a393c3bf$export$69e6e10709eabd91(eParent);
            eParent.appendChild(cellGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        const { context: context } = this.beans;
        if (staleComp) {
            context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
        if (editingCancelledByUserComp) {
            context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            $437b23f6a393c3bf$export$545083624300f13d(97, {
                colId: this.column.getId()
            });
            context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup !== void 0 && cellEditor.isPopup();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        cellEditor.afterGuiAttached?.();
        this.cellCtrl.cellEditorAttached();
    }
    refreshEditStyles(editing, isPopup) {
        const { cellCssManager: cellCssManager } = this;
        cellCssManager.toggleCss("ag-cell-inline-editing", editing && !isPopup);
        cellCssManager.toggleCss("ag-cell-popup-editing", editing && !!isPopup);
        cellCssManager.toggleCss("ag-cell-not-inline-editing", !editing || !!isPopup);
        this.cellCtrl.setInlineEditingCss();
    }
    addInCellEditor() {
        const { eCell: eCell } = this;
        if (eCell.contains($437b23f6a393c3bf$export$16bc98d422315038(this.beans))) eCell.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getParentOfValue());
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        const { gos: gos, context: context, editSvc: editSvc, popupSvc: popupSvc, localeSvc: localeSvc } = this.beans;
        if (gos.get("editType") === "fullRow") $437b23f6a393c3bf$export$545083624300f13d(98);
        const cellEditor = this.cellEditor;
        this.cellEditorPopupWrapper = context.createBean(editSvc.createPopupEditorWrapper(params));
        const ePopupGui = this.cellEditorPopupWrapper.getGui();
        if (this.cellEditorGui) ePopupGui.appendChild(this.cellEditorGui);
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition?.() ?? "over";
        const isRtl = gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            column: this.column,
            rowNode: this.rowNode,
            type: "popupCellEditor",
            eventSource: this.eCell,
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupSvc.positionPopupByComponent.bind(popupSvc, positionParams);
        const translate = $437b23f6a393c3bf$export$cc0bf4adff5b95e7(localeSvc);
        const addPopupRes = popupSvc.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: this.eCell,
            positionCallback: positionCallback,
            ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.eRow.removeChild(this.getGui());
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.cellCtrl.stopEditing();
        this.destroyRenderer();
        this.destroyEditor();
        this.removeControls();
        super.destroy();
    }
};
// packages/ag-grid-community/src/rendering/row/rowComp.ts
var $437b23f6a393c3bf$var$RowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = /* @__PURE__ */ new Map();
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            role: "row",
            attrs: {
                "comp-id": `${this.getCompId()}`
            }
        });
        this.setInitialStyle(rowDiv, containerType);
        this.setTemplateFromElement(rowDiv);
        const style = rowDiv.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.fullWidthCellRenderer,
            toggleCss: (name, on)=>this.toggleCss(name, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$_addStylesToElement(rowDiv, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>rowDiv.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>rowDiv.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>rowDiv.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>this.fullWidthCellRenderer?.refresh?.(getUpdatedParams()) ?? false
        };
        ctrl.setComp(compProxy, this.getGui(), containerType, void 0);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    setInitialStyle(container, containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        if (transform) container.style.setProperty("transform", transform);
        else {
            const top = this.rowCtrl.getInitialRowTop(containerType);
            if (top) container.style.setProperty("top", top);
        }
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = new Map(this.cellComps);
        for (const cellCtrl of cellCtrls){
            const key = cellCtrl.instanceId;
            if (!this.cellComps.has(key)) this.newCellComp(cellCtrl);
            else cellsToRemove.delete(key);
        }
        this.destroyCells(cellsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        for (const cellCtrl of cellCtrls){
            const cellComp = this.cellComps.get(cellCtrl.instanceId);
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        }
        $437b23f6a393c3bf$var$_setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const cellComp = new $437b23f6a393c3bf$var$CellComp(this.beans, cellCtrl, this.rowCtrl.printLayout, this.getGui(), this.rowCtrl.editing);
        this.cellComps.set(cellCtrl.instanceId, cellComp);
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyCells(this.cellComps);
    }
    setFullWidthRowComp(fullWidthRowComponent) {
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
        });
    }
    destroyCells(cellComps) {
        for (const cellComp of cellComps.values()){
            if (!cellComp) return;
            const instanceId = cellComp.cellCtrl.instanceId;
            if (this.cellComps.get(instanceId) !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps.delete(instanceId);
        }
    }
};
// packages/ag-grid-community/src/gridBodyComp/rowContainer/rowContainerComp.ts
function $437b23f6a393c3bf$var$getElementParams(name, options, beans) {
    const isCellSpanning = !!beans.gos.get("enableCellSpan") && !!options.getSpannedRowCtrls;
    const eContainerElement = {
        tag: "div",
        ref: "eContainer",
        cls: $437b23f6a393c3bf$export$35e1b2dddf7fc6e9(name),
        role: "rowgroup"
    };
    if (options.type === "center" || isCellSpanning) {
        const eSpannedContainerElement = {
            tag: "div",
            ref: "eSpannedContainer",
            cls: `ag-spanning-container ${$437b23f6a393c3bf$export$cd6b90bdf6c4fcfd(name)}`,
            role: "rowgroup"
        };
        return {
            tag: "div",
            ref: "eViewport",
            cls: `ag-viewport ${$437b23f6a393c3bf$export$65619730ec980d6a(name)}`,
            role: "presentation",
            children: [
                eContainerElement,
                isCellSpanning ? eSpannedContainerElement : null
            ]
        };
    }
    return eContainerElement;
}
var $437b23f6a393c3bf$var$RowContainerComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params){
        super();
        this.eViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSpannedContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rowCompsNoSpan = {};
        this.rowCompsWithSpan = {};
        this.name = params?.name;
        this.options = $437b23f6a393c3bf$export$a46aad9f8c79261f(this.name);
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$getElementParams(this.name, this.options, this.beans));
        const compProxy = {
            setHorizontalScroll: (offset)=>this.eViewport.scrollLeft = offset,
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls: rowCtrls })=>this.setRowCtrls(rowCtrls),
            setSpannedRowCtrls: (rowCtrls)=>this.setRowCtrls(rowCtrls, true),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>{
                this.eContainer.style.width = width;
                if (this.eSpannedContainer) this.eSpannedContainer.style.width = width;
            },
            setOffsetTop: (offset)=>{
                const top = `translateY(${offset})`;
                this.eContainer.style.transform = top;
                if (this.eSpannedContainer) this.eSpannedContainer.style.transform = top;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$2d4385f6f566fe5e(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eSpannedContainer, this.eViewport);
    }
    destroy() {
        this.setRowCtrls([]);
        this.setRowCtrls([], true);
        super.destroy();
        this.lastPlacedElement = null;
    }
    setRowCtrls(rowCtrls, spanContainer) {
        const { beans: beans, options: options } = this;
        const container = spanContainer ? this.eSpannedContainer : this.eContainer;
        const oldRows = spanContainer ? {
            ...this.rowCompsWithSpan
        } : {
            ...this.rowCompsNoSpan
        };
        const newComps = {};
        if (spanContainer) this.rowCompsWithSpan = newComps;
        else this.rowCompsNoSpan = newComps;
        this.lastPlacedElement = null;
        const orderedRows = [];
        for (const rowCtrl of rowCtrls){
            const instanceId = rowCtrl.instanceId;
            const existingRowComp = oldRows[instanceId];
            let rowComp;
            if (existingRowComp) {
                rowComp = existingRowComp;
                delete oldRows[instanceId];
            } else {
                if (!rowCtrl.rowNode.displayed) continue;
                rowComp = new $437b23f6a393c3bf$var$RowComp(rowCtrl, beans, options.type);
            }
            newComps[instanceId] = rowComp;
            orderedRows.push([
                rowComp,
                !existingRowComp
            ]);
        }
        this.removeOldRows(Object.values(oldRows), container);
        this.addRowNodes(orderedRows, container);
    }
    addRowNodes(rows, container) {
        const { domOrder: domOrder } = this;
        for (const [rowComp, isNew] of rows){
            const eGui = rowComp.getGui();
            if (!domOrder) {
                if (isNew) container.appendChild(eGui);
            } else this.ensureDomOrder(eGui, container);
        }
    }
    removeOldRows(rowComps, container) {
        for (const oldRowComp of rowComps){
            container.removeChild(oldRowComp.getGui());
            oldRowComp.destroy();
        }
    }
    ensureDomOrder(eRow, container) {
        $437b23f6a393c3bf$var$_ensureDomOrder(container, eRow, this.lastPlacedElement);
        this.lastPlacedElement = eRow;
    }
};
var $437b23f6a393c3bf$var$RowContainerSelector = {
    selector: "AG-ROW-CONTAINER",
    component: $437b23f6a393c3bf$var$RowContainerComp
};
// packages/ag-grid-community/src/gridBodyComp/gridBodyComp.ts
function $437b23f6a393c3bf$var$makeRowContainers(paramsMap, names) {
    return names.map((name)=>{
        const refName = `e${name[0].toUpperCase() + name.substring(1)}RowContainer`;
        paramsMap[refName] = {
            name: name
        };
        return {
            tag: "ag-row-container",
            ref: refName,
            attrs: {
                name: name
            }
        };
    });
}
function $437b23f6a393c3bf$var$getGridBodyTemplate(includeOverlay) {
    const paramsMap = {};
    const elementParams = {
        tag: "div",
        ref: "eGridRoot",
        cls: "ag-root ag-unselectable",
        children: [
            {
                tag: "ag-header-root"
            },
            {
                tag: "div",
                ref: "eTop",
                cls: "ag-floating-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "topLeft",
                    "topCenter",
                    "topRight",
                    "topFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBody",
                cls: "ag-body",
                role: "presentation",
                children: [
                    {
                        tag: "div",
                        ref: "eBodyViewport",
                        cls: "ag-body-viewport",
                        role: "presentation",
                        children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                            "left",
                            "center",
                            "right",
                            "fullWidth"
                        ])
                    },
                    {
                        tag: "ag-fake-vertical-scroll"
                    }
                ]
            },
            {
                tag: "div",
                ref: "eStickyTop",
                cls: "ag-sticky-top",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyTopLeft",
                    "stickyTopCenter",
                    "stickyTopRight",
                    "stickyTopFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eStickyBottom",
                cls: "ag-sticky-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "stickyBottomLeft",
                    "stickyBottomCenter",
                    "stickyBottomRight",
                    "stickyBottomFullWidth"
                ])
            },
            {
                tag: "div",
                ref: "eBottom",
                cls: "ag-floating-bottom",
                role: "presentation",
                children: $437b23f6a393c3bf$var$makeRowContainers(paramsMap, [
                    "bottomLeft",
                    "bottomCenter",
                    "bottomRight",
                    "bottomFullWidth"
                ])
            },
            {
                tag: "ag-fake-horizontal-scroll"
            },
            includeOverlay ? {
                tag: "ag-overlay-wrapper"
            } : null
        ]
    };
    return {
        paramsMap: paramsMap,
        elementParams: elementParams
    };
}
var $437b23f6a393c3bf$var$GridBodyComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.eGridRoot = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBodyViewport = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eStickyBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eTop = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBottom = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eBody = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    postConstruct() {
        const { overlays: overlays, rangeSvc: rangeSvc } = this.beans;
        const overlaySelector = overlays?.getOverlayWrapperSelector();
        const { paramsMap: paramsMap, elementParams: elementParams } = $437b23f6a393c3bf$var$getGridBodyTemplate(!!overlaySelector);
        this.setTemplate(elementParams, [
            ...overlaySelector ? [
                overlaySelector
            ] : [],
            $437b23f6a393c3bf$var$FakeHScrollSelector,
            $437b23f6a393c3bf$var$FakeVScrollSelector,
            $437b23f6a393c3bf$var$GridHeaderSelector,
            $437b23f6a393c3bf$var$RowContainerSelector
        ], paramsMap);
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>$437b23f6a393c3bf$export$56744a26086b5898(this.getGui(), count),
            setRowCount: (count)=>$437b23f6a393c3bf$export$1ad8496b26b660f8(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopInvisible: (invisible)=>this.eTop.classList.toggle("ag-invisible", invisible),
            setBottomInvisible: (invisible)=>this.eBottom.classList.toggle("ag-invisible", invisible),
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>{
                this.eStickyBottom.style.height = height;
                this.eStickyBottom.classList.toggle("ag-invisible", height === "0px");
            },
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.toggleCss(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                for (const classList of classLists){
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                    classList.toggle($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
                }
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.AUTO_HEIGHT, params.autoHeight);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.NORMAL, params.normal);
                this.toggleCss($437b23f6a393c3bf$var$LayoutCssClasses.PRINT, params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle($437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ].forEach((ct)=>ct.classList.toggle(cssClass, selectable));
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width,
            setGridRootRole: (role)=>$437b23f6a393c3bf$export$f8d01fa01787902(this.eGridRoot, role)
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$8bebc3145b40d221());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos) || $437b23f6a393c3bf$export$7bd8c52ebc4117d6(this.gos)) $437b23f6a393c3bf$var$_setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation", animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation", !animateRows);
    }
};
var $437b23f6a393c3bf$var$GridBodySelector = {
    selector: "AG-GRID-BODY",
    component: $437b23f6a393c3bf$var$GridBodyComp
};
// packages/ag-grid-community/src/gridComp/gridCtrl.ts
var $437b23f6a393c3bf$export$f3c741dac0be9745 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.additionalFocusableContainers = /* @__PURE__ */ new Set();
    }
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.beans.context.getGridId());
        const { dragAndDrop: dragAndDrop, ctrlsSvc: ctrlsSvc } = this.beans;
        dragAndDrop?.registerGridDropTarget(()=>this.eGui, this);
        $437b23f6a393c3bf$var$_stampTopLevelGridCompWithGridInstance(this.gos, eGridDiv);
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.view));
        this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
        const unsubscribeFromResize = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        ctrlsSvc.register("gridCtrl", this);
    }
    isDetailGrid() {
        const el = $437b23f6a393c3bf$export$c4c49c776025d475(this.getGui());
        return el?.getAttribute("row-id")?.startsWith("detail") || false;
    }
    getOptionalSelectors() {
        const beans = this.beans;
        return {
            paginationSelector: beans.pagination?.getPaginationSelector(),
            gridHeaderDropZonesSelector: beans.registry.getSelector("AG-GRID-HEADER-DROP-ZONES"),
            sideBarSelector: beans.sideBar?.getSelector(),
            statusBarSelector: beans.registry?.getSelector("AG-STATUS-BAR"),
            watermarkSelector: beans.licenseManager?.getWatermarkSelector()
        };
    }
    onGridSizeChanged() {
        this.eventSvc.dispatchEvent({
            type: "gridSizeChanged",
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        });
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(on) {
        this.view.setCursor(on ? "ew-resize" : null);
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.getFocusableContainers();
        const { indexWithFocus: indexWithFocus, nextIndex: nextIndex } = this.getNextFocusableIndex(focusableContainers, backwards);
        if (nextIndex < 0 || nextIndex >= focusableContainers.length) return false;
        if (nextIndex === 0) {
            if (indexWithFocus > 0) {
                const { visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
                const allColumns = visibleCols.allCols;
                const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
                if (focusSvc.focusGridView({
                    column: lastColumn,
                    backwards: true
                })) return true;
            }
            return false;
        }
        return this.focusContainer(focusableContainers[nextIndex], backwards);
    }
    focusInnerElement(fromBottom) {
        const userCallbackFunction = this.gos.getCallback("focusGridInnerElement");
        if (userCallbackFunction && userCallbackFunction({
            fromBottom: !!fromBottom
        })) return true;
        const focusableContainers = this.getFocusableContainers();
        const { focusSvc: focusSvc, visibleCols: visibleCols } = this.beans;
        const allColumns = visibleCols.allCols;
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusContainer($437b23f6a393c3bf$export$236389741107357f(focusableContainers), fromBottom);
            const lastColumn = $437b23f6a393c3bf$export$236389741107357f(allColumns);
            if (focusSvc.focusGridView({
                column: lastColumn,
                backwards: fromBottom
            })) return true;
        }
        if (this.gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) {
            if (focusSvc.focusGridView({
                column: allColumns[0],
                backwards: fromBottom
            })) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if ($437b23f6a393c3bf$export$8598088d375f416f(focusableContainers[i].getGui(), fromBottom)) return true;
            }
            return false;
        }
        return focusSvc.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
    addFocusableContainer(container) {
        this.additionalFocusableContainers.add(container);
    }
    removeFocusableContainer(container) {
        this.additionalFocusableContainers.delete(container);
    }
    allowFocusForNextCoreContainer(up) {
        const coreContainers = this.view.getFocusableContainers();
        const { nextIndex: nextIndex, indexWithFocus: indexWithFocus } = this.getNextFocusableIndex(coreContainers, up);
        if (indexWithFocus === -1 || nextIndex < 0 || nextIndex >= coreContainers.length) return;
        const comp = coreContainers[nextIndex];
        comp.setAllowFocus?.(true);
        setTimeout(()=>{
            comp.setAllowFocus?.(false);
        });
    }
    isFocusable() {
        const beans = this.beans;
        return !$437b23f6a393c3bf$var$_isCellFocusSuppressed(beans) || !$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans) || !!beans.sideBar?.comp?.isDisplayed();
    }
    getNextFocusableIndex(focusableContainers, backwards) {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        const indexWithFocus = focusableContainers.findIndex((container)=>container.getGui().contains(activeEl));
        const nextIndex = indexWithFocus + (backwards ? -1 : 1);
        return {
            indexWithFocus: indexWithFocus,
            nextIndex: nextIndex
        };
    }
    focusContainer(comp, up) {
        comp.setAllowFocus?.(true);
        const result = $437b23f6a393c3bf$export$8598088d375f416f(comp.getGui(), up, false, true);
        comp.setAllowFocus?.(false);
        return result;
    }
    getFocusableContainers() {
        return [
            ...this.view.getFocusableContainers(),
            ...this.additionalFocusableContainers
        ];
    }
    destroy() {
        this.additionalFocusableContainers.clear();
        super.destroy();
    }
};
// packages/ag-grid-community/src/gridComp/gridComp.ts
var $437b23f6a393c3bf$var$GridComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(eGridDiv){
        super();
        this.gridBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.sideBar = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pagination = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.rootWrapperBody = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCss(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$f3c741dac0be9745());
        const comps = ctrl.getOptionalSelectors();
        const template = this.createTemplate(comps);
        const requiredComps = [
            $437b23f6a393c3bf$var$GridBodySelector,
            ...Object.values(comps).filter((c)=>!!c)
        ];
        this.setTemplate(template, requiredComps);
        ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true,
            isEmpty: ()=>!ctrl.isFocusable()
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            this.eGridDiv.removeChild(eGui);
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, "Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.rootWrapperBody.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        const { autoHeight: autoHeight, normal: normal, print: print } = params;
        eRootWrapperBodyClassList.toggle(AUTO_HEIGHT, autoHeight);
        eRootWrapperBodyClassList.toggle(NORMAL, normal);
        eRootWrapperBodyClassList.toggle(PRINT, print);
        this.toggleCss(AUTO_HEIGHT, autoHeight);
        this.toggleCss(NORMAL, normal);
        this.toggleCss(PRINT, print);
    }
    createTemplate(params) {
        const dropZones = params.gridHeaderDropZonesSelector ? {
            tag: "ag-grid-header-drop-zones"
        } : null;
        const sideBar = params.sideBarSelector ? {
            tag: "ag-side-bar",
            ref: "sideBar"
        } : null;
        const statusBar = params.statusBarSelector ? {
            tag: "ag-status-bar"
        } : null;
        const watermark = params.watermarkSelector ? {
            tag: "ag-watermark"
        } : null;
        const pagination = params.paginationSelector ? {
            tag: "ag-pagination",
            ref: "pagination"
        } : null;
        return {
            tag: "div",
            cls: "ag-root-wrapper",
            role: "presentation",
            children: [
                dropZones,
                {
                    tag: "div",
                    ref: "rootWrapperBody",
                    cls: "ag-root-wrapper-body",
                    role: "presentation",
                    children: [
                        {
                            tag: "ag-grid-body",
                            ref: "gridBody"
                        },
                        sideBar
                    ]
                },
                statusBar,
                pagination,
                watermark
            ]
        };
    }
    getFocusableElement() {
        return this.rootWrapperBody;
    }
    forceFocusOutOfContainer(up = false) {
        if (!up && this.pagination?.isDisplayed()) {
            this.pagination.forceFocusOutOfContainer(up);
            return;
        }
        super.forceFocusOutOfContainer(up);
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBody
        ];
        [
            this.sideBar,
            this.pagination
        ].forEach((comp)=>{
            if (comp) focusableContainers.push(comp);
        });
        return focusableContainers.filter((el)=>$437b23f6a393c3bf$export$2badf4aa566524cb(el.getGui()));
    }
};
// packages/ag-grid-community/src/api/gridApiFunctions.ts
var $437b23f6a393c3bf$var$mod = (moduleName, input)=>{
    for (const key of Object.keys(input))input[key] = moduleName;
    return input;
};
var $437b23f6a393c3bf$var$gridApiFunctionsMap = {
    dispatchEvent: "CommunityCore",
    // this is always registered
    ...$437b23f6a393c3bf$var$mod("CommunityCore", {
        destroy: 0,
        getGridId: 0,
        getGridOption: 0,
        isDestroyed: 0,
        setGridOption: 0,
        updateGridOptions: 0,
        isModuleRegistered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("GridState", {
        getState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowSelection", {
        setNodesSelected: 0,
        selectAll: 0,
        deselectAll: 0,
        selectAllFiltered: 0,
        deselectAllFiltered: 0,
        selectAllOnCurrentPage: 0,
        deselectAllOnCurrentPage: 0,
        getSelectedNodes: 0,
        getSelectedRows: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowApi", {
        redrawRows: 0,
        setRowNodeExpanded: 0,
        getRowNode: 0,
        addRenderedRowListener: 0,
        getRenderedNodes: 0,
        forEachNode: 0,
        getFirstDisplayedRowIndex: 0,
        getLastDisplayedRowIndex: 0,
        getDisplayedRowAtIndex: 0,
        getDisplayedRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ScrollApi", {
        getVerticalPixelRange: 0,
        getHorizontalPixelRange: 0,
        ensureColumnVisible: 0,
        ensureIndexVisible: 0,
        ensureNodeVisible: 0
    }),
    ...$437b23f6a393c3bf$var$mod("KeyboardNavigation", {
        getFocusedCell: 0,
        clearFocusedCell: 0,
        setFocusedCell: 0,
        tabToNextCell: 0,
        tabToPreviousCell: 0,
        setFocusedHeader: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EventApi", {
        addEventListener: 0,
        addGlobalListener: 0,
        removeEventListener: 0,
        removeGlobalListener: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ValueCache", {
        expireValueCache: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellApi", {
        getCellValue: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMenu", {
        showColumnMenu: 0,
        hidePopupMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Sort", {
        onSortChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("PinnedRow", {
        getPinnedTopRowCount: 0,
        getPinnedBottomRowCount: 0,
        getPinnedTopRow: 0,
        getPinnedBottomRow: 0,
        forEachPinnedRow: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Overlay", {
        showLoadingOverlay: 0,
        showNoRowsOverlay: 0,
        hideOverlay: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RenderApi", {
        setGridAriaProperty: 0,
        refreshCells: 0,
        refreshHeader: 0,
        isAnimationFrameQueueEmpty: 0,
        flushAllAnimationFrames: 0,
        getSizesForCurrentTheme: 0,
        getCellRendererInstances: 0
    }),
    ...$437b23f6a393c3bf$var$mod("HighlightChanges", {
        flashCells: 0
    }),
    ...$437b23f6a393c3bf$var$mod("RowDrag", {
        addRowDropZone: 0,
        removeRowDropZone: 0,
        getRowDropZoneParams: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnApi", {
        getColumnDefs: 0,
        getColumnDef: 0,
        getDisplayNameForColumn: 0,
        getColumn: 0,
        getColumns: 0,
        applyColumnState: 0,
        getColumnState: 0,
        resetColumnState: 0,
        isPinning: 0,
        isPinningLeft: 0,
        isPinningRight: 0,
        getDisplayedColAfter: 0,
        getDisplayedColBefore: 0,
        setColumnsVisible: 0,
        setColumnsPinned: 0,
        getAllGridColumns: 0,
        getDisplayedLeftColumns: 0,
        getDisplayedCenterColumns: 0,
        getDisplayedRightColumns: 0,
        getAllDisplayedColumns: 0,
        getAllDisplayedVirtualColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnAutoSize", {
        sizeColumnsToFit: 0,
        autoSizeColumns: 0,
        autoSizeAllColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnGroup", {
        setColumnGroupOpened: 0,
        getColumnGroup: 0,
        getProvidedColumnGroup: 0,
        getDisplayNameForColumnGroup: 0,
        getColumnGroupState: 0,
        setColumnGroupState: 0,
        resetColumnGroupState: 0,
        getLeftDisplayedColumnGroups: 0,
        getCenterDisplayedColumnGroups: 0,
        getRightDisplayedColumnGroups: 0,
        getAllDisplayedColumnGroups: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMove", {
        moveColumnByIndex: 0,
        moveColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnResize", {
        setColumnWidths: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnHover", {
        isColumnHovered: 0
    }),
    ...$437b23f6a393c3bf$var$mod("EditCore", {
        getCellEditorInstances: 0,
        getEditingCells: 0,
        stopEditing: 0,
        startEditingCell: 0
    }),
    ...$437b23f6a393c3bf$var$mod("UndoRedoEdit", {
        undoCellEditing: 0,
        redoCellEditing: 0,
        getCurrentUndoSize: 0,
        getCurrentRedoSize: 0
    }),
    ...$437b23f6a393c3bf$var$mod("FilterCore", {
        isAnyFilterPresent: 0,
        onFilterChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnFilter", {
        isColumnFilterPresent: 0,
        getColumnFilterInstance: 0,
        destroyFilter: 0,
        setFilterModel: 0,
        getFilterModel: 0,
        getColumnFilterModel: 0,
        setColumnFilterModel: 0,
        showColumnFilter: 0
    }),
    ...$437b23f6a393c3bf$var$mod("QuickFilter", {
        isQuickFilterPresent: 0,
        getQuickFilter: 0,
        resetQuickFilter: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Find", {
        findGetActiveMatch: 0,
        findGetTotalMatches: 0,
        findGoTo: 0,
        findNext: 0,
        findPrevious: 0,
        findGetNumMatches: 0,
        findGetParts: 0,
        findClearActive: 0,
        findRefresh: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Pagination", {
        paginationIsLastPageFound: 0,
        paginationGetPageSize: 0,
        paginationGetCurrentPage: 0,
        paginationGetTotalPages: 0,
        paginationGetRowCount: 0,
        paginationGoToNextPage: 0,
        paginationGoToPreviousPage: 0,
        paginationGoToFirstPage: 0,
        paginationGoToLastPage: 0,
        paginationGoToPage: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsrmSsrmSharedApi", {
        expandAll: 0,
        collapseAll: 0,
        onRowHeightChanged: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SsrmInfiniteSharedApi", {
        setRowCount: 0,
        getCacheBlockState: 0,
        isLastRowIndexKnown: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ClientSideRowModelApi", {
        onGroupExpandedOrCollapsed: 0,
        refreshClientSideRowModel: 0,
        isRowDataEmpty: 0,
        forEachLeafNode: 0,
        forEachNodeAfterFilter: 0,
        forEachNodeAfterFilterAndSort: 0,
        resetRowHeights: 0,
        applyTransaction: 0,
        applyTransactionAsync: 0,
        flushAsyncTransactions: 0,
        getBestCostNodeSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CsvExport", {
        getDataAsCsv: 0,
        exportDataAsCsv: 0
    }),
    ...$437b23f6a393c3bf$var$mod("InfiniteRowModel", {
        refreshInfiniteCache: 0,
        purgeInfiniteCache: 0,
        getInfiniteRowCount: 0
    }),
    ...$437b23f6a393c3bf$var$mod("AdvancedFilter", {
        getAdvancedFilterModel: 0,
        setAdvancedFilterModel: 0,
        showAdvancedFilterBuilder: 0,
        hideAdvancedFilterBuilder: 0
    }),
    ...$437b23f6a393c3bf$var$mod("IntegratedCharts", {
        getChartModels: 0,
        getChartRef: 0,
        getChartImageDataURL: 0,
        downloadChart: 0,
        openChartToolPanel: 0,
        closeChartToolPanel: 0,
        createRangeChart: 0,
        createPivotChart: 0,
        createCrossFilterChart: 0,
        updateChart: 0,
        restoreChart: 0
    }),
    ...$437b23f6a393c3bf$var$mod("Clipboard", {
        copyToClipboard: 0,
        cutToClipboard: 0,
        copySelectedRowsToClipboard: 0,
        copySelectedRangeToClipboard: 0,
        copySelectedRangeDown: 0,
        pasteFromClipboard: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ExcelExport", {
        getDataAsExcel: 0,
        exportDataAsExcel: 0,
        getSheetDataForExcel: 0,
        getMultipleSheetsAsExcel: 0,
        exportMultipleSheetsAsExcel: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedMasterDetail", {
        addDetailGridInfo: 0,
        removeDetailGridInfo: 0,
        getDetailGridInfo: 0,
        forEachDetailGridInfo: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ContextMenu", {
        showContextMenu: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ColumnMenu", {
        showColumnChooser: 0,
        hideColumnChooser: 0
    }),
    ...$437b23f6a393c3bf$var$mod("CellSelection", {
        getCellRanges: 0,
        addCellRange: 0,
        clearRangeSelection: 0,
        clearCellSelection: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedRowGrouping", {
        setRowGroupColumns: 0,
        removeRowGroupColumns: 0,
        addRowGroupColumns: 0,
        getRowGroupColumns: 0,
        moveRowGroupColumn: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedAggregation", {
        addAggFuncs: 0,
        clearAggFuncs: 0,
        setColumnAggFunc: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SharedPivot", {
        isPivotMode: 0,
        getPivotResultColumn: 0,
        setValueColumns: 0,
        getValueColumns: 0,
        removeValueColumns: 0,
        addValueColumns: 0,
        setPivotColumns: 0,
        removePivotColumns: 0,
        addPivotColumns: 0,
        getPivotColumns: 0,
        setPivotResultColumns: 0,
        getPivotResultColumns: 0
    }),
    ...$437b23f6a393c3bf$var$mod("ServerSideRowModelApi", {
        getServerSideSelectionState: 0,
        setServerSideSelectionState: 0,
        applyServerSideTransaction: 0,
        applyServerSideTransactionAsync: 0,
        applyServerSideRowData: 0,
        retryServerSideLoads: 0,
        flushServerSideAsyncTransactions: 0,
        refreshServerSide: 0,
        getServerSideGroupLevelState: 0
    }),
    ...$437b23f6a393c3bf$var$mod("SideBar", {
        isSideBarVisible: 0,
        setSideBarVisible: 0,
        setSideBarPosition: 0,
        openToolPanel: 0,
        closeToolPanel: 0,
        getOpenedToolPanel: 0,
        refreshToolPanel: 0,
        isToolPanelShowing: 0,
        getToolPanelInstance: 0,
        getSideBar: 0
    }),
    ...$437b23f6a393c3bf$var$mod("StatusBar", {
        getStatusPanel: 0
    })
};
// packages/ag-grid-community/src/api/apiFunctionService.ts
var $437b23f6a393c3bf$var$defaultFns = {
    isDestroyed: ()=>true,
    destroy () {},
    preConstruct () {},
    postConstruct () {},
    preWireBeans () {},
    wireBeans () {}
};
var $437b23f6a393c3bf$var$dispatchEvent = (beans, event)=>beans.eventSvc.dispatchEvent(event);
var $437b23f6a393c3bf$var$GridApiClass = class {
};
Reflect.defineProperty($437b23f6a393c3bf$var$GridApiClass, "name", {
    value: "GridApi"
});
var $437b23f6a393c3bf$var$ApiFunctionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "apiFunctionSvc";
        this.api = new $437b23f6a393c3bf$var$GridApiClass();
        this.fns = {
            ...$437b23f6a393c3bf$var$defaultFns,
            dispatchEvent: // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
            $437b23f6a393c3bf$var$dispatchEvent
        };
        this.preDestroyLink = "";
        const { api: api } = this;
        for (const key of Object.keys($437b23f6a393c3bf$var$gridApiFunctionsMap))api[key] = this.makeApi(key)[key];
    }
    postConstruct() {
        this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
    }
    addFunction(functionName, func) {
        const { fns: fns, beans: beans } = this;
        if (fns !== $437b23f6a393c3bf$var$defaultFns) fns[functionName] = beans?.validation?.validateApiFunction(functionName, func) ?? func;
    }
    makeApi(apiName) {
        return {
            [apiName]: (...args)=>{
                const { beans: beans, fns: { [apiName]: fn } } = this;
                return fn ? fn(beans, ...args) : this.apiNotFound(apiName);
            }
        };
    }
    apiNotFound(fnName) {
        const { beans: beans, gos: gos, preDestroyLink: preDestroyLink } = this;
        if (!beans) $437b23f6a393c3bf$export$545083624300f13d(26, {
            fnName: fnName,
            preDestroyLink: preDestroyLink
        });
        else {
            const module = $437b23f6a393c3bf$var$gridApiFunctionsMap[fnName];
            if (gos.assertModuleRegistered(module, `api.${fnName}`)) $437b23f6a393c3bf$export$545083624300f13d(27, {
                fnName: fnName,
                module: module
            });
        }
    }
    destroy() {
        super.destroy();
        this.fns = $437b23f6a393c3bf$var$defaultFns;
        this.beans = null;
    }
};
// packages/ag-grid-community/src/api/coreApi.ts
function $437b23f6a393c3bf$var$getGridId(beans) {
    return beans.context.getGridId();
}
function $437b23f6a393c3bf$var$destroy(beans) {
    beans.gridDestroySvc.destroy();
}
function $437b23f6a393c3bf$var$isDestroyed(beans) {
    return beans.gridDestroySvc.destroyCalled;
}
function $437b23f6a393c3bf$var$getGridOption(beans, key) {
    return beans.gos.get(key);
}
function $437b23f6a393c3bf$var$setGridOption(beans, key, value) {
    $437b23f6a393c3bf$var$updateGridOptions(beans, {
        [key]: value
    });
}
function $437b23f6a393c3bf$var$updateGridOptions(beans, options) {
    beans.gos.updateGridOptions({
        options: options
    });
}
function $437b23f6a393c3bf$var$isModuleRegistered(beans, moduleName) {
    const withoutSuffix = moduleName.replace(/Module$/, "");
    return beans.gos.isModuleRegistered(withoutSuffix);
}
// packages/ag-grid-community/src/rendering/dndSourceComp.ts
var $437b23f6a393c3bf$var$DndSourceElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        draggable: "true"
    }
};
var $437b23f6a393c3bf$var$DndSourceComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(rowNode, column, eCell){
        super($437b23f6a393c3bf$var$DndSourceElement);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", this.beans, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const { rowNode: rowNode, column: column, eCell: eCell, gos: gos } = this;
        const providedOnRowDrag = column.getColDef().dndSourceOnRowDrag;
        const dataTransfer = dragEvent.dataTransfer;
        dataTransfer.setDragImage(eCell, 0, 0);
        if (providedOnRowDrag) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                rowNode: rowNode,
                dragEvent: dragEvent
            });
            providedOnRowDrag(params);
        } else try {
            const jsonData = JSON.stringify(rowNode.data);
            dataTransfer.setData("application/json", jsonData);
            dataTransfer.setData("text/plain", jsonData);
        } catch (e) {}
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragApi.ts
function $437b23f6a393c3bf$var$addRowDropZone(beans, params) {
    beans.rowDragSvc?.rowDragFeature?.addRowDropZone(params);
}
function $437b23f6a393c3bf$var$removeRowDropZone(beans, params) {
    const activeDropTarget = beans.dragAndDrop?.findExternalZone(params);
    if (activeDropTarget) beans.dragAndDrop?.removeDropTarget(activeDropTarget);
}
function $437b23f6a393c3bf$var$getRowDropZoneParams(beans, events) {
    return beans.rowDragSvc?.rowDragFeature?.getRowDropZone(events);
}
// packages/ag-grid-community/src/dragAndDrop/horizontalResizeService.ts
var $437b23f6a393c3bf$var$HorizontalResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "horizontalResizeSvc";
    }
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            onDragCancel: this.onDragStop.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        const { dragSvc: dragSvc } = this.beans;
        dragSvc.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>dragSvc.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(true);
        ctrl.disableUserSelect(true);
    }
    onDragStop(params) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.beans.ctrlsSvc.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragComp.ts
var $437b23f6a393c3bf$var$RowDragElement = {
    tag: "div",
    cls: "ag-drag-handle ag-row-drag",
    attrs: {
        "aria-hidden": "true"
    }
};
var $437b23f6a393c3bf$var$RowDragComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.suppressVisibilityChange = suppressVisibilityChange;
        this.dragSource = null;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        const { beans: beans, rowNode: rowNode, column: column, gos: gos } = this;
        if (!this.customGui) {
            this.setTemplate($437b23f6a393c3bf$var$RowDragElement);
            this.getGui().appendChild($437b23f6a393c3bf$export$d8feba07bf373edb("rowDrag", beans, null));
            this.addDragSource();
        } else this.setDragElement(this.customGui, this.dragStartPixels);
        if (!this.suppressVisibilityChange) {
            const strategy = gos.get("rowDragManaged") ? new $437b23f6a393c3bf$var$ManagedVisibilityStrategy(this, rowNode, column) : new $437b23f6a393c3bf$var$NonManagedVisibilityStrategy(this, rowNode, column);
            this.createManagedBean(strategy, this.beans.context);
        }
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement, void 0, void 0, true);
        this.addDragSource(dragStartPixels);
    }
    getSelectedNodes() {
        const rowNode = this.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            rowNode
        ];
        const selection = this.beans.selectionSvc?.getSelectedNodes() ?? [];
        return selection.indexOf(rowNode) !== -1 ? selection : [
            rowNode
        ];
    }
    getDragItem() {
        const { column: column, rowNode: rowNode } = this;
        return {
            rowNode: rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: column ? [
                column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    getRowDragText(column) {
        if (column) {
            const colDef = column.getColDef();
            if (colDef.rowDragText) return colDef.rowDragText;
        }
        return this.gos.get("rowDragText");
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        const eGui = this.getGui();
        if (this.gos.get("enableCellTextSelection")) {
            this.removeMouseDownListener();
            this.mouseDownListener = this.addManagedElementListeners(eGui, {
                mousedown: (e)=>{
                    e?.preventDefault();
                }
            })[0];
        }
        const translate = this.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: eGui,
            dragItemName: ()=>{
                const dragItem = this.getDragItem();
                const dragItemCount = dragItem.rowNodes?.length || 1;
                const rowDragText = this.getRowDragText(this.column);
                if (rowDragText) return rowDragText(dragItem, dragItemCount);
                return dragItemCount === 1 ? this.cellValueFn() : `${dragItemCount} ${translate("rowDragRows", "rows")}`;
            },
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels: dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDrop.addDragSource(this.dragSource, true);
    }
    destroy() {
        this.removeDragSource();
        this.removeMouseDownListener();
        super.destroy();
    }
    removeDragSource() {
        if (!this.dragSource) return;
        this.beans.dragAndDrop.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
    removeMouseDownListener() {
        if (!this.mouseDownListener) return;
        this.mouseDownListener();
        this.mouseDownListener = void 0;
    }
};
var $437b23f6a393c3bf$var$VisibilityStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(parent, rowNode, column){
        super();
        this.parent = parent;
        this.rowNode = rowNode;
        this.column = column;
    }
    setDisplayedOrVisible(neverDisplayed) {
        const displayedOptions = {
            skipAriaHidden: true
        };
        if (neverDisplayed) this.parent.setDisplayed(false, displayedOptions);
        else {
            let shown = true;
            let isShownSometimes = false;
            const { column: column, rowNode: rowNode, parent: parent } = this;
            if (column) {
                shown = column.isRowDrag(rowNode) || parent.isCustomGui();
                isShownSometimes = typeof column.getColDef().rowDrag === "function";
            }
            if (isShownSometimes) {
                parent.setDisplayed(true, displayedOptions);
                parent.setVisible(shown, displayedOptions);
            } else {
                parent.setDisplayed(shown, displayedOptions);
                parent.setVisible(true, displayedOptions);
            }
        }
    }
};
var $437b23f6a393c3bf$var$NonManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    postConstruct() {
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        const listener = this.workOutVisibility.bind(this);
        this.addManagedListeners(this.rowNode, {
            dataChanged: listener,
            cellChanged: listener
        });
        this.addManagedListeners(this.beans.eventSvc, {
            newColumnsLoaded: listener
        });
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const neverDisplayed = this.gos.get("suppressRowDrag");
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
var $437b23f6a393c3bf$var$ManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    postConstruct() {
        const listener = this.workOutVisibility.bind(this);
        this.addManagedListeners(this.beans.eventSvc, {
            sortChanged: listener,
            filterChanged: listener,
            columnRowGroupChanged: listener,
            newColumnsLoaded: listener
        });
        this.addManagedListeners(this.rowNode, {
            dataChanged: listener,
            cellChanged: listener
        });
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const { rowDragSvc: rowDragSvc, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
        const rowDragFeature = rowDragSvc.rowDragFeature;
        const shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
        const suppressRowDrag = gos.get("suppressRowDrag");
        const hasExternalDropZones = dragAndDrop.hasExternalDropZones();
        const neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
// packages/ag-grid-community/src/dragAndDrop/rowDragService.ts
var $437b23f6a393c3bf$var$RowDragService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowDragSvc";
    }
    setupRowDrag(element, ctrl) {
        const rowDragFeature = ctrl.createManagedBean(new $437b23f6a393c3bf$var$RowDragFeature(element));
        const dragAndDrop = this.beans.dragAndDrop;
        dragAndDrop.addDropTarget(rowDragFeature);
        ctrl.addDestroyFunc(()=>dragAndDrop.removeDropTarget(rowDragFeature));
        this.rowDragFeature = rowDragFeature;
    }
    createRowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange) {
        return new $437b23f6a393c3bf$var$RowDragComp(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange);
    }
    createRowDragCompForRow(rowNode, element) {
        if ($437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos)) return void 0;
        const translate = this.getLocaleTextFunc();
        return this.createRowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, rowNode, void 0, element, void 0, true);
    }
    createRowDragCompForCell(rowNode, column, cellValueFn, element, dragStartPixels, suppressVisibilityChange) {
        const gos = this.gos;
        if (gos.get("rowDragManaged")) {
            if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos) || gos.get("pagination")) return void 0;
        }
        const rowDragComp = this.createRowDragComp(cellValueFn, rowNode, column, element, dragStartPixels, suppressVisibilityChange);
        return rowDragComp;
    }
};
// packages/ag-grid-community/src/dragAndDrop/dragModule.ts
var $437b23f6a393c3bf$export$e88a21946d283d22 = {
    moduleName: "Drag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragService
    ]
};
var $437b23f6a393c3bf$export$b9bac28848e60126 = {
    moduleName: "DragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        dndSourceComp: $437b23f6a393c3bf$var$DndSourceComp
    },
    icons: {
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$4ad116d131ade5b4 = {
    moduleName: "SharedDragAndDrop",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DragAndDropService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ],
    userComponents: {
        agDragAndDropImage: $437b23f6a393c3bf$var$DragAndDropImageComponent2
    },
    icons: {
        // shown on drag and drop image component icon while dragging column to the side of the grid to pin
        columnMovePin: "pin",
        // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
        columnMoveHide: "eye-slash",
        // shown on drag and drop image component icon while dragging columns to reorder
        columnMoveMove: "arrows",
        // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
        columnMoveLeft: "left",
        // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
        columnMoveRight: "right",
        // shown on drag and drop image component icon while dragging over Row Groups drop zone
        columnMoveGroup: "group",
        // shown on drag and drop image component icon while dragging over Values drop zone
        columnMoveValue: "aggregation",
        // shown on drag and drop image component icon while dragging over pivot drop zone
        columnMovePivot: "pivot",
        // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
        // string column over aggregation drop zone
        dropNotAllowed: "not-allowed",
        // drag handle used to pick up draggable rows
        rowDrag: "grip"
    }
};
var $437b23f6a393c3bf$export$49c914873cdbe391 = {
    moduleName: "RowDrag",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowDragService
    ],
    apiFunctions: {
        addRowDropZone: $437b23f6a393c3bf$var$addRowDropZone,
        removeRowDropZone: $437b23f6a393c3bf$var$removeRowDropZone,
        getRowDropZoneParams: $437b23f6a393c3bf$var$getRowDropZoneParams
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ]
};
var $437b23f6a393c3bf$export$57b5b4ab4a8a663e = {
    moduleName: "HorizontalResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$HorizontalResizeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$e88a21946d283d22
    ]
};
// packages/ag-grid-community/src/columnMove/column-moving.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnMovingCSS = /*css*/ `:where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell,.ag-spanned-cell-wrapper{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}`;
// packages/ag-grid-community/src/columnMove/columnAnimationService.ts
var $437b23f6a393c3bf$var$ColumnAnimationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAnimation";
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        // activeNext starts with active but it is reset earlier after the nextFuncs are cleared
        // to prevent calls made to executeNextVMTurn from queuing functions after executeNextFuncs has already been flushed,
        this.activeNext = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        const { gos: gos } = this;
        if (gos.get("suppressColumnMoveAnimation")) return;
        if (gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
        this.activeNext = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>this.activeNext = false, ()=>this.active = false);
    }
    executeNextVMTurn(func) {
        if (this.activeNext) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        const { gridBodyCtrl: gridBodyCtrl } = this;
        gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callbackNext, callbackLater) {
        const { executeNextFuncs: executeNextFuncs, executeLaterFuncs: executeLaterFuncs } = this;
        if (executeNextFuncs.length === 0 && executeLaterFuncs.length === 0) {
            callbackNext();
            callbackLater();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                callbackNext();
                runFuncs(executeNextFuncs);
            }, 0);
            window.setTimeout(()=>{
                callbackLater();
                runFuncs(executeLaterFuncs);
            }, 200);
        });
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveApi.ts
function $437b23f6a393c3bf$var$moveColumnByIndex(beans, fromIndex, toIndex) {
    beans.colMoves?.moveColumnByIndex(fromIndex, toIndex, "api");
}
function $437b23f6a393c3bf$var$moveColumns(beans, columnsToMoveKeys, toIndex) {
    beans.colMoves?.moveColumns(columnsToMoveKeys, toIndex, "api");
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropPivotTarget.ts
var $437b23f6a393c3bf$var$BodyDropPivotTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        dragColumns.forEach((column)=>{
            if (!column.isPrimary()) return;
            if (column.isAnyFunctionActive()) return;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        });
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? "pinned" : "move";
        return null;
    }
    /** Callback for when drag leaves */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragging(draggingEvent) {}
    /** Callback for when drag stops */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDragStop(draggingEvent) {
        const { valueColsSvc: valueColsSvc, rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        if (this.columnsToAggregate.length > 0) valueColsSvc?.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) rowGroupColsSvc?.addColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) pivotColsSvc?.addColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
    onDragCancel() {
        this.clearColumnsList();
    }
};
// packages/ag-grid-community/src/columnMove/internalColumnMoveUtils.ts
function $437b23f6a393c3bf$var$sortColsLikeCols(colsList, cols) {
    if (!cols || cols.length <= 1) return;
    const notAllColsPresent = cols.filter((c)=>colsList.indexOf(c) < 0).length > 0;
    if (notAllColsPresent) return;
    cols.sort((a, b)=>{
        const indexA = colsList.indexOf(a);
        const indexB = colsList.indexOf(b);
        return indexA - indexB;
    });
}
function $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) {
    const { isFromHeader: isFromHeader, fromLeft: fromLeft, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, pinned: pinned, gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = params;
    let { allMovingColumns: allMovingColumns } = params;
    if (isFromHeader) {
        const newCols = [];
        allMovingColumns.forEach((col)=>{
            let movingGroup = null;
            let parent = col.getParent();
            while(parent != null && parent.getDisplayedLeafColumns().length === 1){
                movingGroup = parent;
                parent = parent.getParent();
            }
            if (movingGroup != null) {
                const isMarryChildren = !!movingGroup.getColGroupDef()?.marryChildren;
                const columnsToMove = isMarryChildren ? // when marry children is true, we also have to move hidden
                // columns within the group, so grab them from the `providedColumnGroup`
                movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
                columnsToMove.forEach((newCol)=>{
                    if (!newCols.includes(newCol)) newCols.push(newCol);
                });
            } else if (!newCols.includes(col)) newCols.push(col);
        });
        allMovingColumns = newCols;
    }
    const allMovingColumnsOrdered = allMovingColumns.slice();
    $437b23f6a393c3bf$var$sortColsLikeCols(colModel.getCols(), allMovingColumnsOrdered);
    const validMoves = $437b23f6a393c3bf$var$calculateValidMoves({
        movingCols: allMovingColumnsOrdered,
        draggingRight: fromLeft,
        xPosition: xPosition,
        pinned: pinned,
        gos: gos,
        colModel: colModel,
        visibleCols: visibleCols
    });
    const oldIndex = $437b23f6a393c3bf$var$calculateOldIndex(allMovingColumnsOrdered, colModel);
    if (validMoves.length === 0) return;
    const firstValidMove = validMoves[0];
    let constrainDirection = oldIndex !== null && !fromEnter;
    if (isFromHeader) constrainDirection = oldIndex !== null;
    if (constrainDirection && !fakeEvent) {
        if (!fromLeft && firstValidMove >= oldIndex) return;
        if (fromLeft && firstValidMove <= oldIndex) return;
    }
    const displayedCols = visibleCols.allCols;
    const potentialMoves = [];
    let targetOrder = null;
    for(let i = 0; i < validMoves.length; i++){
        const move = validMoves[i];
        const order = colMoves.getProposedColumnOrder(allMovingColumnsOrdered, move);
        if (!colMoves.doesOrderPassRules(order)) continue;
        const displayedOrder = order.filter((col)=>displayedCols.includes(col));
        if (targetOrder === null) targetOrder = displayedOrder;
        else if (!$437b23f6a393c3bf$export$893967cdb9833fdd(displayedOrder, targetOrder)) break;
        const fragCount = $437b23f6a393c3bf$var$groupFragCount(order);
        potentialMoves.push({
            move: move,
            fragCount: fragCount
        });
    }
    if (potentialMoves.length === 0) return;
    potentialMoves.sort((a, b)=>a.fragCount - b.fragCount);
    const toIndex = potentialMoves[0].move;
    if (toIndex > colModel.getCols().length - allMovingColumns.length) return;
    return {
        columns: allMovingColumns,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$attemptMoveColumns(params) {
    const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(params) || {};
    const { finished: finished, colMoves: colMoves } = params;
    if (!columns || toIndex == null) return null;
    colMoves.moveColumns(columns, toIndex, "uiColumnMoved", finished);
    return finished ? null : {
        columns: columns,
        toIndex: toIndex
    };
}
function $437b23f6a393c3bf$var$calculateOldIndex(movingCols, colModel) {
    const gridCols = colModel.getCols();
    const indexes = movingCols.map((col)=>gridCols.indexOf(col)).sort((a, b)=>a - b);
    const firstIndex = indexes[0];
    const lastIndex = $437b23f6a393c3bf$export$236389741107357f(indexes);
    const spread = lastIndex - firstIndex;
    const gapsExist = spread !== indexes.length - 1;
    return gapsExist ? null : firstIndex;
}
function $437b23f6a393c3bf$var$groupFragCount(columns) {
    function parents(col) {
        const result = [];
        let parent = col.getOriginalParent();
        while(parent != null){
            result.push(parent);
            parent = parent.getOriginalParent();
        }
        return result;
    }
    let count = 0;
    for(let i = 0; i < columns.length - 1; i++){
        let a = parents(columns[i]);
        let b = parents(columns[i + 1]);
        [a, b] = a.length > b.length ? [
            a,
            b
        ] : [
            b,
            a
        ];
        a.forEach((parent)=>{
            if (b.indexOf(parent) === -1) count++;
        });
    }
    return count;
}
function $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, type) {
    switch(type){
        case "left":
            return visibleCols.leftCols;
        case "right":
            return visibleCols.rightCols;
        default:
            return visibleCols.centerCols;
    }
}
function $437b23f6a393c3bf$var$calculateValidMoves(params) {
    const { movingCols: movingCols, draggingRight: draggingRight, xPosition: xPosition, pinned: pinned, gos: gos, colModel: colModel, visibleCols: visibleCols } = params;
    const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
    if (isMoveBlocked) return [];
    const allDisplayedCols = $437b23f6a393c3bf$var$getDisplayedColumns(visibleCols, pinned);
    const allGridCols = colModel.getCols();
    const movingDisplayedCols = allDisplayedCols.filter((col)=>movingCols.includes(col));
    const otherDisplayedCols = allDisplayedCols.filter((col)=>!movingCols.includes(col));
    const otherGridCols = allGridCols.filter((col)=>!movingCols.includes(col));
    let displayIndex = 0;
    let availableWidth = xPosition;
    if (draggingRight) {
        let widthOfMovingDisplayedCols = 0;
        movingDisplayedCols.forEach((col)=>widthOfMovingDisplayedCols += col.getActualWidth());
        availableWidth -= widthOfMovingDisplayedCols;
    }
    if (availableWidth > 0) {
        for(let i = 0; i < otherDisplayedCols.length; i++){
            const col = otherDisplayedCols[i];
            availableWidth -= col.getActualWidth();
            if (availableWidth < 0) break;
            displayIndex++;
        }
        if (draggingRight) displayIndex++;
    }
    let firstValidMove;
    if (displayIndex > 0) {
        const leftColumn = otherDisplayedCols[displayIndex - 1];
        firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
    } else {
        firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
        if (firstValidMove === -1) firstValidMove = 0;
    }
    const validMoves = [
        firstValidMove
    ];
    const numberComparator = (a, b)=>a - b;
    if (draggingRight) {
        let pointer = firstValidMove + 1;
        const lastIndex = allGridCols.length - 1;
        while(pointer <= lastIndex){
            validMoves.push(pointer);
            pointer++;
        }
        validMoves.sort(numberComparator);
    } else {
        let pointer = firstValidMove;
        const lastIndex = allGridCols.length - 1;
        let displacedCol = allGridCols[pointer];
        while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
            pointer++;
            validMoves.push(pointer);
            displacedCol = allGridCols[pointer];
        }
        pointer = firstValidMove - 1;
        const firstDisplayIndex = 0;
        while(pointer >= firstDisplayIndex){
            validMoves.push(pointer);
            pointer--;
        }
        validMoves.sort(numberComparator).reverse();
    }
    return validMoves;
}
function $437b23f6a393c3bf$var$normaliseX(params) {
    const { pinned: pinned, fromKeyboard: fromKeyboard, gos: gos, ctrlsSvc: ctrlsSvc, useHeaderRow: useHeaderRow, skipScrollPadding: skipScrollPadding } = params;
    let eViewport = ctrlsSvc.getHeaderRowContainerCtrl(pinned)?.eViewport;
    let { x: x } = params;
    if (!eViewport) return 0;
    if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
    if (gos.get("enableRtl")) {
        if (useHeaderRow) eViewport = eViewport.querySelector(".ag-header-row");
        x = eViewport.clientWidth - x;
    }
    if (pinned == null && !skipScrollPadding) x += ctrlsSvc.get("center").getCenterViewportScrollLeft();
    return x;
}
function $437b23f6a393c3bf$var$setColumnsMoving(columns, isMoving) {
    for (const column of columns){
        column.moving = isMoving;
        column.dispatchColEvent("movingChanged", "uiColumnMoved");
    }
}
// packages/ag-grid-community/src/columnMove/columnDrag/moveColumnFeature.ts
var $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD = 7;
var $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH = 100;
var $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH / 2;
var $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE = 5;
var $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL = 100;
var $437b23f6a393c3bf$var$MoveColumnFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.pinned = pinned;
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.isCenterContainer = !$437b23f6a393c3bf$export$25d27f17d3af40f7(pinned);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        const { pinned: pinned, lastDraggingEvent: lastDraggingEvent } = this;
        const { dragItem: dragItem } = lastDraggingEvent || {};
        const columns = dragItem?.columns ?? [];
        for (const col of columns){
            const colPinned = col.getPinned();
            if (col.getColDef().lockPinned) {
                if (colPinned == pinned) return "move";
                continue;
            }
            const initialPinnedState = dragItem?.containerType;
            if (initialPinnedState === pinned || !pinned) return "move";
            if (pinned && (!colPinned || initialPinnedState !== pinned)) return "pinned";
        }
        return "notAllowed";
    }
    onDragEnter(draggingEvent) {
        const dragItem = draggingEvent.dragItem;
        const columns = dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()]);
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        if (!this.gos.get("suppressMoveWhenColumnDragging")) this.attemptToPinColumns(columns, this.pinned);
        this.onDragging(draggingEvent, true, true);
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const isSuppressMoveWhenDragging = gos.get("suppressMoveWhenColumnDragging");
        if (finished && !isSuppressMoveWhenDragging) {
            this.finishColumnMoving();
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if (!draggingEvent || !finished && $437b23f6a393c3bf$export$672d9e47bc342bac(draggingEvent.hDirection)) return;
        const mouseX = $437b23f6a393c3bf$var$normaliseX({
            x: draggingEvent.x,
            pinned: this.pinned,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        if (isSuppressMoveWhenDragging) this.handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
        else this.handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.clearHighlighted();
        this.updateDragItemContainerType();
        this.lastMovedInfo = null;
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    onDragCancel() {
        this.clearHighlighted();
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (!columns) return;
        const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
        this.beans.colModel.setColsVisible(allowedCols, visible, source);
    }
    finishColumnMoving() {
        this.clearHighlighted();
        const lastMovedInfo = this.lastMovedInfo;
        if (!lastMovedInfo) return;
        const { columns: columns, toIndex: toIndex } = lastMovedInfo;
        this.beans.colMoves.moveColumns(columns, toIndex, "uiColumnMoved", true);
    }
    updateDragItemContainerType() {
        const { lastDraggingEvent: lastDraggingEvent } = this;
        if (this.gos.get("suppressMoveWhenColumnDragging") || !lastDraggingEvent) return;
        const dragItem = lastDraggingEvent.dragItem;
        if (!dragItem) return;
        dragItem.containerType = this.pinned;
    }
    handleColumnDragWhileSuppressingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent, true);
        if (finished) {
            const isAttemptingToPin = this.isAttemptingToPin(allMovingColumns);
            if (isAttemptingToPin) this.attemptToPinColumns(allMovingColumns, void 0, true);
            const { fromLeft: fromLeft, xPosition: xPosition } = this.getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) || {};
            if (fromLeft == null || xPosition == null) {
                this.finishColumnMoving();
                return;
            }
            this.moveColumnsAfterHighlight({
                allMovingColumns: allMovingColumns,
                xPosition: xPosition,
                fromEnter: fromEnter,
                fakeEvent: fakeEvent,
                fromLeft: fromLeft
            });
        } else {
            if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(draggingEvent)) return;
            this.highlightHoveredColumn(allMovingColumns, mouseX);
        }
    }
    handleColumnDragWhileAllowingMovement(draggingEvent, fromEnter, fakeEvent, mouseX, finished) {
        const allMovingColumns = this.getAllMovingColumns(draggingEvent);
        const fromLeft = this.normaliseDirection(draggingEvent.hDirection) === "right";
        const isFromHeader = draggingEvent.dragSource.type === 1 /* HeaderCell */ ;
        const params = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            xPosition: mouseX,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const lastMovedInfo = $437b23f6a393c3bf$var$attemptMoveColumns({
            ...params,
            finished: finished
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    getAllMovingColumns(draggingEvent, useSplit = false) {
        const dragItem = draggingEvent.dragSource.getDragItem();
        let columns = null;
        if (useSplit) {
            columns = dragItem.columnsInSplit;
            if (!columns) columns = dragItem.columns;
        } else columns = dragItem.columns;
        const conditionCallback = (col)=>col.getColDef().lockPinned ? col.getPinned() == this.pinned : true;
        if (!columns) return [];
        return columns.filter(conditionCallback);
    }
    getMoveColumnParams(params) {
        const { allMovingColumns: allMovingColumns, isFromHeader: isFromHeader, xPosition: xPosition, fromLeft: fromLeft, fromEnter: fromEnter, fakeEvent: fakeEvent } = params;
        const { gos: gos, colModel: colModel, colMoves: colMoves, visibleCols: visibleCols } = this.beans;
        return {
            allMovingColumns: allMovingColumns,
            isFromHeader: isFromHeader,
            fromLeft: fromLeft,
            xPosition: xPosition,
            pinned: this.pinned,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent,
            gos: gos,
            colModel: colModel,
            colMoves: colMoves,
            visibleCols: visibleCols
        };
    }
    highlightHoveredColumn(movingColumns, mouseX) {
        const { gos: gos, colModel: colModel } = this.beans;
        const isRtl = gos.get("enableRtl");
        const consideredColumns = colModel.getCols().filter((col)=>col.isVisible() && col.getPinned() === this.pinned);
        let start = null;
        let width = null;
        let targetColumn = null;
        for (const col of consideredColumns){
            width = col.getActualWidth();
            start = this.getNormalisedColumnLeft(col, 0, isRtl);
            if (start != null) {
                const end = start + width;
                if (start <= mouseX && end >= mouseX) {
                    targetColumn = col;
                    break;
                }
            }
            start = null;
            width = null;
        }
        if (!targetColumn) {
            for(let i = consideredColumns.length - 1; i >= 0; i--){
                const currentColumn = consideredColumns[i];
                const parent = consideredColumns[i].getParent();
                if (!parent) {
                    targetColumn = currentColumn;
                    break;
                }
                const leafDisplayedCols = parent?.getDisplayedLeafColumns();
                if (leafDisplayedCols.length) {
                    targetColumn = $437b23f6a393c3bf$export$236389741107357f(leafDisplayedCols);
                    break;
                }
            }
            if (!targetColumn) return;
            start = this.getNormalisedColumnLeft(targetColumn, 0, isRtl);
            width = targetColumn.getActualWidth();
        } else if (movingColumns.indexOf(targetColumn) !== -1) targetColumn = null;
        if (this.lastHighlightedColumn?.column !== targetColumn) this.clearHighlighted();
        if (targetColumn == null || start == null || width == null) return;
        let position;
        if (mouseX - start < width / 2 !== isRtl) position = 0 /* Before */ ;
        else position = 1 /* After */ ;
        $437b23f6a393c3bf$var$setColumnHighlighted(targetColumn, position);
        this.lastHighlightedColumn = {
            column: targetColumn,
            position: position
        };
    }
    getNormalisedXPositionInfo(allMovingColumns, isAttemptingToPin) {
        const { gos: gos, visibleCols: visibleCols } = this.beans;
        const isRtl = gos.get("enableRtl");
        const { firstMovingCol: firstMovingCol, column: column, position: position } = this.getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl);
        if (!firstMovingCol || !column || position == null) return;
        const visibleColumns = visibleCols.allCols;
        const movingColIndex = visibleColumns.indexOf(firstMovingCol);
        const targetIndex = visibleColumns.indexOf(column);
        const isBefore = position === 0 /* Before */  !== isRtl;
        const fromLeft = movingColIndex < targetIndex || movingColIndex === targetIndex && !isBefore;
        let diff = 0;
        if (isBefore) {
            if (fromLeft) diff -= 1;
        } else if (!fromLeft) diff += 1;
        if (targetIndex + diff === movingColIndex) return;
        const targetColumn = visibleColumns[targetIndex + diff];
        if (!targetColumn) return;
        const xPosition = this.getNormalisedColumnLeft(targetColumn, 20, isRtl);
        return {
            fromLeft: fromLeft,
            xPosition: xPosition
        };
    }
    getColumnMoveAndTargetInfo(allMovingColumns, isAttemptingToPin, isRtl) {
        const lastHighlightedColumn = this.lastHighlightedColumn || {};
        const { firstMovingCol: firstMovingCol, lastMovingCol: lastMovingCol } = $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns);
        if (!firstMovingCol || !lastMovingCol || lastHighlightedColumn.column || !isAttemptingToPin) return {
            firstMovingCol: firstMovingCol,
            ...lastHighlightedColumn
        };
        const pinned = this.getPinDirection();
        const isLeft = pinned === "left";
        return {
            firstMovingCol: firstMovingCol,
            position: isLeft ? 1 /* After */  : 0 /* Before */ ,
            column: isLeft !== isRtl ? firstMovingCol : lastMovingCol
        };
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case "left":
                return "right";
            case "right":
                return "left";
        }
        return hDirection;
    }
    getNormalisedColumnLeft(col, padding, isRtl) {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        const left = col.getLeft();
        if (left == null) return null;
        const width = col.getActualWidth();
        return $437b23f6a393c3bf$var$normaliseX({
            x: isRtl ? left + width - padding : left + padding,
            pinned: col.getPinned(),
            useHeaderRow: isRtl,
            skipScrollPadding: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
    }
    isAttemptingToPin(columns) {
        const isMovingHorizontally = this.needToMoveLeft || this.needToMoveRight;
        const isFailedMoreThanThreshold = this.failedMoveAttempts > $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD;
        return isMovingHorizontally && isFailedMoreThanThreshold || columns.some((col)=>col.getPinned() !== this.pinned);
    }
    moveColumnsAfterHighlight(params) {
        const { allMovingColumns: allMovingColumns, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, fromLeft: fromLeft } = params;
        const columnMoveParams = this.getMoveColumnParams({
            allMovingColumns: allMovingColumns,
            isFromHeader: true,
            xPosition: xPosition,
            fromLeft: fromLeft,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent
        });
        const { columns: columns, toIndex: toIndex } = $437b23f6a393c3bf$var$getBestColumnMoveIndexFromXPosition(columnMoveParams) || {};
        if (columns && toIndex != null) this.lastMovedInfo = {
            columns: columns,
            toIndex: toIndex
        };
        this.finishColumnMoving();
    }
    clearHighlighted() {
        const { lastHighlightedColumn: lastHighlightedColumn } = this;
        if (!lastHighlightedColumn) return;
        $437b23f6a393c3bf$var$setColumnHighlighted(lastHighlightedColumn.column, null);
        this.lastHighlightedColumn = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (!this.isCenterContainer) return;
        const centerCtrl = this.beans.ctrlsSvc.get("center");
        const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
        const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
        let needToMoveRight;
        let needToMoveLeft;
        if (this.gos.get("enableRtl")) {
            needToMoveRight = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        } else {
            needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
            needToMoveRight = xAdjustedForScroll > lastVisiblePixel - $437b23f6a393c3bf$var$SCROLL_GAP_NEEDED_BEFORE_MOVE;
        }
        this.needToMoveRight = needToMoveRight;
        this.needToMoveLeft = needToMoveLeft;
        if (needToMoveLeft || needToMoveRight) this.ensureIntervalStarted();
        else this.ensureIntervalCleared();
    }
    ensureIntervalStarted() {
        if (this.movingIntervalId) return;
        this.intervalCount = 0;
        this.failedMoveAttempts = 0;
        this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), $437b23f6a393c3bf$var$SCROLL_TIME_INTERVAL);
        this.beans.dragAndDrop.getDragAndDropImageComponent()?.setIcon(this.needToMoveLeft ? "left" : "right", true);
    }
    ensureIntervalCleared() {
        if (!this.movingIntervalId) return;
        window.clearInterval(this.movingIntervalId);
        this.movingIntervalId = null;
        this.failedMoveAttempts = 0;
        this.beans.dragAndDrop.getDragAndDropImageComponent()?.setIcon(this.getIconName(), false);
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * $437b23f6a393c3bf$var$SCROLL_ACCELERATION_RATE;
        if (pixelsToMove > $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH) pixelsToMove = $437b23f6a393c3bf$var$SCROLL_MOVE_WIDTH;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.scrollFeature;
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop, gos: gos } = this.beans;
            if (this.failedMoveAttempts <= $437b23f6a393c3bf$var$MOVE_FAIL_THRESHOLD + 1 || !pinnedCols) return;
            dragAndDrop.getDragAndDropImageComponent()?.setIcon("pinned", false);
            if (!gos.get("suppressMoveWhenColumnDragging")) {
                const columns = this.lastDraggingEvent?.dragItem.columns;
                this.attemptToPinColumns(columns, void 0, true);
            }
        }
    }
    getPinDirection() {
        if (this.needToMoveLeft || this.pinned === "left") return "left";
        if (this.needToMoveRight || this.pinned === "right") return "right";
    }
    attemptToPinColumns(columns, pinned, fromMoving = false) {
        const allowedCols = (columns || []).filter((c)=>!c.getColDef().lockPinned);
        if (!allowedCols.length) return 0;
        if (fromMoving) pinned = this.getPinDirection();
        const { pinnedCols: pinnedCols, dragAndDrop: dragAndDrop } = this.beans;
        pinnedCols?.setColsPinned(allowedCols, pinned, "uiColumnDragged");
        if (fromMoving) dragAndDrop.nudge();
        return allowedCols.length;
    }
    destroy() {
        super.destroy();
        this.lastDraggingEvent = null;
        this.clearHighlighted();
        this.lastMovedInfo = null;
    }
};
function $437b23f6a393c3bf$var$setColumnHighlighted(column, highlighted) {
    if (column.highlighted === highlighted) return;
    column.highlighted = highlighted;
    column.dispatchColEvent("headerHighlightChanged", "uiColumnMoved");
}
function $437b23f6a393c3bf$var$findFirstAndLastMovingColumns(allMovingColumns) {
    const moveLen = allMovingColumns.length;
    let firstMovingCol;
    let lastMovingCol;
    for(let i = 0; i < moveLen; i++){
        if (!firstMovingCol) {
            const leftCol = allMovingColumns[i];
            if (leftCol.getLeft() != null) firstMovingCol = leftCol;
        }
        if (!lastMovingCol) {
            const rightCol = allMovingColumns[moveLen - 1 - i];
            if (rightCol.getLeft() != null) lastMovingCol = rightCol;
        }
        if (firstMovingCol && lastMovingCol) break;
    }
    return {
        firstMovingCol: firstMovingCol,
        lastMovingCol: lastMovingCol
    };
}
// packages/ag-grid-community/src/columnMove/columnDrag/bodyDropTarget.ts
var $437b23f6a393c3bf$var$BodyDropTarget = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        const { ctrlsSvc: ctrlsSvc, dragAndDrop: dragAndDrop } = this.beans;
        const pinned = this.pinned;
        ctrlsSvc.whenReady(this, (p)=>{
            let eSecondaryContainers;
            const eBodyViewport = p.gridBodyCtrl.eBodyViewport;
            switch(pinned){
                case "left":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.left.eContainer
                        ],
                        [
                            p.bottomLeft.eContainer
                        ],
                        [
                            p.topLeft.eContainer
                        ]
                    ];
                    break;
                case "right":
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.right.eContainer
                        ],
                        [
                            p.bottomRight.eContainer
                        ],
                        [
                            p.topRight.eContainer
                        ]
                    ];
                    break;
                default:
                    eSecondaryContainers = [
                        [
                            eBodyViewport,
                            p.center.eViewport
                        ],
                        [
                            p.bottomCenter.eViewport
                        ],
                        [
                            p.topCenter.eViewport
                        ]
                    ];
                    break;
            }
            this.eSecondaryContainers = eSecondaryContainers;
        });
        this.moveColumnFeature = this.createManagedBean(new $437b23f6a393c3bf$var$MoveColumnFeature(pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new $437b23f6a393c3bf$var$BodyDropPivotTarget(pinned));
        dragAndDrop.addDropTarget(this);
        this.addDestroyFunc(()=>dragAndDrop.removeDropTarget(this));
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.beans.colModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
    onDragCancel() {
        this.currentDropListener.onDragCancel();
    }
};
// packages/ag-grid-community/src/columnMove/columnMoveService.ts
var $437b23f6a393c3bf$var$ColumnMoveService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colMoves";
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        const gridColumns = this.beans.colModel.getCols();
        if (!gridColumns) return;
        const column = gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridColumns = colModel.getCols();
        if (!gridColumns) return;
        if (toIndex > gridColumns.length - columnsToMoveKeys.length) {
            $437b23f6a393c3bf$export$545083624300f13d(30, {
                toIndex: toIndex
            });
            return;
        }
        colAnimation?.start();
        const movedColumns = colModel.getColsForKeys(columnsToMoveKeys);
        if (this.doesMovePassRules(movedColumns, toIndex)) {
            $437b23f6a393c3bf$var$_moveInArray(colModel.getCols(), movedColumns, toIndex);
            visibleCols.refresh(source);
            eventSvc.dispatchEvent({
                type: "columnMoved",
                columns: movedColumns,
                column: movedColumns.length === 1 ? movedColumns[0] : null,
                toIndex: toIndex,
                finished: finished,
                source: source
            });
        }
        colAnimation?.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        const { colModel: colModel, gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$var$doesMovePassMarryChildren(gridOrder, colModel.getColTree())) return false;
        const doesMovePassLockedPositions = (proposedColumnOrder)=>{
            const lockPositionToPlacement = (position)=>{
                if (!position) return 0 /* NONE */ ;
                return position === "left" || position === true ? -1 /* LEFT */  : 1 /* RIGHT */ ;
            };
            const isRtl = gos.get("enableRtl");
            let lastPlacement = isRtl ? 1 /* RIGHT */  : -1 /* LEFT */ ;
            let rulePassed = true;
            proposedColumnOrder.forEach((col)=>{
                const placement = lockPositionToPlacement(col.getColDef().lockPosition);
                if (isRtl) {
                    if (placement > lastPlacement) rulePassed = false;
                } else if (placement < lastPlacement) rulePassed = false;
                lastPlacement = placement;
            });
            return rulePassed;
        };
        if (!doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const gridColumns = this.beans.colModel.getCols();
        const proposedColumnOrder = gridColumns.slice();
        $437b23f6a393c3bf$var$_moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    createBodyDropTarget(pinned, dropContainer) {
        return new $437b23f6a393c3bf$var$BodyDropTarget(pinned, dropContainer);
    }
    moveHeader(hDirection, eGui, column, pinned, bean) {
        const { ctrlsSvc: ctrlsSvc, gos: gos, colModel: colModel, visibleCols: visibleCols, focusSvc: focusSvc } = this.beans;
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const width = isGroup ? rect.width : column.getActualWidth();
        const isLeft = hDirection === "left" !== gos.get("enableRtl");
        const xPosition = $437b23f6a393c3bf$var$normaliseX({
            x: isLeft ? left - 20 : left + width + 20,
            pinned: pinned,
            fromKeyboard: true,
            gos: gos,
            ctrlsSvc: ctrlsSvc
        });
        const headerPosition = focusSvc.focusedHeader;
        $437b23f6a393c3bf$var$attemptMoveColumns({
            allMovingColumns: isGroup ? column.getLeafColumns() : [
                column
            ],
            isFromHeader: true,
            fromLeft: hDirection === "right",
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            colModel: colModel,
            colMoves: this,
            visibleCols: visibleCols,
            finished: true
        });
        let targetColumn;
        if (isGroup) {
            const displayedLeafColumns = column.getDisplayedLeafColumns();
            targetColumn = isLeft ? displayedLeafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedLeafColumns);
        } else targetColumn = column;
        ctrlsSvc.getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if ((!bean.isAlive() || gos.get("ensureDomOrder")) && headerPosition) {
            let restoreFocusColumn;
            if (isGroup) {
                const groupId = column.getGroupId();
                const leafCols = column.getLeafColumns();
                if (!leafCols.length) return;
                const parent = leafCols[0].getParent();
                if (!parent) return;
                restoreFocusColumn = $437b23f6a393c3bf$var$findGroupWidthId(parent, groupId);
            } else restoreFocusColumn = column;
            if (restoreFocusColumn) focusSvc.focusHeaderPosition({
                headerPosition: {
                    ...headerPosition,
                    column: restoreFocusColumn
                }
            });
        }
    }
    setDragSourceForHeader(eSource, column, displayName) {
        const { gos: gos, colModel: colModel, dragAndDrop: dragAndDrop, visibleCols: visibleCols } = this.beans;
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const isGroup = $437b23f6a393c3bf$export$1f44a60fc23f9028(column);
        const columns = isGroup ? column.getProvidedColumnGroup().getLeafColumns() : [
            column
        ];
        const getDragItem = isGroup ? ()=>$437b23f6a393c3bf$var$createDragItemForGroup(column, visibleCols.allCols) : ()=>$437b23f6a393c3bf$var$createDragItem(column);
        const dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? "hide" : "notAllowed",
            getDragItem: getDragItem,
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                $437b23f6a393c3bf$var$setColumnsMoving(columns, true);
            },
            onDragStopped: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onDragCancelled: ()=>$437b23f6a393c3bf$var$setColumnsMoving(columns, false),
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) {
                    const { columns: columns2 = [], visibleState: visibleState } = dragItem ?? {};
                    const hasVisibleState = isGroup ? (col)=>!visibleState || visibleState[col.getColId()] : ()=>true;
                    const unlockedColumns = columns2.filter((col)=>!col.getColDef().lockVisible && hasVisibleState(col));
                    colModel.setColsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                if (hideColumnOnExit) {
                    const unlockedColumns = dragItem?.columns?.filter((col)=>!col.getColDef().lockVisible) || [];
                    colModel.setColsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDrop.addDragSource(dragSource, true);
        return dragSource;
    }
};
function $437b23f6a393c3bf$var$findGroupWidthId(columnGroup, id) {
    while(columnGroup){
        if (columnGroup.getGroupId() === id) return columnGroup;
        columnGroup = columnGroup.getParent();
    }
    return void 0;
}
function $437b23f6a393c3bf$var$createDragItem(column) {
    const visibleState = {};
    visibleState[column.getId()] = column.isVisible();
    return {
        columns: [
            column
        ],
        visibleState: visibleState,
        containerType: column.pinned
    };
}
function $437b23f6a393c3bf$var$createDragItemForGroup(columnGroup, allCols) {
    const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
    const visibleState = {};
    allColumnsOriginalOrder.forEach((column)=>visibleState[column.getId()] = column.isVisible());
    const allColumnsCurrentOrder = [];
    allCols.forEach((column)=>{
        if (allColumnsOriginalOrder.indexOf(column) >= 0) {
            allColumnsCurrentOrder.push(column);
            $437b23f6a393c3bf$export$83a881c8b5120679(allColumnsOriginalOrder, column);
        }
    });
    allColumnsOriginalOrder.forEach((column)=>allColumnsCurrentOrder.push(column));
    const columnsInSplit = [];
    const columnGroupColumns = columnGroup.getLeafColumns();
    for (const col of allColumnsCurrentOrder)if (columnGroupColumns.indexOf(col) !== -1) columnsInSplit.push(col);
    return {
        columns: allColumnsCurrentOrder,
        columnsInSplit: columnsInSplit,
        visibleState: visibleState,
        containerType: columnsInSplit[0]?.pinned
    };
}
// packages/ag-grid-community/src/columnMove/columnMoveModule.ts
var $437b23f6a393c3bf$export$1458fbffed29c925 = {
    moduleName: "ColumnMove",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnMoveService,
        $437b23f6a393c3bf$var$ColumnAnimationService
    ],
    apiFunctions: {
        moveColumnByIndex: $437b23f6a393c3bf$var$moveColumnByIndex,
        moveColumns: $437b23f6a393c3bf$var$moveColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$export$4ad116d131ade5b4
    ],
    css: [
        $437b23f6a393c3bf$var$columnMovingCSS
    ]
};
// packages/ag-grid-community/src/rendering/autoWidthCalculator.ts
var $437b23f6a393c3bf$var$AutoWidthCalculator = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "autoWidthCalc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.getPreferredWidthForElements(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.getPreferredWidthForElements([
            eHeaderCell
        ]);
    }
    getPreferredWidthForElements(elements, extraPadding) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.eContainer;
        elements.forEach((el)=>this.cloneItemIntoDummy(el, eDummyContainer));
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eBodyContainer.removeChild(eDummyContainer);
        extraPadding = extraPadding ?? this.gos.get("autoSizePadding");
        return dummyContainerWidth + extraPadding;
    }
    getHeaderCellForColumn(column) {
        let element = null;
        this.beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((container)=>{
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        });
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
// packages/ag-grid-community/src/rendering/autoWidthModule.ts
var $437b23f6a393c3bf$var$AutoWidthModule = {
    moduleName: "AutoWidth",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AutoWidthCalculator
    ]
};
// packages/ag-grid-community/src/columnResize/columnResizeApi.ts
function $437b23f6a393c3bf$var$setColumnWidths(beans, columnWidths, finished = true, source = "api") {
    beans.colResize?.setColumnWidths(columnWidths, false, finished, source);
}
// packages/ag-grid-community/src/columnResize/groupResizeFeature.ts
var $437b23f6a393c3bf$var$GroupResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.comp = comp;
        this.eResize = eResize;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const { horizontalResizeSvc: horizontalResizeSvc, gos: gos, colAutosize: colAutosize } = this.beans;
        const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!gos.get("suppressAutoSize") && colAutosize) this.addDestroyFunc(colAutosize.addColumnGroupResize(this.eResize, this.columnGroup, ()=>this.resizeLeafColumnsToFit("uiColumnResized")));
    }
    onResizeStart(shiftKey) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = this.getInitialValues(shiftKey);
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const getInitialSizeOfColumns = (columns)=>columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
        const getSizeRatiosOfColumns = (columns, initialSizeOfColumns)=>columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize: columnsToResize,
            resizeStartWidth: resizeStartWidth,
            resizeRatios: resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.beans.colGroupSvc?.getGroupAtDirection(this.columnGroup, "After") ?? null;
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: this.resizeTakeFromCols,
            groupAfterStartWidth: this.resizeTakeFromStartWidth,
            groupAfterRatios: this.resizeTakeFromRatios
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.beans.colResize?.resizeColumnSets({
            resizeSets: resizeSets,
            finished: finished,
            source: source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
};
// packages/ag-grid-community/src/columnResize/resizeFeature.ts
var $437b23f6a393c3bf$var$ResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eResize, canResize);
            if (!canResize) return;
            const { horizontalResizeSvc: horizontalResizeSvc, colAutosize: colAutosize } = this.beans;
            const finishedWithResizeFunc = horizontalResizeSvc.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize && colAutosize) destroyResizeFuncs.push(colAutosize.addColumnAutosize(this.eResize, this.column));
        };
        const removeResize = ()=>{
            destroyResizeFuncs.forEach((f)=>f());
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.setRefreshFunction("resize", refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount: lastResizeAmount, resizeStartWidth: resizeStartWidth, beans: beans } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key: key,
                newWidth: newWidth
            }
        ];
        const { pinnedCols: pinnedCols, ctrlsSvc: ctrlsSvc, colResize: colResize } = beans;
        if (this.column.getPinned()) {
            const leftWidth = pinnedCols?.leftWidth ?? 0;
            const rightWidth = pinnedCols?.rightWidth ?? 0;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        colResize?.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.comp.toggleCss("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
// packages/ag-grid-community/src/columnResize/columnResizeService.ts
var $437b23f6a393c3bf$var$ColumnResizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colResize";
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this.beans;
        columnWidths.forEach((columnWidth)=>{
            const col = colModel.getColDefCol(columnWidth.key) || colModel.getCol(columnWidth.key);
            if (!col) return;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = visibleCols.getColAfter(col);
                if (!otherCol) return;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        });
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished: finished,
            source: source
        });
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets: resizeSets, finished: finished, source: source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>$437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        resizeSets.forEach((set)=>{
            const { width: width, columns: columns, ratios: ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            columns.forEach((col)=>allResizedCols.push(col));
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    $437b23f6a393c3bf$export$a20c7248650823a9(31);
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if (colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if (maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            columns.forEach((col)=>{
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            });
        });
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            const { colFlex: colFlex, visibleCols: visibleCols, colViewport: colViewport } = this.beans;
            flexedCols = colFlex?.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            }) ?? [];
            visibleCols.setLeftValues(source);
            visibleCols.updateBodyWidths();
            colViewport.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsForEvent, finished, source, flexedCols);
    }
    resizeHeader(column, delta, shiftKey) {
        if (!column.isResizable()) return;
        const actualWidth = column.getActualWidth();
        const minWidth = column.getMinWidth();
        const maxWidth = column.getMaxWidth();
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.setColumnWidths([
            {
                key: column,
                newWidth: newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    createResizeFeature(pinned, column, eResize, comp, ctrl) {
        return new $437b23f6a393c3bf$var$ResizeFeature(pinned, column, eResize, comp, ctrl);
    }
    createGroupResizeFeature(comp, eResize, pinned, columnGroup) {
        return new $437b23f6a393c3bf$var$GroupResizeFeature(comp, eResize, pinned, columnGroup);
    }
};
function $437b23f6a393c3bf$var$checkMinAndMaxWidthsForSet(columnResizeSet) {
    const { columns: columns, width: width } = columnResizeSet;
    let minWidthAccumulated = 0;
    let maxWidthAccumulated = 0;
    let maxWidthActive = true;
    columns.forEach((col)=>{
        const minWidth = col.getMinWidth();
        minWidthAccumulated += minWidth || 0;
        const maxWidth = col.getMaxWidth();
        if (maxWidth > 0) maxWidthAccumulated += maxWidth;
        else maxWidthActive = false;
    });
    const minWidthPasses = width >= minWidthAccumulated;
    const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
    return minWidthPasses && maxWidthPasses;
}
// packages/ag-grid-community/src/columnResize/columnResizeModule.ts
var $437b23f6a393c3bf$var$ColumnResizeModule = {
    moduleName: "ColumnResize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnResizeService
    ],
    apiFunctions: {
        setColumnWidths: $437b23f6a393c3bf$var$setColumnWidths
    },
    dependsOn: [
        $437b23f6a393c3bf$export$57b5b4ab4a8a663e,
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var $437b23f6a393c3bf$var$GroupWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListeners(this.columnGroup, {
            displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
        });
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach((column)=>{
            column.__addEventListener("widthChanged", widthChangedListener);
            column.__addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.__removeEventListener("widthChanged", widthChangedListener);
                column.__removeEventListener("visibleChanged", widthChangedListener);
            });
        });
    }
    removeListenersOnChildrenColumns() {
        this.removeChildListenersFuncs.forEach((func)=>func());
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.toggleCss("ag-hidden", columnWidth === 0);
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderGroupCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) this.setDragSource(this.eGui);
        };
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper, compBean) {
        const { column: column, beans: beans } = this;
        const { context: context, colNames: colNames, colHover: colHover, rangeSvc: rangeSvc, colResize: colResize } = beans;
        this.comp = comp;
        compBean = $437b23f6a393c3bf$var$setupCompBean(this, context, compBean);
        this.setGui(eGui, compBean);
        this.displayName = colNames.getDisplayNameForColumnGroup(column, "header");
        this.refreshHeaderStyles();
        this.addClasses();
        this.setupMovingCss(compBean);
        this.setupExpandable(compBean);
        this.setupTooltip();
        this.setupAutoHeight({
            wrapperElement: eHeaderCompWrapper,
            compBean: compBean
        });
        this.setupUserComp();
        this.addHeaderMouseListeners(compBean);
        this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this));
        this.refreshMaxHeaderHeight();
        const pinned = this.rowCtrl.pinned;
        const leafCols = column.getProvidedColumnGroup().getLeafColumns();
        colHover?.createHoverFeature(compBean, leafCols, eGui);
        rangeSvc?.createRangeHighlightFeature(compBean, column, comp);
        compBean.createManagedBean(new $437b23f6a393c3bf$var$SetLeftFeature(column, eGui, beans));
        compBean.createManagedBean(new $437b23f6a393c3bf$var$GroupWidthFeature(comp, column));
        if (colResize) this.resizeFeature = compBean.createManagedBean(colResize.createGroupResizeFeature(comp, eResize, pinned, column));
        else comp.setResizableDisplayed(false);
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addHighlightListeners(compBean, leafCols);
        compBean.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners(compBean);
        compBean.addDestroyFunc(()=>this.clearComponent());
    }
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.getDefinition();
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            columnGroup: column,
            floatingFilter: false
        });
    }
    refreshMaxHeaderHeight() {
        const { gos: gos, comp: comp } = this;
        const groupHeaderHeight = gos.get("groupHeaderHeight");
        if (groupHeaderHeight != null) {
            if (groupHeaderHeight === 0) comp.setHeaderWrapperHidden(true);
            else comp.setHeaderWrapperMaxHeight(groupHeaderHeight);
        } else {
            comp.setHeaderWrapperHidden(false);
            comp.setHeaderWrapperMaxHeight(null);
        }
    }
    addHighlightListeners(compBean, columns) {
        if (!this.beans.gos.get("suppressMoveWhenColumnDragging")) return;
        for (const column of columns)compBean.addManagedListeners(column, {
            headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, column)
        });
    }
    onLeafColumnHighlightChanged(column) {
        const displayedColumns = this.column.getDisplayedLeafColumns();
        const isFirst = displayedColumns[0] === column;
        const isLast = $437b23f6a393c3bf$export$236389741107357f(displayedColumns) === column;
        if (!isFirst && !isLast) return;
        const highlighted = column.getHighlighted();
        const isColumnMoveAtThisLevel = !!this.rowCtrl.getHeaderCellCtrls().find((ctrl)=>{
            return ctrl.column.isMoving();
        });
        let beforeOn = false;
        let afterOn = false;
        if (isColumnMoveAtThisLevel) {
            const isRtl = this.beans.gos.get("enableRtl");
            const isHighlightAfter = highlighted === 1 /* After */ ;
            const isHighlightBefore = highlighted === 0 /* Before */ ;
            if (isFirst) {
                if (isRtl) afterOn = isHighlightAfter;
                else beforeOn = isHighlightBefore;
            }
            if (isLast) {
                if (isRtl) beforeOn = isHighlightBefore;
                else afterOn = isHighlightAfter;
            }
        }
        this.comp.toggleCss("ag-header-highlight-before", beforeOn);
        this.comp.toggleCss("ag-header-highlight-after", afterOn);
    }
    resizeHeader(delta, shiftKey) {
        const { resizeFeature: resizeFeature } = this;
        if (!resizeFeature) return;
        const initialValues = resizeFeature.getInitialValues(shiftKey);
        resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    resizeLeafColumnsToFit(source) {
        this.resizeFeature?.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const { colGroupSvc: colGroupSvc, userCompFactory: userCompFactory, gos: gos, enterpriseMenuFactory: enterpriseMenuFactory } = this.beans;
        const columnGroup = this.column;
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            displayName: this.displayName,
            columnGroup: columnGroup,
            setExpanded: (expanded)=>{
                colGroupSvc.setColumnGroupOpened(providedColumnGroup, expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                gos.assertModuleRegistered("Tooltip", 3);
                this.setupTooltip(value, shouldDisplayTooltip);
            },
            showColumnMenu: (buttonElement, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterButtonClick(providedColumnGroup, buttonElement, "columnMenu", onClosedCallback),
            showColumnMenuAfterMouseClick: (mouseEvent, onClosedCallback)=>enterpriseMenuFactory?.showMenuAfterMouseEvent(providedColumnGroup, mouseEvent, "columnMenu", onClosedCallback),
            eGridHeader: this.eGui
        });
        const compDetails = $437b23f6a393c3bf$var$_getHeaderGroupCompDetails(userCompFactory, params);
        if (compDetails) this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners(compBean) {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column.getProvidedColumnGroup());
        compBean.addManagedListeners(this.eGui, {
            mouseenter: listener,
            mouseleave: listener,
            click: clickListener,
            contextmenu: contextMenuListener
        });
    }
    handleMouseOverChange(isMouseOver) {
        this.eventSvc.dispatchEvent({
            type: isMouseOver ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
            column: this.column.getProvidedColumnGroup()
        });
    }
    setupTooltip(value, shouldDisplayTooltip) {
        this.tooltipFeature = this.beans.tooltipSvc?.setupHeaderGroupTooltip(this.tooltipFeature, this, value, shouldDisplayTooltip);
    }
    setupExpandable(compBean) {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        const listener = this.refreshExpanded.bind(this);
        compBean.addManagedListeners(providedColGroup, {
            expandedChanged: listener,
            expandableChanged: listener
        });
    }
    refreshExpanded() {
        const { column: column } = this;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
        this.refreshHeaderStyles();
    }
    addClasses() {
        const { column: column } = this;
        const colGroupDef = column.getColGroupDef();
        const classes = $437b23f6a393c3bf$export$9ba3bd48c77c5e8a(colGroupDef, this.gos, null, column);
        if (column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else {
            classes.push("ag-header-group-cell-with-group");
            if (colGroupDef?.wrapHeaderText) classes.push("ag-header-cell-wrap-text");
        }
        classes.forEach((c)=>this.comp.toggleCss(c, true));
    }
    setupMovingCss(compBean) {
        const { column: column } = this;
        const providedColumnGroup = column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.toggleCss("ag-header-cell-moving", column.isMoving());
        leafColumns.forEach((col)=>{
            compBean.addManagedListeners(col, {
                movingChanged: listener
            });
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) this.focusThis();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!this.expandable || !wrapperHasFocus) return;
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
            const column = this.column;
            const newExpandedValue = !column.isExpanded();
            this.beans.colGroupSvc.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        this.dragSource = this.beans.colMoves?.setDragSourceForHeader(eHeaderGroup, this.column, this.displayName) ?? null;
    }
    isSuppressMoving() {
        return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((column)=>column.getColDef().suppressMovable || column.getColDef().lockPosition);
    }
    destroy() {
        this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupApi.ts
function $437b23f6a393c3bf$var$setColumnGroupOpened(beans, group, newValue) {
    beans.colGroupSvc?.setColumnGroupOpened(group, newValue, "api");
}
function $437b23f6a393c3bf$var$getColumnGroup(beans, name, instanceId) {
    return beans.colGroupSvc?.getColumnGroup(name, instanceId) ?? null;
}
function $437b23f6a393c3bf$var$getProvidedColumnGroup(beans, name) {
    return beans.colGroupSvc?.getProvidedColGroup(name) ?? null;
}
function $437b23f6a393c3bf$var$getDisplayNameForColumnGroup(beans, columnGroup, location) {
    return beans.colNames.getDisplayNameForColumnGroup(columnGroup, location) || "";
}
function $437b23f6a393c3bf$var$getColumnGroupState(beans) {
    return beans.colGroupSvc?.getColumnGroupState() ?? [];
}
function $437b23f6a393c3bf$var$setColumnGroupState(beans, stateItems) {
    beans.colGroupSvc?.setColumnGroupState(stateItems, "api");
}
function $437b23f6a393c3bf$var$resetColumnGroupState(beans) {
    beans.colGroupSvc?.resetColumnGroupState("api");
}
function $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeLeft;
}
function $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeCenter;
}
function $437b23f6a393c3bf$var$getRightDisplayedColumnGroups(beans) {
    return beans.visibleCols.treeRight;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumnGroups(beans) {
    return beans.visibleCols.getAllTrees();
}
// packages/ag-grid-community/src/columns/visibleColsService.ts
function $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++){
        const index = array.indexOf(toRemove[i]);
        if (index >= 0) {
            array[index] = array[array.length - 1];
            array.pop();
        }
    }
}
var $437b23f6a393c3bf$var$VisibleColsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "visibleCols";
        // for fast lookup, to see if a column or group is still visible
        this.colsAndGroupsMap = {};
        // leave level columns of the displayed trees
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        // all three lists above combined
        this.allCols = [];
        // used by:
        // + angularGrid -> for setting body width
        // + rowController -> setting main row widths (when inserting and resizing)
        // need to cache this
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.isBodyWidthDirty = true;
    }
    refresh(source, skipTreeBuild = false) {
        const { colFlex: colFlex, colModel: colModel, colGroupSvc: colGroupSvc, colViewport: colViewport, selectionColSvc: selectionColSvc } = this.beans;
        if (!skipTreeBuild) this.buildTrees(colModel, colGroupSvc);
        colGroupSvc?.updateOpenClosedVisibility();
        this.leftCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeLeft);
        this.centerCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeCenter);
        this.rightCols = $437b23f6a393c3bf$var$pickDisplayedCols(this.treeRight);
        selectionColSvc?.refreshVisibility(this.leftCols, this.centerCols, this.rightCols);
        this.joinColsAriaOrder(colModel);
        this.joinCols();
        this.setLeftValues(source);
        this.autoHeightCols = this.allCols.filter((col)=>col.isAutoHeight());
        colFlex?.refreshFlexedColumns();
        this.updateBodyWidths();
        colViewport.checkViewportColumns(false);
        this.setFirstRightAndLastLeftPinned(colModel, this.leftCols, this.rightCols, source);
        this.eventSvc.dispatchEvent({
            type: "displayedColumnsChanged",
            source: source
        });
    }
    // after setColumnWidth or updateGroupsAndPresentedCols
    updateBodyWidths() {
        const newBodyWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.centerCols);
        const newLeftWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
        const newRightWidth = $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
        this.isBodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            this.eventSvc.dispatchEvent({
                type: "columnContainerWidthChanged"
            });
            this.eventSvc.dispatchEvent({
                type: "displayedColumnsWidthChanged"
            });
        }
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfCols(source);
        this.setLeftValuesOfGroups();
    }
    setFirstRightAndLastLeftPinned(colModel, leftCols, rightCols, source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = leftCols ? leftCols[0] : null;
            firstRight = rightCols ? $437b23f6a393c3bf$export$236389741107357f(rightCols) : null;
        } else {
            lastLeft = leftCols ? $437b23f6a393c3bf$export$236389741107357f(leftCols) : null;
            firstRight = rightCols ? rightCols[0] : null;
        }
        colModel.getCols().forEach((col)=>{
            col.setLastLeftPinned(col === lastLeft, source);
            col.setFirstRightPinned(col === firstRight, source);
        });
    }
    buildTrees(colModel, columnGroupSvc) {
        const cols = colModel.getColsToShow();
        const leftCols = cols.filter((col)=>col.getPinned() == "left");
        const rightCols = cols.filter((col)=>col.getPinned() == "right");
        const centerCols = cols.filter((col)=>col.getPinned() != "left" && col.getPinned() != "right");
        const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
        const createGroups = (params)=>{
            return columnGroupSvc ? columnGroupSvc.createColumnGroups(params) : params.columns;
        };
        this.treeLeft = createGroups({
            columns: leftCols,
            idCreator: idCreator,
            pinned: "left",
            oldDisplayedGroups: this.treeLeft
        });
        this.treeRight = createGroups({
            columns: rightCols,
            idCreator: idCreator,
            pinned: "right",
            oldDisplayedGroups: this.treeRight
        });
        this.treeCenter = createGroups({
            columns: centerCols,
            idCreator: idCreator,
            pinned: null,
            oldDisplayedGroups: this.treeCenter
        });
        this.updateColsAndGroupsMap();
    }
    clear() {
        this.leftCols = [];
        this.rightCols = [];
        this.centerCols = [];
        this.allCols = [];
        this.ariaOrderColumns = [];
    }
    joinColsAriaOrder(colModel) {
        const allColumns = colModel.getCols();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    getAriaColIndex(colOrGroup) {
        let col;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colOrGroup)) col = colOrGroup.getLeafColumns()[0];
        else col = colOrGroup;
        return this.ariaOrderColumns.indexOf(col) + 1;
    }
    setLeftValuesOfGroups() {
        [
            this.treeLeft,
            this.treeRight,
            this.treeCenter
        ].forEach((columns)=>{
            columns.forEach((column)=>{
                if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
                    const columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    }
    setLeftValuesOfCols(source) {
        const { colModel: colModel } = this.beans;
        const primaryCols = colModel.getColDefCols();
        if (!primaryCols) return;
        const allColumns = colModel.getCols().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        [
            this.leftCols,
            this.rightCols,
            this.centerCols
        ].forEach((columns)=>{
            if (doingRtl) {
                let left = $437b23f6a393c3bf$var$getWidthOfColsInList(columns);
                columns.forEach((column)=>{
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                });
            } else {
                let left = 0;
                columns.forEach((column)=>{
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                });
            }
            $437b23f6a393c3bf$var$_removeAllFromUnorderedArray(allColumns, columns);
        });
        allColumns.forEach((column)=>{
            column.setLeft(null, source);
        });
    }
    joinCols() {
        if (this.gos.get("enableRtl")) this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols);
        else this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
    }
    getAllTrees() {
        if (this.treeLeft && this.treeRight && this.treeCenter) return this.treeLeft.concat(this.treeCenter).concat(this.treeRight);
        return null;
    }
    // gridPanel -> ensureColumnVisible
    isColDisplayed(column) {
        return this.allCols.indexOf(column) >= 0;
    }
    getLeftColsForRow(rowNode) {
        const { leftCols: leftCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return leftCols;
        return this.getColsForRow(rowNode, leftCols);
    }
    getRightColsForRow(rowNode) {
        const { rightCols: rightCols, beans: { colModel: colModel } } = this;
        const colSpanActive = colModel.colSpanActive;
        if (!colSpanActive) return rightCols;
        return this.getColsForRow(rowNode, rightCols);
    }
    getColsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                columnsToCheckFilter.forEach((colForFilter)=>{
                    if (filterCallback(colForFilter)) filterPasses = true;
                });
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    getColBefore(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    isPinningLeft() {
        return this.leftCols.length > 0;
    }
    isPinningRight() {
        return this.rightCols.length > 0;
    }
    updateColsAndGroupsMap() {
        this.colsAndGroupsMap = {};
        const func = (child)=>{
            this.colsAndGroupsMap[child.getUniqueId()] = child;
        };
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeCenter, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeLeft, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.treeRight, false, func);
    }
    isVisible(item) {
        const fromMap = this.colsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    getFirstColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "leftCols",
            "centerCols",
            "rightCols"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]];
            if (container.length) return isRtl ? $437b23f6a393c3bf$export$236389741107357f(container) : container[0];
        }
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getColAfter(col) {
        const allDisplayedColumns = this.allCols;
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getColsLeftWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.leftCols);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return $437b23f6a393c3bf$var$getWidthOfColsInList(this.rightCols);
    }
    isColAtEdge(col, edge) {
        const allColumns = this.allCols;
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(col)) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : $437b23f6a393c3bf$export$236389741107357f(allColumns)) === columnToCompare;
    }
};
function $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
function $437b23f6a393c3bf$var$pickDisplayedCols(tree) {
    const res = [];
    $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, true, (child)=>{
        if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) res.push(child);
    });
    return res;
}
// packages/ag-grid-community/src/columns/columnGroups/columnGroupService.ts
var $437b23f6a393c3bf$var$ColumnGroupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colGroupSvc";
    }
    getColumnGroupState() {
        const columnGroupState = [];
        const gridBalancedTree = this.beans.colModel.getColTree();
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, gridBalancedTree, (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    resetColumnGroupState(source) {
        const primaryColumnTree = this.beans.colModel.getColDefColTree();
        if (!primaryColumnTree) return;
        const stateItems = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, primaryColumnTree, (child)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    setColumnGroupState(stateItems, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const gridBalancedTree = colModel.getColTree();
        if (!gridBalancedTree.length) return;
        colAnimation?.start();
        const impactedGroups = [];
        stateItems.forEach((stateItem)=>{
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColGroup(groupKey);
            if (!providedColumnGroup) return;
            if (providedColumnGroup.isExpanded() === newValue) return;
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        });
        visibleCols.refresh(source, true);
        if (impactedGroups.length) eventSvc.dispatchEvent({
            type: "columnGroupOpened",
            columnGroup: impactedGroups.length === 1 ? impactedGroups[0] : void 0,
            columnGroups: impactedGroups
        });
        colAnimation?.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(key)) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColGroup(key) {
        let res = null;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.beans.colModel.getColTree(), (node)=>{
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(node)) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    getGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? $437b23f6a393c3bf$export$236389741107357f(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getCol${direction}`;
        while(true){
            const column = this.beans.visibleCols[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    updateOpenClosedVisibility() {
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) child.calculateDisplayedColumns();
        });
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(colId)) return colId;
        const allColumnGroups = this.beans.visibleCols.getAllTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(child)) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    createColumnGroups(params) {
        const { columns: columns, idCreator: idCreator, pinned: pinned, oldDisplayedGroups: oldDisplayedGroups, isStandaloneStructure: isStandaloneStructure } = params;
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = columns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, idCreator, oldColumnsMapped, pinned, isStandaloneStructure);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(thisNode) ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = $437b23f6a393c3bf$export$1f44a60fc23f9028(previousNode) ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        if (!isStandaloneStructure) this.setupParentsIntoCols(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createProvidedColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const groupId = columnKeyCreator.getUniqueKey(colGroupDef.groupId || null, null);
        const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, colGroupDef, groupId);
        const providedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        const existingGroup = existingGroupAndIndex?.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = $437b23f6a393c3bf$var$_recursivelyCreateColumns(this.beans, colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    balanceColumnTree(unbalancedTree, currentDepth, columnDepth, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(child)) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDepth + 1, columnDepth, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = columnDepth - 1; j >= currentDepth; j--){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = $437b23f6a393c3bf$var$createMergedColGroupDef(this.beans, null, newColId);
                    const paddedGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(colGroupDefMerged, newColId, true, currentDepth);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>$437b23f6a393c3bf$export$bb4bfad2b594b78e(leaf));
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findDepth(balancedColumnTree) {
        let depth = 0;
        let pointer = balancedColumnTree;
        while(pointer && pointer[0] && $437b23f6a393c3bf$export$bb4bfad2b594b78e(pointer[0])){
            depth++;
            pointer = pointer[0].getChildren();
        }
        return depth;
    }
    findMaxDepth(treeChildren, depth) {
        let maxDepthThisLevel = depth;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if ($437b23f6a393c3bf$export$bb4bfad2b594b78e(abstractColumn)) {
                const originalGroup = abstractColumn;
                const newDepth = this.findMaxDepth(originalGroup.getChildren(), depth + 1);
                if (maxDepthThisLevel < newDepth) maxDepthThisLevel = newDepth;
            }
        }
        return maxDepthThisLevel;
    }
    /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */ balanceTreeForAutoCols(autoCols, depth) {
        const tree = [];
        autoCols.forEach((col)=>{
            let nextChild = col;
            for(let i = depth - 1; i >= 0; i--){
                const autoGroup = new $437b23f6a393c3bf$export$7ff27642a6ecc1cf(null, `FAKE_PATH_${col.getId()}}_${i}`, true, i);
                this.createBean(autoGroup);
                autoGroup.setChildren([
                    nextChild
                ]);
                nextChild.originalParent = autoGroup;
                nextChild = autoGroup;
            }
            if (depth === 0) col.originalParent = null;
            tree.push(nextChild);
        });
        return tree;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned, isStandaloneStructure) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = $437b23f6a393c3bf$var$createUniqueColumnGroupId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new $437b23f6a393c3bf$export$273c80940a54c770(providedGroup, groupId, instanceId, pinned);
            if (!isStandaloneStructure) this.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            columnsOrGroups.forEach((columnOrGroup)=>{
                if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnOrGroup)) {
                    const columnGroup = columnOrGroup;
                    result[columnOrGroup.getUniqueId()] = columnGroup;
                    recursive(columnGroup.getChildren());
                }
            });
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoCols(columnsOrGroups, parent) {
        columnsOrGroups.forEach((columnsOrGroup)=>{
            columnsOrGroup.parent = parent;
            if ($437b23f6a393c3bf$export$1f44a60fc23f9028(columnsOrGroup)) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoCols(columnGroup.getChildren(), columnGroup);
            }
        });
    }
};
// packages/ag-grid-community/src/columns/columnGroups/columnGroupModule.ts
var $437b23f6a393c3bf$export$922da35340a6d14e = {
    moduleName: "ColumnGroup",
    version: $437b23f6a393c3bf$var$VERSION,
    dynamicBeans: {
        headerGroupCellCtrl: $437b23f6a393c3bf$var$HeaderGroupCellCtrl
    },
    beans: [
        $437b23f6a393c3bf$var$ColumnGroupService
    ],
    apiFunctions: {
        getAllDisplayedColumnGroups: $437b23f6a393c3bf$var$getAllDisplayedColumnGroups,
        getCenterDisplayedColumnGroups: $437b23f6a393c3bf$var$getCenterDisplayedColumnGroups,
        getColumnGroup: $437b23f6a393c3bf$var$getColumnGroup,
        getColumnGroupState: $437b23f6a393c3bf$var$getColumnGroupState,
        getDisplayNameForColumnGroup: $437b23f6a393c3bf$var$getDisplayNameForColumnGroup,
        getLeftDisplayedColumnGroups: $437b23f6a393c3bf$var$getLeftDisplayedColumnGroups,
        getProvidedColumnGroup: $437b23f6a393c3bf$var$getProvidedColumnGroup,
        getRightDisplayedColumnGroups: $437b23f6a393c3bf$var$getRightDisplayedColumnGroups,
        resetColumnGroupState: $437b23f6a393c3bf$var$resetColumnGroupState,
        setColumnGroupOpened: $437b23f6a393c3bf$var$setColumnGroupOpened,
        setColumnGroupState: $437b23f6a393c3bf$var$setColumnGroupState
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/cellRendererModule.ts
var $437b23f6a393c3bf$var$CheckboxCellRendererModule = {
    moduleName: "CheckboxCellRenderer",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellRenderer: $437b23f6a393c3bf$var$CheckboxCellRenderer
    }
};
// packages/ag-grid-community/src/columns/columnApi.ts
function $437b23f6a393c3bf$var$getColumnDef(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return column.getColDef();
    return null;
}
function $437b23f6a393c3bf$var$getColumnDefs(beans) {
    return beans.colModel.getColumnDefs();
}
function $437b23f6a393c3bf$var$getDisplayNameForColumn(beans, column, location) {
    return beans.colNames.getDisplayNameForColumn(column, location) || "";
}
function $437b23f6a393c3bf$var$getColumn(beans, key) {
    return beans.colModel.getColDefCol(key);
}
function $437b23f6a393c3bf$var$getColumns(beans) {
    return beans.colModel.getColDefCols();
}
function $437b23f6a393c3bf$var$applyColumnState(beans, params) {
    return $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, params, "api");
}
function $437b23f6a393c3bf$var$getColumnState(beans) {
    return $437b23f6a393c3bf$export$e7d9af1fb362df7b(beans);
}
function $437b23f6a393c3bf$var$resetColumnState(beans) {
    $437b23f6a393c3bf$export$96a6cbc000255060(beans, "api");
}
function $437b23f6a393c3bf$var$isPinning(beans) {
    return beans.visibleCols.isPinningLeft() || beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$isPinningLeft(beans) {
    return beans.visibleCols.isPinningLeft();
}
function $437b23f6a393c3bf$var$isPinningRight(beans) {
    return beans.visibleCols.isPinningRight();
}
function $437b23f6a393c3bf$var$getDisplayedColAfter(beans, col) {
    return beans.visibleCols.getColAfter(col);
}
function $437b23f6a393c3bf$var$getDisplayedColBefore(beans, col) {
    return beans.visibleCols.getColBefore(col);
}
function $437b23f6a393c3bf$var$setColumnsVisible(beans, keys, visible) {
    beans.colModel.setColsVisible(keys, visible, "api");
}
function $437b23f6a393c3bf$var$setColumnsPinned(beans, keys, pinned) {
    beans.pinnedCols?.setColsPinned(keys, pinned, "api");
}
function $437b23f6a393c3bf$var$getAllGridColumns(beans) {
    return beans.colModel.getCols();
}
function $437b23f6a393c3bf$var$getDisplayedLeftColumns(beans) {
    return beans.visibleCols.leftCols;
}
function $437b23f6a393c3bf$var$getDisplayedCenterColumns(beans) {
    return beans.visibleCols.centerCols;
}
function $437b23f6a393c3bf$var$getDisplayedRightColumns(beans) {
    return beans.visibleCols.rightCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedColumns(beans) {
    return beans.visibleCols.allCols;
}
function $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns(beans) {
    return beans.colViewport.getViewportColumns();
}
// packages/ag-grid-community/src/columns/columnDefFactory.ts
function $437b23f6a393c3bf$var$_deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    Object.keys(obj).forEach((key)=>{
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || $437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) return;
        const value = obj[key];
        const sourceIsSimpleObject = typeof value === "object" && value !== null && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = $437b23f6a393c3bf$var$_deepCloneDefinition(value);
        else res[key] = value;
    });
    return res;
}
var $437b23f6a393c3bf$var$ColumnDefFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colDefFactory";
    }
    wireBeans(beans) {
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.pivotColsSvc = beans.pivotColsSvc;
    }
    getColumnDefs(colDefColsList, showingPivotResult, lastOrder, colsList) {
        const cols = colDefColsList.slice();
        if (showingPivotResult) cols.sort((a, b)=>lastOrder.indexOf(a) - lastOrder.indexOf(b));
        else if (lastOrder) cols.sort((a, b)=>colsList.indexOf(a) - colsList.indexOf(b));
        const rowGroupColumns = this.rowGroupColsSvc?.columns;
        const pivotColumns = this.pivotColsSvc?.columns;
        return this.buildColumnDefs(cols, rowGroupColumns, pivotColumns);
    }
    buildColumnDefs(cols, rowGroupColumns = [], pivotColumns = []) {
        const res = [];
        const colGroupDefs = {};
        cols.forEach((col)=>{
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        });
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = $437b23f6a393c3bf$var$_deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSort() ? col.getSort() : null;
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
// packages/ag-grid-community/src/columns/columnFlexService.ts
var $437b23f6a393c3bf$var$ColumnFlexService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFlex";
    }
    refreshFlexedColumns(params = {}) {
        const source = params.source ?? "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        const totalSpace = this.flexViewportWidth;
        if (!totalSpace) return [];
        const { visibleCols: visibleCols } = this.beans;
        const visibleCenterCols = visibleCols.centerCols;
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            for(let i = visibleCenterCols.length - 1; i >= 0; i--)if (allResizingCols.has(visibleCenterCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let hasFlexItems = false;
        const items = visibleCenterCols.map((col, i)=>{
            const flex = col.getFlex();
            const isFlex = flex != null && flex > 0 && i > flexAfterDisplayIndex;
            hasFlexItems || (hasFlexItems = isFlex);
            return {
                col: col,
                isFlex: isFlex,
                flex: Math.max(0, flex ?? 0),
                initialSize: col.getActualWidth(),
                min: col.getMinWidth(),
                max: col.getMaxWidth(),
                targetSize: 0
            };
        });
        if (!hasFlexItems) return [];
        let unfrozenItemCount = items.length;
        let unfrozenFlex = items.reduce((acc, item)=>acc + item.flex, 0);
        let unfrozenSpace = totalSpace;
        const freeze = (item, width)=>{
            item.frozenSize = width;
            item.col.setActualWidth(width, source);
            unfrozenSpace -= width;
            unfrozenFlex -= item.flex;
            unfrozenItemCount -= 1;
        };
        const isFrozen = (item)=>item.frozenSize != null;
        for (const item of items)if (!item.isFlex) freeze(item, item.initialSize);
        while(unfrozenItemCount > 0){
            const spaceToFill = Math.round(unfrozenFlex < 1 ? unfrozenSpace * unfrozenFlex : unfrozenSpace);
            let lastUnfrozenItem;
            let actualLeft = 0;
            let idealRight = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                lastUnfrozenItem = item;
                idealRight += spaceToFill * (item.flex / unfrozenFlex);
                const idealSize = idealRight - actualLeft;
                const roundedSize = Math.round(idealSize);
                item.targetSize = roundedSize;
                actualLeft += roundedSize;
            }
            if (lastUnfrozenItem) lastUnfrozenItem.targetSize += spaceToFill - actualLeft;
            let totalViolation = 0;
            for (const item of items){
                if (isFrozen(item)) continue;
                const unclampedSize = item.targetSize;
                const clampedSize = Math.min(Math.max(unclampedSize, item.min), item.max);
                totalViolation += clampedSize - unclampedSize;
                item.violationType = clampedSize === unclampedSize ? void 0 : clampedSize < unclampedSize ? "max" : "min";
                item.targetSize = clampedSize;
            }
            const freezeType = totalViolation === 0 ? "all" : totalViolation > 0 ? "min" : "max";
            for (const item of items){
                if (isFrozen(item)) continue;
                if (freezeType === "all" || item.violationType === freezeType) freeze(item, item.targetSize);
            }
        }
        if (!params.skipSetLeft) visibleCols.setLeftValues(source);
        if (params.updateBodyWidths) visibleCols.updateBodyWidths();
        const unconstrainedFlexColumns = items.filter((item)=>item.isFlex && !item.violationType).map((item)=>item.col);
        if (params.fireResizedEvent) {
            const changedColumns = items.filter((item)=>item.initialSize !== item.frozenSize).map((item)=>item.col);
            const flexingColumns = items.filter((item)=>item.flex).map((item)=>item.col);
            $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, changedColumns, true, source, flexingColumns);
        }
        return unconstrainedFlexColumns;
    }
    initCol(column) {
        const { flex: flex, initialFlex: initialFlex } = column.colDef;
        if (flex !== void 0) column.flex = flex;
        else if (initialFlex !== void 0) column.flex = initialFlex;
    }
    // this method should only be used by the colModel to
    // change flex when required by the applyColumnState method.
    setColFlex(column, flex) {
        column.flex = flex ?? null;
        column.dispatchStateUpdatedEvent("flex");
    }
};
// packages/ag-grid-community/src/columns/dataTypeService.ts
var $437b23f6a393c3bf$var$DataTypeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "dataTypeSvc";
        this.dataTypeDefinitions = {};
        this.isPendingInference = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.colModel.recreateColumnDefs(event);
        });
    }
    processDataTypeDefinitions() {
        const defaultDataTypes = this.getDefaultDataTypes();
        const newDataTypeDefinitions = {};
        this.dataTypeDefinitions = newDataTypeDefinitions;
        const newFormatValueFuncs = {};
        this.formatValueFuncs = newFormatValueFuncs;
        const generateFormatValueFunc = (dataTypeDefinition)=>{
            return (params)=>{
                const { column: column, node: node, value: value } = params;
                let valueFormatter = column.getColDef().valueFormatter;
                if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
                return this.beans.valueSvc.formatValue(column, node, value, valueFormatter);
            };
        };
        for (const cellDataType of Object.keys(defaultDataTypes)){
            const dataTypeDefinition = defaultDataTypes[cellDataType];
            const mergedDataTypeDefinition = {
                ...dataTypeDefinition,
                groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(dataTypeDefinition, this.gos)
            };
            newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
            newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
        }
        const dataTypeDefinitions = this.gos.get("dataTypeDefinitions") ?? {};
        const newDataTypeMatchers = {};
        this.dataTypeMatchers = newDataTypeMatchers;
        for (const cellDataType of Object.keys(dataTypeDefinitions)){
            const dataTypeDefinition = dataTypeDefinitions[cellDataType];
            const mergedDataTypeDefinition = this.processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                newDataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (dataTypeDefinition.dataTypeMatcher) newDataTypeMatchers[cellDataType] = dataTypeDefinition.dataTypeMatcher;
                newFormatValueFuncs[cellDataType] = generateFormatValueFunc(mergedDataTypeDefinition);
            }
        }
        this.checkObjectValueHandlers(defaultDataTypes);
        [
            "dateString",
            "text",
            "number",
            "boolean",
            "date"
        ].forEach((cellDataType)=>{
            const overriddenDataTypeMatcher = newDataTypeMatchers[cellDataType];
            if (overriddenDataTypeMatcher) delete newDataTypeMatchers[cellDataType];
            newDataTypeMatchers[cellDataType] = overriddenDataTypeMatcher ?? defaultDataTypes[cellDataType].dataTypeMatcher;
        });
    }
    processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = dataTypeDefinition.extendsDataType;
        if (dataTypeDefinition.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (dataTypeDefinition.extendsDataType === dataTypeDefinition.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(baseDataTypeDefinition, dataTypeDefinition);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                $437b23f6a393c3bf$export$545083624300f13d(44);
                return void 0;
            }
            const extendedDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (!$437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, dataTypeDefinitions, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = $437b23f6a393c3bf$var$mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, dataTypeDefinition);
        }
        return {
            ...mergedDataTypeDefinition,
            groupSafeValueFormatter: $437b23f6a393c3bf$var$createGroupSafeValueFormatter(mergedDataTypeDefinition, this.gos)
        };
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        let { cellDataType: cellDataType } = userColDef;
        const { field: field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            $437b23f6a393c3bf$export$545083624300f13d(47, {
                cellDataType: cellDataType
            });
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    addColumnListeners(column) {
        if (!this.isPendingInference) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.__addEventListener("columnStateUpdated", columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.__removeEventListener("columnStateUpdated", columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        const { gos: gos } = this;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if ($437b23f6a393c3bf$var$doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = gos.get("columnTypes") ?? {};
            const hasPropsPreventingInference = $437b23f6a393c3bf$var$convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && $437b23f6a393c3bf$var$doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !$437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    inferCellDataType(field, colId) {
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
            value = $437b23f6a393c3bf$var$_getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        return Object.keys(this.dataTypeMatchers).find((_cellDataType)=>this.dataTypeMatchers[_cellDataType](value)) ?? "object";
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData?.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.beans.rowModel.rootNode?.allLeafChildren;
            if (rowNodes?.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isPendingInference) return;
        this.isPendingInference = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        const { colAutosize: colAutosize, eventSvc: eventSvc } = this.beans;
        if (columnTypeOverridesExist && colAutosize) colAutosize.shouldQueueResizeOperations = true;
        const [destroyFunc] = this.addManagedEventListeners({
            rowDataUpdateStarted: (event)=>{
                const { firstRowData: firstRowData } = event;
                if (!firstRowData) return;
                destroyFunc?.();
                this.isPendingInference = false;
                this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
                this.columnStateUpdatesPendingInference = {};
                if (columnTypeOverridesExist) colAutosize?.processResizeOperations();
                eventSvc.dispatchEvent({
                    type: "dataTypesInferred"
                });
            }
        });
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.destroyColumnStateUpdateListeners();
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        for (const colId of Object.keys(this.columnStateUpdatesPendingInference)){
            const columnStateUpdates = this.columnStateUpdatesPendingInference[colId];
            const column = this.colModel.getCol(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.resetColDefIntoCol(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        }
        if (columnTypeOverridesExist) state.push(...this.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
            state: state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        const existingColumnStateUpdates = {};
        const { rowGroupColsSvc: rowGroupColsSvc, pivotColsSvc: pivotColsSvc } = this.beans;
        rowGroupColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedRowGroupColumnState);
        pivotColsSvc?.restoreColumnOrder(existingColumnStateUpdates, updatedPivotColumnState);
        return Object.values(existingColumnStateUpdates);
    }
    resetColDefIntoCol(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = $437b23f6a393c3bf$export$310bdd432cb2279e(this.beans, userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    checkObjectValueHandlers(defaultDataTypes) {
        const resolvedObjectDataTypeDefinition = this.dataTypeDefinitions.object;
        const defaultObjectDataTypeDefinition = defaultDataTypes.object;
        this.hasObjectValueParser = resolvedObjectDataTypeDefinition.valueParser !== defaultObjectDataTypeDefinition.valueParser;
        this.hasObjectValueFormatter = resolvedObjectDataTypeDefinition.valueFormatter !== defaultObjectDataTypeDefinition.valueFormatter;
    }
    getDateStringTypeDefinition(column) {
        const { dateString: dateString } = this.dataTypeDefinitions;
        if (!column) return dateString;
        return this.getDataTypeDefinition(column) ?? dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        return this.getDataTypeDefinition(column)?.baseDataType;
    }
    checkType(column, value) {
        if (value == null) return true;
        const dataTypeMatcher = this.getDataTypeDefinition(column)?.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        const warning = (property)=>$437b23f6a393c3bf$export$545083624300f13d(48, {
                property: property
            });
        if (colDef.cellDataType === "object") {
            const { object: object } = this.dataTypeDefinitions;
            if (colDef.valueFormatter === object.groupSafeValueFormatter && !this.hasObjectValueFormatter) warning("Formatter");
            if (colDef.editable && colDef.valueParser === object.valueParser && !this.hasObjectValueParser) warning("Parser");
        }
    }
    getFormatValue(cellDataType) {
        return this.formatValueFuncs[cellDataType];
    }
    isColPendingInference(colId) {
        return this.isPendingInference && !!this.columnStateUpdatesPendingInference[colId];
    }
    setColDefPropertiesForBaseDataType(colDef, cellDataType, dataTypeDefinition, colId) {
        const formatValue = this.formatValueFuncs[cellDataType];
        switch(dataTypeDefinition.baseDataType){
            case "number":
                colDef.cellEditor = "agNumberCellEditor";
                break;
            case "boolean":
                colDef.cellEditor = "agCheckboxCellEditor";
                colDef.cellRenderer = "agCheckboxCellRenderer";
                colDef.getFindText = ()=>null;
                colDef.suppressKeyboardEvent = (params)=>!!params.colDef.editable && params.event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE;
                break;
            case "date":
                colDef.cellEditor = "agDateCellEditor";
                colDef.keyCreator = formatValue;
                break;
            case "dateString":
                colDef.cellEditor = "agDateStringCellEditor";
                colDef.keyCreator = formatValue;
                break;
            case "object":
                colDef.cellEditorParams = {
                    useFormatter: true
                };
                colDef.comparator = (a, b)=>{
                    const column = this.colModel.getColDefCol(colId);
                    const colDef2 = column?.getColDef();
                    if (!column || !colDef2) return 0;
                    const valA = a == null ? "" : formatValue({
                        column: column,
                        node: null,
                        value: a
                    });
                    const valB = b == null ? "" : formatValue({
                        column: column,
                        node: null,
                        value: b
                    });
                    if (valA === valB) return 0;
                    return valA > valB ? 1 : -1;
                };
                colDef.keyCreator = formatValue;
                break;
        }
        this.beans.filterManager?.setColDefPropertiesForDataType(colDef, dataTypeDefinition, formatValue);
    }
    getDefaultDataTypes() {
        const defaultDateFormatMatcher = (value)=>!!value.match("^\\d{4}-\\d{2}-\\d{2}$");
        const translate = this.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>params.newValue?.trim?.() === "" ? null : Number(params.newValue),
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : $437b23f6a393c3bf$export$2a74c29220d5c88e(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    if (params.newValue == null) return params.newValue;
                    return params.newValue?.trim?.() === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: {
                baseDataType: "date",
                valueParser: (params)=>$437b23f6a393c3bf$export$26ded2d88c01b527(params.newValue == null ? null : String(params.newValue)),
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                    return $437b23f6a393c3bf$export$3d7fedfb21962874(params.value, false) ?? "";
                },
                dataTypeMatcher: (value)=>value instanceof Date
            },
            dateString: {
                baseDataType: "dateString",
                dateParser: (value)=>$437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0,
                dateFormatter: (value)=>$437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, false) ?? void 0,
                valueParser: (params)=>defaultDateFormatMatcher(String(params.newValue)) ? params.newValue : null,
                valueFormatter: (params)=>defaultDateFormatMatcher(String(params.value)) ? params.value : "",
                dataTypeMatcher: (value)=>typeof value === "string" && defaultDateFormatMatcher(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>$437b23f6a393c3bf$export$2a74c29220d5c88e(params.value) ?? ""
            }
        };
    }
    destroyColumnStateUpdateListeners() {
        this.columnStateUpdateListenerDestroyFuncs.forEach((destroyFunc)=>destroyFunc());
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    destroy() {
        this.dataTypeDefinitions = {};
        this.dataTypeMatchers = {};
        this.formatValueFuncs = {};
        this.columnStateUpdatesPendingInference = {};
        this.destroyColumnStateUpdateListeners();
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
    const mergedDataTypeDefinition = {
        ...parentDataTypeDefinition,
        ...childDataTypeDefinition
    };
    if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
        ...$437b23f6a393c3bf$var$convertColumnTypes(parentDataTypeDefinition.columnTypes),
        ...$437b23f6a393c3bf$var$convertColumnTypes(childDataTypeDefinition.columnTypes)
    ];
    return mergedDataTypeDefinition;
}
function $437b23f6a393c3bf$var$validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
    if (!parentDataTypeDefinition) {
        $437b23f6a393c3bf$export$545083624300f13d(45, {
            parentCellDataType: parentCellDataType
        });
        return false;
    }
    if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
        $437b23f6a393c3bf$export$545083624300f13d(46);
        return false;
    }
    return true;
}
function $437b23f6a393c3bf$var$createGroupSafeValueFormatter(dataTypeDefinition, gos) {
    if (!dataTypeDefinition.valueFormatter) return void 0;
    return (params)=>{
        if (params.node?.group) {
            const aggFunc = (params.colDef.pivotValueColumn ?? params.column).getAggFunc();
            if (aggFunc) {
                if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                    if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                    if (typeof params.value === "object") {
                        if (!params.value) return void 0;
                        if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.toNumber()
                        });
                        if ("value" in params.value) return dataTypeDefinition.valueFormatter({
                            ...params,
                            value: params.value.value
                        });
                    }
                }
                return void 0;
            }
            if (gos.get("groupDisplayType") === "groupRows" && !gos.get("treeData")) return void 0;
        } else if (gos.get("groupHideOpenParents") && params.column.isRowGroupActive()) {
            if (typeof params.value === "string" && !dataTypeDefinition.dataTypeMatcher?.(params.value)) return void 0;
        }
        return dataTypeDefinition.valueFormatter(params);
    };
}
function $437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
    if (!checkProps[prop]) return false;
    const value = colDef[prop];
    if (value === null) {
        checkProps[prop] = false;
        return false;
    } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
}
function $437b23f6a393c3bf$var$doColDefPropsPreventInference(colDef, propsToCheckForInference) {
    return [
        [
            "cellRenderer",
            "agSparklineCellRenderer"
        ],
        [
            "valueGetter",
            void 0
        ],
        [
            "valueParser",
            void 0
        ],
        [
            "refData",
            void 0
        ]
    ].some(([prop, comparisonValue])=>$437b23f6a393c3bf$var$doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
}
function $437b23f6a393c3bf$var$getUpdatedColumnState(column, columnStateUpdates) {
    const columnState = $437b23f6a393c3bf$var$getColumnStateFromColDef(column);
    columnStateUpdates.forEach((key)=>{
        delete columnState[key];
        if (key === "rowGroup") delete columnState.rowGroupIndex;
        else if (key === "pivot") delete columnState.pivotIndex;
    });
    return columnState;
}
// packages/ag-grid-community/src/columns/columnModule.ts
var $437b23f6a393c3bf$var$DataTypeModule = {
    moduleName: "DataType",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$DataTypeService
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$CheckboxCellRendererModule
    ]
};
var $437b23f6a393c3bf$var$ColumnFlexModule = {
    moduleName: "ColumnFlex",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFlexService
    ]
};
var $437b23f6a393c3bf$export$5c4abee658e86c68 = {
    moduleName: "ColumnApi",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnDefFactory
    ],
    apiFunctions: {
        getColumnDef: $437b23f6a393c3bf$var$getColumnDef,
        getDisplayNameForColumn: $437b23f6a393c3bf$var$getDisplayNameForColumn,
        getColumn: $437b23f6a393c3bf$var$getColumn,
        getColumns: $437b23f6a393c3bf$var$getColumns,
        applyColumnState: $437b23f6a393c3bf$var$applyColumnState,
        getColumnState: $437b23f6a393c3bf$var$getColumnState,
        resetColumnState: $437b23f6a393c3bf$var$resetColumnState,
        isPinning: $437b23f6a393c3bf$var$isPinning,
        isPinningLeft: $437b23f6a393c3bf$var$isPinningLeft,
        isPinningRight: $437b23f6a393c3bf$var$isPinningRight,
        getDisplayedColAfter: $437b23f6a393c3bf$var$getDisplayedColAfter,
        getDisplayedColBefore: $437b23f6a393c3bf$var$getDisplayedColBefore,
        setColumnsVisible: $437b23f6a393c3bf$var$setColumnsVisible,
        setColumnsPinned: $437b23f6a393c3bf$var$setColumnsPinned,
        getAllGridColumns: $437b23f6a393c3bf$var$getAllGridColumns,
        getDisplayedLeftColumns: $437b23f6a393c3bf$var$getDisplayedLeftColumns,
        getDisplayedCenterColumns: $437b23f6a393c3bf$var$getDisplayedCenterColumns,
        getDisplayedRightColumns: $437b23f6a393c3bf$var$getDisplayedRightColumns,
        getAllDisplayedColumns: $437b23f6a393c3bf$var$getAllDisplayedColumns,
        getAllDisplayedVirtualColumns: $437b23f6a393c3bf$var$getAllDisplayedVirtualColumns,
        getColumnDefs: $437b23f6a393c3bf$var$getColumnDefs
    }
};
// packages/ag-grid-community/src/columns/columnNameService.ts
function $437b23f6a393c3bf$var$_camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
var $437b23f6a393c3bf$var$ColumnNameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colNames";
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        const { aggColNameSvc: aggColNameSvc } = this.beans;
        if (includeAggFunc && aggColNameSvc) return aggColNameSvc.getHeaderName(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup?.getColGroupDef();
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                providedColumnGroup: providedColumnGroup,
                location: location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.beans.expressionSvc?.evaluate(headerValueGetter, params) ?? null;
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return $437b23f6a393c3bf$var$_camelCaseToHumanText(colDef.field);
        return "";
    }
};
// packages/ag-grid-community/src/columns/columnViewportService.ts
var $437b23f6a393c3bf$var$ColumnViewportService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colViewport";
        // cols in center that are in the viewport
        this.colsWithinViewport = [];
        // same as colsWithinViewport, except we always include columns with headerAutoHeight
        this.headerColsWithinViewport = [];
        // A hash key to keep track of changes in viewport columns
        this.colsWithinViewportHash = "";
        // all columns & groups to be rendered, index by row.
        // used by header rows to get all items to render for that row.
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
    }
    postConstruct() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
    }
    setScrollPosition(scrollWidth, scrollPosition, afterScroll = false) {
        const { visibleCols: visibleCols } = this;
        const bodyWidthDirty = visibleCols.isBodyWidthDirty;
        const noChange = scrollWidth === this.scrollWidth && scrollPosition === this.scrollPosition && !bodyWidthDirty;
        if (noChange) return;
        this.scrollWidth = scrollWidth;
        this.scrollPosition = scrollPosition;
        visibleCols.isBodyWidthDirty = true;
        if (this.gos.get("enableRtl")) {
            const bodyWidth = visibleCols.bodyWidth;
            this.viewportLeft = bodyWidth - scrollPosition - scrollWidth;
            this.viewportRight = bodyWidth - scrollPosition;
        } else {
            this.viewportLeft = scrollPosition;
            this.viewportRight = scrollWidth + scrollPosition;
        }
        if (this.colModel.ready) this.checkViewportColumns(afterScroll);
    }
    getHeadersToRender(type, depth) {
        let result;
        switch(type){
            case "left":
                result = this.rowsOfHeadersToRenderLeft[depth];
                break;
            case "right":
                result = this.rowsOfHeadersToRenderRight[depth];
                break;
            default:
                result = this.rowsOfHeadersToRenderCenter[depth];
                break;
        }
        return result || [];
    }
    extractViewportColumns() {
        const displayedColumnsCenter = this.visibleCols.centerCols;
        if (this.isColumnVirtualisationSuppressed()) {
            this.colsWithinViewport = displayedColumnsCenter;
            this.headerColsWithinViewport = displayedColumnsCenter;
        } else {
            this.colsWithinViewport = displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerColsWithinViewport = displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    clear(suppressHashClear) {
        this.rowsOfHeadersToRenderLeft = {};
        this.rowsOfHeadersToRenderRight = {};
        this.rowsOfHeadersToRenderCenter = {};
        if (!suppressHashClear) this.colsWithinViewportHash = "";
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight() || $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col)) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by Grid API only
    getViewportColumns() {
        const { leftCols: leftCols, rightCols: rightCols } = this.visibleCols;
        const res = this.colsWithinViewport.concat(leftCols).concat(rightCols);
        return res;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getColsWithinViewport(rowNode) {
        if (!this.colModel.colSpanActive) return this.colsWithinViewport;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(left) && left > this.viewportLeft;
        };
        const inViewportCallback = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this);
        const { visibleCols: visibleCols } = this;
        const displayedColumnsCenter = visibleCols.centerCols;
        return visibleCols.getColsForRow(rowNode, displayedColumnsCenter, inViewportCallback, emptySpaceBeforeColumn);
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        const viewportColumnsChanged = this.extractViewport();
        if (viewportColumnsChanged) this.eventSvc.dispatchEvent({
            type: "virtualColumnsChanged",
            afterScroll: afterScroll
        });
    }
    calculateHeaderRows() {
        this.clear(true);
        const renderedColIds = {};
        const { leftCols: leftCols, rightCols: rightCols, treeLeft: treeLeft, treeRight: treeRight, treeCenter: treeCenter } = this.visibleCols;
        const allRenderedCols = this.headerColsWithinViewport.concat(leftCols).concat(rightCols);
        allRenderedCols.forEach((col)=>renderedColIds[col.getId()] = true);
        const testGroup = (children, result, depth)=>{
            let returnValue = false;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                let addThisItem = false;
                if ($437b23f6a393c3bf$export$891484e65a02ec71(child)) addThisItem = renderedColIds[child.getId()] === true;
                else {
                    const columnGroup = child;
                    const displayedChildren = columnGroup.getDisplayedChildren();
                    if (displayedChildren) addThisItem = testGroup(displayedChildren, result, depth + 1);
                }
                if (addThisItem) {
                    returnValue = true;
                    if (!result[depth]) result[depth] = [];
                    result[depth].push(child);
                }
            }
            return returnValue;
        };
        testGroup(treeLeft, this.rowsOfHeadersToRenderLeft, 0);
        testGroup(treeRight, this.rowsOfHeadersToRenderRight, 0);
        testGroup(treeCenter, this.rowsOfHeadersToRenderCenter, 0);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.getViewportColumns().map(hashColumn).join("#");
        const changed = this.colsWithinViewportHash !== newHash;
        if (changed) {
            this.colsWithinViewportHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
};
function $437b23f6a393c3bf$var$isAnyParentAutoHeaderHeight(col) {
    while(col){
        if (col.isAutoHeaderHeight()) return true;
        col = col.getParent();
    }
    return false;
}
// packages/ag-grid-community/src/components/framework/agComponentUtils.ts
var $437b23f6a393c3bf$var$AgComponentUtils = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "agCompUtils";
    }
    adaptFunction(type, jsCompFunc) {
        if (!type.cellRenderer) return null;
        class Adapter {
            refresh() {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = jsCompFunc(params);
                const type2 = typeof callbackResult;
                if (type2 === "string" || type2 === "number" || type2 === "boolean") {
                    this.eGui = $437b23f6a393c3bf$export$b1f57d075ca6d5fb("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = $437b23f6a393c3bf$export$a232bb0480ae674a({
                        tag: "span"
                    });
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
};
// packages/ag-grid-community/src/components/framework/cellRendererFunctionModule.ts
var $437b23f6a393c3bf$var$CellRendererFunctionModule = {
    moduleName: "CellRendererFunction",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AgComponentUtils
    ]
};
// packages/ag-grid-community/src/components/framework/registry.ts
var $437b23f6a393c3bf$var$Registry = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "registry";
        this.agGridDefaults = {};
        this.agGridDefaultParams = {};
        this.jsComps = {};
        this.dynamicBeans = {};
        this.selectors = {};
        this.icons = {};
    }
    postConstruct() {
        const comps = this.gos.get("components");
        if (comps != null) for (const key of Object.keys(comps))this.jsComps[key] = comps[key];
    }
    registerModule(module) {
        const { icons: icons, userComponents: userComponents, dynamicBeans: dynamicBeans, selectors: selectors } = module;
        if (userComponents) {
            const registerUserComponent = (name, component, params)=>{
                this.agGridDefaults[name] = component;
                if (params) this.agGridDefaultParams[name] = params;
            };
            for (const name of Object.keys(userComponents)){
                const comp = userComponents[name];
                if (typeof comp === "object") registerUserComponent(name, comp.classImp, comp.params);
                else registerUserComponent(name, comp);
            }
        }
        if (dynamicBeans) for (const name of Object.keys(dynamicBeans))this.dynamicBeans[name] = dynamicBeans[name];
        selectors?.forEach((selector)=>{
            this.selectors[selector.selector] = selector;
        });
        if (icons) for (const name of Object.keys(icons))this.icons[name] = icons[name];
    }
    getUserComponent(propertyName, name) {
        const createResult = (component, componentFromFramework, params)=>({
                componentFromFramework: componentFromFramework,
                component: component,
                params: params
            });
        const { frameworkOverrides: frameworkOverrides } = this.beans;
        const registeredViaFrameworkComp = frameworkOverrides.frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = frameworkOverrides.isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) return createResult(defaultComponent, false, this.agGridDefaultParams[name]);
        this.beans.validation?.missingUserComponent(propertyName, name, this.agGridDefaults, this.jsComps);
        return null;
    }
    createDynamicBean(name, mandatory, ...args) {
        const BeanClass = this.dynamicBeans[name];
        if (BeanClass == null) {
            if (mandatory) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(256));
            return void 0;
        }
        return new BeanClass(...args);
    }
    getSelector(name) {
        return this.selectors[name];
    }
    getIcon(name) {
        return this.icons[name];
    }
};
// packages/ag-grid-community/src/ctrlsService.ts
var $437b23f6a393c3bf$var$NUM_CTRLS = 23;
var $437b23f6a393c3bf$var$CtrlsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "ctrlsSvc";
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    postConstruct() {
        this.addEventListener("ready", ()=>{
            this.updateReady();
            if (this.ready) {
                this.readyCallbacks.forEach((c)=>c(this.params));
                this.readyCallbacks.length = 0;
            }
        }, this.beans.frameworkOverrides.runWhenReadyAsync?.() ?? false);
    }
    updateReady() {
        const values = Object.values(this.params);
        this.ready = values.length === $437b23f6a393c3bf$var$NUM_CTRLS && values.every((ctrl)=>{
            return ctrl?.isAlive() ?? false;
        });
    }
    whenReady(caller, callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
        caller.addDestroyFunc(()=>{
            const index = this.readyCallbacks.indexOf(callback);
            if (index >= 0) this.readyCallbacks.splice(index, 1);
        });
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.updateReady();
        if (this.ready) this.dispatchLocalEvent({
            type: "ready"
        });
        ctrl.addDestroyFunc(()=>{
            this.updateReady();
        });
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        const { leftHeader: leftHeader, centerHeader: centerHeader, rightHeader: rightHeader } = this.params;
        return [
            leftHeader,
            rightHeader,
            centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        const params = this.params;
        switch(pinned){
            case "left":
                return params.leftHeader;
            case "right":
                return params.rightHeader;
            default:
                return params.centerHeader;
        }
    }
    getScrollFeature() {
        return this.getGridBodyCtrl().scrollFeature;
    }
};
// packages/ag-grid-community/src/theming/core/core.css-GENERATED.ts
var $437b23f6a393c3bf$var$coreCSS = /*css*/ `:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none}}:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-viewport{position:relative}.ag-spanning-container{position:absolute;top:0;z-index:1}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-floating-bottom-container,.ag-floating-top-container,.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-animation.ag-prevent-animation) .ag-row{transition:none!important;&:where(.ag-row.ag-after-created){transition:none!important}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-top:not(.ag-invisible)){border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}:where(.ag-floating-bottom:not(.ag-invisible)){border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%;z-index:1}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-large-text-input{display:block}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row,.ag-spanned-row{color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);white-space:nowrap;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px) - 2px)}.ag-row{background-color:var(--ag-background-color);border-bottom:var(--ag-row-border);height:var(--ag-row-height);width:100%}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}.ag-spanned-cell-wrapper{background-color:var(--ag-background-color);position:absolute}.ag-spanned-cell-wrapper>.ag-spanned-cell{display:block;position:relative}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-cell-wrap-text:not(.ag-cell-auto-height)) .ag-cell-wrapper{align-items:normal;height:100%;:where(.ag-cell-value){height:100%}}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-context-menu-open .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}.ag-full-width-row.ag-row-focus:focus{box-shadow:none}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-header-range-highlight{background-color:var(--ag-range-header-highlight-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{contain:paint;display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-chart,.ag-dnd-ghost,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab}.ag-list-item,.ag-virtual-list-item{height:var(--ag-list-item-height)}.ag-virtual-list-item{position:absolute;width:100%}.ag-select-list{background-color:var(--ag-picker-list-background-color);border:var(--ag-picker-list-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-list-item{align-items:center;display:flex;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}:where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;color:var(--ag-icon-color);display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly,.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{background-color:var(--ag-icon-button-background-color);border-radius:var(--ag-icon-button-border-radius);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-background-color);color:var(--ag-icon-button-color);&:hover{background-color:var(--ag-icon-button-hover-background-color);box-shadow:0 0 0 var(--ag-icon-button-background-spread) var(--ag-icon-button-hover-background-color);color:var(--ag-icon-button-hover-color)}}.ag-filter-active{background-image:linear-gradient(var(--ag-icon-button-active-background-color),var(--ag-icon-button-active-background-color));border-radius:1px;outline:solid var(--ag-icon-button-background-spread) var(--ag-icon-button-active-background-color);position:relative;&:after{background-color:var(--ag-accent-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z");color:var(--ag-icon-button-active-color)}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto}.ag-menu,.ag-resizer{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-resizer{pointer-events:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize;height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{cursor:nesw-resize;height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;cursor:nwse-resize;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;cursor:nesw-resize;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}`;
// packages/ag-grid-community/src/theming/inject.ts
var $437b23f6a393c3bf$var$IS_SSR = typeof window !== "object" || !window?.document?.fonts?.forEach;
var $437b23f6a393c3bf$var$_injectGlobalCSS = (css, styleContainer, debugId, layer, priority, nonce)=>{
    if ($437b23f6a393c3bf$var$IS_SSR) return;
    if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
    if (layer) css = `@layer ${CSS.escape(layer)} { ${css} }`;
    let injections = $437b23f6a393c3bf$var$injectionState.map.get(styleContainer);
    if (!injections) {
        injections = [];
        $437b23f6a393c3bf$var$injectionState.map.set(styleContainer, injections);
    }
    if (injections.find((i)=>i.css === css)) return;
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.dataset.agGlobalCss = debugId;
    el.textContent = css;
    const newInjection = {
        css: css,
        el: el,
        priority: priority
    };
    let insertAfter;
    for (const injection of injections){
        if (injection.priority > priority) break;
        insertAfter = injection;
    }
    if (insertAfter) {
        insertAfter.el.insertAdjacentElement("afterend", el);
        const index = injections.indexOf(insertAfter);
        injections.splice(index + 1, 0, newInjection);
    } else {
        styleContainer.insertBefore(el, styleContainer.querySelector(":not(title, meta)"));
        injections.push(newInjection);
    }
};
var $437b23f6a393c3bf$var$_injectCoreAndModuleCSS = (styleContainer, layer, nonce)=>{
    $437b23f6a393c3bf$var$_injectGlobalCSS($437b23f6a393c3bf$var$coreCSS, styleContainer, "core", layer, 0, nonce);
    Array.from($437b23f6a393c3bf$var$_getAllRegisteredModules()).sort((a, b)=>a.moduleName.localeCompare(b.moduleName)).forEach((module)=>module.css?.forEach((css)=>$437b23f6a393c3bf$var$_injectGlobalCSS(css, styleContainer, `module-${module.moduleName}`, layer, 0, nonce)));
};
var $437b23f6a393c3bf$var$_registerGridUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.add(environment);
};
var $437b23f6a393c3bf$var$_unregisterGridUsingThemingAPI = (environment)=>{
    $437b23f6a393c3bf$var$injectionState.grids.delete(environment);
    if ($437b23f6a393c3bf$var$injectionState.grids.size === 0) {
        $437b23f6a393c3bf$var$injectionState.map = /* @__PURE__ */ new WeakMap();
        for (const style of document.head.querySelectorAll("style[data-ag-global-css]"))style.remove();
    }
};
var $437b23f6a393c3bf$var$_a;
var $437b23f6a393c3bf$var$injectionState = ($437b23f6a393c3bf$var$_a = typeof window === "object" ? window : {}).agStyleInjectionState ?? ($437b23f6a393c3bf$var$_a.agStyleInjectionState = {
    map: /* @__PURE__ */ new WeakMap(),
    grids: /* @__PURE__ */ new Set()
});
// packages/ag-grid-community/src/theming/Part.ts
var $437b23f6a393c3bf$export$6e6f0e372f4cb988 = (args)=>{
    return new $437b23f6a393c3bf$var$PartImpl(args);
};
var $437b23f6a393c3bf$var$defaultModeName = "$default";
var $437b23f6a393c3bf$var$partCounter = 0;
var $437b23f6a393c3bf$var$PartImpl = class {
    constructor({ feature: feature, params: params, modeParams: modeParams = {}, css: css, cssImports: cssImports }){
        this.feature = feature;
        this.css = css;
        this.cssImports = cssImports;
        this.modeParams = {
            // NOTE: it's important that default is defined first, putting it
            // first in iteration order, because when merging params the default
            // params override any prior modal params, so modal params in this
            // part need to come after default params to prevent them from being
            // immediately overridden.
            [$437b23f6a393c3bf$var$defaultModeName]: {
                ...modeParams[$437b23f6a393c3bf$var$defaultModeName] ?? {},
                ...params ?? {}
            },
            ...modeParams
        };
    }
    use(styleContainer, layer, nonce) {
        let inject = this._inject;
        if (inject == null) {
            let { css: css } = this;
            if (css) {
                const className = `ag-theme-${this.feature ?? "part"}-${++$437b23f6a393c3bf$var$partCounter}`;
                if (typeof css === "function") css = css();
                css = `:where(.${className}) {
${css}
}
`;
                for (const cssImport of this.cssImports ?? [])css = `@import url(${JSON.stringify(cssImport)});
${css}`;
                inject = {
                    css: css,
                    class: className
                };
            } else inject = false;
            this._inject = inject;
        }
        if (inject && styleContainer) $437b23f6a393c3bf$var$_injectGlobalCSS(inject.css, styleContainer, inject.class, layer, 1, nonce);
        return inject ? inject.class : false;
    }
};
// packages/ag-grid-community/src/theming/theme-utils.ts
var $437b23f6a393c3bf$var$kebabCase = (str)=>str.replace(/[A-Z]/g, (m)=>`-${m}`).toLowerCase();
var $437b23f6a393c3bf$var$paramToVariableName = (paramName)=>`--ag-${$437b23f6a393c3bf$var$kebabCase(paramName)}`;
var $437b23f6a393c3bf$var$paramToVariableExpression = (paramName)=>`var(${$437b23f6a393c3bf$var$paramToVariableName(paramName)})`;
var $437b23f6a393c3bf$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
var $437b23f6a393c3bf$var$memoize = (fn)=>{
    const values = /* @__PURE__ */ new Map();
    return (a)=>{
        const key = a;
        if (!values.has(key)) values.set(key, fn(a));
        return values.get(key);
    };
};
var $437b23f6a393c3bf$var$accentMix = (mix)=>({
        ref: "accentColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix
    });
var $437b23f6a393c3bf$var$foregroundBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "backgroundColor"
    });
var $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix = (mix)=>({
        ref: "foregroundColor",
        mix: mix,
        onto: "headerBackgroundColor"
    });
var $437b23f6a393c3bf$var$backgroundColor = {
    ref: "backgroundColor"
};
var $437b23f6a393c3bf$var$foregroundColor = {
    ref: "foregroundColor"
};
var $437b23f6a393c3bf$var$accentColor = {
    ref: "accentColor"
};
// packages/ag-grid-community/src/theming/core/core-css.ts
var $437b23f6a393c3bf$var$defaultLightColorSchemeParams = {
    backgroundColor: "#fff",
    foregroundColor: "#181d1f",
    borderColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.02),
    browserColorScheme: "light"
};
var $437b23f6a393c3bf$var$coreDefaults = {
    ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
    textColor: $437b23f6a393c3bf$var$foregroundColor,
    accentColor: "#2196f3",
    invalidColor: "#e02525",
    wrapperBorder: true,
    rowBorder: true,
    headerRowBorder: true,
    footerRowBorder: {
        ref: "rowBorder"
    },
    columnBorder: {
        style: "solid",
        width: 1,
        color: "transparent"
    },
    headerColumnBorder: false,
    headerColumnBorderHeight: "100%",
    pinnedColumnBorder: true,
    pinnedRowBorder: true,
    sidePanelBorder: true,
    sideBarPanelWidth: 250,
    sideBarBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    sideButtonBarBackgroundColor: {
        ref: "sideBarBackgroundColor"
    },
    sideButtonBarTopPadding: 0,
    sideButtonSelectedUnderlineWidth: 2,
    sideButtonSelectedUnderlineColor: "transparent",
    sideButtonSelectedUnderlineTransitionDuration: 0,
    sideButtonBackgroundColor: "transparent",
    sideButtonTextColor: {
        ref: "textColor"
    },
    sideButtonHoverBackgroundColor: {
        ref: "sideButtonBackgroundColor"
    },
    sideButtonHoverTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    sideButtonSelectedTextColor: {
        ref: "sideButtonTextColor"
    },
    sideButtonBorder: "solid 1px transparent",
    sideButtonSelectedBorder: true,
    sideButtonLeftPadding: {
        ref: "spacing"
    },
    sideButtonRightPadding: {
        ref: "spacing"
    },
    sideButtonVerticalPadding: {
        calc: "spacing * 3"
    },
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Oxygen-Sans",
        "Ubuntu",
        "Cantarell",
        "Helvetica Neue",
        "sans-serif"
    ],
    headerBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    headerFontFamily: {
        ref: "fontFamily"
    },
    cellFontFamily: {
        ref: "fontFamily"
    },
    headerFontWeight: 500,
    headerFontSize: {
        ref: "fontSize"
    },
    dataFontSize: {
        ref: "fontSize"
    },
    headerTextColor: {
        ref: "textColor"
    },
    headerCellHoverBackgroundColor: "transparent",
    headerCellMovingBackgroundColor: {
        ref: "headerCellHoverBackgroundColor"
    },
    headerCellBackgroundTransitionDuration: "0.2s",
    cellTextColor: {
        ref: "textColor"
    },
    subtleTextColor: {
        ref: "textColor",
        mix: 0.5
    },
    rangeSelectionBorderStyle: "solid",
    rangeSelectionBorderColor: $437b23f6a393c3bf$var$accentColor,
    rangeSelectionBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
    rangeSelectionChartBackgroundColor: "#0058FF1A",
    rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
    rangeSelectionHighlightColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rangeHeaderHighlightColor: $437b23f6a393c3bf$var$foregroundHeaderBackgroundMix(0.08),
    rowNumbersSelectedColor: $437b23f6a393c3bf$var$accentMix(0.5),
    rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.08),
    columnHoverColor: $437b23f6a393c3bf$var$accentMix(0.05),
    selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.12),
    modalOverlayBackgroundColor: {
        ref: "backgroundColor",
        mix: 0.66
    },
    oddRowBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    borderRadius: 4,
    wrapperBorderRadius: 8,
    cellHorizontalPadding: {
        calc: "spacing * 2 * cellHorizontalPaddingScale"
    },
    cellWidgetSpacing: {
        calc: "spacing * 1.5"
    },
    cellHorizontalPaddingScale: 1,
    rowGroupIndentSize: {
        calc: "cellWidgetSpacing + iconSize"
    },
    valueChangeDeltaUpColor: "#43a047",
    valueChangeDeltaDownColor: "#e53935",
    valueChangeValueHighlightBackgroundColor: "#16a08580",
    spacing: 8,
    fontSize: 14,
    rowHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
    },
    rowVerticalPaddingScale: 1,
    headerHeight: {
        calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
    },
    headerVerticalPaddingScale: 1,
    popupShadow: "0 0 16px #00000026",
    cardShadow: "0 1px 4px 1px #00000018",
    dropdownShadow: {
        ref: "cardShadow"
    },
    dragAndDropImageBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    dragAndDropImageBorder: true,
    dragAndDropImageShadow: {
        ref: "popupShadow"
    },
    dragHandleColor: $437b23f6a393c3bf$var$foregroundMix(0.7),
    focusShadow: {
        spread: 3,
        color: $437b23f6a393c3bf$var$accentMix(0.5)
    },
    headerColumnResizeHandleHeight: "30%",
    headerColumnResizeHandleWidth: 2,
    headerColumnResizeHandleColor: {
        ref: "borderColor"
    },
    widgetContainerHorizontalPadding: {
        calc: "spacing * 1.5"
    },
    widgetContainerVerticalPadding: {
        calc: "spacing * 1.5"
    },
    widgetHorizontalSpacing: {
        calc: "spacing * 1.5"
    },
    widgetVerticalSpacing: {
        ref: "spacing"
    },
    listItemHeight: {
        calc: "max(iconSize, dataFontSize) + widgetVerticalSpacing"
    },
    iconSize: 16,
    iconColor: "inherit",
    iconButtonColor: {
        ref: "iconColor"
    },
    iconButtonBackgroundColor: "transparent",
    iconButtonBackgroundSpread: 4,
    iconButtonBorderRadius: 1,
    iconButtonHoverColor: {
        ref: "iconButtonColor"
    },
    iconButtonHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.1),
    iconButtonActiveColor: $437b23f6a393c3bf$var$accentColor,
    iconButtonActiveBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.28),
    iconButtonActiveIndicatorColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonWidth: 28,
    toggleButtonHeight: 18,
    toggleButtonOnBackgroundColor: $437b23f6a393c3bf$var$accentColor,
    toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
    toggleButtonSwitchBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    toggleButtonSwitchInset: 2,
    menuBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.03),
    menuTextColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.95),
    menuShadow: {
        ref: "popupShadow"
    },
    menuSeparatorColor: {
        ref: "borderColor"
    },
    setFilterIndentSize: {
        ref: "iconSize"
    },
    chartMenuPanelWidth: 260,
    chartMenuLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.8),
    dialogShadow: {
        ref: "popupShadow"
    },
    cellEditingBorder: {
        color: $437b23f6a393c3bf$var$accentColor
    },
    cellEditingShadow: {
        ref: "cardShadow"
    },
    dialogBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.2)
    },
    panelBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
    panelTitleBarBackgroundColor: {
        ref: "headerBackgroundColor"
    },
    panelTitleBarIconColor: {
        ref: "headerTextColor"
    },
    panelTitleBarTextColor: {
        ref: "headerTextColor"
    },
    panelTitleBarFontWeight: {
        ref: "headerFontWeight"
    },
    panelTitleBarBorder: true,
    columnSelectIndentSize: {
        ref: "iconSize"
    },
    toolPanelSeparatorBorder: true,
    tooltipBackgroundColor: {
        ref: "chromeBackgroundColor"
    },
    tooltipTextColor: {
        ref: "textColor"
    },
    tooltipBorder: true,
    columnDropCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    columnDropCellTextColor: {
        ref: "textColor"
    },
    columnDropCellDragHandleColor: {
        ref: "textColor"
    },
    columnDropCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    selectCellBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.07),
    selectCellBorder: {
        color: $437b23f6a393c3bf$var$foregroundMix(0.13)
    },
    advancedFilterBuilderButtonBarBorder: true,
    advancedFilterBuilderIndentSize: {
        calc: "spacing * 2 + iconSize"
    },
    advancedFilterBuilderJoinPillColor: "#f08e8d",
    advancedFilterBuilderColumnPillColor: "#a6e194",
    advancedFilterBuilderOptionPillColor: "#f3c08b",
    advancedFilterBuilderValuePillColor: "#85c0e4",
    findMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findMatchBackgroundColor: "#ffff00",
    findActiveMatchColor: $437b23f6a393c3bf$var$foregroundColor,
    findActiveMatchBackgroundColor: "#ffa500",
    filterToolPanelGroupIndent: {
        ref: "spacing"
    },
    rowLoadingSkeletonEffectColor: $437b23f6a393c3bf$var$foregroundMix(0.15),
    statusBarLabelColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarLabelFontWeight: 500,
    statusBarValueColor: $437b23f6a393c3bf$var$foregroundColor,
    statusBarValueFontWeight: 500,
    pinnedSourceRowTextColor: {
        ref: "textColor"
    },
    pinnedSourceRowBackgroundColor: {
        ref: "backgroundColor"
    },
    pinnedSourceRowFontWeight: 600,
    pinnedRowFontWeight: 600,
    pinnedRowBackgroundColor: {
        ref: "backgroundColor"
    },
    pinnedRowTextColor: {
        ref: "textColor"
    }
};
// packages/ag-grid-community/src/theming/parts/button-style/button-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$buttonStyleBaseCSS = /*css*/ `:where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:disabled{cursor:default}&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-button-background-color);border:var(--ag-button-border);border-radius:var(--ag-button-border-radius);color:var(--ag-button-text-color);cursor:pointer;font-weight:var(--ag-button-font-weight);padding:var(--ag-button-vertical-padding) var(--ag-button-horizontal-padding);&:hover{background-color:var(--ag-button-hover-background-color);border:var(--ag-button-hover-border);color:var(--ag-button-hover-text-color)}&:active{background-color:var(--ag-button-active-background-color);border:var(--ag-button-active-border);color:var(--ag-button-active-text-color)}&:disabled{background-color:var(--ag-button-disabled-background-color);border:var(--ag-button-disabled-border);color:var(--ag-button-disabled-text-color)}}`;
// packages/ag-grid-community/src/theming/parts/button-style/button-styles.ts
var $437b23f6a393c3bf$var$baseParams = {
    buttonTextColor: "inherit",
    buttonFontWeight: "normal",
    buttonBackgroundColor: "transparent",
    buttonBorder: false,
    buttonBorderRadius: {
        ref: "borderRadius"
    },
    buttonHorizontalPadding: {
        calc: "spacing * 2"
    },
    buttonVerticalPadding: {
        ref: "spacing"
    },
    buttonHoverTextColor: {
        ref: "buttonTextColor"
    },
    buttonHoverBackgroundColor: {
        ref: "buttonBackgroundColor"
    },
    buttonHoverBorder: {
        ref: "buttonBorder"
    },
    buttonActiveTextColor: {
        ref: "buttonHoverTextColor"
    },
    buttonActiveBackgroundColor: {
        ref: "buttonHoverBackgroundColor"
    },
    buttonActiveBorder: {
        ref: "buttonHoverBorder"
    },
    buttonDisabledTextColor: {
        ref: "inputDisabledTextColor"
    },
    buttonDisabledBackgroundColor: {
        ref: "inputDisabledBackgroundColor"
    },
    buttonDisabledBorder: {
        ref: "inputDisabledBorder"
    }
};
var $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: $437b23f6a393c3bf$var$baseParams,
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$ac3227978dde8e12 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: true,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$a70529c52057ad6a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams,
            buttonBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            buttonFontWeight: 600,
            buttonTextColor: $437b23f6a393c3bf$var$accentColor,
            buttonHoverBackgroundColor: {
                ref: "rowHoverColor"
            },
            buttonActiveBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            buttonActiveTextColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$c5a38eb31ae86567 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "buttonStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams,
            buttonBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "outset"
            },
            buttonActiveBorder: {
                color: $437b23f6a393c3bf$var$foregroundColor,
                width: 2,
                style: "inset"
            },
            buttonBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.07),
            buttonHoverBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            buttonVerticalPadding: {
                calc: "spacing * 0.5"
            }
        },
        css: $437b23f6a393c3bf$var$buttonStyleBaseCSS
    });
var $437b23f6a393c3bf$export$effe67f8e12191d5 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeButtonStyleBalhamTreeShakeable();
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStyleBorderedCSS = /*css*/ `.ag-column-drop-vertical-empty-message{align-items:center;border:1px dashed;border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-style-plain.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnDropStylePlainCSS = /*css*/ `.ag-column-drop-vertical-empty-message{color:var(--ag-subtle-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600;padding-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-empty-message{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing));padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-empty-message{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-icon-size) + var(--ag-spacing) + var(--ag-widget-horizontal-spacing))}`;
// packages/ag-grid-community/src/theming/parts/column-drop-style/column-drop-styles.ts
var $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStyleBorderedCSS
    });
};
var $437b23f6a393c3bf$export$9dd26d60e574ec0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable = ()=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "columnDropStyle",
        css: $437b23f6a393c3bf$var$columnDropStylePlainCSS
    });
};
var $437b23f6a393c3bf$export$9eadc93b54e4a807 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColumnDropStylePlainTreeShakeable();
// packages/ag-grid-community/src/theming/theme-types.ts
var $437b23f6a393c3bf$var$paramTypes = [
    "colorScheme",
    "color",
    "length",
    "scale",
    "borderStyle",
    "border",
    "shadow",
    "image",
    "fontFamily",
    "fontWeight",
    "duration"
];
var $437b23f6a393c3bf$var$getParamType = $437b23f6a393c3bf$var$memoize((param)=>{
    param = param.toLowerCase();
    return $437b23f6a393c3bf$var$paramTypes.find((type)=>param.endsWith(type.toLowerCase())) ?? "length";
});
var $437b23f6a393c3bf$var$literalToCSS = (value)=>{
    if (typeof value === "object" && value?.ref) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);
    return false;
};
var $437b23f6a393c3bf$var$colorValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "ref" in value) {
        const colorExpr = $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
        if (value.mix == null) return colorExpr;
        const backgroundExpr = value.onto ? $437b23f6a393c3bf$var$paramToVariableExpression(value.onto) : "transparent";
        return `color-mix(in srgb, ${backgroundExpr}, ${colorExpr} ${$437b23f6a393c3bf$var$clamp(value.mix * 100, 0, 100)}%)`;
    }
    return false;
};
var $437b23f6a393c3bf$var$colorSchemeValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$lengthValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") return `${value}px`;
    if (value && "calc" in value) {
        const valueWithSpaces = value.calc.replace(/ ?[*/+] ?/g, " $& ");
        return `calc(${valueWithSpaces.replace(/-?\b[a-z][a-z0-9]*\b(?![-(])/gi, (p)=>p[0] === "-" ? p : ` ${$437b23f6a393c3bf$var$paramToVariableExpression(p)} `)})`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$scaleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$borderValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (value === true) return "solid 1px var(--ag-border-color)";
    if (value === false) return param === "columnBorder" ? "solid 1px transparent" : "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return $437b23f6a393c3bf$var$borderStyleValueToCss(value.style ?? "solid") + " " + $437b23f6a393c3bf$var$lengthValueToCss(value.width ?? 1) + " " + $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
        ref: "borderColor"
    });
};
var $437b23f6a393c3bf$var$shadowValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value === false) return "none";
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return [
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetX ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.offsetY ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.radius ?? 0),
        $437b23f6a393c3bf$var$lengthValueToCss(value.spread ?? 0),
        $437b23f6a393c3bf$var$colorValueToCss(value.color ?? {
            ref: "foregroundColor"
        })
    ].join(" ");
};
var $437b23f6a393c3bf$var$borderStyleValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$fontFamilyValueToCss = (value)=>{
    if (typeof value === "string") return value.includes(",") ? value : $437b23f6a393c3bf$var$quoteUnsafeChars(value);
    if (value && "googleFont" in value) return $437b23f6a393c3bf$var$fontFamilyValueToCss(value.googleFont);
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    if (Array.isArray(value)) return value.map((font)=>{
        if (typeof font === "object" && "googleFont" in font) font = font.googleFont;
        return $437b23f6a393c3bf$var$quoteUnsafeChars(font);
    }).join(", ");
    return false;
};
var $437b23f6a393c3bf$var$quoteUnsafeChars = (font)=>// don't quote var() expressions or quote safe identifier names, so that
    // people can specify fonts like sans-serif which are keywords not strings,
    // or var(--my-var)
    /^[\w-]+$|\w\(/.test(font) ? font : JSON.stringify(font);
var $437b23f6a393c3bf$var$fontWeightValueToCss = $437b23f6a393c3bf$var$literalToCSS;
var $437b23f6a393c3bf$var$imageValueToCss = (value)=>{
    if (typeof value === "string") return value;
    if (value && "url" in value) return `url(${JSON.stringify(value.url)})`;
    if (value && "svg" in value) return $437b23f6a393c3bf$var$imageValueToCss({
        url: `data:image/svg+xml,${encodeURIComponent(value.svg)}`
    });
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$durationValueToCss = (value, param)=>{
    if (typeof value === "string") return value;
    if (typeof value === "number") {
        if (value >= 10) $437b23f6a393c3bf$export$a20c7248650823a9(104, {
            value: value,
            param: param
        });
        return `${value}s`;
    }
    if (value && "ref" in value) return $437b23f6a393c3bf$var$paramToVariableExpression(value.ref);
    return false;
};
var $437b23f6a393c3bf$var$paramValidators = {
    color: $437b23f6a393c3bf$var$colorValueToCss,
    colorScheme: $437b23f6a393c3bf$var$colorSchemeValueToCss,
    length: $437b23f6a393c3bf$var$lengthValueToCss,
    scale: $437b23f6a393c3bf$var$scaleValueToCss,
    border: $437b23f6a393c3bf$var$borderValueToCss,
    borderStyle: $437b23f6a393c3bf$var$borderStyleValueToCss,
    shadow: $437b23f6a393c3bf$var$shadowValueToCss,
    image: $437b23f6a393c3bf$var$imageValueToCss,
    fontFamily: $437b23f6a393c3bf$var$fontFamilyValueToCss,
    fontWeight: $437b23f6a393c3bf$var$fontWeightValueToCss,
    duration: $437b23f6a393c3bf$var$durationValueToCss
};
var $437b23f6a393c3bf$var$paramValueToCss = (param, value)=>{
    const type = $437b23f6a393c3bf$var$getParamType(param);
    return $437b23f6a393c3bf$var$paramValidators[type](value, param);
};
// packages/ag-grid-community/src/theming/Theme.ts
var $437b23f6a393c3bf$var$FORCE_LEGACY_THEMES = false;
var $437b23f6a393c3bf$export$638c0e26f33cd834 = (theme)=>{
    if (!(theme instanceof $437b23f6a393c3bf$var$ThemeImpl)) throw new Error("theme is not an object created by createTheme");
    return theme;
};
var $437b23f6a393c3bf$export$25d302a5b900a763 = ()=>new $437b23f6a393c3bf$var$ThemeImpl().withPart($437b23f6a393c3bf$export$a70529c52057ad6a).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0);
var $437b23f6a393c3bf$var$ThemeImpl = class _ThemeImpl {
    constructor(parts = []){
        this.parts = parts;
    }
    withPart(part) {
        if (typeof part === "function") part = part();
        if (!(part instanceof $437b23f6a393c3bf$var$PartImpl)) {
            $437b23f6a393c3bf$var$_logPreInitErr(259, {
                part: part
            }, "Invalid part");
            return this;
        }
        return new _ThemeImpl([
            ...this.parts,
            part
        ]);
    }
    withoutPart(feature) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            feature: feature
        }));
    }
    withParams(params, mode = $437b23f6a393c3bf$var$defaultModeName) {
        return this.withPart($437b23f6a393c3bf$export$6e6f0e372f4cb988({
            modeParams: {
                [mode]: params
            }
        }));
    }
    /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */ _startUse({ styleContainer: styleContainer, cssLayer: cssLayer, nonce: nonce, loadThemeGoogleFonts: loadThemeGoogleFonts }) {
        if ($437b23f6a393c3bf$var$IS_SSR) return;
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return;
        $437b23f6a393c3bf$var$uninstallLegacyCSS();
        $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(styleContainer, cssLayer, nonce);
        const googleFontsUsed = $437b23f6a393c3bf$var$getGoogleFontsUsed(this);
        if (googleFontsUsed.length > 0) {
            for (const googleFont of googleFontsUsed)if (loadThemeGoogleFonts) $437b23f6a393c3bf$var$loadGoogleFont(googleFont, nonce);
        }
        for (const part of this.parts)part.use(styleContainer, cssLayer, nonce);
    }
    /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */ _getCssClass() {
        if ($437b23f6a393c3bf$var$FORCE_LEGACY_THEMES) return "ag-theme-quartz";
        return this._cssClassCache ?? (this._cssClassCache = $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts).map((part)=>part.use(void 0, void 0, void 0)).filter(Boolean).join(" "));
    }
    _getModeParams() {
        let paramsCache = this._paramsCache;
        if (!paramsCache) {
            const mergedModeParams = {
                // NOTE: defining the default mode here is important, it ensures
                // that the default mode is first in iteration order, which puts
                // it first in outputted CSS, allowing other modes to override it
                [$437b23f6a393c3bf$var$defaultModeName]: {
                    ...$437b23f6a393c3bf$var$coreDefaults
                }
            };
            for (const part of $437b23f6a393c3bf$var$deduplicatePartsByFeature(this.parts))for (const partMode of Object.keys(part.modeParams)){
                const partParams = part.modeParams[partMode];
                if (partParams) {
                    const mergedParams = mergedModeParams[partMode] ?? (mergedModeParams[partMode] = {});
                    const partParamNames = /* @__PURE__ */ new Set();
                    for (const partParamName of Object.keys(partParams)){
                        const partParamValue = partParams[partParamName];
                        if (partParamValue !== void 0) {
                            mergedParams[partParamName] = partParamValue;
                            partParamNames.add(partParamName);
                        }
                    }
                    if (partMode === $437b23f6a393c3bf$var$defaultModeName) for (const mergedMode of Object.keys(mergedModeParams)){
                        const mergedParams2 = mergedModeParams[mergedMode];
                        if (mergedMode !== $437b23f6a393c3bf$var$defaultModeName) for (const partParamName of partParamNames)delete mergedParams2[partParamName];
                    }
                }
            }
            this._paramsCache = paramsCache = mergedModeParams;
        }
        return paramsCache;
    }
    /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */ _getPerGridCss(className) {
        const selectorPlaceholder = "##SELECTOR##";
        let innerParamsCss = this._paramsCssCache;
        if (!innerParamsCss) {
            let variablesCss = "";
            let inheritanceCss = "";
            const modeParams = this._getModeParams();
            for (const mode of Object.keys(modeParams)){
                const params = modeParams[mode];
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    const escapedMode = typeof CSS === "object" ? CSS.escape(mode) : mode;
                    const wrapPrefix = `:where([data-ag-theme-mode="${escapedMode}"]) & {
`;
                    variablesCss += wrapPrefix;
                    inheritanceCss += wrapPrefix;
                }
                for (const key of Object.keys(params).sort()){
                    const value = params[key];
                    const cssValue = $437b23f6a393c3bf$var$paramValueToCss(key, value);
                    if (cssValue === false) $437b23f6a393c3bf$export$a20c7248650823a9(107, {
                        key: key,
                        value: value
                    });
                    else {
                        const cssName = $437b23f6a393c3bf$var$paramToVariableName(key);
                        const inheritedName = cssName.replace("--ag-", "--ag-inherited-");
                        variablesCss += `	${cssName}: var(${inheritedName}, ${cssValue});
`;
                        inheritanceCss += `	${inheritedName}: var(${cssName});
`;
                    }
                }
                if (mode !== $437b23f6a393c3bf$var$defaultModeName) {
                    variablesCss += "}\n";
                    inheritanceCss += "}\n";
                }
            }
            let css = `${selectorPlaceholder} {
${variablesCss}}
`;
            css += `:has(> ${selectorPlaceholder}):not(${selectorPlaceholder}) {
${inheritanceCss}}
`;
            this._paramsCssCache = innerParamsCss = css;
        }
        return innerParamsCss.replaceAll(selectorPlaceholder, `:where(.${className})`);
    }
};
var $437b23f6a393c3bf$var$deduplicatePartsByFeature = (parts)=>{
    const lastPartByFeature = /* @__PURE__ */ new Map();
    for (const part of parts)lastPartByFeature.set(part.feature, part);
    const result = [];
    for (const part of parts)if (!part.feature || lastPartByFeature.get(part.feature) === part) result.push(part);
    return result;
};
var $437b23f6a393c3bf$var$getGoogleFontsUsed = (theme)=>{
    const googleFontsUsed = /* @__PURE__ */ new Set();
    const visitParamValue = (paramValue)=>{
        if (Array.isArray(paramValue)) paramValue.forEach(visitParamValue);
        else {
            const googleFont = paramValue?.googleFont;
            if (typeof googleFont === "string") googleFontsUsed.add(googleFont);
        }
    };
    const allModeValues = Object.values(theme._getModeParams());
    const allValues = allModeValues.flatMap((mv)=>Object.values(mv));
    allValues.forEach(visitParamValue);
    return Array.from(googleFontsUsed).sort();
};
var $437b23f6a393c3bf$var$uninstalledLegacyCSS = false;
var $437b23f6a393c3bf$var$uninstallLegacyCSS = ()=>{
    if ($437b23f6a393c3bf$var$uninstalledLegacyCSS) return;
    $437b23f6a393c3bf$var$uninstalledLegacyCSS = true;
    for (const style of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))style.remove();
};
var $437b23f6a393c3bf$var$googleFontsLoaded = /* @__PURE__ */ new Set();
var $437b23f6a393c3bf$var$loadGoogleFont = async (font, nonce)=>{
    $437b23f6a393c3bf$var$googleFontsLoaded.add(font);
    const css = `@import url('https://${$437b23f6a393c3bf$var$googleFontsDomain}/css2?family=${encodeURIComponent(font)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
    $437b23f6a393c3bf$var$_injectGlobalCSS(css, document.head, `googleFont:${font}`, void 0, 0, nonce);
};
var $437b23f6a393c3bf$var$googleFontsDomain = "fonts.googleapis.com";
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-style-default.css-GENERATED.ts
var $437b23f6a393c3bf$var$checkboxStyleDefaultCSS = /*css*/ `.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}`;
// packages/ag-grid-community/src/theming/parts/checkbox-style/checkbox-styles.ts
var $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "checkboxStyle",
        params: {
            checkboxBorderWidth: 1,
            checkboxBorderRadius: {
                ref: "borderRadius"
            },
            checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$accentColor,
            checkboxCheckedBorderColor: {
                ref: "checkboxCheckedBackgroundColor"
            },
            checkboxCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
            },
            checkboxCheckedShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.3),
            checkboxIndeterminateBorderColor: {
                ref: "checkboxIndeterminateBackgroundColor"
            },
            checkboxIndeterminateShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
            },
            checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$backgroundColor,
            radioCheckedShapeImage: {
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
            }
        },
        css: $437b23f6a393c3bf$var$checkboxStyleDefaultCSS
    });
var $437b23f6a393c3bf$export$cb8a4bb75f2f86bb = /* @__PURE__ */ $437b23f6a393c3bf$var$makeCheckboxStyleDefaultTreeShakeable();
// packages/ag-grid-community/src/theming/parts/color-scheme/color-schemes.ts
var $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams
    });
var $437b23f6a393c3bf$export$a116df924b17ca5b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000000de",
            borderColor: "#60300026",
            chromeBackgroundColor: "#60300005"
        }
    });
var $437b23f6a393c3bf$export$57dc871710981584 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            foregroundColor: "#000",
            chromeBackgroundColor: "#f3f8f8"
        }
    });
var $437b23f6a393c3bf$export$4cac94f49a02889d = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeLightColdTreeShakeable();
var $437b23f6a393c3bf$var$darkParams = ()=>({
        ...$437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        backgroundColor: "hsl(217, 0%, 17%)",
        foregroundColor: "#FFF",
        chromeBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.05),
        rowHoverColor: $437b23f6a393c3bf$var$accentMix(0.15),
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.2),
        menuBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.1),
        browserColorScheme: "dark",
        popupShadow: "0 0px 20px #000A",
        cardShadow: "0 1px 4px 1px #000A",
        advancedFilterBuilderJoinPillColor: "#7a3a37",
        advancedFilterBuilderColumnPillColor: "#355f2d",
        advancedFilterBuilderOptionPillColor: "#5a3168",
        advancedFilterBuilderValuePillColor: "#374c86",
        findMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        findActiveMatchColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.4)
    });
var $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkParams()
    });
var $437b23f6a393c3bf$export$cd586495722a2c01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: {
            backgroundColor: "hsl(29, 10%, 17%)",
            foregroundColor: "#FFF",
            browserColorScheme: "dark"
        }
    });
var $437b23f6a393c3bf$var$darkBlueParams = ()=>({
        ...$437b23f6a393c3bf$var$darkParams(),
        backgroundColor: "#1f2836"
    });
var $437b23f6a393c3bf$export$cd0e0dbae95c289b = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkWarmTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$darkBlueParams()
    });
var $437b23f6a393c3bf$export$55741f191f921eee = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeDarkBlueTreeShakeable();
var $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "colorScheme",
        params: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
        modeParams: {
            light: $437b23f6a393c3bf$var$defaultLightColorSchemeParams,
            dark: $437b23f6a393c3bf$var$darkParams(),
            "dark-blue": $437b23f6a393c3bf$var$darkBlueParams()
        }
    });
var $437b23f6a393c3bf$export$e4400993032942f7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeColorSchemeVariableTreeShakeable();
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetBalhamCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M22 12h-2v-2h-8v.092c.056 1.352 3.426 2.598 4.472 4.404.682 1.174.438 2.754-.572 3.72C14.29 19.618 12 20.924 12 22h8v-2h2v4H10c0-1.586-.098-3.304 1.016-4.314 1.904-1.632 4.89-3.108 3.54-4.42-1.918-1.68-4.464-2.936-4.554-5.12L10 8h12z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='m6.414 17 2.294 2.292-1.416 1.416L2.586 16l4.706-4.708 1.416 1.416L6.414 15H15V6.414l-2.292 2.294-1.416-1.416L16 2.586l4.708 4.706-1.416 1.416L17 6.414V15h8.586l-2.294-2.292 1.416-1.416L29.414 16l-4.706 4.708-1.416-1.416L25.586 17H17v8.586l2.292-2.294 1.416 1.416L16 29.414l-4.708-4.706 1.416-1.416L15 25.586V17z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 4C9.378 4 4 9.378 4 16s5.378 12 12 12 12-5.378 12-12S22.622 4 16 4m0 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S6 21.52 6 16 10.48 6 16 6m0 8.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M14 25h-2V7h2zm6 0h-2V7h2zm6 0h-2V7h2zM8 25H6V7h2z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M21.929 27.999h-7.828a5.09 5.09 0 0 1-5.086-5.086v-9.812a5.087 5.087 0 0 1 5.086-5.086h7.828a5.09 5.09 0 0 1 5.086 5.086v9.812a5.087 5.087 0 0 1-5.086 5.086m.16-17.984h-8.088a2.94 2.94 0 0 0-2.938 2.938v10.132a2.94 2.94 0 0 0 2.938 2.938h8.088a2.94 2.94 0 0 0 2.936-2.938V12.953a2.94 2.94 0 0 0-2.936-2.938M7.041 26.013h-2.05a4 4 0 0 1-.006-.228V9.065a5.07 5.07 0 0 1 5.064-5.064h12.812q.069 0 .134.002v2.012H9.915a2.876 2.876 0 0 0-2.874 2.874z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='4 4 24 24'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m16 14.586 5.292-5.294 1.416 1.416L17.414 16l5.294 5.292-1.416 1.416L16 17.414l-5.292 5.294-1.416-1.416L14.586 16l-5.294-5.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14.703 15.096 6.215 4.719a1 1 0 1 1 1.548-1.267l13.058 15.965A5.001 5.001 0 0 1 28 23.916a5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 4.98 4.98 0 0 1 1.23-3.283l-3.238-3.958-3.272 4.001a4.98 4.98 0 0 1 1.265 3.323 5 5 0 0 1-4.999 4.999 5 5 0 0 1-4.999-4.999 5 5 0 0 1 7.13-4.522zM8.991 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M23 20.8a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1m-5.723-8.852 1.292 1.579 7.205-8.808a1 1 0 0 0-1.548-1.267z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m17 21.379 4.292-4.294 1.416 1.416L16 25.207l-6.708-6.706 1.416-1.416L15 21.379V6.793h2z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M9.304 7.89a15.2 15.2 0 0 1 6.404-1.638c.294-.002.292-.002.584 0 5.956.174 11.328 4.088 13.62 9.748 0 0-1.318 3.178-3.224 5.174a13.6 13.6 0 0 1-2.226 1.874L26.414 25 25 26.414l-2.336-2.336C17.866 26.396 11.776 26.15 7.36 22.96a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.218 2.002-3.718a14.6 14.6 0 0 1 3.442-3.334L5.586 7 7 5.586zm-.3 2.528c-2.038 1.344-3.708 3.246-4.724 5.508L4.248 16c2.46 5.762 9.622 9.064 15.63 7.15q.688-.219 1.342-.516l-.912-.912a6.96 6.96 0 0 1-4.19 1.394c-3.862 0-7-3.136-7-7 0-1.57.52-3.022 1.394-4.19zm14.032 11.204a13.25 13.25 0 0 0 4.684-5.548l.032-.074c-1.984-4.646-6.834-7.798-12.006-7.748-1.712.05-3.386.458-4.922 1.158l1.102 1.102a6.97 6.97 0 0 1 4.192-1.396 7.003 7.003 0 0 1 5.606 11.192zm-11.09-8.262a5.003 5.003 0 0 0 6.928 6.928zm8.342 5.514a5.002 5.002 0 0 0-6.928-6.928z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16.292 6.32c5.956.174 11.328 4.086 13.62 9.746 0 0-1.318 3.18-3.224 5.176-4.862 5.088-13.534 5.97-19.328 1.784a14.9 14.9 0 0 1-4.168-4.612c-.41-.71-.694-1.336-1.104-2.348 0 0 .898-2.216 2.002-3.716 2.678-3.64 7.03-5.896 11.618-6.03.294-.004.292-.004.584 0m-.546 2c-4.896.142-9.458 3.202-11.466 7.672l-.032.074c2.46 5.762 9.622 9.066 15.63 7.152 3.458-1.102 6.342-3.738 7.842-7.076l.032-.076C25.768 11.42 20.918 8.27 15.746 8.32m.254.946c3.754 0 6.8 3.048 6.8 6.8 0 3.754-3.046 6.8-6.8 6.8s-6.8-3.046-6.8-6.8c0-3.752 3.046-6.8 6.8-6.8m5 6.768V16c0-2.76-2.24-5-5-5s-5 2.24-5 5v.066c0 2.76 2.24 5 5 5s5-2.24 5-5z'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M26 8.184c-.066 2.658-4.058 5.154-6.742 7.974a1.05 1.05 0 0 0-.258.682v3.66L13 25c0-2.74.066-5.482-.002-8.222a1.05 1.05 0 0 0-.256-.62C10.026 13.304 6.06 10.61 6 8.184V6h20zM8 8c0 .304.06.612.258.842 2.716 2.854 6.682 5.548 6.742 7.974V21l2-1.5v-2.684c.066-2.658 4.058-5.154 6.742-7.974.198-.23.258-.538.258-.842z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.354 8.708 17.06 16l7.294 7.292-1.416 1.416L14.232 16l8.706-8.708zM9.646 8v16h-2V8z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0M7.006 4c-1.57.02-2.946 1.348-3.004 2.922-.078 6.078-.23 12.16.002 18.234.094 1.484 1.354 2.746 2.84 2.84 6.1.232 12.212.232 18.312 0 1.48-.094 2.746-1.35 2.84-2.84.232-6.1.232-12.212 0-18.312-.094-1.48-1.35-2.746-2.84-2.84C19.11 3.774 13.056 4 7.006 4M14 21h-4v-2h4zm12 0H16v-2h10zm-12-4h-4v-2h4zm12 0H16v-2h10zm-16-4H6v-2h4zm16 0H12v-2h14z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m17.768 16-8.706 8.708-1.416-1.416L14.94 16 7.646 8.708l1.416-1.416zm6.586 8h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='m17.621 11-2 2h12.586v6H15.621l2 2-4.414 4.414L3.793 16l9.414-9.414zm-11 5 6.586 6.586L14.793 21l-4-4h15.414v-2H10.793l4-4-1.586-1.586z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M17.138 13.418a1.03 1.03 0 0 0-.298.658s.125.096.226.178c1.372 1.114 2.033 3.039 1.582 4.796a4.7 4.7 0 0 1-1.205 2.123c-1.145 1.151-2.296 2.294-3.445 3.441-1.241 1.232-3.185 1.691-4.864 1.105-1.546-.54-2.756-1.938-3.048-3.572-.267-1.496.246-3.108 1.319-4.186l.578-.578-.03-.092a10.5 10.5 0 0 1-.452-2.3v-.005c-.776.775-1.621 1.489-2.275 2.396-1.817 2.522-1.643 6.323.706 8.669 1.813 1.811 4.708 2.462 7.171 1.517a6.75 6.75 0 0 0 2.336-1.518l3.427-3.424c1.939-1.954 2.533-5.126 1.294-7.674a6.8 6.8 0 0 0-2.071-2.481l-.003-.002zM21.265 4a6.8 6.8 0 0 0-4.734 1.964l-3.427 3.424c-1.961 1.977-2.52 5.092-1.32 7.619a6.8 6.8 0 0 0 2.098 2.537l.003.002c.32-.32.643-.637.96-.96.167-.172.27-.401.286-.64l-.204-.167c-1.603-1.287-2.215-3.68-1.316-5.616a4.7 4.7 0 0 1 .918-1.32c1.145-1.151 2.296-2.294 3.445-3.441 1.239-1.23 3.178-1.694 4.864-1.105 1.83.639 3.16 2.498 3.12 4.493a4.8 4.8 0 0 1-1.391 3.265l-.578.578.03.092c.235.743.387 1.519.452 2.3v.005c.732-.731 1.521-1.406 2.162-2.244 1.192-1.559 1.643-3.651 1.204-5.575a6.8 6.8 0 0 0-3.98-4.703 6.8 6.8 0 0 0-2.529-.506h-.061z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='m7.54 17.4.1 6.98 6.96.1-2.24-2.24L16 18.6 13.4 16l-3.64 3.64zm16.92-2.8-.1-6.98-6.96-.1 2.24 2.24L16 13.4l2.6 2.6 3.64-3.64z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M26 23H6v-2h20zm0-6H6v-2h20zm0-6H6V9h20z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none'%3E%3Cpath fill='%23000' d='M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 26 26'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='m14.8 24.26-.1-6.96-6.96-.1 2.24 2.24-3.64 3.64 2.6 2.6 3.64-3.64zm2.4-16.52.1 6.96 6.96.1-2.24-2.24 3.64-3.64-2.6-2.6-3.64 3.64z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142m-1.414 6.07h16.97v2.002H7.515z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='m10.044 21.258 4.478-4.198L16 18.444 9 25l-7-6.556 1.478-1.384 4.478 4.198V7h2.088zm14 3.742h-2.088V10.742l-4.478 4.198L16 13.556 23 7q3.5 3.28 7 6.556l-1.478 1.384-4.478-4.198z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16.186 3.646c8.188.154 14.898 9.796 11.17 17.78-3.298 7.066-13.932 9.374-19.848 3.87-3.9-3.632-5.076-9.896-2.684-14.708 2.082-4.19 6.588-6.974 11.362-6.942m-.298 1.998c-6.922.132-12.578 8.308-9.33 15.052 3.342 6.934 15.246 7.646 18.932 0 3.076-6.386-1.988-15.1-9.602-15.052m7.596 6.422c2.864 5.33-1.744 13.186-8.306 12.536a8.6 8.6 0 0 1-3.232-.998l-1.266-.706L22.778 10.8q.351.633.706 1.266m-9.422 10.276c3.296 1.028 7.246-1.006 8.216-4.418a6.6 6.6 0 0 0-.056-3.742zm2.104-14.696a8.8 8.8 0 0 1 3.936 1.038l1.266.706L9.27 21.488c-3.018-5.41-.99-13.37 6.318-13.834q.289-.01.578-.008m-.31 2c-4.06.154-7.23 4.614-6.03 8.46l8.16-8.16a6.8 6.8 0 0 0-2.13-.3'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M20 6.5c0-1-1-3-4-3s-4 2-4 3H8c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-14c0-2.21-1.79-4-4-4zm-4 .546c.734 0 1.334.572 1.334 1.272S16.734 9.59 16 9.59s-1.334-.572-1.334-1.272.6-1.272 1.334-1.272M24 26.5H8a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h2v4h12v-4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008c-1.358-.022-2.714-.026-4.07-.022v4.034h4.07z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 7.515c-4.683 4.682-4.683 12.288 0 16.97 4.682 4.683 12.288 4.683 16.97 0 4.683-4.682 4.683-12.288 0-16.97-4.682-4.683-12.288-4.683-16.97 0m1.414 1.414c3.903-3.903 10.239-3.903 14.142 0s3.903 10.239 0 14.142-10.239 3.903-14.142 0-3.903-10.239 0-14.142M15 15l-.001-7.485h2.002L17 15l7.485-.001v2.002L17 17l.001 7.485h-2.002L15 17l-7.485.001v-2.002z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m28.207 16-9.414 9.414L14.379 21l2-2H3.793v-6h12.586l-2-2 4.414-4.414zm-11-5 4 4H5.793v2h15.414l-4 4 1.586 1.586L25.379 16l-6.586-6.586z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M21.061 8.708 13.767 16l7.294 7.292-1.416 1.416L10.939 16l8.706-8.708z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='m24.708 19.645-1.416 1.416L16 13.767l-7.292 7.294-1.416-1.416L16 10.939z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='M24.708 10.855 13 22.561l-5.708-5.706 1.416-1.416L13 19.733 23.292 9.439z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m21.061 16-8.706 8.708-1.416-1.416L18.233 16l-7.294-7.292 1.416-1.416z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6 15h20v2H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M24.708 12.355 16 21.061l-8.708-8.706 1.416-1.416L16 18.233l7.292-7.294z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M5.35 3.999a.2.2 0 0 0-.14.058c-.388.38-.768.768-1.152 1.152a.21.21 0 0 0-.002.288c7.459 7.506 14.965 14.965 22.447 22.447a.21.21 0 0 0 .288.002q.576-.574 1.151-1.151a.21.21 0 0 0 .002-.288C20.484 19.002 12.979 11.542 5.497 4.06a.2.2 0 0 0-.146-.061zm.611 12.548c-1.933 1.939-2.538 5.119-1.289 7.688a6.79 6.79 0 0 0 4.891 3.672 6.82 6.82 0 0 0 5.893-1.866l1.984-1.984-1.438-1.438-1.986 1.986c-1.486 1.476-3.993 1.81-5.834.629a4.73 4.73 0 0 1-2.024-2.853 4.76 4.76 0 0 1 1.241-4.393l1.986-1.986-1.438-1.438-1.984 1.984zM21.273 3.999a6.78 6.78 0 0 0-4.727 1.963l-1.984 1.984L16 9.384l1.985-1.985a4.74 4.74 0 0 1 2.776-1.338c1.974-.224 4.045.926 4.845 2.834.712 1.699.329 3.778-1.004 5.12L22.616 16l1.439 1.438q1-1 2-2c2.012-2.031 2.557-5.368 1.112-7.982-1.144-2.07-3.432-3.441-5.834-3.459h-.061z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m15 10.621-4.292 4.294-1.416-1.416L16 6.793l6.708 6.706-1.416 1.416L17 10.621v14.586h-2z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/balham/icon-set-balham.ts
var $437b23f6a393c3bf$var$iconSetBalham = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetBalhamCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetAlpineCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24 6H8v2l8 8-8 8v2h16v-2H11l8-8-8-8h13z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.515 11.171 2.687 16l4.828 4.829-1.414 1.414L-.142 16l6.243-6.243zm16.97 0 1.414-1.414L32.142 16l-6.243 6.243-1.414-1.414L29.313 16zM16.028 13.2l2.829 2.828-2.829 2.829-2.828-2.829zm-4.857 11.285L16 29.313l4.829-4.828 1.414 1.414L16 32.142l-6.243-6.243zm0-16.97L9.757 6.101 16-.142l6.243 6.243-1.414 1.414L16 2.687z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667A13.32 13.32 0 0 0 2.667 16c0 7.373 5.96 13.333 13.333 13.333S29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M14 7h4v18h-4zM8 17h4v8H8zM20 13h4v12h-4z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26 25H6V7h20zM12 11H8v12h4zm6 0h-4v12h4zm6 12V11h-4v12z' style='fill-rule:nonzero' transform='translate(0 -1)'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m12 6 10 10-10 10-2-2 8-8-8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.984 13.894 27.05 2.828l2.122 2.122-11.066 11.066 11.066 11.066-2.122 2.12-11.066-11.066L4.918 29.202l-2.12-2.12 11.066-11.066L2.798 4.95l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M13.775 15.198 3.835 2.945a1.501 1.501 0 0 1 2.33-1.89l14.997 18.488A6.003 6.003 0 0 1 29.657 25c0 3.311-2.688 6-6 6s-6-2.689-6-6c0-1.335.437-2.569 1.176-3.566l-3.127-3.855-3.001 3.7A5.97 5.97 0 0 1 14 25c0 3.311-2.689 6-6 6s-6-2.689-6-6a6.003 6.003 0 0 1 8.315-5.536zm9.882 6.702a3.1 3.1 0 0 0-3.1 3.1c0 1.711 1.389 3.1 3.1 3.1s3.1-1.389 3.1-3.1-1.389-3.1-3.1-3.1M8 21.95a3.05 3.05 0 1 0 .001 6.101A3.05 3.05 0 0 0 8 21.95m9.63-11.505 1.932 2.381 8.015-9.881a1.5 1.5 0 0 0-2.329-1.89z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 26 10 16 20 6l2 2-8 8 8 8z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M8.95 10.364 7 8.414 8.414 7l2.32 2.32A13.2 13.2 0 0 1 16.5 8c5.608 0 10.542 3.515 12.381 8.667L29 17l-.119.333a13 13 0 0 1-4.255 5.879l1.466 1.466-1.414 1.414-1.754-1.753A13.2 13.2 0 0 1 16.5 26c-5.608 0-10.542-3.515-12.381-8.667L4 17l.119-.333a13 13 0 0 1 4.83-6.303m1.445 1.445A11.02 11.02 0 0 0 6.148 17c1.646 4.177 5.728 7 10.352 7 1.76 0 3.441-.409 4.94-1.146l-1.878-1.878A5.06 5.06 0 0 1 16.5 22c-2.789 0-5.05-2.239-5.05-5 0-1.158.398-2.223 1.065-3.07zm1.855-.974 1.794 1.795A5.07 5.07 0 0 1 16.5 12c2.789 0 5.05 2.239 5.05 5 0 .9-.24 1.745-.661 2.474l2.305 2.306A11 11 0 0 0 26.852 17c-1.646-4.177-5.728-7-10.352-7-1.495 0-2.933.295-4.25.835'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16.5 23c4.624 0 8.706-2.823 10.352-7-1.646-4.177-5.728-7-10.352-7s-8.706 2.823-10.352 7c1.646 4.177 5.728 7 10.352 7M4.119 15.667C5.958 10.515 10.892 7 16.5 7s10.542 3.515 12.381 8.667L29 16l-.119.333C27.042 21.485 22.108 25 16.5 25S5.958 21.485 4.119 16.333L4 16zM16.5 21c2.789 0 5.049-2.239 5.049-5s-2.26-5-5.049-5-5.049 2.239-5.049 5 2.26 5 5.049 5' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m28 8-8 8v5l-6 6V16L6 8V6h22zM9 8l7 7v7l2-2v-5l7-7z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 7v1H9V7zm0-3v1H5.001V4zm-7 7H5v-1h2zm0-3H5V7h2zM3 5H1V4h2zm11 5v1H9v-1zm-7 4H5v-1h2zm7-1v1H9v-1z' style='fill-rule:nonzero' transform='matrix(2 0 0 2 0 -2)'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333a6.67 6.67 0 0 0-6.667 6.667 6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133 4.136 4.136 0 0 1-4.133 4.133h-5.333v2.533h5.333a6.67 6.67 0 0 0 6.667-6.667 6.67 6.67 0 0 0-6.667-6.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M17 29h-2v-8h2zm-3.586-9L7 26.414 5.586 25 12 18.586zm13 5L25 26.414 18.586 20 20 18.586zM29 17h-8v-2h8zm-18 0H3v-2h8zm2.414-5L12 13.414 5.586 7 7 5.586zm13-5L20 13.414 18.586 12 25 5.586zM17 11h-2V3h2z' style='fill-rule:nonzero' transform='translate(-3.692 -3.692)scale(1.23077)'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M14 30H2V18h2.828v7.05l8.254-8.252 2.12 2.12-8.252 8.254H14zm4-28h12v12h-2.828V6.95l-8.254 8.252-2.12-2.12 8.252-8.254H18z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M20 13H0v-2h20zm0-6H0V5h20zm0-6H0v-2h20z' style='fill-rule:nonzero' transform='translate(6 9)'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M16 27a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M2 18h12v12h-2.828v-7.05l-8.254 8.252-2.12-2.12 8.252-8.254H2zm28-4H18V2h2.828v7.05L29.082.798l2.12 2.12-8.252 8.254H30z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.94 6 9.06 7.88 17.167 16 9.06 24.12 10.94 26l10-10z' style='fill-rule:nonzero' transform='translate(1)'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cg fill='%23000' fill-rule='nonzero'%3E%3Cpath d='M23.708 14.645 16 6.939l-7.708 7.706 1.416 1.416L16 9.767l6.292 6.294zM23.708 20.355 16 28.061l-7.708-7.706 1.416-1.416L16 25.233l6.292-6.294z'/%3E%3C/g%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.334 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4M16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m10.78 19.777-4.668-4.666s.032-1 .67-1.87c1.366-1.86 4.052-1.96 6.056-1.572l3.158-3.108c-.7-2.342 3.352-5.046 3.352-5.046l9.166 9.168q-.334.447-.67.894c-1.074 1.426-2.538 2.63-4.272 2.338l-3.32 3.218c.046.344.042.03.118 1.152.144 2.13-.64 4.324-2.632 5.34l-.746.364-4.798-4.798-7.292 7.294-1.416-1.416zm8.24-13.672c-.688.568-1.416 1.45-1.024 2.072l.49.722-4.986 4.988c-1.988-.506-4.346-.636-5.156.614l9.02 9.032q.14-.099.272-.21c1.226-1.08.764-3.04.498-4.9l4.79-4.79s1.47.938 2.936-.776l-6.79-6.79q-.026.019-.05.038' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M25.128 2.002c2.56.096 4.772 2.292 4.87 4.87a712 712 0 0 1 0 18.256c-.096 2.56-2.292 4.772-4.87 4.87a712 712 0 0 1-18.256 0c-2.558-.096-4.772-2.29-4.87-4.87a712 712 0 0 1 0-18.256c.096-2.56 2.292-4.772 4.87-4.87a712 712 0 0 1 18.256 0m2.966 7.954H9.892v18.136c5.086.13 10.18.098 15.264-.096 1.48-.094 2.746-1.35 2.84-2.84.192-5.064.226-10.134.098-15.2M3.968 24.1q.015.528.036 1.056c.094 1.484 1.354 2.746 2.84 2.84l1.012.036V24.1zM22 15.414l-.292.294-1.416-1.416L23 11.586l2.708 2.706-1.416 1.416-.292-.294v3.592c-.032 2.604-2.246 4.892-4.872 4.992L15.414 24l.294.292-1.416 1.416L11.586 23l2.706-2.708 1.416 1.416-.322.32c3.372.03 6.578-.164 6.614-3.034zM3.88 18.038c.002 1.346.012 2.694.038 4.04h3.938v-4.04zm.05-6.062a681 681 0 0 0-.044 4.042h3.97v-4.042zm5.962-7.99Q8.449 3.999 7.006 4c-1.57.02-2.946 1.348-3.004 2.922q-.02 1.517-.042 3.034h3.896v-2.02h2.036zm14.244-.016v3.966h3.898q-.017-.546-.038-1.092c-.094-1.48-1.35-2.746-2.84-2.84q-.51-.019-1.02-.034m-8.14-.054q-2.035.022-4.07.048v3.972h4.07zm6.106.008a213 213 0 0 0-4.07-.022v4.034h4.07z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.94 7.88 20.06 6l-10 10 10 10 1.88-1.88L13.833 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M15.708 2.355 8 10.061.292 2.355 1.708.939 8 7.233 14.292.939z' style='fill-rule:nonzero' transform='translate(8 14)'/%3E%3Cpath d='M5 26h22v2H5zM15 4h2v18h-2z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 10.667 16 21.334l8.667-10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M21.333 7.334 10.666 16l10.667 8.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M10.667 24.666 21.334 16 10.667 7.333z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M7.334 21.333 16 10.666l8.667 10.667z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M11.586 22.96 27.718 6.828 29.84 8.95 11.586 27.202 2.4 18.016l2.12-2.122z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m11.94 6-1.88 1.88L18.167 16l-8.107 8.12L11.94 26l10-10z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6 13.5h20v3H6z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M24.12 9.06 16 17.167 7.88 9.06 6 10.94l10 10 10-10z' style='fill-rule:nonzero' transform='translate(0 1)'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333 5.332 16z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M8 24H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 18H6v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zm6 0h-2v-4h2zM8 12H6V8h2zm6 0h-2V8h2zm6 0h-2V8h2zm6 0h-2V8h2z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='m6.112 15.111 3.272 3.271 1.436-1.402-2.476-2.479c.81-1.25 3.168-1.12 5.156-.614l4.986-4.988-.49-.722c-.392-.622.336-1.504 1.024-2.072l.008-.007.01-.006.032-.025 1.447 1.447 1.432-1.397-2.601-2.602s-4.052 2.704-3.352 5.046l-3.158 3.108c-2.004-.388-4.69-.288-6.056 1.572-.638.87-.67 1.87-.67 1.87m.581 11.582.014.014 5.502-5.501 4.783 4.783.746-.364c1.992-1.016 2.776-3.21 2.632-5.34-.055-.805-.068-.87-.088-.97-.008-.04-.017-.085-.03-.182l3.32-3.218c1.734.292 3.198-.912 4.272-2.338q.337-.447.67-.894l-.001-.001-.007-.007-.007-.007-.007-.007-3.87-3.87 1.585-1.584-1.414-1.414-14.381 14.38-1.237 1.209-5.69 5.687 1.417 1.416zM23.21 10.206l2.65 2.651c-1.465 1.714-2.935.776-2.935.776l-4.79 4.79q.041.291.087.583c.257 1.676.513 3.35-.585 4.317a4 4 0 0 1-.272.21l-3.739-3.744z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='m16.708 10.878 8.708 8.706L24 21l-6.292-6.294V27h-2V14.706L9.416 21 8 19.584q4.348-4.344 8.691-8.69zM25 6H8v2h17z'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' d='M16.708 22.122 8 13.416 9.416 12l6.292 6.294V6h2v12.294L24 12l1.416 1.416-8.691 8.69zM7.416 28h17v-2h-17z'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/alpine/icon-set-alpine.ts
var $437b23f6a393c3bf$export$9bb4a1bee1653083 = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetAlpineCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.css-GENERATED.ts
var $437b23f6a393c3bf$var$iconSetMaterialCSS = /*css*/ `.ag-icon-aggregation:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eaggregation%3C/title%3E%3Cpath d='M24 5.333H8V8l8.667 8L8 24v2.667h16v-4h-9.333L21.334 16l-6.667-6.667H24z'/%3E%3C/svg%3E")}.ag-icon-arrows:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Earrows%3C/title%3E%3Cpath d='M13.333 11.556h5.333V8h3.556L16 1.778 9.778 8h3.556zm-1.777 1.777H8V9.777l-6.222 6.222L8 22.221v-3.556h3.556zM30.222 16 24 9.778v3.556h-3.556v5.333H24v3.556l6.222-6.222zm-11.555 4.444h-5.333V24H9.778L16 30.222 22.222 24h-3.556z'/%3E%3C/svg%3E")}.ag-icon-asc:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-cancel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecancel%3C/title%3E%3Cpath d='M16 2.667C8.627 2.667 2.667 8.627 2.667 16S8.627 29.333 16 29.333 29.333 23.373 29.333 16 23.373 2.667 16 2.667m6.667 18.12-1.88 1.88L16 17.88l-4.787 4.787-1.88-1.88L14.12 16l-4.787-4.787 1.88-1.88L16 14.12l4.787-4.787 1.88 1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-chart:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Echart%3C/title%3E%3Cpath d='M6.667 12.267h4v13.067h-4zm7.466-5.6h3.733v18.667h-3.733zM21.6 17.333h3.733v8H21.6z'/%3E%3C/svg%3E")}.ag-icon-color-picker:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolor-picker%3C/title%3E%3Cpath d='M23.907 17.587 10.574 4.254l-1.88 1.88 3.173 3.173-8.28 8.28 10.16 10.16zm-16.547 0 6.387-6.387 6.387 6.387H7.361zm18.387 2s-2.667 2.893-2.667 4.667c0 1.467 1.2 2.667 2.667 2.667s2.667-1.2 2.667-2.667c0-1.773-2.667-4.667-2.667-4.667'/%3E%3C/svg%3E")}.ag-icon-columns:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecolumns%3C/title%3E%3Cpath d='M5.333 10.667h5.333V5.334H5.333zm8 16h5.333v-5.333h-5.333zm-8 0h5.333v-5.333H5.333zm0-8h5.333v-5.333H5.333zm8 0h5.333v-5.333h-5.333zm8-13.334v5.333h5.333V5.333zm-8 5.334h5.333V5.334h-5.333zm8 8h5.333v-5.333h-5.333zm0 8h5.333v-5.333h-5.333z'/%3E%3C/svg%3E")}.ag-icon-contracted:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Econtracted%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-copy:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecopy%3C/title%3E%3Cpath d='M22 1.333H6A2.675 2.675 0 0 0 3.333 4v18.667H6V4h16zm4 5.334H11.333a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667H26c1.467 0 2.667-1.2 2.667-2.667V9.334c0-1.467-1.2-2.667-2.667-2.667M26 28H11.333V9.333H26z'/%3E%3C/svg%3E")}.ag-icon-cross:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Ecross%3C/title%3E%3Cpath d='m25.333 8.547-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16z'/%3E%3C/svg%3E")}.ag-icon-csv:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='M.688-.226a.2.2 0 0 1-.017.074.28.28 0 0 1-.145.14.412.412 0 0 1-.234.013.28.28 0 0 1-.202-.168.468.468 0 0 1-.04-.19q0-.086.025-.155a.319.319 0 0 1 .182-.191.4.4 0 0 1 .134-.025q.087 0 .155.035a.3.3 0 0 1 .104.085.17.17 0 0 1 .036.097.06.06 0 0 1-.018.044.06.06 0 0 1-.042.019.06.06 0 0 1-.042-.013.2.2 0 0 1-.031-.046.2.2 0 0 0-.066-.079.16.16 0 0 0-.095-.027.17.17 0 0 0-.142.068.3.3 0 0 0-.053.193.4.4 0 0 0 .023.139.2.2 0 0 0 .067.083.2.2 0 0 0 .1.027q.063 0 .106-.031a.2.2 0 0 0 .065-.091.2.2 0 0 1 .023-.046q.014-.018.044-.018a.06.06 0 0 1 .044.018.06.06 0 0 1 .019.045' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 7.122 25.977)'/%3E%3Cpath d='M.622-.215a.2.2 0 0 1-.033.117.23.23 0 0 1-.098.081.4.4 0 0 1-.153.029.34.34 0 0 1-.175-.04.23.23 0 0 1-.079-.077.17.17 0 0 1-.031-.093q0-.027.019-.045a.06.06 0 0 1 .046-.019.06.06 0 0 1 .039.014.1.1 0 0 1 .027.044.3.3 0 0 0 .03.057q.015.023.044.038.03.015.076.015.065 0 .105-.03a.09.09 0 0 0 .04-.075.08.08 0 0 0-.022-.058.14.14 0 0 0-.056-.034 1 1 0 0 0-.092-.025.7.7 0 0 1-.129-.042.2.2 0 0 1-.083-.066.17.17 0 0 1-.03-.104q0-.058.032-.105a.2.2 0 0 1 .093-.07.4.4 0 0 1 .144-.025q.066 0 .114.016a.3.3 0 0 1 .08.044.2.2 0 0 1 .046.057q.015.03.015.058a.07.07 0 0 1-.018.046.06.06 0 0 1-.046.021q-.025 0-.038-.012a.2.2 0 0 1-.028-.041.2.2 0 0 0-.047-.063Q.387-.625.326-.625a.15.15 0 0 0-.09.025q-.035.024-.035.059 0 .021.012.037a.1.1 0 0 0 .032.027.4.4 0 0 0 .111.036q.06.015.11.031.048.018.083.042a.2.2 0 0 1 .054.062.2.2 0 0 1 .019.091' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 13.339 25.977)'/%3E%3Cpath d='m.184-.633.162.48.163-.483q.013-.038.019-.053a.062.062 0 0 1 .061-.039q.018 0 .034.009a.1.1 0 0 1 .025.025q.009.015.009.031L.654-.64l-.007.025-.009.024-.173.468-.019.051a.2.2 0 0 1-.021.042.1.1 0 0 1-.033.03.1.1 0 0 1-.049.012.1.1 0 0 1-.05-.011A.1.1 0 0 1 .26-.03a.2.2 0 0 1-.021-.042L.22-.123.05-.587.041-.612.033-.638.03-.662q0-.025.02-.046a.07.07 0 0 1 .05-.02q.037 0 .053.023.015.023.031.072' style='fill-rule:nonzero' transform='matrix(8.39799 0 0 12.455 18.94 25.977)'/%3E%3C/svg%3E")}.ag-icon-cut:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='m19 3-6 6 2 2 7-7V3m-10 9.5a.503.503 0 0 1-.5-.5c0-.274.226-.5.5-.5s.5.226.5.5-.226.5-.5.5M6 20c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2M6 8c-1.097 0-2-.903-2-2a2 2 0 0 1 2-2c1.097 0 2 .903 2 2a2 2 0 0 1-2 2m3.64-.36c.23-.5.36-1.05.36-1.64 0-2.194-1.806-4-4-4S2 3.806 2 6s1.806 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.194 0-4 1.806-4 4s1.806 4 4 4 4-1.806 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1z' style='fill-rule:nonzero' transform='translate(4 4)'/%3E%3C/svg%3E")}.ag-icon-desc:before,.ag-icon-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Edesc%3C/title%3E%3Cpath d='m26.667 16-1.88-1.88-7.453 7.44V5.333h-2.667V21.56l-7.44-7.453L5.334 16l10.667 10.667L26.668 16z'/%3E%3C/svg%3E")}.ag-icon-excel:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M384 131.9c-7.753-8.433-110.425-128.473-114.9-133L48-.1C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zm-35.9 2.1H257V27.9zM30 479V27h200l1 105c0 13.3-1.3 29 12 29h111l1 318z' style='fill-rule:nonzero' transform='matrix(.06285 0 0 .06285 3.934 -.054)'/%3E%3Cpath d='m.052-.139.16-.234-.135-.208a.4.4 0 0 1-.028-.052.1.1 0 0 1-.01-.042.05.05 0 0 1 .018-.037.07.07 0 0 1 .045-.016q.03 0 .047.018a1 1 0 0 1 .047.066l.107.174.115-.174.024-.038.019-.026.021-.015a.1.1 0 0 1 .027-.005.06.06 0 0 1 .044.016.05.05 0 0 1 .018.039q0 .033-.038.089l-.141.211.152.234a.3.3 0 0 1 .03.051.1.1 0 0 1 .009.038.1.1 0 0 1-.008.031.1.1 0 0 1-.024.023.1.1 0 0 1-.034.008.1.1 0 0 1-.035-.008.1.1 0 0 1-.023-.022L.427-.067.301-.265l-.134.204-.022.034-.016.019a.1.1 0 0 1-.022.015.1.1 0 0 1-.03.005.06.06 0 0 1-.044-.016.06.06 0 0 1-.017-.047q0-.036.036-.088' style='fill-rule:nonzero' transform='matrix(17.82892 0 0 16.50777 10.371 25.928)'/%3E%3C/svg%3E")}.ag-icon-expanded:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eexpanded%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-eye-slash:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye-slash%3C/title%3E%3Cpath d='M21.106 15.088A5.19 5.19 0 0 0 16 10.814a5.17 5.17 0 0 0-3.668 1.522L9.866 9.868a12.2 12.2 0 0 1 6.133-1.646c5.186 0 9.614 3.225 11.408 7.778a12.34 12.34 0 0 1-5.276 6.133l-2.468-2.466a5.17 5.17 0 0 0 1.449-2.802h-2.123c-.148.508-.42.964-.782 1.33l-1.33-1.33h-2.514l2.196 2.196q-.272.049-.56.05a3.11 3.11 0 0 1-2.99-2.245h-2.123a5.19 5.19 0 0 0 7.3 3.836l2.247 2.247a12.2 12.2 0 0 1-4.434.828c-5.186 0-9.614-3.225-11.408-7.778a12.3 12.3 0 0 1 3.781-5.111l2.924 2.924a5.1 5.1 0 0 0-.404 1.275h4.206l-1.296-1.296a3.1 3.1 0 0 1 2.196-.903c1.404 0 2.587.924 2.976 2.199h2.13z'/%3E%3C/svg%3E")}.ag-icon-eye:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eeye%3C/title%3E%3Cpath d='M16 8.222c-5.186 0-9.614 3.225-11.408 7.778 1.794 4.553 6.222 7.778 11.408 7.778S25.614 20.553 27.408 16C25.614 11.447 21.186 8.222 16 8.222m0 12.964c-2.862 0-5.186-2.324-5.186-5.186s2.324-5.186 5.186-5.186 5.186 2.324 5.186 5.186-2.324 5.186-5.186 5.186m0-8.297c-1.721 0-3.111 1.39-3.111 3.111s1.39 3.111 3.111 3.111 3.111-1.39 3.111-3.111-1.39-3.111-3.111-3.111'/%3E%3C/svg%3E")}.ag-icon-filter:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efilter%3C/title%3E%3Cpath d='M13.333 24h5.333v-2.667h-5.333zM4 8v2.667h24V8zm4 9.333h16v-2.667H8z'/%3E%3C/svg%3E")}.ag-icon-first:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Efirst%3C/title%3E%3Cpath d='M24.273 22.12 18.153 16l6.12-6.12L22.393 8l-8 8 8 8zM7.727 8h2.667v16H7.727z'/%3E%3C/svg%3E")}.ag-icon-group:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egroup%3C/title%3E%3Cpath d='M18.667 21.333h8.889A3.555 3.555 0 0 1 24 24.889h-5.333zm8.888-7.111v3.556h-8.889v-3.556zM24 7.111a3.555 3.555 0 0 1 3.556 3.556h-16V7.111zm-8.889 17.778h-3.556v-3.556h3.556zm0-7.111h-3.556v-3.556h3.556zM8 10.667H4.444A3.555 3.555 0 0 1 8 7.111z'/%3E%3C/svg%3E")}.ag-icon-last:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elast%3C/title%3E%3Cpath d='m7.727 9.88 6.12 6.12-6.12 6.12L9.607 24l8-8-8-8zM21.607 8h2.667v16h-2.667z'/%3E%3C/svg%3E")}.ag-icon-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eleft%3C/title%3E%3Cpath d='M26.667 14.667H10.44l7.453-7.453L16 5.334 5.333 16.001 16 26.668l1.88-1.88-7.44-7.453h16.227v-2.667z'/%3E%3C/svg%3E")}.ag-icon-linked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Elinked%3C/title%3E%3Cpath d='M5.2 16a4.136 4.136 0 0 1 4.133-4.133h5.333V9.334H9.333c-3.68 0-6.667 2.987-6.667 6.667s2.987 6.667 6.667 6.667h5.333v-2.533H9.333A4.136 4.136 0 0 1 5.2 16.002zm5.467 1.333h10.667v-2.667H10.667zm12-8h-5.333v2.533h5.333c2.28 0 4.133 1.853 4.133 4.133s-1.853 4.133-4.133 4.133h-5.333v2.533h5.333c3.68 0 6.667-2.987 6.667-6.667s-2.987-6.667-6.667-6.667z'/%3E%3C/svg%3E")}.ag-icon-loading:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eloading%3C/title%3E%3Cpath d='m17.778 11.708 3.25-3.251 2.516 2.516-3.251 3.25h4.597v3.556h-4.597l3.251 3.25-2.516 2.516-3.25-3.251v4.597h-3.556v-4.597l-3.25 3.251-2.516-2.516 3.251-3.25H7.11v-3.556h4.597l-3.251-3.25 2.516-2.516 3.25 3.251V7.111h3.556zm-3.251 7.847h2.944l2.084-2.084v-2.944l-2.084-2.084h-2.944l-2.084 2.084v2.944z'/%3E%3C/svg%3E")}.ag-icon-maximize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emaximize%3C/title%3E%3Cpath d='M4 4h24v2.667H4z'/%3E%3C/svg%3E")}.ag-icon-menu:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Emenu%3C/title%3E%3Cpath d='M4 24h24v-2.667H4zm0-6.667h24v-2.667H4zM4 8v2.667h24V8z'/%3E%3C/svg%3E")}.ag-icon-menu-alt:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M16 26.667a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 24q0-1.1.784-1.883A2.57 2.57 0 0 1 16 21.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 16q0-1.1.784-1.883A2.57 2.57 0 0 1 16 13.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784m0-8a2.57 2.57 0 0 1-1.883-.784A2.57 2.57 0 0 1 13.333 8q0-1.1.784-1.883A2.57 2.57 0 0 1 16 5.333q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784'/%3E%3C/svg%3E")}.ag-icon-minimize:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eminimize%3C/title%3E%3Cpath d='M8 25.333h16V28H8z'/%3E%3C/svg%3E")}.ag-icon-minus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658H7.901v-2.658z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-next:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enext%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-none:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enone%3C/title%3E%3Cpath d='M4 24h16v-2.667H4zM4 8v2.667h24V8zm0 9.333h24v-2.667H4z'/%3E%3C/svg%3E")}.ag-icon-not-allowed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Enot-allowed%3C/title%3E%3Cpath d='M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667M5.333 16c0-5.893 4.773-10.667 10.667-10.667 2.467 0 4.733.84 6.533 2.253L7.586 22.533A10.54 10.54 0 0 1 5.333 16M16 26.667c-2.467 0-4.733-.84-6.533-2.253L24.414 9.467A10.54 10.54 0 0 1 26.667 16c0 5.893-4.773 10.667-10.667 10.667'/%3E%3C/svg%3E")}.ag-icon-paste:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epaste%3C/title%3E%3Cpath d='M25.333 4H19.76C19.2 2.453 17.733 1.333 16 1.333S12.8 2.453 12.24 4H6.667A2.675 2.675 0 0 0 4 6.667V28c0 1.467 1.2 2.667 2.667 2.667h18.667c1.467 0 2.667-1.2 2.667-2.667V6.667C28.001 5.2 26.801 4 25.334 4zM16 4c.733 0 1.333.6 1.333 1.333s-.6 1.333-1.333 1.333-1.333-.6-1.333-1.333S15.267 4 16 4m9.333 24H6.666V6.667h2.667v4h13.333v-4h2.667z'/%3E%3C/svg%3E")}.ag-icon-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epin%3C/title%3E%3Cpath d='m11.106 22.093-4.444 4.444-1.259-1.259 4.444-4.444zm5.872-16.63 9.618 9.62-.962.962-.962-.962-7.694 3.847 1.924 1.924-2.74 2.74-7.696-7.696 2.741-2.74 1.924 1.925 3.847-7.696-.962-.962z'/%3E%3C/svg%3E")}.ag-icon-pivot:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Epivot%3C/title%3E%3Cpath d='M26.667 30.223H5.334a3.556 3.556 0 0 1-3.556-3.556V5.334a3.556 3.556 0 0 1 3.556-3.556h21.333a3.556 3.556 0 0 1 3.556 3.556v21.333a3.556 3.556 0 0 1-3.556 3.556m-16-8.89H5.334v5.333h5.333zm16-7.11H12.444v12.444h14.223zm-9.15 6.85-2.039 2.037 2.039 2.039-1.257 1.257-3.295-3.296 3.295-3.295q.63.628 1.257 1.257zm-6.85-6.85H5.334v5.333h5.333zm15.74 3.816-1.257 1.256-2.039-2.037-2.037 2.037-1.257-1.256 3.295-3.296zM10.667 5.333H5.334v5.333h5.333zm8.889 0h-7.112v5.333h7.112zm7.111 0h-5.333v5.333h5.333z'/%3E%3C/svg%3E")}.ag-icon-plus:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2' viewBox='0 0 32 32'%3E%3Cpath d='M6.572 6.572a13.32 13.32 0 0 0 0 18.856 13.32 13.32 0 0 0 18.856 0 13.32 13.32 0 0 0 0-18.856 13.32 13.32 0 0 0-18.856 0m17.527 8.099v2.658h-6.77v6.77h-2.658v-6.77h-6.77v-2.658h6.77v-6.77h2.658v6.77z' style='fill-rule:nonzero'/%3E%3C/svg%3E")}.ag-icon-previous:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eprevious%3C/title%3E%3Cpath d='M20.94 9.88 19.06 8l-8 8 8 8 1.88-1.88L14.833 16z'/%3E%3C/svg%3E")}.ag-icon-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eright%3C/title%3E%3Cpath d='m16 5.333-1.88 1.88 7.44 7.453H5.333v2.667H21.56l-7.44 7.453 1.88 1.88 10.667-10.667L16 5.332z'/%3E%3C/svg%3E")}.ag-icon-save:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esave%3C/title%3E%3Cpath d='M25.333 16v9.333H6.666V16H3.999v9.333C3.999 26.8 5.199 28 6.666 28h18.667C26.8 28 28 26.8 28 25.333V16zm-8 .893 3.453-3.44 1.88 1.88L15.999 22l-6.667-6.667 1.88-1.88 3.453 3.44V4h2.667v12.893z'/%3E%3C/svg%3E")}.ag-icon-small-down:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-down%3C/title%3E%3Cpath d='M9.333 12.667 16 19.334l6.667-6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-small-left:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-left%3C/title%3E%3Cpath d='M19.333 9.333 12.666 16l6.667 6.667V9.334z'/%3E%3C/svg%3E")}.ag-icon-small-right:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-right%3C/title%3E%3Cpath d='M12.667 22.667 19.334 16l-6.667-6.667v13.333z'/%3E%3C/svg%3E")}.ag-icon-small-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Esmall-up%3C/title%3E%3Cpath d='M9.333 19.333 16 12.666l6.667 6.667H9.334z'/%3E%3C/svg%3E")}.ag-icon-tick:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etick%3C/title%3E%3Cpath d='m11.727 21.167-5.56-5.56-1.893 1.88 7.453 7.453 16-16-1.88-1.88z'/%3E%3C/svg%3E")}.ag-icon-tree-closed:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-closed%3C/title%3E%3Cpath d='m12.94 8-1.88 1.88L17.167 16l-6.107 6.12L12.94 24l8-8z'/%3E%3C/svg%3E")}.ag-icon-tree-indeterminate:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-indeterminate%3C/title%3E%3Cpath d='M6.667 14.667h18.667v2.667H6.667z'/%3E%3C/svg%3E")}.ag-icon-tree-open:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Etree-open%3C/title%3E%3Cpath d='M22.12 11.06 16 17.167 9.88 11.06 8 12.94l8 8 8-8z'/%3E%3C/svg%3E")}.ag-icon-unlinked:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Eunlinked%3C/title%3E%3Cpath d='M22.667 9.333h-5.333v2.533h5.333a4.136 4.136 0 0 1 4.133 4.133c0 1.907-1.307 3.507-3.08 3.973l1.947 1.947c2.173-1.107 3.667-3.32 3.667-5.92a6.67 6.67 0 0 0-6.667-6.667zm-1.334 5.334h-2.92l2.667 2.667h.253zM2.667 5.693 6.814 9.84A6.65 6.65 0 0 0 2.667 16a6.67 6.67 0 0 0 6.667 6.667h5.333v-2.533H9.334a4.136 4.136 0 0 1-4.133-4.133c0-2.12 1.613-3.867 3.68-4.093l2.76 2.76h-.973v2.667h3.64l3.027 3.027v2.307h2.307l5.347 5.333 1.68-1.68L4.362 4.002 2.669 5.695z'/%3E%3C/svg%3E")}.ag-icon-up:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Easc%3C/title%3E%3Cpath d='m5.333 16 1.88 1.88 7.453-7.44v16.227h2.667V10.44l7.44 7.453L26.666 16 15.999 5.333z'/%3E%3C/svg%3E")}.ag-icon-grip:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ctitle%3Egrip%3C/title%3E%3Cpath d='M26.667 12H5.334v2.667h21.333zM5.333 20h21.333v-2.667H5.333z'/%3E%3C/svg%3E")}.ag-icon-settings:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='%23000' d='M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30zm-9 4c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3M2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2zm9-4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3'/%3E%3C/svg%3E")}.ag-icon-column-arrow:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 32 32'%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M11 4a1 1 0 0 1 1 1v22a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 13a1 1 0 0 1 1-1h23.5a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1' clip-rule='evenodd'/%3E%3Cpath fill='currentColor' fill-rule='evenodd' d='M2 4h18v24H2zm2 2v20h14V6zM26.793 13 23 9.207l1.414-1.414L29.621 13l-5.207 5.207L23 16.793z' clip-rule='evenodd'/%3E%3C/svg%3E")}.ag-icon-un-pin:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11'/%3E%3Cpath fill='currentColor' d='M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28zM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972z'/%3E%3C/svg%3E")}.ag-icon-pinned-top:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22M3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536'/%3E%3C/svg%3E")}.ag-icon-pinned-bottom:before{mask-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'%3E%3Cpath fill='currentColor' d='M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22M12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536'/%3E%3C/svg%3E")}`;
// packages/ag-grid-community/src/theming/parts/icon-set/material/icon-set-material.ts
var $437b23f6a393c3bf$export$e9404e008fead04f = /* @__PURE__ */ $437b23f6a393c3bf$export$6e6f0e372f4cb988({
    feature: "iconSet",
    css: $437b23f6a393c3bf$var$iconSetMaterialCSS
});
// packages/ag-grid-community/src/theming/parts/icon-set/overrides/icon-overrides.ts
var $437b23f6a393c3bf$export$32f04c7493939075 = (args)=>{
    const cssParts = [];
    if (args.type === "image") {
        const { icons: icons, mask: mask } = args;
        for (const key of Object.keys(icons)){
            const imageCssValue = $437b23f6a393c3bf$var$imageValueToCss(icons[key]);
            if (mask) cssParts.push(`.ag-icon-${key}::before { mask-image: ${imageCssValue}; }`);
            else cssParts.push(`.ag-icon-${key}::before { background-image: ${imageCssValue}; ${$437b23f6a393c3bf$var$unsetMaskIcon} }`);
        }
    }
    if (args.type === "font") {
        const { family: family, weight: weight, color: color, icons: icons } = args;
        let properties = $437b23f6a393c3bf$var$unsetMaskIcon;
        if (family) properties += ` font-family: ${$437b23f6a393c3bf$var$fontFamilyValueToCss(family)};`;
        if (weight) properties += ` font-weight: ${$437b23f6a393c3bf$var$fontWeightValueToCss(weight)};`;
        if (color) properties += ` color: ${$437b23f6a393c3bf$var$colorValueToCss(color)};`;
        for (const key of Object.keys(icons))cssParts.push(`.ag-icon-${key}::before { content: ${JSON.stringify(icons[key])}; ${properties} }`);
    }
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        css: cssParts.join(";\n"),
        cssImports: args.cssImports
    });
};
var $437b23f6a393c3bf$var$unsetMaskIcon = `background-color: unset; mask-image: unset; -webkit-mask-image: unset;`;
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/quartz-icon-data.ts
var $437b23f6a393c3bf$var$iconNameToSvgFragment = {
    aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
    arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
    asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
    chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
    "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
    columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
    contracted: '<path d="m9 18 6-6-6-6"/>',
    copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
    cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
    desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
    excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
    expanded: '<path d="m15 18-6-6 6-6"/>',
    "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
    eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
    filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
    first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
    group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
    last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
    left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
    loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
    maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
    menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
    "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
    minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
    minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
    next: '<path d="m9 18 6-6-6-6"/>',
    none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
    "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
    paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
    pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
    pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
    plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
    previous: '<path d="m15 18-6-6 6-6"/>',
    right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
    "small-left": '<path d="m15 18-6-6 6-6"/>',
    "small-right": '<path d="m9 18 6-6-6-6"/>',
    tick: '<path d="M20 6 9 17l-5-5"/>',
    "tree-closed": '<path d="m9 18 6-6-6-6"/>',
    "tree-indeterminate": '<path d="M5 12h14"/>',
    "tree-open": '<path d="m6 9 6 6 6-6"/>',
    unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
    up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
    grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
    settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
};
var $437b23f6a393c3bf$var$iconNameToFullSvg = {
    "column-arrow": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 26C0 28.2092 1.79086 30 4 30H14C16.2091 30 18 28.2092 18 26V15H25.8786L24.4394 16.4393C23.8536 17.0251 23.8536 17.9749 24.4394 18.5607C25.0252 19.1464 25.9748 19.1464 26.5606 18.5607L30.5606 14.5607C31.1464 13.9749 31.1464 13.0251 30.5606 12.4393L26.5606 8.43934C25.9748 7.85356 25.0252 7.85356 24.4394 8.43934C23.8536 9.02512 23.8536 9.97488 24.4394 10.5607L25.8786 12H18V6C18 3.79086 16.2091 2 14 2H4C1.79086 2 0 3.79086 0 6V26ZM14 5H10.5V12H15V6C15 5.44772 14.5523 5 14 5ZM4 5H7.5V12H3V6C3 5.44772 3.44772 5 4 5ZM10.5 15H15V26C15 26.5522 14.5523 27 14 27H10.5V15ZM4 27H7.5V15H3V26C3 26.5522 3.44772 27 4 27Z" fill="currentColor"/></svg>',
    "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
    "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>',
    "pinned-top": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.53 3.72A.75.75 0 0 1 12 5H4a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 .53.22ZM3.269 10.744a.75.75 0 0 1 .2-.524l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L8.75 8.56V14a.75.75 0 0 1-1.5 0V8.56l-2.72 2.72a.75.75 0 0 1-1.26-.536Z"/></svg>',
    "pinned-bottom": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M3.47 12.28A.75.75 0 0 1 4 11h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.53-.22ZM12.731 5.256a.75.75 0 0 1-.2.524l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V2a.75.75 0 0 1 1.5 0v5.44l2.72-2.72a.75.75 0 0 1 1.26.536Z"/></svg>',
    "un-pin": '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="ag-icon" viewBox="0 0 16 16"><path fill="currentColor" d="M8 11a.75.75 0 0 0-.75.75v3.333a.75.75 0 1 0 1.5 0V11.75A.75.75 0 0 0 8 11Z"/><path fill="currentColor" d="M13.11 1.436a.75.75 0 0 0-1.22-.872l-10 14a.75.75 0 1 0 1.22.872L5.207 12.5h7.376a.75.75 0 0 0 .75-.75v-1.174a2.08 2.08 0 0 0-1.153-1.863l-1.185-.599-.005-.002a.58.58 0 0 1-.323-.522V5.165a2.083 2.083 0 0 0 1.854-2.904l.589-.825Zm-3.943 5.52v.634a2.08 2.08 0 0 0 1.153 1.863l1.185.6.005.002a.58.58 0 0 1 .323.522V11H6.28l2.887-4.044ZM9.277 1H5.25a2.084 2.084 0 0 0-.083 4.165v1.676l1.5-2.132v-.292a.75.75 0 0 0-.75-.75H5.25a.584.584 0 0 1 0-1.167h2.972L9.277 1Z"/></svg>'
};
var $437b23f6a393c3bf$var$getQuartzIconsCss = (args = {})=>{
    let result = "";
    for (const iconName of [
        ...Object.keys($437b23f6a393c3bf$var$iconNameToSvgFragment),
        ...Object.keys($437b23f6a393c3bf$var$iconNameToFullSvg)
    ]){
        const iconSvg = $437b23f6a393c3bf$var$quartzIconSvg(iconName, args.strokeWidth);
        result += `.ag-icon-${iconName}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(iconSvg)}'); }
`;
    }
    return result;
};
var $437b23f6a393c3bf$var$quartzIconSvg = (name, strokeWidth = 1.5)=>{
    const fullSVG = $437b23f6a393c3bf$var$iconNameToFullSvg[name];
    if (fullSVG) return fullSVG;
    const svgFragment = $437b23f6a393c3bf$var$iconNameToSvgFragment[name];
    if (!svgFragment) throw new Error(`Missing icon data for ${name}`);
    return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${strokeWidth}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + svgFragment + "</svg>";
};
// packages/ag-grid-community/src/theming/parts/icon-set/quartz/icon-set-quartz.ts
var $437b23f6a393c3bf$export$d2d85e4420173ddb = (args = {})=>{
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "iconSet",
        css: ()=>$437b23f6a393c3bf$var$getQuartzIconsCss(args)
    });
};
var $437b23f6a393c3bf$export$3147a7744202f5a7 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 1
});
var $437b23f6a393c3bf$export$b60dff12ba08ba55 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb();
var $437b23f6a393c3bf$export$3a4c15e55a998025 = /* @__PURE__ */ $437b23f6a393c3bf$export$d2d85e4420173ddb({
    strokeWidth: 2
});
// packages/ag-grid-community/src/theming/parts/input-style/input-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBaseCSS = /*css*/ `:where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) .ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-bordered.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleBorderedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){&:focus{box-shadow:var(--ag-focus-shadow)}}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-style-underlined.css-GENERATED.ts
var $437b23f6a393c3bf$var$inputStyleUnderlinedCSS = /*css*/ `.ag-input-field-input:where(input:not([type]),input[type=text],input[type=number],input[type=tel],input[type=date],input[type=datetime-local],textarea){border-left:none;border-right:none;border-top:none}`;
// packages/ag-grid-community/src/theming/parts/input-style/input-styles.ts
var $437b23f6a393c3bf$var$baseParams2 = {
    inputBackgroundColor: "transparent",
    inputBorder: false,
    inputBorderRadius: 0,
    inputTextColor: {
        ref: "textColor"
    },
    inputPlaceholderTextColor: {
        ref: "inputTextColor",
        mix: 0.5
    },
    inputPaddingStart: 0,
    inputHeight: {
        calc: "max(iconSize, fontSize) + spacing * 2"
    },
    inputFocusBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputFocusBorder: {
        ref: "inputBorder"
    },
    inputFocusShadow: "none",
    inputFocusTextColor: {
        ref: "inputTextColor"
    },
    inputDisabledBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputDisabledBorder: {
        ref: "inputBorder"
    },
    inputDisabledTextColor: {
        ref: "inputTextColor"
    },
    inputInvalidBackgroundColor: {
        ref: "inputBackgroundColor"
    },
    inputInvalidBorder: {
        ref: "inputBorder"
    },
    inputInvalidTextColor: {
        ref: "inputTextColor"
    },
    inputIconColor: {
        ref: "inputTextColor"
    },
    pickerButtonBorder: false,
    pickerButtonFocusBorder: {
        ref: "inputFocusBorder"
    },
    pickerButtonBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerButtonFocusBackgroundColor: {
        ref: "backgroundColor"
    },
    pickerListBorder: false,
    pickerListBackgroundColor: {
        ref: "backgroundColor"
    }
};
var $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: $437b23f6a393c3bf$var$baseParams2,
        css: $437b23f6a393c3bf$var$inputStyleBaseCSS
    });
var $437b23f6a393c3bf$export$2c8ad0489069516 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            inputBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
            inputBorder: true,
            inputBorderRadius: {
                ref: "borderRadius"
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: {
                color: $437b23f6a393c3bf$var$accentColor
            },
            inputFocusShadow: {
                ref: "focusShadow"
            },
            inputDisabledBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.06),
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputInvalidBorder: {
                color: {
                    ref: "invalidColor"
                }
            },
            pickerButtonBorder: true,
            pickerListBorder: true
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleBorderedCSS
    });
var $437b23f6a393c3bf$export$df11db3e1948ad10 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleBorderedTreeShakeable();
var $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "inputStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams2,
            inputBackgroundColor: "transparent",
            inputBorder: {
                width: 2,
                color: $437b23f6a393c3bf$var$foregroundMix(0.3)
            },
            inputPaddingStart: {
                ref: "spacing"
            },
            inputFocusBorder: "solid 2px var(--ag-accent-color)",
            inputDisabledTextColor: {
                ref: "textColor",
                mix: 0.5
            },
            inputDisabledBorder: "solid 1px var(--ag-border-color)",
            inputInvalidBorder: {
                width: 2,
                color: {
                    ref: "invalidColor",
                    mix: 0.3
                }
            }
        },
        css: ()=>$437b23f6a393c3bf$var$inputStyleBaseCSS + $437b23f6a393c3bf$var$inputStyleUnderlinedCSS
    });
var $437b23f6a393c3bf$export$c9667c02da45fcf0 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeInputStyleUnderlinedTreeShakeable();
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-base.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleBaseCSS = /*css*/ `.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:1px solid var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:1px solid var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-style-rolodex.css-GENERATED.ts
var $437b23f6a393c3bf$var$tabStyleRolodexCSS = /*css*/ `.ag-tab{border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;border-top:var(--ag-tab-selected-border-width) solid transparent;flex:none;&.ag-tab-selected{border-left-color:var(--ag-tab-selected-border-color);border-right-color:var(--ag-tab-selected-border-color);border-top-color:var(--ag-tab-selected-border-color);margin-bottom:-1px;padding-bottom:calc(var(--ag-tab-bottom-padding) + 1px)}}`;
// packages/ag-grid-community/src/theming/parts/tab-style/tab-styles.ts
var $437b23f6a393c3bf$var$baseParams3 = {
    tabBarBackgroundColor: "transparent",
    tabBarHorizontalPadding: 0,
    tabBarTopPadding: 0,
    tabBackgroundColor: "transparent",
    tabTextColor: {
        ref: "textColor"
    },
    tabHorizontalPadding: {
        ref: "spacing"
    },
    tabTopPadding: {
        ref: "spacing"
    },
    tabBottomPadding: {
        ref: "spacing"
    },
    tabSpacing: "0",
    tabHoverBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabHoverTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBackgroundColor: {
        ref: "tabBackgroundColor"
    },
    tabSelectedTextColor: {
        ref: "tabTextColor"
    },
    tabSelectedBorderWidth: 1,
    tabSelectedBorderColor: "transparent",
    tabSelectedUnderlineColor: "transparent",
    tabSelectedUnderlineWidth: 0,
    tabSelectedUnderlineTransitionDuration: 0,
    tabBarBorder: false
};
var $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: $437b23f6a393c3bf$var$baseParams3,
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7e3279c3902732ba = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleBaseTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            tabBarBorder: true,
            tabBarBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
            tabTextColor: {
                ref: "textColor",
                mix: 0.7
            },
            tabSelectedTextColor: {
                ref: "textColor"
            },
            tabHoverTextColor: {
                ref: "textColor"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$7ad22b51edfdfcfe = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabSelectedUnderlineColor: {
                ref: "primaryColor"
            },
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: 0
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$4c07fbd6ebedeb01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            tabBarBorder: true,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabHoverTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedTextColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
            tabSelectedUnderlineWidth: 2,
            tabSelectedUnderlineTransitionDuration: "0.3s"
        },
        css: $437b23f6a393c3bf$var$tabStyleBaseCSS
    });
var $437b23f6a393c3bf$export$e3b539837601fcda = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable = ()=>$437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "tabStyle",
        params: {
            ...$437b23f6a393c3bf$var$baseParams3,
            tabBarBackgroundColor: {
                ref: "chromeBackgroundColor"
            },
            tabBarHorizontalPadding: {
                ref: "spacing"
            },
            tabBarTopPadding: {
                ref: "spacing"
            },
            tabBarBorder: true,
            tabHorizontalPadding: {
                calc: "spacing * 2"
            },
            tabTopPadding: {
                ref: "spacing"
            },
            tabBottomPadding: {
                ref: "spacing"
            },
            tabSpacing: {
                ref: "spacing"
            },
            tabSelectedBorderColor: {
                ref: "borderColor"
            },
            tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor
        },
        css: ()=>$437b23f6a393c3bf$var$tabStyleBaseCSS + $437b23f6a393c3bf$var$tabStyleRolodexCSS
    });
var $437b23f6a393c3bf$export$5c4a9ec5ca09df01 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeTabStyleRolodexTreeShakeable();
// packages/ag-grid-community/src/theming/parts/theme/material-adjustments.css-GENERATED.ts
var $437b23f6a393c3bf$var$materialAdjustmentsCSS = /*css*/ `.ag-dnd-ghost,.ag-filter-toolpanel-header,.ag-filter-toolpanel-search,.ag-multi-filter-group-title-bar,.ag-panel-title-bar-title,.ag-status-bar{color:var(--ag-header-text-color);font-size:calc(var(--ag-font-size) - 1px);font-weight:600}.ag-column-drop-horizontal{background-color:color-mix(in srgb,var(--ag-background-color),var(--ag-foreground-color) 8%)}.ag-cell.ag-cell-inline-editing{background-color:var(--ag-background-color);background-image:linear-gradient(0deg,var(--ag-input-background-color),var(--ag-input-background-color));border:var(--ag-input-border)!important;border-width:1px!important;height:calc(var(--ag-row-height) + var(--ag-spacing)*3);padding:var(--ag-spacing);:where(.ag-row-last:not(.ag-row-first)) &{bottom:0}:where(.ag-has-focus) &{border:var(--ag-input-focus-border)!important;border-width:1px!important}}.ag-advanced-filter-builder-button,.ag-standard-button{text-transform:uppercase}.ag-status-bar{border:1px solid var(--ag-border-color)}.ag-list-item-hovered:after{background-color:var(--ag-primary-color)}.ag-pill-button:hover{color:var(--ag-primary-color)}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-primary-color)}`;
// packages/ag-grid-community/src/theming/parts/theme/themes.ts
var $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$b60dff12ba08ba55).withPart($437b23f6a393c3bf$export$7ad22b51edfdfcfe).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        fontFamily: [
            {
                googleFont: "IBM Plex Sans"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Roboto",
            "Oxygen-Sans",
            "Ubuntu"
        ]
    });
var $437b23f6a393c3bf$export$495b90cf446940a1 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeQuartzTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$c5a38eb31ae86567).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$9bb4a1bee1653083).withPart($437b23f6a393c3bf$export$e3b539837601fcda).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9dd26d60e574ec0).withParams({
        accentColor: "#2196f3",
        selectedRowBackgroundColor: $437b23f6a393c3bf$var$accentMix(0.3),
        inputFocusBorder: {
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        focusShadow: {
            radius: 2,
            spread: 1.6,
            color: $437b23f6a393c3bf$var$accentMix(0.4)
        },
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45),
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        fontSize: 13,
        dataFontSize: 14,
        headerFontWeight: 700,
        borderRadius: 3,
        wrapperBorderRadius: 3,
        tabSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sideButtonSelectedUnderlineColor: $437b23f6a393c3bf$var$accentColor,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonBarTopPadding: {
            calc: "spacing * 3"
        },
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonHoverTextColor: $437b23f6a393c3bf$var$accentColor,
        iconButtonHoverColor: $437b23f6a393c3bf$var$accentColor,
        toggleButtonWidth: 28,
        toggleButtonHeight: 18,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.45)
    });
var $437b23f6a393c3bf$export$dfd7728c5c3233e9 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeAlpineTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable = ()=>$437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$effe67f8e12191d5).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$var$iconSetBalham).withPart($437b23f6a393c3bf$export$5c4a9ec5ca09df01).withPart($437b23f6a393c3bf$export$df11db3e1948ad10).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withParams({
        accentColor: "#0091ea",
        borderColor: $437b23f6a393c3bf$var$foregroundMix(0.2),
        spacing: 4,
        widgetVerticalSpacing: {
            calc: "max(8px, spacing)"
        },
        borderRadius: 2,
        wrapperBorderRadius: 2,
        headerColumnResizeHandleColor: "transparent",
        headerColumnBorder: true,
        headerColumnBorderHeight: "50%",
        oddRowBackgroundColor: {
            ref: "chromeBackgroundColor",
            mix: 0.5
        },
        checkboxBorderRadius: 2,
        checkboxBorderWidth: 1,
        checkboxUncheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxCheckedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxCheckedBorderColor: $437b23f6a393c3bf$var$accentColor,
        checkboxCheckedShapeColor: $437b23f6a393c3bf$var$accentColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        checkboxIndeterminateBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateShapeColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        focusShadow: {
            radius: 2,
            spread: 1,
            color: $437b23f6a393c3bf$var$accentColor
        },
        headerTextColor: $437b23f6a393c3bf$var$foregroundMix(0.6),
        iconButtonHoverBackgroundColor: "transparent",
        iconButtonActiveBackgroundColor: "transparent",
        fontSize: 12,
        tabSelectedBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        headerFontWeight: "bold",
        toggleButtonWidth: 32,
        toggleButtonHeight: 16,
        toggleButtonSwitchInset: 1,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        sideButtonBorder: true,
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.54),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor
    });
var $437b23f6a393c3bf$export$679a577f1afc49d7 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeBalhamTreeShakeable();
var $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable = ()=>{
    const sharedParams = {
        tabSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        sideButtonSelectedUnderlineColor: {
            ref: "primaryColor"
        },
        buttonTextColor: {
            ref: "primaryColor"
        },
        rangeSelectionBackgroundColor: {
            ref: "primaryColor",
            mix: 0.2
        },
        rangeSelectionBorderColor: {
            ref: "primaryColor"
        },
        rangeSelectionHighlightColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        rangeHeaderHighlightColor: {
            ref: "foregroundColor",
            mix: 0.08
        },
        rowNumbersSelectedColor: {
            ref: "primaryColor",
            mix: 0.5
        },
        inputFocusBorder: {
            width: 2,
            color: {
                ref: "primaryColor"
            }
        },
        pickerButtonFocusBorder: {
            width: 1,
            color: {
                ref: "primaryColor"
            }
        },
        cellEditingBorder: {
            color: {
                ref: "primaryColor"
            }
        },
        menuBackgroundColor: {
            ref: "backgroundColor"
        },
        sideButtonBarBackgroundColor: $437b23f6a393c3bf$var$backgroundColor,
        sideButtonSelectedBackgroundColor: "transparent",
        sideButtonBarTopPadding: {
            calc: "spacing * 4"
        },
        headerColumnResizeHandleColor: "none",
        headerBackgroundColor: {
            ref: "backgroundColor"
        },
        rowHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        columnHoverColor: $437b23f6a393c3bf$var$foregroundMix(0.08),
        headerCellHoverBackgroundColor: $437b23f6a393c3bf$var$foregroundMix(0.05),
        statusBarLabelColor: $437b23f6a393c3bf$var$foregroundMix(0.63),
        statusBarLabelFontWeight: 600,
        statusBarValueFontWeight: 600,
        valueChangeValueHighlightBackgroundColor: "#00acc1",
        panelTitleBarIconColor: $437b23f6a393c3bf$var$foregroundColor,
        advancedFilterBuilderButtonBarBorder: false
    };
    const lightParams = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#000D",
        headerTextColor: "#0008",
        accentColor: "#ff4081",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundColor,
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundColor,
        selectedRowBackgroundColor: "rgba(33, 150, 243, 0.3)"
    };
    const darkParams2 = {
        ...sharedParams,
        primaryColor: "#3f51b5",
        foregroundColor: "#fffD",
        headerTextColor: "#fff8",
        accentColor: "#bb86fc",
        checkboxUncheckedBorderColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        checkboxIndeterminateBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        toggleButtonOffBackgroundColor: $437b23f6a393c3bf$var$foregroundBackgroundMix(0.5),
        selectedRowBackgroundColor: "#bb86fc33"
    };
    return $437b23f6a393c3bf$export$6e6f0e372f4cb988({
        feature: "styleMaterial",
        css: $437b23f6a393c3bf$var$materialAdjustmentsCSS,
        params: lightParams,
        modeParams: {
            light: lightParams,
            dark: darkParams2,
            "dark-blue": darkParams2
        }
    });
};
var $437b23f6a393c3bf$export$5fe7e1ddfe58a67 = /* @__PURE__ */ $437b23f6a393c3bf$var$makeStyleMaterialTreeShakeable();
var $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable = ()=>/* @__PURE__ */ $437b23f6a393c3bf$export$25d302a5b900a763().withPart($437b23f6a393c3bf$export$ac3227978dde8e12).withPart($437b23f6a393c3bf$export$cb8a4bb75f2f86bb).withPart($437b23f6a393c3bf$export$e4400993032942f7).withPart($437b23f6a393c3bf$export$e9404e008fead04f).withPart($437b23f6a393c3bf$export$4c07fbd6ebedeb01).withPart($437b23f6a393c3bf$export$c9667c02da45fcf0).withPart($437b23f6a393c3bf$export$9eadc93b54e4a807).withPart($437b23f6a393c3bf$export$5fe7e1ddfe58a67).withParams({
        rowHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 3.75 * rowVerticalPaddingScale"
        },
        headerHeight: {
            calc: "max(iconSize, dataFontSize) + spacing * 4.75 * headerVerticalPaddingScale"
        },
        widgetVerticalSpacing: {
            calc: "spacing * 1.75"
        },
        cellHorizontalPadding: {
            calc: "spacing * 3"
        },
        buttonHorizontalPadding: {
            ref: "spacing"
        },
        widgetContainerHorizontalPadding: {
            calc: "spacing * 1.5"
        },
        widgetContainerVerticalPadding: {
            calc: "spacing * 2"
        },
        fontSize: 13,
        iconSize: 18,
        borderRadius: 0,
        wrapperBorderRadius: 0,
        wrapperBorder: false,
        menuBorder: false,
        dialogBorder: false,
        panelTitleBarBorder: false,
        tabSelectedBorderWidth: 0,
        tabSelectedUnderlineTransitionDuration: 0.3,
        sidePanelBorder: false,
        sideButtonSelectedBorder: false,
        sideButtonSelectedUnderlineWidth: 2,
        sideButtonSelectedUnderlineTransitionDuration: 0.3,
        sideButtonBorder: false,
        buttonBorder: false,
        buttonDisabledBorder: false,
        focusShadow: {
            spread: 4,
            color: $437b23f6a393c3bf$var$foregroundMix(0.16)
        },
        fontFamily: [
            {
                googleFont: "Roboto"
            },
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            "Oxygen-Sans",
            "Ubuntu",
            "Cantarell",
            "Helvetica Neue",
            "sans-serif"
        ],
        inputHeight: {
            calc: "max(iconSize, fontSize) + spacing * 3"
        },
        pickerButtonBorder: {
            width: 1,
            color: "transparent"
        },
        headerFontWeight: 600,
        headerFontSize: {
            calc: "fontSize - 1px"
        },
        checkboxBorderWidth: 2,
        checkboxBorderRadius: 2,
        toggleButtonWidth: 34,
        toggleButtonSwitchInset: 1,
        cardShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
        popupShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)"
    });
var $437b23f6a393c3bf$export$55ff169dc6a8025a = /* @__PURE__ */ $437b23f6a393c3bf$var$makeThemeMaterialTreeShakeable();
// packages/ag-grid-community/src/environment.ts
var $437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING = {
    cssName: "--ag-cell-horizontal-padding",
    changeKey: "cellHorizontalPaddingChanged",
    defaultValue: 16
};
var $437b23f6a393c3bf$var$INDENTATION_LEVEL = {
    cssName: "--ag-indentation-level",
    changeKey: "indentationLevelChanged",
    defaultValue: 0,
    noWarn: true,
    cacheDefault: true
};
var $437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE = {
    cssName: "--ag-row-group-indent-size",
    changeKey: "rowGroupIndentSizeChanged",
    defaultValue: 0
};
var $437b23f6a393c3bf$var$ROW_HEIGHT = {
    cssName: "--ag-row-height",
    changeKey: "rowHeightChanged",
    defaultValue: 42
};
var $437b23f6a393c3bf$var$HEADER_HEIGHT = {
    cssName: "--ag-header-height",
    changeKey: "headerHeightChanged",
    defaultValue: 48
};
var $437b23f6a393c3bf$var$LIST_ITEM_HEIGHT = {
    cssName: "--ag-list-item-height",
    changeKey: "listItemHeightChanged",
    defaultValue: 24
};
var $437b23f6a393c3bf$var$ROW_BORDER_WIDTH = {
    cssName: "--ag-row-border",
    changeKey: "rowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$PINNED_BORDER_WIDTH = {
    cssName: "--ag-pinned-row-border",
    changeKey: "pinnedRowBorderWidthChanged",
    defaultValue: 1,
    border: true
};
var $437b23f6a393c3bf$var$paramsId = 0;
var $437b23f6a393c3bf$var$Environment = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "environment";
        this.sizeEls = /* @__PURE__ */ new Map();
        this.lastKnownValues = /* @__PURE__ */ new Map();
        this.sizesMeasured = false;
        this.paramsClass = `ag-theme-params-${++$437b23f6a393c3bf$var$paramsId}`;
        this.globalCSS = [];
    }
    wireBeans(beans) {
        const { eGridDiv: eGridDiv, gridOptions: gridOptions } = beans;
        this.eGridDiv = eGridDiv;
        this.eStyleContainer = gridOptions.themeStyleContainer ?? (eGridDiv.getRootNode() === document ? document.head : eGridDiv);
        this.cssLayer = gridOptions.themeCssLayer;
        this.styleNonce = gridOptions.styleNonce;
    }
    postConstruct() {
        this.addManagedPropertyListener("theme", ()=>this.handleThemeGridOptionChange());
        this.handleThemeGridOptionChange();
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.getSizeEl($437b23f6a393c3bf$var$ROW_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$HEADER_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
        this.getSizeEl($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.getSizeEl($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
        this.refreshRowBorderWidthVariable();
        this.addDestroyFunc(()=>$437b23f6a393c3bf$var$_unregisterGridUsingThemingAPI(this));
        this.mutationObserver = new MutationObserver(()=>{
            this.fireGridStylesChangedEvent("themeChanged");
        });
        this.addDestroyFunc(()=>this.mutationObserver.disconnect());
    }
    getPinnedRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$PINNED_BORDER_WIDTH);
    }
    getRowBorderWidth() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
    }
    getDefaultRowHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_HEIGHT);
    }
    getDefaultHeaderHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$HEADER_HEIGHT);
    }
    getDefaultCellHorizontalPadding() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$CELL_HORIZONTAL_PADDING);
    }
    getCellPaddingLeft() {
        const cellHorizontalPadding = this.getDefaultCellHorizontalPadding();
        const indentationLevel = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$INDENTATION_LEVEL);
        const rowGroupIndentSize = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_GROUP_INDENT_SIZE);
        return cellHorizontalPadding - 1 + rowGroupIndentSize * indentationLevel;
    }
    getCellPadding() {
        const cellPaddingRight = this.getDefaultCellHorizontalPadding() - 1;
        return this.getCellPaddingLeft() + cellPaddingRight;
    }
    getDefaultColumnMinWidth() {
        return Math.min(36, this.getDefaultRowHeight());
    }
    getDefaultListItemHeight() {
        return this.getCSSVariablePixelValue($437b23f6a393c3bf$var$LIST_ITEM_HEIGHT);
    }
    applyThemeClasses(el) {
        const { gridTheme: gridTheme } = this;
        let themeClass = "";
        if (gridTheme) themeClass = `${this.paramsClass} ${gridTheme._getCssClass()}`;
        else {
            this.mutationObserver.disconnect();
            let node = this.eGridDiv;
            while(node){
                let isThemeEl = false;
                for (const className of Array.from(node.classList))if (className.startsWith("ag-theme-")) {
                    isThemeEl = true;
                    themeClass = themeClass ? `${themeClass} ${className}` : className;
                }
                if (isThemeEl) this.mutationObserver.observe(node, {
                    attributes: true,
                    attributeFilter: [
                        "class"
                    ]
                });
                node = node.parentElement;
            }
        }
        for (const className of Array.from(el.classList))if (className.startsWith("ag-theme-")) el.classList.remove(className);
        if (themeClass) {
            const oldClass = el.className;
            el.className = oldClass + (oldClass ? " " : "") + themeClass;
        }
    }
    refreshRowHeightVariable() {
        const { eGridDiv: eGridDiv } = this;
        const oldRowHeight = eGridDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) eGridDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            eGridDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? parseFloat(oldRowHeight) : -1;
    }
    addGlobalCSS(css, debugId) {
        if (this.gridTheme) $437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
        else this.globalCSS.push([
            css,
            debugId
        ]);
    }
    getCSSVariablePixelValue(variable) {
        const cached = this.lastKnownValues.get(variable);
        if (cached != null) return cached;
        const measurement = this.measureSizeEl(variable);
        if (measurement === "detached" || measurement === "no-styles") {
            if (variable.cacheDefault) this.lastKnownValues.set(variable, variable.defaultValue);
            return variable.defaultValue;
        }
        this.lastKnownValues.set(variable, measurement);
        return measurement;
    }
    measureSizeEl(variable) {
        const sizeEl = this.getSizeEl(variable);
        if (sizeEl.offsetParent == null) return "detached";
        const newSize = sizeEl.offsetWidth;
        if (newSize === $437b23f6a393c3bf$var$NO_VALUE_SENTINEL) return "no-styles";
        this.sizesMeasured = true;
        return newSize;
    }
    getMeasurementContainer() {
        let container = this.eMeasurementContainer;
        if (!container) {
            container = this.eMeasurementContainer = $437b23f6a393c3bf$export$a232bb0480ae674a({
                tag: "div",
                cls: "ag-measurement-container"
            });
            this.eGridDiv.appendChild(container);
        }
        return container;
    }
    getSizeEl(variable) {
        let sizeEl = this.sizeEls.get(variable);
        if (sizeEl) return sizeEl;
        const container = this.getMeasurementContainer();
        sizeEl = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        const { border: border, noWarn: noWarn } = variable;
        if (border) {
            sizeEl.className = "ag-measurement-element-border";
            sizeEl.style.setProperty("--ag-internal-measurement-border", `var(${variable.cssName}, solid ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`);
        } else sizeEl.style.width = `var(${variable.cssName}, ${$437b23f6a393c3bf$var$NO_VALUE_SENTINEL}px)`;
        container.appendChild(sizeEl);
        this.sizeEls.set(variable, sizeEl);
        let lastMeasurement = this.measureSizeEl(variable);
        if (lastMeasurement === "no-styles" && !noWarn) $437b23f6a393c3bf$export$545083624300f13d(9, {
            variable: variable
        });
        const unsubscribe = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, sizeEl, ()=>{
            const newMeasurement = this.measureSizeEl(variable);
            if (newMeasurement === "detached" || newMeasurement === "no-styles") return;
            this.lastKnownValues.set(variable, newMeasurement);
            if (newMeasurement !== lastMeasurement) {
                lastMeasurement = newMeasurement;
                this.fireGridStylesChangedEvent(variable.changeKey);
            }
        });
        this.addDestroyFunc(()=>unsubscribe());
        return sizeEl;
    }
    fireGridStylesChangedEvent(change) {
        if (change === "rowBorderWidthChanged") this.refreshRowBorderWidthVariable();
        this.eventSvc.dispatchEvent({
            type: "gridStylesChanged",
            [change]: true
        });
    }
    refreshRowBorderWidthVariable() {
        const width = this.getCSSVariablePixelValue($437b23f6a393c3bf$var$ROW_BORDER_WIDTH);
        this.eGridDiv.style.setProperty("--ag-internal-row-border-width", `${width}px`);
    }
    handleThemeGridOptionChange() {
        const { gos: gos, eGridDiv: eGridDiv, globalCSS: globalCSS, gridTheme: oldGridTheme } = this;
        const themeGridOption = gos.get("theme");
        let newGridTheme;
        if (themeGridOption === "legacy") newGridTheme = void 0;
        else {
            const themeOrDefault = themeGridOption ?? $437b23f6a393c3bf$export$495b90cf446940a1;
            if (themeOrDefault instanceof $437b23f6a393c3bf$var$ThemeImpl) newGridTheme = themeOrDefault;
            else $437b23f6a393c3bf$export$a20c7248650823a9(240, {
                theme: themeOrDefault
            });
        }
        if (newGridTheme !== oldGridTheme) {
            if (newGridTheme) {
                $437b23f6a393c3bf$var$_registerGridUsingThemingAPI(this);
                $437b23f6a393c3bf$var$_injectCoreAndModuleCSS(this.eStyleContainer, this.cssLayer, this.styleNonce);
                for (const [css, debugId] of globalCSS)$437b23f6a393c3bf$var$_injectGlobalCSS(css, this.eStyleContainer, debugId, this.cssLayer, 0, this.styleNonce);
                globalCSS.length = 0;
            }
            this.gridTheme = newGridTheme;
            newGridTheme?._startUse({
                loadThemeGoogleFonts: gos.get("loadThemeGoogleFonts"),
                styleContainer: this.eStyleContainer,
                cssLayer: this.cssLayer,
                nonce: this.styleNonce
            });
            let eParamsStyle = this.eParamsStyle;
            if (!eParamsStyle) {
                eParamsStyle = this.eParamsStyle = $437b23f6a393c3bf$export$a232bb0480ae674a({
                    tag: "style"
                });
                const styleNonce = this.gos.get("styleNonce");
                if (styleNonce) eParamsStyle.setAttribute("nonce", styleNonce);
                eGridDiv.appendChild(eParamsStyle);
            }
            if (!$437b23f6a393c3bf$var$IS_SSR) eParamsStyle.textContent = newGridTheme?._getPerGridCss(this.paramsClass) || "";
            this.applyThemeClasses(eGridDiv);
            this.fireGridStylesChangedEvent("themeChanged");
        }
        if (newGridTheme && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded")) {
            if (themeGridOption) $437b23f6a393c3bf$export$a20c7248650823a9(106);
            else $437b23f6a393c3bf$export$a20c7248650823a9(239);
        }
    }
};
var $437b23f6a393c3bf$var$NO_VALUE_SENTINEL = 15538;
// packages/ag-grid-community/src/eventService.ts
var $437b23f6a393c3bf$var$EventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "eventSvc";
        this.globalSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
    }
    postConstruct() {
        const { globalListener: globalListener, globalSyncListener: globalSyncListener } = this.beans;
        if (globalListener) this.addGlobalListener(globalListener, true);
        if (globalSyncListener) this.addGlobalListener(globalSyncListener, false);
    }
    addEventListener(eventType, listener, async) {
        this.globalSvc.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, listener, async) {
        this.globalSvc.removeEventListener(eventType, listener, async);
    }
    addGlobalListener(listener, async = false) {
        this.globalSvc.addGlobalListener(listener, async);
    }
    removeGlobalListener(listener, async = false) {
        this.globalSvc.removeGlobalListener(listener, async);
    }
    /** @deprecated DO NOT FIRE LOCAL EVENTS OFF THE EVENT SERVICE */ dispatchLocalEvent() {}
    dispatchEvent(event) {
        this.globalSvc.dispatchEvent($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event));
    }
    dispatchEventOnce(event) {
        this.globalSvc.dispatchEventOnce($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, event));
    }
};
// packages/ag-grid-community/src/navigation/headerNavigationService.ts
function $437b23f6a393c3bf$var$isAnyChildSpanningHeaderHeight(columnGroup) {
    if (!columnGroup) return false;
    return columnGroup.getLeafColumns().some((col)=>col.isSpanHeaderHeight());
}
function $437b23f6a393c3bf$var$getHeaderIndexToFocus(column, currentIndex) {
    let nextColumn;
    if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column) && $437b23f6a393c3bf$var$isAnyChildSpanningHeaderHeight(column) && column.isPadding()) {
        const targetColumn = column;
        nextColumn = targetColumn.getLeafColumns()[0];
        let col = nextColumn;
        while(col !== targetColumn){
            currentIndex++;
            col = col.getParent();
        }
    }
    return {
        column: nextColumn || column,
        headerRowIndex: currentIndex
    };
}
var $437b23f6a393c3bf$var$HeaderNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "headerNavigation";
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        const beans = this.beans;
        beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        this.addManagedElementListeners(eDocument, {
            mousedown: ()=>{
                this.currentHeaderRowWithoutSpan = -1;
            }
        });
    }
    getHeaderPositionForColumn(colKey, floatingFilter) {
        let column;
        const { colModel: colModel, colGroupSvc: colGroupSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        if (typeof colKey === "string") {
            column = colModel.getCol(colKey);
            if (!column) column = colGroupSvc?.getColumnGroup(colKey) ?? null;
        } else column = colKey;
        if (!column) return null;
        const centerHeaderContainer = ctrlsSvc.getHeaderRowContainerCtrl();
        const allCtrls = centerHeaderContainer?.getAllCtrls();
        const isFloatingFilterVisible = $437b23f6a393c3bf$export$236389741107357f(allCtrls || []).type === "filter";
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        let row = -1;
        let col = column;
        while(col){
            row++;
            col = col.getParent();
        }
        let headerRowIndex = row;
        if (floatingFilter && isFloatingFilterVisible && headerRowIndex === headerRowCount - 1) headerRowIndex++;
        return headerRowIndex === -1 ? null : {
            headerRowIndex: headerRowIndex,
            column: column
        };
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, fromHeader, event) {
        const focusSvc = this.beans.focusSvc;
        if (!fromHeader) fromHeader = focusSvc.focusedHeader;
        if (!fromHeader) return false;
        const { headerRowIndex: headerRowIndex } = fromHeader;
        const column = fromHeader.column;
        const rowLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const isUp = direction === "UP";
        const currentRowType = this.getHeaderRowType(headerRowIndex);
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan: headerRowIndexWithoutSpan } = isUp ? $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, column, headerRowIndex) : $437b23f6a393c3bf$var$getColumnVisibleChild(currentRowType, column, headerRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.currentHeaderRowWithoutSpan = -1;
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event: event
        });
    }
    /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const { focusSvc: focusSvc, gos: gos } = this.beans;
        const focusedHeader = focusSvc.focusedHeader;
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (direction === "LEFT" !== gos.get("enableRtl")) {
            normalisedDirection = "Before";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.findHeader(focusedHeader, normalisedDirection);
        }
        const userFunc = gos.getCallback("tabToNextHeader");
        if (fromTab && userFunc) {
            const wasFocusedFromUserFunc = focusSvc.focusHeaderPositionFromUserFunc({
                userFunc: userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
            if (wasFocusedFromUserFunc) {
                const { headerRowIndex: headerRowIndex } = focusSvc.focusedHeader || {};
                if (headerRowIndex != null && headerRowIndex != focusedHeader.headerRowIndex) this.currentHeaderRowWithoutSpan = headerRowIndex;
            }
            return wasFocusedFromUserFunc;
        }
        if (nextHeader || !fromTab) return focusSvc.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab: fromTab,
            allowUserOverride: true,
            event: event
        });
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const currentIndex = focusedHeader.headerRowIndex;
        let nextPosition = null;
        let nextRowIndex;
        const beans = this.beans;
        if (direction === "Before") {
            if (currentIndex > 0) {
                nextRowIndex = currentIndex - 1;
                this.currentHeaderRowWithoutSpan -= 1;
                nextPosition = this.findColAtEdgeForHeaderRow(nextRowIndex, "end");
            }
        } else {
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans)) this.currentHeaderRowWithoutSpan += 1;
            else this.currentHeaderRowWithoutSpan = -1;
            nextPosition = this.findColAtEdgeForHeaderRow(nextRowIndex, "start");
        }
        if (!nextPosition) return false;
        const { column: column, headerRowIndex: headerRowIndex } = $437b23f6a393c3bf$var$getHeaderIndexToFocus(nextPosition.column, nextPosition?.headerRowIndex);
        return beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: headerRowIndex
            },
            direction: direction,
            fromTab: true,
            allowUserOverride: true,
            event: event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(column)) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? $437b23f6a393c3bf$export$236389741107357f(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.scrollFeature.ensureColumnVisible(columnToScrollTo);
    }
    findHeader(focusedHeader, direction) {
        let nextColumn;
        let getColMethod;
        const { colGroupSvc: colGroupSvc, visibleCols: visibleCols } = this.beans;
        if ($437b23f6a393c3bf$export$1f44a60fc23f9028(focusedHeader.column)) nextColumn = colGroupSvc?.getGroupAtDirection(focusedHeader.column, direction) ?? void 0;
        else {
            getColMethod = `getCol${direction}`;
            nextColumn = visibleCols[getColMethod](focusedHeader.column);
        }
        if (!nextColumn) return;
        const { headerRowIndex: headerRowIndex } = focusedHeader;
        if (this.getHeaderRowType(headerRowIndex) !== "filter") {
            const columnsInPath = [
                nextColumn
            ];
            while(nextColumn.getParent()){
                nextColumn = nextColumn.getParent();
                columnsInPath.push(nextColumn);
            }
            nextColumn = columnsInPath[Math.max(0, columnsInPath.length - 1 - headerRowIndex)];
        }
        const { column: column, headerRowIndex: indexToFocus } = $437b23f6a393c3bf$var$getHeaderIndexToFocus(nextColumn, headerRowIndex);
        return {
            column: column,
            headerRowIndex: indexToFocus
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
    findColAtEdgeForHeaderRow(level, position) {
        const { visibleCols: visibleCols, ctrlsSvc: ctrlsSvc, colGroupSvc: colGroupSvc } = this.beans;
        const displayedColumns = visibleCols.allCols;
        const column = displayedColumns[position === "start" ? 0 : displayedColumns.length - 1];
        if (!column) return;
        const childContainer = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned());
        const type = childContainer?.getRowType(level);
        if (type == "group") {
            const columnGroup = colGroupSvc?.getColGroupAtLevel(column, level);
            return {
                headerRowIndex: level,
                column: columnGroup
            };
        }
        return {
            // if type==null, means the header level didn't exist
            headerRowIndex: type == null ? -1 : level,
            column: column
        };
    }
};
function $437b23f6a393c3bf$var$getColumnVisibleParent(currentRowType, currentColumn, currentIndex) {
    const isFloatingFilter = currentRowType === "filter";
    const isColumn2 = currentRowType === "column";
    let nextFocusColumn = isFloatingFilter ? currentColumn : currentColumn.getParent();
    let nextRow = currentIndex - 1;
    let headerRowIndexWithoutSpan = nextRow;
    if (isColumn2 && $437b23f6a393c3bf$var$isAnyChildSpanningHeaderHeight(currentColumn.getParent())) {
        while(nextFocusColumn && nextFocusColumn.isPadding()){
            nextFocusColumn = nextFocusColumn.getParent();
            nextRow--;
        }
        headerRowIndexWithoutSpan = nextRow;
        if (nextRow < 0) {
            nextFocusColumn = currentColumn;
            nextRow = currentIndex;
            headerRowIndexWithoutSpan = void 0;
        }
    }
    return {
        column: nextFocusColumn,
        headerRowIndex: nextRow,
        headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
    };
}
function $437b23f6a393c3bf$var$getColumnVisibleChild(currentRowType, column, currentIndex, direction = "After") {
    let nextFocusColumn = column;
    let nextRow = currentIndex + 1;
    const headerRowIndexWithoutSpan = nextRow;
    if (currentRowType === "group") {
        const leafColumns = column.getDisplayedLeafColumns();
        const leafColumn = direction === "After" ? leafColumns[0] : $437b23f6a393c3bf$export$236389741107357f(leafColumns);
        const columnsInTheWay = [];
        let currentColumn = leafColumn;
        while(currentColumn.getParent() !== column){
            currentColumn = currentColumn.getParent();
            columnsInTheWay.push(currentColumn);
        }
        nextFocusColumn = leafColumn;
        if (leafColumn.isSpanHeaderHeight()) for(let i = columnsInTheWay.length - 1; i >= 0; i--){
            const colToFocus = columnsInTheWay[i];
            if (!colToFocus.isPadding()) {
                nextFocusColumn = colToFocus;
                break;
            }
            nextRow++;
        }
        else {
            nextFocusColumn = $437b23f6a393c3bf$export$236389741107357f(columnsInTheWay);
            if (!nextFocusColumn) nextFocusColumn = leafColumn;
        }
    }
    return {
        column: nextFocusColumn,
        headerRowIndex: nextRow,
        headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
    };
}
// packages/ag-grid-community/src/focusService.ts
var $437b23f6a393c3bf$var$FocusService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "focusSvc";
        /** If a cell was destroyed that previously had focus, focus needs restored when the cell reappears */ this.focusFallbackTimeout = null;
        this.needsFocusRestored = false;
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.visibleCols = beans.visibleCols;
        this.rowRenderer = beans.rowRenderer;
        this.navigation = beans.navigation;
        this.filterManager = beans.filterManager;
        this.overlays = beans.overlays;
    }
    postConstruct() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedEventListeners({
            columnPivotModeChanged: clearFocusedCellListener,
            newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
            columnGroupOpened: clearFocusedCellListener,
            columnRowGroupChanged: clearFocusedCellListener
        });
        this.addDestroyFunc($437b23f6a393c3bf$var$_registerKeyboardFocusEvents(this.beans));
    }
    attemptToRecoverFocus() {
        this.needsFocusRestored = true;
        if (this.focusFallbackTimeout != null) clearTimeout(this.focusFallbackTimeout);
        this.focusFallbackTimeout = window.setTimeout(this.setFocusRecovered.bind(this), 100);
    }
    setFocusRecovered() {
        this.needsFocusRestored = false;
        if (this.focusFallbackTimeout != null) {
            clearTimeout(this.focusFallbackTimeout);
            this.focusFallbackTimeout = null;
        }
    }
    /**
   * Specifies whether to take focus, as grid either already has focus, or lost it due
   * to a destroyed cell
   * @returns true if the grid should re-take focus, otherwise false
   */ shouldTakeFocus() {
        if (this.gos.get("suppressFocusAfterRefresh")) {
            this.setFocusRecovered();
            return false;
        }
        if (this.needsFocusRestored) {
            this.setFocusRecovered();
            return true;
        }
        return this.doesRowOrCellHaveBrowserFocus();
    }
    onColumnEverythingChanged() {
        if (!this.focusedCell) return;
        const col = this.focusedCell.column;
        const colFromColumnModel = this.colModel.getCol(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        const { gos: gos, focusedCell: focusedCell } = this;
        if (gos.get("suppressFocusAfterRefresh") || gos.get("suppressCellFocus") || !focusedCell) return null;
        if (!this.doesRowOrCellHaveBrowserFocus()) return null;
        return focusedCell;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader) return null;
        if (!this.isDomDataPresentInHierarchy($437b23f6a393c3bf$export$16bc98d422315038(this.beans), $437b23f6a393c3bf$var$DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeader;
    }
    /**
   * Check for both cells and rows, as a row might be destroyed and the dom data removed before the cell if the
   * row is animating out.
   */ doesRowOrCellHaveBrowserFocus() {
        const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        if (this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_CELL_CTRL)) return true;
        return this.isDomDataPresentInHierarchy(activeElement, $437b23f6a393c3bf$var$DOM_DATA_KEY_ROW_CTRL);
    }
    isDomDataPresentInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = $437b23f6a393c3bf$var$_getDomData(this.gos, ePointer, key);
            if (data) return true;
            ePointer = ePointer.parentNode;
        }
        return false;
    }
    getFocusedCell() {
        return this.focusedCell;
    }
    getFocusEventParams(focusedCellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCellPosition;
        const params = {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        if (this.focusedCell == null) return;
        const focusEventParams = this.getFocusEventParams(this.focusedCell);
        this.focusedCell = null;
        this.eventSvc.dispatchEvent({
            type: "cellFocusCleared",
            ...focusEventParams
        });
    }
    setFocusedCell(params) {
        this.setFocusRecovered();
        const { column: column, rowIndex: rowIndex, rowPinned: rowPinned, forceBrowserFocus: forceBrowserFocus = false, preventScrollOnBrowserFocus: preventScrollOnBrowserFocus = false } = params;
        const gridColumn = this.colModel.getCol(column);
        if (!gridColumn) {
            this.focusedCell = null;
            return;
        }
        this.focusedCell = {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
            column: gridColumn
        };
        this.eventSvc.dispatchEvent({
            type: "cellFocused",
            ...this.getFocusEventParams(this.focusedCell),
            forceBrowserFocus: forceBrowserFocus,
            preventScrollOnBrowserFocus: preventScrollOnBrowserFocus
        });
    }
    isCellFocused(cellPosition) {
        if (this.focusedCell == null) return false;
        return $437b23f6a393c3bf$export$be3973033c2c5267(cellPosition, this.focusedCell);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeader == null) return false;
        const { column: column, rowCtrl: { rowIndex: headerRowIndex, pinned: pinned } } = headerCtrl;
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeader;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    focusHeaderPosition(params) {
        this.setFocusRecovered();
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { direction: direction, fromTab: fromTab, allowUserOverride: allowUserOverride, event: event, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue } = params;
        let { headerPosition: headerPosition } = params;
        if (fromCell && this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.focusedHeader;
            const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc: userFunc,
                    direction: direction,
                    currentPosition: currentPosition,
                    headerPosition: headerPosition,
                    headerRowCount: headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount: headerRowCount,
                        event: event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition: headerPosition,
            direction: direction,
            event: event,
            fromCell: fromCell,
            rowWithoutSpanValue: rowWithoutSpanValue
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if ($437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return false;
        const { userFunc: userFunc, headerPosition: headerPosition, direction: direction, event: event } = params;
        const currentPosition = this.focusedHeader;
        const headerRowCount = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans);
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc: userFunc,
            direction: direction,
            currentPosition: currentPosition,
            headerPosition: headerPosition,
            headerRowCount: headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction: direction,
            event: event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc: userFunc, direction: direction, currentPosition: currentPosition, headerPosition: headerPosition, headerRowCount: headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true) return currentPosition;
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition: headerPosition, direction: direction, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, event: event } = params;
        const { column: column, headerRowIndex: headerRowIndex } = headerPosition;
        const { filterManager: filterManager, ctrlsSvc: ctrlsSvc, headerNavigation: headerNavigation } = this.beans;
        if (headerRowIndex === -1) {
            if (filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView({
                column: column,
                event: event
            });
        }
        headerNavigation?.scrollToColumn(column, direction);
        const headerRowContainerCtrl = ctrlsSvc.getHeaderRowContainerCtrl(column.getPinned());
        const focusSuccess = headerRowContainerCtrl?.focusHeader(headerPosition.headerRowIndex, column, event) || false;
        if (headerNavigation && focusSuccess && (rowWithoutSpanValue != null || fromCell)) headerNavigation.currentHeaderRowWithoutSpan = rowWithoutSpanValue ?? -1;
        return focusSuccess;
    }
    focusFirstHeader() {
        if (this.overlays?.isExclusive() && this.focusOverlay()) return true;
        let firstColumn = this.visibleCols.allCols[0];
        if (!firstColumn) return false;
        const { colGroupSvc: colGroupSvc } = this.beans;
        if (colGroupSvc && firstColumn.getParent()) firstColumn = colGroupSvc.getColGroupAtLevel(firstColumn, 0);
        const headerPosition = $437b23f6a393c3bf$var$getHeaderIndexToFocus(firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition: headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        if (this.overlays?.isExclusive() && this.focusOverlay(true)) return true;
        const headerRowIndex = $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1;
        const column = $437b23f6a393c3bf$export$236389741107357f(this.visibleCols.allCols);
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: headerRowIndex,
                column: column
            },
            rowWithoutSpanValue: -1,
            event: event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager?.isAdvFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCell;
    }
    isRowFocused(rowIndex, rowPinnedType) {
        if (this.focusedCell == null) return false;
        return this.focusedCell.rowIndex === rowIndex && this.focusedCell.rowPinned === $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinnedType);
    }
    focusOverlay(backwards) {
        const overlayGui = this.overlays?.isVisible() && this.overlays.eWrapper?.getGui();
        return !!overlayGui && $437b23f6a393c3bf$export$8598088d375f416f(overlayGui, backwards);
    }
    focusGridView(params) {
        const { backwards: backwards = false, canFocusOverlay: canFocusOverlay = true, event: event } = params;
        if (this.overlays?.isExclusive()) return canFocusOverlay && this.focusOverlay(backwards);
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(this.beans)) {
            if (backwards) {
                if (!$437b23f6a393c3bf$var$_isHeaderFocusSuppressed(this.beans)) return this.focusLastHeader();
            }
            if (canFocusOverlay && this.focusOverlay(backwards)) return true;
            if (backwards) return false;
            return $437b23f6a393c3bf$export$987f3c95dc941f0c(this.beans, backwards);
        }
        const nextRow = backwards ? $437b23f6a393c3bf$var$_getLastRow(this.beans) : $437b23f6a393c3bf$var$_getFirstRow(this.beans);
        if (nextRow) {
            const column = params.column ?? this.focusedHeader?.column;
            const { rowIndex: rowIndex, rowPinned: rowPinned } = nextRow;
            const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, nextRow);
            if (!column || !rowNode || rowIndex == null) return false;
            if (column.isSuppressNavigable(rowNode)) {
                const isRtl = this.gos.get("enableRtl");
                let key;
                if (!event || event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) key = isRtl ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT : $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
                else key = event.key;
                this.beans.navigation?.navigateToNextCell(null, key, {
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned || null
                }, true);
                return true;
            }
            this.navigation?.ensureCellVisible({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned
            });
            if (backwards) {
                const rowCtrl = this.rowRenderer.getRowByPosition(nextRow);
                if (rowCtrl?.isFullWidth() && this.navigation?.tryToFocusFullWidthRow(nextRow, backwards)) return true;
            }
            this.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: $437b23f6a393c3bf$export$4978424c4f7b5fc0(rowPinned),
                forceBrowserFocus: true
            });
            this.beans.rangeSvc?.setRangeToCell({
                rowIndex: rowIndex,
                rowPinned: rowPinned,
                column: column
            });
            return true;
        }
        if (canFocusOverlay && this.focusOverlay(backwards)) return true;
        if (backwards && this.focusLastHeader()) return true;
        return false;
    }
    focusAdvancedFilter(position) {
        this.advFilterFocusColumn = position?.column;
        return this.beans.advancedFilter?.getCtrl().focusHeaderComp() ?? false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        const column = (forceFirstColumn ? void 0 : this.advFilterFocusColumn) ?? this.visibleCols.allCols?.[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1
            }
        });
        else return this.focusGridView({
            column: column
        });
    }
    clearAdvancedFilterColumn() {
        this.advFilterFocusColumn = void 0;
    }
};
// packages/ag-grid-community/src/gridBodyComp/scrollVisibleService.ts
var $437b23f6a393c3bf$var$ScrollVisibleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "scrollVisibleSvc";
    }
    wireBeans(beans) {
        this.ctrlsSvc = beans.ctrlsSvc;
        this.colAnimation = beans.colAnimation;
    }
    postConstruct() {
        this.getScrollbarWidth();
        this.addManagedEventListeners({
            displayedColumnsChanged: this.updateScrollVisible.bind(this),
            displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
        });
    }
    updateScrollVisible() {
        const { colAnimation: colAnimation } = this;
        if (colAnimation?.isActive()) colAnimation.executeLaterVMTurn(()=>{
            colAnimation.executeLaterVMTurn(()=>this.updateScrollVisibleImpl());
        });
        else this.updateScrollVisibleImpl();
    }
    updateScrollVisibleImpl() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        if (!centerRowCtrl || this.colAnimation?.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.verticalScrollShowing
        };
        this.setScrollsVisible(params);
        this.updateScrollGap();
    }
    updateScrollGap() {
        const centerRowCtrl = this.ctrlsSvc.get("center");
        const horizontalGap = centerRowCtrl.hasHorizontalScrollGap();
        const verticalGap = centerRowCtrl.hasVerticalScrollGap();
        const atLeastOneDifferent = this.horizontalScrollGap !== horizontalGap || this.verticalScrollGap !== verticalGap;
        if (atLeastOneDifferent) {
            this.horizontalScrollGap = horizontalGap;
            this.verticalScrollGap = verticalGap;
            this.eventSvc.dispatchEvent({
                type: "scrollGapChanged"
            });
        }
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            this.eventSvc.dispatchEvent({
                type: "scrollVisibilityChanged"
            });
        }
    }
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const gridOptionsScrollbarWidth = this.gos.get("scrollbarWidth");
            const useGridOptions = typeof gridOptionsScrollbarWidth === "number" && gridOptionsScrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? gridOptionsScrollbarWidth : $437b23f6a393c3bf$var$_getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventSvc.dispatchEvent({
                    type: "scrollbarWidthChanged"
                });
            }
        }
        return this.scrollbarWidth;
    }
};
// packages/ag-grid-community/src/gridDestroyService.ts
var $437b23f6a393c3bf$var$GridDestroyService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridDestroySvc";
        this.destroyCalled = false;
    }
    destroy() {
        if (this.destroyCalled) return;
        const { stateSvc: stateSvc, ctrlsSvc: ctrlsSvc, context: context } = this.beans;
        this.eventSvc.dispatchEvent({
            type: "gridPreDestroyed",
            state: stateSvc?.getState() ?? {}
        });
        this.destroyCalled = true;
        ctrlsSvc.get("gridCtrl")?.destroyGridUi();
        context.destroy();
        super.destroy();
    }
};
// packages/ag-grid-community/src/events.ts
var $437b23f6a393c3bf$export$12e4e9a3cbd0ec07 = /* @__PURE__ */ new Set([
    "gridPreDestroyed",
    "fillStart",
    "pasteStart"
]);
// packages/ag-grid-community/src/gridOptionsDefault.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: true,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    enableStrictPivotColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressMoveWhenColumnDragging: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    cellFlashDuration: 500,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1,
    columnMenu: "new",
    reactiveCustomComponents: true,
    suppressSetFilterByDefault: false,
    rowNumbers: false
};
// packages/ag-grid-community/src/sort/sortIndicatorComp.ts
var $437b23f6a393c3bf$var$makeIconParams = (dataRefSuffix, classSuffix)=>({
        tag: "span",
        ref: `eSort${dataRefSuffix}`,
        cls: `ag-sort-indicator-icon ag-sort-${classSuffix} ag-hidden`,
        attrs: {
            "aria-hidden": "true"
        }
    });
var $437b23f6a393c3bf$var$SortIndicatorElement = {
    tag: "span",
    cls: "ag-sort-indicator-container",
    children: [
        $437b23f6a393c3bf$var$makeIconParams("Order", "order"),
        $437b23f6a393c3bf$var$makeIconParams("Asc", "ascending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Desc", "descending-icon"),
        $437b23f6a393c3bf$var$makeIconParams("Mixed", "mixed-icon"),
        $437b23f6a393c3bf$var$makeIconParams("None", "none-icon")
    ]
};
var $437b23f6a393c3bf$var$SortIndicatorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(skipTemplate){
        super();
        // Elements might by undefined when the user provides a custom template
        this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        if (!skipTemplate) this.setTemplate($437b23f6a393c3bf$var$SortIndicatorElement);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!column.isSortable() && !column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        const updateIcons = this.updateIcons.bind(this);
        const sortUpdated = this.onSortChanged.bind(this);
        this.addManagedPropertyListener("unSortIcon", updateIcons);
        this.addManagedEventListeners({
            newColumnsLoaded: updateIcons,
            // Watch global events, as row group columns can effect their display column.
            sortChanged: sortUpdated,
            // when grouping changes so can sort indexes and icons
            columnRowGroupChanged: sortUpdated
        });
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const { eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortNone: eSortNone, column: column, gos: gos, beans: beans } = this;
        const sortDirection = beans.sortSvc.getDisplaySortForColumn(column);
        if (eSortAsc) {
            const isAscending = sortDirection === "asc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortAsc, isAscending, {
                skipAriaHidden: true
            });
        }
        if (eSortDesc) {
            const isDescending = sortDirection === "desc";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortDesc, isDescending, {
                skipAriaHidden: true
            });
        }
        if (eSortNone) {
            const alwaysHideNoSort = !column.getColDef().unSortIcon && !gos.get("unSortIcon");
            const isNone = sortDirection === null || sortDirection === void 0;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortNone, !alwaysHideNoSort && isNone, {
                skipAriaHidden: true
            });
        }
    }
    setupMultiSortIndicator() {
        const { eSortMixed: eSortMixed, column: column, gos: gos } = this;
        this.addInIcon("sortUnSort", eSortMixed, column);
        const isColumnShowingRowGroup = column.getColDef().showRowGroup;
        const areGroupsCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedEventListeners({
                // Watch global events, as row group columns can effect their display column.
                sortChanged: this.updateMultiSortIndicator.bind(this),
                // when grouping changes so can sort indexes and icons
                columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
            });
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        const { eSortMixed: eSortMixed, beans: beans, column: column } = this;
        if (eSortMixed) {
            const isMixedSort = beans.sortSvc.getDisplaySortForColumn(column) === "mixed";
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        const { eSortOrder: eSortOrder, column: column, beans: { sortSvc: sortSvc } } = this;
        if (!eSortOrder) return;
        const allColumnsWithSorting = sortSvc.getColumnsWithSortingOrdered();
        const indexThisCol = sortSvc.getDisplaySortIndexForColumn(column) ?? -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>sortSvc.getDisplaySortIndexForColumn(col) ?? false);
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) eSortOrder.textContent = (indexThisCol + 1).toString();
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eSortOrder);
    }
};
var $437b23f6a393c3bf$var$SortIndicatorSelector = {
    selector: "AG-SORT-INDICATOR",
    component: $437b23f6a393c3bf$var$SortIndicatorComp
};
// packages/ag-grid-community/src/sort/sortService.ts
var $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
var $437b23f6a393c3bf$var$SortService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortSvc";
    }
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    progressSortFromEvent(column, event) {
        const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
        const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
        this.progressSort(column, multiSort, "uiColumnSorted");
    }
    setSortForColumn(column, sort, multiSort, source) {
        if (sort !== "asc" && sort !== "desc") sort = null;
        const { gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        const isColumnsSortingCoupledToGroup = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = showRowGroupCols?.getSourceColumnsForGroupColumn?.(column);
                const sortableRowGroupColumns = rowGroupColumns?.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        columnsToUpdate.forEach((col)=>this.setColSort(col, sort, source));
        const doingMultiSort = (multiSort || gos.get("alwaysMultiSort")) && !gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols } = this.beans;
        const isCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        const groupParent = showRowGroupCols?.getShowRowGroupCol(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        colModel.forAllCols((col)=>this.setColSortIndex(col, null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = lastSortIndexCol.getSort() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>this.setColSortIndex(col, idx));
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        let isSorting = false;
        this.beans.colModel.forAllCols((col)=>{
            if (col.getSort()) isSorting = true;
        });
        return isSorting;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: "sortChanged",
            source: source
        };
        if (columns) event.columns = columns;
        this.eventSvc.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.beans.colModel.forAllCols((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (columnToClear.getSort()) clearedColumns.push(columnToClear);
                this.setColSort(columnToClear, void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        const sortingOrder = column.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? $437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER;
        const currentIndex = sortingOrder.indexOf(column.getSort());
        const notInArray = currentIndex < 0;
        const lastItemInArray = currentIndex == sortingOrder.length - 1;
        return notInArray || lastItemInArray ? sortingOrder[0] : sortingOrder[currentIndex + 1];
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        const { gos: gos, colModel: colModel, showRowGroupCols: showRowGroupCols, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        let allSortedCols = [];
        colModel.forAllCols((col)=>{
            if (col.getSort()) allSortedCols.push(col);
        });
        if (colModel.isPivotMode()) {
            const isSortingLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? showRowGroupCols?.getShowRowGroupCol(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = rowGroupColsSvc?.columns.filter((col)=>!!col.getSort()) ?? [];
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = $437b23f6a393c3bf$export$96c51c2547b81aed(gos) && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>showRowGroupCols?.getShowRowGroupCol(col.getId()) ?? col))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) sortedRowGroupCols.forEach((col)=>{
            const groupDisplayCol = showRowGroupCols.getShowRowGroupCol(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        });
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([, idx1], [, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    // used by server side row models, to sent sort to server
    getSortModel() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                colId: column.getId()
            }));
    }
    getSortOptions() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                column: column
            }));
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = $437b23f6a393c3bf$export$96c51c2547b81aed(this.gos);
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !linkedColumns?.length) return column.getSort();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSort();
        const allMatch = sortableColumns.every((col)=>col.getSort() == firstSort);
        if (!allMatch) return "mixed";
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
    setupHeader(comp, column, clickElement) {
        let lastMovingChanged = 0;
        comp.addManagedListeners(column, {
            movingChanged: ()=>{
                lastMovingChanged = Date.now();
            }
        });
        if (clickElement) comp.addManagedElementListeners(clickElement, {
            click: (event)=>{
                const moving = column.isMoving();
                const nowTime = Date.now();
                const movedRecently = nowTime - lastMovingChanged < 50;
                const columnMoving = moving || movedRecently;
                if (!columnMoving) this.progressSortFromEvent(column, event);
            }
        });
        const onSortingChanged = ()=>{
            const sort = column.getSort();
            comp.toggleCss("ag-header-cell-sorted-asc", sort === "asc");
            comp.toggleCss("ag-header-cell-sorted-desc", sort === "desc");
            comp.toggleCss("ag-header-cell-sorted-none", !sort);
            if (column.getColDef().showRowGroup) {
                const sourceColumns = this.beans.showRowGroupCols?.getSourceColumnsForGroupColumn(column);
                const sortDirectionsMatch = sourceColumns?.every((sourceCol)=>column.getSort() == sourceCol.getSort());
                const isMultiSorting = !sortDirectionsMatch;
                comp.toggleCss("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        comp.addManagedEventListeners({
            sortChanged: onSortingChanged,
            columnRowGroupChanged: onSortingChanged
        });
    }
    initCol(column) {
        const { sort: sort, initialSort: initialSort, sortIndex: sortIndex, initialSortIndex: initialSortIndex } = column.colDef;
        if (sort !== void 0) {
            if (sort === "asc" || sort === "desc") column.sort = sort;
        } else if (initialSort === "asc" || initialSort === "desc") column.sort = initialSort;
        if (sortIndex !== void 0) {
            if (sortIndex !== null) column.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) column.sortIndex = initialSortIndex;
    }
    updateColSort(column, sort, source) {
        if (sort !== void 0) {
            if (sort === "desc" || sort === "asc") this.setColSort(column, sort, source);
            else this.setColSort(column, void 0, source);
        }
    }
    setColSort(column, sort, source) {
        if (column.sort !== sort) {
            column.sort = sort;
            column.dispatchColEvent("sortChanged", source);
        }
        column.dispatchStateUpdatedEvent("sort");
    }
    setColSortIndex(column, sortOrder) {
        column.sortIndex = sortOrder;
        column.dispatchStateUpdatedEvent("sortIndex");
    }
    createSortIndicator(skipTemplate) {
        return new $437b23f6a393c3bf$var$SortIndicatorComp(skipTemplate);
    }
    getSortIndicatorSelector() {
        return $437b23f6a393c3bf$var$SortIndicatorSelector;
    }
};
// packages/ag-grid-community/src/validation/rules/userCompValidations.ts
var $437b23f6a393c3bf$var$USER_COMP_MODULES = {
    agSetColumnFilter: "SetFilter",
    agSetColumnFloatingFilter: "SetFilter",
    agMultiColumnFilter: "MultiFilter",
    agMultiColumnFloatingFilter: "MultiFilter",
    agGroupColumnFilter: "GroupFilter",
    agGroupColumnFloatingFilter: "GroupFilter",
    agGroupCellRenderer: "GroupCellRenderer",
    agGroupRowRenderer: "GroupCellRenderer",
    agRichSelect: "RichSelect",
    agRichSelectCellEditor: "RichSelect",
    agDetailCellRenderer: "SharedMasterDetail",
    agSparklineCellRenderer: "Sparklines",
    agDragAndDropImage: "SharedDragAndDrop",
    agColumnHeader: "ColumnHeaderComp",
    agColumnGroupHeader: "ColumnGroupHeaderComp",
    agSortIndicator: "Sort",
    agAnimateShowChangeCellRenderer: "HighlightChanges",
    agAnimateSlideCellRenderer: "HighlightChanges",
    agLoadingCellRenderer: "LoadingCellRenderer",
    agSkeletonCellRenderer: "SkeletonCellRenderer",
    agCheckboxCellRenderer: "CheckboxCellRenderer",
    agLoadingOverlay: "Overlay",
    agNoRowsOverlay: "Overlay",
    agTooltipComponent: "Tooltip",
    agReadOnlyFloatingFilter: "CustomFilter",
    agTextColumnFilter: "TextFilter",
    agNumberColumnFilter: "NumberFilter",
    agDateColumnFilter: "DateFilter",
    agDateInput: "DateFilter",
    agTextColumnFloatingFilter: "TextFilter",
    agNumberColumnFloatingFilter: "NumberFilter",
    agDateColumnFloatingFilter: "DateFilter",
    agCellEditor: "TextEditor",
    agSelectCellEditor: "SelectEditor",
    agTextCellEditor: "TextEditor",
    agNumberCellEditor: "NumberEditor",
    agDateCellEditor: "DateEditor",
    agDateStringCellEditor: "DateEditor",
    agCheckboxCellEditor: "CheckboxEditor",
    agLargeTextCellEditor: "LargeTextEditor",
    agMenuItem: "MenuItem",
    agColumnsToolPanel: "ColumnsToolPanel",
    agFiltersToolPanel: "FiltersToolPanel",
    agAggregationComponent: "StatusBar",
    agSelectedRowCountComponent: "StatusBar",
    agTotalRowCountComponent: "StatusBar",
    agFilteredRowCountComponent: "StatusBar",
    agTotalAndFilteredRowCountComponent: "StatusBar",
    agFindCellRenderer: "Find"
};
// packages/ag-grid-community/src/validation/rules/colDefValidations.ts
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS = ()=>({
        checkboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.checkboxes` in `GridOptions` instead."
        },
        headerCheckboxSelection: {
            version: "32.2",
            message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
        },
        headerCheckboxSelectionFilteredOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
        },
        headerCheckboxSelectionCurrentPageOnly: {
            version: "32.2",
            message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
        },
        showDisabledCheckboxes: {
            version: "32.2",
            message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
        }
    });
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS = {
    aggFunc: "SharedAggregation",
    autoHeight: "RowAutoHeight",
    cellClass: "CellStyle",
    cellClassRules: "CellStyle",
    cellEditor: ({ cellEditor: cellEditor, editable: editable })=>{
        if (!editable) return null;
        if (typeof cellEditor === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellEditor] ?? "CustomEditor";
        return "CustomEditor";
    },
    cellRenderer: ({ cellRenderer: cellRenderer })=>{
        if (typeof cellRenderer !== "string") return null;
        return $437b23f6a393c3bf$var$USER_COMP_MODULES[cellRenderer];
    },
    cellStyle: "CellStyle",
    columnChooserParams: "ColumnMenu",
    contextMenuItems: "ContextMenu",
    dndSource: "DragAndDrop",
    dndSourceOnRowDrag: "DragAndDrop",
    editable: ({ editable: editable, cellEditor: cellEditor })=>{
        if (editable && !cellEditor) return "TextEditor";
        return null;
    },
    enableCellChangeFlash: "HighlightChanges",
    enablePivot: "SharedPivot",
    enableRowGroup: "SharedRowGrouping",
    enableValue: "SharedAggregation",
    filter: ({ filter: filter })=>{
        if (filter && typeof filter !== "string" && typeof filter !== "boolean") return "CustomFilter";
        if (typeof filter === "string") return $437b23f6a393c3bf$var$USER_COMP_MODULES[filter] ?? "ColumnFilter";
        return "ColumnFilter";
    },
    floatingFilter: "ColumnFilter",
    getQuickFilterText: "QuickFilter",
    headerTooltip: "Tooltip",
    mainMenuItems: "ColumnMenu",
    menuTabs: (options)=>{
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if (options.menuTabs?.some((tab)=>enterpriseMenuTabs.includes(tab))) return "ColumnMenu";
        return null;
    },
    pivot: "SharedPivot",
    pivotIndex: "SharedPivot",
    rowDrag: "RowDrag",
    rowGroup: "SharedRowGrouping",
    rowGroupIndex: "SharedRowGrouping",
    tooltipField: "Tooltip",
    tooltipValueGetter: "Tooltip",
    spanRows: "CellSpan"
};
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS = ()=>{
    const validations = {
        autoHeight: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_colDef, { paginationAutoPageSize: paginationAutoPageSize })=>{
                if (paginationAutoPageSize) return "colDef.autoHeight is not supported with paginationAutoPageSize.";
                return null;
            }
        },
        cellRendererParams: {
            validate: (colDef)=>{
                const groupColumn = colDef.rowGroup != null || colDef.rowGroupIndex != null || colDef.cellRenderer === "agGroupCellRenderer";
                if (groupColumn && "checkbox" in colDef.cellRendererParams) return 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.';
                return null;
            }
        },
        flex: {
            validate: (_options, gridOptions)=>{
                if (gridOptions.autoSizeStrategy) return "colDef.flex is not supported with gridOptions.autoSizeStrategy";
                return null;
            }
        },
        headerCheckboxSelection: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionCurrentPageOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
        },
        headerCheckboxSelectionFilteredOnly: {
            supportedRowModels: [
                "clientSide"
            ],
            validate: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
        },
        headerValueGetter: {
            validate: (_options)=>{
                const headerValueGetter = _options.headerValueGetter;
                if (typeof headerValueGetter === "function" || typeof headerValueGetter === "string") return null;
                return "headerValueGetter must be a function or a valid string expression";
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        type: {
            validate: (_options)=>{
                const type = _options.type;
                if (type instanceof Array) {
                    const invalidArray = type.some((a)=>typeof a !== "string");
                    if (invalidArray) return "if colDef.type is supplied an array it should be of type 'string[]'";
                    return null;
                }
                if (typeof type === "string") return null;
                return "colDef.type should be of type 'string' | 'string[]'";
            }
        },
        rowSpan: {
            validate: (_options, { suppressRowTransform: suppressRowTransform })=>{
                if (!suppressRowTransform) return "colDef.rowSpan requires suppressRowTransform to be enabled.";
                return null;
            }
        },
        spanRows: {
            dependencies: {
                editable: {
                    required: [
                        false,
                        void 0
                    ]
                },
                rowDrag: {
                    required: [
                        false,
                        void 0
                    ]
                },
                colSpan: {
                    required: [
                        void 0
                    ]
                },
                rowSpan: {
                    required: [
                        void 0
                    ]
                }
            },
            validate: (_options, { rowSelection: rowSelection, cellSelection: cellSelection, suppressRowTransform: suppressRowTransform, enableCellSpan: enableCellSpan, rowDragEntireRow: rowDragEntireRow, enableCellTextSelection: enableCellTextSelection })=>{
                if (typeof rowSelection === "object") {
                    if (rowSelection?.mode === "singleRow" && rowSelection?.enableClickSelection) return "colDef.spanRows is not supported with rowSelection.clickSelection";
                }
                if (cellSelection) return "colDef.spanRows is not supported with cellSelection.";
                if (suppressRowTransform) return "colDef.spanRows is not supported with suppressRowTransform.";
                if (!enableCellSpan) return "colDef.spanRows requires enableCellSpan to be enabled.";
                if (rowDragEntireRow) return "colDef.spanRows is not supported with rowDragEntireRow.";
                if (enableCellTextSelection) return "colDef.spanRows is not supported with enableCellTextSelection.";
                return null;
            }
        }
    };
    return validations;
};
var $437b23f6a393c3bf$var$colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerStyle: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    spanRows: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0,
    context: void 0,
    dateComponent: void 0,
    dateComponentParams: void 0,
    getFindText: void 0
};
var $437b23f6a393c3bf$var$ALL_PROPERTIES = ()=>Object.keys($437b23f6a393c3bf$var$colDefPropertyMap);
var $437b23f6a393c3bf$var$COL_DEF_VALIDATORS = ()=>({
        objectName: "colDef",
        allProperties: $437b23f6a393c3bf$var$ALL_PROPERTIES(),
        docsUrl: "column-properties/",
        deprecations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS()
    });
// packages/ag-grid-community/src/eventTypes.ts
var $437b23f6a393c3bf$export$e9c8ffb796317123 = [
    "columnEverythingChanged",
    "newColumnsLoaded",
    "columnPivotModeChanged",
    "pivotMaxColumnsExceeded",
    "columnRowGroupChanged",
    "expandOrCollapseAll",
    "columnPivotChanged",
    "gridColumnsChanged",
    "columnValueChanged",
    "columnMoved",
    "columnVisible",
    "columnPinned",
    "columnGroupOpened",
    "columnResized",
    "displayedColumnsChanged",
    "virtualColumnsChanged",
    "columnHeaderMouseOver",
    "columnHeaderMouseLeave",
    "columnHeaderClicked",
    "columnHeaderContextMenu",
    "asyncTransactionsFlushed",
    "rowGroupOpened",
    "rowDataUpdated",
    "pinnedRowDataChanged",
    "pinnedRowsChanged",
    "rangeSelectionChanged",
    "cellSelectionChanged",
    "chartCreated",
    "chartRangeSelectionChanged",
    "chartOptionsChanged",
    "chartDestroyed",
    "toolPanelVisibleChanged",
    "toolPanelSizeChanged",
    "modelUpdated",
    "cutStart",
    "cutEnd",
    "pasteStart",
    "pasteEnd",
    "fillStart",
    "fillEnd",
    "cellSelectionDeleteStart",
    "cellSelectionDeleteEnd",
    "rangeDeleteStart",
    "rangeDeleteEnd",
    "undoStarted",
    "undoEnded",
    "redoStarted",
    "redoEnded",
    "cellClicked",
    "cellDoubleClicked",
    "cellMouseDown",
    "cellContextMenu",
    "cellValueChanged",
    "cellEditRequest",
    "rowValueChanged",
    "headerFocused",
    "cellFocused",
    "rowSelected",
    "selectionChanged",
    "tooltipShow",
    "tooltipHide",
    "cellKeyDown",
    "cellMouseOver",
    "cellMouseOut",
    "filterChanged",
    "filterModified",
    "filterOpened",
    "advancedFilterBuilderVisibleChanged",
    "sortChanged",
    "virtualRowRemoved",
    "rowClicked",
    "rowDoubleClicked",
    "gridReady",
    "gridPreDestroyed",
    "gridSizeChanged",
    "viewportChanged",
    "firstDataRendered",
    "dragStarted",
    "dragStopped",
    "dragCancelled",
    "rowEditingStarted",
    "rowEditingStopped",
    "cellEditingStarted",
    "cellEditingStopped",
    "bodyScroll",
    "bodyScrollEnd",
    "paginationChanged",
    "componentStateChanged",
    "storeRefreshed",
    "stateUpdated",
    "columnMenuVisibleChanged",
    "contextMenuVisibleChanged",
    "rowDragEnter",
    "rowDragMove",
    "rowDragLeave",
    "rowDragEnd",
    "rowDragCancel",
    "findChanged",
    "rowResizeStarted",
    "rowResizeEnded"
];
var $437b23f6a393c3bf$var$_INTERNAL_EVENTS = [
    "scrollbarWidthChanged",
    "keyShortcutChangedCellStart",
    "keyShortcutChangedCellEnd",
    "pinnedHeightChanged",
    "cellFocusCleared",
    "fullWidthRowFocused",
    "checkboxChanged",
    "heightScaleChanged",
    "suppressMovableColumns",
    "suppressMenuHide",
    "suppressFieldDotNotation",
    "columnPanelItemDragStart",
    "columnPanelItemDragEnd",
    "bodyHeightChanged",
    "columnContainerWidthChanged",
    "displayedColumnsWidthChanged",
    "scrollVisibilityChanged",
    "scrollGapChanged",
    "columnHoverChanged",
    "flashCells",
    "paginationPixelOffsetChanged",
    "displayedRowsChanged",
    "leftPinnedWidthChanged",
    "rightPinnedWidthChanged",
    "rowContainerHeightChanged",
    "headerHeightChanged",
    "columnGroupHeaderHeightChanged",
    "columnHeaderHeightChanged",
    "gridStylesChanged",
    "storeUpdated",
    "filterDestroyed",
    "rowDataUpdateStarted",
    "rowCountReady",
    "advancedFilterEnabledChanged",
    "dataTypesInferred",
    "fieldValueChanged",
    "fieldPickerValueSelected",
    "richSelectListRowSelected",
    "sideBarUpdated",
    "alignedGridScroll",
    "alignedGridColumn",
    "gridOptionsChanged",
    "chartTitleEdit",
    "recalculateRowBounds",
    "stickyTopOffsetChanged",
    "overlayExclusiveChanged",
    "beforeRefreshModel",
    "rowNodeDataChanged"
];
var $437b23f6a393c3bf$export$a4bee1102f884a4d = ()=>[
        ...$437b23f6a393c3bf$export$e9c8ffb796317123,
        ...$437b23f6a393c3bf$var$_INTERNAL_EVENTS
    ];
// packages/ag-grid-community/src/propertyKeys.ts
var $437b23f6a393c3bf$var$STRING_GRID_OPTIONS = [
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "treeDataChildrenField",
    "treeDataParentIdField",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "grandTotalRow",
    "themeCssLayer",
    "findSearchValue",
    "styleNonce"
];
var $437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "dragAndDropImageComponentParams",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "popupParent",
    "themeStyleContainer",
    "statusBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "initialState",
    "autoSizeStrategy",
    "selectionColumnDef",
    "findOptions"
];
var $437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector"
];
var $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns"
];
var $437b23f6a393c3bf$var$OTHER_GRID_OPTIONS = [
    "theme",
    "rowSelection"
];
var $437b23f6a393c3bf$export$fb22311288c545c2 = [
    "cellSelection",
    "sideBar",
    "rowNumbers",
    "suppressGroupChangesColumnVisibility",
    "groupAggFiltering",
    "suppressStickyTotalRow",
    "groupHideParentOfSingleChild",
    "enableRowPinning"
];
var $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS = [
    "loadThemeGoogleFonts",
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressColumnMoveAnimation",
    "suppressMoveWhenColumnDragging",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "enableCellSpan",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval",
    "loading",
    "maintainColumnOrder",
    "enableStrictPivotColumnOrder",
    "suppressSetFilterByDefault"
];
var $437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "dragAndDropImageComponent",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher",
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "focusGridInnerElement",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "loadingCellRendererSelector",
    "getRowId",
    "chartMenuItems",
    "groupTotalRow",
    "alwaysPassFilter",
    "isRowPinnable",
    "isRowPinned"
];
var $437b23f6a393c3bf$export$a827a39ae0574df3 = ()=>[
        ...$437b23f6a393c3bf$var$ARRAY_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$OBJECT_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$STRING_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_FUNCTION_GRID_OPTIONS,
        ...$437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS,
        ...$437b23f6a393c3bf$export$fb22311288c545c2,
        ...$437b23f6a393c3bf$var$OTHER_GRID_OPTIONS
    ];
// packages/ag-grid-community/src/validation/rules/gridOptionsValidations.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS = ()=>({
        suppressLoadingOverlay: {
            version: "32",
            message: "Use `loading`=false instead."
        },
        enableFillHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeHandle: {
            version: "32.2",
            message: "Use `cellSelection.handle` instead."
        },
        enableRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection = true` instead."
        },
        suppressMultiRangeSelection: {
            version: "32.2",
            message: "Use `cellSelection.suppressMultiRanges` instead."
        },
        suppressClearOnFillReduction: {
            version: "32.2",
            message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
        },
        fillHandleDirection: {
            version: "32.2",
            message: "Use `cellSelection.handle.direction` instead."
        },
        fillOperation: {
            version: "32.2",
            message: "Use `cellSelection.handle.setFillValue` instead."
        },
        suppressRowClickSelection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        suppressRowDeselection: {
            version: "32.2",
            message: "Use `rowSelection.enableClickSelection` instead."
        },
        rowMultiSelectWithClick: {
            version: "32.2",
            message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
        },
        groupSelectsChildren: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
        },
        groupSelectsFiltered: {
            version: "32.2",
            message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
        },
        isRowSelectable: {
            version: "32.2",
            message: "Use `selectionOptions.isRowSelectable` instead."
        },
        suppressCopySingleCellRanges: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        suppressCopyRowsToClipboard: {
            version: "32.2",
            message: "Use `rowSelection.copySelectedRows` instead."
        },
        onRangeSelectionChanged: {
            version: "32.2",
            message: "Use `onCellSelectionChanged` instead."
        },
        onRangeDeleteStart: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteStart` instead."
        },
        onRangeDeleteEnd: {
            version: "32.2",
            message: "Use `onCellSelectionDeleteEnd` instead."
        },
        suppressBrowserResizeObserver: {
            version: "32.2",
            message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
        },
        onColumnEverythingChanged: {
            version: "32.2",
            message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
        },
        groupRemoveSingleChildren: {
            version: "33",
            message: "Use `groupHideParentOfSingleChild` instead."
        },
        groupRemoveLowestSingleChildren: {
            version: "33",
            message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
        },
        suppressRowGroupHidesColumns: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
        },
        suppressMakeColumnVisibleAfterUnGroup: {
            version: "33",
            message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
        },
        unSortIcon: {
            version: "33",
            message: "Use `defaultColDef.unSortIcon` instead."
        },
        sortingOrder: {
            version: "33",
            message: "Use `defaultColDef.sortingOrder` instead."
        },
        suppressPropertyNamesCheck: {
            version: "33",
            message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
        }
    });
function $437b23f6a393c3bf$var$toConstrainedNum(key, value, min) {
    if (typeof value === "number" || value == null) {
        if (value == null) return null;
        return value >= min ? null : `${key}: value should be greater than or equal to ${min}`;
    }
    return `${key}: value should be a number`;
}
var $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES = {
    alignedGrids: "AlignedGrids",
    allowContextMenuWithControlKey: "ContextMenu",
    autoSizeStrategy: "ColumnAutoSize",
    cellSelection: "CellSelection",
    columnHoverHighlight: "ColumnHover",
    datasource: "InfiniteRowModel",
    doesExternalFilterPass: "ExternalFilter",
    editType: "EditCore",
    enableAdvancedFilter: "AdvancedFilter",
    enableCellSpan: "CellSpan",
    enableCharts: "IntegratedCharts",
    enableRangeSelection: "CellSelection",
    enableRowPinning: "PinnedRow",
    findSearchValue: "Find",
    getContextMenuItems: "ContextMenu",
    getLocaleText: "Locale",
    getMainMenuItems: "ColumnMenu",
    getRowClass: "RowStyle",
    getRowStyle: "RowStyle",
    groupTotalRow: "SharedRowGrouping",
    grandTotalRow: "SharedRowGrouping",
    initialState: "GridState",
    isExternalFilterPresent: "ExternalFilter",
    isRowPinnable: "PinnedRow",
    localeText: "Locale",
    masterDetail: "SharedMasterDetail",
    pagination: "Pagination",
    pinnedBottomRowData: "PinnedRow",
    pinnedTopRowData: "PinnedRow",
    pivotMode: "SharedPivot",
    pivotPanelShow: "RowGroupingPanel",
    quickFilterText: "QuickFilter",
    rowClass: "RowStyle",
    rowClassRules: "RowStyle",
    rowData: "ClientSideRowModel",
    rowDragManaged: "RowDrag",
    rowGroupPanelShow: "RowGroupingPanel",
    rowNumbers: "RowNumbers",
    rowSelection: "SharedRowSelection",
    rowStyle: "RowStyle",
    serverSideDatasource: "ServerSideRowModel",
    sideBar: "SideBar",
    statusBar: "StatusBar",
    treeData: "SharedTreeData",
    undoRedoCellEditing: "UndoRedoEdit",
    valueCache: "ValueCache",
    viewportDatasource: "ViewportRowModel"
};
var $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS = ()=>{
    const definedValidations = {
        autoSizePadding: {
            validate ({ autoSizePadding: autoSizePadding }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("autoSizePadding", autoSizePadding, 0);
            }
        },
        cacheBlockSize: {
            supportedRowModels: [
                "serverSide",
                "infinite"
            ],
            validate ({ cacheBlockSize: cacheBlockSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheBlockSize", cacheBlockSize, 1);
            }
        },
        cacheOverflowSize: {
            validate ({ cacheOverflowSize: cacheOverflowSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("cacheOverflowSize", cacheOverflowSize, 1);
            }
        },
        datasource: {
            supportedRowModels: [
                "infinite"
            ]
        },
        domLayout: {
            validate: (options)=>{
                const domLayout = options.domLayout;
                const validLayouts = [
                    "autoHeight",
                    "normal",
                    "print"
                ];
                if (domLayout && !validLayouts.includes(domLayout)) return `domLayout must be one of [${validLayouts.join()}], currently it's ${domLayout}`;
                return null;
            }
        },
        enableFillHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeHandle: {
            dependencies: {
                enableRangeSelection: {
                    required: [
                        true
                    ]
                }
            }
        },
        enableRangeSelection: {
            dependencies: {
                rowDragEntireRow: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        enableRowPinning: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ enableRowPinning: enableRowPinning, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (enableRowPinning && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either set `enableRowPinning` to `false`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        isRowPinnable: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ isRowPinnable: isRowPinnable, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinnable && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinnable`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        isRowPinned: {
            supportedRowModels: [
                "clientSide"
            ],
            validate ({ isRowPinned: isRowPinned, pinnedTopRowData: pinnedTopRowData, pinnedBottomRowData: pinnedBottomRowData }) {
                if (isRowPinned && (pinnedTopRowData || pinnedBottomRowData)) return "Manual row pinning cannot be used together with pinned row data. Either remove `isRowPinned`, or remove `pinnedTopRowData` and `pinnedBottomRowData`.";
                return null;
            }
        },
        groupDefaultExpanded: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        groupHideOpenParents: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            dependencies: {
                groupTotalRow: {
                    required: [
                        void 0,
                        "bottom"
                    ]
                },
                treeData: {
                    required: [
                        void 0,
                        false
                    ],
                    reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
                }
            }
        },
        groupHideParentOfSingleChild: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveLowestSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupRemoveSingleChildren: {
            dependencies: {
                groupHideOpenParents: {
                    required: [
                        void 0,
                        false
                    ]
                },
                groupRemoveLowestSingleChildren: {
                    required: [
                        void 0,
                        false
                    ]
                }
            }
        },
        groupSelectsChildren: {
            dependencies: {
                rowSelection: {
                    required: [
                        "multiple"
                    ]
                }
            }
        },
        icons: {
            validate: ({ icons: icons })=>{
                if (icons) {
                    if (icons["smallDown"]) return $437b23f6a393c3bf$export$680bb5102fca525e(262);
                    if (icons["smallLeft"]) return $437b23f6a393c3bf$export$680bb5102fca525e(263);
                    if (icons["smallRight"]) return $437b23f6a393c3bf$export$680bb5102fca525e(264);
                }
                return null;
            }
        },
        infiniteInitialRowCount: {
            validate ({ infiniteInitialRowCount: infiniteInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("infiniteInitialRowCount", infiniteInitialRowCount, 1);
            }
        },
        initialGroupOrderComparator: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        keepDetailRowsCount: {
            validate ({ keepDetailRowsCount: keepDetailRowsCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("keepDetailRowsCount", keepDetailRowsCount, 1);
            }
        },
        paginationPageSize: {
            validate ({ paginationPageSize: paginationPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("paginationPageSize", paginationPageSize, 1);
            }
        },
        paginationPageSizeSelector: {
            validate: (options)=>{
                const values = options.paginationPageSizeSelector;
                if (typeof values === "boolean" || values == null) return null;
                if (!values.length) return `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
                return null;
            }
        },
        pivotMode: {
            dependencies: {
                treeData: {
                    required: [
                        false,
                        void 0
                    ],
                    reason: "Pivot Mode is not supported with Tree Data."
                }
            }
        },
        quickFilterText: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowBuffer: {
            validate ({ rowBuffer: rowBuffer }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("rowBuffer", rowBuffer, 0);
            }
        },
        rowClass: {
            validate: (options)=>{
                const rowClass = options.rowClass;
                if (typeof rowClass === "function") return "rowClass should not be a function, please use getRowClass instead";
                return null;
            }
        },
        rowData: {
            supportedRowModels: [
                "clientSide"
            ]
        },
        rowDragManaged: {
            supportedRowModels: [
                "clientSide"
            ],
            dependencies: {
                treeData: {
                    required: [
                        false,
                        void 0
                    ]
                },
                pagination: {
                    required: [
                        false,
                        void 0
                    ]
                }
            }
        },
        rowSelection: {
            validate ({ rowSelection: rowSelection }) {
                if (rowSelection && typeof rowSelection === "string") return 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.';
                if (rowSelection && typeof rowSelection !== "object") return "Expected `RowSelectionOptions` object for the `rowSelection` property.";
                if (rowSelection && rowSelection.mode !== "multiRow" && rowSelection.mode !== "singleRow") return `Selection mode "${rowSelection.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.`;
                return null;
            }
        },
        rowStyle: {
            validate: (options)=>{
                const rowStyle = options.rowStyle;
                if (rowStyle && typeof rowStyle === "function") return "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead";
                return null;
            }
        },
        serverSideDatasource: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideInitialRowCount: {
            supportedRowModels: [
                "serverSide"
            ],
            validate ({ serverSideInitialRowCount: serverSideInitialRowCount }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("serverSideInitialRowCount", serverSideInitialRowCount, 1);
            }
        },
        serverSideOnlyRefreshFilteredGroups: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        serverSideSortAllLevels: {
            supportedRowModels: [
                "serverSide"
            ]
        },
        sortingOrder: {
            validate: (_options)=>{
                const sortingOrder = _options.sortingOrder;
                if (Array.isArray(sortingOrder) && sortingOrder.length > 0) {
                    const invalidItems = sortingOrder.filter((a)=>!$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.includes(a));
                    if (invalidItems.length > 0) return `sortingOrder must be an array with elements from [${$437b23f6a393c3bf$var$DEFAULT_SORTING_ORDER.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}], currently it includes [${invalidItems.map($437b23f6a393c3bf$var$toStringWithNullUndefined).join()}]`;
                } else if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) return `sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`;
                return null;
            }
        },
        tooltipHideDelay: {
            validate: (options)=>{
                if (options.tooltipHideDelay && options.tooltipHideDelay < 0) return "tooltipHideDelay should not be lower than 0";
                return null;
            }
        },
        tooltipShowDelay: {
            validate: (options)=>{
                if (options.tooltipShowDelay && options.tooltipShowDelay < 0) return "tooltipShowDelay should not be lower than 0";
                return null;
            }
        },
        treeData: {
            supportedRowModels: [
                "clientSide",
                "serverSide"
            ],
            validate: (options)=>{
                const rowModel = options.rowModelType ?? "clientSide";
                switch(rowModel){
                    case "clientSide":
                        {
                            const { treeDataChildrenField: treeDataChildrenField, treeDataParentIdField: treeDataParentIdField, getDataPath: getDataPath, getRowId: getRowId } = options;
                            if (!treeDataChildrenField && !treeDataParentIdField && !getDataPath) return "treeData requires either 'treeDataChildrenField' or 'treeDataParentIdField' or 'getDataPath' in the clientSide row model.";
                            if (treeDataChildrenField) {
                                if (getDataPath) return "Cannot use both 'treeDataChildrenField' and 'getDataPath' at the same time.";
                                if (treeDataParentIdField) return "Cannot use both 'treeDataChildrenField' and 'treeDataParentIdField' at the same time.";
                            }
                            if (treeDataParentIdField) {
                                if (!getRowId) return "getRowId callback not provided, tree data with parent id cannot be built.";
                                if (getDataPath) return "Cannot use both 'treeDataParentIdField' and 'getDataPath' at the same time.";
                            }
                            return null;
                        }
                    case "serverSide":
                        {
                            const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                            return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
                        }
                }
                return null;
            }
        },
        viewportDatasource: {
            supportedRowModels: [
                "viewport"
            ]
        },
        viewportRowModelBufferSize: {
            validate ({ viewportRowModelBufferSize: viewportRowModelBufferSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelBufferSize", viewportRowModelBufferSize, 0);
            }
        },
        viewportRowModelPageSize: {
            validate ({ viewportRowModelPageSize: viewportRowModelPageSize }) {
                return $437b23f6a393c3bf$var$toConstrainedNum("viewportRowModelPageSize", viewportRowModelPageSize, 1);
            }
        },
        rowDragEntireRow: {
            dependencies: {
                cellSelection: {
                    required: [
                        void 0
                    ]
                }
            }
        },
        autoGroupColumnDef: {
            validate ({ autoGroupColumnDef: autoGroupColumnDef, showOpenedGroup: showOpenedGroup }) {
                if (autoGroupColumnDef?.field && showOpenedGroup) return "autoGroupColumnDef.field and showOpenedGroup are not supported when used together.";
                if (autoGroupColumnDef?.valueGetter && showOpenedGroup) return "autoGroupColumnDef.valueGetter and showOpenedGroup are not supported when used together.";
                return null;
            }
        }
    };
    const validations = {};
    $437b23f6a393c3bf$var$_BOOLEAN_GRID_OPTIONS.forEach((key)=>{
        validations[key] = {
            expectedType: "boolean"
        };
    });
    $437b23f6a393c3bf$var$_NUMBER_GRID_OPTIONS.forEach((key)=>{
        validations[key] = {
            expectedType: "number"
        };
    });
    $437b23f6a393c3bf$export$8ade6bd474fcde42(validations, definedValidations);
    return validations;
};
var $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS = ()=>({
        objectName: "gridOptions",
        allProperties: [
            ...$437b23f6a393c3bf$export$a827a39ae0574df3(),
            ...$437b23f6a393c3bf$export$a4bee1102f884a4d().map((event)=>$437b23f6a393c3bf$export$2badf35af69344c1(event))
        ],
        propertyExceptions: [
            "api"
        ],
        docsUrl: "grid-options/",
        deprecations: $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS(),
        validations: $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS()
    });
// packages/ag-grid-community/src/gridOptionsService.ts
var $437b23f6a393c3bf$var$changeSetId = 0;
var $437b23f6a393c3bf$var$gridInstanceSequence = 0;
var $437b23f6a393c3bf$var$GridOptionsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gos";
        this.domDataKey = "__AG_" + Math.random().toString();
        /** This is only used for the main DOM element */ this.gridInstanceId = $437b23f6a393c3bf$var$gridInstanceSequence++;
        // Used to hold user events until the grid is ready
        // Required to support React 19 StrictMode. See IFrameworkOverrides.runWhenReadyAsync but also is likely a good idea that onGridReady is the first event fired.
        this.gridReadyFired = false;
        this.queueEvents = [];
        this.propEventSvc = new $437b23f6a393c3bf$export$820da7696a401cdc();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (!this.isAlive()) return;
                const alwaysSync = $437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                const fireEvent = (name, e)=>{
                    const eventHandler = this.gridOptions[$437b23f6a393c3bf$export$2badf35af69344c1(name)];
                    if (typeof eventHandler === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>eventHandler(e));
                };
                if (this.gridReadyFired) fireEvent(eventName, event);
                else if (eventName === "gridReady") {
                    fireEvent(eventName, event);
                    this.gridReadyFired = true;
                    for (const q of this.queueEvents)fireEvent(q.eventName, q.event);
                    this.queueEvents = [];
                } else this.queueEvents.push({
                    eventName: eventName,
                    event: event
                });
            };
        };
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        this.validation = beans.validation;
        this.api = beans.gridApi;
        this.gridId = beans.context.getGridId();
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get gridOptionsContext() {
        return this.gridOptions["context"];
    }
    postConstruct() {
        this.validateGridOptions(this.gridOptions);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), true);
        this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides);
        this.addManagedEventListeners({
            gridOptionsChanged: ({ options: options })=>{
                this.updateGridOptions({
                    options: options,
                    force: true,
                    source: "gridOptionsUpdated"
                });
            }
        });
    }
    destroy() {
        super.destroy();
        this.queueEvents = [];
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        return this.gridOptions[property] ?? $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(this.gridOptions[property]);
    }
    /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                return callback(this.addGridCommonParams(callbackParams));
            };
            return wrapped;
        }
        return callback;
    }
    updateGridOptions({ options: options, force: force, source: source = "api" }) {
        const changeSet = {
            id: $437b23f6a393c3bf$var$changeSetId++,
            properties: []
        };
        const events = [];
        const { gridOptions: gridOptions, validation: validation2 } = this;
        for (const key of Object.keys(options)){
            const value = options[key];
            validation2?.warnOnInitialPropertyUpdate(source, key);
            const shouldForce = force || typeof value === "object" && source === "api";
            const previousValue = gridOptions[key];
            if (shouldForce || previousValue !== value) {
                gridOptions[key] = value;
                const event = {
                    type: key,
                    currentValue: value,
                    previousValue: previousValue,
                    changeSet: changeSet,
                    source: source
                };
                events.push(event);
            }
        }
        this.validateGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        events.forEach((event)=>{
            $437b23f6a393c3bf$var$_logIfDebug(this, `Updated property ${event.type} from`, event.previousValue, ` to `, event.currentValue);
            this.propEventSvc.dispatchEvent(event);
        });
    }
    addPropertyEventListener(key, listener) {
        this.propEventSvc.addEventListener(key, listener);
    }
    removePropertyEventListener(key, listener) {
        this.propEventSvc.removeEventListener(key, listener);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    /** Prefer _addGridCommonParams from gridOptionsUtils for bundle size savings */ addGridCommonParams(params) {
        params.api = this.api;
        params.context = this.gridOptionsContext;
        return params;
    }
    validateOptions(options, modValidations) {
        for (const key of Object.keys(options)){
            const value = options[key];
            if (value == null || value === false) continue;
            let moduleToCheck = modValidations[key];
            if (typeof moduleToCheck === "function") moduleToCheck = moduleToCheck(options, this.gridOptions, this.beans);
            if (moduleToCheck) this.assertModuleRegistered(moduleToCheck, key);
        }
    }
    validateGridOptions(gridOptions) {
        this.validateOptions(gridOptions, $437b23f6a393c3bf$var$GRID_OPTIONS_MODULES);
        this.validation?.processGridOptions(gridOptions);
    }
    validateColDef(colDef, colId, skipInferenceCheck) {
        if (skipInferenceCheck || !this.beans.dataTypeSvc?.isColPendingInference(colId)) {
            this.validateOptions(colDef, $437b23f6a393c3bf$var$COLUMN_DEFINITION_MOD_VALIDATIONS);
            this.validation?.validateColDef(colDef);
        }
    }
    assertModuleRegistered(moduleName, reasonOrId) {
        const registered = Array.isArray(moduleName) ? moduleName.some((modName)=>this.isModuleRegistered(modName)) : this.isModuleRegistered(moduleName);
        if (!registered) $437b23f6a393c3bf$export$a20c7248650823a9(200, {
            ...this.getModuleErrorParams(),
            moduleName: moduleName,
            reasonOrId: reasonOrId
        });
        return registered;
    }
    getModuleErrorParams() {
        return {
            gridId: this.gridId,
            gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
            rowModelType: this.get("rowModelType"),
            isUmd: $437b23f6a393c3bf$var$_isUmd()
        };
    }
    isModuleRegistered(moduleName) {
        return $437b23f6a393c3bf$var$_isModuleRegistered(moduleName, this.gridId, this.get("rowModelType"));
    }
};
// packages/ag-grid-community/src/headerRendering/cells/column/headerComp.ts
function $437b23f6a393c3bf$var$getHeaderCompElementParams(includeSortIndicator) {
    const hiddenAttrs = {
        "aria-hidden": "true"
    };
    return {
        tag: "div",
        cls: "ag-cell-label-container",
        role: "presentation",
        children: [
            {
                tag: "span",
                ref: "eMenu",
                cls: "ag-header-icon ag-header-cell-menu-button",
                attrs: hiddenAttrs
            },
            {
                tag: "span",
                ref: "eFilterButton",
                cls: "ag-header-icon ag-header-cell-filter-button",
                attrs: hiddenAttrs
            },
            {
                tag: "div",
                ref: "eLabel",
                cls: "ag-header-cell-label",
                role: "presentation",
                children: [
                    {
                        tag: "span",
                        ref: "eText",
                        cls: "ag-header-cell-text"
                    },
                    {
                        tag: "span",
                        ref: "eFilter",
                        cls: "ag-header-icon ag-header-label-icon ag-filter-icon",
                        attrs: hiddenAttrs
                    },
                    includeSortIndicator ? {
                        tag: "ag-sort-indicator",
                        ref: "eSortIndicator"
                    } : null
                ]
            }
        ]
    };
}
var $437b23f6a393c3bf$var$HeaderCompElement = $437b23f6a393c3bf$var$getHeaderCompElementParams(true);
var $437b23f6a393c3bf$var$HeaderCompElementNoSort = $437b23f6a393c3bf$var$getHeaderCompElementParams(false);
var $437b23f6a393c3bf$export$266cd3930df0b35d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        // All the elements are optional, as they are not guaranteed to be present if the user provides a custom template
        this.eFilter = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eFilterButton = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortIndicator = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eMenu = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eText = $437b23f6a393c3bf$export$6c811454646ed8be;
        /**
     * Selectors for custom headers templates, i.e when the ag-sort-indicator is not present.
     */ this.eSortOrder = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortAsc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortDesc = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortMixed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eSortNone = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate(params, !!this.beans?.sortSvc) != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || params.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        if (this.innerHeaderComponent) {
            const mergedParams = {
                ...params
            };
            $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedParams, params.innerHeaderComponentParams);
            this.innerHeaderComponent.refresh?.(mergedParams);
        } else this.setDisplayName(params);
        return true;
    }
    workOutTemplate(params, isSorting) {
        const paramsTemplate = params.template;
        if (paramsTemplate) return paramsTemplate?.trim ? paramsTemplate.trim() : paramsTemplate;
        else return isSorting ? $437b23f6a393c3bf$var$HeaderCompElement : $437b23f6a393c3bf$var$HeaderCompElementNoSort;
    }
    init(params) {
        this.params = params;
        const { sortSvc: sortSvc, touchSvc: touchSvc, rowNumbersSvc: rowNumbersSvc, userCompFactory: userCompFactory } = this.beans;
        const sortComp = sortSvc?.getSortIndicatorSelector();
        this.currentTemplate = this.workOutTemplate(params, !!sortComp);
        this.setTemplate(this.currentTemplate, sortComp ? [
            sortComp
        ] : void 0);
        touchSvc?.setupForHeader(this);
        this.setMenu();
        this.setupSort();
        rowNumbersSvc?.setupForHeader(this);
        this.setupFilterIcon();
        this.setupFilterButton();
        this.workOutInnerHeaderComponent(userCompFactory, params);
        this.setDisplayName(params);
    }
    workOutInnerHeaderComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderComponent = comp;
                if (this.eText) this.eText.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setDisplayName(params) {
        const { displayName: displayName } = params;
        const oldDisplayName = this.currentDisplayName;
        this.currentDisplayName = displayName;
        if (!this.eText || oldDisplayName === displayName || this.innerHeaderComponent || this.isLoadingInnerComponent) return;
        this.eText.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
    }
    addInIcon(iconName, eParent, column) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    workOutShowMenu() {
        return this.params.enableMenu && !!this.beans.menuSvc?.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return !!this.beans.menuSvc?.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const { gos: gos, eMenu: eMenu, params: params } = this;
        const isLegacyMenu = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", eMenu, params.column);
        eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        const currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.currentSuppressMenuHide = currentSuppressMenuHide;
        this.addManagedElementListeners(eMenu, {
            click: ()=>this.showColumnMenu(this.eMenu)
        });
        this.toggleMenuAlwaysShow(currentSuppressMenuHide);
    }
    toggleMenuAlwaysShow(alwaysShow) {
        this.eMenu?.classList.toggle("ag-header-menu-always-show", alwaysShow);
    }
    showColumnMenu(element) {
        const { currentSuppressMenuHide: currentSuppressMenuHide, params: params } = this;
        if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(true);
        params.showColumnMenu(element, ()=>{
            if (!currentSuppressMenuHide) this.toggleMenuAlwaysShow(false);
        });
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        const { params: params, gos: gos, beans: beans, eMenu: eMenu, eFilterButton: eFilterButton } = this;
        const column = params.column;
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(gos);
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (beans.menuSvc?.isFilterMenuInHeaderEnabled(column)) {
                params.showFilter(eFilterButton ?? eMenu ?? this.getGui());
                return true;
            }
        } else if (params.enableMenu) {
            this.showColumnMenu(eMenu ?? eFilterButton ?? this.getGui());
            return true;
        }
        return false;
    }
    setupSort() {
        const { sortSvc: sortSvc } = this.beans;
        if (!sortSvc) return;
        const { enableSorting: enableSorting, column: column } = this.params;
        this.currentSort = enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.createBean(sortSvc.createSortIndicator(true));
            const { eSortIndicator: eSortIndicator, eSortOrder: eSortOrder, eSortAsc: eSortAsc, eSortDesc: eSortDesc, eSortMixed: eSortMixed, eSortNone: eSortNone } = this;
            eSortIndicator.attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone);
        }
        this.eSortIndicator.setupSort(column);
        if (!this.currentSort) return;
        sortSvc.setupHeader(this, column, this.eLabel);
    }
    setupFilterIcon() {
        const { eFilter: eFilter, params: params } = this;
        if (!eFilter) return;
        const onFilterChangedIcon = ()=>{
            const filterPresent = params.column.isFilterActive();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(eFilter, filterPresent, {
                skipAriaHidden: true
            });
        };
        this.configureFilter(params.enableFilterIcon, eFilter, onFilterChangedIcon, "filterActive");
    }
    setupFilterButton() {
        const { eFilterButton: eFilterButton, params: params } = this;
        if (!eFilterButton) return;
        const configured = this.configureFilter(params.enableFilterButton, eFilterButton, this.onFilterChangedButton.bind(this), "filter");
        if (configured) this.addManagedElementListeners(eFilterButton, {
            click: ()=>params.showFilter(eFilterButton)
        });
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback, icon) {
        if (!enabled) {
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(element);
            return false;
        }
        const column = this.params.column;
        this.addInIcon(icon, element, column);
        this.addManagedListeners(column, {
            filterChanged: filterChangedCallback
        });
        filterChangedCallback();
        return true;
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        const { eFilterButton: eFilterButton, eMenu: eMenu } = this;
        if (isFilter) return eFilterButton ?? eMenu ?? this.getGui();
        return eMenu ?? eFilterButton ?? this.getGui();
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderComponent) {
            this.destroyBean(this.innerHeaderComponent);
            this.innerHeaderComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var $437b23f6a393c3bf$var$HeaderGroupCompElement = {
    tag: "div",
    cls: "ag-header-group-cell-label",
    role: "presentation",
    children: [
        {
            tag: "span",
            ref: "agLabel",
            cls: "ag-header-group-text",
            role: "presentation"
        },
        {
            tag: "span",
            ref: "agOpened",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded`
        },
        {
            tag: "span",
            ref: "agClosed",
            cls: `ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed`
        }
    ]
};
var $437b23f6a393c3bf$var$HeaderGroupComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$HeaderGroupCompElement);
        this.agOpened = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agClosed = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.agLabel = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isLoadingInnerComponent = false;
    }
    init(params) {
        const { userCompFactory: userCompFactory, touchSvc: touchSvc } = this.beans;
        this.params = params;
        this.checkWarnings();
        this.workOutInnerHeaderGroupComponent(userCompFactory, params);
        this.setupLabel(params);
        this.addGroupExpandIcon(params);
        this.setupExpandIcons();
        touchSvc?.setupForHeaderGroup(this);
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) $437b23f6a393c3bf$export$545083624300f13d(89);
    }
    workOutInnerHeaderGroupComponent(userCompFactory, params) {
        const userCompDetails = $437b23f6a393c3bf$var$_getInnerHeaderGroupCompDetails(userCompFactory, params, params);
        if (!userCompDetails) return;
        this.isLoadingInnerComponent = true;
        userCompDetails.newAgStackInstance().then((comp)=>{
            this.isLoadingInnerComponent = false;
            if (!comp) return;
            if (this.isAlive()) {
                this.innerHeaderGroupComponent = comp;
                this.agLabel.appendChild(comp.getGui());
            } else this.destroyBean(comp);
        });
    }
    setupExpandIcons() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup }, beans: beans } = this;
        this.addInIcon("columnGroupOpened", agOpened);
        this.addInIcon("columnGroupClosed", agClosed);
        const expandAction = (event)=>{
            if ($437b23f6a393c3bf$export$9a48e23524c6d58(event)) return;
            const newExpandedValue = !columnGroup.isExpanded();
            beans.colGroupSvc.setColumnGroupOpened(columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(beans, agClosed, expandAction);
        this.addTouchAndClickListeners(beans, agOpened, expandAction);
        const stopPropagationAction = (event)=>{
            $437b23f6a393c3bf$export$456c40e80134d72a(event);
        };
        this.addManagedElementListeners(agClosed, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(agOpened, {
            dblclick: stopPropagationAction
        });
        this.addManagedElementListeners(this.getGui(), {
            dblclick: expandAction
        });
        this.updateIconVisibility();
        const providedColumnGroup = columnGroup.getProvidedColumnGroup();
        const updateIcon = this.updateIconVisibility.bind(this);
        this.addManagedListeners(providedColumnGroup, {
            expandedChanged: updateIcon,
            expandableChanged: updateIcon
        });
    }
    addTouchAndClickListeners(beans, eElement, action) {
        beans.touchSvc?.setupForHeaderGroupElement(this, eElement, action);
        this.addManagedElementListeners(eElement, {
            click: action
        });
    }
    updateIconVisibility() {
        const { agOpened: agOpened, agClosed: agClosed, params: { columnGroup: columnGroup } } = this;
        if (columnGroup.isExpandable()) {
            const expanded = columnGroup.isExpanded();
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, expanded);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, !expanded);
        } else {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
        }
    }
    addInIcon(iconName, element) {
        const eIcon = $437b23f6a393c3bf$export$d8feba07bf373edb(iconName, this.beans, null);
        if (eIcon) element.appendChild(eIcon);
    }
    addGroupExpandIcon(params) {
        if (!params.columnGroup.isExpandable()) {
            const { agOpened: agOpened, agClosed: agClosed } = this;
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agOpened, false);
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(agClosed, false);
            return;
        }
    }
    setupLabel(params) {
        const { displayName: displayName, columnGroup: columnGroup } = params;
        const hasInnerComponent = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(displayName) && !hasInnerComponent) this.agLabel.textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(displayName);
        this.toggleCss("ag-sticky-label", !columnGroup.getColGroupDef()?.suppressStickyLabel);
    }
    destroy() {
        super.destroy();
        if (this.innerHeaderGroupComponent) {
            this.destroyBean(this.innerHeaderGroupComponent);
            this.innerHeaderGroupComponent = void 0;
        }
    }
};
// packages/ag-grid-community/src/headerRendering/cells/headerModule.ts
var $437b23f6a393c3bf$var$ColumnHeaderCompModule = {
    moduleName: "ColumnHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnHeader: $437b23f6a393c3bf$export$266cd3930df0b35d
    },
    icons: {
        // button to launch legacy column menu
        menu: "menu",
        // button to launch new enterprise column menu
        menuAlt: "menu-alt"
    }
};
var $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule = {
    moduleName: "ColumnGroupHeaderComp",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agColumnGroupHeader: $437b23f6a393c3bf$var$HeaderGroupComp
    },
    icons: {
        // header column group shown when expanded (click to contract)
        columnGroupOpened: "expanded",
        // header column group shown when contracted (click to expand)
        columnGroupClosed: "contracted"
    }
};
// packages/ag-grid-community/src/misc/animationFrameService.ts
var $437b23f6a393c3bf$var$AnimationFrameService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "animationFrameSvc";
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.p1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.p2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        this.f1 = {
            list: [],
            sorted: false
        };
        // eg framework cell renderers
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastScrollTop = 0;
        this.taskCount = 0;
    }
    setScrollTop(scrollTop) {
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (scrollTop === 0) this.scrollGoingDown = true;
        this.lastScrollTop = scrollTop;
    }
    postConstruct() {
        this.active = !this.gos.get("suppressAnimationFrame");
        this.batchFrameworkComps = this.beans.frameworkOverrides.batchFrameworkComps;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verify() {
        if (this.active === false) $437b23f6a393c3bf$export$545083624300f13d(92);
    }
    createTask(task, index, list, isFramework) {
        this.verify();
        let taskList = list;
        if (isFramework && this.batchFrameworkComps) taskList = "f1";
        const taskItem = {
            task: task,
            index: index,
            createOrder: ++this.taskCount
        };
        this.addTaskToList(this[taskList], taskItem);
        this.schedule();
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder);
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verify();
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        const { p1: p1, p2: p2, f1: f1, destroyTasks: destroyTasks, beans: beans } = this;
        const { ctrlsSvc: ctrlsSvc, frameworkOverrides: frameworkOverrides } = beans;
        const p1Tasks = p1.list;
        const p2Tasks = p2.list;
        const f1Tasks = f1.list;
        const frameStart = Date.now();
        let duration = 0;
        const noMaxMillis = millis <= 0;
        const scrollFeature = ctrlsSvc.getScrollFeature();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = scrollFeature.scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2);
                    task = p2Tasks.pop().task;
                } else if (f1Tasks.length) {
                    frameworkOverrides.wrapOutgoing(()=>{
                        while(noMaxMillis || duration < millis){
                            const gridBodyDidSomething2 = scrollFeature.scrollGridIfNeeded();
                            if (!gridBodyDidSomething2) {
                                if (f1Tasks.length) {
                                    this.sortTaskList(f1);
                                    task = f1Tasks.pop().task;
                                    task();
                                } else break;
                            } else break;
                            duration = Date.now() - frameStart;
                        }
                    });
                    task = ()=>{};
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else break;
                task();
            }
            duration = Date.now() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || f1Tasks.length || destroyTasks.length) this.requestFrame();
        else this.ticking = false;
    }
    flushAllFrames() {
        if (!this.active) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.active) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, callback);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
};
// packages/ag-grid-community/src/misc/animationFrameModule.ts
var $437b23f6a393c3bf$var$AnimationFrameModule = {
    moduleName: "AnimationFrame",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AnimationFrameService
    ]
};
// packages/ag-grid-community/src/misc/touchService.ts
var $437b23f6a393c3bf$var$TouchService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "touchSvc";
    }
    mockBodyContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eBodyViewport, listener);
    }
    mockHeaderContextMenu(ctrl, listener) {
        this.mockContextMenu(ctrl, ctrl.eGui, listener);
    }
    mockRowContextMenu(ctrl) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const listener = (mouseListener, touch, touchEvent)=>{
            const { rowCtrl: rowCtrl, cellCtrl: cellCtrl } = ctrl.getControlsForEventTarget(touchEvent?.target ?? null);
            if (cellCtrl?.column) cellCtrl.dispatchCellContextMenuEvent(touchEvent ?? null);
            this.beans.contextMenuSvc?.handleContextMenuMouseEvent(void 0, touchEvent, rowCtrl, cellCtrl);
        };
        this.mockContextMenu(ctrl, ctrl.element, listener);
    }
    handleCellDoubleClick(ctrl, mouseEvent) {
        const isDoubleClickOnIPad = ()=>{
            if (!$437b23f6a393c3bf$export$6b6034a68325bd8a() || $437b23f6a393c3bf$var$_isEventSupported("dblclick")) return false;
            const nowMillis = Date.now();
            const res = nowMillis - ctrl.lastIPadMouseClickEvent < 200;
            ctrl.lastIPadMouseClickEvent = nowMillis;
            return res;
        };
        if (isDoubleClickOnIPad()) {
            ctrl.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return true;
        }
        return false;
    }
    setupForHeader(comp) {
        const { gos: gos, sortSvc: sortSvc, menuSvc: menuSvc } = this.beans;
        if (gos.get("suppressTouch")) return;
        const { params: params, eMenu: eMenu, eFilterButton: eFilterButton } = comp;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(comp.getGui(), true);
        const suppressMenuHide = comp.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && $437b23f6a393c3bf$export$25d27f17d3af40f7(eMenu) && params.enableMenu;
        const menuTouchListener = tapMenuButton ? new $437b23f6a393c3bf$export$7b2e93987414b382(eMenu, true) : touchListener;
        if (params.enableMenu || menuSvc?.isHeaderContextMenuEnabled(params.column)) {
            const eventType = tapMenuButton ? "tap" : "longTap";
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(menuTouchListener, {
                [eventType]: showMenuFn
            });
        }
        if (params.enableSorting) {
            const tapListener = (event)=>{
                const target = event.touchStart.target;
                if (suppressMenuHide && (eMenu?.contains(target) || eFilterButton?.contains(target))) return;
                sortSvc?.progressSort(params.column, false, "uiColumnSorted");
            };
            comp.addManagedListeners(touchListener, {
                tap: tapListener
            });
        }
        if (params.enableFilterButton && eFilterButton) {
            const filterButtonTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eFilterButton, true);
            comp.addManagedListeners(filterButtonTouchListener, {
                tap: ()=>params.showFilter(eFilterButton)
            });
            comp.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
        comp.addDestroyFunc(()=>touchListener.destroy());
        if (tapMenuButton) comp.addDestroyFunc(()=>menuTouchListener.destroy());
    }
    setupForHeaderGroup(comp) {
        const params = comp.params;
        if (this.beans.menuSvc?.isHeaderContextMenuEnabled(params.columnGroup.getProvidedColumnGroup())) {
            const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(params.eGridHeader, true);
            const showMenuFn = (event)=>params.showColumnMenuAfterMouseClick(event.touchStart);
            comp.addManagedListeners(touchListener, {
                longTap: showMenuFn
            });
            comp.addDestroyFunc(()=>touchListener.destroy());
        }
    }
    setupForHeaderGroupElement(comp, eElement, action) {
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eElement, true);
        comp.addManagedListeners(touchListener, {
            tap: action
        });
        comp.addDestroyFunc(()=>touchListener.destroy());
    }
    mockContextMenu(ctrl, element, listener) {
        if (!$437b23f6a393c3bf$export$6b6034a68325bd8a()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        const longTapListener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isEventFromThisGrid(this.gos, event.touchEvent)) return;
            listener(void 0, event.touchStart, event.touchEvent);
        };
        ctrl.addManagedListeners(touchListener, {
            longTap: longTapListener
        });
        ctrl.addDestroyFunc(()=>touchListener.destroy());
    }
};
// packages/ag-grid-community/src/misc/touchModule.ts
var $437b23f6a393c3bf$var$TouchModule = {
    moduleName: "Touch",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TouchService
    ]
};
// packages/ag-grid-community/src/navigation/cellNavigationService.ts
var $437b23f6a393c3bf$var$CellNavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellNavigation";
    }
    wireBeans(beans) {
        this.rowSpanSvc = beans.rowSpanSvc;
    }
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        const downKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        const leftKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        let column;
        let rowIndex;
        const { pageBounds: pageBounds, gos: gos, visibleCols: visibleCols } = this.beans;
        if (upKey || downKey) {
            rowIndex = upKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
            column = focusedCell.column;
        } else {
            const isRtl = gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            const allColumns = leftKey !== isRtl ? visibleCols.allCols : [
                ...visibleCols.allCols
            ].reverse();
            column = allColumns.find((col)=>this.isCellGoodToFocusOn({
                    rowIndex: rowIndex,
                    rowPinned: null,
                    column: col
                }));
        }
        return column ? {
            rowIndex: rowIndex,
            rowPinned: null,
            column: column
        } : null;
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToLeft(pointer) : this.getCellToRight(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    pointer = this.gos.get("enableRtl") ? this.getCellToRight(pointer) : this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    $437b23f6a393c3bf$export$545083624300f13d(8, {
                        key: key
                    });
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = pinnedRowModel?.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = pinnedRowModel?.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = this.isSuppressNavigable(column, rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.beans.visibleCols.getColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.beans.visibleCols.getColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellEnd(lastCell) ?? lastCell;
        const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, adjustedLastCell);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const adjustedLastCell = this.rowSpanSvc?.getCellStart(lastCell) ?? lastCell;
        const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
            rowIndex: adjustedLastCell.rowIndex,
            rowPinned: adjustedLastCell.rowPinned
        });
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const { visibleCols: visibleCols, pagination: pagination } = this.beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = $437b23f6a393c3bf$export$3077f3bcabdc5ad1(this.beans, gridCell);
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowBelow)) return null;
            if (!rowBelow.rowPinned && !(pagination?.isRowInPage(rowBelow.rowIndex) ?? true)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const { beans: beans } = this;
        const { visibleCols: visibleCols, pagination: pagination } = beans;
        const displayedColumns = visibleCols.allCols;
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = visibleCols.getColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = $437b23f6a393c3bf$export$236389741107357f(displayedColumns);
            const rowAbove = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(beans, {
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            });
            if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowAbove)) return null;
            if (!rowAbove.rowPinned && !(pagination?.isRowInPage(rowAbove.rowIndex) ?? true)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    isSuppressNavigable(column, rowNode) {
        const { suppressNavigable: suppressNavigable } = column.colDef;
        if (typeof suppressNavigable === "boolean") return suppressNavigable;
        if (typeof suppressNavigable === "function") {
            const params = column.createColumnFunctionCallbackParams(rowNode);
            const userFunc = suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
};
// packages/ag-grid-community/src/navigation/navigationApi.ts
function $437b23f6a393c3bf$var$getFocusedCell(beans) {
    return beans.focusSvc.getFocusedCell();
}
function $437b23f6a393c3bf$var$clearFocusedCell(beans) {
    return beans.focusSvc.clearFocusedCell();
}
function $437b23f6a393c3bf$var$setFocusedCell(beans, rowIndex, colKey, rowPinned) {
    beans.focusSvc.setFocusedCell({
        rowIndex: rowIndex,
        column: colKey,
        rowPinned: rowPinned,
        forceBrowserFocus: true
    });
}
function $437b23f6a393c3bf$var$tabToNextCell(beans, event) {
    return beans.navigation?.tabToNextCell(false, event) ?? false;
}
function $437b23f6a393c3bf$var$tabToPreviousCell(beans, event) {
    return beans.navigation?.tabToNextCell(true, event) ?? false;
}
function $437b23f6a393c3bf$var$setFocusedHeader(beans, colKey, floatingFilter = false) {
    const headerPosition = beans.headerNavigation?.getHeaderPositionForColumn(colKey, floatingFilter);
    if (!headerPosition) return;
    beans.focusSvc.focusHeaderPosition({
        headerPosition: headerPosition
    });
}
// packages/ag-grid-community/src/navigation/navigationService.ts
var $437b23f6a393c3bf$var$NavigationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "navigation";
        this.onPageDown = $437b23f6a393c3bf$var$_throttle(this.onPageDown, 100);
        this.onPageUp = $437b23f6a393c3bf$var$_throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.beans.rangeSvc && event.shiftKey;
        const currentCell = $437b23f6a393c3bf$export$d85fcb0e6e51242(this.gos, event);
        let processed = false;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.beans.focusSvc.getFocusedCell();
        if (!currentCell) return false;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo(navigateParams) {
        const { scrollIndex: scrollIndex, scrollType: scrollType, scrollColumn: scrollColumn, focusIndex: focusIndex, focusColumn: focusColumn } = navigateParams;
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollColumn) && !scrollColumn.isPinned()) scrollFeature.ensureColumnVisible(scrollColumn);
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(scrollIndex)) scrollFeature.ensureIndexVisible(scrollIndex, scrollType);
        if (!navigateParams.isAsync) scrollFeature.ensureIndexVisible(focusIndex);
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: null,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: null,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = rowModel.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const { pageBounds: pageBounds, rowModel: rowModel, rowAutoHeight: rowAutoHeight } = beans;
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = rowModel.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (rowAutoHeight?.active) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        const pagingPixelOffset = pageBounds.getPixelOffset();
        const currentRowNode = rowModel.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        currentRowNode?.rowHeight - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = currentRowNode?.rowTop + rowPixelDiff;
        let focusIndex = rowModel.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(rowModel.getRow(focusIndex))) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: scrollType,
            scrollColumn: null,
            focusIndex: focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex: scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex: focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const lastRowIndex = pageBounds.getLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = rowModel.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = currentCell.rowHeight ?? 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const beans = this.beans;
        const scrollPosition = $437b23f6a393c3bf$var$getVScroll(beans);
        const scrollbarWidth = this.beans.scrollVisibleSvc.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (beans.ctrlsSvc.get("center").isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowNode) {
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.beans.cellNavigation.getNextCellToFocus(key, gridCell, true);
        const { rowIndex: rowIndex } = cellToFocus;
        const column = cellToFocus.column;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: column,
            focusIndex: rowIndex,
            focusColumn: column
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME;
        const { visibleCols: visibleCols, pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const allColumns = visibleCols.allCols;
        const scrollIndex = homeKey ? pageBounds.getFirstRow() : pageBounds.getLastRow();
        const rowNode = rowModel.getRow(scrollIndex);
        if (!rowNode) return;
        const columnToSelect = (homeKey ? allColumns : [
            ...allColumns
        ].reverse()).find((col)=>!col.isSuppressNavigable(rowNode));
        if (!columnToSelect) return;
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        const beans = this.beans;
        const { ctrlsSvc: ctrlsSvc, pageBounds: pageBounds, focusSvc: focusSvc, gos: gos } = beans;
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            else if (movedToNextCell === null) ctrlsSvc.get("gridCtrl").allowFocusForNextCoreContainer(backwards);
            return;
        }
        if (backwards) {
            const { rowIndex: rowIndex, rowPinned: rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === pageBounds.getFirstRow();
            if (firstRow) {
                if (gos.get("headerHeight") === 0 || $437b23f6a393c3bf$var$_isHeaderFocusSuppressed(beans)) $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, true, true);
                else {
                    keyboardEvent.preventDefault();
                    focusSvc.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof $437b23f6a393c3bf$var$CellCtrl) previous.focusCell(true);
            if (!backwards && focusSvc.focusOverlay(false) || $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const beans = this.beans;
        const { focusSvc: focusSvc, rowRenderer: rowRenderer } = beans;
        const focusedCell = focusSvc.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, focusedCell);
        if (!cellOrRow) {
            cellOrRow = rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow || !cellOrRow.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event);
    }
    tabToNextCellCommon(previous, backwards, event) {
        let editing = previous.editing;
        if (!editing && previous instanceof $437b23f6a393c3bf$var$CellCtrl) {
            const cell = previous;
            const row = cell.rowCtrl;
            if (row) editing = row.editing;
        }
        let res;
        if (editing) {
            if (this.gos.get("editType") === "fullRow") res = this.moveToNextEditingRow(previous, backwards, event);
            else res = this.moveToNextEditingCell(previous, backwards, event);
        } else res = this.moveToNextCellNotEditing(previous, backwards, event);
        if (res === null) return res;
        return res || !!this.beans.focusSvc.focusedHeader;
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(previousCell, backwards, event = null) {
        const previousPos = previousCell.cellPosition;
        previousCell.eGui.focus();
        previousCell.stopEditing();
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        this.beans.editSvc?.startEditing(nextCell, null, true, event);
        nextCell.focusCell(false);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextEditingRow(previousCell, backwards, event = null) {
        const previousPos = previousCell.cellPosition;
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.cellPosition;
        const previousEditable = this.isCellEditable(previousPos);
        const nextEditable = this.isCellEditable(nextPos);
        const rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;
        const { editSvc: editSvc, rowEditSvc: rowEditSvc } = this.beans;
        if (previousEditable) editSvc?.setFocusOutOnEditor(previousCell);
        if (!rowsMatch) {
            const pRow = previousCell.rowCtrl;
            editSvc?.stopRowEditing(pRow);
            const nRow = nextCell.rowCtrl;
            rowEditSvc?.startEditing(nRow, void 0, void 0, event);
        }
        if (nextEditable) {
            editSvc?.setFocusInOnEditor(nextCell);
            nextCell.focusCell();
        } else nextCell.focusCell(true);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards, event) {
        const displayedColumns = this.beans.visibleCols.allCols;
        let cellPos;
        if (previousCell instanceof $437b23f6a393c3bf$var$RowCtrl) {
            cellPos = {
                ...previousCell.getRowPosition(),
                column: backwards ? displayedColumns[0] : $437b23f6a393c3bf$export$236389741107357f(displayedColumns)
            };
            if (this.gos.get("embedFullWidthRows") && event) {
                const focusedContainer = previousCell.findFullWidthInfoForEvent(event);
                if (focusedContainer) cellPos.column = focusedContainer.column;
            }
        } else cellPos = previousCell.getFocusedCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, backwards, false);
        if (nextCell === false) return null;
        if (nextCell instanceof $437b23f6a393c3bf$var$CellCtrl) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell, backwards);
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, backwards, startEditing) {
        let nextPosition = previousPosition;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, gos: gos, focusSvc: focusSvc, rowRenderer: rowRenderer, rangeSvc: rangeSvc } = beans;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = cellNavigation.getNextTabbedCell(nextPosition, backwards);
            const userFunc = gos.getCallback("tabToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true) nextPosition = previousPosition;
                else if (userResult === false) return false;
                else nextPosition = {
                    rowIndex: userResult.rowIndex,
                    column: userResult.column,
                    rowPinned: userResult.rowPinned
                };
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
                focusSvc.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = gos.get("editType") === "fullRow";
            if (startEditing && !fullRowEdit) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, nextPosition);
            if (!nextCell) {
                const row = rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return {
                    ...row.getRowPosition(),
                    column: nextPosition?.column
                };
            }
            if (cellNavigation.isSuppressNavigable(nextCell.column, nextCell.rowNode)) continue;
            nextCell.setFocusedCellPosition(nextPosition);
            rangeSvc?.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    lookupRowNodeForCell({ rowIndex: rowIndex, rowPinned: rowPinned }) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        if (rowPinned === "top") return pinnedRowModel?.getPinnedTopRow(rowIndex);
        if (rowPinned === "bottom") return pinnedRowModel?.getPinnedBottomRow(rowIndex);
        return rowModel.getRow(rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        const beans = this.beans;
        const { cellNavigation: cellNavigation, focusSvc: focusSvc, gos: gos } = beans;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (gos.get("enableRtl")) {
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = cellNavigation.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = $437b23f6a393c3bf$export$672d9e47bc342bac(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = gos.getCallback("navigateToNextCell");
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userFunc)) {
                const params = {
                    key: key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event: event
                };
                const userCell = userFunc(params);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(userCell)) nextCell = {
                    rowPinned: userCell.rowPinned,
                    rowIndex: userCell.rowIndex,
                    column: userCell.column
                };
                else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = $437b23f6a393c3bf$var$getFocusHeaderRowCount(beans);
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        const isSpannedCell = !!this.beans.spannedRowRenderer?.getCellByPosition(cellPosition);
        if (isSpannedCell) return cellPosition;
        this.ensureCellVisible(cellPosition);
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getFocusedCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards) {
        const { visibleCols: visibleCols, rowRenderer: rowRenderer, focusSvc: focusSvc, eventSvc: eventSvc } = this.beans;
        const displayedColumns = visibleCols.allCols;
        const rowComp = rowRenderer.getRowByPosition(position);
        if (!rowComp || !rowComp.isFullWidth()) return false;
        const currentCellFocused = focusSvc.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? $437b23f6a393c3bf$export$236389741107357f(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = backwards == null ? currentCellFocused != null && $437b23f6a393c3bf$export$6cce97428a227a31(cellPosition, currentCellFocused) : backwards;
        eventSvc.dispatchEvent({
            type: "fullWidthRowFocused",
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            fromBelow: fromBelow
        });
        return true;
    }
    focusPosition(cellPosition) {
        const { focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        focusSvc.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = $437b23f6a393c3bf$export$1bd7ce47360c3c0(this.beans, cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: $437b23f6a393c3bf$export$236389741107357f(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = $437b23f6a393c3bf$export$d5f33aacea6a0849(this.gos);
        const rowNode = this.beans.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && rowNode?.sticky;
        const { scrollFeature: scrollFeature } = this.gridBodyCon;
        if (!skipScrollToRow && $437b23f6a393c3bf$export$672d9e47bc342bac(gridCell.rowPinned)) scrollFeature.ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) scrollFeature.ensureColumnVisible(gridCell.column);
    }
};
function $437b23f6a393c3bf$var$getVScroll(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
// packages/ag-grid-community/src/navigation/navigationModule.ts
var $437b23f6a393c3bf$export$44f04c51d8088336 = {
    moduleName: "KeyboardNavigation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$NavigationService,
        $437b23f6a393c3bf$var$CellNavigationService,
        $437b23f6a393c3bf$var$HeaderNavigationService
    ],
    apiFunctions: {
        getFocusedCell: $437b23f6a393c3bf$var$getFocusedCell,
        clearFocusedCell: $437b23f6a393c3bf$var$clearFocusedCell,
        setFocusedCell: $437b23f6a393c3bf$var$setFocusedCell,
        setFocusedHeader: $437b23f6a393c3bf$var$setFocusedHeader,
        tabToNextCell: $437b23f6a393c3bf$var$tabToNextCell,
        tabToPreviousCell: $437b23f6a393c3bf$var$tabToPreviousCell
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsListener.ts
var $437b23f6a393c3bf$var$PageBoundsListener = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBoundsListener";
    }
    postConstruct() {
        this.addManagedEventListeners({
            modelUpdated: this.onModelUpdated.bind(this),
            recalculateRowBounds: this.calculatePages.bind(this)
        });
        this.onModelUpdated();
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: modelUpdatedEvent?.animate ?? false,
            newData: modelUpdatedEvent?.newData ?? false,
            newPage: modelUpdatedEvent?.newPage ?? false,
            newPageSize: modelUpdatedEvent?.newPageSize ?? false,
            keepRenderedRows: modelUpdatedEvent?.keepRenderedRows ?? false
        });
    }
    calculatePages() {
        const { pageBounds: pageBounds, pagination: pagination, rowModel: rowModel } = this.beans;
        if (pagination) pagination.calculatePages();
        else pageBounds.calculateBounds(0, rowModel.getRowCount() - 1);
    }
};
// packages/ag-grid-community/src/pagination/pageBoundsService.ts
var $437b23f6a393c3bf$var$PageBoundsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pageBounds";
        this.pixelOffset = 0;
    }
    getFirstRow() {
        return this.topRowBounds?.rowIndex ?? -1;
    }
    getLastRow() {
        return this.bottomRowBounds?.rowIndex ?? -1;
    }
    getCurrentPageHeight() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        if (!topRowBounds || !bottomRowBounds) return 0;
        return Math.max(bottomRowBounds.rowTop + bottomRowBounds.rowHeight - topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const { topRowBounds: topRowBounds, bottomRowBounds: bottomRowBounds } = this;
        const pageFirstPixel = topRowBounds?.rowTop ?? 0;
        const pageLastPixel = bottomRowBounds ? bottomRowBounds.rowTop + bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel: pageFirstPixel,
            pageLastPixel: pageLastPixel
        };
    }
    calculateBounds(topDisplayedRowIndex, bottomDisplayedRowIndex) {
        const { rowModel: rowModel } = this.beans;
        const topRowBounds = rowModel.getRowBounds(topDisplayedRowIndex);
        if (topRowBounds) topRowBounds.rowIndex = topDisplayedRowIndex;
        this.topRowBounds = topRowBounds;
        const bottomRowBounds = rowModel.getRowBounds(bottomDisplayedRowIndex);
        if (bottomRowBounds) bottomRowBounds.rowIndex = bottomDisplayedRowIndex;
        this.bottomRowBounds = bottomRowBounds;
        this.calculatePixelOffset();
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    calculatePixelOffset() {
        const value = this.topRowBounds?.rowTop ?? 0;
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventSvc.dispatchEvent({
            type: "paginationPixelOffsetChanged"
        });
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.css-GENERATED.ts
var $437b23f6a393c3bf$var$pinnedColumnModuleCSS = /*css*/ `.ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}`;
// packages/ag-grid-community/src/gridBodyComp/rowContainer/setPinnedWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(isLeft, elements){
        super();
        this.isLeft = isLeft;
        this.elements = elements;
        this.getWidth = isLeft ? ()=>this.beans.pinnedCols.leftWidth : ()=>this.beans.pinnedCols.rightWidth;
    }
    postConstruct() {
        this.addManagedEventListeners({
            [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
        });
    }
    onPinnedWidthChanged() {
        const width = this.getWidth();
        const displayed = width > 0;
        for (const element of this.elements)if (element) {
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, displayed);
            $437b23f6a393c3bf$export$ce98ba7f5cfe7725(element, width);
        }
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnService.ts
var $437b23f6a393c3bf$var$PinnedColumnService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pinnedCols";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedEventListeners({
            displayedColumnsChanged: listener,
            displayedColumnsWidthChanged: listener
        });
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const { gos: gos, visibleCols: visibleCols, eventSvc: eventSvc } = this.beans;
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        const newLeftWidth = printLayout ? 0 : visibleCols.getColsLeftWidth();
        const newRightWidth = printLayout ? 0 : visibleCols.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            eventSvc.dispatchEvent({
                type: "leftPinnedWidthChanged"
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            eventSvc.dispatchEvent({
                type: "rightPinnedWidthChanged"
            });
        }
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.eBodyViewport;
        const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(eBodyViewport);
        if (bodyWidth <= 50) return;
        const processedColumnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        const { columns: columns, hasLockedPinned: hasLockedPinned } = processedColumnsToRemove;
        let columnsToRemove = columns;
        if (!columnsToRemove.length && !hasLockedPinned) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        if (!columnsToRemove || !columnsToRemove.length) return;
        columnsToRemove = columnsToRemove.filter((col)=>!$437b23f6a393c3bf$export$3d3e7d751f0445eb(col));
        this.setColsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    createPinnedWidthFeature(isLeft, ...elements) {
        return new $437b23f6a393c3bf$var$SetPinnedWidthFeature(isLeft, elements);
    }
    setColsPinned(keys, pinned, source) {
        const { colModel: colModel, colAnimation: colAnimation, visibleCols: visibleCols, gos: gos } = this.beans;
        if (!colModel.cols) return;
        if (!keys?.length) return;
        if ($437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print")) {
            $437b23f6a393c3bf$export$545083624300f13d(37);
            return;
        }
        colAnimation?.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        const updatedCols = [];
        keys.forEach((key)=>{
            if (!key) return;
            const column = colModel.getCol(key);
            if (!column) return;
            if (column.getPinned() !== actualPinned) {
                this.setColPinned(column, actualPinned);
                updatedCols.push(column);
            }
        });
        if (updatedCols.length) {
            visibleCols.refresh(source);
            $437b23f6a393c3bf$var$dispatchColumnPinnedEvent(this.eventSvc, updatedCols, source);
        }
        colAnimation?.finish();
    }
    initCol(column) {
        const { pinned: pinned, initialPinned: initialPinned } = column.colDef;
        if (pinned !== void 0) this.setColPinned(column, pinned);
        else this.setColPinned(column, initialPinned);
    }
    setColPinned(column, pinned) {
        if (pinned === true || pinned === "left") column.pinned = "left";
        else if (pinned === "right") column.pinned = "right";
        else column.pinned = null;
        column.dispatchStateUpdatedEvent("pinned");
    }
    setupHeaderPinnedWidth(ctrl) {
        const { scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        if (ctrl.pinned == null) return;
        const pinningLeft = ctrl.pinned === "left";
        const pinningRight = ctrl.pinned === "right";
        ctrl.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.leftWidth : this.rightWidth;
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = ctrl.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = scrollVisibleSvc.getScrollbarWidth();
            const addPaddingForScrollbar = scrollVisibleSvc.verticalScrollShowing && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            ctrl.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            ctrl.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                ctrl.hidden = hidden;
                ctrl.refresh();
            }
        };
        ctrl.addManagedEventListeners({
            leftPinnedWidthChanged: listener,
            rightPinnedWidthChanged: listener,
            scrollVisibilityChanged: listener,
            scrollbarWidthChanged: listener
        });
    }
    getHeaderResizeDiff(diff, column) {
        const pinned = column.getPinned();
        if (pinned) {
            const { leftWidth: leftWidth, rightWidth: rightWidth } = this;
            const bodyWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.rightWidth ?? 0;
        const pinnedLeftWidth = this.leftWidth ?? 0;
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        let hasLockedPinned = false;
        if (totalPinnedWidth < viewportWidth) return {
            columns: [],
            hasLockedPinned: hasLockedPinned
        };
        const { visibleCols: visibleCols } = this.beans;
        const pinnedLeftColumns = [
            ...visibleCols.leftCols
        ];
        const pinnedRightColumns = [
            ...visibleCols.rightCols
        ];
        let indexRight = 0;
        let indexLeft = 0;
        const totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                if (currentColumn.colDef.lockPinned) {
                    hasLockedPinned = true;
                    continue;
                }
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return {
            columns: columnsToRemove,
            hasLockedPinned: hasLockedPinned
        };
    }
};
// packages/ag-grid-community/src/pinnedColumns/pinnedColumnModule.ts
var $437b23f6a393c3bf$var$PinnedColumnModule = {
    moduleName: "PinnedColumn",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PinnedColumnService
    ],
    css: [
        $437b23f6a393c3bf$var$pinnedColumnModuleCSS
    ]
};
// packages/ag-grid-community/src/rendering/ariaAnnouncementService.ts
var $437b23f6a393c3bf$var$AriaAnnouncementService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.beanName = "ariaAnnounce";
        this.descriptionContainer = null;
        this.pendingAnnouncements = /* @__PURE__ */ new Map();
        this.lastAnnouncement = "";
        this.updateAnnouncement = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.updateAnnouncement.bind(this), 200);
    }
    postConstruct() {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        $437b23f6a393c3bf$var$_setAriaLive(div, "polite");
        $437b23f6a393c3bf$var$_setAriaRelevant(div, "additions text");
        $437b23f6a393c3bf$var$_setAriaAtomic(div, true);
        beans.eGridDiv.appendChild(div);
    }
    /**
   * @param key used for debouncing calls
   */ announceValue(value, key) {
        this.pendingAnnouncements.set(key, value);
        this.updateAnnouncement();
    }
    updateAnnouncement() {
        if (!this.descriptionContainer) return;
        const value = Array.from(this.pendingAnnouncements.values()).join(". ");
        this.pendingAnnouncements.clear();
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            if (this.isAlive() && this.descriptionContainer) {
                let valueToAnnounce = value;
                if (this.lastAnnouncement === valueToAnnounce) valueToAnnounce = `${valueToAnnounce}.`;
                this.lastAnnouncement = valueToAnnounce;
                this.descriptionContainer.textContent = valueToAnnounce;
            }
        }, 50);
    }
    destroy() {
        super.destroy();
        const { descriptionContainer: descriptionContainer } = this;
        if (descriptionContainer) {
            $437b23f6a393c3bf$export$69e6e10709eabd91(descriptionContainer);
            descriptionContainer.parentElement?.removeChild(descriptionContainer);
        }
        this.descriptionContainer = null;
        this.pendingAnnouncements.clear();
    }
};
// packages/ag-grid-community/src/rendering/ariaModule.ts
var $437b23f6a393c3bf$var$AriaModule = {
    moduleName: "Aria",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AriaAnnouncementService
    ]
};
// packages/ag-grid-community/src/rendering/overlays/overlayApi.ts
function $437b23f6a393c3bf$var$showLoadingOverlay(beans) {
    beans.overlays?.showLoadingOverlay();
}
function $437b23f6a393c3bf$var$showNoRowsOverlay(beans) {
    beans.overlays?.showNoRowsOverlay();
}
function $437b23f6a393c3bf$var$hideOverlay(beans) {
    beans.overlays?.hideOverlay();
}
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.css-GENERATED.ts
var $437b23f6a393c3bf$var$overlayWrapperComponentCSS = /*css*/ `.ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:1px solid var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}`;
// packages/ag-grid-community/src/rendering/overlays/overlayWrapperComponent.ts
var $437b23f6a393c3bf$var$OverlayWrapperElement = {
    tag: "div",
    cls: "ag-overlay",
    role: "presentation",
    children: [
        {
            tag: "div",
            cls: "ag-overlay-panel",
            role: "presentation",
            children: [
                {
                    tag: "div",
                    ref: "eOverlayWrapper",
                    cls: "ag-overlay-wrapper",
                    role: "presentation"
                }
            ]
        }
    ]
};
var $437b23f6a393c3bf$var$OverlayWrapperComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$OverlayWrapperElement);
        this.eOverlayWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.activePromise = null;
        this.activeOverlay = null;
        this.updateListenerDestroyFunc = null;
        this.activeCssClass = null;
        this.elToFocusAfter = null;
        this.registerCSS($437b23f6a393c3bf$var$overlayWrapperComponentCSS);
    }
    handleKeyDown(e) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$9a48e23524c6d58(e)) return;
        const beans = this.beans;
        const nextEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eOverlayWrapper, false, e.shiftKey);
        if (nextEl) return;
        let isFocused = false;
        if (e.shiftKey) isFocused = beans.focusSvc.focusGridView({
            column: $437b23f6a393c3bf$export$236389741107357f(beans.visibleCols.allCols),
            backwards: true,
            canFocusOverlay: false
        });
        else isFocused = $437b23f6a393c3bf$export$987f3c95dc941f0c(beans, false);
        if (isFocused) e.preventDefault();
    }
    updateLayoutClasses(cssClass, params) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        const { AUTO_HEIGHT: AUTO_HEIGHT, NORMAL: NORMAL, PRINT: PRINT } = $437b23f6a393c3bf$var$LayoutCssClasses;
        overlayWrapperClassList.toggle(AUTO_HEIGHT, params.autoHeight);
        overlayWrapperClassList.toggle(NORMAL, params.normal);
        overlayWrapperClassList.toggle(PRINT, params.print);
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.beans.overlays.setOverlayWrapperComp(this);
        this.addManagedElementListeners(this.getFocusableElement(), {
            keydown: this.handleKeyDown.bind(this)
        });
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        if (this.activeCssClass) overlayWrapperClassList.toggle(this.activeCssClass, false);
        this.activeCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComponentPromise, overlayWrapperCssClass, exclusive, gridOption) {
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.destroyActiveOverlay();
        this.elToFocusAfter = null;
        this.activePromise = overlayComponentPromise;
        if (!overlayComponentPromise) return;
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
        if (exclusive && this.isGridFocused()) {
            const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
            if (activeElement && !$437b23f6a393c3bf$export$8ff9eef09a45371f(this.beans)) this.elToFocusAfter = activeElement;
        }
        overlayComponentPromise.then((comp)=>{
            if (this.activePromise !== overlayComponentPromise) {
                if (this.activeOverlay !== comp) {
                    this.destroyBean(comp);
                    comp = null;
                }
                return;
            }
            this.activePromise = null;
            if (!comp) return;
            if (this.activeOverlay !== comp) {
                this.eOverlayWrapper.appendChild(comp.getGui());
                this.activeOverlay = comp;
                if (gridOption) {
                    const component = comp;
                    this.updateListenerDestroyFunc = this.addManagedPropertyListener(gridOption, ({ currentValue: currentValue })=>{
                        component.refresh?.($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                            ...currentValue ?? {}
                        }));
                    });
                }
            }
            if (exclusive && this.isGridFocused()) $437b23f6a393c3bf$export$8598088d375f416f(this.eOverlayWrapper);
        });
    }
    updateOverlayWrapperPaddingTop(padding) {
        this.eOverlayWrapper.style.setProperty("padding-top", `${padding}px`);
    }
    destroyActiveOverlay() {
        this.activePromise = null;
        const activeOverlay = this.activeOverlay;
        if (!activeOverlay) return;
        let elementToFocus = this.elToFocusAfter;
        this.activeOverlay = null;
        this.elToFocusAfter = null;
        if (elementToFocus && !this.isGridFocused()) elementToFocus = null;
        const updateListenerDestroyFunc = this.updateListenerDestroyFunc;
        if (updateListenerDestroyFunc) {
            updateListenerDestroyFunc();
            this.updateListenerDestroyFunc = null;
        }
        this.destroyBean(activeOverlay);
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eOverlayWrapper);
        elementToFocus?.focus?.({
            preventScroll: true
        });
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    isGridFocused() {
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(this.beans);
        return !!activeEl && this.beans.eGridDiv.contains(activeEl);
    }
    destroy() {
        this.elToFocusAfter = null;
        this.destroyActiveOverlay();
        this.beans.overlays.setOverlayWrapperComp(void 0);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$OverlayWrapperSelector = {
    selector: "AG-OVERLAY-WRAPPER",
    component: $437b23f6a393c3bf$var$OverlayWrapperComponent
};
// packages/ag-grid-community/src/rendering/overlays/overlayService.ts
var $437b23f6a393c3bf$var$OverlayService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "overlays";
        this.state = 0 /* Hidden */ ;
        this.showInitialOverlay = true;
        this.wrapperPadding = 0;
    }
    postConstruct() {
        this.isClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        this.isServerSide = !this.isClientSide && $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        const updateOverlayVisibility = ()=>this.updateOverlayVisibility();
        this.addManagedEventListeners({
            newColumnsLoaded: updateOverlayVisibility,
            rowDataUpdated: updateOverlayVisibility,
            gridSizeChanged: this.refreshWrapperPadding.bind(this),
            rowCountReady: ()=>{
                this.showInitialOverlay = false;
                this.updateOverlayVisibility();
            }
        });
        this.addManagedPropertyListener("loading", updateOverlayVisibility);
    }
    setOverlayWrapperComp(overlayWrapperComp) {
        this.eWrapper = overlayWrapperComp;
        this.updateOverlayVisibility();
    }
    /** Returns true if the overlay is visible. */ isVisible() {
        return this.state !== 0 /* Hidden */  && !!this.eWrapper;
    }
    /** Returns true if the overlay is visible and is exclusive (popup over the grid) */ isExclusive() {
        return this.state === 1 /* Loading */  && !!this.eWrapper;
    }
    showLoadingOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        const loading = gos.get("loading");
        if (!loading && (loading !== void 0 || gos.get("suppressLoadingOverlay"))) return;
        this.doShowLoadingOverlay();
    }
    showNoRowsOverlay() {
        this.showInitialOverlay = false;
        const gos = this.gos;
        if (gos.get("loading") || gos.get("suppressNoRowsOverlay")) return;
        this.doShowNoRowsOverlay();
    }
    hideOverlay() {
        this.showInitialOverlay = false;
        if (this.gos.get("loading")) {
            $437b23f6a393c3bf$export$545083624300f13d(99);
            return;
        }
        this.doHideOverlay();
    }
    getOverlayWrapperSelector() {
        return $437b23f6a393c3bf$var$OverlayWrapperSelector;
    }
    getOverlayWrapperCompClass() {
        return $437b23f6a393c3bf$var$OverlayWrapperComponent;
    }
    updateOverlayVisibility() {
        if (!this.eWrapper) {
            this.state = 0 /* Hidden */ ;
            return;
        }
        const { state: state, isClientSide: isClientSide, isServerSide: isServerSide, beans: { gos: gos, colModel: colModel, rowModel: rowModel } } = this;
        let loading = this.gos.get("loading");
        if (loading !== void 0) this.showInitialOverlay = false;
        if (this.showInitialOverlay && loading === void 0 && !gos.get("suppressLoadingOverlay")) loading = !gos.get("columnDefs") || !colModel.ready || !gos.get("rowData") && isClientSide;
        if (loading) {
            if (state !== 1 /* Loading */ ) this.doShowLoadingOverlay();
        } else {
            this.showInitialOverlay = false;
            if (isClientSide && rowModel.isEmpty() && !gos.get("suppressNoRowsOverlay")) {
                if (state !== 2 /* NoRows */ ) this.doShowNoRowsOverlay();
            } else if (state === 1 /* Loading */  || !isServerSide && state !== 0 /* Hidden */ ) this.doHideOverlay();
        }
    }
    doShowLoadingOverlay() {
        if (!this.eWrapper) return;
        this.state = 1 /* Loading */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getLoadingOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
        this.updateExclusive();
    }
    doShowNoRowsOverlay() {
        if (!this.eWrapper) return;
        this.state = 2 /* NoRows */ ;
        this.showOverlay($437b23f6a393c3bf$var$_getNoRowsOverlayCompDetails(this.beans.userCompFactory, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})), "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
        this.updateExclusive();
    }
    doHideOverlay() {
        if (!this.eWrapper) return;
        this.state = 0 /* Hidden */ ;
        this.eWrapper.hideOverlay();
        this.updateExclusive();
    }
    showOverlay(compDetails, wrapperCssClass, gridOption) {
        const promise = compDetails?.newAgStackInstance() ?? null;
        this.eWrapper?.showOverlay(promise, wrapperCssClass, this.isExclusive(), gridOption);
        this.refreshWrapperPadding();
    }
    updateExclusive() {
        const wasExclusive = this.exclusive;
        this.exclusive = this.isExclusive();
        if (this.exclusive !== wasExclusive) this.eventSvc.dispatchEvent({
            type: "overlayExclusiveChanged"
        });
    }
    refreshWrapperPadding() {
        const eWrapper = this.eWrapper;
        if (!eWrapper) return;
        let newPadding = 0;
        if (this.state === 2 /* NoRows */ ) {
            const headerCtrl = this.beans.ctrlsSvc.get("gridHeaderCtrl");
            const headerHeight = headerCtrl?.headerHeight || 0;
            newPadding = headerHeight;
        } else if (this.wrapperPadding !== 0) newPadding = 0;
        if (this.wrapperPadding === newPadding) return;
        this.wrapperPadding = newPadding;
        eWrapper.updateOverlayWrapperPaddingTop(newPadding);
    }
};
// packages/ag-grid-community/src/rendering/overlays/overlayModule.ts
var $437b23f6a393c3bf$var$OverlayModule = {
    moduleName: "Overlay",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayComponent2,
        agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayComponent2
    },
    apiFunctions: {
        showLoadingOverlay: $437b23f6a393c3bf$var$showLoadingOverlay,
        showNoRowsOverlay: $437b23f6a393c3bf$var$showNoRowsOverlay,
        hideOverlay: $437b23f6a393c3bf$var$hideOverlay
    },
    beans: [
        $437b23f6a393c3bf$var$OverlayService
    ]
};
// packages/ag-grid-community/src/rendering/rowContainerHeightService.ts
var $437b23f6a393c3bf$var$RowContainerHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowContainerHeight";
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    postConstruct() {
        this.addManagedEventListeners({
            bodyHeightChanged: this.updateOffset.bind(this)
        });
        this.maxDivHeight = $437b23f6a393c3bf$var$_getMaxDivHeight();
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
    }
    updateOffset() {
        if (!this.stretching) return;
        const newScrollY = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowContainerHeightService - Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventSvc.dispatchEvent({
                type: "rowContainerHeightChanged"
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventSvc.dispatchEvent({
            type: "heightScaleChanged"
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && // null happens when in print layout
        this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const pos = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
// packages/ag-grid-community/src/rendering/rowRenderer.ts
var $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT = 400;
var $437b23f6a393c3bf$var$RowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowRenderer";
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onCellSelectionChanged = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellSelectionChanged());
            };
            const onColumnMovedPinnedVisible = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.updateRangeBordersIfRangeCount());
            };
            const addCellSelectionListeners = ()=>{
                this.eventSvc.addEventListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.addEventListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.addEventListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.addEventListener("columnVisible", onColumnMovedPinnedVisible);
            };
            const removeCellSelectionListeners = ()=>{
                this.eventSvc.removeEventListener("cellSelectionChanged", onCellSelectionChanged);
                this.eventSvc.removeEventListener("columnMoved", onColumnMovedPinnedVisible);
                this.eventSvc.removeEventListener("columnPinned", onColumnMovedPinnedVisible);
                this.eventSvc.removeEventListener("columnVisible", onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeCellSelectionListeners());
            this.addManagedPropertyListeners([
                "enableRangeSelection",
                "cellSelection"
            ], ()=>{
                const isEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
                if (isEnabled) addCellSelectionListeners();
                else removeCellSelectionListeners();
            });
            const cellSelectionEnabled = $437b23f6a393c3bf$export$1f7ca6920544d9e4(this.gos);
            if (cellSelectionEnabled) addCellSelectionListeners();
        };
    }
    wireBeans(beans) {
        this.pageBounds = beans.pageBounds;
        this.colModel = beans.colModel;
        this.pinnedRowModel = beans.pinnedRowModel;
        this.rowModel = beans.rowModel;
        this.focusSvc = beans.focusSvc;
        this.rowContainerHeight = beans.rowContainerHeight;
        this.ctrlsSvc = beans.ctrlsSvc;
    }
    postConstruct() {
        this.ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedEventListeners({
            paginationChanged: this.onPageLoaded.bind(this),
            pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
            pinnedRowsChanged: this.onPinnedRowsChanged.bind(this),
            displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
            bodyScroll: this.onBodyScroll.bind(this),
            bodyHeightChanged: this.redraw.bind(this, {})
        });
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListener("suppressCellFocus", (e)=>this.onSuppressCellFocusChanged(e.currentValue));
        this.addManagedPropertyListeners([
            "groupSuppressBlankHeader",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        this.addManagedPropertyListener("cellSelection", ({ currentValue: currentValue, previousValue: previousValue })=>{
            if (!previousValue && currentValue || previousValue && !currentValue) this.redrawRows();
        });
        const { stickyRowSvc: stickyRowSvc, gos: gos, showRowGroupCols: showRowGroupCols } = this.beans;
        if (showRowGroupCols) this.addManagedPropertyListener("showOpenedGroup", ()=>{
            const columns = showRowGroupCols.getShowRowGroupCols();
            if (columns.length) this.refreshCells({
                columns: columns,
                force: true
            });
        });
        if (stickyRowSvc) this.stickyRowFeature = stickyRowSvc.createStickyRowFeature(this, this.createRowCon.bind(this), this.destroyRowCtrls.bind(this));
        else {
            const gridBodyCtrl = this.gridBodyCtrl;
            gridBodyCtrl.setStickyTopHeight(0);
            gridBodyCtrl.setStickyBottomHeight(0);
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(gos, "print");
        this.embedFullWidthRows = this.printLayout || gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new $437b23f6a393c3bf$var$RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        return this.stickyRowFeature?.stickyTopRowCtrls ?? [];
    }
    getStickyBottomRowCtrls() {
        return this.stickyRowFeature?.stickyBottomRowCtrls ?? [];
    }
    updateAllRowCtrls() {
        const liveList = Object.values(this.rowCtrlsByRowIndex);
        const zombieList = Object.values(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls?.getEntries() ?? [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    /**
   * Checks if the cell is rendered or not. Also returns true if row ctrl is present but has not rendered
   * cells yet.
   * @returns true if cellCtrl is present, or if the row is present but has not rendered rows yet
   */ isCellBeingRendered(rowIndex, column) {
        const rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!column || !rowCtrl) return !!rowCtrl;
        if (rowCtrl.isFullWidth()) return true;
        const spannedCell = this.beans.spannedRowRenderer?.getCellByPosition({
            rowIndex: rowIndex,
            column: column,
            rowPinned: null
        });
        return !!spannedCell || !!rowCtrl.getCellCtrl(column) || !rowCtrl.isRowRendered();
    }
    /**
   * Notifies all row and cell controls of any change in focused cell.
   * @param event cell focused event
   */ updateCellFocus(event) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellFocused(event));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onFullWidthRowFocused(event));
    }
    /**
   * Called when a new cell is focused in the grid
   * - if the focused cell isn't rendered; re-draw rows to dry to render it
   * - subsequently updates all cell and row controls with the new focused cell
   * @param event cell focused event
   */ onCellFocusChanged(event) {
        if (event && event.rowIndex != null && !event.rowPinned) {
            const col = this.beans.colModel.getCol(event.column) ?? void 0;
            if (!this.isCellBeingRendered(event.rowIndex, col)) this.redraw();
        }
        this.updateCellFocus(event);
    }
    onSuppressCellFocusChanged(suppressCellFocus) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onSuppressCellFocusChanged(suppressCellFocus));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onSuppressCellFocusChanged(suppressCellFocus));
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedEventListeners({
            cellFocused: (event)=>this.onCellFocusChanged(event),
            cellFocusCleared: ()=>this.updateCellFocus(),
            flashCells: (event)=>{
                const { cellFlashSvc: cellFlashSvc } = this.beans;
                if (cellFlashSvc) this.getAllCellCtrls().forEach((cellCtrl)=>cellFlashSvc.onFlashCells(cellCtrl, event));
            },
            columnHoverChanged: ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onColumnHover());
            },
            displayedColumnsChanged: ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onDisplayedColumnsChanged());
            },
            displayedColumnsWidthChanged: ()=>{
                if (this.printLayout) this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onLeftChanged());
            }
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedEventListeners({
            gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
        });
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        this.destroyFuncsForColumnListeners.forEach((func)=>func());
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.colModel.getCols();
        cols.forEach((col)=>{
            const forEachCellWithThisCol = (callback)=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>{
                    if (cellCtrl.column === col) callback(cellCtrl);
                });
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.__addEventListener("leftChanged", leftChangedListener);
            col.__addEventListener("widthChanged", widthChangedListener);
            col.__addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.__addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.__addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.__removeEventListener("leftChanged", leftChangedListener);
                col.__removeEventListener("widthChanged", widthChangedListener);
                col.__removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.__removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.__removeEventListener("colDefChanged", colDefChangedListener);
            });
        });
    }
    onDomLayoutChanged() {
        const printLayout = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */ getAllCellsNotSpanningForColumn(column) {
        const res = [];
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            const eCell = rowCtrl.getCellCtrl(column, true)?.eGui;
            if (eCell) res.push(eCell);
        });
        return res;
    }
    refreshFloatingRowComps(recycleRows = true) {
        this.refreshFloatingRows(this.topRowCtrls, "top", recycleRows);
        this.refreshFloatingRows(this.bottomRowCtrls, "bottom", recycleRows);
    }
    /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */ refreshFloatingRows(rowCtrls, floating, recycleRows) {
        const { pinnedRowModel: pinnedRowModel, beans: beans, printLayout: printLayout } = this;
        const rowCtrlMap = Object.fromEntries(rowCtrls.map((ctrl)=>[
                ctrl.rowNode.id,
                ctrl
            ]));
        pinnedRowModel?.forEachPinnedRow(floating, (node, i)=>{
            const rowCtrl = rowCtrls[i];
            const rowCtrlDoesNotExist = rowCtrl && pinnedRowModel.getPinnedRowById(rowCtrl.rowNode.id, floating) === void 0;
            if (rowCtrlDoesNotExist) {
                rowCtrl.destroyFirstPass();
                rowCtrl.destroySecondPass();
            }
            if (node.id in rowCtrlMap && recycleRows) {
                rowCtrls[i] = rowCtrlMap[node.id];
                delete rowCtrlMap[node.id];
            } else rowCtrls[i] = new $437b23f6a393c3bf$var$RowCtrl(node, beans, false, false, printLayout);
        });
        const rowNodeCount = (floating === "top" ? pinnedRowModel?.getPinnedTopRowCount() : pinnedRowModel?.getPinnedBottomRowCount()) ?? 0;
        rowCtrls.length = rowNodeCount;
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    onPinnedRowsChanged() {
        this.redrawAfterModelUpdate({
            recycleRows: true
        });
    }
    redrawRow(rowNode, suppressEvent = false) {
        if (rowNode.sticky) this.stickyRowFeature?.refreshStickyNode(rowNode);
        else if (this.cachedRowCtrls?.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.rowNode !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            rowNodes?.forEach((node)=>this.redrawRow(node, true));
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.beans.focusSvc?.getFocusCellToUseAfterRefresh();
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        const { stickyRowFeature: stickyRowFeature, gos: gos } = this;
        if (stickyRowFeature) {
            stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps(gos.get("enableRowPinning") ? recycleRows : void 0);
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) {
            this.gridBodyCtrl.scrollFeature.scrollToTop();
            this.stickyRowFeature?.resetOffsets();
        }
    }
    updateContainerHeights(additionalHeight = 0) {
        const { rowContainerHeight: rowContainerHeight } = this;
        if (this.printLayout) {
            rowContainerHeight.setModelHeight(null);
            return;
        }
        let containerHeight = this.pageBounds.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        rowContainerHeight.setModelHeight(containerHeight + additionalHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error($437b23f6a393c3bf$export$680bb5102fca525e(252));
        this.refreshInProgress = true;
        this.beans.frameworkOverrides.getLockOnRefresh?.();
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
        this.beans.frameworkOverrides.releaseLockOnRefresh?.();
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (!cellPosition) return;
        const focusSvc = this.beans.focusSvc;
        const cellToFocus = this.findPositionToFocus(cellPosition);
        if (!cellToFocus) {
            focusSvc.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: $437b23f6a393c3bf$var$getFocusHeaderRowCount(this.beans) - 1,
                    column: cellPosition.column
                }
            });
            return;
        }
        if (cellPosition.rowIndex !== cellToFocus.rowIndex || cellPosition.rowPinned != cellToFocus.rowPinned) {
            focusSvc.setFocusedCell({
                ...cellToFocus,
                preventScrollOnBrowserFocus: true,
                forceBrowserFocus: true
            });
            return;
        }
        if (!focusSvc.doesRowOrCellHaveBrowserFocus()) this.updateCellFocus($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            ...cellToFocus,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true,
            type: "cellFocused"
        }));
    }
    findPositionToFocus(cellPosition) {
        const { pagination: pagination, pageBounds: pageBounds } = this.beans;
        let rowPosition = cellPosition;
        if (rowPosition.rowPinned == null && pagination && pageBounds && !pagination.isRowInPage(rowPosition.rowIndex)) rowPosition = {
            rowPinned: null,
            rowIndex: pageBounds.getFirstRow()
        };
        while(rowPosition){
            if (rowPosition.rowPinned == null && pageBounds) {
                if (rowPosition.rowIndex < pageBounds.getFirstRow()) {
                    rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, {
                        rowPinned: null,
                        rowIndex: 0
                    });
                    if (!rowPosition) return null;
                } else if (rowPosition.rowIndex > pageBounds.getLastRow()) rowPosition = {
                    rowPinned: null,
                    rowIndex: pageBounds.getLastRow()
                };
            }
            const row = this.getRowByPosition(rowPosition);
            if (row?.isAlive()) return {
                ...row.getRowPosition(),
                column: cellPosition.column
            };
            rowPosition = $437b23f6a393c3bf$export$b36b14fdaf41f4d8(this.beans, rowPosition);
        }
        return null;
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        const stickyTopRowCtrls = this.getStickyTopRowCtrls();
        const stickyBottomRowCtrls = this.getStickyBottomRowCtrls();
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls,
            ...spannedRowRenderer?.getCtrls("top") ?? [],
            ...spannedRowRenderer?.getCtrls("bottom") ?? [],
            ...spannedRowRenderer?.getCtrls("center") ?? [],
            ...Object.values(this.rowCtrlsByRowIndex)
        ];
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    refreshCells(params = {}) {
        const refreshCellParams = {
            forceRefresh: params.force,
            newData: false,
            suppressFlash: params.suppressFlash
        };
        for (const cellCtrl of this.getCellCtrls(params.rowNodes, params.columns))cellCtrl.refreshOrDestroyCell(refreshCellParams);
        this.refreshFullWidth(params.rowNodes);
    }
    refreshFullWidth(rowNodes) {
        if (!rowNodes) return;
        let rowRedrawn = false;
        for (const rowCtrl of this.getRowCtrls(rowNodes)){
            if (!rowCtrl.isFullWidth()) continue;
            const refreshed = rowCtrl.refreshFullWidth();
            if (!refreshed) {
                rowRedrawn = true;
                this.redrawRow(rowCtrl.rowNode, true);
            }
        }
        if (rowRedrawn) this.dispatchDisplayedRowsChanged(false);
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.rowNode;
            return $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.colModel.getCol(colKey);
                if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        this.getRowCtrls(rowNodes).forEach((rowCtrl)=>{
            rowCtrl.getAllCellCtrls().forEach((cellCtrl)=>{
                const colId = cellCtrl.column.getId();
                const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
                if (excludeColFromRefresh) return;
                res.push(cellCtrl);
            });
        });
        return res;
    }
    destroy() {
        this.removeAllRowComps(true);
        super.destroy();
    }
    removeAllRowComps(suppressAnimation = false) {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove, suppressAnimation);
        this.stickyRowFeature?.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        for (const index of Object.keys(this.rowCtrlsByRowIndex)){
            const rowCtrl = this.rowCtrlsByRowIndex[index];
            const stubNode = rowCtrl.rowNode.id == null;
            if (stubNode) stubNodeIndexes.push(index);
        }
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex)){
            const rowNode = rowCtrl.rowNode;
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        }
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        rowsToRemove.forEach((indexToRemove)=>{
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        });
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { focusSvc: focusSvc, animationFrameSvc: animationFrameSvc } = this.beans;
        const { afterScroll: afterScroll } = params;
        let cellFocused;
        const stickyRowFeature = this.stickyRowFeature;
        if (stickyRowFeature) cellFocused = focusSvc?.getFocusCellToUseAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (stickyRowFeature) {
            hasStickyRowChanges = stickyRowFeature.checkStickyRows();
            const extraHeight = stickyRowFeature.extraTopHeight + stickyRowFeature.extraBottomHeight;
            if (extraHeight) this.updateContainerHeights(extraHeight);
        }
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = focusSvc?.getFocusCellToUseAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                animationFrameSvc?.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        indexesToDraw.forEach((index)=>indexesToDrawMap[index] = true);
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        const indexesToDraw = [];
        for(let i = this.firstRenderedRow; i <= this.lastRenderedRow; i++)indexesToDraw.push(i);
        const pagination = this.beans.pagination;
        const focusedRowIndex = this.beans.focusSvc?.getFocusedCell()?.rowIndex;
        if (focusedRowIndex != null && (focusedRowIndex < this.firstRenderedRow || focusedRowIndex > this.lastRenderedRow) && (!pagination || pagination.isRowInPage(focusedRowIndex)) && focusedRowIndex < this.rowModel.getRowCount()) indexesToDraw.push(focusedRowIndex);
        const checkRowToDraw = (rowComp)=>{
            const index = rowComp.rowNode.rowIndex;
            if (index == null || index === focusedRowIndex) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        for (const rowCtrl of Object.values(this.rowCtrlsByRowIndex))checkRowToDraw(rowCtrl);
        if (rowsToRecycle) for (const rowCtrl of Object.values(rowsToRecycle))checkRowToDraw(rowCtrl);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.rowModel.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        const rowCtrls = [];
        indexesToDraw.forEach((rowIndex)=>{
            const rowCtrl = this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowCtrl)) rowCtrls.push(rowCtrl);
        });
        if (rowsToRecycle) {
            const { animationFrameSvc: animationFrameSvc } = this.beans;
            const useAnimationFrame = animationFrameSvc?.active && afterScroll && !this.printLayout;
            if (useAnimationFrame) animationFrameSvc.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        this.eventSvc.dispatchEvent({
            type: "displayedRowsChanged",
            afterScroll: afterScroll
        });
    }
    onDisplayedColumnsChanged() {
        const { visibleCols: visibleCols } = this.beans;
        const pinningLeft = visibleCols.isPinningLeft();
        const pinningRight = visibleCols.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        this.getFullWidthRowCtrls().forEach((fullWidthCtrl)=>{
            const rowIndex = fullWidthCtrl.rowNode.rowIndex;
            rowsToRemove.push(rowIndex.toString());
        });
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = $437b23f6a393c3bf$var$mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.rowNode;
            if (rowNodesMap != null && !$437b23f6a393c3bf$var$isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode) && $437b23f6a393c3bf$export$25d27f17d3af40f7(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.rowModel.getRow(rowIndex);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
        return rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        if (rowCtrlsMap) for (const rowCtrl of Object.values(rowCtrlsMap)){
            if (!rowCtrl) continue;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                continue;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                const instanceId = rowCtrl.instanceId;
                this.zombieRowCtrls[instanceId] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[instanceId];
                });
            } else rowCtrl.destroySecondPass();
        }
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            window.setTimeout(()=>executeInAWhileFuncs.forEach((func)=>func()), $437b23f6a393c3bf$var$ROW_ANIMATION_TIMEOUT);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        const { rowContainerHeight: rowContainerHeight, pageBounds: pageBounds, rowModel: rowModel } = this;
        rowContainerHeight.updateOffset();
        let newFirst;
        let newLast;
        if (!rowModel.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.beans.environment.refreshRowHeightVariable();
            newFirst = pageBounds.getFirstRow();
            newLast = pageBounds.getLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const scrollFeature = this.ctrlsSvc.getScrollFeature();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = pageBounds.getPixelOffset();
                const { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel } = pageBounds.getCurrentPagePixelRange();
                const divStretchOffset = rowContainerHeight.divStretchOffset;
                const bodyVRange = scrollFeature.getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = rowModel.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = rowModel.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = pageBounds.getFirstRow();
            const pageLastRow = pageBounds.getLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            this.eventSvc.dispatchEvent({
                type: "viewportChanged",
                firstRow: newFirst,
                lastRow: newLast
            });
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        $437b23f6a393c3bf$export$7b1f5bd01973c897(this.beans, ()=>{
            this.beans.eventSvc.dispatchEvent({
                type: "firstDataRendered",
                firstRow: this.firstRenderedRow,
                lastRow: this.lastRenderedRow
            });
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const pinnedRowHeightsChanged = this.pinnedRowModel?.ensureRowHeightsValid();
        const stickyHeightsChanged = this.stickyRowFeature?.ensureRowHeightsValid();
        const { pageBounds: pageBounds, rowModel: rowModel } = this;
        const rowModelHeightsChanged = rowModel.ensureRowHeightsValid(topPixel, bottomPixel, pageBounds.getFirstRow(), pageBounds.getLastRow());
        if (rowModelHeightsChanged || stickyHeightsChanged) this.eventSvc.dispatchEvent({
            type: "recalculateRowBounds"
        });
        if (stickyHeightsChanged || rowModelHeightsChanged || pinnedRowHeightsChanged) {
            this.updateContainerHeights();
            return true;
        }
        return false;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowCtrl) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowCtrl.rowNode;
        const rowHasFocus = this.focusSvc.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
        const rowIsEditing = rowCtrl.editing;
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        return this.beans.pagination?.isRowInPage(rowNode.rowIndex) ?? true;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls?.getRow(rowNode) ?? null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const useAnimationFrameForCreate = afterScroll && !this.printLayout && !!this.beans.animationFrameSvc?.active;
        const res = new $437b23f6a393c3bf$var$RowCtrl(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const viewportRows = Object.values(this.rowCtrlsByRowIndex).map((rowCtrl)=>rowCtrl.rowNode);
        const stickyTopRows = this.getStickyTopRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        const stickyBottomRows = this.getStickyBottomRowCtrls().map((rowCtrl)=>rowCtrl.rowNode);
        return [
            ...stickyTopRows,
            ...viewportRows,
            ...stickyBottomRows
        ];
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex: rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.rowNode.rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
var $437b23f6a393c3bf$var$RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.rowNode.id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode == null || rowNode.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.rowNode != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.rowNode.id;
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$export$83a881c8b5120679(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
function $437b23f6a393c3bf$var$mapRowNodes(rowNodes) {
    if (!rowNodes) return;
    const res = {
        top: {},
        bottom: {},
        normal: {}
    };
    rowNodes.forEach((rowNode)=>{
        const id = rowNode.id;
        switch(rowNode.rowPinned){
            case "top":
                res.top[id] = rowNode;
                break;
            case "bottom":
                res.bottom[id] = rowNode;
                break;
            default:
                res.normal[id] = rowNode;
                break;
        }
    });
    return res;
}
function $437b23f6a393c3bf$var$isRowInMap(rowNode, rowIdsMap) {
    const id = rowNode.id;
    const floating = rowNode.rowPinned;
    switch(floating){
        case "top":
            return rowIdsMap.top[id] != null;
        case "bottom":
            return rowIdsMap.bottom[id] != null;
        default:
            return rowIdsMap.normal[id] != null;
    }
}
// packages/ag-grid-community/src/sort/rowNodeSorter.ts
var $437b23f6a393c3bf$var$RowNodeSorter = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeSorter";
    }
    postConstruct() {
        const { gos: gos } = this;
        this.isAccentedSort = gos.get("accentedSort");
        this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos);
        this.addManagedPropertyListener("accentedSort", (propChange)=>this.isAccentedSort = propChange.currentValue);
        this.addManagedPropertyListener("autoGroupColumnDef", ()=>this.primaryColumnsSortGroups = $437b23f6a393c3bf$export$96c51c2547b81aed(gos));
    }
    doFullSort(rowNodes, sortOptions) {
        const sortedRowNodes = rowNodes.map((rowNode, currentPos)=>({
                currentPos: currentPos,
                rowNode: rowNode
            }));
        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
        return sortedRowNodes.map((item)=>item.rowNode);
    }
    compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
        const nodeA = sortedNodeA.rowNode;
        const nodeB = sortedNodeB.rowNode;
        for(let i = 0, len = sortOptions.length; i < len; i++){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            const valueA = this.getValue(nodeA, sortOption.column);
            const valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else comparatorResult = $437b23f6a393c3bf$export$b0cca9f3c87c8df8(valueA, valueB, this.isAccentedSort);
            const validResult = !isNaN(comparatorResult);
            if (validResult && comparatorResult !== 0) return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
    getComparator(sortOption, rowNode) {
        const column = sortOption.column;
        const comparatorOnCol = column.getColDef().comparator;
        if (comparatorOnCol != null) return comparatorOnCol;
        if (!column.getColDef().showRowGroup) return;
        const groupLeafField = !rowNode.group && column.getColDef().field;
        if (!groupLeafField) return;
        const primaryColumn = this.beans.colModel.getColDefCol(groupLeafField);
        if (!primaryColumn) return;
        return primaryColumn.getColDef().comparator;
    }
    getValue(node, column) {
        const { valueSvc: valueSvc, colModel: colModel, showRowGroupCols: showRowGroupCols, gos: gos } = this.beans;
        if (!this.primaryColumnsSortGroups) return valueSvc.getValue(column, node, false);
        const isNodeGroupedAtLevel = node.rowGroupColumn === column;
        if (isNodeGroupedAtLevel) {
            const isGroupRows = $437b23f6a393c3bf$export$b911c5b172d227b4(gos, colModel.isPivotActive());
            if (isGroupRows) {
                const leafChild = node.allLeafChildren?.[0];
                if (leafChild) return valueSvc.getValue(column, leafChild, false);
                return void 0;
            }
            const displayCol = showRowGroupCols?.getShowRowGroupCol(column.getId());
            if (!displayCol) return void 0;
            return node.groupData?.[displayCol.getId()];
        }
        if (node.group && column.getColDef().showRowGroup) return void 0;
        return valueSvc.getValue(column, node, false);
    }
};
// packages/ag-grid-community/src/sort/sortApi.ts
function $437b23f6a393c3bf$var$onSortChanged(beans) {
    beans.sortSvc?.onSortChanged("api");
}
// packages/ag-grid-community/src/sort/sortModule.ts
var $437b23f6a393c3bf$export$1a6625c5691649e8 = {
    moduleName: "Sort",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SortService,
        $437b23f6a393c3bf$var$RowNodeSorter
    ],
    apiFunctions: {
        onSortChanged: $437b23f6a393c3bf$var$onSortChanged
    },
    userComponents: {
        agSortIndicator: $437b23f6a393c3bf$var$SortIndicatorComp
    },
    icons: {
        // show on column header when column is sorted ascending
        sortAscending: "asc",
        // show on column header when column is sorted descending
        sortDescending: "desc",
        // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
        sortUnSort: "none"
    }
};
// packages/ag-grid-community/src/syncService.ts
var $437b23f6a393c3bf$var$SyncService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "syncSvc";
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.beans.ctrlsSvc.whenReady(this, ()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        const { colModel: colModel, rowModel: rowModel } = this.beans;
        colModel.setColumnDefs(columnDefs ?? [], "gridInitializing");
        rowModel.start();
    }
    gridReady() {
        const { eventSvc: eventSvc, gos: gos } = this;
        eventSvc.dispatchEvent({
            type: "gridReady"
        });
        $437b23f6a393c3bf$var$_logIfDebug(gos, `initialised successfully, enterprise = ${gos.isModuleRegistered("EnterpriseCore")}`);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.beans.colModel.setColumnDefs(columnDefs, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
    }
};
// packages/ag-grid-community/src/valueService/cellApi.ts
function $437b23f6a393c3bf$var$expireValueCache(beans) {
    beans.valueCache?.expire();
}
function $437b23f6a393c3bf$var$getCellValue(beans, params) {
    const { colKey: colKey, rowNode: rowNode, useFormatter: useFormatter } = params;
    const column = beans.colModel.getColDefCol(colKey) ?? beans.colModel.getCol(colKey);
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(column)) return null;
    const value = beans.valueSvc.getValueForDisplay(column, rowNode).value;
    if (useFormatter) {
        const formattedValue = beans.valueSvc.formatValue(column, rowNode, value);
        return formattedValue ?? $437b23f6a393c3bf$export$a16cfb6652fe466f(value);
    }
    return value;
}
// packages/ag-grid-community/src/valueService/changeDetectionService.ts
var $437b23f6a393c3bf$var$SOURCE_PASTE = "paste";
var $437b23f6a393c3bf$var$ChangeDetectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "changeDetectionSvc";
        this.clientSideRowModel = null;
    }
    postConstruct() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) this.clientSideRowModel = rowModel;
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this)
        });
    }
    onCellValueChanged(event) {
        const { gos: gos, rowRenderer: rowRenderer } = this.beans;
        if (event.source === $437b23f6a393c3bf$var$SOURCE_PASTE || gos.get("suppressChangeDetection")) return;
        const rowNode = event.node;
        const nodesToRefresh = [
            rowNode
        ];
        const clientSideRowModel = this.clientSideRowModel;
        const rootNode = clientSideRowModel?.rootNode;
        if (rootNode && !rowNode.isRowPinned()) {
            const onlyChangedColumns = gos.get("aggregateOnlyChangedColumns");
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(onlyChangedColumns, rootNode);
            changedPath.addParentNode(rowNode.parent, [
                event.column
            ]);
            clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
                if (rowNode2.sibling) nodesToRefresh.push(rowNode2.sibling);
            });
        }
        rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
// packages/ag-grid-community/src/valueService/expressionService.ts
var $437b23f6a393c3bf$var$ExpressionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "expressionSvc";
        this.cache = {};
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else $437b23f6a393c3bf$export$a20c7248650823a9(15, {
            expression: expression
        });
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            $437b23f6a393c3bf$export$a20c7248650823a9(16, {
                expression: expression,
                params: params,
                e: e
            });
            return null;
        }
    }
    createExpressionFunction(expression) {
        const expressionToFunctionCache = this.cache;
        if (expressionToFunctionCache[expression]) return expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup", functionBody);
        expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.indexOf("return") >= 0) return expression;
        else return "return " + expression + ";";
    }
};
// packages/ag-grid-community/src/valueService/valueCache.ts
var $437b23f6a393c3bf$var$ValueCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueCache";
        this.cacheVersion = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("valueCache");
        this.neverExpires = gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            const cacheVersion = this.cacheVersion;
            if (rowNode.__cacheVersion !== cacheVersion) {
                rowNode.__cacheVersion = cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
// packages/ag-grid-community/src/valueService/valueModule.ts
var $437b23f6a393c3bf$export$3110fedd6be63d8e = {
    moduleName: "ValueCache",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValueCache
    ],
    apiFunctions: {
        expireValueCache: $437b23f6a393c3bf$var$expireValueCache
    }
};
var $437b23f6a393c3bf$var$ExpressionModule = {
    moduleName: "Expression",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ExpressionService
    ]
};
var $437b23f6a393c3bf$var$ChangeDetectionModule = {
    moduleName: "ChangeDetection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ChangeDetectionService
    ]
};
var $437b23f6a393c3bf$export$d7a9d7f5c41fb970 = {
    moduleName: "CellApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getCellValue: $437b23f6a393c3bf$var$getCellValue
    }
};
// packages/ag-grid-community/src/valueService/valueService.ts
var $437b23f6a393c3bf$var$ValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "valueSvc";
        this.initialised = false;
        this.isSsrm = false;
    }
    wireBeans(beans) {
        this.expressionSvc = beans.expressionSvc;
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.dataTypeSvc = beans.dataTypeSvc;
    }
    postConstruct() {
        if (!this.initialised) this.init();
    }
    init() {
        this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this);
        this.isSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos);
        this.cellExpressions = this.gos.get("enableCellExpressions");
        this.isTreeData = this.gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        this.eventSvc.addEventListener("cellValueChanged", listener, true);
        this.addDestroyFunc(()=>this.eventSvc.removeEventListener("cellValueChanged", listener, true));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    /**
   * Use this function to get a displayable cell value.
   * The values from this function are not used for sorting, filtering, or aggregation purposes.
   * Handles: groupHideOpenParents, showOpenedGroup and groupSuppressBlankHeader behaviours
   */ getValueForDisplay(column, node, includeValueFormatted = false, exporting = false) {
        const { showRowGroupColValueSvc: showRowGroupColValueSvc } = this.beans;
        const isFullWidthGroup = !column && node.group;
        const isGroupCol = column?.colDef.showRowGroup;
        const processTreeDataAsGroup = !this.isTreeData || node.footer;
        if (showRowGroupColValueSvc && processTreeDataAsGroup && (isFullWidthGroup || isGroupCol)) {
            const groupValue = showRowGroupColValueSvc.getGroupValue(node, column);
            if (groupValue == null) return {
                value: null,
                valueFormatted: null
            };
            if (!includeValueFormatted) return {
                value: groupValue.value,
                valueFormatted: null
            };
            const valueFormatted = showRowGroupColValueSvc.formatAndPrefixGroupColValue(groupValue, column, exporting);
            return {
                value: groupValue.value,
                valueFormatted: valueFormatted
            };
        }
        if (!column) return {
            value: node.key,
            valueFormatted: null
        };
        const isPivotLeaf = node.leafGroup && this.colModel.isPivotMode();
        const isOpenedGroup = node.group && node.expanded && !node.footer && !isPivotLeaf;
        const groupShowsAggData = this.gos.get("groupSuppressBlankHeader") || !node.sibling;
        const ignoreAggData = isOpenedGroup && !groupShowsAggData;
        const value = this.getValue(column, node, ignoreAggData);
        const format = includeValueFormatted && !(exporting && column.colDef.useValueFormatterForExport === false);
        return {
            value: value,
            valueFormatted: format ? this.formatValue(column, node, value) : null
        };
    }
    getValue(column, rowNode, ignoreAggData = false) {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        const colDef = column.getColDef();
        const field = colDef.field;
        const colId = column.getColId();
        const data = rowNode.data;
        let result;
        const rowGroupColId = colDef.showRowGroup;
        if (typeof rowGroupColId === "string") {
            const colRowGroupIndex = this.beans.rowGroupColsSvc?.getColumnIndex(rowGroupColId) ?? -1;
            if (colRowGroupIndex > rowNode.level) return null;
        }
        const allowUserValuesForCell = typeof rowGroupColId !== "string" || !rowNode.group;
        const groupDataExists = rowNode.groupData && colId in rowNode.groupData;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!column.getColDef().aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (column.getColDef().showRowGroup === true || column.getColDef().showRowGroup === rowNode.field);
        if (this.isTreeData && aggDataExists) result = rowNode.aggData[colId];
        else if (this.isTreeData && colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (this.isTreeData && field && data) result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        else if (groupDataExists) result = rowNode.groupData[colId];
        else if (aggDataExists) result = rowNode.aggData[colId];
        else if (colDef.valueGetter) {
            if (!allowUserValuesForCell) return result;
            result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        } else if (ssrmFooterGroupCol) result = $437b23f6a393c3bf$var$_getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        else if (field && data && !ignoreSsrmAggData) {
            if (!allowUserValuesForCell) return result;
            result = $437b23f6a393c3bf$var$_getValueUsingField(data, field, column.isFieldContainsDots());
        }
        if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        return result;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        const valueParser = colDef.valueParser;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueParser)) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: rowNode,
                data: rowNode?.data,
                oldValue: oldValue,
                newValue: newValue,
                colDef: colDef,
                column: column
            });
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionSvc?.evaluate(valueParser, params);
        }
        return newValue;
    }
    getDeleteValue(column, rowNode) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(column.getColDef().valueParser)) return this.parseValue(column, rowNode, "", this.getValueForDisplay(column, rowNode).value) ?? null;
        return null;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: node ? node.data : null,
                colDef: colDef,
                column: column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = this.expressionSvc ? this.expressionSvc.evaluate(formatter, params) : null;
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.colModel.getColDefCol(colKey);
        if (!rowNode || !column) return false;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.data)) rowNode.data = {};
        const { field: field, valueSetter: valueSetter } = column.getColDef();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(field) && $437b23f6a393c3bf$export$672d9e47bc342bac(valueSetter)) {
            $437b23f6a393c3bf$export$545083624300f13d(17);
            return false;
        }
        if (this.dataTypeSvc && !this.dataTypeSvc.checkType(column, newValue)) {
            $437b23f6a393c3bf$export$545083624300f13d(135);
            return false;
        }
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode),
            newValue: newValue,
            colDef: column.getColDef(),
            column: column
        });
        params.newValue = newValue;
        let valueWasDifferent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueSetter)) {
            if (typeof valueSetter === "function") valueWasDifferent = valueSetter(params);
            else valueWasDifferent = this.expressionSvc?.evaluate(valueSetter, params);
        } else valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        rowNode.resetQuickFilterAggregateText();
        this.valueCache?.onDataChanged();
        const savedValue = this.getValue(column, rowNode);
        this.eventSvc.dispatchEvent({
            type: "cellValueChanged",
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            colDef: params.colDef,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: savedValue,
            value: savedValue,
            source: eventSource
        });
        return true;
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.beans.frameworkOverrides.wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeValueGetterWithValueCache(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const result = this.executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    executeValueGetterWithoutValueCache(valueGetter, data, column, rowNode) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionSvc?.evaluate(valueGetter, params);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.colModel.getColDefCol(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") $437b23f6a393c3bf$export$545083624300f13d(121);
        return result;
    }
};
// packages/ag-grid-community/src/gridCoreModule.ts
var $437b23f6a393c3bf$var$CommunityCoreModule = {
    moduleName: "CommunityCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridDestroyService,
        $437b23f6a393c3bf$var$ApiFunctionService,
        $437b23f6a393c3bf$var$Registry,
        $437b23f6a393c3bf$var$UserComponentFactory,
        $437b23f6a393c3bf$var$RowContainerHeightService,
        $437b23f6a393c3bf$var$VisibleColsService,
        $437b23f6a393c3bf$var$EventService,
        $437b23f6a393c3bf$var$GridOptionsService,
        $437b23f6a393c3bf$var$ColumnModel,
        $437b23f6a393c3bf$var$PageBoundsService,
        $437b23f6a393c3bf$var$PageBoundsListener,
        $437b23f6a393c3bf$var$RowRenderer,
        $437b23f6a393c3bf$var$ValueService,
        $437b23f6a393c3bf$var$FocusService,
        $437b23f6a393c3bf$var$Environment,
        $437b23f6a393c3bf$var$ScrollVisibleService,
        $437b23f6a393c3bf$var$CtrlsService,
        $437b23f6a393c3bf$var$SyncService,
        $437b23f6a393c3bf$var$ColumnNameService,
        $437b23f6a393c3bf$var$ColumnViewportService
    ],
    icons: {
        // icon on select dropdowns (select cell editor, charts tool panels)
        selectOpen: "small-down",
        /** @deprecated v33 */ smallDown: "small-down",
        /** @deprecated v33 */ colorPicker: "color-picker",
        /** @deprecated v33 */ smallUp: "small-up",
        /** @deprecated v33 */ checkboxChecked: "small-up",
        /** @deprecated v33 */ checkboxIndeterminate: "checkbox-indeterminate",
        /** @deprecated v33 */ checkboxUnchecked: "checkbox-unchecked",
        /** @deprecated v33 */ radioButtonOn: "radio-button-on",
        /** @deprecated v33 */ radioButtonOff: "radio-button-off",
        /** @deprecated v33 */ smallLeft: "small-left",
        /** @deprecated v33 */ smallRight: "small-right"
    },
    apiFunctions: {
        getGridId: $437b23f6a393c3bf$var$getGridId,
        destroy: $437b23f6a393c3bf$var$destroy,
        isDestroyed: $437b23f6a393c3bf$var$isDestroyed,
        getGridOption: $437b23f6a393c3bf$var$getGridOption,
        setGridOption: $437b23f6a393c3bf$var$setGridOption,
        updateGridOptions: $437b23f6a393c3bf$var$updateGridOptions,
        isModuleRegistered: $437b23f6a393c3bf$var$isModuleRegistered
    },
    dependsOn: [
        $437b23f6a393c3bf$var$DataTypeModule,
        $437b23f6a393c3bf$export$1458fbffed29c925,
        $437b23f6a393c3bf$var$ColumnResizeModule,
        $437b23f6a393c3bf$export$1a6625c5691649e8,
        $437b23f6a393c3bf$var$ColumnHeaderCompModule,
        $437b23f6a393c3bf$export$922da35340a6d14e,
        $437b23f6a393c3bf$var$ColumnGroupHeaderCompModule,
        $437b23f6a393c3bf$var$OverlayModule,
        $437b23f6a393c3bf$var$ChangeDetectionModule,
        $437b23f6a393c3bf$var$AnimationFrameModule,
        $437b23f6a393c3bf$export$44f04c51d8088336,
        $437b23f6a393c3bf$var$PinnedColumnModule,
        $437b23f6a393c3bf$var$AriaModule,
        $437b23f6a393c3bf$var$TouchModule,
        $437b23f6a393c3bf$var$CellRendererFunctionModule,
        $437b23f6a393c3bf$var$ColumnFlexModule,
        $437b23f6a393c3bf$var$ExpressionModule
    ]
};
// packages/ag-grid-community/src/utils/fuzzyMatch.ts
function $437b23f6a393c3bf$export$85cab1b5a4aa292c(params) {
    const { inputValue: inputValue, allSuggestions: allSuggestions, hideIrrelevant: hideIrrelevant, filterByPercentageOfBestMatch: filterByPercentageOfBestMatch } = params;
    let thisSuggestions = allSuggestions.map((text, idx)=>({
            value: text,
            relevance: $437b23f6a393c3bf$var$hybridFuzzySearch(inputValue, text),
            idx: idx
        }));
    thisSuggestions.sort((a, b)=>b.relevance - a.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance !== 0);
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values,
        indices: indices
    };
}
function $437b23f6a393c3bf$var$hybridFuzzySearch(str1, str2) {
    if (str1 === str2) return 1e3;
    const len1 = str1.length;
    const len2 = str2.length;
    if (len1 === 0 || len2 === 0) return 0;
    const str1Lower = str1.toLocaleLowerCase();
    const str2Lower = str2.toLocaleLowerCase();
    const str2PositionInStr1 = str2Lower.indexOf(str1Lower);
    if (str2PositionInStr1 !== -1) return 980 - str2PositionInStr1 * 2;
    const commonChars = [
        ...str1Lower
    ].filter((char)=>str2Lower.includes(char));
    if (commonChars.length === 0) return 0;
    let previousRow = Array.from({
        length: len2 + 1
    }, (_, i)=>i);
    for(let i = 0; i < len1; i++){
        const currentRow = [
            i + 1
        ];
        for(let j = 0; j < len2; j++){
            const insertions = previousRow[j + 1] + 1;
            const deletions = currentRow[j] + 1;
            let substitutions = previousRow[j] + (str1[i] !== str2[j] ? 1 : 0);
            if (len2 > 10 && j > len2 / 2) substitutions += 1;
            if (i > 0 && j > 0 && str1[i - 1] === str2[j - 1]) substitutions -= 4;
            currentRow.push(Math.min(insertions, deletions, substitutions));
        }
        previousRow = currentRow;
    }
    const distance = Math.round(previousRow[len2]);
    const score = Math.max(1, 1e3 - distance * 30);
    return Math.max(1, score);
}
// packages/ag-grid-community/src/validation/enterpriseModuleNames.ts
var $437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES = {
    AdvancedFilter: 1,
    AllEnterprise: 1,
    CellSelection: 1,
    Clipboard: 1,
    ColumnMenu: 1,
    ColumnsToolPanel: 1,
    ContextMenu: 1,
    ExcelExport: 1,
    FiltersToolPanel: 1,
    Find: 1,
    GridCharts: 1,
    IntegratedCharts: 1,
    GroupFilter: 1,
    MasterDetail: 1,
    Menu: 1,
    MultiFilter: 1,
    Pivot: 1,
    RangeSelection: 1,
    RichSelect: 1,
    RowNumbers: 1,
    RowGrouping: 1,
    RowGroupingPanel: 1,
    ServerSideRowModelApi: 1,
    ServerSideRowModel: 1,
    SetFilter: 1,
    SideBar: 1,
    Sparklines: 1,
    StatusBar: 1,
    TreeData: 1,
    ViewportRowModel: 1
};
// packages/ag-grid-community/src/validation/resolvableModuleNames.ts
var $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS = [
    "TextFilter",
    "NumberFilter",
    "DateFilter",
    "SetFilter",
    "MultiFilter",
    "GroupFilter",
    "CustomFilter"
];
var $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES = {
    EditCore: [
        "TextEditor",
        "NumberEditor",
        "DateEditor",
        "CheckboxEditor",
        "LargeTextEditor",
        "SelectEditor",
        "RichSelect",
        "CustomEditor"
    ],
    CheckboxCellRenderer: [
        "AllCommunity"
    ],
    ClientSideRowModelHierarchy: [
        "RowGrouping",
        "Pivot",
        "TreeData"
    ],
    ColumnFilter: $437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
    ColumnGroupHeaderComp: [
        "AllCommunity"
    ],
    ColumnGroup: [
        "AllCommunity"
    ],
    ColumnHeaderComp: [
        "AllCommunity"
    ],
    ColumnMove: [
        "AllCommunity"
    ],
    ColumnResize: [
        "AllCommunity"
    ],
    CommunityCore: [
        "AllCommunity"
    ],
    CsrmSsrmSharedApi: [
        "ClientSideRowModelApi",
        "ServerSideRowModelApi"
    ],
    EnterpriseCore: [
        "AllEnterprise"
    ],
    FilterCore: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "QuickFilter",
        "ExternalFilter",
        "AdvancedFilter"
    ],
    GroupCellRenderer: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "MasterDetail",
        "ServerSideRowModel"
    ],
    KeyboardNavigation: [
        "AllCommunity"
    ],
    LoadingCellRenderer: [
        "ServerSideRowModel"
    ],
    MenuCore: [
        "ColumnMenu",
        "ContextMenu"
    ],
    MenuItem: [
        "ColumnMenu",
        "ContextMenu",
        "MultiFilter",
        "IntegratedCharts",
        "ColumnsToolPanel"
    ],
    Overlay: [
        "AllCommunity"
    ],
    PinnedColumn: [
        "AllCommunity"
    ],
    SharedAggregation: [
        "RowGrouping",
        "Pivot",
        "TreeData",
        "ServerSideRowModel"
    ],
    SharedDragAndDrop: [
        "AllCommunity"
    ],
    SharedMasterDetail: [
        "MasterDetail",
        "ServerSideRowModel"
    ],
    SharedMenu: [
        ...$437b23f6a393c3bf$var$ALL_COLUMN_FILTERS,
        "ColumnMenu",
        "ContextMenu"
    ],
    SharedPivot: [
        "Pivot",
        "ServerSideRowModel"
    ],
    SharedRowGrouping: [
        "RowGrouping",
        "ServerSideRowModel"
    ],
    SharedRowSelection: [
        "RowSelection",
        "ServerSideRowModel"
    ],
    SkeletonCellRenderer: [
        "ServerSideRowModel"
    ],
    Sort: [
        "AllCommunity"
    ],
    SsrmInfiniteSharedApi: [
        "InfiniteRowModel",
        "ServerSideRowModelApi"
    ],
    SharedTreeData: [
        "TreeData",
        "ServerSideRowModel"
    ]
};
var $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS = {
    InfiniteRowModel: "infinite",
    ClientSideRowModelApi: "clientSide",
    ClientSideRowModel: "clientSide",
    ServerSideRowModelApi: "serverSide",
    ServerSideRowModel: "serverSide",
    ViewportRowModel: "viewport"
};
function $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType) {
    const resolvedModuleNames = [];
    (Array.isArray(moduleName) ? moduleName : [
        moduleName
    ]).forEach((modName)=>{
        const resolved = $437b23f6a393c3bf$var$RESOLVABLE_MODULE_NAMES[modName];
        if (resolved) resolved.forEach((resolvedModName)=>{
            const rowModelForModule = $437b23f6a393c3bf$var$MODULES_FOR_ROW_MODELS[resolvedModName];
            if (!rowModelForModule || rowModelForModule === rowModelType) resolvedModuleNames.push(resolvedModName);
        });
        else resolvedModuleNames.push(modName);
    });
    return resolvedModuleNames;
}
// packages/ag-grid-community/src/validation/errorMessages/errorText.ts
var $437b23f6a393c3bf$var$NoModulesRegisteredError = ()=>`No AG Grid modules are registered! It is recommended to start with all Community features via the AllCommunityModule:
                    
    import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
    
    ModuleRegistry.registerModules([ AllCommunityModule ]);
    `;
var $437b23f6a393c3bf$var$moduleImportMsg = (moduleNames)=>{
    const imports = moduleNames.map((moduleName)=>`import { ${$437b23f6a393c3bf$var$convertToUserModuleName(moduleName)} } from '${$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[moduleName] ? "ag-grid-enterprise" : "ag-grid-community"}';`);
    const includeCharts = moduleNames.some((m)=>m === "IntegratedCharts" || m === "Sparklines");
    if (includeCharts) {
        const chartImport = `import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';`;
        imports.push(chartImport);
    }
    return `import { ModuleRegistry } from 'ag-grid-community'; 
${imports.join(" \n")} 

ModuleRegistry.registerModules([ ${moduleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m, true)).join(", ")} ]); 

For more info see: ${$437b23f6a393c3bf$var$baseDocLink}/modules/`;
};
function $437b23f6a393c3bf$var$convertToUserModuleName(moduleName, inModuleRegistration = false) {
    if (inModuleRegistration && (moduleName === "IntegratedCharts" || moduleName === "Sparklines")) return `${moduleName}Module.with(AgChartsEnterpriseModule)`;
    return `${moduleName}Module`;
}
function $437b23f6a393c3bf$var$umdMissingModule(reasonOrId, moduleNames) {
    const chartModules = moduleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    let message = "";
    const agChartsDynamic = globalThis?.agCharts;
    if (!agChartsDynamic && chartModules.length > 0) message = `Unable to use ${reasonOrId} as either the ag-charts-community or ag-charts-enterprise script needs to be included alongside ag-grid-enterprise.
`;
    else if (moduleNames.some((m)=>$437b23f6a393c3bf$var$ENTERPRISE_MODULE_NAMES[m])) message = message + `Unable to use ${reasonOrId} as that requires the ag-grid-enterprise script to be included.
`;
    return message;
}
function $437b23f6a393c3bf$var$missingRowModelTypeError({ moduleName: moduleName, rowModelType: rowModelType }) {
    return `To use the ${moduleName}Module you must set the gridOption "rowModelType='${rowModelType}'"`;
}
var $437b23f6a393c3bf$var$missingModule = ({ reasonOrId: reasonOrId, moduleName: moduleName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType, additionalText: additionalText, isUmd: isUmd2 })=>{
    const resolvedModuleNames = $437b23f6a393c3bf$var$resolveModuleNames(moduleName, rowModelType);
    const reason = typeof reasonOrId === "string" ? reasonOrId : $437b23f6a393c3bf$var$MISSING_MODULE_REASONS[reasonOrId];
    if (isUmd2) return $437b23f6a393c3bf$var$umdMissingModule(reason, resolvedModuleNames);
    const chartModules = resolvedModuleNames.filter((m)=>m === "IntegratedCharts" || m === "Sparklines");
    const chartImportRequired = chartModules.length > 0 ? `${chartModules.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join()} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.` : "";
    const explanation = `Unable to use ${reason} as ${resolvedModuleNames.length > 1 ? "one of " + resolvedModuleNames.map((m)=>$437b23f6a393c3bf$var$convertToUserModuleName(m)).join(", ") : $437b23f6a393c3bf$var$convertToUserModuleName(resolvedModuleNames[0])} is not registered${gridScoped ? " for gridId: " + gridId : ""}. ${chartImportRequired} Check if you have registered the module:
`;
    return `${explanation}
${$437b23f6a393c3bf$var$moduleImportMsg(resolvedModuleNames)}` + (additionalText ? ` 

${additionalText}` : "");
};
var $437b23f6a393c3bf$var$missingChartsWithModule = (gridModule)=>{
    return `${gridModule} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${gridModule} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${gridModule}.with(AgChartsEnterpriseModule)]);
    `;
};
var $437b23f6a393c3bf$var$clipboardApiError = (method)=>`AG Grid: Unable to use the Clipboard API (navigator.clipboard.${method}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`;
var $437b23f6a393c3bf$var$AG_GRID_ERRORS = {
    1: ()=>"`rowData` must be an array",
    2: ({ nodeId: nodeId })=>`Duplicate node id '${nodeId}' detected from getRowId callback, this could cause issues in your grid.`,
    3: ()=>"Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
    4: ({ id: id })=>`Could not find row id=${id}, data item was not found for this id`,
    5: ({ data: data })=>[
            `Could not find data item as object was not found.`,
            data,
            " Consider using getRowId to help the Grid find matching row data"
        ],
    6: ()=>`'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'`,
    7: ()=>"Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
    8: ({ key: key })=>`Unknown key for navigation ${key}`,
    9: ({ variable: variable })=>`No value for ${variable?.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${variable?.defaultValue} will be used and updated when styles load.`,
    10: ({ eventType: eventType })=>`As of v33, the '${eventType}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
    11: ()=>"No gridOptions provided to createGrid",
    12: ({ colKey: colKey })=>[
            "column ",
            colKey,
            " not found"
        ],
    13: ()=>"Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
    14: ({ groupPrefix: groupPrefix })=>`Row IDs cannot start with ${groupPrefix}, this is a reserved prefix for AG Grid's row grouping feature.`,
    15: ({ expression: expression })=>[
            "value should be either a string or a function",
            expression
        ],
    16: ({ expression: expression, params: params, e: e })=>[
            "Processing of the expression failed",
            "Expression = ",
            expression,
            "Params = ",
            params,
            "Exception = ",
            e
        ],
    17: ()=>"you need either field or valueSetter set on colDef for editing to work",
    18: ()=>`alignedGrids contains an undefined option.`,
    19: ()=>`alignedGrids - No api found on the linked grid.`,
    20: ()=>`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
    21: ()=>"pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
    22: ({ key: key })=>`${key} is an initial property and cannot be updated.`,
    23: ()=>"The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
    24: ()=>"row height must be a number if not using standard row model",
    25: ({ id: id })=>[
            `The getRowId callback must return a string. The ID `,
            id,
            ` is being cast to a string.`
        ],
    26: ({ fnName: fnName, preDestroyLink: preDestroyLink })=>{
        return `Grid API function ${fnName}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    },
    27: ({ fnName: fnName, module: module })=>`API function '${fnName}' not registered to module '${module}'`,
    28: ()=>"setRowCount cannot be used while using row grouping.",
    29: ()=>"tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
    30: ({ toIndex: toIndex })=>[
            "tried to insert columns in invalid location, toIndex = ",
            toIndex,
            "remember that you should not count the moving columns when calculating the new index"
        ],
    31: ()=>"infinite loop in resizeColumnSets",
    32: ()=>"applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
    33: ()=>"stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
    34: ({ key: key })=>`the column type '${key}' is a default column type and cannot be overridden.`,
    35: ()=>`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`,
    36: ({ t: t })=>"colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes",
    37: ()=>`Changing the column pinning status is not allowed with domLayout='print'`,
    38: ({ iconName: iconName })=>`provided icon '${iconName}' needs to be a string or a function`,
    39: ()=>"Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
    40: ({ e: e, method: method })=>`${e}
${$437b23f6a393c3bf$var$clipboardApiError(method)}`,
    41: ()=>"Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
    42: ()=>"Browser does not support document.execCommand('copy') for clipboard operations",
    43: ({ iconName: iconName })=>`As of v33, icon '${iconName}' is deprecated. Use the icon CSS name instead.`,
    44: ()=>'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
    45: ({ parentCellDataType: parentCellDataType })=>`The data type definition ${parentCellDataType} does not exist.`,
    46: ()=>'The "baseDataType" property of a data type definition must match that of its parent.',
    47: ({ cellDataType: cellDataType })=>`Missing data type definition - "${cellDataType}"`,
    48: ({ property: property })=>`Cell data type is "object" but no Value ${property} has been provided. Please either provide an object data type definition with a Value ${property}, or set "colDef.value${property}"`,
    49: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    50: ({ compName: compName })=>`Could not find component ${compName}, did you forget to configure this component?`,
    51: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    52: ()=>"There is no `window` associated with the current `document`",
    53: ()=>`unknown value type during csv conversion`,
    54: ()=>"Could not find document body, it is needed for drag and drop and context menu.",
    55: ()=>"addRowDropZone - A container target needs to be provided",
    56: ()=>"addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
    57: ()=>"unable to show popup filter, filter instantiation failed",
    58: ()=>"no values found for select cellEditor",
    59: ()=>"cannot select pinned rows",
    60: ()=>"cannot select node until it has finished loading",
    61: ()=>"since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
    62: ({ colId: colId })=>`setFilterModel() - no column found for colId: ${colId}`,
    63: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, filtering disabled for colId: ${colId}`,
    64: ({ colId: colId })=>`setFilterModel() - unable to fully apply model, unable to create filter for colId: ${colId}`,
    65: ()=>"filter missing setModel method, which is needed for setFilterModel",
    66: ()=>"filter API missing getModel method, which is needed for getFilterModel",
    67: ()=>"Filter is missing isFilterActive() method",
    68: ()=>"Column Filter API methods have been disabled as Advanced Filters are enabled.",
    69: ({ guiFromFilter: guiFromFilter })=>`getGui method from filter returned ${guiFromFilter}; it should be a DOM element.`,
    70: ({ newFilter: newFilter })=>`Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`,
    71: ()=>"debounceMs is ignored when apply button is present",
    72: ({ keys: keys })=>[
            `ignoring FilterOptionDef as it doesn't contain one of `,
            keys
        ],
    73: ()=>`invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`,
    74: ()=>"no filter options for filter",
    75: ()=>"Unknown button type specified",
    76: ({ filterModelType: filterModelType })=>[
            'Unexpected type of filter "',
            filterModelType,
            '", it looks like the filter was configured with incorrect Filter Options'
        ],
    77: ()=>`Filter model is missing 'conditions'`,
    78: ()=>'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
    79: ()=>'"filterParams.maxNumConditions" must be greater than or equal to zero.',
    80: ()=>'"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
    81: ()=>'"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
    82: ({ param: param })=>`DateFilter ${param} is not a number`,
    83: ()=>`DateFilter minValidYear should be <= maxValidYear`,
    84: ()=>`DateFilter minValidDate should be <= maxValidDate`,
    85: ()=>"DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
    86: ()=>"DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
    87: ()=>"DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
    88: ({ index: index })=>`Invalid row index for ensureIndexVisible: ${index}`,
    89: ()=>`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`,
    90: ()=>`datasource is missing getRows method`,
    91: ()=>"Filter is missing method doesFilterPass",
    92: ()=>`AnimationFrameService called but animation frames are off`,
    93: ()=>"cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
    94: ({ paginationPageSizeOption: paginationPageSizeOption, pageSizeSet: pageSizeSet, pageSizesSet: pageSizesSet, pageSizeOptions: pageSizeOptions })=>`'paginationPageSize=${paginationPageSizeOption}'${pageSizeSet ? "" : " (default value)"}, but ${paginationPageSizeOption} is not included in${pageSizesSet ? "" : " the default"} paginationPageSizeSelector=[${pageSizeOptions?.join(", ")}].`,
    95: ({ paginationPageSizeOption: paginationPageSizeOption, paginationPageSizeSelector: paginationPageSizeSelector2 })=>`Either set '${paginationPageSizeSelector2}' to an array that includes ${paginationPageSizeOption} or to 'false' to disable the page size selector.`,
    96: ({ id: id, data: data })=>[
            "Duplicate ID",
            id,
            "found for pinned row with data",
            data,
            "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
        ],
    97: ({ colId: colId })=>`cellEditor for column ${colId} is missing getGui() method`,
    98: ()=>"popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
    99: ()=>"Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
    100: ({ rowModelType: rowModelType })=>`selectAll only available when rowModelType='clientSide', ie not ${rowModelType}`,
    101: ({ propertyName: propertyName, componentName: componentName, agGridDefaults: agGridDefaults, jsComps: jsComps })=>{
        const textOutput = [];
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(agGridDefaults ?? []).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(jsComps ?? [])
        ];
        const suggestions = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: componentName,
            allSuggestions: validComponents,
            hideIrrelevant: true,
            filterByPercentageOfBestMatch: 0.8
        }).values;
        textOutput.push(`Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.
`);
        if (suggestions.length > 0) textOutput.push(`         Did you mean: [${suggestions.slice(0, 3)}]?
`);
        textOutput.push(`If using a custom component check it has been registered correctly.`);
        return textOutput;
    },
    102: ()=>"selectAll: 'filtered' only works when gridOptions.rowModelType='clientSide'",
    103: ()=>"Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
    104: ({ value: value, param: param })=>`Numeric value ${value} passed to ${param} param will be interpreted as ${value} seconds. If this is intentional use "${value}s" to silence this warning.`,
    105: ({ e: e })=>[
            `chart rendering failed`,
            e
        ],
    106: ()=>`Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${$437b23f6a393c3bf$var$baseDocLink}/theming-migration/`,
    107: ({ key: key, value: value })=>`Invalid value for theme param ${key} - ${value}`,
    108: ({ e: e })=>[
            "chart update failed",
            e
        ],
    109: ({ aggFuncOrString: aggFuncOrString })=>`unrecognised aggregation function ${aggFuncOrString}`,
    110: ()=>"groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
    111: ()=>"Invalid selection state. When `groupSelects` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
    113: ()=>"Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
    114: ({ component: component })=>`Could not find component with name of ${component}. Is it in Vue.components?`,
    // 115: () => 'The provided selection state should be an object.' as const,
    116: ()=>"Invalid selection state. The state must conform to `IServerSideSelectionState`.",
    117: ()=>"selectAll must be of boolean type.",
    118: ()=>"Infinite scrolling must be enabled in order to set the row count.",
    119: ()=>"Unable to instantiate filter",
    120: ()=>"MultiFloatingFilterComp expects MultiFilter as its parent",
    121: ()=>"a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
    122: ()=>"could not find the document, document is empty",
    123: ()=>"Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
    124: ()=>"No active charts to update.",
    125: ({ chartId: chartId })=>`Unable to update chart. No active chart found with ID: ${chartId}.`,
    126: ()=>"unable to restore chart as no chart model is provided",
    127: ({ allRange: allRange })=>`unable to create chart as ${allRange ? "there are no columns in the grid" : "no range is selected"}.`,
    128: ({ feature: feature })=>`${feature} is only available if using 'multiRow' selection mode.`,
    129: ({ feature: feature, rowModel: rowModel })=>`${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModel}.`,
    130: ()=>'cannot multi select unless selection mode is "multiRow"',
    // 131: () => 'cannot range select while selecting multiple rows' as const,
    132: ()=>"Row selection features are not available unless `rowSelection` is enabled.",
    133: ({ iconName: iconName })=>`icon '${iconName}' function should return back a string or a dom object`,
    134: ({ iconName: iconName })=>`Did not find icon '${iconName}'`,
    135: ()=>`Data type of the new value does not match the cell data type of the column`,
    136: ()=>`Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`,
    137: ({ type: type, currentChartType: currentChartType })=>`Unable to update chart as a '${type}' update type is not permitted on a ${currentChartType}.`,
    138: ({ chartType: chartType })=>`invalid chart type supplied: ${chartType}`,
    139: ({ customThemeName: customThemeName })=>`a custom chart theme with the name ${customThemeName} has been supplied but not added to the 'chartThemes' list`,
    140: ({ name: name })=>`no stock theme exists with the name '${name}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
    141: ()=>"cross filtering with row grouping is not supported.",
    142: ()=>"cross filtering is only supported in the client side row model.",
    143: ({ panel: panel })=>`'${panel}' is not a valid Chart Tool Panel name`,
    144: ({ type: type })=>`Invalid charts data panel group name supplied: '${type}'`,
    145: ({ group: group })=>`As of v32, only one charts customize panel group can be expanded at a time. '${group}' will not be expanded.`,
    146: ({ comp: comp })=>`Unable to instantiate component '${comp}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
    147: ({ group: group })=>`Invalid charts customize panel group name supplied: '${group}'`,
    148: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    149: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    150: ()=>`'seriesChartTypes' are required when the 'customCombo' chart type is specified.`,
    151: ({ chartType: chartType })=>`invalid chartType '${chartType}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
    152: ({ colId: colId })=>`no 'seriesChartType' found for colId = '${colId}', defaulting to 'line'.`,
    153: ({ chartDataType: chartDataType })=>`unexpected chartDataType value '${chartDataType}' supplied, instead use 'category', 'series' or 'excluded'`,
    154: ({ colId: colId })=>`cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${colId}`,
    155: ({ option: option })=>`'${option}' is not a valid Chart Toolbar Option`,
    156: ({ panel: panel })=>`Invalid panel in chartToolPanelsDef.panels: '${panel}'`,
    157: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find group(s) for supplied groupIds:",
            unrecognisedGroupIds
        ],
    158: ()=>"can not expand a column item that does not represent a column group header",
    159: ()=>"Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
    160: ()=>`Export cancelled. Export is not allowed as per your configuration.`,
    161: ()=>"The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
    162: ({ id: id, dataType: dataType })=>`Unrecognized data type for excel export [${id}.dataType=${dataType}]`,
    163: ({ featureName: featureName })=>`Excel table export does not work with ${featureName}. The exported Excel file will not contain any Excel tables.
 Please turn off ${featureName} to enable Excel table exports.`,
    164: ()=>"Unable to add data table to Excel sheet: A table already exists.",
    165: ()=>"Unable to add data table to Excel sheet: Missing required parameters.",
    166: ({ unrecognisedGroupIds: unrecognisedGroupIds })=>[
            "unable to find groups for these supplied groupIds:",
            unrecognisedGroupIds
        ],
    167: ({ unrecognisedColIds: unrecognisedColIds })=>[
            "unable to find columns for these supplied colIds:",
            unrecognisedColIds
        ],
    168: ()=>"detailCellRendererParams.template should be function or string",
    169: ()=>'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
    170: ({ providedStrategy: providedStrategy })=>`invalid cellRendererParams.refreshStrategy = ${providedStrategy} supplied, defaulting to refreshStrategy = 'rows'.`,
    171: ()=>"could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
    172: ()=>"could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
    173: ({ group: group })=>`invalid chartGroupsDef config '${group}'`,
    174: ({ group: group, chartType: chartType })=>`invalid chartGroupsDef config '${group}.${chartType}'`,
    175: ({ menuTabName: menuTabName, itemsToConsider: itemsToConsider })=>[
            `Trying to render an invalid menu item '${menuTabName}'. Check that your 'menuTabs' contains one of `,
            itemsToConsider
        ],
    176: ({ key: key })=>`unknown menu item type ${key}`,
    177: ()=>`valid values for cellSelection.handle.direction are 'x', 'y' and 'xy'. Default to 'xy'.`,
    178: ({ colId: colId })=>`column ${colId} is not visible`,
    179: ()=>"totalValueGetter should be either a function or a string (expression)",
    180: ()=>"agRichSelectCellEditor requires cellEditorParams.values to be set",
    181: ()=>"agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
    182: ()=>'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
    183: ()=>"Group Column Filter only works on group columns. Please use a different filter.",
    184: ({ parentGroupData: parentGroupData, childNodeData: childNodeData })=>[
            `duplicate group keys for row data, keys should be unique`,
            [
                parentGroupData,
                childNodeData
            ]
        ],
    185: ({ data: data })=>[
            `getDataPath() should not return an empty path`,
            [
                data
            ]
        ],
    186: ({ rowId: rowId, rowData: rowData, duplicateRowsData: duplicateRowsData })=>[
            `duplicate group keys for row data, keys should be unique`,
            rowId,
            rowData,
            ...duplicateRowsData ?? []
        ],
    187: ({ rowId: rowId, firstData: firstData, secondData: secondData })=>[
            `Duplicate node id ${rowId}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
            "first instance",
            firstData,
            "second instance",
            secondData
        ],
    188: ()=>`getRowId callback must be provided for Server Side Row Model selection to work correctly.`,
    189: ({ startRow: startRow })=>`invalid value ${startRow} for startRow, the value should be >= 0`,
    190: ({ rowGroupId: rowGroupId, data: data })=>[
            `null and undefined values are not allowed for server side row model keys`,
            rowGroupId ? `column = ${rowGroupId}` : ``,
            `data is `,
            data
        ],
    // 191: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    // 192: () => `cannot use range selection when multi selecting rows` as const,
    // 193: () => "cannot multi select unless selection mode is 'multiRow'" as const,
    194: ({ method: method })=>`calling gridApi.${method}() is only possible when using rowModelType=\`clientSide\`.`,
    195: ({ justCurrentPage: justCurrentPage })=>`selecting just ${justCurrentPage ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
    196: ({ key: key })=>`Provided ids must be of string type. Invalid id provided: ${key}`,
    197: ()=>"`toggledNodes` must be an array of string ids.",
    // 198: () => `cannot multi select unless selection mode is 'multiRow'` as const,
    199: ()=>`getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    200: $437b23f6a393c3bf$var$missingModule,
    201: ({ rowModelType: rowModelType })=>`Could not find row model for rowModelType = ${rowModelType}`,
    202: ()=>`\`getSelectedNodes\` and \`getSelectedRows\` functions cannot be used with \`groupSelectsChildren\` and the server-side row model. Use \`api.getServerSideSelectionState()\` instead.`,
    203: ()=>"Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
    204: ()=>"Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
    205: ({ duplicateIdText: duplicateIdText })=>`Unable to display rows as duplicate row ids (${duplicateIdText}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
    206: ()=>"getRowId callback must be implemented for transactions to work. Transaction was ignored.",
    207: ()=>'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
    208: ()=>`Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.`,
    209: ()=>`Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${$437b23f6a393c3bf$var$baseDocLink}/filter-set-filter-list/#filter-value-types`,
    210: ()=>"Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
    211: ()=>"property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
    212: ()=>`please review all your toolPanel components, it seems like at least one of them doesn't have an id`,
    213: ()=>"Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
    214: ({ key: key })=>`unable to lookup Tool Panel as invalid key supplied: ${key}`,
    215: ({ key: key, defaultByKey: defaultByKey })=>`the key ${key} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(defaultByKey ?? {}).join(",")}`,
    216: ({ name: name })=>`Missing component for '${name}'`,
    217: ({ invalidColIds: invalidColIds })=>[
            "unable to find grid columns for the supplied colDef(s):",
            invalidColIds
        ],
    218: ({ property: property, defaultOffset: defaultOffset })=>`${property} must be a number, the value you provided is not a valid number. Using the default of ${defaultOffset}px.`,
    219: ({ property: property })=>`Property ${property} does not exist on the target object.`,
    220: ({ lineDash: lineDash })=>`'${lineDash}' is not a valid 'lineDash' option.`,
    221: ()=>`agAggregationComponent should only be used with the client and server side row model.`,
    222: ()=>`agFilteredRowCountComponent should only be used with the client side row model.`,
    223: ()=>`agSelectedRowCountComponent should only be used with the client and server side row model.`,
    224: ()=>`agTotalAndFilteredRowCountComponent should only be used with the client side row model.`,
    225: ()=>"agTotalRowCountComponent should only be used with the client side row model.",
    226: ()=>"viewport is missing init method.",
    227: ()=>"menu item icon must be DOM node or string",
    228: ({ menuItemOrString: menuItemOrString })=>`unrecognised menu item ${menuItemOrString}`,
    229: ({ index: index })=>[
            "invalid row index for ensureIndexVisible: ",
            index
        ],
    230: ()=>"detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://www.ag-grid.com/react-data-grid/master-detail-custom-detail/",
    // @deprecated v32 mark for removal as part of v32 deprecated features
    231: ()=>"As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
    232: ()=>"Using both rowData and v-model. rowData will be ignored.",
    233: ({ methodName: methodName })=>`Framework component is missing the method ${methodName}()`,
    234: ()=>'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
    235: ()=>'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
    236: ()=>'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
    237: ()=>"Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
    238: ()=>"setRowCount can only accept a positive row count.",
    239: ()=>'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
    240: ({ theme: theme })=>`theme grid option must be a Theming API theme object or the string "legacy", received: ${theme}`,
    // 241: () => `cannot select multiple rows when rowSelection.mode is set to 'singleRow'` as const,
    // 242: () => 'cannot select multiple rows when using rangeSelect' as const,
    243: ()=>"Failed to deserialize state - each provided state object must be an object.",
    244: ()=>"Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
    245: ()=>"Failed to deserialize state - `toggledNodes` must be an array.",
    246: ()=>"Failed to deserialize state - Every `toggledNode` requires an associated string id.",
    247: ()=>`Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
    248: ()=>"SetFloatingFilter expects SetFilter as its parent",
    249: ()=>"Must supply a Value Formatter in Set Filter params when using a Key Creator",
    250: ()=>"Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
    251: ({ chartType: chartType })=>`AG Grid: Unable to create chart as an invalid chartType = '${chartType}' was supplied.`,
    252: ()=>"cannot get grid to draw rows when it is in the middle of drawing rows. \nYour code probably called a grid API method while the grid was in the render stage. \nTo overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). \nTo see what part of your code that caused the refresh check this stacktrace.",
    253: ({ version: version })=>[
            "Illegal version string: ",
            version
        ],
    254: ()=>"Cannot create chart: no chart themes available.",
    255: ({ point: point })=>`Lone surrogate U+${point?.toString(16).toUpperCase()} is not a scalar value`,
    256: ()=>"Unable to initialise. See validation error, or load ValidationModule if missing.",
    257: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("IntegratedChartsModule"),
    258: ()=>$437b23f6a393c3bf$var$missingChartsWithModule("SparklinesModule"),
    259: ({ part: part })=>`the argument to theme.withPart must be a Theming API part object, received: ${part}`,
    260: ({ propName: propName, compName: compName, gridScoped: gridScoped, gridId: gridId, rowModelType: rowModelType })=>$437b23f6a393c3bf$var$missingModule({
            reasonOrId: `AG Grid '${propName}' component: ${compName}`,
            moduleName: $437b23f6a393c3bf$var$USER_COMP_MODULES[compName],
            gridId: gridId,
            gridScoped: gridScoped,
            rowModelType: rowModelType
        }),
    261: ()=>"As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
    262: ()=>'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor.',
    263: ()=>'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
    264: ()=>'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus.',
    265: ({ colId: colId })=>`Unable to infer chart data type for column '${colId}' if first data entry is null. Please specify "chartDataType", or a "cellDataType" in the column definition. For more information, see ${$437b23f6a393c3bf$var$baseDocLink}/integrated-charts-range-chart#coldefchartdatatype .`,
    266: ()=>'As of v33.1, using "keyCreator" with the Rich Select Editor has been deprecated. It now requires the "formatValue" callback to convert complex data to strings.',
    267: ()=>"Detail grids can not use a different theme to the master grid, the `theme` detail grid option will be ignored.",
    268: ()=>"Transactions aren't supported with tree data when using treeDataChildrenField",
    269: ()=>"When `masterSelects: 'detail'`, detail grids must be configured with multi-row selection",
    270: ({ id: id, parentId: parentId })=>`Cycle detected for row with id='${id}' and parent id='${parentId}'. Resetting the parent for row with id='${id}' and showing it as a root-level node.`,
    271: ({ id: id, parentId: parentId })=>`Parent row not found for row with id='${id}' and parent id='${parentId}'. Showing row with id='${id}' as a root-level node.`,
    272: ()=>$437b23f6a393c3bf$var$NoModulesRegisteredError(),
    273: ({ providedId: providedId, usedId: usedId })=>`Provided column id '${providedId}' was already in use, ensure all column and group ids are unique. Using '${usedId}' instead.`,
    274: ({ prop: prop })=>{
        let msg = `Since v33, ${prop} has been deprecated.`;
        switch(prop){
            case "maxComponentCreationTimeMs":
                msg += " This property is no longer required and so will be removed in a future version.";
                break;
            case "setGridApi":
                msg += ` This method is not called by AG Grid. To access the GridApi see: https://ag-grid.com/react-data-grid/grid-interface/#grid-api `;
                break;
            case "children":
                msg += ` For multiple versions AgGridReact does not support children.`;
                break;
        }
        return msg;
    },
    275: $437b23f6a393c3bf$var$missingRowModelTypeError,
    276: ()=>"Row Numbers Row Resizer cannot be used when Grid Columns have `autoHeight` enabled."
};
function $437b23f6a393c3bf$var$getError(errorId, args) {
    const msgOrFunc = $437b23f6a393c3bf$var$AG_GRID_ERRORS[errorId];
    if (!msgOrFunc) return [
        `Missing error text for error id ${errorId}!`
    ];
    const errorBody = msgOrFunc(args);
    const errorLink = $437b23f6a393c3bf$var$getErrorLink(errorId, args);
    const errorSuffix = `
See ${errorLink}`;
    return Array.isArray(errorBody) ? errorBody.concat(errorSuffix) : [
        errorBody,
        errorSuffix
    ];
}
var $437b23f6a393c3bf$var$MISSING_MODULE_REASONS = {
    1: "Charting Aggregation",
    2: "pivotResultFields",
    3: "setTooltip"
};
// packages/ag-grid-community/src/grid.ts
var $437b23f6a393c3bf$var$_GlobalGridOptions = class _GlobalGridOptions {
    /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */ static applyGlobalGridOptions(providedOptions) {
        if (!_GlobalGridOptions.gridOptions) return {
            ...providedOptions
        };
        let mergedGridOps = {};
        $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, _GlobalGridOptions.gridOptions, true, true);
        if (_GlobalGridOptions.mergeStrategy === "deep") $437b23f6a393c3bf$export$8ade6bd474fcde42(mergedGridOps, providedOptions, true, true);
        else mergedGridOps = {
            ...mergedGridOps,
            ...providedOptions
        };
        if (_GlobalGridOptions.gridOptions.context) mergedGridOps.context = _GlobalGridOptions.gridOptions.context;
        if (providedOptions.context) {
            if (_GlobalGridOptions.mergeStrategy === "deep" && mergedGridOps.context) $437b23f6a393c3bf$export$8ade6bd474fcde42(providedOptions.context, mergedGridOps.context, true, true);
            mergedGridOps.context = providedOptions.context;
        }
        return mergedGridOps;
    }
};
$437b23f6a393c3bf$var$_GlobalGridOptions.gridOptions = void 0;
$437b23f6a393c3bf$var$_GlobalGridOptions.mergeStrategy = "shallow";
var $437b23f6a393c3bf$var$GlobalGridOptions = $437b23f6a393c3bf$var$_GlobalGridOptions;
function $437b23f6a393c3bf$export$9def8154c643bfd1(gridOptions, mergeStrategy = "shallow") {
    $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = gridOptions;
    $437b23f6a393c3bf$var$GlobalGridOptions.mergeStrategy = mergeStrategy;
}
function $437b23f6a393c3bf$export$c3524a7ed99826d4(gridOption) {
    return $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions?.[gridOption];
}
function $437b23f6a393c3bf$export$fce123c48a7b4eae(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        $437b23f6a393c3bf$export$a20c7248650823a9(11);
        return {};
    }
    const gridParams = params;
    let destroyCallback;
    if (!gridParams?.setThemeOnGridDiv) {
        const newGridDiv = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        newGridDiv.style.height = "100%";
        eGridDiv.appendChild(newGridDiv);
        eGridDiv = newGridDiv;
        destroyCallback = ()=>eGridDiv.remove();
    }
    const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new $437b23f6a393c3bf$var$GridComp(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params, destroyCallback);
    return api;
}
var $437b23f6a393c3bf$var$nextGridId = 1;
var $437b23f6a393c3bf$export$7759b93c6200a2f9 = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params, destroyCallback) {
        const gridOptions = $437b23f6a393c3bf$var$GlobalGridOptions.applyGlobalGridOptions(providedOptions);
        const gridId = gridOptions.gridId ?? String($437b23f6a393c3bf$var$nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId, gridOptions.rowModelType);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) return void 0;
        const contextParams = {
            providedBeanInstances: providedBeanInstances,
            beanClasses: beanClasses,
            gridId: gridId,
            beanInitComparator: $437b23f6a393c3bf$var$gridBeanInitComparator,
            beanDestroyComparator: $437b23f6a393c3bf$var$gridBeanDestroyComparator,
            derivedBeans: [
                $437b23f6a393c3bf$var$createGridApi
            ],
            destroyCallback: destroyCallback
        };
        const context = new $437b23f6a393c3bf$var$Context(contextParams);
        this.registerModuleFeatures(context, registeredModules);
        createUi(context);
        context.getBean("syncSvc").start();
        if (acceptChanges) acceptChanges(context);
        return context.getBean("gridApi");
    }
    getRegisteredModules(params, gridId, rowModelType) {
        $437b23f6a393c3bf$export$d0b008fbcc09e577($437b23f6a393c3bf$var$CommunityCoreModule, void 0, true);
        params?.modules?.forEach((m)=>$437b23f6a393c3bf$export$d0b008fbcc09e577(m, gridId));
        return $437b23f6a393c3bf$var$_getRegisteredModules(gridId, $437b23f6a393c3bf$var$getDefaultRowModelType(rowModelType));
    }
    registerModuleFeatures(context, registeredModules) {
        const registry = context.getBean("registry");
        const apiFunctionSvc = context.getBean("apiFunctionSvc");
        registeredModules.forEach((module)=>{
            registry.registerModule(module);
            const apiFunctions = module.apiFunctions;
            if (apiFunctions) {
                const names = Object.keys(apiFunctions);
                names.forEach((name)=>{
                    apiFunctionSvc?.addFunction(name, apiFunctions[name]);
                });
            }
        });
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(frameworkOverrides)) frameworkOverrides = new $437b23f6a393c3bf$export$8174ad74937c6482();
        const seed = {
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            globalListener: params ? params.globalListener : null,
            globalSyncListener: params ? params.globalSyncListener : null,
            frameworkOverrides: frameworkOverrides
        };
        if (params && params.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createBeansList(userProvidedRowModelType, registeredModules, gridId) {
        const rowModelModuleNames = {
            clientSide: "ClientSideRowModel",
            infinite: "InfiniteRowModel",
            serverSide: "ServerSideRowModel",
            viewport: "ViewportRowModel"
        };
        const rowModelType = $437b23f6a393c3bf$var$getDefaultRowModelType(userProvidedRowModelType);
        const rowModuleModelName = rowModelModuleNames[rowModelType];
        if (!rowModuleModelName) {
            $437b23f6a393c3bf$var$_logPreInitErr(201, {
                rowModelType: rowModelType
            }, `Unknown rowModelType ${rowModelType}.`);
            return;
        }
        if (!$437b23f6a393c3bf$var$_hasUserRegistered()) {
            $437b23f6a393c3bf$var$_logPreInitErr(272, void 0, $437b23f6a393c3bf$var$NoModulesRegisteredError());
            return;
        }
        if (!userProvidedRowModelType) {
            const registeredRowModelModules = Object.entries(rowModelModuleNames).filter(([rowModelType2, module])=>$437b23f6a393c3bf$var$_isModuleRegistered(module, gridId, rowModelType2));
            if (registeredRowModelModules.length == 1) {
                const [userRowModelType, moduleName] = registeredRowModelModules[0];
                if (userRowModelType !== rowModelType) {
                    const params = {
                        moduleName: moduleName,
                        rowModelType: userRowModelType
                    };
                    $437b23f6a393c3bf$var$_logPreInitErr(275, params, $437b23f6a393c3bf$var$missingRowModelTypeError(params));
                    return;
                }
            }
        }
        if (!$437b23f6a393c3bf$var$_isModuleRegistered(rowModuleModelName, gridId, rowModelType)) {
            $437b23f6a393c3bf$var$_logPreInitErr(200, {
                reasonOrId: `rowModelType = '${rowModelType}'`,
                moduleName: rowModuleModelName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: gridId,
                rowModelType: rowModelType
            }, `Missing module ${rowModuleModelName}Module for rowModelType ${rowModelType}.`);
            return;
        }
        const beans = /* @__PURE__ */ new Set();
        registeredModules.forEach((module)=>module.beans?.forEach((bean)=>beans.add(bean)));
        return Array.from(beans);
    }
};
function $437b23f6a393c3bf$var$getDefaultRowModelType(passedRowModelType) {
    return passedRowModelType ?? "clientSide";
}
// packages/ag-grid-community/src/api/rowModelApiUtils.ts
function $437b23f6a393c3bf$export$f5285e6f27a03f95(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "clientSide" ? rowModel : void 0;
}
function $437b23f6a393c3bf$var$_getInfiniteRowModel(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "infinite" ? rowModel : void 0;
}
function $437b23f6a393c3bf$export$aada92189a74e985(beans) {
    const rowModel = beans.rowModel;
    return rowModel.getType() === "serverSide" ? rowModel : void 0;
}
// packages/ag-grid-community/src/misc/locale/localeService.ts
var $437b23f6a393c3bf$export$f325e19d05d9c36d = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "localeSvc";
    }
    getLocaleTextFunc() {
        const gos = this.gos;
        const getLocaleText = gos.getCallback("getLocaleText");
        if (getLocaleText) return (key, defaultValue, variableValues)=>{
            const params = {
                key: key,
                defaultValue: defaultValue,
                variableValues: variableValues
            };
            return getLocaleText(params);
        };
        const localeText = gos.get("localeText");
        return (key, defaultValue, variableValues)=>{
            let localisedText = localeText && localeText[key];
            if (localisedText && variableValues && variableValues.length) {
                let found = 0;
                while(true){
                    if (found >= variableValues.length) break;
                    const idx = localisedText.indexOf("${variable}");
                    if (idx === -1) break;
                    localisedText = localisedText.replace("${variable}", variableValues[found++]);
                }
            }
            return localisedText ?? defaultValue;
        };
    }
};
// packages/ag-grid-community/src/misc/state/stateUtils.ts
function $437b23f6a393c3bf$export$9453e80be74134db(columnState, enablePivotMode = false) {
    const sortColumns = [];
    const groupColIds = [];
    const aggregationColumns = [];
    const pivotColIds = [];
    const leftColIds = [];
    const rightColIds = [];
    const hiddenColIds = [];
    const columnSizes = [];
    const columns = [];
    let defaultSortIndex = 0;
    for(let i = 0; i < columnState.length; i++){
        const { colId: colId, sort: sort, sortIndex: sortIndex, rowGroup: rowGroup, rowGroupIndex: rowGroupIndex, aggFunc: aggFunc, pivot: pivot, pivotIndex: pivotIndex, pinned: pinned, hide: hide, width: width, flex: flex } = columnState[i];
        columns.push(colId);
        if (sort) sortColumns[sortIndex ?? defaultSortIndex++] = {
            colId: colId,
            sort: sort
        };
        if (rowGroup) groupColIds[rowGroupIndex ?? 0] = colId;
        if (typeof aggFunc === "string") aggregationColumns.push({
            colId: colId,
            aggFunc: aggFunc
        });
        if (pivot) pivotColIds[pivotIndex ?? 0] = colId;
        if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
        if (hide) hiddenColIds.push(colId);
        if (flex != null || width) columnSizes.push({
            colId: colId,
            flex: flex ?? void 0,
            width: width
        });
    }
    return {
        sort: sortColumns.length ? {
            sortModel: sortColumns
        } : void 0,
        rowGroup: groupColIds.length ? {
            groupColIds: groupColIds
        } : void 0,
        aggregation: aggregationColumns.length ? {
            aggregationModel: aggregationColumns
        } : void 0,
        pivot: pivotColIds.length || enablePivotMode ? {
            pivotMode: enablePivotMode,
            pivotColIds: pivotColIds
        } : void 0,
        columnPinning: leftColIds.length || rightColIds.length ? {
            leftColIds: leftColIds,
            rightColIds: rightColIds
        } : void 0,
        columnVisibility: hiddenColIds.length ? {
            hiddenColIds: hiddenColIds
        } : void 0,
        columnSizing: columnSizes.length ? {
            columnSizingModel: columnSizes
        } : void 0,
        columnOrder: columns.length ? {
            orderedColIds: columns
        } : void 0
    };
}
function $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState) {
    const openColumnGroups = [];
    columnGroupState.forEach(({ groupId: groupId, open: open })=>{
        if (open) openColumnGroups.push(groupId);
    });
    return openColumnGroups.length ? {
        openColumnGroupIds: openColumnGroups
    } : void 0;
}
function $437b23f6a393c3bf$export$e5b0fd7258628d55(columnGroupState) {
    return {
        columnGroup: $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState)
    };
}
// packages/ag-grid-community/src/components/framework/frameworkComponentWrapper.ts
var $437b23f6a393c3bf$export$157f014d661b6f19 = class {
    wrap(OriginalConstructor, mandatoryMethods, optionalMethods, componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        mandatoryMethods?.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, true);
        });
        optionalMethods?.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, false);
        });
        return wrapper;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) $437b23f6a393c3bf$export$545083624300f13d(49, {
                methodName: methodName
            });
            return null;
        };
    }
};
// packages/ag-grid-community/src/tooltip/tooltipComponent.ts
var $437b23f6a393c3bf$var$TooltipComponentElement = {
    tag: "div",
    cls: "ag-tooltip"
};
var $437b23f6a393c3bf$var$TooltipComponent2 = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super($437b23f6a393c3bf$var$TooltipComponentElement);
    }
    // will need to type params
    init(params) {
        const { value: value } = params;
        this.getGui().textContent = $437b23f6a393c3bf$export$a16cfb6652fe466f(value);
    }
};
// packages/ag-grid-community/src/utils/number.ts
function $437b23f6a393c3bf$export$c8980add4a69422e(value, getLocaleTextFunc) {
    if (typeof value !== "number") return "";
    const localeTextFunc = getLocaleTextFunc();
    const thousandSeparator = localeTextFunc("thousandSeparator", ",");
    const decimalSeparator = localeTextFunc("decimalSeparator", ".");
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
// packages/ag-grid-community/src/export/baseCreator.ts
var $437b23f6a393c3bf$export$b335f23c5aead909 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (fileName == null || !fileName.length) fileName = this.getDefaultFileName();
        return fileName.indexOf(".") === -1 ? `${fileName}.${extension}` : fileName;
    }
    getData(params) {
        const serializingSession = this.createSerializingSession(params);
        return this.beans.gridSerializer.serialize(serializingSession, params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
// packages/ag-grid-community/src/export/baseGridSerializingSession.ts
var $437b23f6a393c3bf$export$5018ab277b833b61 = class {
    constructor(config){
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, colNames: colNames, valueSvc: valueSvc, gos: gos, processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback } = config;
        this.colModel = colModel;
        this.rowGroupColsSvc = rowGroupColsSvc;
        this.colNames = colNames;
        this.valueSvc = valueSvc;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(_columnsToExport) {}
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value ?? "";
    }
    extractRowCellValue(column, currentColumnIndex, accumulatedRowIndex, type, node) {
        if (this.processRowGroupCallback && (this.gos.get("treeData") || node.group) && (!node.rowGroupColumn || column.isRowGroupDisplayed(node.rowGroupColumn.getColId()))) return {
            value: this.processRowGroupCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                column: column,
                node: node
            })) ?? ""
        };
        if (this.processCellCallback) return {
            value: this.processCellCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                accumulatedRowIndex: accumulatedRowIndex,
                column: column,
                node: node,
                value: this.valueSvc.getValueForDisplay(column, node).value,
                type: type,
                parseValue: (valueToParse)=>this.valueSvc.parseValue(column, node, valueToParse, this.valueSvc.getValue(column, node)),
                formatValue: (valueToFormat)=>this.valueSvc.formatValue(column, node, valueToFormat) ?? valueToFormat
            })) ?? ""
        };
        const isTreeData = this.gos.get("treeData");
        const valueService = this.valueSvc;
        const isGrandTotalRow = node.level === -1 && node.footer;
        const isFullWidthGroup = currentColumnIndex === 0 && $437b23f6a393c3bf$export$410912a9c501b8cc(this.gos, node, this.colModel.isPivotMode());
        const isMultiAutoCol = column.colDef.showRowGroup === true && (node.group || isTreeData);
        if (!isGrandTotalRow && (isFullWidthGroup || isMultiAutoCol)) {
            let concatenatedGroupValue = "";
            let pointer = node;
            while(pointer && pointer.level !== -1){
                const { value: value2, valueFormatted: valueFormatted2 } = valueService.getValueForDisplay(isFullWidthGroup ? void 0 : column, // full width group doesn't have a column
                pointer, true, true);
                concatenatedGroupValue = ` -> ${valueFormatted2 ?? value2 ?? ""}${concatenatedGroupValue}`;
                pointer = pointer.parent;
            }
            return {
                value: concatenatedGroupValue,
                // don't return the unformatted value; as if the grid detects number it'll not use the concatenated string
                valueFormatted: concatenatedGroupValue
            };
        }
        const { value: value, valueFormatted: valueFormatted } = valueService.getValueForDisplay(column, node, true, true);
        return {
            value: value ?? "",
            valueFormatted: valueFormatted
        };
    }
    getHeaderName(callback, column) {
        if (callback) return callback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column
        }));
        return this.colNames.getDisplayNameForColumn(column, "csv", true);
    }
};
// packages/ag-grid-community/src/export/downloader.ts
function $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(fileName, content) {
    const win = document.defaultView || window;
    if (!win) {
        $437b23f6a393c3bf$export$545083624300f13d(52);
        return;
    }
    const element = document.createElement("a");
    const url = win.URL.createObjectURL(content);
    element.setAttribute("href", url);
    element.setAttribute("download", fileName);
    element.style.display = "none";
    document.body.appendChild(element);
    element.dispatchEvent(new MouseEvent("click", {
        bubbles: false,
        cancelable: true,
        view: win
    }));
    document.body.removeChild(element);
    win.setTimeout(()=>{
        win.URL.revokeObjectURL(url);
    }, 0);
}
// packages/ag-grid-community/src/gridOptionsInitial.ts
var $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressTouch: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    dragAndDropImageComponent: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    groupLockGroupColumns: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    columnMenu: true,
    suppressSetFilterByDefault: true,
    getDataPath: true,
    enableCellSpan: true
};
// packages/ag-grid-community/src/validation/apiFunctionValidator.ts
var $437b23f6a393c3bf$var$clientSide = "clientSide";
var $437b23f6a393c3bf$var$serverSide = "serverSide";
var $437b23f6a393c3bf$var$infinite = "infinite";
var $437b23f6a393c3bf$var$functionRowModels = {
    onGroupExpandedOrCollapsed: [
        $437b23f6a393c3bf$var$clientSide
    ],
    refreshClientSideRowModel: [
        $437b23f6a393c3bf$var$clientSide
    ],
    isRowDataEmpty: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachLeafNode: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilter: [
        $437b23f6a393c3bf$var$clientSide
    ],
    forEachNodeAfterFilterAndSort: [
        $437b23f6a393c3bf$var$clientSide
    ],
    resetRowHeights: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransaction: [
        $437b23f6a393c3bf$var$clientSide
    ],
    applyTransactionAsync: [
        $437b23f6a393c3bf$var$clientSide
    ],
    flushAsyncTransactions: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getBestCostNodeSelection: [
        $437b23f6a393c3bf$var$clientSide
    ],
    getServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    setServerSideSelectionState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransaction: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideTransactionAsync: [
        $437b23f6a393c3bf$var$serverSide
    ],
    applyServerSideRowData: [
        $437b23f6a393c3bf$var$serverSide
    ],
    retryServerSideLoads: [
        $437b23f6a393c3bf$var$serverSide
    ],
    flushServerSideAsyncTransactions: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshServerSide: [
        $437b23f6a393c3bf$var$serverSide
    ],
    getServerSideGroupLevelState: [
        $437b23f6a393c3bf$var$serverSide
    ],
    refreshInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    purgeInfiniteCache: [
        $437b23f6a393c3bf$var$infinite
    ],
    getInfiniteRowCount: [
        $437b23f6a393c3bf$var$infinite
    ],
    isLastRowIndexKnown: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    expandAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    collapseAll: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    onRowHeightChanged: [
        $437b23f6a393c3bf$var$clientSide,
        $437b23f6a393c3bf$var$serverSide
    ],
    setRowCount: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ],
    getCacheBlockState: [
        $437b23f6a393c3bf$var$infinite,
        $437b23f6a393c3bf$var$serverSide
    ]
};
var $437b23f6a393c3bf$var$deprecatedFunctions = {
    showLoadingOverlay: {
        version: "v32",
        message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
    },
    clearRangeSelection: {
        version: "v32.2",
        message: "Use `clearCellSelection` instead."
    },
    getInfiniteRowCount: {
        version: "v32.2",
        old: "getInfiniteRowCount()",
        new: "getDisplayedRowCount()"
    },
    selectAllFiltered: {
        version: "v33",
        old: "selectAllFiltered()",
        new: 'selectAll("filtered")'
    },
    deselectAllFiltered: {
        version: "v33",
        old: "deselectAllFiltered()",
        new: 'deselectAll("filtered")'
    },
    selectAllOnCurrentPage: {
        version: "v33",
        old: "selectAllOnCurrentPage()",
        new: 'selectAll("currentPage")'
    },
    deselectAllOnCurrentPage: {
        version: "v33",
        old: "deselectAllOnCurrentPage()",
        new: 'deselectAll("currentPage")'
    }
};
function $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, beans) {
    const deprecation = $437b23f6a393c3bf$var$deprecatedFunctions[functionName];
    if (deprecation) {
        const { version: version, new: replacement, old: old, message: message } = deprecation;
        const apiMethod = old ?? functionName;
        return (...args)=>{
            const replacementMessage = replacement ? `Please use ${replacement} instead. ` : "";
            $437b23f6a393c3bf$export$2cf41453020eef66(`Since ${version} api.${apiMethod} is deprecated. ${replacementMessage}${message ?? ""}`);
            return apiFunction.apply(apiFunction, args);
        };
    }
    const rowModels = $437b23f6a393c3bf$var$functionRowModels[functionName];
    if (rowModels) return (...args)=>{
        const rowModel = beans.rowModel.getType();
        if (!rowModels.includes(rowModel)) {
            $437b23f6a393c3bf$var$_errorOnce(`api.${functionName} can only be called when gridOptions.rowModelType is ${rowModels.join(" or ")}`);
            return void 0;
        }
        return apiFunction.apply(apiFunction, args);
    };
    return apiFunction;
}
// packages/ag-grid-community/src/validation/rules/iconValidations.ts
var $437b23f6a393c3bf$var$ICON_VALUES = {
    expanded: 1,
    contracted: 1,
    "tree-closed": 1,
    "tree-open": 1,
    "tree-indeterminate": 1,
    pin: 1,
    "eye-slash": 1,
    arrows: 1,
    left: 1,
    right: 1,
    group: 1,
    aggregation: 1,
    pivot: 1,
    "not-allowed": 1,
    chart: 1,
    cross: 1,
    cancel: 1,
    tick: 1,
    first: 1,
    previous: 1,
    next: 1,
    last: 1,
    linked: 1,
    unlinked: 1,
    "color-picker": 1,
    loading: 1,
    menu: 1,
    "menu-alt": 1,
    filter: 1,
    columns: 1,
    maximize: 1,
    minimize: 1,
    copy: 1,
    cut: 1,
    paste: 1,
    grip: 1,
    save: 1,
    csv: 1,
    excel: 1,
    "small-down": 1,
    "small-left": 1,
    "small-right": 1,
    "small-up": 1,
    asc: 1,
    desc: 1,
    none: 1,
    up: 1,
    down: 1,
    plus: 1,
    minus: 1,
    settings: 1,
    "checkbox-checked": 1,
    "checkbox-indeterminate": 1,
    "checkbox-unchecked": 1,
    "radio-button-on": 1,
    "radio-button-off": 1,
    eye: 1,
    "column-arrow": 1,
    "un-pin": 1,
    "pinned-top": 1,
    "pinned-bottom": 1
};
var $437b23f6a393c3bf$var$ICON_MODULES = {
    chart: "MenuCore",
    cancel: "EnterpriseCore",
    first: "Pagination",
    previous: "Pagination",
    next: "Pagination",
    last: "Pagination",
    linked: "IntegratedCharts",
    loadingMenuItems: "MenuCore",
    unlinked: "IntegratedCharts",
    menu: "ColumnHeaderComp",
    legacyMenu: "ColumnMenu",
    filter: "ColumnFilter",
    filterActive: "ColumnFilter",
    filterTab: "ColumnMenu",
    filtersToolPanel: "FiltersToolPanel",
    columns: [
        "MenuCore"
    ],
    columnsToolPanel: [
        "ColumnsToolPanel"
    ],
    maximize: "EnterpriseCore",
    minimize: "EnterpriseCore",
    save: "MenuCore",
    columnGroupOpened: "ColumnGroupHeaderComp",
    columnGroupClosed: "ColumnGroupHeaderComp",
    accordionOpen: "EnterpriseCore",
    accordionClosed: "EnterpriseCore",
    accordionIndeterminate: "EnterpriseCore",
    columnSelectClosed: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectOpen: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnSelectIndeterminate: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    columnMovePin: "SharedDragAndDrop",
    columnMoveHide: "SharedDragAndDrop",
    columnMoveMove: "SharedDragAndDrop",
    columnMoveLeft: "SharedDragAndDrop",
    columnMoveRight: "SharedDragAndDrop",
    columnMoveGroup: "SharedDragAndDrop",
    columnMoveValue: "SharedDragAndDrop",
    columnMovePivot: "SharedDragAndDrop",
    dropNotAllowed: "SharedDragAndDrop",
    ensureColumnVisible: [
        "ColumnsToolPanel",
        "ColumnMenu"
    ],
    groupContracted: "GroupCellRenderer",
    groupExpanded: "GroupCellRenderer",
    setFilterGroupClosed: "SetFilter",
    setFilterGroupOpen: "SetFilter",
    setFilterGroupIndeterminate: "SetFilter",
    setFilterLoading: "SetFilter",
    close: "EnterpriseCore",
    check: "MenuItem",
    colorPicker: "CommunityCore",
    groupLoading: "LoadingCellRenderer",
    menuAlt: "ColumnHeaderComp",
    menuPin: "MenuCore",
    menuValue: "MenuCore",
    menuAddRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    menuRemoveRowGroup: [
        "MenuCore",
        "ColumnsToolPanel"
    ],
    clipboardCopy: "MenuCore",
    clipboardCut: "MenuCore",
    clipboardPaste: "MenuCore",
    pivotPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    rowGroupPanel: [
        "ColumnsToolPanel",
        "RowGroupingPanel"
    ],
    valuePanel: "ColumnsToolPanel",
    columnDrag: "EnterpriseCore",
    rowDrag: [
        "RowDrag",
        "DragAndDrop"
    ],
    csvExport: "MenuCore",
    excelExport: "MenuCore",
    smallDown: "CommunityCore",
    selectOpen: "CommunityCore",
    richSelectOpen: "RichSelect",
    richSelectRemove: "RichSelect",
    smallLeft: "CommunityCore",
    smallRight: "CommunityCore",
    subMenuOpen: "MenuItem",
    subMenuOpenRtl: "MenuItem",
    panelDelimiter: "RowGroupingPanel",
    panelDelimiterRtl: "RowGroupingPanel",
    smallUp: "CommunityCore",
    sortAscending: [
        "MenuCore",
        "Sort"
    ],
    sortDescending: [
        "MenuCore",
        "Sort"
    ],
    sortUnSort: [
        "MenuCore",
        "Sort"
    ],
    advancedFilterBuilder: "AdvancedFilter",
    advancedFilterBuilderDrag: "AdvancedFilter",
    advancedFilterBuilderInvalid: "AdvancedFilter",
    advancedFilterBuilderMoveUp: "AdvancedFilter",
    advancedFilterBuilderMoveDown: "AdvancedFilter",
    advancedFilterBuilderAdd: "AdvancedFilter",
    advancedFilterBuilderRemove: "AdvancedFilter",
    advancedFilterBuilderSelectOpen: "AdvancedFilter",
    chartsMenu: "IntegratedCharts",
    chartsMenuEdit: "IntegratedCharts",
    chartsMenuAdvancedSettings: "IntegratedCharts",
    chartsMenuAdd: "IntegratedCharts",
    chartsColorPicker: "IntegratedCharts",
    chartsThemePrevious: "IntegratedCharts",
    chartsThemeNext: "IntegratedCharts",
    chartsDownload: "IntegratedCharts",
    checkboxChecked: "CommunityCore",
    checkboxIndeterminate: "CommunityCore",
    checkboxUnchecked: "CommunityCore",
    radioButtonOn: "CommunityCore",
    radioButtonOff: "CommunityCore",
    rowPin: "PinnedRow",
    rowUnpin: "PinnedRow",
    rowPinBottom: "PinnedRow",
    rowPinTop: "PinnedRow"
};
var $437b23f6a393c3bf$var$DEPRECATED_ICONS_V33 = /* @__PURE__ */ new Set([
    "colorPicker",
    "smallUp",
    "checkboxChecked",
    "checkboxIndeterminate",
    "checkboxUnchecked",
    "radioButtonOn",
    "radioButtonOff",
    "smallDown",
    "smallLeft",
    "smallRight"
]);
// packages/ag-grid-community/src/validation/validationService.ts
var $437b23f6a393c3bf$var$ValidationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "validation";
    }
    wireBeans(beans) {
        this.gridOptions = beans.gridOptions;
        $437b23f6a393c3bf$var$provideValidationServiceLogger(this);
    }
    warnOnInitialPropertyUpdate(source, key) {
        if (source === "api" && $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS[key]) $437b23f6a393c3bf$export$545083624300f13d(22, {
            key: key
        });
    }
    processGridOptions(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS());
    }
    validateApiFunction(functionName, apiFunction) {
        return $437b23f6a393c3bf$var$validateApiFunction(functionName, apiFunction, this.beans);
    }
    missingUserComponent(propertyName, componentName, agGridDefaults, jsComps) {
        const moduleForComponent = $437b23f6a393c3bf$var$USER_COMP_MODULES[componentName];
        if (moduleForComponent) this.gos.assertModuleRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${componentName}`);
        else $437b23f6a393c3bf$export$545083624300f13d(101, {
            propertyName: propertyName,
            componentName: componentName,
            agGridDefaults: agGridDefaults,
            jsComps: jsComps
        });
    }
    checkRowEvents(eventType) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS.has(eventType)) $437b23f6a393c3bf$export$545083624300f13d(10, {
            eventType: eventType
        });
    }
    validateIcon(iconName) {
        if ($437b23f6a393c3bf$var$DEPRECATED_ICONS_V33.has(iconName)) $437b23f6a393c3bf$export$545083624300f13d(43, {
            iconName: iconName
        });
        if ($437b23f6a393c3bf$var$ICON_VALUES[iconName]) return;
        const moduleName = $437b23f6a393c3bf$var$ICON_MODULES[iconName];
        if (moduleName) {
            $437b23f6a393c3bf$export$a20c7248650823a9(200, {
                reasonOrId: `icon '${iconName}'`,
                moduleName: moduleName,
                gridScoped: $437b23f6a393c3bf$var$_areModulesGridScoped(),
                gridId: this.beans.context.getGridId(),
                rowModelType: this.gos.get("rowModelType"),
                additionalText: "Alternatively, use the CSS icon name directly."
            });
            return;
        }
        $437b23f6a393c3bf$export$545083624300f13d(134, {
            iconName: iconName
        });
    }
    isProvidedUserComp(compName) {
        return !!$437b23f6a393c3bf$var$USER_COMP_MODULES[compName];
    }
    /** Should only be called via the GridOptionsService */ validateColDef(colDef) {
        this.processOptions(colDef, $437b23f6a393c3bf$var$COL_DEF_VALIDATORS());
    }
    processOptions(options, validator) {
        const { validations: validations, deprecations: deprecations, allProperties: allProperties, propertyExceptions: propertyExceptions, objectName: objectName, docsUrl: docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions ?? [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            const deprecation = deprecations[key];
            if (deprecation) {
                const { message: message, version: version } = deprecation;
                warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message ?? ""}`);
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rules = validations[key];
            if (!rules) return;
            const { dependencies: dependencies, validate: validate, supportedRowModels: supportedRowModels, expectedType: expectedType } = rules;
            if (expectedType) {
                const actualType = typeof value;
                if (actualType !== expectedType) {
                    warnings.add(`${String(key)} should be of type '${expectedType}' but received '${actualType}' (${value}).`);
                    return;
                }
            }
            if (supportedRowModels) {
                const rowModel = this.gridOptions.rowModelType ?? "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model. It is only valid with: ${supportedRowModels.join(", ")}.`);
                    return;
                }
            }
            if (dependencies) {
                const warning = this.checkForRequiredDependencies(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
            if (validate) {
                const warning = validate(options, this.gridOptions, this.beans);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) warnings.forEach((warning)=>{
            $437b23f6a393c3bf$export$2cf41453020eef66(warning);
        });
    }
    checkForRequiredDependencies(key, validator, options) {
        const optionEntries = Object.entries(validator);
        const failedOptions = optionEntries.filter(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.required.includes(gridOptionValue);
        });
        if (failedOptions.length === 0) return null;
        return failedOptions.map(([failedKey, possibleOptions])=>`'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.required.map((o)=>{
                if (o === null) return "null";
                else if (o === void 0) return "undefined";
                return o;
            }).join(", ")}]. ${possibleOptions.reason ?? ""}`).join("\n           ");
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = $437b23f6a393c3bf$var$_fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        const invalidPropertiesKeys = Object.keys(invalidProperties);
        for (const key of invalidPropertiesKeys){
            const value = invalidProperties[key];
            let message = `invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}.`;
            if (validProperties.includes("context")) message += `
If you are trying to annotate ${containerName} with application data, use the '${containerName}.context' property instead.`;
            $437b23f6a393c3bf$export$2cf41453020eef66(message);
        }
        if (invalidPropertiesKeys.length > 0 && docsUrl) {
            const url = this.beans.frameworkOverrides.getDocLink(docsUrl);
            $437b23f6a393c3bf$export$2cf41453020eef66(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
    getConsoleMessage(id, args) {
        return $437b23f6a393c3bf$var$getError(id, args);
    }
};
function $437b23f6a393c3bf$var$_fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) invalidInputs.forEach((invalidInput)=>fuzzyMatches[invalidInput] = $437b23f6a393c3bf$export$85cab1b5a4aa292c({
            inputValue: invalidInput,
            allSuggestions: allSuggestions
        }).values);
    return fuzzyMatches;
}
var $437b23f6a393c3bf$var$DEPRECATED_ROW_NODE_EVENTS = /* @__PURE__ */ new Set([
    "firstChildChanged",
    "lastChildChanged",
    "childIndexChanged"
]);
// packages/ag-grid-community/src/validation/validationModule.ts
var $437b23f6a393c3bf$export$798770a8f68ba4e7 = {
    moduleName: "Validation",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ValidationService
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/filterStage.ts
function $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode) {
    if (rowNode.sibling) rowNode.sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
}
var $437b23f6a393c3bf$var$FilterStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "excludeChildrenWhenTreeDataFiltering"
        ]);
        this.step = "filter";
    }
    wireBeans(beans) {
        this.filterManager = beans.filterManager;
    }
    execute(params) {
        const { changedPath: changedPath } = params;
        this.filter(changedPath);
    }
    filter(changedPath) {
        const filterActive = !!this.filterManager?.isChildFilterPresent();
        this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    doingTreeDataFiltering() {
        return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
// packages/ag-grid-community/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var $437b23f6a393c3bf$var$HeaderFilterCellCtrl = class extends $437b23f6a393c3bf$var$AbstractHeaderCellCtrl {
    constructor(){
        super(...arguments);
        this.iconCreated = false;
    }
    setComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody, compBeanInput) {
        this.comp = comp;
        const compBean = $437b23f6a393c3bf$var$setupCompBean(this, this.beans.context, compBeanInput);
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui, compBean);
        this.setupActive();
        this.refreshHeaderStyles();
        this.setupWidth(compBean);
        this.setupLeft(compBean);
        this.setupHover(compBean);
        this.setupFocus(compBean);
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter(compBean);
        this.setupUi();
        compBean.addManagedElementListeners(this.eButtonShowMainFilter, {
            click: this.showParentFilter.bind(this)
        });
        this.setupFilterChangedListener(compBean);
        compBean.addManagedListeners(this.column, {
            colDefChanged: ()=>this.onColDefChanged(compBean)
        });
        compBean.addDestroyFunc(()=>{
            this.eButtonShowMainFilter = null;
            this.eFloatingFilterBody = null;
            this.userCompDetails = null;
            this.clearComponent();
        });
    }
    // empty abstract method
    resizeHeader() {}
    moveHeader() {}
    getHeaderClassParams() {
        const { column: column, beans: beans } = this;
        const colDef = column.colDef;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(beans.gos, {
            colDef: colDef,
            column: column,
            floatingFilter: true
        });
    }
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = $437b23f6a393c3bf$export$d8feba07bf373edb("filter", this.beans, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus(compBean) {
        compBean.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.getLocaleTextFunc();
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const { beans: beans } = this;
        const activeEl = $437b23f6a393c3bf$export$16bc98d422315038(beans);
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = $437b23f6a393c3bf$export$83fc12531358bd28(beans, this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            beans.headerNavigation?.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (beans.focusSvc.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.rowCtrl.rowIndex,
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const presentedColsService = this.beans.visibleCols;
        let nextCol = this.column;
        do {
            nextCol = backwards ? presentedColsService.getColBefore(nextCol) : presentedColsService.getColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (wrapperHasFocus) return;
                $437b23f6a393c3bf$export$456c40e80134d72a(e);
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (wrapperHasFocus) {
                    if ($437b23f6a393c3bf$export$8598088d375f416f(this.eGui)) e.preventDefault();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && $437b23f6a393c3bf$var$_isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                $437b23f6a393c3bf$export$8598088d375f416f(this.eGui, shouldFocusLast);
            }
        }
        this.focusThis();
    }
    setupHover(compBean) {
        this.beans.colHover?.addHeaderFilterColumnHoverListener(compBean, this.comp, this.column, this.eGui);
    }
    setupLeft(compBean) {
        const setLeftFeature = new $437b23f6a393c3bf$var$SetLeftFeature(this.column, this.eGui, this.beans);
        compBean.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.beans.menuSvc?.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !$437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.filterManager?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.beans.menuSvc?.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter(compBean) {
        if (!this.active) return;
        const { filterManager: filterManager } = this.beans;
        const syncWithFilter = (event)=>{
            if (event?.source === "filterDestroyed" && !this.isAlive()) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                if (comp) {
                    const parentModel = filterManager?.getCurrentFloatingFilterParentModel(this.column);
                    const filterChangedEvent = event ? {
                        // event can have additional params like `afterDataChange` which need to be passed through
                        ...event,
                        columns: event.columns ?? [],
                        source: event.source === "api" ? "api" : "columnFilter"
                    } : null;
                    comp.onParentModelChanged(parentModel, filterChangedEvent);
                }
            });
        };
        [this.destroySyncListener] = compBean.addManagedListeners(this.column, {
            filterChanged: syncWithFilter
        });
        if (filterManager?.isFilterActive(this.column)) syncWithFilter(null);
    }
    setupWidth(compBean) {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        compBean.addManagedListeners(this.column, {
            widthChanged: listener
        });
        listener();
    }
    setupFilterChangedListener(compBean) {
        if (this.active) {
            [this.destroyFilterChangedListener] = compBean.addManagedListeners(this.column, {
                filterChanged: this.updateFilterButton.bind(this)
            });
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = !!this.beans.filterManager?.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged(compBean) {
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            this.destroySyncListener();
            this.destroyFilterChangedListener();
        }
        const newCompDetails = this.active ? this.beans.filterManager?.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(compBean, newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            if (!compInstance || this.beans.filterManager?.areFilterCompsDifferent(this.userCompDetails ?? null, newCompDetails)) this.updateCompDetails(compBean, newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails);
        });
    }
    updateCompDetails(compBean, compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter(compBean);
            this.setupFilterChangedListener(compBean);
        }
    }
    updateFloatingFilterParams(userCompDetails) {
        if (!userCompDetails) return;
        const params = userCompDetails.params;
        this.comp.getFloatingFilterComp()?.then((floatingFilter)=>{
            if (floatingFilter?.refresh && typeof floatingFilter.refresh === "function") floatingFilter.refresh(params);
        });
    }
    addResizeAndMoveKeyboardListeners() {}
    destroy() {
        super.destroy();
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// packages/ag-grid-community/src/misc/menu/menuApi.ts
function $437b23f6a393c3bf$var$showColumnMenu(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showColumnMenu({
        column: column,
        positionBy: "auto"
    });
}
function $437b23f6a393c3bf$var$hidePopupMenu(beans) {
    beans.menuSvc?.hidePopupMenu();
}
// packages/ag-grid-community/src/misc/menu/sharedMenuModule.ts
var $437b23f6a393c3bf$export$b0ea578339daf1f7 = {
    moduleName: "SharedMenu",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$MenuService
    ],
    apiFunctions: {
        showColumnMenu: $437b23f6a393c3bf$var$showColumnMenu,
        hidePopupMenu: $437b23f6a393c3bf$var$hidePopupMenu
    }
};
// packages/ag-grid-community/src/widgets/popupService.ts
var $437b23f6a393c3bf$var$instanceIdSeq = 0;
var $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
var $437b23f6a393c3bf$var$PopupService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "popupSvc";
        this.popupList = [];
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.gridCtrl = p.gridCtrl;
        });
        this.addManagedEventListeners({
            gridStylesChanged: this.handleThemeChange.bind(this)
        });
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.gridCtrl.getGui();
    }
    positionPopupForMenu(params) {
        const { eventSource: eventSource, ePopup: ePopup, column: column, node: node, event: event } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        let minWidthSet = false;
        const updatePosition = ()=>{
            const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* vertical */ );
            const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
            if (!minWidthSet) {
                ePopup.style.minWidth = `${minWidth}px`;
                minWidthSet = true;
            }
            const widthOfParent = parentRect.right - parentRect.left;
            const maxX = widthOfParent - minWidth;
            let x;
            if (this.gos.get("enableRtl")) {
                x = xLeftPosition();
                if (x < 0) {
                    x = xRightPosition();
                    this.setAlignedStyles(ePopup, "left");
                }
                if (x > maxX) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "right");
                }
            } else {
                x = xRightPosition();
                if (x > maxX) {
                    x = xLeftPosition();
                    this.setAlignedStyles(ePopup, "right");
                }
                if (x < 0) {
                    x = 0;
                    this.setAlignedStyles(ePopup, "left");
                }
            }
            return {
                x: x,
                y: y
            };
            function xRightPosition() {
                return sourceRect.right - parentRect.left - 2;
            }
            function xLeftPosition() {
                return sourceRect.left - parentRect.left - minWidth;
            }
        };
        this.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup("subMenu", ePopup, eventSource, event instanceof MouseEvent ? event : void 0, column, node)
        });
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver } = params;
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: true,
            skipObserver: skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, keepWithinBounds: keepWithinBounds, eventSource: eventSource, alignSide: alignSide = "left", position: position = "over", column: column, rowNode: rowNode, type: type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        this.setAlignedTo(eventSource, ePopup);
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x: x,
                y: y
            };
        };
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: keepWithinBounds,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(type, ePopup, eventSource, null, column, rowNode)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement: alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        positions.forEach((position)=>{
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        });
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    setAlignedTo(eventSource, ePopup) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
    }
    callPostProcessPopup(type, ePopup, eventSource, mouseEvent, column, rowNode) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const params = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(params);
        }
    }
    positionPopup(params) {
        const { ePopup: ePopup, keepWithinBounds: keepWithinBounds, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver, updatePosition: updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x: x, y: y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = $437b23f6a393c3bf$export$9aef8476630687be(this.beans, ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), $437b23f6a393c3bf$var$WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    getParentRect() {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return $437b23f6a393c3bf$var$_getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "height" : "width";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const popupRect = ePopup.getBoundingClientRect();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = Math.ceil(popupRect[offsetProperty]);
        const getSize2 = isVertical ? $437b23f6a393c3bf$export$d23c22492e0f7c0c : $437b23f6a393c3bf$export$642efcb17474eb51;
        let sizeOfParent = isBody ? getSize2(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.abs(max));
    }
    addPopup(params) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        const { eChild: eChild, ariaLabel: ariaLabel, alwaysOnTop: alwaysOnTop, positionCallback: positionCallback, anchorToElement: anchorToElement } = params;
        if (!eDocument) {
            $437b23f6a393c3bf$export$545083624300f13d(122);
            return {
                hideFunc: ()=>{}
            };
        }
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, ariaLabel, !!alwaysOnTop);
        const removeListeners = this.addEventListenersToPopup({
            ...params,
            wrapperEl: wrapperEl
        });
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, ariaLabel, alwaysOnTop) {
        const ePopupParent = this.getPopupParent();
        const { environment: environment, gos: gos } = this.beans;
        const eWrapper = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div"
        });
        environment.applyThemeClasses(eWrapper);
        eWrapper.classList.add("ag-popup");
        element.classList.add(gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) $437b23f6a393c3bf$export$f8d01fa01787902(element, "dialog");
        $437b23f6a393c3bf$export$e81cb0dd07f289f6(element, ariaLabel);
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    handleThemeChange(e) {
        if (e.themeChanged) {
            const environment = this.beans.environment;
            for (const popup of this.popupList)environment.applyThemeClasses(popup.wrapper);
        }
    }
    addEventListenersToPopup(params) {
        const beans = this.beans;
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
        const ePopupParent = this.getPopupParent();
        const { wrapperEl: wrapperEl, eChild: popupEl, closedCallback: closedCallback, afterGuiAttached: afterGuiAttached, closeOnEsc: closeOnEsc, modal: modal } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains($437b23f6a393c3bf$export$16bc98d422315038(beans))) return;
            const key = event.key;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE && !$437b23f6a393c3bf$export$9a48e23524c6d58(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent: mouseEvent, touchEvent: touchEvent, keyboardEvent: keyboardEvent, forceHide: forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent: mouseEvent,
                touchEvent: touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            ePopupParent.removeChild(wrapperEl);
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventSvc.removeEventListener("dragStarted", hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventSvc.addEventListener("dragStarted", hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element: element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: $437b23f6a393c3bf$var$instanceIdSeq++,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element: element, ePopup: ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const extractFromPixelValue = (pxSize)=>parseInt(pxSize.substring(0, pxSize.length - 1), 10);
        const createPosition = (prop, direction)=>{
            const initialDiff = parentRect[prop] - sourceRect[prop];
            const initial = extractFromPixelValue(ePopup.style[prop]);
            return {
                initialDiff: initialDiff,
                lastDiff: initialDiff,
                initial: initial,
                last: initial,
                direction: direction
            };
        };
        const topPosition = createPosition("top", 0 /* vertical */ );
        const leftPosition = createPosition("left", 1 /* horizontal */ );
        const fwOverrides = this.beans.frameworkOverrides;
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            fwOverrides.wrapIncoming(()=>{
                fwOverrides.setInterval(()=>{
                    const pRect = eParent.getBoundingClientRect();
                    const sRect = element.getBoundingClientRect();
                    const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                    if (elementNotInDom) {
                        params.hidePopup();
                        return;
                    }
                    const calculateNewPosition = (position, prop)=>{
                        const current = extractFromPixelValue(ePopup.style[prop]);
                        if (position.last !== current) {
                            position.initial = current;
                            position.last = current;
                        }
                        const currentDiff = pRect[prop] - sRect[prop];
                        if (currentDiff != position.lastDiff) {
                            const newValue = this.keepXYWithinBounds(ePopup, position.initial + position.initialDiff - currentDiff, position.direction);
                            ePopup.style[prop] = `${newValue}px`;
                            position.last = newValue;
                        }
                        position.lastDiff = currentDiff;
                    };
                    calculateNewPosition(topPosition, "top");
                    calculateNewPosition(leftPosition, "left");
                }, 200).then((intervalId)=>{
                    const result = ()=>{
                        if (intervalId != null) window.clearInterval(intervalId);
                    };
                    resolve(result);
                });
            }, "popupPositioning");
        });
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if ($437b23f6a393c3bf$export$b5446458166e97b4(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = $437b23f6a393c3bf$export$f63d0991874c6f81(this.beans);
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    /** @return true if moved */ bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const standardPopupList = [];
        const alwaysOnTopList = [];
        for (const popup of popupList){
            if (popup === eWrapper) continue;
            if (popup.classList.contains("ag-always-on-top")) alwaysOnTopList.push(popup);
            else standardPopupList.push(popup);
        }
        const innerElsScrollMap = [];
        const onTopLength = alwaysOnTopList.length;
        const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
        const shouldBeLast = isPopupAlwaysOnTop || !onTopLength;
        const targetList = shouldBeLast ? [
            ...standardPopupList,
            ...alwaysOnTopList,
            eWrapper
        ] : [
            ...standardPopupList,
            eWrapper,
            ...alwaysOnTopList
        ];
        for(let i = 0; i <= popupLen; i++){
            const currentPopup = targetList[i];
            if (popupList[i] === targetList[i] || currentPopup === eWrapper) continue;
            const innerEls = currentPopup.querySelectorAll("div");
            innerEls.forEach((el)=>{
                if (el.scrollTop !== 0) innerElsScrollMap.push([
                    el,
                    el.scrollTop
                ]);
            });
            if (i === 0) parent.insertAdjacentElement("afterbegin", currentPopup);
            else targetList[i - 1].insertAdjacentElement("afterend", currentPopup);
        }
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
};
// packages/ag-grid-community/src/widgets/popupModule.ts
var $437b23f6a393c3bf$export$da5c9bb998e6c24d = {
    moduleName: "Popup",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PopupService
    ]
};
// packages/ag-grid-community/src/filter/column-filters.css-GENERATED.ts
var $437b23f6a393c3bf$var$columnFiltersCSS = /*css*/ `.ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}:where(.ag-floating-filter-full-body)>div{flex:1 1 auto}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-date-floating-filter-wrapper{display:flex}.ag-set-floating-filter-input :where(input)[disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{align-items:unset;background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:1px solid var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}`;
// packages/ag-grid-community/src/filter/columnFilterApi.ts
function $437b23f6a393c3bf$var$isColumnFilterPresent(beans) {
    const filterManager = beans.filterManager;
    return !!filterManager?.isColumnFilterPresent() || !!filterManager?.isAggregateFilterPresent();
}
function $437b23f6a393c3bf$var$getColumnFilterInstance(beans, key) {
    return beans.filterManager?.getColumnFilterInstance(key) ?? Promise.resolve(void 0);
}
function $437b23f6a393c3bf$var$destroyFilter(beans, key) {
    const column = beans.colModel.getColDefCol(key);
    if (column) return beans.filterManager?.destroyFilter(column, "api");
}
function $437b23f6a393c3bf$var$setFilterModel(beans, model) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.filterManager?.setFilterModel(model));
}
function $437b23f6a393c3bf$var$getFilterModel(beans) {
    return beans.filterManager?.getFilterModel() ?? {};
}
function $437b23f6a393c3bf$var$getColumnFilterModel(beans, column) {
    return beans.filterManager?.getColumnFilterModel(column) ?? null;
}
function $437b23f6a393c3bf$var$setColumnFilterModel(beans, column, model) {
    return beans.filterManager?.setColumnFilterModel(column, model) ?? Promise.resolve();
}
function $437b23f6a393c3bf$var$showColumnFilter(beans, colKey) {
    const column = beans.colModel.getCol(colKey);
    if (!column) {
        $437b23f6a393c3bf$export$a20c7248650823a9(12, {
            colKey: colKey
        });
        return;
    }
    beans.menuSvc?.showFilterMenu({
        column: column,
        containerType: "columnFilter",
        positionBy: "auto"
    });
}
// packages/ag-grid-community/src/filter/columnFilterService.ts
var $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var $437b23f6a393c3bf$var$MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $437b23f6a393c3bf$var$setFilterNumberComparator(a, b) {
    if (a == null) return -1;
    if (b == null) return 1;
    return parseFloat(a) - parseFloat(b);
}
var $437b23f6a393c3bf$var$ColumnFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colFilter";
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue = [];
    }
    postConstruct() {
        this.addManagedEventListeners({
            gridColumnsChanged: this.onColumnsChanged.bind(this),
            beforeRefreshModel: ({ params: params })=>{
                if (params.rowDataUpdated || params.changedProps?.has("treeData")) this.onNewRowsLoaded("rowDataUpdated");
            },
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        this.initialFilterModel = {
            ...this.gos.get("initialState")?.filter?.filterModel ?? {}
        };
    }
    setFilterModel(model, source = "api") {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc, filterManager: filterManager } = this.beans;
        if (dataTypeSvc?.isPendingInference) {
            this.filterModelUpdateQueue.push({
                model: model,
                source: source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getFilterModel(true);
        if (model) {
            const modelKeys = new Set(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push($437b23f6a393c3bf$var$setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = colModel.getColDefCol(colId) || colModel.getCol(colId);
                if (!column) {
                    $437b23f6a393c3bf$export$545083624300f13d(62, {
                        colId: colId
                    });
                    return;
                }
                if (!column.isFilterAllowed()) {
                    $437b23f6a393c3bf$export$545083624300f13d(63, {
                        colId: colId
                    });
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column);
                if (!filterWrapper) {
                    $437b23f6a393c3bf$export$545083624300f13d(64, {
                        colId: colId
                    });
                    return;
                }
                allPromises.push($437b23f6a393c3bf$var$setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
            });
        } else this.allColumnFilters.forEach((filterWrapper)=>{
            allPromises.push($437b23f6a393c3bf$var$setModelOnFilterWrapper(filterWrapper.filterPromise, null));
        });
        $437b23f6a393c3bf$export$30ec7836a4847721.all(allPromises).then(()=>{
            const currentModel = this.getFilterModel(true);
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) filterManager?.onFilterChanged({
                columns: columns,
                source: source
            });
        });
    }
    getFilterModel(excludeInitialState) {
        const result = {};
        const { allColumnFilters: allColumnFilters, initialFilterModel: initialFilterModel, beans: { colModel: colModel } } = this;
        allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model)) result[key] = model;
        });
        if (!excludeInitialState) for (const colId of Object.keys(initialFilterModel)){
            const model = initialFilterModel[colId];
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(model) && !allColumnFilters.has(colId) && colModel.getCol(colId)?.isFilterAllowed()) result[colId] = model;
        }
        return result;
    }
    getModelFromFilterWrapper(filterWrapper) {
        const { filter: filter } = filterWrapper;
        if (filter) {
            if (typeof filter.getModel !== "function") {
                $437b23f6a393c3bf$export$545083624300f13d(66);
                return null;
            }
            return filter.getModel();
        } else return this.getModelFromInitialState(filterWrapper.column);
    }
    getModelFromInitialState(column) {
        return this.initialFilterModel[column.getColId()] ?? null;
    }
    isColumnFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggregateFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    disableColumnFilters() {
        this.initialFilterModel = {};
        const { allColumnFilters: allColumnFilters } = this;
        if (allColumnFilters.size) {
            allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
            return true;
        }
        return false;
    }
    doAggregateFiltersPass(node, filterToSkip) {
        return this.doColumnFiltersPass(node, filterToSkip, true);
    }
    updateActiveFilters() {
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                $437b23f6a393c3bf$export$545083624300f13d(67);
                return false;
            }
            return filter.isFilterActive();
        };
        const { colModel: colModel, gos: gos } = this.beans;
        const groupFilterEnabled = !!$437b23f6a393c3bf$export$3708afee0330994(gos);
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !colModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (colModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        const activeAggregateFilters = [];
        const activeColumnFilters = [];
        return this.forEachColumnFilter((filter, filterWrapper)=>{
            const filterActive = isFilterActive(filter);
            if (filterActive) {
                if (isAggFilter(filterWrapper.column)) activeAggregateFilters.push(filter);
                else activeColumnFilters.push(filter);
            }
        }).then(()=>{
            this.activeAggregateFilters = activeAggregateFilters;
            this.activeColumnFilters = activeColumnFilters;
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        return this.forEachColumnFilter((filter, filterWrapper)=>this.setColFilterActive(filterWrapper.column, filter.isFilterActive(), source, additionalEventAttributes));
    }
    forEachColumnFilter(callback) {
        const promises = [];
        this.allColumnFilters.forEach((filterWrapper)=>{
            const filterPromise = filterWrapper.filterPromise;
            if (filterPromise) promises.push(filterPromise.then((filter)=>callback(filter, filterWrapper)));
        });
        return $437b23f6a393c3bf$export$30ec7836a4847721.all(promises);
    }
    doColumnFiltersPass(node, filterToSkip, targetAggregates) {
        const { data: data, aggData: aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            if (filter == null || filter === filterToSkip) continue;
            if (typeof filter.doesFilterPass !== "function") {
                $437b23f6a393c3bf$export$a20c7248650823a9(91);
                continue;
            }
            if (!filter.doesFilterPass({
                node: node,
                data: targetedData
            })) return false;
        }
        return true;
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const { rowRenderer: rowRenderer, filterManager: filterManager } = this.beans;
        const action = ()=>{
            if (this.isAlive()) filterManager?.onFilterChanged(params);
        };
        if (rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    updateBeforeFilterChanged(params = {}) {
        const { filterInstance: filterInstance, additionalEventAttributes: additionalEventAttributes } = params;
        this.updateDependentFilters();
        return this.updateActiveFilters().then(()=>this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes).then(()=>{
                this.allColumnFilters.forEach((filterWrapper)=>{
                    if (!filterWrapper.filterPromise) return;
                    filterWrapper.filterPromise.then((filter)=>{
                        if (filter && filter !== filterInstance && filter.onAnyFilterChanged) filter.onAnyFilterChanged();
                    });
                });
                this.processingFilterChange = true;
            }));
    }
    updateAfterFilterChanged() {
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        const allowShowChangeAfterFilter = this.gos.get("allowShowChangeAfterFilter") ?? false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    onNewRowsLoaded(source) {
        this.forEachColumnFilter((filter)=>{
            filter.onNewRowsLoaded?.();
        }).then(()=>this.updateFilterFlagInColumns(source, {
                afterDataChange: true
            })).then(()=>this.updateActiveFilters());
    }
    createGetValue(filterColumn) {
        const { filterValueSvc: filterValueSvc, colModel: colModel } = this.beans;
        return (rowNode, column)=>{
            const columnToUse = column ? colModel.getCol(column) : filterColumn;
            return columnToUse ? filterValueSvc.getValue(columnToUse, rowNode) : void 0;
        };
    }
    isFilterActive(column) {
        const { filter: filter } = this.cachedFilter(column) ?? {};
        if (filter) return filter.isFilterActive();
        return this.getModelFromInitialState(column) != null;
    }
    getOrCreateFilterWrapper(column) {
        if (!column.isFilterAllowed()) return null;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            filterWrapper = this.createFilterWrapper(column);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column) {
        let defaultFilter;
        const { gos: gos, dataTypeSvc: dataTypeSvc } = this.beans;
        if ($437b23f6a393c3bf$var$_isSetFilterByDefault(gos)) defaultFilter = "agSetColumnFilter";
        else {
            const cellDataType = dataTypeSvc?.getBaseDataType(column);
            if (cellDataType === "number") defaultFilter = "agNumberColumnFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFilter = "agDateColumnFilter";
            else defaultFilter = "agTextColumnFilter";
        }
        return defaultFilter;
    }
    getDefaultFloatingFilter(column) {
        let defaultFloatingFilterType;
        const { gos: gos, dataTypeSvc: dataTypeSvc } = this.beans;
        if ($437b23f6a393c3bf$var$_isSetFilterByDefault(gos)) defaultFloatingFilterType = "agSetColumnFloatingFilter";
        else {
            const cellDataType = dataTypeSvc?.getBaseDataType(column);
            if (cellDataType === "number") defaultFloatingFilterType = "agNumberColumnFloatingFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFloatingFilterType = "agDateColumnFloatingFilter";
            else defaultFloatingFilterType = "agTextColumnFloatingFilter";
        }
        return defaultFloatingFilterType;
    }
    createFilterInstance(column, filterWrapper) {
        const defaultFilter = this.getDefaultFilter(column);
        const colDef = column.getColDef();
        let filterInstance;
        const params = {
            ...this.createFilterParams(column, colDef),
            filterModifiedCallback: ()=>this.filterModifiedCallbackFactory(filterInstance, column)(),
            filterChangedCallback: (additionalEventAttributes)=>this.filterChangedCallbackFactory(filterInstance, column)(additionalEventAttributes),
            doesRowPassOtherFilter: (node)=>this.beans.filterManager?.doesRowPassOtherFilters(filterInstance, node) ?? true
        };
        const compDetails = $437b23f6a393c3bf$export$e6db9a2d59456da0(this.beans.userCompFactory, colDef, params, defaultFilter);
        if (!compDetails) return {
            filterPromise: null,
            compDetails: null
        };
        return {
            filterPromise: ()=>{
                const filterPromise = compDetails.newAgStackInstance();
                filterPromise.then((r)=>{
                    filterInstance = r;
                    if (filterWrapper) filterWrapper.filter = r ?? void 0;
                });
                return filterPromise;
            },
            compDetails: compDetails
        };
    }
    createFilterParams(column, colDef) {
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            colDef: colDef,
            rowModel: this.beans.rowModel,
            // @deprecated v33.1
            filterChangedCallback: ()=>{},
            filterModifiedCallback: ()=>{},
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: ()=>true
        });
        return params;
    }
    createFilterWrapper(column) {
        const filterWrapper = {
            column: column,
            filterPromise: null,
            compDetails: null
        };
        const { filterPromise: filterPromise, compDetails: compDetails } = this.createFilterInstance(column, filterWrapper);
        filterWrapper.filterPromise = filterPromise?.() ?? null;
        filterWrapper.compDetails = compDetails;
        return filterWrapper;
    }
    onColumnsChanged() {
        const columns = [];
        const { colModel: colModel, filterManager: filterManager } = this.beans;
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = colModel.getColDefCol(colId);
            else currentColumn = colModel.getCol(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        const allFiltersAreGroupFilters = columns.every($437b23f6a393c3bf$var$isGroupFilter);
        if (columns.length > 0 && !allFiltersAreGroupFilters) filterManager?.onFilterChanged({
            columns: columns,
            source: "api"
        });
        else this.updateDependentFilters();
    }
    updateDependentFilters() {
        this.beans.autoColSvc?.getColumns()?.forEach((groupColumn)=>{
            if ($437b23f6a393c3bf$var$isGroupFilter(groupColumn)) this.getOrCreateFilterWrapper(groupColumn);
        });
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const { filter: filter } = this.allColumnFilters.get(column.getColId()) ?? {};
        if (filter) return typeof filter?.isFilterAllowed === "function" ? filter.isFilterAllowed() : true;
        return true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getOrCreateFilterWrapper(column)?.filterPromise;
            if (filterComponent == null) return;
            filterComponent.then((instance)=>{
                callback($437b23f6a393c3bf$export$213d4c63c3df47e4(instance));
            });
        };
        const colDef = column.getColDef();
        const filterParams = {
            ...this.createFilterParams(column, colDef),
            filterChangedCallback: ()=>parentFilterInstance((filterInstance)=>this.filterChangedCallbackFactory(filterInstance, column)())
        };
        const { userCompFactory: userCompFactory, frameworkOverrides: frameworkOverrides } = this.beans;
        const finalFilterParams = $437b23f6a393c3bf$var$_mergeFilterParamsWithApplicationProvidedParams(userCompFactory, colDef, filterParams);
        let defaultFloatingFilterType = $437b23f6a393c3bf$export$47072b32bdaf5d61(frameworkOverrides, colDef, ()=>this.getDefaultFloatingFilter(column));
        if (defaultFloatingFilterType == null) defaultFloatingFilterType = "agReadOnlyFloatingFilter";
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            column: column,
            filterParams: finalFilterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance: parentFilterInstance,
            showParentFilter: showParentFilter
        });
        return $437b23f6a393c3bf$export$14d0998f093f007e(userCompFactory, colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        return this.getModelFromFilterWrapper(this.cachedFilter(column) ?? {
            column: column
        });
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialFilterModel[colId];
        if (filterWrapper) this.disposeFilterWrapper(filterWrapper, source).then((wasActive)=>{
            if (wasActive && this.isAlive()) this.beans.filterManager?.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        });
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        return filterWrapper.filterPromise?.then((filter)=>{
            const isActive = !!filter?.isFilterActive();
            this.destroyBean(filter);
            this.setColFilterActive(filterWrapper.column, false, "filterDestroyed");
            this.allColumnFilters.delete(filterWrapper.column.getColId());
            this.eventSvc.dispatchEvent({
                type: "filterDestroyed",
                source: source,
                column: filterWrapper.column
            });
            return isActive;
        }) ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve(false);
    }
    filterModifiedCallbackFactory(filter, column) {
        return ()=>{
            this.eventSvc.dispatchEvent({
                type: "filterModified",
                column: column,
                filterInstance: filter
            });
        };
    }
    filterChangedCallbackFactory(filter, column) {
        return (additionalEventAttributes)=>{
            const source = additionalEventAttributes?.source ?? "columnFilter";
            const params = {
                filter: filter,
                additionalEventAttributes: additionalEventAttributes,
                columns: [
                    column
                ],
                source: source
            };
            this.callOnFilterChangedOutsideRenderCycle(params);
        };
    }
    checkDestroyFilter(colId) {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const column = filterWrapper.column;
        const { compDetails: compDetails } = column.isFilterAllowed() ? this.createFilterInstance(column) : {
            compDetails: null
        };
        if (this.areFilterCompsDifferent(filterWrapper.compDetails, compDetails)) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const newFilterParams = column.getColDef().filterParams;
        if (!filterWrapper.filterPromise) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        filterWrapper.filterPromise.then((filter)=>{
            const shouldRefreshFilter = filter?.refresh ? filter.refresh({
                ...this.createFilterParams(column, column.getColDef()),
                filterModifiedCallback: this.filterModifiedCallbackFactory(filter, column),
                filterChangedCallback: this.filterChangedCallbackFactory(filter, column),
                doesRowPassOtherFilter: (node)=>this.beans.filterManager?.doesRowPassOtherFilters(filter, node) ?? true,
                ...newFilterParams
            }) : true;
            if (shouldRefreshFilter === false) this.destroyFilter(column, "paramsUpdated");
        });
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListeners(column, {
            colDefChanged: ()=>this.checkDestroyFilter(colId)
        })[0]);
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        oldComponentClass?.render && newComponentClass?.render && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    hasFloatingFilters() {
        const gridColumns = this.beans.colModel.getCols();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getColumnFilterInstance(key) {
        return new Promise((resolve)=>{
            this.getFilterInstanceImpl(key).then((filter)=>{
                resolve($437b23f6a393c3bf$export$213d4c63c3df47e4(filter));
            });
        });
    }
    getFilterInstanceImpl(key) {
        const column = this.beans.colModel.getColDefCol(key);
        if (!column) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(void 0);
        const filterPromise = this.getOrCreateFilterWrapper(column)?.filterPromise;
        return filterPromise ?? $437b23f6a393c3bf$export$30ec7836a4847721.resolve(null);
    }
    processFilterModelUpdateQueue() {
        this.filterModelUpdateQueue.forEach(({ model: model, source: source })=>this.setFilterModel(model, source));
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue.forEach(({ key: key, model: model, resolve: resolve })=>{
            this.setColumnFilterModel(key, model).then(()=>resolve());
        });
        this.columnFilterModelUpdateQueue = [];
    }
    getColumnFilterModel(key) {
        const filterWrapper = this.getFilterWrapper(key);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setColumnFilterModel(key, model) {
        const { colModel: colModel, dataTypeSvc: dataTypeSvc } = this.beans;
        if (dataTypeSvc?.isPendingInference) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnFilterModelUpdateQueue.push({
                key: key,
                model: model,
                resolve: resolve
            });
            return promise;
        }
        const column = colModel.getColDefCol(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column) : null;
        const convertPromise = (promise)=>{
            return new Promise((resolve)=>{
                promise.then((result)=>resolve(result));
            });
        };
        return filterWrapper ? convertPromise($437b23f6a393c3bf$var$setModelOnFilterWrapper(filterWrapper.filterPromise, model)) : Promise.resolve();
    }
    getFilterWrapper(key) {
        const column = this.beans.colModel.getColDefCol(key);
        return column ? this.cachedFilter(column) ?? null : null;
    }
    setColDefPropertiesForDataType(colDef, dataTypeDefinition, formatValue) {
        const usingSetFilter = $437b23f6a393c3bf$var$_isSetFilterByDefault(this.gos);
        const translate = this.getLocaleTextFunc();
        const mergeFilterParams = (params)=>{
            const { filterParams: filterParams } = colDef;
            colDef.filterParams = typeof filterParams === "object" ? {
                ...filterParams,
                ...params
            } : params;
        };
        switch(dataTypeDefinition.baseDataType){
            case "number":
                if (usingSetFilter) mergeFilterParams({
                    comparator: $437b23f6a393c3bf$var$setFilterNumberComparator
                });
                break;
            case "boolean":
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return translate("blanks", "(Blanks)");
                        return translate(String(params.value), params.value ? "True" : "False");
                    }
                });
                else mergeFilterParams({
                    maxNumConditions: 1,
                    debounceMs: 0,
                    filterOptions: [
                        "empty",
                        {
                            displayKey: "true",
                            displayName: "True",
                            predicate: (_filterValues, cellValue)=>cellValue,
                            numberOfInputs: 0
                        },
                        {
                            displayKey: "false",
                            displayName: "False",
                            predicate: (_filterValues, cellValue)=>cellValue === false,
                            numberOfInputs: 0
                        }
                    ]
                });
                break;
            case "date":
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params);
                        return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    },
                    treeList: true,
                    treeListFormatter: (pathKey, level)=>{
                        if (pathKey === "NaN") return translate("invalidDate", "Invalid Date");
                        if (level === 1 && pathKey != null) {
                            const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                            return translate(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                        }
                        return pathKey ?? translate("blanks", "(Blanks)");
                    }
                });
                else mergeFilterParams({
                    isValidDate: $437b23f6a393c3bf$var$isValidDate
                });
                break;
            case "dateString":
                {
                    const convertToDate = dataTypeDefinition.dateParser;
                    if (usingSetFilter) mergeFilterParams({
                        valueFormatter: (params)=>{
                            const valueFormatted = formatValue(params);
                            return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                        },
                        treeList: true,
                        treeListPathGetter: (value)=>{
                            const date = convertToDate(value ?? void 0);
                            return date ? [
                                String(date.getFullYear()),
                                String(date.getMonth() + 1),
                                String(date.getDate())
                            ] : null;
                        },
                        treeListFormatter: (pathKey, level)=>{
                            if (level === 1 && pathKey != null) {
                                const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                                return translate(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                            }
                            return pathKey ?? translate("blanks", "(Blanks)");
                        }
                    });
                    else mergeFilterParams({
                        comparator: (filterDate, cellValue)=>{
                            const cellAsDate = convertToDate(cellValue);
                            if (cellValue == null || cellAsDate < filterDate) return -1;
                            if (cellAsDate > filterDate) return 1;
                            return 0;
                        },
                        isValidDate: (value)=>typeof value === "string" && $437b23f6a393c3bf$var$isValidDate(convertToDate(value))
                    });
                    break;
                }
            case "object":
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params);
                        return $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    }
                });
                else colDef.filterValueGetter = (params)=>formatValue({
                        column: params.column,
                        node: params.node,
                        value: this.beans.valueSvc.getValue(params.column, params.node)
                    });
                break;
        }
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setColFilterActive(column, active, source, additionalEventAttributes) {
        if (column.filterActive !== active) {
            column.filterActive = active;
            column.dispatchColEvent("filterActiveChanged", source);
        }
        column.dispatchColEvent("filterChanged", source, additionalEventAttributes);
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
    }
};
function $437b23f6a393c3bf$var$setModelOnFilterWrapper(filterPromise, newModel) {
    if (!filterPromise) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
        filterPromise.then((filter)=>{
            if (typeof filter.setModel !== "function") {
                $437b23f6a393c3bf$export$545083624300f13d(65);
                resolve();
            }
            (filter.setModel(newModel) || $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>resolve());
        });
    });
}
function $437b23f6a393c3bf$var$isGroupFilter(column) {
    return column.getColDef().filter === "agGroupColumnFilter";
}
function $437b23f6a393c3bf$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}
// packages/ag-grid-community/src/filter/filterApi.ts
function $437b23f6a393c3bf$var$isAnyFilterPresent(beans) {
    return !!beans.filterManager?.isAnyFilterPresent();
}
function $437b23f6a393c3bf$var$onFilterChanged(beans, source = "api") {
    beans.filterManager?.onFilterChanged({
        source: source
    });
}
// packages/ag-grid-community/src/filter/filterManager.ts
var $437b23f6a393c3bf$var$FilterManager = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterManager";
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.advFilterModelUpdateQueue = [];
    }
    wireBeans(beans) {
        this.quickFilter = beans.quickFilter;
        this.advancedFilter = beans.advancedFilter;
        this.colFilter = beans.colFilter;
    }
    postConstruct() {
        const refreshFiltersForAggregations = this.refreshFiltersForAggregations.bind(this);
        const updateAdvFilterColumns = this.updateAdvFilterColumns.bind(this);
        this.addManagedEventListeners({
            columnValueChanged: refreshFiltersForAggregations,
            columnPivotChanged: refreshFiltersForAggregations,
            columnPivotModeChanged: refreshFiltersForAggregations,
            newColumnsLoaded: updateAdvFilterColumns,
            columnVisible: updateAdvFilterColumns,
            advancedFilterEnabledChanged: ({ enabled: enabled })=>this.onAdvFilterEnabledChanged(enabled),
            dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
        });
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        if (this.quickFilter) this.addManagedListeners(this.quickFilter, {
            quickFilterChanged: ()=>this.onFilterChanged({
                    source: "quickFilter"
                })
        });
        const { gos: gos } = this;
        this.alwaysPassFilter = gos.get("alwaysPassFilter");
        this.addManagedPropertyListener("alwaysPassFilter", ()=>{
            this.alwaysPassFilter = gos.get("alwaysPassFilter");
            this.onFilterChanged({
                source: "api"
            });
        });
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        return typeof isFilterPresent === "function" && isFilterPresent({});
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        return typeof doesFilterPass === "function" && doesFilterPass(node);
    }
    setFilterModel(model, source = "api") {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return;
        }
        this.colFilter?.setFilterModel(model, source);
    }
    getFilterModel() {
        return this.colFilter?.getFilterModel() ?? {};
    }
    isColumnFilterPresent() {
        return !!this.colFilter?.isColumnFilterPresent();
    }
    isAggregateFilterPresent() {
        return !!this.colFilter?.isAggregateFilterPresent();
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
    }
    isAnyFilterPresent() {
        return this.isChildFilterPresent() || this.isAggregateFilterPresent();
    }
    isAdvFilterPresent() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
    }
    onAdvFilterEnabledChanged(enabled) {
        if (enabled) {
            if (this.colFilter?.disableColumnFilters()) this.onFilterChanged({
                source: "advancedFilter"
            });
        } else if (this.advancedFilter?.isFilterPresent()) {
            this.advancedFilter.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvFilterEnabled() {
        return !!this.advancedFilter?.isEnabled();
    }
    isAdvFilterHeaderActive() {
        return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
    }
    refreshFiltersForAggregations() {
        const isAggFiltering = $437b23f6a393c3bf$export$3708afee0330994(this.gos);
        if (isAggFiltering) this.onFilterChanged();
    }
    onFilterChanged(params = {}) {
        const { source: source, additionalEventAttributes: additionalEventAttributes, columns: columns = [] } = params;
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        (this.colFilter ? this.colFilter.updateBeforeFilterChanged(params) : $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>{
            const filterChangedEvent = {
                source: source,
                type: "filterChanged",
                columns: columns
            };
            if (additionalEventAttributes) $437b23f6a393c3bf$export$8ade6bd474fcde42(filterChangedEvent, additionalEventAttributes);
            this.eventSvc.dispatchEvent(filterChangedEvent);
            this.colFilter?.updateAfterFilterChanged();
        });
    }
    isSuppressFlashingCellsBecauseFiltering() {
        return !!this.colFilter?.isSuppressFlashingCellsBecauseFiltering();
    }
    isQuickFilterPresent() {
        return !!this.quickFilter?.isFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!$437b23f6a393c3bf$export$3708afee0330994(this.gos);
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(filterToSkip, node) {
        return this.doesRowPassFilter({
            rowNode: node,
            filterInstanceToSkip: filterToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.colFilter.doAggregateFiltersPass(rowNode, params.filterInstanceToSkip)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        const { rowNode: rowNode } = params;
        if (this.alwaysPassFilter?.(rowNode)) return true;
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(rowNode)) return false;
        if (this.externalFilterPresent && !this.doesExternalFilterPass(rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.colFilter.doColumnFiltersPass(rowNode, params.filterInstanceToSkip)) return false;
        if (this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(rowNode)) return false;
        return true;
    }
    isFilterActive(column) {
        return !!this.colFilter?.isFilterActive(column);
    }
    getOrCreateFilterWrapper(column) {
        return this.colFilter?.getOrCreateFilterWrapper(column) ?? null;
    }
    getDefaultFloatingFilter(column) {
        return this.colFilter.getDefaultFloatingFilter(column);
    }
    createFilterParams(column, colDef) {
        return this.colFilter.createFilterParams(column, colDef);
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.isFilterAllowed(column);
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        return this.colFilter?.getFloatingFilterCompDetails(column, showParentFilter);
    }
    getCurrentFloatingFilterParentModel(column) {
        return this.colFilter?.getCurrentFloatingFilterParentModel(column);
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        this.colFilter?.destroyFilter(column, source);
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        return !!this.colFilter?.areFilterCompsDifferent(oldCompDetails, newCompDetails);
    }
    getAdvFilterModel() {
        return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
    }
    setAdvFilterModel(expression, source = "api") {
        if (!this.isAdvFilterEnabled()) return;
        if (this.beans.dataTypeSvc?.isPendingInference) {
            this.advFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilter.setModel(expression ?? null);
        this.onFilterChanged({
            source: source
        });
    }
    toggleAdvFilterBuilder(show, source) {
        if (!this.isAdvFilterEnabled()) return;
        this.advancedFilter.getCtrl().toggleFilterBuilder({
            source: source,
            force: show
        });
    }
    updateAdvFilterColumns() {
        if (!this.isAdvFilterEnabled()) return;
        if (this.advancedFilter.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvFilterEnabled()) return false;
        return !!this.colFilter?.hasFloatingFilters();
    }
    getColumnFilterInstance(key) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve(void 0);
        }
        return this.colFilter?.getColumnFilterInstance(key) ?? Promise.resolve(void 0);
    }
    warnAdvFilters() {
        $437b23f6a393c3bf$export$545083624300f13d(68);
    }
    setupAdvFilterHeaderComp(eCompToInsertBefore) {
        this.advancedFilter?.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        this.advFilterModelUpdateQueue.forEach((model)=>this.setAdvFilterModel(model));
        this.advFilterModelUpdateQueue = [];
    }
    getColumnFilterModel(key) {
        return this.colFilter?.getColumnFilterModel(key);
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvFilterEnabled()) {
            this.warnAdvFilters();
            return Promise.resolve();
        }
        return this.colFilter?.setColumnFilterModel(key, model) ?? Promise.resolve();
    }
    setColDefPropertiesForDataType(colDef, dataTypeDefinition, formatValue) {
        this.colFilter?.setColDefPropertiesForDataType(colDef, dataTypeDefinition, formatValue);
    }
};
// packages/ag-grid-community/src/filter/filterMenuFactory.ts
var $437b23f6a393c3bf$var$FilterMenuFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterMenuFactory";
    }
    wireBeans(beans) {
        this.popupSvc = beans.popupSvc;
    }
    hideActiveMenu() {
        this.hidePopup?.();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupUnderMouseEvent({
                column: column,
                type: containerType,
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos), onClosedCallback);
    }
    showMenuAfterButtonClick(column, eventSource, containerType, onClosedCallback) {
        if (column && !column.isColumn) return;
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = $437b23f6a393c3bf$export$2f1c8e943ce1a1be(this.gos);
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        const nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupSvc?.positionPopupByComponent({
                type: containerType,
                eventSource: eventSource,
                ePopup: eMenu,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                alignSide: alignSide,
                keepWithinBounds: true,
                position: "under",
                column: column
            });
        }, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled, onClosedCallback) {
        const comp = column ? this.createBean(new $437b23f6a393c3bf$export$70acaf0e0e30e7d(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!comp?.hasFilter() || !column) {
            $437b23f6a393c3bf$export$a20c7248650823a9(57);
            return;
        }
        const eMenu = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-menu${!isLegacyMenuEnabled ? " ag-filter-menu" : ""}`,
            role: "presentation"
        });
        [this.tabListener] = this.addManagedElementListeners(eMenu, {
            keydown: (e)=>this.trapFocusWithin(e, eMenu)
        });
        eMenu.appendChild(comp?.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp?.afterGuiDetached();
        const anchorToElement = $437b23f6a393c3bf$export$cfe4cf52f3717a7b(this.gos) ? eventSource ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0;
        const closedCallback = (e)=>{
            $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && $437b23f6a393c3bf$export$2badf4aa566524cb(eventSource)) {
                const focusableEl = $437b23f6a393c3bf$export$c4c49c776025d475(eventSource);
                focusableEl?.focus({
                    preventScroll: true
                });
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
            onClosedCallback?.();
        };
        const translate = this.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupSvc?.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback: closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement: anchorToElement,
            ariaLabel: ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup: hidePopup
            });
        });
        $437b23f6a393c3bf$export$2f1bf9feac2f7fbd(column, true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || $437b23f6a393c3bf$export$83fc12531358bd28(this.beans, menu, false, e.shiftKey)) return;
        e.preventDefault();
        $437b23f6a393c3bf$export$8598088d375f416f(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        this.eventSvc.dispatchEvent({
            type: "columnMenuVisibleChanged",
            visible: visible,
            switchingTab: false,
            key: containerType,
            column: column ?? null,
            columnGroup: null
        });
    }
    isMenuEnabled(column) {
        return column.isFilterAllowed() && (column.getColDef().menuTabs ?? [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
// packages/ag-grid-community/src/filter/filterValueService.ts
var $437b23f6a393c3bf$var$FilterValueService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "filterValueSvc";
    }
    getValue(column, rowNode) {
        if (!rowNode) return;
        const colDef = column.getColDef();
        const { filterValueGetter: filterValueGetter } = colDef;
        if (filterValueGetter) return this.executeFilterValueGetter(filterValueGetter, rowNode.data, column, rowNode, colDef);
        return this.beans.valueSvc.getValue(column, rowNode);
    }
    executeFilterValueGetter(valueGetter, data, column, node, colDef) {
        const { expressionSvc: expressionSvc, valueSvc: valueSvc } = this.beans;
        const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            data: data,
            node: node,
            column: column,
            colDef: colDef,
            getValue: valueSvc.getValueCallback.bind(valueSvc, node)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return expressionSvc?.evaluate(valueGetter, params);
    }
};
// packages/ag-grid-community/src/filter/floating/provided/readOnlyFloatingFilter.ts
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eFloatingFilterText"
        }
    ]
};
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$ReadOnlyFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eFloatingFilterText = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`);
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    refresh(params) {
        this.init(params);
    }
};
// packages/ag-grid-community/src/filter/provided/optionsFactory.ts
var $437b23f6a393c3bf$var$OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions || defaultOptions;
        this.mapCustomOptions();
        this.selectDefaultItem(params);
    }
    mapCustomOptions() {
        const { filterOptions: filterOptions } = this;
        if (!filterOptions) return;
        filterOptions.forEach((filterOption)=>{
            if (typeof filterOption === "string") return;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys)=>{
                if (!keys.some((key)=>filterOption[key] != null)) {
                    $437b23f6a393c3bf$export$545083624300f13d(72, {
                        keys: keys
                    });
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = filterOptions.filter((v)=>v === filterOption) || [];
                return;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        });
    }
    selectDefaultItem(params) {
        const { filterOptions: filterOptions } = this;
        if (params.defaultOption) this.defaultOption = params.defaultOption;
        else if (filterOptions.length >= 1) {
            const firstFilterOption = filterOptions[0];
            if (typeof firstFilterOption === "string") this.defaultOption = firstFilterOption;
            else if (firstFilterOption.displayKey) this.defaultOption = firstFilterOption.displayKey;
            else $437b23f6a393c3bf$export$545083624300f13d(73);
        } else $437b23f6a393c3bf$export$545083624300f13d(74);
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// packages/ag-grid-community/src/filter/provided/simpleFilterUtils.ts
function $437b23f6a393c3bf$var$removeItems(items, startPosition, deleteCount) {
    return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
}
function $437b23f6a393c3bf$var$isBlank(cellValue) {
    return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
}
function $437b23f6a393c3bf$var$getDefaultJoinOperator(defaultJoinOperator) {
    return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
}
function $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue) {
    if (customFilterOption == null) return;
    const { predicate: predicate } = customFilterOption;
    if (predicate != null && !values.some((v)=>v == null)) return predicate(values, cellValue);
    return;
}
function $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, maxNumConditions) {
    let numConditions = conditions.length;
    if (numConditions > maxNumConditions) {
        conditions.splice(maxNumConditions);
        $437b23f6a393c3bf$export$545083624300f13d(78);
        numConditions = maxNumConditions;
    }
    return numConditions;
}
// packages/ag-grid-community/src/filter/provided/simpleFilter.ts
var $437b23f6a393c3bf$var$SimpleFilter = class extends $437b23f6a393c3bf$export$a927a1327c2cc7f0 {
    constructor(){
        super(...arguments);
        this.eTypes = [];
        this.eJoinOperatorPanels = [];
        this.eJoinOperatorsAnd = [];
        this.eJoinOperatorsOr = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    getNumberOfInputs(type) {
        const customOpts = this.optionsFactory.getCustomOption(type);
        if (customOpts) {
            const { numberOfInputs: numberOfInputs } = customOpts;
            return numberOfInputs != null ? numberOfInputs : 1;
        }
        const zeroInputTypes = [
            "empty",
            "notBlank",
            "blank"
        ];
        if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
        else if (type === "inRange") return 2;
        return 1;
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged(true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            const value = position === 0 ? type : this.optionsFactory.defaultOption;
            eType.setValue(value, true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.filterType,
            operator: this.getJoinOperator(),
            conditions: conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        const { eJoinOperatorsOr: eJoinOperatorsOr, defaultJoinOperator: defaultJoinOperator } = this;
        return eJoinOperatorsOr.length === 0 ? defaultJoinOperator : eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areModelsEqual(a, b) {
        if (!a && !b) return true;
        if (!a && b || a && !b) return false;
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && $437b23f6a393c3bf$export$893967cdb9833fdd(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    shouldRefresh(newParams) {
        const model = this.getModel();
        const conditions = model ? model.conditions ?? [
            model
        ] : null;
        const newOptionsList = newParams.filterOptions?.map((option)=>typeof option === "string" ? option : option.displayKey) ?? this.getDefaultFilterOptions();
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) return false;
        if (typeof newParams.maxNumConditions === "number" && conditions && conditions.length > newParams.maxNumConditions) return false;
        return true;
    }
    refresh(newParams) {
        if (!this.shouldRefresh(newParams)) return false;
        const parentRefreshed = super.refresh(newParams);
        if (!parentRefreshed) return false;
        this.setParams(newParams);
        this.removeConditionsAndOperators(0);
        this.createOption();
        this.setModel(this.getModel());
        return true;
    }
    setModelIntoUi(model) {
        const isCombined = model.operator;
        if (isCombined) {
            const combinedModel = model;
            let conditions = combinedModel.conditions;
            if (conditions == null) {
                conditions = [];
                $437b23f6a393c3bf$export$545083624300f13d(77);
            }
            const numConditions = $437b23f6a393c3bf$var$validateAndUpdateConditions(conditions, this.maxNumConditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOperatorsOr.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.onUiChanged();
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    doesFilterPass(params) {
        const model = this.getModel();
        if (model == null) return true;
        const { operator: operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...combinedModel.conditions ?? []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m));
    }
    setParams(params) {
        super.setParams(params);
        this.setNumConditions(params);
        this.defaultJoinOperator = $437b23f6a393c3bf$var$getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory.init(params, this.getDefaultFilterOptions());
        this.createFilterListOptions();
        this.createOption();
        this.createMissingConditionsAndOperators();
        if (this.isReadOnly()) this.eFilterBody.setAttribute("tabindex", "-1");
    }
    setNumConditions(params) {
        let maxNumConditions = params.maxNumConditions ?? 2;
        if (maxNumConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(79);
            maxNumConditions = 1;
        }
        this.maxNumConditions = maxNumConditions;
        let numAlwaysVisibleConditions = params.numAlwaysVisibleConditions ?? 1;
        if (numAlwaysVisibleConditions < 1) {
            $437b23f6a393c3bf$export$545083624300f13d(80);
            numAlwaysVisibleConditions = 1;
        }
        if (numAlwaysVisibleConditions > maxNumConditions) {
            $437b23f6a393c3bf$export$545083624300f13d(81);
            numAlwaysVisibleConditions = maxNumConditions;
        }
        this.numAlwaysVisibleConditions = numAlwaysVisibleConditions;
    }
    createOption() {
        const eType = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032());
        this.eTypes.push(eType);
        eType.addCss("ag-filter-select");
        this.eFilterBody.appendChild(eType.getGui());
        const eConditionBody = this.createValueElement();
        this.eConditionBodies.push(eConditionBody);
        this.eFilterBody.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-condition"
        });
        this.eJoinOperatorPanels.push(eJoinOperatorPanel);
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinOperatorsAnd, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOperatorsOr, eJoinOperatorPanel, "or");
        this.eFilterBody.appendChild(eJoinOperatorPanel);
        const index = this.eJoinOperatorPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new $437b23f6a393c3bf$export$5caa9ea96bbb722());
        eJoinOperators.push(eJoinOperator);
        const baseClass = "ag-filter-condition-operator";
        eJoinOperator.addCss(baseClass);
        eJoinOperator.addCss(`${baseClass}-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    createFilterListOptions() {
        this.filterListOptions = this.optionsFactory.filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        const { filterListOptions: filterListOptions } = this;
        filterListOptions.forEach((listOption)=>{
            eType.addOption(listOption);
        });
        eType.setDisabled(filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey: displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    createBodyTemplate() {
        return null;
    }
    getAgComponents() {
        return [];
    }
    getCssIdentifier() {
        return "simple-filter";
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                $437b23f6a393c3bf$export$b6b4f08392e9bfaf(this.eJoinOperatorPanels[0], disabled);
                this.eJoinOperatorsAnd[0].setDisabled(disabled);
                this.eJoinOperatorsOr[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            $437b23f6a393c3bf$export$9405f1cbb4e2383f(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator ?? this.getJoinOperator()) === "OR";
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd)=>{
            eJoinOperatorAnd.setValue(!orChecked, true);
        });
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr)=>{
            eJoinOperatorOr.setValue(orChecked, true);
        });
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        const { eTypes: eTypes, eConditionBodies: eConditionBodies, eJoinOperatorPanels: eJoinOperatorPanels, eJoinOperatorsAnd: eJoinOperatorsAnd, eJoinOperatorsOr: eJoinOperatorsOr } = this;
        this.removeComponents(eTypes, startPosition, deleteCount);
        this.removeElements(eConditionBodies, startPosition, deleteCount);
        this.removeValueElements(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = $437b23f6a393c3bf$var$removeItems(elements, startPosition, deleteCount);
        removedElements.forEach((element)=>$437b23f6a393c3bf$export$dd4d52e41fb4cef5(element));
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>{
            $437b23f6a393c3bf$export$dd4d52e41fb4cef5(comp.getGui());
            this.destroyBean(comp);
        });
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!params?.suppressFocus) {
            const { eFilterBody: eFilterBody, eTypes: eTypes } = this;
            let elementToFocus;
            if (!this.isReadOnly()) {
                const firstInput = this.getInputs(0)[0];
                if (firstInput instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3 && this.isConditionBodyVisible(0)) elementToFocus = firstInput.getInputElement();
                else elementToFocus = eTypes[0]?.getFocusableElement();
            }
            (elementToFocus ?? eFilterBody).focus({
                preventScroll: true
            });
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const appliedModel = this.getModel();
        this.resetUiToActiveModel(appliedModel);
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getPlaceholderText(defaultPlaceholder, position) {
        let placeholder = this.translate(defaultPlaceholder);
        if (typeof this.filterPlaceholder === "function") {
            const filterOptionKey = this.eTypes[position].getValue();
            const filterOption = this.translate(filterOptionKey);
            placeholder = this.filterPlaceholder({
                filterOptionKey: filterOptionKey,
                filterOption: filterOption,
                placeholder: placeholder
            });
        } else if (typeof this.filterPlaceholder === "string") placeholder = this.filterPlaceholder;
        return placeholder;
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3)) return;
            const placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            element.setInputPlaceholder(this.getPlaceholderText(placeholder, position));
            element.setInputAriaLabel(ariaLabel);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$export$9405f1cbb4e2383f(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$export$b6b4f08392e9bfaf(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof $437b23f6a393c3bf$export$9671f513d4aa42e3) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = this.getNumberOfInputs(type);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = this.getNumberOfInputs(type);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === "empty") return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        if (!silent) this.onUiChanged();
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    resetType(eType) {
        const translate = this.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.defaultOption, true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.defaultJoinOperator === "AND", this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.defaultJoinOperator === "OR", this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        const updater = (eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index);
        this.eJoinOperatorsAnd.forEach(updater);
        this.eJoinOperatorsOr.forEach(updater);
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values = this.mapValuesFromModel(model);
        this.forEachInput((element, index, elPosition)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values[index] != null ? values[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel) {
        const cellValue = this.getCellValue(params.node);
        const values = this.mapValuesFromModel(filterModel);
        const customFilterOption = this.optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = $437b23f6a393c3bf$var$evaluateCustomFilter(customFilterOption, values, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values, cellValue, filterModel, params);
    }
    hasInvalidInputs() {
        return false;
    }
};
// packages/ag-grid-community/src/filter/provided/scalarFilter.ts
var $437b23f6a393c3bf$var$ScalarFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    setParams(params) {
        super.setParams(params);
        this.scalarFilterParams = params;
    }
    evaluateNullValue(filterType) {
        const { includeBlanksInEquals: includeBlanksInEquals, includeBlanksInNotEqual: includeBlanksInNotEqual, includeBlanksInGreaterThan: includeBlanksInGreaterThan, includeBlanksInLessThan: includeBlanksInLessThan, includeBlanksInRange: includeBlanksInRange } = this.scalarFilterParams;
        switch(filterType){
            case "equals":
                if (includeBlanksInEquals) return true;
                break;
            case "notEqual":
                if (includeBlanksInNotEqual) return true;
                break;
            case "greaterThan":
            case "greaterThanOrEqual":
                if (includeBlanksInGreaterThan) return true;
                break;
            case "lessThan":
            case "lessThanOrEqual":
                if (includeBlanksInLessThan) return true;
                break;
            case "inRange":
                if (includeBlanksInRange) return true;
                break;
            case "blank":
                return true;
            case "notBlank":
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values, cellValue, filterModel) {
        const type = filterModel.type;
        if (!this.isValid(cellValue)) return type === "notEqual" || type === "notBlank";
        const comparator = this.comparator();
        const compareResult = values[0] != null ? comparator(values[0], cellValue) : 0;
        switch(type){
            case "equals":
                return compareResult === 0;
            case "notEqual":
                return compareResult !== 0;
            case "greaterThan":
                return compareResult > 0;
            case "greaterThanOrEqual":
                return compareResult >= 0;
            case "lessThan":
                return compareResult < 0;
            case "lessThanOrEqual":
                return compareResult <= 0;
            case "inRange":
                {
                    const compareToResult = comparator(values[1], cellValue);
                    return this.scalarFilterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case "blank":
                return $437b23f6a393c3bf$var$isBlank(cellValue);
            case "notBlank":
                return !$437b23f6a393c3bf$var$isBlank(cellValue);
            default:
                $437b23f6a393c3bf$export$545083624300f13d(76, {
                    filterModelType: type
                });
                return true;
        }
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateCompWrapper.ts
var $437b23f6a393c3bf$var$DateCompWrapper = class {
    constructor(context, userCompFactory, colDef, dateComponentParams, eParent, onReady){
        this.alive = true;
        this.context = context;
        this.eParent = eParent;
        const compDetails = $437b23f6a393c3bf$var$_getDateCompDetails(userCompFactory, colDef, dateComponentParams);
        if (!compDetails) return;
        compDetails.newAgStackInstance().then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            dateComp?.afterGuiAttached?.();
            const { tempValue: tempValue, disabled: disabled } = this;
            if (tempValue) dateComp.setDate(tempValue);
            if (disabled != null) dateComp.setDisabled?.(disabled);
            onReady?.(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        const dateComp = this.dateComp;
        if (dateComp) dateComp.setDisabled?.(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        this.dateComp?.setInputPlaceholder?.(placeholder);
    }
    setInputAriaLabel(label) {
        this.dateComp?.setInputAriaLabel?.(label);
    }
    afterGuiAttached(params) {
        this.dateComp?.afterGuiAttached?.(params);
    }
    updateParams(params) {
        this.dateComp?.refresh?.(params);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "lessThan",
    "greaterThan",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/simpleFilterModelFormatter.ts
var $437b23f6a393c3bf$var$SimpleFilterModelFormatter = class {
    constructor(getLocaleTextFunc, optionsFactory, valueFormatter){
        this.getLocaleTextFunc = getLocaleTextFunc;
        this.optionsFactory = optionsFactory;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model) {
        if (!model) return null;
        const isCombined = model.operator != null;
        const translate = this.getLocaleTextFunc();
        if (isCombined) {
            const combinedModel = model;
            const conditions = combinedModel.conditions ?? [];
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${translate(joinOperatorTranslateKey, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT[joinOperatorTranslateKey])} `);
        } else if (model.type === "blank" || model.type === "notBlank") return translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey: displayKey, displayName: displayName, numberOfInputs: numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) {
                translate(displayKey, displayName);
                return displayName;
            }
            return this.conditionToString(condition, customOption);
        }
    }
    updateParams(params) {
        this.optionsFactory = params.optionsFactory;
    }
    formatValue(value) {
        const valueFormatter = this.valueFormatter;
        return valueFormatter ? valueFormatter(value ?? null) ?? "" : String(value);
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilterModelFormatter.ts
var $437b23f6a393c3bf$var$DateFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(dateFilterParams, getLocaleTextFunc, optionsFactory){
        super(getLocaleTextFunc, optionsFactory);
        this.dateFilterParams = dateFilterParams;
    }
    conditionToString(condition, options) {
        const { type: type } = condition;
        const { numberOfInputs: numberOfInputs } = options || {};
        const isRange = type == "inRange" || numberOfInputs === 2;
        const dateFrom = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateFrom);
        const dateTo = $437b23f6a393c3bf$export$26ded2d88c01b527(condition.dateTo);
        const format = this.dateFilterParams.inRangeFloatingFilterDateFormat;
        if (isRange) {
            const formattedFrom = dateFrom !== null ? $437b23f6a393c3bf$var$_dateToFormattedString(dateFrom, format) : "null";
            const formattedTo = dateTo !== null ? $437b23f6a393c3bf$var$_dateToFormattedString(dateTo, format) : "null";
            return `${formattedFrom}-${formattedTo}`;
        }
        if (dateFrom != null) return $437b23f6a393c3bf$var$_dateToFormattedString(dateFrom, format);
        return `${type}`;
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateFilterParams = params.dateFilterParams;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFilter.ts
var $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR = 1e3;
var $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR = Infinity;
var $437b23f6a393c3bf$var$DateFilter = class extends $437b23f6a393c3bf$var$ScalarFilter {
    constructor(){
        super("dateFilter");
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR;
        this.maxValidYear = $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
        this.filterType = "date";
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
    }
    mapValuesFromModel(filterModel) {
        const { dateFrom: dateFrom, dateTo: dateTo, type: type } = filterModel || {};
        return [
            dateFrom && $437b23f6a393c3bf$export$26ded2d88c01b527(dateFrom) || null,
            dateTo && $437b23f6a393c3bf$export$26ded2d88c01b527(dateTo) || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    comparator() {
        return this.dateFilterParams.comparator ?? $437b23f6a393c3bf$var$defaultDateComparator;
    }
    isValid(value) {
        const isValidDate2 = this.dateFilterParams.isValidDate;
        return !isValidDate2 || isValidDate2(value);
    }
    setParams(params) {
        this.dateFilterParams = params;
        super.setParams(params);
        const yearParser = (param, fallback)=>{
            if (params[param] != null) {
                if (!isNaN(params[param])) return params[param] == null ? fallback : Number(params[param]);
                else $437b23f6a393c3bf$export$545083624300f13d(82, {
                    param: param
                });
            }
            return fallback;
        };
        this.minValidYear = yearParser("minValidYear", $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR);
        this.maxValidYear = yearParser("maxValidYear", $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR);
        if (this.minValidYear > this.maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(83);
        this.minValidDate = params.minValidDate ? params.minValidDate instanceof Date ? params.minValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(params.minValidDate) : null;
        this.maxValidDate = params.maxValidDate ? params.maxValidDate instanceof Date ? params.maxValidDate : $437b23f6a393c3bf$export$26ded2d88c01b527(params.maxValidDate) : null;
        if (this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate) $437b23f6a393c3bf$export$545083624300f13d(84);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$DateFilterModelFormatter(this.dateFilterParams, this.getLocaleTextFunc.bind(this), this.optionsFactory);
    }
    createDateCompWrapper(element) {
        const { beans: { userCompFactory: userCompFactory, context: context, gos: gos }, dateFilterParams: dateFilterParams } = this;
        const dateCompWrapper = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, dateFilterParams.colDef, $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            onDateChanged: ()=>this.onUiChanged(),
            filterParams: dateFilterParams,
            location: "filter"
        }), element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    setElementValue(element, value) {
        element.setDate(value);
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS;
    }
    createValueElement() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body"
        });
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eConditionPanel = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: `ag-filter-${fromTo} ag-filter-date-${fromTo}`
        });
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        $437b23f6a393c3bf$var$removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = $437b23f6a393c3bf$var$removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>comp.destroy());
    }
    isValidDateValue(value) {
        if (value === null) return false;
        const { minValidDate: minValidDate, maxValidDate: maxValidDate, minValidYear: minValidYear, maxValidYear: maxValidYear } = this;
        if (minValidDate) {
            if (value < minValidDate) return false;
        } else {
            if (value.getUTCFullYear() < minValidYear) return false;
        }
        if (maxValidDate) {
            if (value > maxValidDate) return false;
        } else {
            if (value.getUTCFullYear() > maxValidYear) return false;
        }
        return true;
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachInput((element, index, elPosition, numberOfInputs)=>{
            if (elPosition !== position || !valid || index >= numberOfInputs) return;
            valid = valid && this.isValidDateValue(element.getDate());
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values = this.getValues(position);
        if (values.length > 0) model.dateFrom = $437b23f6a393c3bf$export$3d7fedfb21962874(values[0]);
        if (values.length > 1) model.dateTo = $437b23f6a393c3bf$export$3d7fedfb21962874(values[1]);
        return {
            dateFrom: null,
            dateTo: null,
            filterType: this.filterType,
            type: type,
            ...model
        };
    }
    resetPlaceholder() {
        const globalTranslate = this.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        const { dateConditionFromComps: dateConditionFromComps, dateConditionToComps: dateConditionToComps } = this;
        if (position >= dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            dateConditionFromComps[position],
            dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key) {
        if (key === "lessThan") return super.translate("before");
        if (key === "greaterThan") return super.translate("after");
        return super.translate(key);
    }
    getModelAsString(model) {
        return this.filterModelFormatter.getModelAsString(model) ?? "";
    }
};
function $437b23f6a393c3bf$var$defaultDateComparator(filterDate, cellValue) {
    const cellAsDate = cellValue;
    if (cellAsDate < filterDate) return -1;
    if (cellAsDate > filterDate) return 1;
    return 0;
}
// packages/ag-grid-community/src/filter/floating/provided/simpleFloatingFilter.ts
var $437b23f6a393c3bf$var$SimpleFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.defaultDebounceMs = 0;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.defaultOption;
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        const optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory = optionsFactory;
        optionsFactory.init(params.filterParams, this.getDefaultOptions());
        const defaultOption = optionsFactory.defaultOption;
        if (!update) this.lastType = defaultOption;
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(defaultOption);
        this.setEditable(editable);
    }
    refresh(params) {
        this.setSimpleParams(params);
    }
    hasSingleInput(filterType) {
        const numberOfInputs = this.optionsFactory.getCustomOption(filterType)?.numberOfInputs;
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            "inRange",
            "empty",
            "blank",
            "notBlank"
        ];
        return !!type && !this.readOnly && this.hasSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(params) {
        const displayName = this.beans.colNames.getDisplayNameForColumn(params.column, "header", true);
        return `${displayName} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
    }
};
// packages/ag-grid-community/src/filter/provided/date/dateFloatingFilter.ts
var $437b23f6a393c3bf$var$DateFloatingFilterElement = {
    tag: "div",
    cls: "ag-floating-filter-input",
    role: "presentation",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eReadOnlyText"
        },
        {
            tag: "div",
            ref: "eDateWrapper",
            cls: "ag-date-floating-filter-wrapper"
        }
    ]
};
var $437b23f6a393c3bf$var$DateFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super($437b23f6a393c3bf$var$DateFloatingFilterElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eReadOnlyText = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDateWrapper = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    getDefaultOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_DATE_FILTER_OPTIONS;
    }
    init(params) {
        super.init(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.createDateComponent();
        this.filterModelFormatter = new $437b23f6a393c3bf$var$DateFilterModelFormatter(this.filterParams, this.getLocaleTextFunc.bind(this), this.optionsFactory);
        const translate = this.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    refresh(params) {
        super.refresh(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.dateComp.updateParams(this.getDateComponentParams());
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory,
            dateFilterParams: this.filterParams
        });
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.readOnly && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            const dateModel = model ? $437b23f6a393c3bf$export$26ded2d88c01b527(model.dateFrom) : null;
            this.dateComp.setDate(dateModel);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eDateWrapper, editable);
        $437b23f6a393c3bf$export$9405f1cbb4e2383f(this.eReadOnlyText.getGui(), !editable);
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter || event?.afterDataChange) return;
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        const filterValueText = $437b23f6a393c3bf$export$3d7fedfb21962874(filterValueDate);
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance) {
                const date = $437b23f6a393c3bf$export$26ded2d88c01b527(filterValueText);
                filterInstance.onFloatingFilterChanged(this.lastType || null, date);
            }
        });
    }
    getDateComponentParams() {
        const { filterParams: filterParams, column: column } = this.params;
        const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(filterParams, this.defaultDebounceMs);
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            onDateChanged: $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onDateChanged.bind(this), debounceMs),
            filterParams: column.getColDef().filterParams,
            location: "floatingFilter"
        });
    }
    createDateComponent() {
        const { beans: { context: context, userCompFactory: userCompFactory }, eDateWrapper: eDateWrapper, params: params } = this;
        this.dateComp = new $437b23f6a393c3bf$var$DateCompWrapper(context, userCompFactory, params.column.getColDef(), this.getDateComponentParams(), eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(params));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
};
// packages/ag-grid-community/src/filter/provided/date/defaultDateComponent.ts
var $437b23f6a393c3bf$var$DefaultDateElement = {
    tag: "div",
    cls: "ag-filter-filter",
    children: [
        {
            tag: "ag-input-text-field",
            ref: "eDateInput",
            cls: "ag-date-filter"
        }
    ]
};
var $437b23f6a393c3bf$var$DefaultDateComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$DefaultDateElement, [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ]);
        this.eDateInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.isApply = false;
        this.applyOnFocusOut = false;
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListeners(inputElement, {
            // ensures that the input element is focussed when a clear button is clicked,
            // unless using safari as there is no clear button and focus does not work properly
            mouseDown: ()=>{
                if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
                inputElement.focus({
                    preventScroll: true
                });
            },
            input: this.handleInput.bind(this, false),
            change: this.handleInput.bind(this, true),
            focusout: this.handleFocusOut.bind(this)
        });
    }
    handleInput(isChange) {
        if (this.eDateInput.isDisabled()) return;
        if (this.isApply) {
            this.applyOnFocusOut = !isChange;
            if (isChange) this.params.onDateChanged();
            return;
        }
        if (!isChange) this.params.onDateChanged();
    }
    handleFocusOut() {
        if (this.applyOnFocusOut) {
            this.applyOnFocusOut = false;
            this.params.onDateChanged();
        }
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && $437b23f6a393c3bf$var$_isBrowserSafari();
        inputElement.type = shouldUseBrowserDatePicker ? "date" : "text";
        const { minValidYear: minValidYear, maxValidYear: maxValidYear, minValidDate: minValidDate, maxValidDate: maxValidDate, buttons: buttons } = params.filterParams || {};
        if (minValidDate && minValidYear) $437b23f6a393c3bf$export$545083624300f13d(85);
        if (maxValidDate && maxValidYear) $437b23f6a393c3bf$export$545083624300f13d(86);
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : $437b23f6a393c3bf$export$26ded2d88c01b527(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) $437b23f6a393c3bf$export$545083624300f13d(87);
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = $437b23f6a393c3bf$var$_dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = $437b23f6a393c3bf$var$_dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
        this.isApply = params.location === "floatingFilter" && !!buttons?.includes("apply");
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return $437b23f6a393c3bf$export$26ded2d88c01b527(this.eDateInput.getValue());
    }
    setDate(date) {
        this.eDateInput.setValue($437b23f6a393c3bf$export$3d7fedfb21962874(date, false));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params || !params.suppressFocus) this.eDateInput.getInputElement().focus({
            preventScroll: true
        });
    }
    shouldUseBrowserDatePicker(params) {
        return params?.filterParams?.browserDatePicker ?? true;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS = [
    "equals",
    "notEqual",
    "greaterThan",
    "greaterThanOrEqual",
    "lessThan",
    "lessThanOrEqual",
    "inRange",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/number/numberFilterModelFormatter.ts
var $437b23f6a393c3bf$var$NumberFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs: numberOfInputs } = options || {};
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        const isRange = type == "inRange" || numberOfInputs === 2;
        const formatValue = this.formatValue.bind(this);
        if (isRange) return `${formatValue(filter)}-${formatValue(filterTo)}`;
        if (filter != null) return formatValue(filter);
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFilterUtils.ts
function $437b23f6a393c3bf$var$getAllowedCharPattern(filterParams) {
    const { allowedCharPattern: allowedCharPattern } = filterParams ?? {};
    return allowedCharPattern ?? null;
}
// packages/ag-grid-community/src/filter/provided/number/numberFilter.ts
var $437b23f6a393c3bf$var$NumberFilter = class extends $437b23f6a393c3bf$var$ScalarFilter {
    constructor(){
        super("numberFilter");
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.filterType = "number";
        this.defaultDebounceMs = 500;
    }
    refresh(params) {
        if (this.numberFilterParams.allowedCharPattern !== params.allowedCharPattern) return false;
        return super.refresh(params);
    }
    mapValuesFromModel(filterModel) {
        const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
        return [
            this.processValue(filter),
            this.processValue(filterTo)
        ].slice(0, this.getNumberOfInputs(type));
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    isValid(value) {
        return !isNaN(value);
    }
    setParams(params) {
        this.numberFilterParams = params;
        super.setParams(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$NumberFilterModelFormatter(this.getLocaleTextFunc.bind(this), this.optionsFactory, this.numberFilterParams.numberFormatter);
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const { numberFormatter: numberFormatter } = this.numberFilterParams;
        const valueToSet = !fromFloatingFilter && numberFormatter ? numberFormatter(value ?? null) : value;
        super.setElementValue(element, valueToSet);
    }
    createValueElement() {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(this.numberFilterParams);
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
        this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new $437b23f6a393c3bf$export$8c027679838afd47({
            allowedCharPattern: allowedCharPattern
        }) : new $437b23f6a393c3bf$export$c8aa0be99738aee());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        removeComps(this.eValuesFrom);
        removeComps(this.eValuesTo);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(this.processValue(this.stringToFloat(element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    processValue(value) {
        if (value == null) return null;
        return isNaN(value) ? null : value;
    }
    stringToFloat(value) {
        if (typeof value === "number") return value;
        let filterText = $437b23f6a393c3bf$export$4978424c4f7b5fc0(value);
        if (filterText != null && filterText.trim() === "") filterText = null;
        const numberParser = this.numberFilterParams.numberParser;
        if (numberParser) return numberParser(filterText);
        return filterText == null || filterText.trim() === "-" ? null : parseFloat(filterText);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValues(position);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    getModelAsString(model) {
        return this.filterModelFormatter.getModelAsString(model) ?? "";
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>{
            if (!element.getInputElement().validity.valid) {
                invalidInputs = true;
                return;
            }
        });
        return invalidInputs;
    }
};
// packages/ag-grid-community/src/filter/floating/provided/floatingFilterTextInputService.ts
var $437b23f6a393c3bf$var$FloatingFilterTextInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.onValueChanged = ()=>{};
    }
    setupGui(parentElement) {
        this.eInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47(this.params?.config));
        const eInput = this.eInput.getGui();
        parentElement.appendChild(eInput);
        const listener = (e)=>this.onValueChanged(e);
        this.addManagedListeners(eInput, {
            input: listener,
            keydown: listener
        });
    }
    setEditable(editable) {
        this.eInput.setDisabled(!editable);
    }
    getValue() {
        return this.eInput.getValue();
    }
    setValue(value, silent) {
        this.eInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setParams({ ariaLabel: ariaLabel, autoComplete: autoComplete }) {
        const { eInput: eInput } = this;
        eInput.setInputAriaLabel(ariaLabel);
        if (autoComplete !== void 0) eInput.setAutoComplete(autoComplete);
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterUtils.ts
function $437b23f6a393c3bf$var$trimInputForFilter(value) {
    const trimmedInput = value?.trim();
    return trimmedInput === "" ? value : trimmedInput;
}
// packages/ag-grid-community/src/filter/floating/provided/textInputFloatingFilter.ts
var $437b23f6a393c3bf$var$TextInputFloatingFilterElement = {
    tag: "div",
    ref: "eFloatingFilterInputContainer",
    cls: "ag-floating-filter-input",
    role: "presentation"
};
var $437b23f6a393c3bf$var$TextInputFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super(...arguments);
        this.eFloatingFilterInputContainer = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.defaultDebounceMs = 500;
    }
    postConstruct() {
        this.setTemplate($437b23f6a393c3bf$var$TextInputFloatingFilterElement);
    }
    onParentModelChanged(model, event) {
        if (event?.afterFloatingFilter || event?.afterDataChange) return;
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(model));
    }
    init(params) {
        this.setupFloatingFilterInputService(params);
        super.init(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.inputSvc = this.createFloatingFilterInputService(params);
        this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        this.params = params;
        const autoComplete = params.browserAutoComplete ?? false;
        const { inputSvc: inputSvc, defaultDebounceMs: defaultDebounceMs, readOnly: readOnly } = this;
        inputSvc.setParams({
            ariaLabel: this.getAriaLabel(params),
            autoComplete: autoComplete
        });
        this.applyActive = $437b23f6a393c3bf$var$isUseApplyButton(params.filterParams);
        if (!readOnly) {
            const debounceMs = $437b23f6a393c3bf$var$getDebounceMs(params.filterParams, defaultDebounceMs);
            const toDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.syncUpWithParentFilter.bind(this), debounceMs);
            inputSvc.setValueChangedListener(toDebounce);
        }
    }
    refresh(params) {
        super.refresh(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const { inputSvc: inputSvc } = this;
        const value = inputSvc.getValue();
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eFloatingFilterInputContainer);
        this.destroyBean(inputSvc);
        this.setupFloatingFilterInputService(params);
        inputSvc.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        if (this.applyActive && !isEnterKey) return;
        const { inputSvc: inputSvc, params: params } = this;
        let value = inputSvc.getValue();
        if (params.filterParams.trimInput) {
            value = $437b23f6a393c3bf$var$trimInputForFilter(value);
            inputSvc.setValue(value, true);
        }
        params.parentFilterInstance((filterInstance)=>{
            filterInstance?.onFloatingFilterChanged(this.lastType || null, value || null);
        });
    }
    setEditable(editable) {
        this.inputSvc.setEditable(editable);
    }
};
// packages/ag-grid-community/src/filter/provided/number/numberFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterNumberInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.onValueChanged = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eNumberInput = this.createManagedBean(new $437b23f6a393c3bf$export$c8aa0be99738aee());
        this.eTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        this.eTextInput.setDisabled(true);
        const eNumberInput = this.eNumberInput.getGui();
        const eTextInput = this.eTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.onValueChanged(e));
        this.setupListeners(eTextInput, (e)=>this.onValueChanged(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eNumberInput.setDisplayed(this.numberInputActive);
        this.eTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eNumberInput.setAutoComplete(autoComplete);
        this.eTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eNumberInput : this.eTextInput;
    }
    setValueChangedListener(listener) {
        this.onValueChanged = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListeners(element, {
            input: listener,
            keydown: listener
        });
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eNumberInput.setInputAriaLabel(ariaLabel);
        this.eTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$NumberFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    init(params) {
        super.init(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$NumberFilterModelFormatter(this.getLocaleTextFunc.bind(this), this.optionsFactory, params.filterParams?.numberFormatter);
    }
    refresh(params) {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_NUMBER_FILTER_OPTIONS;
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterNumberInputService());
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilterConstants.ts
var $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS = [
    "contains",
    "notContains",
    "equals",
    "notEqual",
    "startsWith",
    "endsWith",
    "blank",
    "notBlank"
];
// packages/ag-grid-community/src/filter/provided/text/textFilterModelFormatter.ts
var $437b23f6a393c3bf$var$TextFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs: numberOfInputs } = options || {};
        const { filter: filter, filterTo: filterTo, type: type } = condition;
        const isRange = type == "inRange" || numberOfInputs === 2;
        if (isRange) return `${filter}-${filterTo}`;
        if (filter != null) return `${filter}`;
        return `${type}`;
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFilter.ts
var $437b23f6a393c3bf$var$TextFilter = class extends $437b23f6a393c3bf$var$SimpleFilter {
    constructor(){
        super("textFilter");
        this.filterType = "text";
        this.defaultFormatter = (from)=>from;
        this.defaultLowercaseFormatter = (from)=>from == null ? null : from.toString().toLowerCase();
        this.defaultMatcher = ({ filterOption: filterOption, value: value, filterText: filterText })=>{
            if (filterText == null) return false;
            switch(filterOption){
                case "contains":
                    return value.indexOf(filterText) >= 0;
                case "notContains":
                    return value.indexOf(filterText) < 0;
                case "equals":
                    return value === filterText;
                case "notEqual":
                    return value != filterText;
                case "startsWith":
                    return value.indexOf(filterText) === 0;
                case "endsWith":
                    {
                        const index = value.lastIndexOf(filterText);
                        return index >= 0 && index === value.length - filterText.length;
                    }
                default:
                    return false;
            }
        };
        this.eValuesFrom = [];
        this.eValuesTo = [];
        this.defaultDebounceMs = 500;
    }
    setParams(params) {
        this.textFilterParams = params;
        super.setParams(params);
        this.matcher = params.textMatcher || this.defaultMatcher;
        this.formatter = params.textFormatter || (params.caseSensitive ? this.defaultFormatter : this.defaultLowercaseFormatter);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$TextFilterModelFormatter(this.getLocaleTextFunc.bind(this), this.optionsFactory);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.filterType,
            type: type
        };
        const values = this.getValuesWithSideEffects(position, true);
        if (values.length > 0) model.filter = values[0];
        if (values.length > 1) model.filterTo = values[1];
        return model;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        const { eValuesFrom: eValuesFrom, eValuesTo: eValuesTo } = this;
        if (position >= eValuesFrom.length) return [
            null,
            null
        ];
        return [
            eValuesFrom[position],
            eValuesTo[position]
        ];
    }
    getValues(position) {
        return this.getValuesWithSideEffects(position, false);
    }
    getValuesWithSideEffects(position, applySideEffects) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) {
                let value = $437b23f6a393c3bf$export$4978424c4f7b5fc0(element.getValue());
                if (applySideEffects && this.textFilterParams.trimInput) {
                    value = $437b23f6a393c3bf$var$trimInputForFilter(value) ?? null;
                    element.setValue(value, true);
                }
                result.push(value);
            }
        });
        return result;
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS;
    }
    createValueElement() {
        const eCondition = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "div",
            cls: "ag-filter-body",
            role: "presentation"
        });
        this.createFromToElement(eCondition, this.eValuesFrom, "from");
        this.createFromToElement(eCondition, this.eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        eValue.addCss(`ag-filter-${fromTo}`);
        eValue.addCss("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        const removeComps = (eGui)=>this.removeComponents(eGui, startPosition, deleteCount);
        removeComps(this.eValuesFrom);
        removeComps(this.eValuesTo);
    }
    mapValuesFromModel(filterModel) {
        const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
        return [
            filter || null,
            filterTo || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            "notEqual",
            "notContains",
            "blank"
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values, cellValue, filterModel, params) {
        const formattedValues = values.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api: api, colDef: colDef, column: column, context: context, textFormatter: textFormatter } = this.textFilterParams;
        if (filterModel.type === "blank") return $437b23f6a393c3bf$var$isBlank(cellValue);
        else if (filterModel.type === "notBlank") return !$437b23f6a393c3bf$var$isBlank(cellValue);
        const matcherParams = {
            api: api,
            colDef: colDef,
            column: column,
            context: context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter: textFormatter
        };
        return formattedValues.some((v)=>this.matcher({
                ...matcherParams,
                filterText: v
            }));
    }
    getModelAsString(model) {
        return this.filterModelFormatter.getModelAsString(model) ?? "";
    }
};
// packages/ag-grid-community/src/filter/provided/text/textFloatingFilter.ts
var $437b23f6a393c3bf$var$TextFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    init(params) {
        super.init(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$TextFilterModelFormatter(this.getLocaleTextFunc.bind(this), this.optionsFactory);
    }
    refresh(params) {
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultOptions() {
        return $437b23f6a393c3bf$var$DEFAULT_TEXT_FILTER_OPTIONS;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService());
    }
};
// packages/ag-grid-community/src/filter/quickFilterApi.ts
function $437b23f6a393c3bf$var$isQuickFilterPresent(beans) {
    return !!beans.quickFilter?.isFilterPresent();
}
function $437b23f6a393c3bf$var$getQuickFilter(beans) {
    return beans.quickFilter?.getText();
}
function $437b23f6a393c3bf$var$resetQuickFilter(beans) {
    beans.quickFilter?.resetCache();
}
// packages/ag-grid-community/src/filter/quickFilterService.ts
var $437b23f6a393c3bf$var$QuickFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "quickFilter";
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        const resetListener = this.resetCache.bind(this);
        const gos = this.gos;
        this.addManagedEventListeners({
            columnPivotModeChanged: resetListener,
            newColumnsLoaded: resetListener,
            columnRowGroupChanged: resetListener,
            columnVisible: ()=>{
                if (!gos.get("includeHiddenColumnsInQuickFilter")) this.resetCache();
            }
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onColumnConfigChanged());
        this.quickFilter = this.parseFilter(gos.get("quickFilterText"));
        this.parser = gos.get("quickFilterParser");
        this.matcher = gos.get("quickFilterMatcher");
        this.setFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setParserAndMatcher());
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshCols() {
        const { autoColSvc: autoColSvc, colModel: colModel, gos: gos, pivotResultCols: pivotResultCols } = this.beans;
        const pivotMode = colModel.isPivotMode();
        const groupAutoCols = autoColSvc?.getColumns();
        const providedCols = colModel.getColDefCols();
        let columnsForQuickFilter = (pivotMode && !gos.get("applyQuickFilterBeforePivotOrAgg") ? pivotResultCols?.getPivotResultCols()?.list : providedCols) ?? [];
        if (groupAutoCols) columnsForQuickFilter = columnsForQuickFilter.concat(groupAutoCols);
        this.colsToUse = gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    isFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPass(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassCache(node, part) : this.doesRowPassNoCache(node, part));
    }
    resetCache() {
        this.beans.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    getText() {
        return this.gos.get("quickFilterText");
    }
    setFilterParts() {
        const { quickFilter: quickFilter, parser: parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseFilter(newFilter) {
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(newFilter)) return null;
        return newFilter.toUpperCase();
    }
    setFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            $437b23f6a393c3bf$export$545083624300f13d(70, {
                newFilter: newFilter
            });
            return;
        }
        const parsedFilter = this.parseFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    setParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setFilterParts();
            this.dispatchLocalEvent({
                type: "quickFilterChanged"
            });
        }
    }
    onColumnConfigChanged() {
        this.refreshCols();
        this.resetCache();
        if (this.isFilterPresent()) this.dispatchLocalEvent({
            type: "quickFilterChanged"
        });
    }
    doesRowPassNoCache(node, filterPart) {
        return this.colsToUse.some((column)=>{
            const part = this.getTextForColumn(column, node);
            return $437b23f6a393c3bf$export$25d27f17d3af40f7(part) && part.indexOf(filterPart) >= 0;
        });
    }
    doesRowPassCache(node, filterPart) {
        this.checkGenerateAggText(node);
        return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
    }
    doesRowPassMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateAggText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getAggText(node);
        const { quickFilterParts: quickFilterParts, matcher: matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateAggText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getAggText(node);
    }
    getTextForColumn(column, node) {
        let value = this.beans.filterValueSvc.getValue(column, node);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                value: value,
                node: node,
                data: node.data,
                column: column,
                colDef: colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return $437b23f6a393c3bf$export$25d27f17d3af40f7(value) ? value.toString().toUpperCase() : null;
    }
    getAggText(node) {
        const stringParts = [];
        this.colsToUse.forEach((column)=>{
            const part = this.getTextForColumn(column, node);
            if ($437b23f6a393c3bf$export$25d27f17d3af40f7(part)) stringParts.push(part);
        });
        return stringParts.join("\n");
    }
};
// packages/ag-grid-community/src/filter/filterModule.ts
var $437b23f6a393c3bf$var$ClientSideRowModelFilterModule = {
    moduleName: "ClientSideRowModelFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$FilterStage
    ]
};
var $437b23f6a393c3bf$export$b8779358eaaabc87 = {
    moduleName: "FilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterManager
    ],
    apiFunctions: {
        isAnyFilterPresent: $437b23f6a393c3bf$var$isAnyFilterPresent,
        onFilterChanged: $437b23f6a393c3bf$var$onFilterChanged
    },
    css: [
        $437b23f6a393c3bf$var$columnFiltersCSS
    ],
    dependsOn: [
        $437b23f6a393c3bf$var$ClientSideRowModelFilterModule
    ]
};
var $437b23f6a393c3bf$export$55e846ac25ec4cc0 = {
    moduleName: "FilterValue",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$FilterValueService
    ]
};
var $437b23f6a393c3bf$export$bee7a6b8183a1c61 = {
    moduleName: "ColumnFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnFilterService,
        $437b23f6a393c3bf$var$FilterMenuFactory
    ],
    dynamicBeans: {
        headerFilterCellCtrl: $437b23f6a393c3bf$var$HeaderFilterCellCtrl
    },
    icons: {
        // open filter button - header, floating filter, menu
        filter: "filter",
        // filter is applied - header (legacy column menu), filter tool panel
        filterActive: "filter"
    },
    apiFunctions: {
        isColumnFilterPresent: $437b23f6a393c3bf$var$isColumnFilterPresent,
        getColumnFilterInstance: $437b23f6a393c3bf$var$getColumnFilterInstance,
        destroyFilter: $437b23f6a393c3bf$var$destroyFilter,
        setFilterModel: $437b23f6a393c3bf$var$setFilterModel,
        getFilterModel: $437b23f6a393c3bf$var$getFilterModel,
        getColumnFilterModel: $437b23f6a393c3bf$var$getColumnFilterModel,
        setColumnFilterModel: $437b23f6a393c3bf$var$setColumnFilterModel,
        showColumnFilter: $437b23f6a393c3bf$var$showColumnFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$da5c9bb998e6c24d,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0,
        $437b23f6a393c3bf$export$b0ea578339daf1f7
    ]
};
var $437b23f6a393c3bf$export$c992812899d813d0 = {
    moduleName: "CustomFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agReadOnlyFloatingFilter: $437b23f6a393c3bf$var$ReadOnlyFloatingFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ]
};
var $437b23f6a393c3bf$export$5ce3e57cec1fecc9 = {
    moduleName: "TextFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agTextColumnFilter: $437b23f6a393c3bf$var$TextFilter,
        agTextColumnFloatingFilter: $437b23f6a393c3bf$var$TextFloatingFilter
    }
};
var $437b23f6a393c3bf$export$aabcd4399b0469bb = {
    moduleName: "NumberFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agNumberColumnFilter: $437b23f6a393c3bf$var$NumberFilter,
        agNumberColumnFloatingFilter: $437b23f6a393c3bf$var$NumberFloatingFilter
    }
};
var $437b23f6a393c3bf$export$2a2721fe06c4c013 = {
    moduleName: "DateFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$bee7a6b8183a1c61
    ],
    userComponents: {
        agDateColumnFilter: $437b23f6a393c3bf$var$DateFilter,
        agDateInput: $437b23f6a393c3bf$var$DefaultDateComponent,
        agDateColumnFloatingFilter: $437b23f6a393c3bf$var$DateFloatingFilter
    }
};
var $437b23f6a393c3bf$var$QuickFilterCoreModule = {
    moduleName: "QuickFilterCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$QuickFilterService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87,
        $437b23f6a393c3bf$export$55e846ac25ec4cc0
    ]
};
var $437b23f6a393c3bf$export$7e8079ed742f8307 = {
    moduleName: "QuickFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        isQuickFilterPresent: $437b23f6a393c3bf$var$isQuickFilterPresent,
        getQuickFilter: $437b23f6a393c3bf$var$getQuickFilter,
        resetQuickFilter: $437b23f6a393c3bf$var$resetQuickFilter
    },
    dependsOn: [
        $437b23f6a393c3bf$var$QuickFilterCoreModule
    ]
};
var $437b23f6a393c3bf$export$fc403e59f6fc67b = {
    moduleName: "ExternalFilter",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$b8779358eaaabc87
    ]
};
// packages/ag-grid-community/src/undoRedo/undoRedoStack.ts
var $437b23f6a393c3bf$var$UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var $437b23f6a393c3bf$var$RangeUndoRedoAction = class extends $437b23f6a393c3bf$var$UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE = 10;
var $437b23f6a393c3bf$var$UndoRedoStack = class {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : $437b23f6a393c3bf$var$DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
// packages/ag-grid-community/src/undoRedo/undoRedoService.ts
var $437b23f6a393c3bf$var$UndoRedoService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "undoRedo";
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && $437b23f6a393c3bf$export$be3973033c2c5267(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && $437b23f6a393c3bf$export$de6f9fa10e9f4188(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned: rowPinned, rowIndex: rowIndex, column: column, oldValue: oldValue, value: value } = event;
            const cellValueChange = {
                rowPinned: rowPinned,
                rowIndex: rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue: oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    postConstruct() {
        const { gos: gos, ctrlsSvc: ctrlsSvc } = this.beans;
        if (!gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.redoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.addListeners();
        const listener = this.clearStacks.bind(this);
        this.addManagedEventListeners({
            cellValueChanged: this.onCellValueChanged.bind(this),
            // undo / redo is restricted to actual editing so we clear the stacks when other operations are
            // performed that change the order of the row / cols.
            modelUpdated: (e)=>{
                if (!e.keepUndoRedoStack) this.clearStacks();
            },
            columnPivotModeChanged: listener,
            newColumnsLoaded: listener,
            columnGroupOpened: listener,
            columnRowGroupChanged: listener,
            columnMoved: listener,
            columnPinned: listener,
            columnVisible: listener,
            rowDragEnd: listener
        });
        ctrlsSvc.whenReady(this, (p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack?.getCurrentStackSize() ?? 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack?.getCurrentStackSize() ?? 0;
    }
    undo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "undoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(undoStack, redoStack, "initialRange", "oldValue", "undo");
        eventSvc.dispatchEvent({
            type: "undoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    redo(source) {
        const { eventSvc: eventSvc, undoStack: undoStack, redoStack: redoStack } = this;
        eventSvc.dispatchEvent({
            type: "redoStarted",
            source: source
        });
        const operationPerformed = this.undoRedo(redoStack, undoStack, "finalRange", "newValue", "redo");
        eventSvc.dispatchEvent({
            type: "redoEnded",
            source: source,
            operationPerformed: operationPerformed
        });
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction || !undoRedoAction.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof $437b23f6a393c3bf$var$RangeUndoRedoAction) this.processRange(undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        action.cellValueChanges.forEach((cellValueChange)=>{
            const { rowIndex: rowIndex, rowPinned: rowPinned, columnId: columnId } = cellValueChange;
            const rowPosition = {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const currentRow = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
            if (!currentRow.displayed) return;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        });
    }
    processRange(ranges) {
        let lastFocusedCell;
        const rangeSvc = this.beans.rangeSvc;
        rangeSvc.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeSvc.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        const row = $437b23f6a393c3bf$export$d4675a60917db7b0(this.beans, rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell);
    }
    setLastFocusedCell(lastFocusedCell) {
        const { rowIndex: rowIndex, columnId: columnId, rowPinned: rowPinned } = lastFocusedCell;
        const { colModel: colModel, focusSvc: focusSvc, rangeSvc: rangeSvc } = this.beans;
        const column = colModel.getCol(columnId);
        if (!column) return;
        const { scrollFeature: scrollFeature } = this.gridBodyCtrl;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        };
        focusSvc.setFocusedCell({
            ...cellPosition,
            forceBrowserFocus: true
        });
        rangeSvc?.setRangeToCell(cellPosition);
    }
    addListeners() {
        this.addManagedEventListeners({
            rowEditingStarted: (e)=>{
                this.activeRowEdit = {
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            rowEditingStopped: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.activeRowEdit = null;
            },
            cellEditingStarted: (e)=>{
                this.activeCellEdit = {
                    column: e.column,
                    rowIndex: e.rowIndex,
                    rowPinned: e.rowPinned
                };
            },
            cellEditingStopped: (e)=>{
                this.activeCellEdit = null;
                const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
                if (shouldPushAction) {
                    const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                    this.pushActionsToUndoStack(action);
                }
            },
            pasteStart: ()=>{
                this.isPasting = true;
            },
            pasteEnd: ()=>{
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isPasting = false;
            },
            fillStart: ()=>{
                this.isRangeInAction = true;
            },
            fillEnd: (event)=>{
                const action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            },
            keyShortcutChangedCellStart: ()=>{
                this.isRangeInAction = true;
            },
            keyShortcutChangedCellEnd: ()=>{
                let action;
                const { rangeSvc: rangeSvc, gos: gos } = this.beans;
                if (rangeSvc && $437b23f6a393c3bf$export$1f7ca6920544d9e4(gos)) action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                    ...rangeSvc.getCellRanges()
                ]);
                else action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
                this.isRangeInAction = false;
            }
        });
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
// packages/ag-grid-community/src/edit/cell-editing.css-GENERATED.ts
var $437b23f6a393c3bf$var$cellEditingCSS = /*css*/ `.ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;min-height:100%;width:100%}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}`;
// packages/ag-grid-community/src/edit/cellEditors/checkboxCellEditor.ts
var $437b23f6a393c3bf$var$CheckboxCellEditorElement = {
    tag: "div",
    cls: "ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit",
    children: [
        {
            tag: "ag-checkbox",
            ref: "eCheckbox",
            role: "presentation"
        }
    ]
};
var $437b23f6a393c3bf$var$CheckboxCellEditor = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super($437b23f6a393c3bf$var$CheckboxCellEditorElement, [
            $437b23f6a393c3bf$export$2e2c317d2e31f2ca
        ]);
        this.eCheckbox = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const isSelected = params.value ?? void 0;
        const eCheckbox = this.eCheckbox;
        eCheckbox.setValue(isSelected);
        const inputEl = eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListeners(eCheckbox, {
            fieldValueChanged: (event)=>this.setAriaLabel(event.selected)
        });
    }
    getValue() {
        return this.eCheckbox.getValue();
    }
    focusIn() {
        this.eCheckbox.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$_getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eCheckbox.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
};
// packages/ag-grid-community/src/edit/cellEditors/simpleCellEditor.ts
var $437b23f6a393c3bf$var$SimpleCellEditor = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(cellEditorInput){
        super({
            tag: "div",
            cls: "ag-cell-edit-wrapper",
            children: [
                cellEditorInput.getTemplate()
            ]
        }, cellEditorInput.getAgComponents());
        this.cellEditorInput = cellEditorInput;
        this.eInput = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        const { cellStartedEdit: cellStartedEdit, eventKey: eventKey, suppressPreventDefault: suppressPreventDefault } = params;
        const eInput = this.eInput;
        this.cellEditorInput.init(eInput, params);
        let startValue;
        let shouldSetStartValue = true;
        if (cellStartedEdit) {
            this.focusAfterAttached = true;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) {
                if (suppressPreventDefault) shouldSetStartValue = false;
                else startValue = eventKey;
            } else {
                startValue = this.cellEditorInput.getStartValue();
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.cellEditorInput.getStartValue();
        }
        if (shouldSetStartValue && startValue != null) eInput.setStartValue(startValue);
        this.addManagedElementListeners(eInput.getGui(), {
            keydown: (event)=>{
                const { key: key } = event;
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) event.preventDefault();
            }
        });
    }
    afterGuiAttached() {
        const translate = this.getLocaleTextFunc();
        const eInput = this.eInput;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!$437b23f6a393c3bf$var$_isBrowserSafari()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else this.cellEditorInput.setCaret?.();
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const eInput = this.eInput;
        const focusEl = eInput.getFocusableElement();
        const inputEl = eInput.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateCellEditor.ts
var $437b23f6a393c3bf$var$DateCellElement = {
    tag: "ag-input-date-field",
    ref: "eInput",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateCellEditorInput = class {
    getTemplate() {
        return $437b23f6a393c3bf$var$DateCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        const { min: min, max: max, step: step } = params;
        if (min != null) eInput.setMin(min);
        if (max != null) eInput.setMax(max);
        if (step != null) eInput.setStep(step);
    }
    getValue() {
        const { eInput: eInput, params: params } = this;
        const value = eInput.getDate();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return value ?? null;
    }
    getStartValue() {
        const { value: value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return $437b23f6a393c3bf$export$3d7fedfb21962874(value, false);
    }
};
var $437b23f6a393c3bf$var$DateCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateCellEditorInput());
    }
};
// packages/ag-grid-community/src/edit/cellEditors/dateStringCellEditor.ts
var $437b23f6a393c3bf$var$DateStringCellElement = {
    tag: "ag-input-date-field",
    ref: "eInput",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$DateStringCellEditorInput = class {
    constructor(getDataTypeService){
        this.getDataTypeService = getDataTypeService;
    }
    getTemplate() {
        return $437b23f6a393c3bf$var$DateStringCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$var$AgInputDateFieldSelector
        ];
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        const { min: min, max: max, step: step } = params;
        if (min != null) eInput.setMin(min);
        if (max != null) eInput.setMax(max);
        if (step != null) eInput.setStep(step);
    }
    getValue() {
        const { params: params, eInput: eInput } = this;
        const value = this.formatDate(eInput.getDate());
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value ?? "");
    }
    getStartValue() {
        return $437b23f6a393c3bf$export$3d7fedfb21962874(this.parseDate(this.params.value ?? void 0) ?? null, false);
    }
    parseDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateParserFunction(this.params.column)(value) : $437b23f6a393c3bf$export$26ded2d88c01b527(value) ?? void 0;
    }
    formatDate(value) {
        const dataTypeSvc = this.getDataTypeService();
        return dataTypeSvc ? dataTypeSvc.getDateFormatterFunction(this.params.column)(value) : $437b23f6a393c3bf$export$3d7fedfb21962874(value ?? null, false) ?? void 0;
    }
};
var $437b23f6a393c3bf$var$DateStringCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateStringCellEditorInput(()=>this.beans.dataTypeSvc));
    }
};
// packages/ag-grid-community/src/edit/cellEditors/largeTextCellEditor.ts
var $437b23f6a393c3bf$var$LargeTextCellElement = {
    tag: "div",
    cls: "ag-large-text",
    children: [
        {
            tag: "ag-input-text-area",
            ref: "eTextArea",
            cls: "ag-large-text-input"
        }
    ]
};
var $437b23f6a393c3bf$var$LargeTextCellEditor = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super($437b23f6a393c3bf$var$LargeTextCellElement, [
            $437b23f6a393c3bf$var$AgInputTextAreaSelector
        ]);
        this.eTextArea = $437b23f6a393c3bf$export$6c811454646ed8be;
    }
    init(params) {
        this.params = params;
        this.focusAfterAttached = params.cellStartedEdit;
        this.eTextArea.setMaxLength(params.maxLength || 200).setCols(params.cols || 60).setRows(params.rows || 10);
        if (params.value != null) this.eTextArea.setValue(params.value.toString(), true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN || event.shiftKey && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const translate = this.getLocaleTextFunc();
        this.eTextArea.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (this.focusAfterAttached) this.eTextArea.getFocusableElement().focus();
    }
    getValue() {
        const value = this.eTextArea.getValue();
        const params = this.params;
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value);
    }
};
// packages/ag-grid-community/src/edit/cellEditors/numberCellEditor.ts
var $437b23f6a393c3bf$var$NumberCellElement = {
    tag: "ag-input-number-field",
    ref: "eInput",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$NumberCellEditorInput = class {
    getTemplate() {
        return $437b23f6a393c3bf$var$NumberCellElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$c18153c9c909b7d7
        ];
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        const { max: max, min: min, precision: precision, step: step } = params;
        if (max != null) eInput.setMax(max);
        if (min != null) eInput.setMin(min);
        if (precision != null) eInput.setPrecision(precision);
        if (step != null) eInput.setStep(step);
        const inputEl = eInput.getInputElement();
        if (params.preventStepping) eInput.addManagedElementListeners(inputEl, {
            keydown: this.preventStepping
        });
        else if (params.showStepperButtons) inputEl.classList.add("ag-number-field-input-stepper");
    }
    preventStepping(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN) e.preventDefault();
    }
    getValue() {
        const { eInput: eInput, params: params } = this;
        const value = eInput.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        let parsedValue = params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
    setCaret() {
        if ($437b23f6a393c3bf$var$_isBrowserSafari()) this.eInput.getInputElement().focus({
            preventScroll: true
        });
    }
};
var $437b23f6a393c3bf$var$NumberCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$NumberCellEditorInput());
    }
};
// packages/ag-grid-community/src/edit/cellEditors/selectCellEditor.ts
var $437b23f6a393c3bf$var$SelectCellElement = {
    tag: "div",
    cls: "ag-cell-edit-wrapper",
    children: [
        {
            tag: "ag-select",
            ref: "eSelect",
            cls: "ag-cell-editor"
        }
    ]
};
var $437b23f6a393c3bf$var$SelectCellEditor = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super($437b23f6a393c3bf$var$SelectCellElement, [
            $437b23f6a393c3bf$export$e32612175ad118ef
        ]);
        this.eSelect = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.startedByEnter = false;
    }
    wireBeans(beans) {
        this.valueSvc = beans.valueSvc;
    }
    init(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eSelect: eSelect, valueSvc: valueSvc, gos: gos } = this;
        const { values: values, value: value, eventKey: eventKey } = params;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(values)) {
            $437b23f6a393c3bf$export$545083624300f13d(58);
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER : false;
        let hasValue = false;
        values.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueSvc.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eSelect.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eSelect.setValue(params.value, true);
        else if (params.values.length) eSelect.setValue(params.values[0], true);
        const { valueListGap: valueListGap, valueListMaxWidth: valueListMaxWidth, valueListMaxHeight: valueListMaxHeight } = params;
        if (valueListGap != null) eSelect.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eSelect.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eSelect.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListeners(this.eSelect, {
            selectedItem: ()=>params.stopEditing()
        });
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eSelect.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eSelect.showPicker();
        });
    }
    focusIn() {
        this.eSelect.getFocusableElement().focus();
    }
    getValue() {
        return this.eSelect.getValue();
    }
    isPopup() {
        return false;
    }
};
// packages/ag-grid-community/src/edit/cellEditors/textCellEditor.ts
var $437b23f6a393c3bf$var$TextCellEditorElement = {
    tag: "ag-input-text-field",
    ref: "eInput",
    cls: "ag-cell-editor"
};
var $437b23f6a393c3bf$var$TextCellEditorInput = class {
    getTemplate() {
        return $437b23f6a393c3bf$var$TextCellEditorElement;
    }
    getAgComponents() {
        return [
            $437b23f6a393c3bf$export$31e2985be4ee06ab
        ];
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        const maxLength = params.maxLength;
        if (maxLength != null) eInput.setMaxLength(maxLength);
    }
    getValue() {
        const { eInput: eInput, params: params } = this;
        const value = eInput.getValue();
        if (!$437b23f6a393c3bf$export$25d27f17d3af40f7(value) && !$437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) return params.value;
        return params.parseValue(value);
    }
    getStartValue() {
        const params = this.params;
        const formatValue = params.useFormatter || params.column.getColDef().refData;
        return formatValue ? params.formatValue(params.value) : params.value;
    }
    setCaret() {
        const eInput = this.eInput;
        const value = eInput.getValue();
        const len = $437b23f6a393c3bf$export$25d27f17d3af40f7(value) && value.length || 0;
        if (len) eInput.getInputElement().setSelectionRange(len, len);
    }
};
var $437b23f6a393c3bf$var$TextCellEditor = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$TextCellEditorInput());
    }
};
// packages/ag-grid-community/src/api/scrollApi.ts
function $437b23f6a393c3bf$var$getVerticalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function $437b23f6a393c3bf$var$getHorizontalPixelRange(beans) {
    return beans.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function $437b23f6a393c3bf$var$ensureColumnVisible(beans, key, position = "auto") {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureIndexVisible(beans, index, position) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
}
function $437b23f6a393c3bf$var$ensureNodeVisible(beans, nodeSelector, position = null) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
}
// packages/ag-grid-community/src/edit/editApi.ts
function $437b23f6a393c3bf$var$undoCellEditing(beans) {
    beans.undoRedo?.undo("api");
}
function $437b23f6a393c3bf$var$redoCellEditing(beans) {
    beans.undoRedo?.redo("api");
}
function $437b23f6a393c3bf$var$getCellEditorInstances(beans, params = {}) {
    const res = [];
    beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>{
        const cellEditor = cellCtrl.comp?.getCellEditor();
        if (cellEditor) res.push($437b23f6a393c3bf$export$213d4c63c3df47e4(cellEditor));
    });
    return res;
}
function $437b23f6a393c3bf$var$getEditingCells(beans) {
    const res = [];
    beans.rowRenderer.getAllCellCtrls().forEach((cellCtrl)=>{
        if (cellCtrl.editing) {
            const { cellPosition: cellPosition } = cellCtrl;
            res.push(cellPosition);
        }
    });
    return res;
}
function $437b23f6a393c3bf$var$stopEditing(beans, cancel = false) {
    beans.editSvc?.stopAllEditing(cancel);
}
function $437b23f6a393c3bf$var$startEditingCell(beans, params) {
    const column = beans.colModel.getCol(params.colKey);
    if (!column) {
        $437b23f6a393c3bf$export$545083624300f13d(12, {
            colKey: params.colKey
        });
        return;
    }
    const cellPosition = {
        rowIndex: params.rowIndex,
        rowPinned: params.rowPinned || null,
        column: column
    };
    const notPinned = params.rowPinned == null;
    if (notPinned) $437b23f6a393c3bf$var$ensureIndexVisible(beans, params.rowIndex);
    $437b23f6a393c3bf$var$ensureColumnVisible(beans, params.colKey);
    const cell = $437b23f6a393c3bf$export$1bd7ce47360c3c0(beans, cellPosition);
    if (!cell) return;
    const { focusSvc: focusSvc, gos: gos, editSvc: editSvc } = beans;
    const isFocusWithinCell = ()=>{
        const activeElement = $437b23f6a393c3bf$export$16bc98d422315038(beans);
        const eCell = cell.eGui;
        return activeElement !== eCell && !!eCell?.contains(activeElement);
    };
    const forceBrowserFocus = gos.get("stopEditingWhenCellsLoseFocus") && isFocusWithinCell();
    if (forceBrowserFocus || !focusSvc.isCellFocused(cellPosition)) focusSvc.setFocusedCell({
        ...cellPosition,
        forceBrowserFocus: forceBrowserFocus,
        preventScrollOnBrowserFocus: true
    });
    editSvc?.startRowOrCellEdit(cell, params.key);
}
function $437b23f6a393c3bf$var$getCurrentUndoSize(beans) {
    return beans.undoRedo?.getCurrentUndoStackSize() ?? 0;
}
function $437b23f6a393c3bf$var$getCurrentRedoSize(beans) {
    return beans.undoRedo?.getCurrentRedoStackSize() ?? 0;
}
// packages/ag-grid-community/src/edit/cellEditors/popupEditorWrapper.ts
var $437b23f6a393c3bf$var$PopupEditorElement = {
    tag: "div",
    cls: "ag-popup-editor",
    attrs: {
        tabindex: "-1"
    }
};
var $437b23f6a393c3bf$var$PopupEditorWrapper = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(params){
        super($437b23f6a393c3bf$var$PopupEditorElement);
        this.params = params;
    }
    postConstruct() {
        $437b23f6a393c3bf$var$_setDomData(this.gos, this.getGui(), "popupEditorWrapper", true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!$437b23f6a393c3bf$var$_isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedElementListeners(eGui, {
            keydown: listener
        });
    }
};
// packages/ag-grid-community/src/edit/editService.ts
var $437b23f6a393c3bf$var$EditService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "editSvc";
    }
    /** @return whether to prevent default on event */ startEditing(cellCtrl, key = null, cellStartedEdit = false, event = null) {
        if (!cellCtrl.isCellEditable() || cellCtrl.editing) return false;
        if (!cellCtrl.comp) {
            cellCtrl.onCompAttachedFuncs.push(()=>{
                this.startEditing(cellCtrl, key, cellStartedEdit, event);
            });
            return true;
        }
        const editorParams = this.createCellEditorParams(cellCtrl, key, cellStartedEdit);
        const colDef = cellCtrl.column.getColDef();
        const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(this.beans.userCompFactory, colDef, editorParams);
        const popup = compDetails?.popupFromSelector != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
        const position = compDetails?.popupPositionFromSelector != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
        $437b23f6a393c3bf$var$setEditing(cellCtrl, true, compDetails);
        cellCtrl.comp.setEditDetails(compDetails, popup, position, this.gos.get("reactiveCustomComponents"));
        this.eventSvc.dispatchEvent(cellCtrl.createEvent(event, "cellEditingStarted"));
        return !compDetails?.params?.suppressPreventDefault;
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cellCtrl, cancel = false) {
        cellCtrl.onEditorAttachedFuncs = [];
        if (!cellCtrl.editing) return false;
        const { comp: cellComp, column: column, rowNode: rowNode } = cellCtrl;
        const { newValue: newValue, newValueExists: newValueExists } = $437b23f6a393c3bf$var$takeValueFromCellEditor(cancel, cellComp);
        const oldValue = this.beans.valueSvc.getValueForDisplay(column, rowNode).value;
        let valueChanged = false;
        if (newValueExists) valueChanged = $437b23f6a393c3bf$var$saveNewValue(cellCtrl, oldValue, newValue, rowNode, column);
        $437b23f6a393c3bf$var$setEditing(cellCtrl, false, void 0);
        cellComp.setEditDetails();
        cellCtrl.updateAndFormatValue(false);
        cellCtrl.refreshCell({
            forceRefresh: true,
            suppressFlash: true
        });
        this.eventSvc.dispatchEvent({
            ...cellCtrl.createEvent(null, "cellEditingStopped"),
            oldValue: oldValue,
            newValue: newValue,
            valueChanged: valueChanged
        });
        return valueChanged;
    }
    handleColDefChanged(cellCtrl) {
        const cellEditor = cellCtrl.comp?.getCellEditor();
        if (cellEditor?.refresh) {
            const { eventKey: eventKey, cellStartedEdit: cellStartedEdit } = cellCtrl.editCompDetails.params;
            const editorParams = this.createCellEditorParams(cellCtrl, eventKey, cellStartedEdit);
            const colDef = cellCtrl.column.getColDef();
            const compDetails = $437b23f6a393c3bf$var$_getCellEditorDetails(this.beans.userCompFactory, colDef, editorParams);
            cellEditor.refresh(compDetails.params);
        }
    }
    setFocusOutOnEditor(cellCtrl) {
        if (!cellCtrl.editing) return;
        const cellEditor = cellCtrl.comp.getCellEditor();
        if (cellEditor && cellEditor.focusOut) cellEditor.focusOut();
    }
    setFocusInOnEditor(cellCtrl) {
        if (!cellCtrl.editing) return;
        const cellComp = cellCtrl.comp;
        const cellEditor = cellComp.getCellEditor();
        if (cellEditor?.focusIn) cellEditor.focusIn();
        else {
            cellCtrl.focusCell(true);
            cellCtrl.onEditorAttachedFuncs.push(()=>cellComp.getCellEditor()?.focusIn?.());
        }
    }
    createPopupEditorWrapper(params) {
        return new $437b23f6a393c3bf$var$PopupEditorWrapper(params);
    }
    stopAllEditing(cancel = false) {
        this.beans.rowRenderer.getAllRowCtrls().forEach((rowCtrl)=>this.stopRowEditing(rowCtrl, cancel));
    }
    stopRowEditing(rowCtrl, cancel = false) {
        if (rowCtrl.stoppingRowEdit) return;
        const cellControls = rowCtrl.getAllCellCtrls();
        const isRowEdit = rowCtrl.editing;
        rowCtrl.stoppingRowEdit = true;
        let fireRowEditEvent = false;
        for (const ctrl of cellControls){
            const valueChanged = ctrl.stopEditing(cancel);
            if (isRowEdit && !cancel && !fireRowEditEvent && valueChanged) fireRowEditEvent = true;
        }
        if (fireRowEditEvent) this.eventSvc.dispatchEvent(rowCtrl.createRowEvent("rowValueChanged"));
        if (isRowEdit) this.beans.rowEditSvc?.setEditing(rowCtrl, false);
        rowCtrl.stoppingRowEdit = false;
    }
    addStopEditingWhenGridLosesFocus(viewports) {
        if (!this.gos.get("stopEditingWhenCellsLoseFocus")) return;
        const focusOutListener = (event)=>{
            const elementWithFocus = event.relatedTarget;
            if ($437b23f6a393c3bf$var$_getTabIndex(elementWithFocus) === null) {
                this.stopAllEditing();
                return;
            }
            let clickInsideGrid = // see if click came from inside the viewports
            viewports.some((viewport)=>viewport.contains(elementWithFocus)) && // and also that it's not from a detail grid
            $437b23f6a393c3bf$var$_isElementInThisGrid(this.gos, elementWithFocus);
            if (!clickInsideGrid) {
                const popupSvc = this.beans.popupSvc;
                clickInsideGrid = !!popupSvc && (popupSvc.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupSvc.isElementWithinCustomPopup(elementWithFocus));
            }
            if (!clickInsideGrid) this.stopAllEditing();
        };
        viewports.forEach((viewport)=>this.addManagedElementListeners(viewport, {
                focusout: focusOutListener
            }));
    }
    setInlineEditingCss(rowCtrl) {
        const editing = rowCtrl.editing || rowCtrl.getAllCellCtrls().some((cellCtrl)=>cellCtrl.editing);
        rowCtrl.forEachGui(void 0, (gui)=>{
            gui.rowComp.toggleCss("ag-row-inline-editing", editing);
            gui.rowComp.toggleCss("ag-row-not-inline-editing", !editing);
        });
    }
    isCellEditable(column, rowNode) {
        if (rowNode.group) {
            if (this.gos.get("treeData")) {
                if (!rowNode.data && !this.gos.get("enableGroupEdit")) return false;
            } else {
                if (!this.gos.get("enableGroupEdit")) return false;
            }
        }
        return column.isColumnFunc(rowNode, column.colDef.editable);
    }
    // called by rowRenderer when user navigates via tab key
    /** @return whether to prevent default on event */ startRowOrCellEdit(cellCtrl, key, event = null) {
        if (!cellCtrl.comp) {
            cellCtrl.onCompAttachedFuncs.push(()=>{
                this.startRowOrCellEdit(cellCtrl, key, event);
            });
            return true;
        }
        if (this.gos.get("editType") === "fullRow") return this.beans.rowEditSvc?.startEditing(cellCtrl.rowCtrl, key, cellCtrl) ?? false;
        else return this.startEditing(cellCtrl, key, true, event);
    }
    // pass in 'true' to cancel the editing.
    stopRowOrCellEdit(cellCtrl, cancel = false, suppressNavigateAfterEdit = false, shiftKey = false) {
        if (this.gos.get("editType") === "fullRow") this.stopRowEditing(cellCtrl.rowCtrl, cancel);
        else this.stopEditing(cellCtrl, cancel);
        if (!suppressNavigateAfterEdit) this.navigateAfterEdit(shiftKey, cellCtrl.cellPosition);
    }
    createCellEditorParams(cellCtrl, key, cellStartedEdit) {
        const { column: column, rowNode: rowNode, cellPosition: { rowIndex: rowIndex } } = cellCtrl;
        const { valueSvc: valueSvc, gos: gos } = this.beans;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
            value: valueSvc.getValueForDisplay(column, rowNode).value,
            eventKey: key,
            column: column,
            colDef: column.getColDef(),
            rowIndex: rowIndex,
            node: rowNode,
            data: rowNode.data,
            cellStartedEdit: cellStartedEdit,
            onKeyDown: cellCtrl.onKeyDown.bind(cellCtrl),
            stopEditing: this.stopRowOrCellEdit.bind(this, cellCtrl, false),
            eGridCell: cellCtrl.eGui,
            parseValue: (newValue)=>valueSvc.parseValue(column, rowNode, newValue, cellCtrl.value),
            formatValue: cellCtrl.formatValue.bind(cellCtrl)
        });
    }
    navigateAfterEdit(shiftKey, cellPosition) {
        const enterNavigatesVerticallyAfterEdit = this.gos.get("enterNavigatesVerticallyAfterEdit");
        if (enterNavigatesVerticallyAfterEdit) {
            const key = shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            this.beans.navigation?.navigateToNextCell(null, key, cellPosition, false);
        }
    }
};
function $437b23f6a393c3bf$var$setEditing(cellCtrl, editing, compDetails) {
    cellCtrl.editCompDetails = compDetails;
    if (cellCtrl.editing === editing) return;
    cellCtrl.editing = editing;
}
function $437b23f6a393c3bf$var$takeValueFromCellEditor(cancel, cellComp) {
    const noValueResult = {
        newValueExists: false
    };
    if (cancel) return noValueResult;
    const cellEditor = cellComp.getCellEditor();
    if (!cellEditor) return noValueResult;
    const userWantsToCancel = cellEditor.isCancelAfterEnd && cellEditor.isCancelAfterEnd();
    if (userWantsToCancel) return noValueResult;
    const newValue = cellEditor.getValue();
    return {
        newValue: newValue,
        newValueExists: true
    };
}
function $437b23f6a393c3bf$var$saveNewValue(cellCtrl, oldValue, newValue, rowNode, column) {
    if (newValue === oldValue) return false;
    cellCtrl.suppressRefreshCell = true;
    const valueChanged = rowNode.setDataValue(column, newValue, "edit");
    cellCtrl.suppressRefreshCell = false;
    return valueChanged;
}
// packages/ag-grid-community/src/edit/rowEditService.ts
var $437b23f6a393c3bf$var$RowEditService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowEditSvc";
    }
    /** @return whether to prevent default on event */ startEditing(rowCtrl, key = null, sourceRenderedCell = null, event = null) {
        if (rowCtrl.editing) return false;
        let preventDefault = true;
        let atLeastOneEditing = false;
        const { editSvc: editSvc } = this.beans;
        rowCtrl.getAllCellCtrls().forEach((cellCtrl)=>{
            const cellStartedEdit = cellCtrl === sourceRenderedCell;
            if (cellStartedEdit) preventDefault = editSvc?.startEditing(cellCtrl, key, cellStartedEdit, event) ?? false;
            else editSvc?.startEditing(cellCtrl, null, cellStartedEdit, event);
            atLeastOneEditing || (atLeastOneEditing = cellCtrl.editing);
        });
        if (atLeastOneEditing) this.setEditing(rowCtrl, true);
        return preventDefault;
    }
    setEditing(rowCtrl, value) {
        rowCtrl.editing = value;
        rowCtrl.forEachGui(void 0, (gui)=>gui.rowComp.toggleCss("ag-row-editing", value));
        const event = value ? rowCtrl.createRowEvent("rowEditingStarted") : rowCtrl.createRowEvent("rowEditingStopped");
        this.eventSvc.dispatchEvent(event);
    }
};
// packages/ag-grid-community/src/edit/editModule.ts
var $437b23f6a393c3bf$export$12c61a50add34259 = {
    moduleName: "EditCore",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$EditService,
        $437b23f6a393c3bf$var$RowEditService
    ],
    apiFunctions: {
        getCellEditorInstances: $437b23f6a393c3bf$var$getCellEditorInstances,
        getEditingCells: $437b23f6a393c3bf$var$getEditingCells,
        stopEditing: $437b23f6a393c3bf$var$stopEditing,
        startEditingCell: $437b23f6a393c3bf$var$startEditingCell
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ],
    css: [
        $437b23f6a393c3bf$var$cellEditingCSS
    ]
};
var $437b23f6a393c3bf$export$2bb59c6ee8834731 = {
    moduleName: "UndoRedoEdit",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$UndoRedoService
    ],
    apiFunctions: {
        undoCellEditing: $437b23f6a393c3bf$var$undoCellEditing,
        redoCellEditing: $437b23f6a393c3bf$var$redoCellEditing,
        getCurrentUndoSize: $437b23f6a393c3bf$var$getCurrentUndoSize,
        getCurrentRedoSize: $437b23f6a393c3bf$var$getCurrentRedoSize
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$5e6636bea954ad4e = {
    moduleName: "TextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCellEditor: $437b23f6a393c3bf$var$TextCellEditor,
        agTextCellEditor: $437b23f6a393c3bf$var$TextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$9bc83f811986c4f2 = {
    moduleName: "NumberEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agNumberCellEditor: {
            classImp: $437b23f6a393c3bf$var$NumberCellEditor,
            params: {
                suppressPreventDefault: true
            }
        }
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$d1dd3475f4d98a27 = {
    moduleName: "DateEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agDateCellEditor: $437b23f6a393c3bf$var$DateCellEditor,
        agDateStringCellEditor: $437b23f6a393c3bf$var$DateStringCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$b6d3a45586965934 = {
    moduleName: "CheckboxEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agCheckboxCellEditor: $437b23f6a393c3bf$var$CheckboxCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$ccaa44b10c75f1d = {
    moduleName: "SelectEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agSelectCellEditor: $437b23f6a393c3bf$var$SelectCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1b6b5aa47694f20 = {
    moduleName: "LargeTextEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    userComponents: {
        agLargeTextCellEditor: $437b23f6a393c3bf$var$LargeTextCellEditor
    },
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
var $437b23f6a393c3bf$export$e1d2707568ed81f6 = {
    moduleName: "CustomEditor",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$12c61a50add34259
    ]
};
// packages/ag-grid-community/src/columns/selectionColService.ts
var $437b23f6a393c3bf$var$SelectionColService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "selectionColSvc";
    }
    postConstruct() {
        this.addManagedPropertyListener("rowSelection", (event)=>{
            this.onSelectionOptionsChanged(event.currentValue, event.previousValue, $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source));
        });
        this.addManagedPropertyListener("selectionColumnDef", this.updateColumns.bind(this));
    }
    addColumns(cols) {
        const selectionCols = this.columns;
        if (selectionCols == null) return;
        cols.list = selectionCols.list.concat(cols.list);
        cols.tree = selectionCols.tree.concat(cols.tree);
        $437b23f6a393c3bf$export$c82fd63ff1738bed(cols);
    }
    createColumns(cols, updateOrders) {
        const destroyCollection = ()=>{
            $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
            this.columns = null;
        };
        const newTreeDepth = cols.treeDepth;
        const oldTreeDepth = this.columns?.treeDepth ?? -1;
        const treeDepthSame = oldTreeDepth == newTreeDepth;
        const list = this.generateSelectionCols();
        const areSame = $437b23f6a393c3bf$export$f56e341a1fe35ed4(list, this.columns?.list ?? []);
        if (areSame && treeDepthSame) return;
        destroyCollection();
        const { colGroupSvc: colGroupSvc } = this.beans;
        const treeDepth = colGroupSvc?.findDepth(cols.tree) ?? 0;
        const tree = colGroupSvc?.balanceTreeForAutoCols(list, treeDepth) ?? [];
        this.columns = {
            list: list,
            tree: tree,
            treeDepth: treeDepth,
            map: {}
        };
        const putSelectionColsFirstInList = (cols2)=>{
            if (!cols2) return null;
            const colsFiltered = cols2.filter((col)=>!$437b23f6a393c3bf$export$f6074a9792015c5d(col));
            return [
                ...list,
                ...colsFiltered
            ];
        };
        updateOrders(putSelectionColsFirstInList);
    }
    updateColumns(event) {
        const source = $437b23f6a393c3bf$export$eb2a92b6162267d1(event.source);
        this.columns?.list.forEach((col)=>{
            const newColDef = this.createSelectionColDef(event.currentValue);
            col.setColDef(newColDef, null, source);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: [
                    {
                        ...newColDef,
                        colId: col.getColId()
                    }
                ]
            }, source);
        });
    }
    getColumn(key) {
        return this.columns?.list.find((col)=>$437b23f6a393c3bf$export$f5687d41c39fa1b3(col, key)) ?? null;
    }
    getColumns() {
        return this.columns?.list ?? null;
    }
    isSelectionColumnEnabled() {
        const { gos: gos, beans: beans } = this;
        const rowSelection = gos.get("rowSelection");
        if (typeof rowSelection !== "object" || !$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return false;
        const hasAutoCols = (beans.autoColSvc?.getColumns()?.length ?? 0) > 0;
        if (rowSelection.checkboxLocation === "autoGroupColumn" && hasAutoCols) return false;
        const checkboxes = !!$437b23f6a393c3bf$export$6df3a55606bca6ae(rowSelection);
        const headerCheckbox = $437b23f6a393c3bf$export$e92e75627785d7a4(rowSelection);
        return checkboxes || headerCheckbox;
    }
    createSelectionColDef(def) {
        const { gos: gos } = this.beans;
        const selectionColumnDef = def ?? gos.get("selectionColumnDef");
        const enableRTL = gos.get("enableRtl");
        const { rowSpan: _, spanRows: __, ...filteredSelColDef } = selectionColumnDef ?? {};
        return {
            // overridable properties
            width: 50,
            resizable: false,
            suppressHeaderMenuButton: true,
            sortable: false,
            suppressMovable: true,
            lockPosition: enableRTL ? "right" : "left",
            comparator (valueA, valueB, nodeA, nodeB) {
                const aSelected = nodeA.isSelected();
                const bSelected = nodeB.isSelected();
                return aSelected === bSelected ? 0 : aSelected ? 1 : -1;
            },
            editable: false,
            suppressFillHandle: true,
            pinned: null,
            // overrides
            ...filteredSelColDef,
            // non-overridable properties
            colId: $437b23f6a393c3bf$export$dd05e5f089eb2421,
            chartDataType: "excluded"
        };
    }
    generateSelectionCols() {
        if (!this.isSelectionColumnEnabled()) return [];
        const colDef = this.createSelectionColDef();
        const colId = colDef.colId;
        this.gos.validateColDef(colDef, colId, true);
        const col = new $437b23f6a393c3bf$export$a8da3e2b83e5ddf2(colDef, null, colId, false);
        this.createBean(col);
        return [
            col
        ];
    }
    onSelectionOptionsChanged(current, prev, source) {
        const prevCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(prev) : void 0;
        const currCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$6df3a55606bca6ae(current) : void 0;
        const checkboxHasChanged = prevCheckbox !== currCheckbox;
        const prevHeaderCheckbox = prev && typeof prev !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(prev) : void 0;
        const currHeaderCheckbox = current && typeof current !== "string" ? $437b23f6a393c3bf$export$e92e75627785d7a4(current) : void 0;
        const headerCheckboxHasChanged = prevHeaderCheckbox !== currHeaderCheckbox;
        const currLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(current);
        const prevLocation = $437b23f6a393c3bf$export$8fb5d781b5c28347(prev);
        const locationChanged = currLocation !== prevLocation;
        if (checkboxHasChanged || headerCheckboxHasChanged || locationChanged) this.beans.colModel.refreshAll(source);
    }
    destroy() {
        $437b23f6a393c3bf$export$dbaaa57234b60d8f(this.beans, this.columns?.tree);
        super.destroy();
    }
    /**
   * Refreshes visibility of the selection column based on which columns are currently visible.
   * Called by the VisibleColsService with the columns that are currently visible in left/center/right
   * containers. This method *MUTATES* those arrays directly.
   *
   * The selection column should be visible if all of the following are true
   * - The selection column is not disabled
   * - The number of visible columns excluding the selection column and row numbers column is greater than 0
   * @param leftCols Visible columns in the left-pinned container
   * @param centerCols Visible columns in the center viewport
   * @param rightCols Visible columns in the right-pinned container
   */ refreshVisibility(leftCols, centerCols, rightCols) {
        if (!this.columns?.list.length) return;
        const numVisibleCols = leftCols.length + centerCols.length + rightCols.length;
        if (numVisibleCols === 0) return;
        const column = this.columns.list[0];
        if (!column.isVisible()) return;
        const hideSelectionCol = ()=>{
            let cols;
            switch(column.pinned){
                case "left":
                case true:
                    cols = leftCols;
                    break;
                case "right":
                    cols = rightCols;
                    break;
                default:
                    cols = centerCols;
            }
            cols && $437b23f6a393c3bf$export$83a881c8b5120679(cols, column);
        };
        const rowNumbersCol = this.beans.rowNumbersSvc?.getColumn($437b23f6a393c3bf$export$f55c01dfb205b029);
        const expectedNumCols = rowNumbersCol ? 2 : 1;
        if (expectedNumCols === numVisibleCols) hideSelectionCol();
    }
};
// packages/ag-grid-community/src/selection/rowSelectionApi.ts
function $437b23f6a393c3bf$var$setNodesSelected(beans, params) {
    const allNodesValid = params.nodes.every((node)=>{
        if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
            $437b23f6a393c3bf$export$545083624300f13d(59);
            return false;
        }
        if (node.id === void 0) {
            $437b23f6a393c3bf$export$545083624300f13d(60);
            return false;
        }
        return true;
    });
    if (!allNodesValid) return;
    const { nodes: nodes, source: source, newValue: newValue } = params;
    beans.selectionSvc?.setNodesSelected({
        nodes: nodes,
        source: source ?? "api",
        newValue: newValue
    });
}
function $437b23f6a393c3bf$var$selectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$deselectAll(beans, selectAll2, source = "apiSelectAll") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: selectAll2
    });
}
function $437b23f6a393c3bf$var$selectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$deselectAllFiltered(beans, source = "apiSelectAllFiltered") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "filtered"
    });
}
function $437b23f6a393c3bf$var$selectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.selectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$deselectAllOnCurrentPage(beans, source = "apiSelectAllCurrentPage") {
    beans.selectionSvc?.deselectAllRowNodes({
        source: source,
        selectAll: "currentPage"
    });
}
function $437b23f6a393c3bf$var$getSelectedNodes(beans) {
    return beans.selectionSvc?.getSelectedNodes() ?? [];
}
function $437b23f6a393c3bf$var$getSelectedRows(beans) {
    return beans.selectionSvc?.getSelectedRows() ?? [];
}
// packages/ag-grid-community/src/selection/selectionService.ts
var $437b23f6a393c3bf$var$SelectionService = class extends $437b23f6a393c3bf$export$3d7b168c0c9c2a78 {
    constructor(){
        super(...arguments);
        this.beanName = "selectionSvc";
        this.selectedNodes = /* @__PURE__ */ new Map();
        /** Only used to track detail grid selection state when master/detail is enabled */ this.detailSelection = /* @__PURE__ */ new Map();
        this.masterSelectsDetail = false;
    }
    postConstruct() {
        super.postConstruct();
        const { gos: gos } = this;
        this.mode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
        this.groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
        this.groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
        this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "groupSelectsFiltered",
            "rowSelection"
        ], ()=>{
            const groupSelectsDescendants = $437b23f6a393c3bf$export$460e5745f0e6a40d(gos);
            const selectionMode = $437b23f6a393c3bf$export$80b6607444b3274f(gos);
            const groupSelectsFiltered = $437b23f6a393c3bf$export$673080972d8c733e(gos) === "filteredDescendants";
            this.masterSelectsDetail = $437b23f6a393c3bf$var$_getMasterSelects(gos) === "detail";
            if (groupSelectsDescendants !== this.groupSelectsDescendants || groupSelectsFiltered !== this.groupSelectsFiltered || selectionMode !== this.mode) {
                this.deselectAllRowNodes({
                    source: "api"
                });
                this.groupSelectsDescendants = groupSelectsDescendants;
                this.groupSelectsFiltered = groupSelectsFiltered;
                this.mode = selectionMode;
            }
        });
        this.addManagedEventListeners({
            rowSelected: this.onRowSelected.bind(this)
        });
    }
    destroy() {
        super.destroy();
        this.resetNodes();
    }
    handleSelectionEvent(event, rowNode, source) {
        if (this.isRowSelectionBlocked(rowNode)) return 0;
        const selection = this.inferNodeSelections(rowNode, event.shiftKey, event.metaKey || event.ctrlKey, source);
        if (selection == null) return 0;
        this.selectionCtx.selectAll = false;
        if ("select" in selection) {
            if (selection.reset) this.resetNodes();
            else this.selectRange(selection.deselect, false, source);
            return this.selectRange(selection.select, true, source);
        } else return this.setNodesSelected({
            nodes: [
                selection.node
            ],
            newValue: selection.newValue,
            clearSelection: selection.clearSelection,
            keepDescendants: selection.keepDescendants,
            event: event,
            source: source
        });
    }
    setNodesSelected({ newValue: newValue, clearSelection: clearSelection, suppressFinishActions: suppressFinishActions, nodes: nodes, event: event, source: source, keepDescendants: keepDescendants = false }) {
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(this.gos) && newValue) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return 0;
        }
        if (nodes.length === 0) return 0;
        if (nodes.length > 1 && !this.isMultiSelect()) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return 0;
        }
        let updatedCount = 0;
        for(let i = 0; i < nodes.length; i++){
            const rowNode = nodes[i];
            const node = $437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode);
            const skipThisNode = this.groupSelectsFiltered && node.group;
            if (node.rowPinned && !$437b23f6a393c3bf$var$_isManualPinnedRow(node)) {
                $437b23f6a393c3bf$export$545083624300f13d(59);
                continue;
            }
            if (node.id === void 0) {
                $437b23f6a393c3bf$export$545083624300f13d(60);
                continue;
            }
            if (!skipThisNode) {
                const thisNodeWasSelected = this.selectRowNode(node, newValue, event, source);
                if (thisNodeWasSelected) {
                    this.detailSelection.delete(node.id);
                    updatedCount++;
                }
            }
            if (this.groupSelectsDescendants && node.childrenAfterGroup?.length) updatedCount += this.selectChildren(node, newValue, source);
        }
        if (!suppressFinishActions) {
            if (nodes.length === 1 && source === "api") this.selectionCtx.setRoot($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]));
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiSelect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes($437b23f6a393c3bf$var$_normaliseSiblingRef(nodes[0]), keepDescendants, source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                this.dispatchSelectionChanged(source);
            }
        }
        return updatedCount;
    }
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(nodesToSelect, value, source) {
        let updatedCount = 0;
        nodesToSelect.forEach((node)=>{
            const rowNode = $437b23f6a393c3bf$var$_normaliseSiblingRef(node);
            if (rowNode.group && this.groupSelectsDescendants) return;
            const nodeWasSelected = this.selectRowNode(rowNode, value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        if (updatedCount > 0) {
            this.updateGroupsFromChildrenSelections(source);
            this.dispatchSelectionChanged(source);
        }
        return updatedCount;
    }
    selectChildren(node, newValue, source) {
        const children = this.groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if (!children) return 0;
        return this.setNodesSelected({
            newValue: newValue,
            clearSelection: false,
            suppressFinishActions: true,
            source: source,
            nodes: children
        });
    }
    getSelectedNodes() {
        return Array.from(this.selectedNodes.values());
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>selectedRows.push(rowNode.data));
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            if (predicate(rowNode)) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsDescendants) return false;
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return false;
        const rootNode = rowModel.rootNode;
        if (!rootNode) return false;
        if (!changedPath) {
            changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(true, rootNode);
            changedPath.active = false;
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = this.calculateSelectedFromChildren(rowNode);
                selectionChanged = this.selectRowNode(rowNode, selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, keepDescendants, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            const isNodeToKeep = otherRowNode.id == rowNodeToKeepSelected.id;
            const shouldClearDescendant = keepDescendants ? !$437b23f6a393c3bf$var$isDescendantOf(rowNodeToKeepSelected, otherRowNode) : true;
            if (shouldClearDescendant && !isNodeToKeep) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += this.setNodesSelected({
                    nodes: [
                        rowNode
                    ],
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source: source
                });
                if (this.groupSelectsDescendants && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = this.calculateSelectedFromChildren(group);
            this.selectRowNode(group, selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsDescendants && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    createDaemonNode(rowNode) {
        if (!rowNode.id) return void 0;
        const oldNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        oldNode.id = rowNode.id;
        oldNode.data = rowNode.data;
        oldNode.__daemon = true;
        oldNode.__selected = rowNode.__selected;
        oldNode.level = rowNode.level;
        return oldNode;
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        if (oldNode && rowNode.id !== oldNode.id) {
            const oldNodeSelected = this.selectedNodes.get(oldNode.id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.__selected = true;
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.__selected = false;
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) this.dispatchSelectionChanged(source);
    }
    resetNodes() {
        this.selectedNodes.forEach((node)=>{
            this.selectRowNode(node, false);
        });
        this.selectedNodes.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos, rowModel)) return;
        const topLevelNodes = rowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else if (node.group && node.childrenAfterGroup) traverse(node.childrenAfterGroup);
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        return this.getSelectionCount() === 0;
    }
    deselectAllRowNodes({ source: source, selectAll: selectAll2 }) {
        const rowModelClientSide = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        let updatedNodes = false;
        const callback = (rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), false, void 0, source);
            updatedNodes || (updatedNodes = updated);
        };
        if (selectAll2 === "currentPage" || selectAll2 === "filtered") {
            if (!rowModelClientSide) {
                $437b23f6a393c3bf$export$a20c7248650823a9(102);
                return;
            }
            this.getNodesToSelect(selectAll2).forEach(callback);
        } else {
            this.selectedNodes.forEach(callback);
            this.reset(source);
        }
        this.selectionCtx.selectAll = false;
        if (rowModelClientSide && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectedCounts(selectAll2) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        this.getNodesToSelect(selectAll2).forEach((node)=>{
            if (this.groupSelectsDescendants && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (node.selectable) notSelectedCount++;
        });
        return {
            selectedCount: selectedCount,
            notSelectedCount: notSelectedCount
        };
    }
    getSelectAllState(selectAll2) {
        const { selectedCount: selectedCount, notSelectedCount: notSelectedCount } = this.getSelectedCounts(selectAll2);
        return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount) ?? null;
    }
    hasNodesToSelect(selectAll2) {
        return this.getNodesToSelect(selectAll2).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(selectAll2) {
        if (!this.canSelectAll()) return [];
        const nodes = [];
        const addToResult = (node)=>nodes.push(node);
        if (selectAll2 === "currentPage") {
            this.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    addToResult(node);
                    return;
                }
                if (!node.expanded && !node.footer) {
                    const recursivelyAddChildren = (child)=>{
                        addToResult(child);
                        child.childrenAfterFilter?.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsDescendants) addToResult(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.beans.rowModel;
        if (selectAll2 === "filtered") {
            clientSideRowModel.forEachNodeAfterFilter(addToResult);
            return nodes;
        }
        clientSideRowModel.forEachNode(addToResult);
        return nodes;
    }
    forEachNodeOnPage(callback) {
        const { pageBounds: pageBounds, rowModel: rowModel } = this.beans;
        const firstRow = pageBounds.getFirstRow();
        const lastRow = pageBounds.getLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = rowModel.getRow(i);
            if (node) callback(node);
        }
    }
    selectAllRowNodes(params) {
        const { gos: gos, selectionCtx: selectionCtx } = this;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(132);
            return;
        }
        if ($437b23f6a393c3bf$export$d3c80fcacb2e2d55(gos) && !$437b23f6a393c3bf$export$7bd8c52ebc4117d6(gos)) {
            $437b23f6a393c3bf$export$545083624300f13d(130);
            return;
        }
        if (!this.canSelectAll()) return;
        const { source: source, selectAll: selectAll2 } = params;
        let updatedNodes = false;
        this.getNodesToSelect(selectAll2).forEach((rowNode)=>{
            const updated = this.selectRowNode($437b23f6a393c3bf$var$_normaliseSiblingRef(rowNode), true, void 0, source);
            updatedNodes || (updatedNodes = updated);
        });
        selectionCtx.selectAll = true;
        if ($437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants) {
            const updated = this.updateGroupsFromChildrenSelections(source);
            updatedNodes || (updatedNodes = updated);
        }
        if (updatedNodes) this.dispatchSelectionChanged(source);
    }
    getSelectionState() {
        return this.isEmpty() ? null : Array.from(this.selectedNodes.keys());
    }
    setSelectionState(state, source) {
        if (!Array.isArray(state)) {
            $437b23f6a393c3bf$export$a20c7248650823a9(103);
            return;
        }
        const rowIds = new Set(state);
        const nodes = [];
        this.beans.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        this.setNodesSelected({
            newValue: true,
            nodes: nodes,
            source: source
        });
    }
    canSelectAll() {
        const { gos: gos } = this.beans;
        if (!$437b23f6a393c3bf$export$9f182d9ca737e15(gos)) return false;
        return true;
    }
    /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */ updateSelectable(changedPath) {
        const { gos: gos, rowModel: rowModel } = this.beans;
        if (!$437b23f6a393c3bf$export$5d5fd838f5df1dd2(gos)) return;
        const source = "selectableChanged";
        const skipLeafNodes = changedPath !== void 0;
        const isCSRMGroupSelectsDescendants = $437b23f6a393c3bf$export$9f182d9ca737e15(gos) && this.groupSelectsDescendants;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCSRMGroupSelectsDescendants && node.group) {
                const hasSelectableChild = node.childrenAfterGroup?.some((rowNode)=>rowNode.selectable) ?? false;
                this.setRowSelectable(node, hasSelectableChild, true);
                return;
            }
            const rowSelectable = this.updateRowSelectable(node, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCSRMGroupSelectsDescendants) {
            if (changedPath === void 0) {
                const rootNode = rowModel.rootNode;
                changedPath = rootNode ? new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, rootNode) : void 0;
            }
            changedPath?.forEachChangedNodeDepthFirst(nodeCallback, !skipLeafNodes, !skipLeafNodes);
        } else rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: source
        });
        if (!skipLeafNodes && isCSRMGroupSelectsDescendants) this.updateGroupsFromChildrenSelections?.(source);
    }
    // only called by CSRM
    updateSelectableAfterGrouping(changedPath) {
        this.updateSelectable(changedPath);
        if (this.groupSelectsDescendants) {
            const selectionChanged = this.updateGroupsFromChildrenSelections?.("rowGroupChanged", changedPath);
            if (selectionChanged) this.dispatchSelectionChanged("rowGroupChanged");
        }
    }
    refreshMasterNodeState(node, e) {
        if (!this.masterSelectsDetail) return;
        const detailApi = node.detailNode?.detailGridInfo?.api;
        if (!detailApi) return;
        const isSelectAll = $437b23f6a393c3bf$var$_isAllSelected(detailApi);
        const current = node.isSelected();
        if (current !== isSelectAll) {
            const selectionChanged = this.selectRowNode(node, isSelectAll, e, "masterDetail");
            if (selectionChanged) this.dispatchSelectionChanged("masterDetail");
        }
        if (!isSelectAll) {
            const detailSelected = this.detailSelection.get(node.id) ?? /* @__PURE__ */ new Set();
            for (const n of detailApi.getSelectedNodes())detailSelected.add(n.id);
            this.detailSelection.set(node.id, detailSelected);
        }
    }
    setDetailSelectionState(masterNode, detailGridOptions, detailApi) {
        if (!this.masterSelectsDetail) return;
        if (!$437b23f6a393c3bf$export$7bd8c52ebc4117d6(detailGridOptions)) {
            $437b23f6a393c3bf$export$545083624300f13d(269);
            return;
        }
        switch(masterNode.isSelected()){
            case true:
                detailApi.selectAll();
                break;
            case false:
                detailApi.deselectAll();
                break;
            case void 0:
                {
                    const selectedIds = this.detailSelection.get(masterNode.id);
                    if (selectedIds) {
                        const nodes = [];
                        for (const id of selectedIds){
                            const n = detailApi.getRowNode(id);
                            if (n) nodes.push(n);
                        }
                        detailApi.setNodesSelected({
                            nodes: nodes,
                            newValue: true,
                            source: "masterDetail"
                        });
                    }
                    break;
                }
            default:
                break;
        }
    }
    dispatchSelectionChanged(source) {
        this.eventSvc.dispatchEvent({
            type: "selectionChanged",
            source: source,
            selectedNodes: this.getSelectedNodes(),
            serverSideState: null
        });
    }
};
function $437b23f6a393c3bf$var$_normaliseSiblingRef(node) {
    return $437b23f6a393c3bf$var$_isManualPinnedRow(node) ? node.pinnedSibling : node.footer ? node.sibling : node;
}
function $437b23f6a393c3bf$var$_isAllSelected(api) {
    let selectedCount = 0;
    let notSelectedCount = 0;
    api.forEachNode((node)=>{
        if (node.isSelected()) selectedCount++;
        else if (node.selectable) notSelectedCount++;
    });
    return $437b23f6a393c3bf$var$_calculateSelectAllState(selectedCount, notSelectedCount);
}
function $437b23f6a393c3bf$var$_calculateSelectAllState(selected, notSelected) {
    if (selected === 0 && notSelected === 0) return false;
    if (selected > 0 && notSelected > 0) return;
    return selected > 0;
}
function $437b23f6a393c3bf$var$isDescendantOf(root, child) {
    let parent = child.parent;
    while(parent){
        if (parent === root) return true;
        parent = parent.parent;
    }
    return false;
}
// packages/ag-grid-community/src/selection/rowSelectionModule.ts
var $437b23f6a393c3bf$export$16cbd1164b82410d = {
    moduleName: "SharedRowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$SelectionColService
    ],
    apiFunctions: {
        setNodesSelected: $437b23f6a393c3bf$var$setNodesSelected,
        selectAll: $437b23f6a393c3bf$var$selectAll,
        deselectAll: $437b23f6a393c3bf$var$deselectAll,
        selectAllFiltered: $437b23f6a393c3bf$var$selectAllFiltered,
        deselectAllFiltered: $437b23f6a393c3bf$var$deselectAllFiltered,
        selectAllOnCurrentPage: $437b23f6a393c3bf$var$selectAllOnCurrentPage,
        deselectAllOnCurrentPage: $437b23f6a393c3bf$var$deselectAllOnCurrentPage,
        getSelectedNodes: $437b23f6a393c3bf$var$getSelectedNodes,
        getSelectedRows: $437b23f6a393c3bf$var$getSelectedRows
    }
};
var $437b23f6a393c3bf$export$dae0b5c1ba15d66f = {
    moduleName: "RowSelection",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide",
        "infinite",
        "viewport"
    ],
    beans: [
        $437b23f6a393c3bf$var$SelectionService
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$16cbd1164b82410d
    ]
};
// packages/ag-grid-community/src/api/csrmSsrmSharedApi.ts
function $437b23f6a393c3bf$var$expandAll(beans) {
    beans.expansionSvc?.expandAll(true);
}
function $437b23f6a393c3bf$var$collapseAll(beans) {
    beans.expansionSvc?.expandAll(false);
}
function $437b23f6a393c3bf$var$onRowHeightChanged(beans) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (clientSideRowModel) clientSideRowModel.onRowHeightChanged();
    else if (serverSideRowModel) serverSideRowModel.onRowHeightChanged();
}
// packages/ag-grid-community/src/api/ssrmInfiniteSharedApi.ts
function $437b23f6a393c3bf$var$setRowCount(beans, rowCount, maxRowFound) {
    const serverSideRowModel = $437b23f6a393c3bf$export$aada92189a74e985(beans);
    if (serverSideRowModel) {
        if (beans.rowGroupColsSvc?.columns.length === 0) {
            if (rowCount < 0) {
                $437b23f6a393c3bf$export$a20c7248650823a9(238);
                return;
            }
            serverSideRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        $437b23f6a393c3bf$export$a20c7248650823a9(28);
        return;
    }
    const infiniteRowModel = $437b23f6a393c3bf$var$_getInfiniteRowModel(beans);
    if (infiniteRowModel) {
        infiniteRowModel.setRowCount(rowCount, maxRowFound);
        return;
    }
}
function $437b23f6a393c3bf$var$getCacheBlockState(beans) {
    if ($437b23f6a393c3bf$export$cf1bac0013650216(beans.gos)) {
        const ssrm = beans.rowModel;
        return ssrm.getBlockStates();
    }
    return beans.rowNodeBlockLoader?.getBlockState() ?? {};
}
function $437b23f6a393c3bf$var$isLastRowIndexKnown(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
// packages/ag-grid-community/src/api/sharedApiModule.ts
var $437b23f6a393c3bf$export$76fb120d9e251426 = {
    moduleName: "CsrmSsrmSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        expandAll: $437b23f6a393c3bf$var$expandAll,
        collapseAll: $437b23f6a393c3bf$var$collapseAll,
        onRowHeightChanged: $437b23f6a393c3bf$var$onRowHeightChanged
    }
};
var $437b23f6a393c3bf$export$2f6740e35dedc261 = {
    moduleName: "SsrmInfiniteSharedApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setRowCount: $437b23f6a393c3bf$var$setRowCount,
        getCacheBlockState: $437b23f6a393c3bf$var$getCacheBlockState,
        isLastRowIndexKnown: $437b23f6a393c3bf$var$isLastRowIndexKnown
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsService.ts
var $437b23f6a393c3bf$var$AlignedGridsService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "alignedGridsSvc";
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    getAlignedGridApis() {
        let alignedGrids = this.gos.get("alignedGrids") ?? [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const apis = alignedGrids.map((alignedGrid)=>{
            if (!alignedGrid) {
                $437b23f6a393c3bf$export$a20c7248650823a9(18);
                if (!isCallbackConfig) $437b23f6a393c3bf$export$a20c7248650823a9(20);
                return;
            }
            if (this.isGridApi(alignedGrid)) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return refOrComp.current?.api;
            if (!refOrComp.api) $437b23f6a393c3bf$export$a20c7248650823a9(19);
            return refOrComp.api;
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    isGridApi(ref) {
        return !!ref && !!ref.dispatchEvent;
    }
    postConstruct() {
        const fireColumnEvent = this.fireColumnEvent.bind(this);
        this.addManagedEventListeners({
            columnMoved: fireColumnEvent,
            columnVisible: fireColumnEvent,
            columnPinned: fireColumnEvent,
            columnGroupOpened: fireColumnEvent,
            columnResized: fireColumnEvent,
            bodyScroll: this.fireScrollEvent.bind(this),
            alignedGridColumn: ({ event: event })=>this.onColumnEvent(event),
            alignedGridScroll: ({ event: event })=>this.onScrollEvent(event)
        });
    }
    // common logic across all the fire methods
    fireEvent(event) {
        if (this.consuming) return;
        this.getAlignedGridApis().forEach((api)=>{
            if (api.isDestroyed()) return;
            api.dispatchEvent(event);
        });
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(columnEvent) {
        this.fireEvent({
            type: "alignedGridColumn",
            event: columnEvent
        });
    }
    fireScrollEvent(scrollEvent) {
        if (scrollEvent.direction !== "horizontal") return;
        this.fireEvent({
            type: "alignedGridScroll",
            event: scrollEvent
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    extractDataFromEvent(event, func) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(func(column));
        });
        else if (event.column) result.push(func(event.column));
        return result;
    }
    getMasterColumns(event) {
        return this.extractDataFromEvent(event, (col)=>col);
    }
    getColumnIds(event) {
        return this.extractDataFromEvent(event, (col)=>col.getColId());
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case "columnMoved":
                case "columnVisible":
                case "columnPinned":
                case "columnResized":
                    this.processColumnEvent(event);
                    break;
                case "columnGroupOpened":
                    this.processGroupOpenedEvent(event);
                    break;
                case "columnPivotChanged":
                    $437b23f6a393c3bf$export$545083624300f13d(21);
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        const { colGroupSvc: colGroupSvc } = this.beans;
        if (!colGroupSvc) return;
        groupOpenedEvent.columnGroups.forEach((masterGroup)=>{
            let otherColumnGroup = null;
            if (masterGroup) otherColumnGroup = colGroupSvc.getProvidedColGroup(masterGroup.getGroupId());
            if (masterGroup && !otherColumnGroup) return;
            colGroupSvc.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        });
    }
    processColumnEvent(colEvent) {
        const masterColumn = colEvent.column;
        let otherColumn = null;
        const beans = this.beans;
        const { colResize: colResize, ctrlsSvc: ctrlsSvc, colModel: colModel } = beans;
        if (masterColumn) otherColumn = colModel.getColDefCol(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case "columnMoved":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                }
                break;
            case "columnVisible":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnPinned":
                {
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                        state: destColState
                    }, "alignedGridChanged");
                }
                break;
            case "columnResized":
                {
                    const resizedEvent = colEvent;
                    const columnWidths = {};
                    masterColumns.forEach((column)=>{
                        columnWidths[column.getId()] = {
                            key: column.getColId(),
                            newWidth: column.getActualWidth()
                        };
                    });
                    resizedEvent.flexColumns?.forEach((col)=>{
                        if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                    });
                    colResize?.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                    break;
                }
        }
        const gridBodyCon = ctrlsSvc.getGridBodyCtrl();
        const isVerticalScrollShowing = gridBodyCon.isVerticalScrollShowing();
        this.getAlignedGridApis().forEach((api)=>{
            api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing);
        });
    }
};
// packages/ag-grid-community/src/alignedGrids/alignedGridsModule.ts
var $437b23f6a393c3bf$export$a8c763073927f695 = {
    moduleName: "AlignedGrids",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$AlignedGridsService
    ]
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideNodeManager.ts
var $437b23f6a393c3bf$var$ClientSideNodeManager = class extends $437b23f6a393c3bf$export$4d7e4be6cbba058c {
    constructor(){
        super(...arguments);
        this.beanName = "csrmNodeSvc";
    }
};
// packages/ag-grid-community/src/clientSideRowModel/changedRowNodes.ts
var $437b23f6a393c3bf$var$ChangedRowNodes = class {
    constructor(){
        this.removals = /* @__PURE__ */ new Set();
        this.updates = /* @__PURE__ */ new Set();
        this.adds = /* @__PURE__ */ new Set();
    }
    /** Marks a row as removed. Order of operations is: remove, update, add */ remove(node) {
        if (!this.adds.delete(node)) {
            this.updates.delete(node);
            this.removals.add(node);
        }
    }
    /** Marks a row as updated. Order of operations is: remove, update, add */ update(node) {
        if (!this.adds.has(node)) this.updates.add(node);
    }
    /** Marks a row as added. Order of operation is: remove, update, add */ add(node) {
        this.adds.add(node);
    }
};
// packages/ag-grid-community/src/clientSideRowModel/sortStage.ts
function $437b23f6a393c3bf$var$updateChildIndexes(rowNode) {
    if ($437b23f6a393c3bf$export$672d9e47bc342bac(rowNode.childrenAfterSort)) return;
    const listToSort = rowNode.childrenAfterSort;
    for(let i = 0; i < listToSort.length; i++){
        const child = listToSort[i];
        const firstChild = i === 0;
        const lastChild = i === rowNode.childrenAfterSort.length - 1;
        child.setFirstChild(firstChild);
        if (child.lastChild !== lastChild) {
            child.lastChild = lastChild;
            child.dispatchRowEvent("lastChildChanged");
        }
        if (child.childIndex !== i) {
            child.childIndex = i;
            child.dispatchRowEvent("childIndexChanged");
        }
    }
}
function $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode) {
    if (rowNode.sibling) rowNode.sibling.childrenAfterSort = rowNode.childrenAfterSort;
    $437b23f6a393c3bf$var$updateChildIndexes(rowNode);
}
var $437b23f6a393c3bf$var$SortStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "sortStage";
        this.refreshProps = /* @__PURE__ */ new Set([
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ]);
        this.step = "sort";
    }
    execute(params) {
        const beans = this.beans;
        const sortOptions = beans.sortSvc.getSortOptions();
        const sortActive = $437b23f6a393c3bf$export$25d27f17d3af40f7(sortOptions) && sortOptions.length > 0;
        const deltaSort = sortActive && !!params.changedRowNodes && // in time we can remove this check, so that delta sort is always
        // on if transactions are present. it's off for now so that we can
        // selectively turn it on and test it with some select users before
        // rolling out to everyone.
        this.gos.get("deltaSort");
        const sortContainsGroupColumns = sortOptions.some(({ column: column })=>{
            const isSortingCoupled = $437b23f6a393c3bf$export$96c51c2547b81aed(beans.gos);
            if (isSortingCoupled) return column.isPrimary() && column.isRowGroupActive();
            return !!column.getColDef().showRowGroup;
        });
        this.sort(beans, sortOptions, sortActive, deltaSort, params.changedRowNodes, params.changedPath, sortContainsGroupColumns);
    }
    sort(beans, sortOptions, sortActive, useDeltaSort, changedRowNodes, changedPath, sortContainsGroupColumns) {
        const { gos: gos, colModel: colModel, rowGroupColsSvc: rowGroupColsSvc, rowNodeSorter: rowNodeSorter, rowRenderer: rowRenderer, showRowGroupCols: showRowGroupCols } = beans;
        const groupMaintainOrder = gos.get("groupMaintainOrder");
        const groupColumnsPresent = colModel.getCols().some((c)=>c.isRowGroupActive());
        const isPivotMode = colModel.isPivotMode();
        const postSortFunc = gos.getCallback("postSortRows");
        let hasAnyFirstChildChanged = false;
        const callback = (rowNode)=>{
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            const skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup && !sortContainsGroupColumns;
            let newChildrenAfterSort;
            if (skipSortingGroups) {
                const nextGroup = rowGroupColsSvc?.columns?.[rowNode.level + 1];
                const wasSortExplicitlyRemoved = nextGroup?.getSort() === null;
                const childrenToBeSorted = rowNode.childrenAfterAggFilter.slice(0);
                if (rowNode.childrenAfterSort && !wasSortExplicitlyRemoved) {
                    const indexedOrders = {};
                    rowNode.childrenAfterSort.forEach((node, idx)=>{
                        indexedOrders[node.id] = idx;
                    });
                    childrenToBeSorted.sort((row1, row2)=>(indexedOrders[row1.id] ?? 0) - (indexedOrders[row2.id] ?? 0));
                }
                newChildrenAfterSort = childrenToBeSorted;
            } else if (!sortActive || skipSortingPivotLeafs) newChildrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            else if (useDeltaSort && changedRowNodes) newChildrenAfterSort = $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions);
            else newChildrenAfterSort = rowNodeSorter.doFullSort(rowNode.childrenAfterAggFilter, sortOptions);
            hasAnyFirstChildChanged || (hasAnyFirstChildChanged = rowNode.childrenAfterSort?.[0] !== newChildrenAfterSort[0]);
            rowNode.childrenAfterSort = newChildrenAfterSort;
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        changedPath?.forEachChangedNodeDepthFirst(callback);
        if (hasAnyFirstChildChanged && this.gos.get("groupHideOpenParents")) {
            const columns = showRowGroupCols?.getShowRowGroupCols();
            if (columns?.length) rowRenderer.refreshCells({
                columns: columns,
                force: true
            });
        }
    }
};
function $437b23f6a393c3bf$var$doDeltaSort(rowNodeSorter, rowNode, changedRowNodes, changedPath, sortOptions) {
    const unsortedRows = rowNode.childrenAfterAggFilter;
    const oldSortedRows = rowNode.childrenAfterSort;
    if (!oldSortedRows) return rowNodeSorter.doFullSort(unsortedRows, sortOptions);
    const untouchedRows = /* @__PURE__ */ new Set();
    const touchedRows = [];
    const { updates: updates, adds: adds } = changedRowNodes;
    for(let i = 0, len = unsortedRows.length; i < len; ++i){
        const row = unsortedRows[i];
        if (updates.has(row) || adds.has(row) || changedPath && !changedPath.canSkip(row)) touchedRows.push({
            currentPos: touchedRows.length,
            rowNode: row
        });
        else untouchedRows.add(row.id);
    }
    const sortedUntouchedRows = oldSortedRows.filter((child)=>untouchedRows.has(child.id)).map((rowNode2, currentPos)=>({
            currentPos: currentPos,
            rowNode: rowNode2
        }));
    touchedRows.sort((a, b)=>rowNodeSorter.compareRowNodes(sortOptions, a, b));
    return $437b23f6a393c3bf$var$mergeSortedArrays(rowNodeSorter, sortOptions, touchedRows, sortedUntouchedRows);
}
function $437b23f6a393c3bf$var$mergeSortedArrays(rowNodeSorter, sortOptions, arr1, arr2) {
    const res = [];
    let i = 0;
    let j = 0;
    const arr1Length = arr1.length;
    const arr2Length = arr2.length;
    while(i < arr1Length && j < arr2Length){
        const a = arr1[i];
        const b = arr2[j];
        const compareResult = rowNodeSorter.compareRowNodes(sortOptions, a, b);
        let chosen;
        if (compareResult < 0) {
            chosen = a;
            ++i;
        } else {
            chosen = b;
            ++j;
        }
        res.push(chosen.rowNode);
    }
    while(i < arr1Length)res.push(arr1[i++].rowNode);
    while(j < arr2Length)res.push(arr2[j++].rowNode);
    return res;
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModel.ts
var $437b23f6a393c3bf$var$ClientSideRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
        // top most node of the tree. the children are the user provided data.
        this.rootNode = null;
        this.rowsToDisplay = [];
        this.lastHighlightedRow = null;
        /** Has the start method been called */ this.started = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.isRefreshingModel = false;
        this.rowNodesCountReady = false;
        this.rowCountReady = false;
        this.onRowHeightChanged_debounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.onRowHeightChanged.bind(this), 100);
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.valueCache = beans.valueCache;
        this.filterStage = beans.filterStage;
        this.sortStage = beans.sortStage;
        this.flattenStage = beans.flattenStage;
        this.groupStage = beans.groupStage;
        this.aggStage = beans.aggStage;
        this.pivotStage = beans.pivotStage;
        this.filterAggStage = beans.filterAggStage;
    }
    postConstruct() {
        this.orderedStages = [
            this.groupStage,
            this.filterStage,
            this.pivotStage,
            this.aggStage,
            this.sortStage,
            this.filterAggStage,
            this.flattenStage
        ].filter((stage)=>!!stage);
        const refreshEverythingFunc = this.refreshModel.bind(this, {
            step: "group"
        });
        const refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
            step: "group",
            // after cols change, row grouping (the first stage) could of changed
            afterColumnsChanged: true,
            keepRenderedRows: true,
            // we want animations cos sorting or filtering could be applied
            animate: !this.gos.get("suppressAnimationFrame")
        });
        this.addManagedEventListeners({
            newColumnsLoaded: refreshEverythingAfterColsChangedFunc,
            columnRowGroupChanged: refreshEverythingFunc,
            columnValueChanged: this.onValueChanged.bind(this),
            columnPivotChanged: this.refreshModel.bind(this, {
                step: "pivot"
            }),
            filterChanged: this.onFilterChanged.bind(this),
            sortChanged: this.onSortChanged.bind(this),
            columnPivotModeChanged: refreshEverythingFunc,
            gridStylesChanged: this.onGridStylesChanges.bind(this),
            gridReady: this.onGridReady.bind(this)
        });
        this.addPropertyListeners();
        this.rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        const nodeManager = this.getNewNodeManager();
        this.nodeManager = nodeManager;
        nodeManager.activate(this.rootNode);
    }
    getNewNodeManager() {
        const { gos: gos, beans: beans } = this;
        switch($437b23f6a393c3bf$export$e9780a3033a82b4f(gos)){
            case "treeNested":
                return beans.csrmChildrenTreeNodeSvc ?? beans.csrmNodeSvc;
            case "treePath":
                return beans.csrmPathTreeNodeSvc ?? beans.csrmNodeSvc;
            default:
                return beans.csrmNodeSvc;
        }
    }
    addPropertyListeners() {
        const allProps = [
            "treeData",
            "treeDataChildrenField",
            ...this.orderedStages.flatMap(({ refreshProps: refreshProps })=>[
                    ...refreshProps
                ])
        ];
        this.addManagedPropertyListeners(allProps, (params)=>{
            const properties = params.changeSet?.properties;
            if (properties) this.onPropChange(properties);
        });
        this.addManagedPropertyListener("rowData", ()=>this.onPropChange([
                "rowData"
            ]));
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.started = true;
        if (this.rowNodesCountReady) this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            newData: true
        });
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) this.onPropChange([
            "rowData"
        ]);
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    onPropChange(properties) {
        if (!this.rootNode) return;
        const gos = this.gos;
        const changedProps = new Set(properties);
        const params = {
            step: "nothing",
            changedProps: changedProps
        };
        const rowDataChanged = changedProps.has("rowData");
        const oldNodeManager = this.nodeManager;
        const nodeManager = this.getNewNodeManager();
        const reset = oldNodeManager !== nodeManager || rowDataChanged && changedProps.has("treeData") && gos.get("treeData") || changedProps.has("treeDataChildrenField") && gos.get("treeData");
        let newRowData;
        if (reset || rowDataChanged) {
            newRowData = gos.get("rowData");
            if (newRowData != null && !Array.isArray(newRowData)) {
                newRowData = null;
                $437b23f6a393c3bf$export$545083624300f13d(1);
            }
        }
        if (reset) {
            if (!rowDataChanged) newRowData = oldNodeManager?.extractRowData() ?? newRowData;
            if (oldNodeManager !== nodeManager) {
                oldNodeManager?.deactivate();
                this.nodeManager = nodeManager;
            }
            nodeManager.activate(this.rootNode);
        }
        if (newRowData) {
            const immutable = !reset && !this.isEmpty() && newRowData.length > 0 && gos.exists("getRowId") && // this property is a backwards compatibility property, for those who want
            // the old behaviour of Row IDs but NOT Immutable Data.
            !gos.get("resetRowDataOnUpdate");
            if (immutable) {
                params.keepRenderedRows = true;
                params.animate = !this.gos.get("suppressAnimationFrame");
                params.changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
                nodeManager.setImmutableRowData(params, newRowData);
            } else {
                params.rowDataUpdated = true;
                params.newData = true;
                const { selectionSvc: selectionSvc, pinnedRowModel: pinnedRowModel } = this.beans;
                selectionSvc?.reset("rowDataChanged");
                if (pinnedRowModel?.isManual()) pinnedRowModel.reset();
                this.rowNodesCountReady = true;
                nodeManager.setNewRowData(newRowData);
            }
        }
        if (params.rowDataUpdated) params.step = "group";
        else if (params.step === "nothing") {
            for (const { refreshProps: refreshProps, step: step } of this.orderedStages)if (properties.some((prop)=>refreshProps.has(prop))) {
                params.step = step;
                break;
            }
        }
        if (params.step !== "nothing") this.refreshModel(params);
    }
    setRowTopAndRowIndex() {
        const { beans: beans, rowsToDisplay: rowsToDisplay } = this;
        const defaultRowHeight = beans.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const displayedRowsMapped = /* @__PURE__ */ new Set();
        const allowEstimate = $437b23f6a393c3bf$export$aa3ea9d0da61306f(this.gos, "normal");
        for(let i = 0, len = rowsToDisplay.length; i < len; ++i){
            const rowNode = rowsToDisplay[i];
            if (rowNode.id != null) displayedRowsMapped.add(rowNode.id);
            if (rowNode.rowHeight == null) {
                const rowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(beans, rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
        return displayedRowsMapped;
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.active;
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode && rowNode.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            if (rowNode === null) return;
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            if (rowNode.hasChildren()) {
                if (rowNode.childrenAfterGroup) {
                    const isRootNode = rowNode.level == -1;
                    const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
                    if (!skipChildren) rowNode.childrenAfterGroup.forEach(recurse);
                }
            }
        };
        recurse(this.rootNode);
    }
    clearHighlight() {
        const last = this.lastHighlightedRow;
        if (last) {
            last.highlighted = null;
            last.dispatchRowEvent("rowHighlightChanged");
            this.lastHighlightedRow = null;
        }
    }
    highlightRow(row, highlight) {
        const nodeChanged = row !== this.lastHighlightedRow;
        const highlightChanged = highlight !== row.highlighted;
        if (nodeChanged || highlightChanged) {
            if (nodeChanged) this.clearHighlight();
            row.highlighted = highlight;
            row.dispatchRowEvent("rowHighlightChanged");
            this.lastHighlightedRow = row;
        }
    }
    getLastHighlightedRowNode() {
        return this.lastHighlightedRow;
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        if (this.rowsToDisplay) return this.rowsToDisplay.length;
        return 0;
    }
    /**
   * Returns the number of rows with level === 1
   */ getTopLevelRowCount() {
        const rootNode = this.rootNode;
        if (!rootNode) return 0;
        if (this.rowsToDisplay.length === 0) return 0;
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === rootNode;
        if (showingRootNode) return 1;
        const filteredChildren = rootNode.childrenAfterAggFilter;
        const totalFooterInc = rootNode.sibling ? 1 : 0;
        return (filteredChildren ? filteredChildren.length : 0) + totalFooterInc;
    }
    /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return topLevelIndex;
        const { childrenAfterSort: childrenAfterSort } = rootNode;
        const getDefaultIndex = (adjustedIndex)=>{
            let rowNode = childrenAfterSort[adjustedIndex];
            if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
            return rowNode.rowIndex;
        };
        const { footerSvc: footerSvc } = this.beans;
        if (footerSvc) return footerSvc.getTopDisplayIndex(rowsToDisplay, topLevelIndex, childrenAfterSort, getDefaultIndex);
        else return getDefaultIndex(topLevelIndex);
    }
    /**
   * The opposite of `getTopLevelRowDisplayedIndex`
   */ getTopLevelIndexFromDisplayedIndex(displayedIndex) {
        const { rootNode: rootNode, rowsToDisplay: rowsToDisplay } = this;
        const showingRootNode = !rootNode || !rowsToDisplay.length || rowsToDisplay[0] === rootNode;
        if (showingRootNode) return displayedIndex;
        let node = this.getRow(displayedIndex);
        if (node.footer) node = node.sibling;
        while(node.parent && node.parent !== rootNode)node = node.parent;
        const topLevelIndex = rootNode.childrenAfterSort?.findIndex((childNode)=>childNode === node);
        return topLevelIndex === -1 ? displayedIndex : topLevelIndex ?? displayedIndex;
    }
    getRowBounds(index) {
        const rowNode = this.rowsToDisplay[index];
        if (rowNode) return {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        };
        return null;
    }
    onRowGroupOpened() {
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            animate: animate
        });
    }
    onFilterChanged(event) {
        if (event.afterDataChange) return;
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        const primaryOrQuickFilterChanged = event.columns.length === 0 || event.columns.some((col)=>col.isPrimary());
        const step = primaryOrQuickFilterChanged ? "filter" : "filter_aggregates";
        this.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: animate
        });
    }
    onSortChanged() {
        const animate = $437b23f6a393c3bf$export$27adf74cf591fd1e(this.gos);
        this.refreshModel({
            step: "sort",
            keepRenderedRows: true,
            animate: animate
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        this.refreshModel({
            step: this.colModel.isPivotActive() ? "pivot" : "aggregate"
        });
    }
    createChangePath(enabled) {
        const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.rootNode);
        if (!enabled) changedPath.active = false;
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        const { changedRowNodes: changedRowNodes, newData: newData, rowDataUpdated: rowDataUpdated } = params;
        if (!changedRowNodes || newData || !rowDataUpdated) return false;
        if (changedRowNodes.removals.size || changedRowNodes.adds.size) return false;
        return true;
    }
    refreshModel(params) {
        if (!this.rootNode) return;
        const changedPath = params.changedPath ?? (params.changedPath = this.createChangePath(!params.newData && !!params.rowDataUpdated));
        this.nodeManager.refreshModel?.(params, this.started);
        this.eventSvc.dispatchEvent({
            type: "beforeRefreshModel",
            params: params
        });
        if (!this.started) return;
        if (params.rowDataUpdated) this.eventSvc.dispatchEvent({
            type: "rowDataUpdated"
        });
        if (this.isRefreshingModel || this.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(params)) return;
        this.isRefreshingModel = true;
        switch(params.step){
            case "group":
                this.doRowGrouping(params.changedRowNodes, changedPath, !!params.rowNodesOrderChanged, !!params.afterColumnsChanged);
            case "filter":
                this.doFilter(changedPath);
            case "pivot":
                this.doPivot(changedPath);
            case "aggregate":
                this.doAggregate(changedPath);
            case "filter_aggregates":
                this.doFilterAggregates(changedPath);
            case "sort":
                this.doSort(params.changedRowNodes, changedPath);
            case "map":
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = this.setRowTopAndRowIndex();
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.isRefreshingModel = false;
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        });
    }
    isEmpty() {
        return !this.rootNode?.allLeafChildren?.length || !this.colModel?.ready;
    }
    isRowsToRender() {
        return this.rowsToDisplay.length > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = false;
        let finished = false;
        const result = [];
        const groupsSelectChildren = $437b23f6a393c3bf$export$460e5745f0e6a40d(this.gos);
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (rowNode.group && groupsSelectChildren) {
                        result.push(...rowNode.allLeafChildren);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) {
                result.push(rowNode);
                return;
            }
        });
        return result;
    }
    getTopLevelNodes() {
        return this.rootNode?.childrenAfterGroup ?? null;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        const rowsToDisplay = this.rowsToDisplay;
        if (this.isEmpty() || rowsToDisplay.length === 0) return -1;
        let bottomPointer = 0;
        let topPointer = rowsToDisplay.length - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = $437b23f6a393c3bf$export$236389741107357f(rowsToDisplay);
        if (lastNode.rowTop <= pixelToMatch) return rowsToDisplay.length - 1;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        const pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    }
    forEachLeafNode(callback) {
        this.rootNode?.allLeafChildren?.forEach((rowNode, index)=>callback(rowNode, index));
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes);
    }
    forEachDisplayedNode(callback) {
        this.rowsToDisplay.forEach(callback);
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterAggFilter);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>node.childrenAfterSort);
    }
    forEachPivotNode(callback, includeFooterNodes = false, afterSort = false) {
        const { colModel: colModel, rowGroupColsSvc: rowGroupColsSvc } = this.beans;
        if (!colModel.isPivotMode()) return;
        if (!rowGroupColsSvc?.columns.length) {
            callback(this.rootNode, 0);
            return;
        }
        const childrenField = afterSort ? "childrenAfterSort" : "childrenAfterGroup";
        this.depthFirstSearchRowNodes(callback, includeFooterNodes, (node)=>!node.leafGroup ? node[childrenField] : null);
    }
    /**
   * Iterate through each node and all of its children
   * @param callback the function to execute for each node
   * @param includeFooterNodes whether to also iterate over footer nodes
   * @param nodes the nodes to start iterating over
   * @param getChildren a function to determine the recursion strategy
   * @param startIndex the index to start from
   * @returns the index ended at
   */ depthFirstSearchRowNodes(callback, includeFooterNodes = false, getChildren = (node2)=>node2.childrenAfterGroup, node = this.rootNode, startIndex = 0) {
        let index = startIndex;
        if (!node) return index;
        const isRootNode = node === this.rootNode;
        if (!isRootNode) callback(node, index++);
        const { footerSvc: footerSvc } = this.beans;
        if (node.hasChildren() && !node.footer) {
            const children = getChildren(node);
            if (children) {
                index = footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "top") ?? index;
                for (const node2 of children)index = this.depthFirstSearchRowNodes(callback, includeFooterNodes, getChildren, node2, index);
                return footerSvc?.addTotalRows(index, node, callback, includeFooterNodes, isRootNode, "bottom") ?? index;
            }
        }
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        const rootNode = this.rootNode;
        if (rootNode) this.aggStage?.execute({
            rowNode: rootNode,
            changedPath: changedPath
        });
    }
    doFilterAggregates(changedPath) {
        const rootNode = this.rootNode;
        if (this.filterAggStage) this.filterAggStage.execute({
            rowNode: rootNode,
            changedPath: changedPath
        });
        else rootNode.childrenAfterAggFilter = rootNode.childrenAfterFilter;
    }
    doSort(changedRowNodes, changedPath) {
        if (this.sortStage) this.sortStage.execute({
            rowNode: this.rootNode,
            changedRowNodes: changedRowNodes,
            changedPath: changedPath
        });
        else changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            $437b23f6a393c3bf$var$updateRowNodeAfterSort(rowNode);
        });
    }
    doRowGrouping(changedRowNodes, changedPath, rowNodesOrderChanged, afterColumnsChanged) {
        const rootNode = this.rootNode;
        const groupStageExecuted = this.groupStage?.execute({
            rowNode: rootNode,
            changedPath: changedPath,
            changedRowNodes: changedRowNodes,
            rowNodesOrderChanged: rowNodesOrderChanged,
            afterColumnsChanged: afterColumnsChanged
        });
        if (!groupStageExecuted && !this.nodeManager.treeData) {
            const sibling = rootNode.sibling;
            rootNode.childrenAfterGroup = rootNode.allLeafChildren;
            if (sibling) sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            rootNode.updateHasChildren();
        }
        if (this.rowNodesCountReady) {
            this.rowCountReady = true;
            this.eventSvc.dispatchEventOnce({
                type: "rowCountReady"
            });
        }
    }
    doFilter(changedPath) {
        if (this.filterStage) this.filterStage.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
        else changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            $437b23f6a393c3bf$var$updateRowNodeAfterFilter(rowNode);
        }, true);
    }
    doPivot(changedPath) {
        this.pivotStage?.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    getRowNode(id) {
        const idIsGroup = typeof id == "string" && id.indexOf($437b23f6a393c3bf$export$cb038fdaa8338d9f) == 0;
        if (idIsGroup) {
            let res = void 0;
            this.forEachNode((node)=>{
                if (node.id === id) res = node;
            });
            return res;
        }
        return this.nodeManager.getRowNode(id);
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (this.applyAsyncTransactionsTimeout == null) {
            this.rowDataTransactionBatch = [];
            const waitMillis = this.gos.get("asyncTransactionWaitMillis");
            this.applyAsyncTransactionsTimeout = window.setTimeout(()=>{
                if (this.isAlive()) this.executeBatchUpdateRowData();
            }, waitMillis);
        }
        this.rowDataTransactionBatch.push({
            rowDataTransaction: rowDataTransaction,
            callback: callback
        });
    }
    flushAsyncTransactions() {
        if (this.applyAsyncTransactionsTimeout != null) {
            clearTimeout(this.applyAsyncTransactionsTimeout);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        this.valueCache?.onDataChanged();
        const callbackFuncsBound = [];
        const rowNodeTrans = [];
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        let orderChanged = false;
        this.rowDataTransactionBatch?.forEach((tranItem)=>{
            this.rowNodesCountReady = true;
            const { rowNodeTransaction: rowNodeTransaction, rowsInserted: rowsInserted } = this.nodeManager.updateRowData(tranItem.rowDataTransaction, changedRowNodes);
            if (rowsInserted) orderChanged = true;
            rowNodeTrans.push(rowNodeTransaction);
            if (tranItem.callback) callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTransaction));
        });
        this.commitTransactions(orderChanged, changedRowNodes);
        if (callbackFuncsBound.length > 0) window.setTimeout(()=>{
            callbackFuncsBound.forEach((func)=>func());
        }, 0);
        if (rowNodeTrans.length > 0) this.eventSvc.dispatchEvent({
            type: "asyncTransactionsFlushed",
            results: rowNodeTrans
        });
        this.rowDataTransactionBatch = null;
        this.applyAsyncTransactionsTimeout = void 0;
    }
    /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */ updateRowData(rowDataTran) {
        this.valueCache?.onDataChanged();
        this.rowNodesCountReady = true;
        const changedRowNodes = new $437b23f6a393c3bf$var$ChangedRowNodes();
        const { rowNodeTransaction: rowNodeTransaction, rowsInserted: rowsInserted } = this.nodeManager.updateRowData(rowDataTran, changedRowNodes);
        this.commitTransactions(rowsInserted, changedRowNodes);
        return rowNodeTransaction;
    }
    /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */ commitTransactions(rowNodesOrderChanged, changedRowNodes) {
        this.refreshModel({
            step: "group",
            rowDataUpdated: true,
            rowNodesOrderChanged: rowNodesOrderChanged,
            keepRenderedRows: true,
            animate: !this.gos.get("suppressAnimationFrame"),
            changedRowNodes: changedRowNodes,
            changedPath: this.createChangePath(true)
        });
    }
    doRowsToDisplay() {
        const { flattenStage: flattenStage, rootNode: rootNode } = this;
        let rowsToDisplay;
        if (flattenStage) rowsToDisplay = flattenStage.execute({
            rowNode: rootNode
        });
        else {
            rowsToDisplay = rootNode?.childrenAfterSort ?? [];
            for (const row of rowsToDisplay)row.setUiLevel(0);
        }
        this.rowsToDisplay = rowsToDisplay;
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map",
            keepRenderedRows: true,
            keepUndoRedoStack: true
        });
    }
    resetRowHeights() {
        const rootNode = this.rootNode;
        if (!rootNode) return;
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        rootNode.setRowHeight(rootNode.rowHeight, true);
        if (rootNode.sibling) rootNode.sibling.setRowHeight(rootNode.sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            if (detailNode) detailNode.setRowHeight(detailNode.rowHeight, true);
            if (rowNode.sibling) rowNode.sibling.setRowHeight(rowNode.sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges(e) {
        if (e.rowHeightChanged) {
            if (this.beans.rowAutoHeight?.active) return;
            this.resetRowHeights();
        }
    }
    onGridReady() {
        if (!this.started) this.setInitialData();
    }
    isRowDataLoaded() {
        return this.rowCountReady;
    }
    destroy() {
        super.destroy();
        this.clearHighlight();
        this.started = false;
        this.rootNode = null;
        this.nodeManager = null;
        this.rowDataTransactionBatch = null;
        this.orderedStages = $437b23f6a393c3bf$export$c758d9371030a6ac;
        this.rowsToDisplay = $437b23f6a393c3bf$export$c758d9371030a6ac;
    }
    /**
   * @deprecated v33.1
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
};
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelApi.ts
function $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed(beans) {
    beans.expansionSvc?.onGroupExpandedOrCollapsed();
}
function $437b23f6a393c3bf$var$refreshClientSideRowModel(beans, step) {
    const clientSideRowModel = $437b23f6a393c3bf$export$f5285e6f27a03f95(beans);
    if (clientSideRowModel) {
        if (!step || step === "everything") step = "group";
        clientSideRowModel.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: !beans.gos.get("suppressAnimationFrame")
        });
    }
}
function $437b23f6a393c3bf$var$isRowDataEmpty(beans) {
    return $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.isEmpty() ?? true;
}
function $437b23f6a393c3bf$var$forEachLeafNode(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachLeafNode(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilter(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilter(callback);
}
function $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort(beans, callback) {
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.forEachNodeAfterFilterAndSort(callback);
}
function $437b23f6a393c3bf$var$resetRowHeights(beans) {
    if (beans.rowAutoHeight?.active) {
        $437b23f6a393c3bf$export$545083624300f13d(3);
        return;
    }
    $437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.resetRowHeights();
}
function $437b23f6a393c3bf$var$applyTransaction(beans, rowDataTransaction) {
    return beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.updateRowData(rowDataTransaction));
}
function $437b23f6a393c3bf$var$applyTransactionAsync(beans, rowDataTransaction, callback) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.batchUpdateRowData(rowDataTransaction, callback));
}
function $437b23f6a393c3bf$var$flushAsyncTransactions(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>$437b23f6a393c3bf$export$f5285e6f27a03f95(beans)?.flushAsyncTransactions());
}
function $437b23f6a393c3bf$var$getBestCostNodeSelection(beans) {
    return beans.selectionSvc?.getBestCostNodeSelection();
}
// packages/ag-grid-community/src/clientSideRowModel/clientSideRowModelModule.ts
var $437b23f6a393c3bf$export$4c74201d5a94c8e5 = {
    moduleName: "ClientSideRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "clientSide"
    ],
    beans: [
        $437b23f6a393c3bf$var$ClientSideNodeManager,
        $437b23f6a393c3bf$var$ClientSideRowModel,
        $437b23f6a393c3bf$var$SortStage
    ],
    dependsOn: [
        $437b23f6a393c3bf$export$1a6625c5691649e8
    ]
};
var $437b23f6a393c3bf$export$15323dcce1401b05 = {
    moduleName: "ClientSideRowModelApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        onGroupExpandedOrCollapsed: $437b23f6a393c3bf$var$onGroupExpandedOrCollapsed,
        refreshClientSideRowModel: $437b23f6a393c3bf$var$refreshClientSideRowModel,
        isRowDataEmpty: $437b23f6a393c3bf$var$isRowDataEmpty,
        forEachLeafNode: $437b23f6a393c3bf$var$forEachLeafNode,
        forEachNodeAfterFilter: $437b23f6a393c3bf$var$forEachNodeAfterFilter,
        forEachNodeAfterFilterAndSort: $437b23f6a393c3bf$var$forEachNodeAfterFilterAndSort,
        resetRowHeights: $437b23f6a393c3bf$var$resetRowHeights,
        applyTransaction: $437b23f6a393c3bf$var$applyTransaction,
        applyTransactionAsync: $437b23f6a393c3bf$var$applyTransactionAsync,
        flushAsyncTransactions: $437b23f6a393c3bf$var$flushAsyncTransactions,
        getBestCostNodeSelection: $437b23f6a393c3bf$var$getBestCostNodeSelection
    },
    dependsOn: [
        $437b23f6a393c3bf$export$76fb120d9e251426
    ]
};
// packages/ag-grid-community/src/export/gridSerializer.ts
var $437b23f6a393c3bf$var$GridSerializer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "gridSerializer";
    }
    wireBeans(beans) {
        this.visibleCols = beans.visibleCols;
        this.colModel = beans.colModel;
        this.rowModel = beans.rowModel;
        this.pinnedRowModel = beans.pinnedRowModel;
    }
    serialize(gridSerializingSession, params = {}) {
        const { allColumns: allColumns, columnKeys: columnKeys, skipRowGroups: skipRowGroups, exportRowNumbers: exportRowNumbers } = params;
        const columnsToExport = this.getColumnsToExport({
            allColumns: allColumns,
            skipRowGroups: skipRowGroups,
            columnKeys: columnKeys,
            exportRowNumbers: exportRowNumbers
        });
        return [
            // first pass, put in the header names of the cols
            this.prepareSession(columnsToExport),
            this.prependContent(params),
            this.exportColumnGroups(params, columnsToExport),
            this.exportHeaders(params, columnsToExport),
            this.processPinnedTopRows(params, columnsToExport),
            this.processRows(params, columnsToExport),
            this.processPinnedBottomRows(params, columnsToExport),
            this.appendContent(params)
        ].reduce((composed, f)=>f(composed), gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.colModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && node.childrenAfterGroup?.length === 1 && $437b23f6a393c3bf$export$2f5892ff24cc879d(this.gos, node);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom" || node.stub) return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
            node: node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                node: node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const idCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
                const { colGroupSvc: colGroupSvc } = this.beans;
                const displayedGroups = colGroupSvc ? colGroupSvc.createColumnGroups({
                    columns: columnsToExport,
                    idCreator: idCreator,
                    pinned: null,
                    isStandaloneStructure: true
                }) : columnsToExport;
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("top", processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const usingCsrm = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos, rowModel);
            const usingSsrm = $437b23f6a393c3bf$export$cf1bac0013650216(this.gos, rowModel);
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows: exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) {
                params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
                return gridSerializingSession;
            }
            if (this.colModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true, exportedRows === "filteredAndSorted");
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
                return gridSerializingSession;
            }
            if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.beans.selectionSvc?.getSelectedNodes() ?? [];
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else {
                if (exportedRows === "all") rowModel.forEachNode(processRow);
                else if (usingCsrm || usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            }
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const { sortSvc: sortSvc, rowNodeSorter: rowNodeSorter } = this.beans;
        if (!sortSvc || !rowNodeSorter) return;
        const sortOptions = sortSvc.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (rowA.parent?.id === rowB.parent?.id) return rowNodeSorter.compareRowNodes(sortOptions, {
                    rowNode: rowA,
                    currentPos: rowA.rowIndex ?? -1
                }, {
                    rowNode: rowB,
                    currentPos: rowB.rowIndex ?? -1
                });
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel?.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else if (!this.pinnedRowModel?.isManual()) this.pinnedRowModel?.forEachPinnedRow("bottom", processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(params) {
        const { allColumns: allColumns = false, skipRowGroups: skipRowGroups = false, exportRowNumbers: exportRowNumbers = false, columnKeys: columnKeys } = params;
        const { colModel: colModel, gos: gos, visibleCols: visibleCols } = this;
        const isPivotMode = colModel.isPivotMode();
        const filterSpecialColumns = (col)=>{
            if ($437b23f6a393c3bf$export$f6074a9792015c5d(col)) return false;
            return !$437b23f6a393c3bf$export$3d3e7d751f0445eb(col) || exportRowNumbers;
        };
        if (columnKeys && columnKeys.length) return colModel.getColsForKeys(columnKeys).filter(filterSpecialColumns);
        const isTreeData = gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = colModel.getCols();
        else columnsToExport = visibleCols.allCols;
        columnsToExport = columnsToExport.filter((column)=>filterSpecialColumns(column) && (skipRowGroups && !isTreeData ? !$437b23f6a393c3bf$export$61b34611dc010a97(column) : true));
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) return;
            columnGroup.getChildren().forEach((it)=>directChildrenHeaderGroups.push(it));
        });
        if (displayedGroups.length > 0 && $437b23f6a393c3bf$export$1f44a60fc23f9028(displayedGroups[0])) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                columnGroup: columnGroup
            }));
            else name = this.beans.colNames.getDisplayNameForColumnGroup(columnGroup, "header");
            const collapsibleGroupRanges = columnGroup.getLeafColumns().reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = $437b23f6a393c3bf$export$236389741107357f(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        });
    }
};
// packages/ag-grid-community/src/export/exportModule.ts
var $437b23f6a393c3bf$export$e6030935e93fda2b = {
    moduleName: "SharedExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$GridSerializer
    ]
};
// packages/ag-grid-community/src/csvExport/csvSerializingSession.ts
var $437b23f6a393c3bf$var$LINE_SEPARATOR = "\r\n";
var $437b23f6a393c3bf$var$CsvSerializingSession = class extends $437b23f6a393c3bf$export$5018ab277b833b61 {
    constructor(config){
        super(config);
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, $437b23f6a393c3bf$var$LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue(column, index, index, "csv", node);
        this.result += this.putInQuotes(rowCellValue.valueFormatted ?? rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            $437b23f6a393c3bf$export$545083624300f13d(53);
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += $437b23f6a393c3bf$var$LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
// packages/ag-grid-community/src/csvExport/csvCreator.ts
var $437b23f6a393c3bf$var$CsvCreator = class extends $437b23f6a393c3bf$export$b335f23c5aead909 {
    constructor(){
        super(...arguments);
        this.beanName = "csvCreator";
    }
    wireBeans(beans) {
        this.colModel = beans.colModel;
        this.colNames = beans.colNames;
        this.rowGroupColsSvc = beans.rowGroupColsSvc;
        this.valueSvc = beans.valueSvc;
    }
    getMergedParams(params) {
        const baseParams4 = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams4, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            $437b23f6a393c3bf$export$545083624300f13d(51);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const packagedFile = new Blob([
            "\uFEFF",
            data
        ], {
            type: "text/plain"
        });
        const fileName = typeof mergedParams.fileName === "function" ? mergedParams.fileName($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {})) : mergedParams.fileName;
        $437b23f6a393c3bf$export$97aef6bcdc3f7ef5(this.getFileName(fileName), packagedFile);
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { colModel: colModel, colNames: colNames, rowGroupColsSvc: rowGroupColsSvc, valueSvc: valueSvc, gos: gos } = this;
        const { processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback, suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = params;
        return new $437b23f6a393c3bf$var$CsvSerializingSession({
            colModel: colModel,
            colNames: colNames,
            valueSvc: valueSvc,
            gos: gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ",",
            rowGroupColsSvc: rowGroupColsSvc
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
// packages/ag-grid-community/src/csvExport/csvExportApi.ts
function $437b23f6a393c3bf$var$getDataAsCsv(beans, params) {
    return beans.csvCreator?.getDataAsCsv(params);
}
function $437b23f6a393c3bf$var$exportDataAsCsv(beans, params) {
    beans.csvCreator?.exportDataAsCsv(params);
}
// packages/ag-grid-community/src/csvExport/csvExportModule.ts
var $437b23f6a393c3bf$export$f744275d8b795fc2 = {
    moduleName: "CsvExport",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CsvCreator
    ],
    apiFunctions: {
        getDataAsCsv: $437b23f6a393c3bf$var$getDataAsCsv,
        exportDataAsCsv: $437b23f6a393c3bf$var$exportDataAsCsv
    },
    dependsOn: [
        $437b23f6a393c3bf$export$e6030935e93fda2b
    ]
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteBlock.ts
var $437b23f6a393c3bf$var$InfiniteBlock = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(id, parentCache, params){
        super();
        this.id = id;
        this.parentCache = parentCache;
        this.params = params;
        this.state = "needsLoading";
        this.version = 0;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    load() {
        this.state = "loading";
        this.loadFromDatasource();
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = "needsLoading";
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) this.state = "failed";
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLocalEvent({
            type: "loadComplete"
        });
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = "loaded";
            this.processServerResult(params);
        }
    }
    postConstruct() {
        this.rowNodes = [];
        const { params: { blockSize: blockSize, rowHeight: rowHeight }, startRow: startRow, beans: beans, rowNodes: rowNodes } = this;
        for(let i = 0; i < blockSize; i++){
            const rowIndex = startRow + i;
            const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
            rowNode.setRowHeight(rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(rowHeight * rowIndex);
            rowNodes.push(rowNode);
        }
    }
    getBlockStateJson() {
        const { id: id, startRow: startRow, endRow: endRow, state: pageStatus } = this;
        return {
            id: "" + id,
            state: {
                blockNumber: id,
                startRow: startRow,
                endRow: endRow,
                pageStatus: pageStatus
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(this.params.datasource.getRows)) {
            $437b23f6a393c3bf$export$545083624300f13d(90);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    createLoadParams() {
        const { startRow: startRow, endRow: endRow, version: version, params: { sortModel: sortModel, filterModel: filterModel }, gos: gos } = this;
        const params = {
            startRow: startRow,
            endRow: endRow,
            successCallback: this.pageLoaded.bind(this, version),
            failCallback: this.pageLoadFailed.bind(this, version),
            sortModel: sortModel,
            filterModel: filterModel,
            context: $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {}).context
        };
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.value++);
        });
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.value++;
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    processServerResult(params) {
        const { rowNodes: rowNodes, beans: beans } = this;
        rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                rowNodes[index] = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(beans);
                rowNodes[index].setRowIndex(rowNode.rowIndex);
                rowNodes[index].setRowTop(rowNode.rowTop);
                rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode.clearRowTopAndRowIndex();
            }
            this.setDataAndId(rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroy() {
        this.rowNodes.forEach((rowNode)=>{
            rowNode.clearRowTopAndRowIndex();
        });
        super.destroy();
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteCache.ts
var $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP = 2;
var $437b23f6a393c3bf$var$InfiniteCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const params = this.params;
        const newBlock = this.createBean(new $437b23f6a393c3bf$var$InfiniteBlock(blockNumber, this, params));
        this.blocks[newBlock.id] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        this.getBlocksInOrder().forEach((block)=>block.setStateWaitingToLoad());
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroy() {
        this.getBlocksInOrder().forEach((block)=>this.destroyBlock(block));
        super.destroy();
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `InfiniteCache - onPageLoaded: page = ${block.id}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.lastAccessed - a.lastAccessed;
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = $437b23f6a393c3bf$var$MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.state === "needsLoading" && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const { startRow: startRow, endRow: endRow } = block;
        const hasFocus = focusedCell.rowIndex >= startRow && focusedCell.rowIndex < endRow;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const { startRow: startRow, endRow: endRow } = block;
        return this.beans.rowRenderer.isRangeInRenderedViewport(startRow, endRow - 1);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const { blockSize: blockSize, overflowSize: overflowSize } = this.params;
            const lastRowIndex = (block.id + 1) * blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = {
            value: 0
        };
        this.getBlocksInOrder().forEach((block)=>block.forEachNode(callback, sequence, this.rowCount));
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.id - b.id;
        const blocks = Object.values(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.id];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            this.eventSvc.dispatchEvent({
                type: "storeUpdated"
            });
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        this.getBlocksInOrder().forEach((block)=>{
            const startRow = block.id * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        });
        if (blocksToDestroy.length > 0) blocksToDestroy.forEach((block)=>this.destroyBlock(block));
    }
    purgeCache() {
        this.getBlocksInOrder().forEach((block)=>this.removeBlockFromCache(block));
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = {
            value: 0
        };
        let foundGapInSelection = false;
        this.getBlocksInOrder().forEach((block)=>{
            if (foundGapInSelection) return;
            if (inActiveRange && lastBlockId + 1 !== block.id) {
                foundGapInSelection = true;
                return;
            }
            lastBlockId = block.id;
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        });
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModel.ts
var $437b23f6a393c3bf$var$InfiniteRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowModel";
    }
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    postConstruct() {
        if (this.gos.get("rowModelType") !== "infinite") return;
        this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroy() {
        this.destroyDatasource();
        super.destroy();
    }
    destroyDatasource() {
        if (this.datasource) {
            this.destroyBean(this.datasource);
            this.beans.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedEventListeners({
            filterChanged: this.reset.bind(this),
            sortChanged: this.reset.bind(this),
            newColumnsLoaded: this.onColumnEverything.bind(this),
            storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
        });
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = $437b23f6a393c3bf$export$8966875adec41e5b(this.beans);
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = !$437b23f6a393c3bf$export$dbc2068cc90f5875(this.cacheParams.sortModel, this.beans.sortSvc?.getSortModel() ?? []);
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache?.getRowNodesInRange(firstInRange, lastInRange) ?? [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = $437b23f6a393c3bf$export$57c3bb2f89b59a89(this.gos);
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.beans.selectionSvc?.reset("rowDataChanged");
        this.resetCache();
    }
    dispatchModelUpdatedEvent() {
        this.eventSvc.dispatchEvent({
            type: "modelUpdated",
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        });
    }
    resetCache() {
        this.destroyCache();
        const beans = this.beans;
        const { filterManager: filterManager, sortSvc: sortSvc, rowNodeBlockLoader: rowNodeBlockLoader, eventSvc: eventSvc, gos: gos } = beans;
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: filterManager?.getFilterModel() ?? {},
            sortModel: sortSvc?.getSortModel() ?? [],
            rowNodeBlockLoader: rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: gos.get("maxBlocksInCache"),
            rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: {
                value: 0
            }
        };
        this.infiniteCache = this.createBean(new $437b23f6a393c3bf$var$InfiniteCache(this.cacheParams));
        eventSvc.dispatchEventOnce({
            type: "rowCountReady"
        });
        this.dispatchModelUpdatedEvent();
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        this.dispatchModelUpdatedEvent();
    }
    destroyCache() {
        this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    getRow(rowIndex) {
        const infiniteCache = this.infiniteCache;
        if (!infiniteCache) return void 0;
        if (rowIndex >= infiniteCache.getRowCount()) return void 0;
        return infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        this.infiniteCache?.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        return !!this.getRowNode(rowNode.id);
    }
    refreshCache() {
        this.infiniteCache?.refreshCache();
    }
    purgeCache() {
        this.infiniteCache?.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        return this.infiniteCache?.isLastRowIndexKnown() ?? false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.infiniteCache?.setRowCount(rowCount, lastRowIndexKnown);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelApi.ts
function $437b23f6a393c3bf$var$refreshInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.refreshCache();
}
function $437b23f6a393c3bf$var$purgeInfiniteCache(beans) {
    $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.purgeCache();
}
function $437b23f6a393c3bf$var$getInfiniteRowCount(beans) {
    return $437b23f6a393c3bf$var$_getInfiniteRowModel(beans)?.getRowCount();
}
// packages/ag-grid-community/src/infiniteRowModel/rowNodeBlockLoader.ts
var $437b23f6a393c3bf$var$RowNodeBlockLoader = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowNodeBlockLoader";
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = $437b23f6a393c3bf$export$efae4c751fa7cc4d(this.gos);
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener("loadComplete", this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        $437b23f6a393c3bf$export$83a881c8b5120679(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1;
        const blocksToLoad = this.blocks.filter((block)=>block.state === "needsLoading").slice(0, loadAvailability);
        this.activeBlockLoadsCount += blocksToLoad.length;
        blocksToLoad.forEach((block)=>block.load());
        this.printCacheStatus();
    }
    getBlockState() {
        const result = {};
        this.blocks.forEach((block)=>{
            const { id: id, state: state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        $437b23f6a393c3bf$var$_logIfDebug(this.gos, `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
};
// packages/ag-grid-community/src/infiniteRowModel/infiniteRowModelModule.ts
var $437b23f6a393c3bf$var$InfiniteRowModelCoreModule = {
    moduleName: "InfiniteRowModelCore",
    version: $437b23f6a393c3bf$var$VERSION,
    rowModels: [
        "infinite"
    ],
    beans: [
        $437b23f6a393c3bf$var$InfiniteRowModel,
        $437b23f6a393c3bf$var$RowNodeBlockLoader
    ]
};
var $437b23f6a393c3bf$export$ca8341149bdd39bc = {
    moduleName: "InfiniteRowModel",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        refreshInfiniteCache: $437b23f6a393c3bf$var$refreshInfiniteCache,
        purgeInfiniteCache: $437b23f6a393c3bf$var$purgeInfiniteCache,
        getInfiniteRowCount: $437b23f6a393c3bf$var$getInfiniteRowCount
    },
    dependsOn: [
        $437b23f6a393c3bf$var$InfiniteRowModelCoreModule,
        $437b23f6a393c3bf$export$2f6740e35dedc261
    ]
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var $437b23f6a393c3bf$var$ARROW_UP = "\u2191";
var $437b23f6a393c3bf$var$ARROW_DOWN = "\u2193";
var $437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eDelta",
            cls: "ag-value-change-delta"
        },
        {
            tag: "span",
            ref: "eValue",
            cls: "ag-value-change-value"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateShowChangeCellRendererElement);
        this.eValue = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.eDelta = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
    }
    init(params) {
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = $437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        const eDelta = this.eDelta;
        if (deltaUp) eDelta.textContent = $437b23f6a393c3bf$var$ARROW_UP + valueToUse;
        else eDelta.textContent = $437b23f6a393c3bf$var$ARROW_DOWN + valueToUse;
        eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const { value: value, valueFormatted: valueFormatted } = params;
        const { eValue: eValue, lastValue: lastValue, beans: beans } = this;
        if (value === lastValue) return false;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(valueFormatted)) eValue.textContent = valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(value)) eValue.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eValue);
        if (beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (typeof value === "number" && typeof lastValue === "number") {
            const delta = value - lastValue;
            this.showDelta(params, delta);
        }
        if (lastValue) eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.css-GENERATED.ts
var $437b23f6a393c3bf$var$animateSlideCellRendererCSS = /*css*/ `.ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}`;
// packages/ag-grid-community/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var $437b23f6a393c3bf$var$AnimateSlideCellRendererElement = {
    tag: "span",
    children: [
        {
            tag: "span",
            ref: "eCurrent",
            cls: "ag-value-slide-current"
        }
    ]
};
var $437b23f6a393c3bf$var$AnimateSlideCellRenderer = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$AnimateSlideCellRendererElement);
        this.eCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.refreshCount = 0;
        this.registerCSS($437b23f6a393c3bf$var$animateSlideCellRendererCSS);
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        if (this.ePrevious) this.getGui().removeChild(this.ePrevious);
        const { beans: beans, eCurrent: eCurrent } = this;
        const prevElement = $437b23f6a393c3bf$export$a232bb0480ae674a({
            tag: "span",
            cls: "ag-value-slide-previous ag-value-slide-out"
        });
        this.ePrevious = prevElement;
        prevElement.textContent = eCurrent.textContent;
        this.getGui().insertBefore(prevElement, eCurrent);
        beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.getGui().removeChild(this.ePrevious);
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if ($437b23f6a393c3bf$export$672d9e47bc342bac(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.beans.filterManager?.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        const eCurrent = this.eCurrent;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.valueFormatted)) eCurrent.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$export$25d27f17d3af40f7(params.value)) eCurrent.textContent = value;
        else $437b23f6a393c3bf$export$69e6e10709eabd91(eCurrent);
        return true;
    }
};
// packages/ag-grid-community/src/rendering/cell/cellFlashService.ts
var $437b23f6a393c3bf$var$CellFlashService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellFlashSvc";
        this.nextAnimationTime = null;
        this.nextAnimationCycle = null;
        this.animations = {
            highlight: /* @__PURE__ */ new Map(),
            "data-changed": /* @__PURE__ */ new Map()
        };
    }
    animateCell(cellCtrl, cssName, flashDuration = this.beans.gos.get("cellFlashDuration"), fadeDuration = this.beans.gos.get("cellFadeDuration")) {
        const animations = this.animations[cssName];
        animations.delete(cellCtrl);
        const time = Date.now();
        const flashEndTime = time + flashDuration;
        const fadeEndTime = time + flashDuration + fadeDuration;
        const animState = {
            phase: "flash",
            flashEndTime: flashEndTime,
            fadeEndTime: fadeEndTime
        };
        animations.set(cellCtrl, animState);
        const cssBase = `ag-cell-${cssName}`;
        const cssAnimation = `${cssBase}-animation`;
        const { comp: comp, eGui: { style: style } } = cellCtrl;
        comp.toggleCss(cssBase, true);
        comp.toggleCss(cssAnimation, false);
        style.removeProperty("transition");
        style.removeProperty("transition-delay");
        if (this.nextAnimationTime && flashEndTime + 15 < this.nextAnimationTime) {
            clearTimeout(this.nextAnimationCycle);
            this.nextAnimationCycle = null;
            this.nextAnimationTime = null;
        }
        if (!this.nextAnimationCycle) {
            this.beans.frameworkOverrides.wrapIncoming(()=>{
                this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), flashDuration);
            });
            this.nextAnimationTime = flashEndTime;
        }
    }
    advanceAnimations() {
        const time = Date.now();
        let nextAnimationTime = null;
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            const cssBase = `ag-cell-${cssName}`;
            const cssAnimation = `${cssBase}-animation`;
            for (const [cell, animState] of animations){
                if (!cell.isAlive() || !cell.comp) {
                    animations.delete(cell);
                    continue;
                }
                const { phase: phase, flashEndTime: flashEndTime, fadeEndTime: fadeEndTime } = animState;
                const nextActionableTime = phase === "flash" ? flashEndTime : fadeEndTime;
                const requiresAction = time + 15 >= nextActionableTime;
                if (!requiresAction) {
                    nextAnimationTime = Math.min(nextActionableTime, nextAnimationTime ?? Infinity);
                    continue;
                }
                const { comp: comp, eGui: { style: style } } = cell;
                switch(phase){
                    case "flash":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, true);
                        style.transition = `background-color ${fadeEndTime - flashEndTime}ms`;
                        style.transitionDelay = `${flashEndTime - time}ms`;
                        nextAnimationTime = Math.min(fadeEndTime, nextAnimationTime ?? Infinity);
                        animState.phase = "fade";
                        break;
                    case "fade":
                        comp.toggleCss(cssBase, false);
                        comp.toggleCss(cssAnimation, false);
                        style.removeProperty("transition");
                        style.removeProperty("transition-delay");
                        animations.delete(cell);
                        break;
                }
            }
        }
        if (nextAnimationTime == null) {
            this.nextAnimationTime = null;
            this.nextAnimationCycle = null;
        } else if (nextAnimationTime) {
            this.nextAnimationCycle = setTimeout(this.advanceAnimations.bind(this), nextAnimationTime - time);
            this.nextAnimationTime = nextAnimationTime;
        }
    }
    onFlashCells(cellCtrl, event) {
        if (!cellCtrl.comp) return;
        const cellId = $437b23f6a393c3bf$export$c0c5a5ba9327269f(cellCtrl.cellPosition);
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell(cellCtrl, "highlight");
    }
    flashCell(cellCtrl, delays) {
        this.animateCell(cellCtrl, "data-changed", delays?.flashDuration, delays?.fadeDuration);
    }
    destroy() {
        for (const cssName of Object.keys(this.animations)){
            const animations = this.animations[cssName];
            animations.clear();
        }
    }
};
// packages/ag-grid-community/src/rendering/cell/highlightChangesApi.ts
function $437b23f6a393c3bf$var$flashCells(beans, params = {}) {
    const { cellFlashSvc: cellFlashSvc } = beans;
    if (!cellFlashSvc) return;
    beans.frameworkOverrides.wrapIncoming(()=>{
        beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellFlashSvc.flashCell(cellCtrl, params));
    });
}
// packages/ag-grid-community/src/rendering/cell/highlightChangesModule.ts
var $437b23f6a393c3bf$export$98e8472b11750a07 = {
    moduleName: "HighlightChanges",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellFlashService
    ],
    userComponents: {
        agAnimateShowChangeCellRenderer: $437b23f6a393c3bf$var$AnimateShowChangeCellRenderer,
        agAnimateSlideCellRenderer: $437b23f6a393c3bf$var$AnimateSlideCellRenderer
    },
    apiFunctions: {
        flashCells: $437b23f6a393c3bf$var$flashCells
    }
};
// packages/ag-grid-community/src/misc/state/stateApi.ts
function $437b23f6a393c3bf$var$getState(beans) {
    return beans.stateSvc?.getState() ?? {};
}
// packages/ag-grid-community/src/misc/state/stateModelMigration.ts
function $437b23f6a393c3bf$var$migrateGridStateModel(state) {
    state = {
        ...state
    };
    if (!state.version) state.version = "32.1.0";
    switch(state.version){
        case "32.1.0":
            state = $437b23f6a393c3bf$var$migrateV32_1(state);
    }
    return state;
}
function $437b23f6a393c3bf$var$migrateV32_1(state) {
    state.cellSelection = $437b23f6a393c3bf$var$jsonGet(state, "rangeSelection");
    return state;
}
function $437b23f6a393c3bf$var$jsonGet(json, key) {
    if (json && typeof json === "object") return json[key];
}
// packages/ag-grid-community/src/misc/state/stateService.ts
var $437b23f6a393c3bf$var$StateService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "stateSvc";
        this.updateRowGroupExpansionStateTimer = 0;
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        }, 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, ()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        this.isClientSideRowModel = $437b23f6a393c3bf$export$9f182d9ca737e15(this.gos);
        this.cachedState = this.getInitialState();
        this.setCachedStateValue("version", $437b23f6a393c3bf$var$VERSION);
        const suppressEventsAndDispatchInitEvent = this.suppressEventsAndDispatchInitEvent.bind(this);
        this.beans.ctrlsSvc.whenReady(this, ()=>suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady()));
        const [newColumnsLoadedDestroyFunc, rowCountReadyDestroyFunc, firstDataRenderedDestroyFunc] = this.addManagedEventListeners({
            newColumnsLoaded: ({ source: source })=>{
                if (source === "gridInitializing") {
                    newColumnsLoadedDestroyFunc();
                    suppressEventsAndDispatchInitEvent(()=>this.setupStateOnColumnsInitialised());
                }
            },
            rowCountReady: ()=>{
                rowCountReadyDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady());
            },
            firstDataRendered: ()=>{
                firstDataRenderedDestroyFunc?.();
                suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered());
            }
        });
    }
    destroy() {
        super.destroy();
        clearTimeout(this.updateRowGroupExpansionStateTimer);
        this.queuedUpdateSources.clear();
    }
    getInitialState() {
        return $437b23f6a393c3bf$var$migrateGridStateModel(this.gos.get("initialState") ?? {});
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setupStateOnGridReady() {
        const stateUpdater = ()=>this.updateCachedState("sideBar", this.getSideBarState());
        stateUpdater();
        this.addManagedEventListeners({
            toolPanelVisibleChanged: stateUpdater,
            sideBarUpdated: stateUpdater
        });
    }
    setupStateOnColumnsInitialised() {
        const initialState = this.getInitialState();
        this.setColumnState(initialState);
        this.setColumnGroupState(initialState);
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
        const onUpdate = (state)=>()=>this.updateColumnState([
                    state
                ]);
        this.addManagedEventListeners({
            columnValueChanged: onUpdate("aggregation"),
            columnMoved: onUpdate("columnOrder"),
            columnPinned: onUpdate("columnPinning"),
            columnResized: onUpdate("columnSizing"),
            columnVisible: onUpdate("columnVisibility"),
            columnPivotChanged: onUpdate("pivot"),
            columnPivotModeChanged: onUpdate("pivot"),
            columnRowGroupChanged: onUpdate("rowGroup"),
            sortChanged: onUpdate("sort"),
            newColumnsLoaded: ()=>this.updateColumnState([
                    "aggregation",
                    "columnOrder",
                    "columnPinning",
                    "columnSizing",
                    "columnVisibility",
                    "pivot",
                    "rowGroup",
                    "sort"
                ]),
            columnGroupOpened: ()=>this.updateCachedState("columnGroup", this.getColumnGroupState())
        });
    }
    setupStateOnRowCountReady() {
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, rowSelection: rowSelectionState, pagination: paginationState } = this.getInitialState();
        if (filterState) this.setFilterState(filterState);
        if (rowGroupExpansionState) this.setRowGroupExpansionState(rowGroupExpansionState);
        if (rowSelectionState) this.setRowSelectionState(rowSelectionState);
        if (paginationState) this.setPaginationState(paginationState);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("filter", this.getFilterState());
        updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        updateCachedState("rowSelection", this.getRowSelectionState());
        updateCachedState("pagination", this.getPaginationState());
        const updateRowGroupExpansionState = ()=>{
            this.updateRowGroupExpansionStateTimer = 0;
            updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        };
        this.addManagedEventListeners({
            filterChanged: ()=>updateCachedState("filter", this.getFilterState()),
            rowGroupOpened: ()=>this.onRowGroupOpenedDebounced(),
            expandOrCollapseAll: updateRowGroupExpansionState,
            // `groupDefaultExpanded` updates expansion state without an expansion event
            columnRowGroupChanged: updateRowGroupExpansionState,
            rowDataUpdated: ()=>{
                if (this.gos.get("groupDefaultExpanded") !== 0) this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(updateRowGroupExpansionState));
            },
            selectionChanged: ()=>{
                this.staleStateKeys.add("rowSelection");
                this.onRowSelectedDebounced();
            },
            paginationChanged: (event)=>{
                if (event.newPage || event.newPageSize) updateCachedState("pagination", this.getPaginationState());
            }
        });
    }
    setupStateOnFirstDataRendered() {
        const { scroll: scrollState, cellSelection: cellSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState, rowPinning: rowPinning } = this.getInitialState();
        if (focusedCellState) this.setFocusedCellState(focusedCellState);
        if (cellSelectionState) this.setCellSelectionState(cellSelectionState);
        if (scrollState) this.setScrollState(scrollState);
        if (rowPinning) this.setRowPinningState(rowPinning);
        this.setColumnPivotState(!!columnOrderState?.orderedColIds);
        const updateCachedState = this.updateCachedState.bind(this);
        updateCachedState("sideBar", this.getSideBarState());
        updateCachedState("focusedCell", this.getFocusedCellState());
        const cellSelection = this.getRangeSelectionState();
        updateCachedState("rangeSelection", cellSelection);
        updateCachedState("cellSelection", cellSelection);
        updateCachedState("scroll", this.getScrollState());
        this.addManagedEventListeners({
            cellFocused: ()=>updateCachedState("focusedCell", this.getFocusedCellState()),
            cellSelectionChanged: (event)=>{
                if (event.finished) {
                    const cellSelection2 = this.getRangeSelectionState();
                    updateCachedState("rangeSelection", cellSelection2);
                    updateCachedState("cellSelection", cellSelection2);
                }
            },
            bodyScrollEnd: ()=>updateCachedState("scroll", this.getScrollState()),
            pinnedRowsChanged: ()=>updateCachedState("rowPinning", this.getRowPinningState())
        });
    }
    getColumnState() {
        const beans = this.beans;
        return $437b23f6a393c3bf$export$9453e80be74134db($437b23f6a393c3bf$export$e7d9af1fb362df7b(beans), beans.colModel.isPivotMode());
    }
    setColumnState(initialState) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState, partialColumnState: partialColumnState } = initialState;
        const columnStateMap = {};
        const getColumnState2 = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId: colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        const defaultState = partialColumnState ? {} : {
            sort: null,
            sortIndex: null,
            rowGroup: null,
            rowGroupIndex: null,
            aggFunc: null,
            pivot: null,
            pivotIndex: null,
            pinned: null,
            hide: null,
            flex: null
        };
        if (sortState) {
            sortState.sortModel.forEach(({ colId: colId, sort: sort }, sortIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.sort = sort;
                columnState.sortIndex = sortIndex;
            });
            defaultState.sort = null;
            defaultState.sortIndex = null;
        }
        if (groupState) {
            groupState.groupColIds.forEach((colId, rowGroupIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.rowGroup = true;
                columnState.rowGroupIndex = rowGroupIndex;
            });
            defaultState.rowGroup = null;
            defaultState.rowGroupIndex = null;
        }
        if (aggregationState) {
            aggregationState.aggregationModel.forEach(({ colId: colId, aggFunc: aggFunc })=>{
                getColumnState2(colId).aggFunc = aggFunc;
            });
            defaultState.aggFunc = null;
        }
        if (pivotState) {
            pivotState.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState2(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: pivotState.pivotMode
                },
                source: "gridInitializing"
            });
            defaultState.pivot = null;
            defaultState.pivotIndex = null;
        }
        if (columnPinningState) {
            columnPinningState.leftColIds.forEach((colId)=>{
                getColumnState2(colId).pinned = "left";
            });
            columnPinningState.rightColIds.forEach((colId)=>{
                getColumnState2(colId).pinned = "right";
            });
            defaultState.pinned = null;
        }
        if (columnVisibilityState) {
            columnVisibilityState.hiddenColIds.forEach((colId)=>{
                getColumnState2(colId).hide = true;
            });
            defaultState.hide = null;
        }
        if (columnSizingState) {
            columnSizingState.columnSizingModel.forEach(({ colId: colId, flex: flex, width: width })=>{
                const columnState = getColumnState2(colId);
                columnState.flex = flex ?? null;
                columnState.width = width;
            });
            defaultState.flex = null;
        }
        const columns = columnOrderState?.orderedColIds;
        const applyOrder = !!columns?.length;
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState2(colId)) : Object.values(columnStateMap);
        if (columnStates.length) {
            this.columnStates = columnStates;
            $437b23f6a393c3bf$export$b2854c1cb8f10386(this.beans, {
                state: columnStates,
                applyOrder: applyOrder,
                defaultState: defaultState
            }, "gridInitializing");
        }
    }
    setColumnPivotState(applyOrder) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        const beans = this.beans;
        const { pivotResultCols: pivotResultCols, colGroupSvc: colGroupSvc } = beans;
        if (!pivotResultCols?.isPivotResultColsPresent()) return;
        if (columnStates) {
            const secondaryColumnStates = [];
            for (const columnState of columnStates)if (pivotResultCols.getPivotResultCol(columnState.colId)) secondaryColumnStates.push(columnState);
            $437b23f6a393c3bf$export$b2854c1cb8f10386(beans, {
                state: secondaryColumnStates,
                applyOrder: applyOrder
            }, "gridInitializing");
        }
        if (columnGroupStates) colGroupSvc?.setColumnGroupState(columnGroupStates, "gridInitializing");
    }
    getColumnGroupState() {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!colGroupSvc) return void 0;
        const columnGroupState = colGroupSvc.getColumnGroupState();
        return $437b23f6a393c3bf$var$_convertColumnGroupState(columnGroupState);
    }
    setColumnGroupState(initialState) {
        const colGroupSvc = this.beans.colGroupSvc;
        if (!Object.prototype.hasOwnProperty.call(initialState, "columnGroup") || !colGroupSvc) return;
        const openColumnGroups = new Set(initialState.columnGroup?.openColumnGroupIds);
        const existingColumnGroupState = colGroupSvc.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId: groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId: groupId,
                open: open
            };
        });
        openColumnGroups.forEach((groupId)=>{
            stateItems.push({
                groupId: groupId,
                open: true
            });
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        colGroupSvc.setColumnGroupState(stateItems, "gridInitializing");
    }
    getFilterState() {
        const filterManager = this.beans.filterManager;
        let filterModel = filterManager?.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const advancedFilterModel = filterManager?.getAdvFilterModel() ?? void 0;
        return filterModel || advancedFilterModel ? {
            filterModel: filterModel,
            advancedFilterModel: advancedFilterModel
        } : void 0;
    }
    setFilterState(filterState) {
        const filterManager = this.beans.filterManager;
        const { filterModel: filterModel, advancedFilterModel: advancedFilterModel } = filterState ?? {};
        if (filterModel) filterManager?.setFilterModel(filterModel, "columnFilter");
        if (advancedFilterModel) filterManager?.setAdvFilterModel(advancedFilterModel, "advancedFilter");
    }
    getRangeSelectionState() {
        const cellRanges = this.beans.rangeSvc?.getCellRanges().map((cellRange)=>{
            const { id: id, type: type, startRow: startRow, endRow: endRow, columns: columns, startColumn: startColumn } = cellRange;
            return {
                id: id,
                type: type,
                startRow: startRow,
                endRow: endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return cellRanges?.length ? {
            cellRanges: cellRanges
        } : void 0;
    }
    setCellSelectionState(cellSelectionState) {
        const { gos: gos, rangeSvc: rangeSvc, colModel: colModel, visibleCols: visibleCols } = this.beans;
        if (!$437b23f6a393c3bf$export$1f7ca6920544d9e4(gos) || !rangeSvc) return;
        const cellRanges = [];
        cellSelectionState.cellRanges.forEach((cellRange)=>{
            const columns = [];
            cellRange.colIds.forEach((colId)=>{
                const column = colModel.getCol(colId);
                if (column) columns.push(column);
            });
            if (!columns.length) return;
            let startColumn = colModel.getCol(cellRange.startColId);
            if (!startColumn) {
                const allColumns = visibleCols.allCols;
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push({
                ...cellRange,
                columns: columns,
                startColumn: startColumn
            });
        });
        rangeSvc.setCellRanges(cellRanges);
    }
    getScrollState() {
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = this.beans.ctrlsSvc.getScrollFeature();
        const { left: left } = scrollFeature?.getHScrollPosition() ?? {
            left: 0
        };
        const { top: top } = scrollFeature?.getVScrollPosition() ?? {
            top: 0
        };
        return top || left ? {
            top: top,
            left: left
        } : void 0;
    }
    setScrollState(scrollState) {
        if (!this.isClientSideRowModel) return;
        const { top: top, left: left } = scrollState;
        const { frameworkOverrides: frameworkOverrides, rowRenderer: rowRenderer, animationFrameSvc: animationFrameSvc, ctrlsSvc: ctrlsSvc } = this.beans;
        frameworkOverrides.wrapIncoming(()=>{
            ctrlsSvc.get("center").setCenterViewportScrollLeft(left);
            ctrlsSvc.getScrollFeature()?.setVerticalScrollPosition(top);
            rowRenderer.redraw({
                afterScroll: true
            });
            animationFrameSvc?.flushAllFrames();
        });
    }
    getSideBarState() {
        return this.beans.sideBar?.comp?.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        if (focusedCell) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { colId: colId, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellState;
        const { focusSvc: focusSvc, colModel: colModel } = this.beans;
        focusSvc.setFocusedCell({
            column: colModel.getCol(colId),
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return void 0;
        const page = pagination.getCurrentPage();
        const pageSize = !gos.get("paginationAutoPageSize") ? pagination.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page: page,
            pageSize: pageSize
        };
    }
    setPaginationState(paginationState) {
        const { pagination: pagination, gos: gos } = this.beans;
        if (!pagination) return;
        if (paginationState.pageSize && !gos.get("paginationAutoPageSize")) pagination.setPageSize(paginationState.pageSize, "initialState");
        if (typeof paginationState.page === "number") pagination.setPage(paginationState.page);
    }
    getRowSelectionState() {
        const selectionSvc = this.beans.selectionSvc;
        if (!selectionSvc) return void 0;
        const selectionState = selectionSvc.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !selectionState?.toggledNodes?.length;
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState) {
        this.beans.selectionSvc?.setSelectionState(rowSelectionState, "gridInitializing");
    }
    getRowGroupExpansionState() {
        const { expansionSvc: expansionSvc, rowModel: rowModel } = this.beans;
        if (!expansionSvc) return void 0;
        const expandedRowGroups = [];
        rowModel.forEachNode(({ expanded: expanded, id: id })=>{
            if (expanded && id) expandedRowGroups.push(id);
        });
        return expandedRowGroups.length ? {
            expandedRowGroupIds: expandedRowGroups
        } : void 0;
    }
    getRowPinningState() {
        return this.beans.pinnedRowModel?.getPinnedState();
    }
    setRowPinningState(state) {
        this.beans.pinnedRowModel?.setPinnedState(state);
    }
    setRowGroupExpansionState(rowGroupExpansionState) {
        this.beans.expansionSvc?.expandRows(rowGroupExpansionState.expandedRowGroupIds);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        const cachedState = this.cachedState;
        for (const key of Object.keys(newColumnState)){
            const value = newColumnState[key];
            if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, cachedState[key])) hasChanged = true;
        }
        this.cachedState = {
            ...cachedState,
            ...newColumnState
        };
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!$437b23f6a393c3bf$export$dbc2068cc90f5875(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = {
            ...this.cachedState,
            [key]: value
        };
    }
    refreshStaleState() {
        const staleStateKeys = this.staleStateKeys;
        staleStateKeys.forEach((key)=>{
            switch(key){
                case "rowSelection":
                    this.setCachedStateValue(key, this.getRowSelectionState());
                    break;
            }
        });
        staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        sources.forEach((source)=>this.queuedUpdateSources.add(source));
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const queuedUpdateSources = this.queuedUpdateSources;
        const sources = Array.from(queuedUpdateSources);
        queuedUpdateSources.clear();
        this.eventSvc.dispatchEvent({
            type: "stateUpdated",
            sources: sources,
            state: this.cachedState
        });
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.suppressEvents = true;
        const colAnimation = this.beans.colAnimation;
        colAnimation?.setSuppressAnimation(true);
        updateFunc();
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            colAnimation?.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                "gridInitializing"
            ]);
        });
    }
};
// packages/ag-grid-community/src/misc/state/stateModule.ts
var $437b23f6a393c3bf$export$3402149dbbda9537 = {
    moduleName: "GridState",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$StateService
    ],
    apiFunctions: {
        getState: $437b23f6a393c3bf$var$getState
    }
};
// packages/ag-grid-community/src/pagination/paginationApi.ts
function $437b23f6a393c3bf$var$paginationIsLastPageFound(beans) {
    return beans.rowModel.isLastRowIndexKnown();
}
function $437b23f6a393c3bf$var$paginationGetPageSize(beans) {
    return beans.pagination?.getPageSize() ?? 100;
}
function $437b23f6a393c3bf$var$paginationGetCurrentPage(beans) {
    return beans.pagination?.getCurrentPage() ?? 0;
}
function $437b23f6a393c3bf$var$paginationGetTotalPages(beans) {
    return beans.pagination?.getTotalPages() ?? 1;
}
function $437b23f6a393c3bf$var$paginationGetRowCount(beans) {
    return beans.pagination ? beans.pagination.getMasterRowCount() : beans.rowModel.getRowCount();
}
function $437b23f6a393c3bf$var$paginationGoToNextPage(beans) {
    beans.pagination?.goToNextPage();
}
function $437b23f6a393c3bf$var$paginationGoToPreviousPage(beans) {
    beans.pagination?.goToPreviousPage();
}
function $437b23f6a393c3bf$var$paginationGoToFirstPage(beans) {
    beans.pagination?.goToFirstPage();
}
function $437b23f6a393c3bf$var$paginationGoToLastPage(beans) {
    beans.pagination?.goToLastPage();
}
function $437b23f6a393c3bf$var$paginationGoToPage(beans, page) {
    beans.pagination?.goToPage(page);
}
// packages/ag-grid-community/src/pagination/paginationAutoPageSizeService.ts
var $437b23f6a393c3bf$var$PaginationAutoPageSizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "paginationAutoPageSizeSvc";
    }
    postConstruct() {
        this.beans.ctrlsSvc.whenReady(this, (p)=>{
            this.centerRowsCtrl = p.center;
            const listener = this.checkPageSize.bind(this);
            this.addManagedEventListeners({
                bodyHeightChanged: listener,
                scrollVisibilityChanged: listener
            });
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.beans.pagination.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
        if (bodyHeight > 0) {
            const beans = this.beans;
            const update = ()=>{
                const rowHeight = Math.max($437b23f6a393c3bf$export$8966875adec41e5b(beans), 1);
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                beans.pagination.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, update, 50)();
        } else this.isBodyRendered = false;
    }
};
// packages/ag-grid-community/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var $437b23f6a393c3bf$var$paginationPageSizeSelector = "paginationPageSizeSelector";
var $437b23f6a393c3bf$var$PageSizeSelectorCompElement = {
    tag: "span",
    cls: "ag-paging-page-size"
};
var $437b23f6a393c3bf$var$PageSizeSelectorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$PageSizeSelectorCompElement);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.pagination.getPageSize()) return;
            this.pagination.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    wireBeans(beans) {
        this.pagination = beans.pagination;
    }
    postConstruct() {
        this.addManagedPropertyListener($437b23f6a393c3bf$var$paginationPageSizeSelector, ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedEventListeners({
            paginationChanged: (event)=>this.handlePaginationChanged(event)
        });
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !paginationChangedEvent?.newPageSize) return;
        const paginationPageSize = this.pagination.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp && !show) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
    }
    reset() {
        $437b23f6a393c3bf$export$69e6e10709eabd91(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp);
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.pagination.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            const pageSizeSet = this.gos.exists("paginationPageSize");
            const pageSizesSet = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector) !== true;
            $437b23f6a393c3bf$export$545083624300f13d(94, {
                pageSizeSet: pageSizeSet,
                pageSizesSet: pageSizesSet,
                pageSizeOptions: pageSizeOptions,
                paginationPageSizeOption: paginationPageSizeOption
            });
            if (!pageSizesSet) $437b23f6a393c3bf$export$545083624300f13d(95, {
                paginationPageSizeOption: paginationPageSizeOption,
                paginationPageSizeSelector: $437b23f6a393c3bf$var$paginationPageSizeSelector
            });
            pageSizeOptions.unshift("");
        }
        const value = String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption);
        if (this.selectPageSizeComp) {
            if (!$437b23f6a393c3bf$export$893967cdb9833fdd(this.pageSizeOptions, pageSizeOptions)) {
                this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(pageSizeOptions));
                this.pageSizeOptions = pageSizeOptions;
            }
            this.selectPageSizeComp.setValue(value, true);
        } else this.createPageSizeSelectorComp(pageSizeOptions, value);
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    createPageSizeSelectOptions(pageSizeOptions) {
        return pageSizeOptions.map((value)=>({
                value: String(value)
            }));
    }
    createPageSizeSelectorComp(pageSizeOptions, value) {
        const localeTextFunc = this.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032()).addOptions(this.createPageSizeSelectOptions(pageSizeOptions)).setValue(value).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.appendChild(this.selectPageSizeComp);
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get($437b23f6a393c3bf$var$paginationPageSizeSelector);
        if (!Array.isArray(paginationPageSizeSelectorValues) || !paginationPageSizeSelectorValues?.length) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
var $437b23f6a393c3bf$var$PageSizeSelectorSelector = {
    selector: "AG-PAGE-SIZE-SELECTOR",
    component: $437b23f6a393c3bf$var$PageSizeSelectorComp
};
// packages/ag-grid-community/src/pagination/paginationComp.css-GENERATED.ts
var $437b23f6a393c3bf$var$paginationCompCSS = /*css*/ `.ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:max(var(--ag-row-height),22px);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}`;
// packages/ag-grid-community/src/pagination/paginationComp.ts
var $437b23f6a393c3bf$var$PaginationComp = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(){
        super();
        this.btFirst = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btPrevious = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btNext = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.btLast = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbRecordCount = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbFirstRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbLastRowOnPage = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbCurrent = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.lbTotal = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.pageSizeComp = $437b23f6a393c3bf$export$6c811454646ed8be;
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
        this.allowFocusInnerElement = false;
        this.registerCSS($437b23f6a393c3bf$var$paginationCompCSS);
    }
    wireBeans(beans) {
        this.rowModel = beans.rowModel;
        this.pagination = beans.pagination;
        this.ariaAnnounce = beans.ariaAnnounce;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate(), [
            $437b23f6a393c3bf$var$PageSizeSelectorSelector
        ]);
        const { btFirst: btFirst, btPrevious: btPrevious, btNext: btNext, btLast: btLast } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "last" : "first", this.beans));
        btPrevious.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "next" : "previous", this.beans));
        btNext.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "previous" : "next", this.beans));
        btLast.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$export$d8feba07bf373edb(isRtl ? "first" : "last", this.beans));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.initialiseTabGuard({
            // prevent tab guard default logic
            onTabKeyDown: ()=>{},
            focusInnerElement: (fromBottom)=>{
                if (this.allowFocusInnerElement) return this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(fromBottom);
                else return $437b23f6a393c3bf$export$b3beea4db79d8bb3(this.beans, fromBottom);
            },
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
        this.onPaginationChanged();
    }
    setAllowFocus(allowFocus) {
        this.allowFocusInnerElement = allowFocus;
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedEventListeners({
                paginationChanged: this.onPaginationChanged.bind(this)
            });
            [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ].forEach((item)=>{
                const { el: el, fn: fn } = item;
                this.addManagedListeners(el, {
                    click: fn,
                    keydown: (e)=>{
                        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                            e.preventDefault();
                            fn();
                        }
                    }
                });
            });
            $437b23f6a393c3bf$export$8865b8c867776648(this.beans, this, this.getGui());
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToFirstPage();
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value: value
            };
            return userFunc(params);
        }
        return $437b23f6a393c3bf$export$c8980add4a69422e(value, this.getLocaleTextFunc.bind(this));
    }
    getTemplate() {
        const localeTextFunc = this.getLocaleTextFunc();
        const idPrefix = `ag-${this.getCompId()}`;
        return {
            tag: "div",
            cls: "ag-paging-panel ag-unselectable",
            attrs: {
                id: `${idPrefix}`
            },
            children: [
                {
                    tag: "ag-page-size-selector",
                    ref: "pageSizeComp"
                },
                {
                    tag: "span",
                    cls: "ag-paging-row-summary-panel",
                    children: [
                        {
                            tag: "span",
                            ref: "lbFirstRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-first-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-to`
                            },
                            children: localeTextFunc("to", "to")
                        },
                        {
                            tag: "span",
                            ref: "lbLastRowOnPage",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-last-row`
                            }
                        },
                        {
                            tag: "span",
                            attrs: {
                                id: `${idPrefix}-of`
                            },
                            children: localeTextFunc("of", "of")
                        },
                        {
                            tag: "span",
                            ref: "lbRecordCount",
                            cls: "ag-paging-row-summary-panel-number",
                            attrs: {
                                id: `${idPrefix}-row-count`
                            }
                        }
                    ]
                },
                {
                    tag: "span",
                    cls: "ag-paging-page-summary-panel",
                    role: "presentation",
                    children: [
                        {
                            tag: "div",
                            ref: "btFirst",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("firstPage", "First Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btPrevious",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("previousPage", "Previous Page")
                            }
                        },
                        {
                            tag: "span",
                            cls: "ag-paging-description",
                            children: [
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-start-page`
                                    },
                                    children: localeTextFunc("page", "Page")
                                },
                                {
                                    tag: "span",
                                    ref: "lbCurrent",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-start-page-number`
                                    }
                                },
                                {
                                    tag: "span",
                                    attrs: {
                                        id: `${idPrefix}-of-page`
                                    },
                                    children: localeTextFunc("of", "of")
                                },
                                {
                                    tag: "span",
                                    ref: "lbTotal",
                                    cls: "ag-paging-number",
                                    attrs: {
                                        id: `${idPrefix}-of-page-number`
                                    }
                                }
                            ]
                        },
                        {
                            tag: "div",
                            ref: "btNext",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("nextPage", "Next Page")
                            }
                        },
                        {
                            tag: "div",
                            ref: "btLast",
                            cls: "ag-button ag-paging-button",
                            role: "button",
                            attrs: {
                                "aria-label": localeTextFunc("lastPage", "Last Page")
                            }
                        }
                    ]
                }
            ]
        };
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.pagination.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.pagination.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.pagination.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.pagination.getCurrentPage();
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        $437b23f6a393c3bf$export$7ed376f43c6f2bbd(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    updateLabels() {
        const lastPageFound = this.rowModel.isLastRowIndexKnown();
        const totalPages = this.pagination.getTotalPages();
        const masterRowCount = this.pagination.getMasterRowCount();
        const rowCount = lastPageFound ? masterRowCount : null;
        const currentPage = this.pagination.getCurrentPage();
        const pageSize = this.pagination.getPageSize();
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (lastPageFound && endRow > rowCount) endRow = rowCount;
        }
        const theoreticalEndRow = startRow + pageSize - 1;
        const isLoadingPageSize = !lastPageFound && masterRowCount < theoreticalEndRow;
        const lbFirstRowOnPage = this.formatNumber(startRow);
        this.lbFirstRowOnPage.textContent = lbFirstRowOnPage;
        let lbLastRowOnPage;
        const localeTextFunc = this.getLocaleTextFunc();
        if (isLoadingPageSize) lbLastRowOnPage = localeTextFunc("pageLastRowUnknown", "?");
        else lbLastRowOnPage = this.formatNumber(endRow);
        this.lbLastRowOnPage.textContent = lbLastRowOnPage;
        const pagesExist = totalPages > 0;
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        const lbCurrent = this.formatNumber(toDisplay);
        this.lbCurrent.textContent = lbCurrent;
        let lbTotal;
        let lbRecordCount;
        if (lastPageFound) {
            lbTotal = this.formatNumber(totalPages);
            lbRecordCount = this.formatNumber(rowCount);
        } else {
            const moreText = localeTextFunc("more", "more");
            lbTotal = moreText;
            lbRecordCount = moreText;
        }
        this.lbTotal.textContent = lbTotal;
        this.lbRecordCount.textContent = lbRecordCount;
        this.announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal);
    }
    announceAriaStatus(lbFirstRowOnPage, lbLastRowOnPage, lbRecordCount, lbCurrent, lbTotal) {
        const localeTextFunc = this.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const ariaRowStatus = `${lbFirstRowOnPage} ${strTo} ${lbLastRowOnPage} ${strOf} ${lbRecordCount}`;
        const ariaPageStatus = `${strPage} ${lbCurrent} ${strOf} ${lbTotal}`;
        if (ariaRowStatus !== this.ariaRowStatus) {
            this.ariaRowStatus = ariaRowStatus;
            this.ariaAnnounce?.announceValue(ariaRowStatus, "paginationRow");
        }
        if (ariaPageStatus !== this.ariaPageStatus) {
            this.ariaPageStatus = ariaPageStatus;
            this.ariaAnnounce?.announceValue(ariaPageStatus, "paginationPage");
        }
    }
    setTotalLabelsToZero() {
        const strZero = this.formatNumber(0);
        this.lbFirstRowOnPage.textContent = strZero;
        this.lbCurrent.textContent = strZero;
        this.lbLastRowOnPage.textContent = strZero;
        this.lbTotal.textContent = strZero;
        this.lbRecordCount.textContent = strZero;
        this.announceAriaStatus(strZero, strZero, strZero, strZero, strZero);
    }
};
var $437b23f6a393c3bf$var$PaginationSelector = {
    selector: "AG-PAGINATION",
    component: $437b23f6a393c3bf$var$PaginationComp
};
// packages/ag-grid-community/src/pagination/paginationService.ts
var $437b23f6a393c3bf$var$PaginationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "pagination";
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        const gos = this.gos;
        this.active = gos.get("pagination");
        this.pageSizeFromGridOptions = gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
    }
    getPaginationSelector() {
        return $437b23f6a393c3bf$var$PaginationSelector;
    }
    isPaginateChildRows() {
        const gos = this.gos;
        const shouldPaginate = gos.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
        gos.get("groupRemoveSingleChildren") || gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return gos.get("paginateChildRows");
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            keepRenderedRows: true
        });
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        const currentPage = this.currentPage;
        if (!this.active || currentPage === page || typeof currentPage !== "number") return;
        this.currentPage = page;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPage: true
        });
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        let adjustedIndex = index;
        if (!this.paginateChildRows) adjustedIndex = this.beans.rowModel.getTopLevelIndexFromDisplayedIndex?.(index) ?? index;
        this.goToPage(Math.floor(adjustedIndex / this.pageSize));
    }
    isRowInPage(rowIndex) {
        if (!this.active) return true;
        return rowIndex >= this.topDisplayedRowIndex && rowIndex <= this.bottomDisplayedRowIndex;
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.beans.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize")) return this.pageSizeAutoCalculated;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if ($437b23f6a393c3bf$export$25d27f17d3af40f7(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        this.dispatchPaginationChangedEvent({
            newPageSize: true
        });
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            this.dispatchPaginationChangedEvent({
                newPageSize: true,
                keepRenderedRows: true
            });
        }
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        const totalPages = this.totalPages;
        if (this.currentPage >= totalPages) this.currentPage = totalPages - 1;
        const currentPage = this.currentPage;
        if (!isFinite(currentPage) || isNaN(currentPage) || currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        const rowModel = this.beans.rowModel;
        const masterRowCount = rowModel.getTopLevelRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const pageSize = this.pageSize;
        const masterLastRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const currentPage = this.currentPage;
        const masterPageStartIndex = pageSize * currentPage;
        let masterPageEndIndex = pageSize * (currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        const masterRowCount = this.beans.rowModel.getRowCount();
        this.masterRowCount = masterRowCount;
        if (masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const { pageSize: pageSize, currentPage: currentPage } = this;
        const maxRowIndex = masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = pageSize * currentPage;
        this.bottomDisplayedRowIndex = pageSize * (currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
    }
    dispatchPaginationChangedEvent(params) {
        const { keepRenderedRows: keepRenderedRows = false, newPage: newPage = false, newPageSize: newPageSize = false } = params;
        this.eventSvc.dispatchEvent({
            type: "paginationChanged",
            animate: false,
            newData: false,
            newPage: newPage,
            newPageSize: newPageSize,
            keepRenderedRows: keepRenderedRows
        });
    }
};
// packages/ag-grid-community/src/pagination/paginationModule.ts
var $437b23f6a393c3bf$export$a57c5ed18afb0c4 = {
    moduleName: "Pagination",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$PaginationService,
        $437b23f6a393c3bf$var$PaginationAutoPageSizeService
    ],
    icons: {
        // "go to first" button in pagination controls
        first: "first",
        // "go to previous" button in pagination controls
        previous: "previous",
        // "go to next" button in pagination controls
        next: "next",
        // "go to last" button in pagination controls
        last: "last"
    },
    apiFunctions: {
        paginationIsLastPageFound: $437b23f6a393c3bf$var$paginationIsLastPageFound,
        paginationGetPageSize: $437b23f6a393c3bf$var$paginationGetPageSize,
        paginationGetCurrentPage: $437b23f6a393c3bf$var$paginationGetCurrentPage,
        paginationGetTotalPages: $437b23f6a393c3bf$var$paginationGetTotalPages,
        paginationGetRowCount: $437b23f6a393c3bf$var$paginationGetRowCount,
        paginationGoToNextPage: $437b23f6a393c3bf$var$paginationGoToNextPage,
        paginationGoToPreviousPage: $437b23f6a393c3bf$var$paginationGoToPreviousPage,
        paginationGoToFirstPage: $437b23f6a393c3bf$var$paginationGoToFirstPage,
        paginationGoToLastPage: $437b23f6a393c3bf$var$paginationGoToLastPage,
        paginationGoToPage: $437b23f6a393c3bf$var$paginationGoToPage
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ]
};
// packages/ag-grid-community/src/api/rowApi.ts
function $437b23f6a393c3bf$var$redrawRows(beans, params = {}) {
    const rowNodes = params ? params.rowNodes : void 0;
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.redrawRows(rowNodes));
}
function $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode, expanded, expandParents, forceSync) {
    if (rowNode) {
        if (expandParents && rowNode.parent && rowNode.parent.level !== -1) $437b23f6a393c3bf$var$setRowNodeExpanded(beans, rowNode.parent, expanded, expandParents, forceSync);
        rowNode.setExpanded(expanded, void 0, forceSync);
    }
}
function $437b23f6a393c3bf$var$getRowNode(beans, id) {
    return beans.rowModel.getRowNode(id);
}
function $437b23f6a393c3bf$var$addRenderedRowListener(beans, eventName, rowIndex, callback) {
    beans.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
}
function $437b23f6a393c3bf$var$getRenderedNodes(beans) {
    return beans.rowRenderer.getRenderedNodes();
}
function $437b23f6a393c3bf$var$forEachNode(beans, callback, includeFooterNodes) {
    beans.rowModel.forEachNode(callback, includeFooterNodes);
}
function $437b23f6a393c3bf$var$getFirstDisplayedRowIndex(beans) {
    return beans.rowRenderer.firstRenderedRow;
}
function $437b23f6a393c3bf$var$getLastDisplayedRowIndex(beans) {
    return beans.rowRenderer.lastRenderedRow;
}
function $437b23f6a393c3bf$var$getDisplayedRowAtIndex(beans, index) {
    return beans.rowModel.getRow(index);
}
function $437b23f6a393c3bf$var$getDisplayedRowCount(beans) {
    return beans.rowModel.getRowCount();
}
// packages/ag-grid-community/src/api/apiModule.ts
var $437b23f6a393c3bf$export$12e9d7df2a270583 = {
    moduleName: "RowApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        redrawRows: $437b23f6a393c3bf$var$redrawRows,
        setRowNodeExpanded: $437b23f6a393c3bf$var$setRowNodeExpanded,
        getRowNode: $437b23f6a393c3bf$var$getRowNode,
        addRenderedRowListener: $437b23f6a393c3bf$var$addRenderedRowListener,
        getRenderedNodes: $437b23f6a393c3bf$var$getRenderedNodes,
        forEachNode: $437b23f6a393c3bf$var$forEachNode,
        getFirstDisplayedRowIndex: $437b23f6a393c3bf$var$getFirstDisplayedRowIndex,
        getLastDisplayedRowIndex: $437b23f6a393c3bf$var$getLastDisplayedRowIndex,
        getDisplayedRowAtIndex: $437b23f6a393c3bf$var$getDisplayedRowAtIndex,
        getDisplayedRowCount: $437b23f6a393c3bf$var$getDisplayedRowCount
    }
};
var $437b23f6a393c3bf$export$351f260d7f887abc = {
    moduleName: "ScrollApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        getVerticalPixelRange: $437b23f6a393c3bf$var$getVerticalPixelRange,
        getHorizontalPixelRange: $437b23f6a393c3bf$var$getHorizontalPixelRange,
        ensureColumnVisible: $437b23f6a393c3bf$var$ensureColumnVisible,
        ensureIndexVisible: $437b23f6a393c3bf$var$ensureIndexVisible,
        ensureNodeVisible: $437b23f6a393c3bf$var$ensureNodeVisible
    }
};
// packages/ag-grid-community/src/rendering/renderApi.ts
function $437b23f6a393c3bf$var$setGridAriaProperty(beans, property, value) {
    if (!property) return;
    const eGrid = beans.ctrlsSvc.getGridBodyCtrl().eGridBody;
    const ariaProperty = `aria-${property}`;
    if (value === null) eGrid.removeAttribute(ariaProperty);
    else eGrid.setAttribute(ariaProperty, value);
}
function $437b23f6a393c3bf$var$refreshCells(beans, params = {}) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.rowRenderer.refreshCells(params));
}
function $437b23f6a393c3bf$var$refreshHeader(beans) {
    beans.frameworkOverrides.wrapIncoming(()=>beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((c)=>c.refresh()));
}
function $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty(beans) {
    return beans.animationFrameSvc?.isQueueEmpty() ?? true;
}
function $437b23f6a393c3bf$var$flushAllAnimationFrames(beans) {
    beans.animationFrameSvc?.flushAllFrames();
}
function $437b23f6a393c3bf$var$getSizesForCurrentTheme(beans) {
    return {
        rowHeight: $437b23f6a393c3bf$export$8966875adec41e5b(beans),
        headerHeight: $437b23f6a393c3bf$var$getHeaderHeight(beans)
    };
}
function $437b23f6a393c3bf$var$getCellRendererInstances(beans, params = {}) {
    const cellRenderers = [];
    beans.rowRenderer.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>{
        const cellRenderer = cellCtrl.getCellRenderer();
        if (cellRenderer != null) cellRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(cellRenderer));
    });
    if (params.columns?.length) return cellRenderers;
    const fullWidthRenderers = [];
    const rowIdMap = $437b23f6a393c3bf$var$mapRowNodes(params.rowNodes);
    beans.rowRenderer.getAllRowCtrls().forEach((rowCtrl)=>{
        if (rowIdMap && !$437b23f6a393c3bf$var$isRowInMap(rowCtrl.rowNode, rowIdMap)) return;
        if (!rowCtrl.isFullWidth()) return;
        const renderers = rowCtrl.getFullWidthCellRenderers();
        for(let i = 0; i < renderers.length; i++){
            const renderer = renderers[i];
            if (renderer != null) fullWidthRenderers.push($437b23f6a393c3bf$export$213d4c63c3df47e4(renderer));
        }
    });
    return [
        ...fullWidthRenderers,
        ...cellRenderers
    ];
}
// packages/ag-grid-community/src/rendering/renderModule.ts
var $437b23f6a393c3bf$export$b67b27f72da743ce = {
    moduleName: "RenderApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        setGridAriaProperty: $437b23f6a393c3bf$var$setGridAriaProperty,
        refreshCells: $437b23f6a393c3bf$var$refreshCells,
        refreshHeader: $437b23f6a393c3bf$var$refreshHeader,
        isAnimationFrameQueueEmpty: $437b23f6a393c3bf$var$isAnimationFrameQueueEmpty,
        flushAllAnimationFrames: $437b23f6a393c3bf$var$flushAllAnimationFrames,
        getSizesForCurrentTheme: $437b23f6a393c3bf$var$getSizesForCurrentTheme,
        getCellRendererInstances: $437b23f6a393c3bf$var$getCellRendererInstances
    }
};
// packages/ag-grid-community/src/columnAutosize/columnAutosizeApi.ts
function $437b23f6a393c3bf$var$sizeColumnsToFit(beans, paramsOrGridWidth) {
    if (typeof paramsOrGridWidth === "number") beans.colAutosize?.sizeColumnsToFit(paramsOrGridWidth, "api");
    else beans.colAutosize?.sizeColumnsToFitGridBody(paramsOrGridWidth);
}
function $437b23f6a393c3bf$var$autoSizeColumns(beans, keys, skipHeader) {
    beans.colAutosize?.autoSizeCols({
        colKeys: keys,
        skipHeader: skipHeader,
        source: "api"
    });
}
function $437b23f6a393c3bf$var$autoSizeAllColumns(beans, skipHeader) {
    beans.colAutosize?.autoSizeAllColumns("api", skipHeader);
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeService.ts
var $437b23f6a393c3bf$var$ColumnAutosizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colAutosize";
        this.timesDelayed = 0;
        // when we're waiting for cell data types to be inferred, we need to defer column resizing
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    postConstruct() {
        this.addManagedEventListeners({
            firstDataRendered: ()=>this.onFirstDataRendered()
        });
    }
    autoSizeCols(params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeCols(params));
            return;
        }
        const { colKeys: colKeys, skipHeader: skipHeader, skipHeaderGroups: skipHeaderGroups, stopAtGroup: stopAtGroup, source: source = "api" } = params;
        const { animationFrameSvc: animationFrameSvc, renderStatus: renderStatus, colModel: colModel, autoWidthCalc: autoWidthCalc, visibleCols: visibleCols } = this.beans;
        animationFrameSvc?.flushAllFrames();
        if (this.timesDelayed < 5 && renderStatus && !renderStatus.areHeaderCellsRendered()) {
            this.timesDelayed++;
            setTimeout(()=>{
                if (this.isAlive()) this.autoSizeCols(params);
            });
            return;
        }
        this.timesDelayed = 0;
        const columnsAutoSized = [];
        let changesThisTimeAround = -1;
        const shouldSkipHeader = skipHeader != null ? skipHeader : this.gos.get("skipHeaderOnAutoSize");
        const shouldSkipHeaderGroups = skipHeaderGroups != null ? skipHeaderGroups : shouldSkipHeader;
        while(changesThisTimeAround !== 0){
            changesThisTimeAround = 0;
            const updatedColumns = [];
            colKeys.forEach((key)=>{
                if (!key) return;
                const column = colModel.getCol(key);
                if (!column || $437b23f6a393c3bf$export$3d3e7d751f0445eb(column)) return;
                if (columnsAutoSized.indexOf(column) >= 0) return;
                const preferredWidth = autoWidthCalc.getPreferredWidthForColumn(column, shouldSkipHeader);
                if (preferredWidth > 0) {
                    const newWidth = $437b23f6a393c3bf$var$normaliseColumnWidth(column, preferredWidth);
                    column.setActualWidth(newWidth, source);
                    columnsAutoSized.push(column);
                    changesThisTimeAround++;
                }
                updatedColumns.push(column);
            });
            if (!updatedColumns.length) continue;
            visibleCols.refresh(source);
        }
        if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(colKeys, source, stopAtGroup);
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, columnsAutoSized, true, "autosizeColumns");
    }
    autoSizeColumn(key, source, skipHeader) {
        if (key) this.autoSizeCols({
            colKeys: [
                key
            ],
            skipHeader: skipHeader,
            skipHeaderGroups: true,
            source: source
        });
    }
    autoSizeColumnGroupsByColumns(keys, source, stopAtGroup) {
        const { colModel: colModel, ctrlsSvc: ctrlsSvc } = this.beans;
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = colModel.getColsForKeys(keys);
        columns.forEach((col)=>{
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        });
        let headerGroupCtrl;
        const resizedColumns = [];
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of ctrlsSvc.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            if (headerGroupCtrl) headerGroupCtrl.resizeLeafColumnsToFit(source);
        }
        return resizedColumns;
    }
    autoSizeAllColumns(source, skipHeader) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.autoSizeAllColumns(source, skipHeader));
            return;
        }
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        this.autoSizeCols({
            colKeys: allDisplayedColumns,
            skipHeader: skipHeader,
            source: source
        });
    }
    addColumnAutosize(element, column) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const autoSizeColListener = ()=>{
            this.autoSizeColumn(column, "uiColumnResized", skipHeaderOnAutoSize);
        };
        element.addEventListener("dblclick", autoSizeColListener);
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(element);
        touchListener.addEventListener("doubleTap", autoSizeColListener);
        return ()=>{
            element.removeEventListener("dblclick", autoSizeColListener);
            touchListener.removeEventListener("doubleTap", autoSizeColListener);
            touchListener.destroy();
        };
    }
    addColumnGroupResize(element, columnGroup, callback) {
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        const listener = ()=>{
            const keys = [];
            const leafCols = columnGroup.getDisplayedLeafColumns();
            leafCols.forEach((column)=>{
                if (!column.getColDef().suppressAutoSize) keys.push(column.getColId());
            });
            if (keys.length > 0) this.autoSizeCols({
                colKeys: keys,
                skipHeader: skipHeaderOnAutoSize,
                stopAtGroup: columnGroup,
                source: "uiColumnResized"
            });
            callback();
        };
        element.addEventListener("dblclick", listener);
        return ()=>element.removeEventListener("dblclick", listener);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFitGridBody(params, nextTimeout) {
        if (!this.isAlive()) return;
        const { ctrlsSvc: ctrlsSvc, scrollVisibleSvc: scrollVisibleSvc } = this.beans;
        const gridBodyCtrl = ctrlsSvc.getGridBodyCtrl();
        const removeScrollWidth = gridBodyCtrl.isVerticalScrollShowing();
        const scrollWidthToRemove = removeScrollWidth ? scrollVisibleSvc.getScrollbarWidth() : 0;
        const bodyViewportWidth = $437b23f6a393c3bf$export$cc615e4191ec3e0c(gridBodyCtrl.eGridBody);
        const availableWidth = bodyViewportWidth - scrollWidthToRemove;
        if (availableWidth > 0) {
            this.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFitGridBody(params, -1);
        }, 500);
        else $437b23f6a393c3bf$export$545083624300f13d(29);
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        if (this.shouldQueueResizeOperations) {
            this.pushResizeOperation(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const limitsMap = {};
        if (params) params?.columnLimits?.forEach(({ key: key, ...dimensions })=>{
            limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        });
        const allDisplayedColumns = this.beans.visibleCols.allCols;
        if (gridWidth <= 0 || !allDisplayedColumns.length) return;
        const doColumnsAlreadyFit = gridWidth === $437b23f6a393c3bf$var$getWidthOfColsInList(allDisplayedColumns);
        if (doColumnsAlreadyFit) {
            const doAllColumnsSatisfyConstraints = allDisplayedColumns.every((column)=>{
                if (column.colDef.suppressSizeToFit) return true;
                const widthOverride = limitsMap?.[column.getId()];
                const minWidth = widthOverride?.minWidth ?? params?.defaultMinWidth;
                const maxWidth = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                const colWidth = column.getActualWidth();
                return (minWidth == null || colWidth >= minWidth) && (maxWidth == null || colWidth <= maxWidth);
            });
            if (doAllColumnsSatisfyConstraints) return;
        }
        const colsToSpread = [];
        const colsToNotSpread = [];
        allDisplayedColumns.forEach((column)=>{
            if (column.getColDef().suppressSizeToFit === true) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        });
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            $437b23f6a393c3bf$export$83a881c8b5120679(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        colsToSpread.forEach((column)=>{
            column.resetActualWidth(source);
            const widthOverride = limitsMap?.[column.getId()];
            const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
            const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        });
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - $437b23f6a393c3bf$var$getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) colsToSpread.forEach((column)=>{
                const widthOverride = limitsMap?.[column.getId()]?.minWidth ?? params?.defaultMinWidth;
                if (typeof widthOverride === "number") {
                    column.setActualWidth(widthOverride, source, true);
                    return;
                }
                column.setActualWidth(column.minWidth, source);
            });
            else {
                const scale = availablePixels / $437b23f6a393c3bf$var$getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap?.[column.getId()];
                    const minOverride = widthOverride?.minWidth ?? params?.defaultMinWidth;
                    const maxOverride = widthOverride?.maxWidth ?? params?.defaultMaxWidth;
                    const colMinWidth = column.getMinWidth();
                    const colMaxWidth = column.getMaxWidth();
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : colMinWidth;
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : colMaxWidth;
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if (newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        colsToDispatchEventFor.forEach((col)=>{
            col.fireColumnWidthChangedEvent(source);
        });
        const visibleCols = this.beans.visibleCols;
        visibleCols.setLeftValues(source);
        visibleCols.updateBodyWidths();
        if (silent) return;
        $437b23f6a393c3bf$var$dispatchColumnResizedEvent(this.eventSvc, colsToDispatchEventFor, true, source);
    }
    applyAutosizeStrategy() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (!autoSizeStrategy) return;
        const { type: type } = autoSizeStrategy;
        setTimeout(()=>{
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth: defaultMinWidth, defaultMaxWidth: defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits?.map(({ colId: key, minWidth: minWidth, maxWidth: maxWidth })=>({
                        key: key,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    }));
                this.sizeColumnsToFitGridBody({
                    defaultMinWidth: defaultMinWidth,
                    defaultMaxWidth: defaultMaxWidth,
                    columnLimits: columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
        });
    }
    onFirstDataRendered() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (autoSizeStrategy?.type !== "fitCellContents") return;
        const { colIds: columns, skipHeader: skipHeader } = autoSizeStrategy;
        setTimeout(()=>{
            if (columns) this.autoSizeCols({
                colKeys: columns,
                skipHeader: skipHeader,
                source: "autosizeColumns"
            });
            else this.autoSizeAllColumns("autosizeColumns", skipHeader);
        });
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue.forEach((resizeOperation)=>resizeOperation());
        this.resizeOperationQueue = [];
    }
    pushResizeOperation(func) {
        this.resizeOperationQueue.push(func);
    }
    destroy() {
        this.resizeOperationQueue.length = 0;
        super.destroy();
    }
};
function $437b23f6a393c3bf$var$normaliseColumnWidth(column, newWidth) {
    const minWidth = column.getMinWidth();
    if (newWidth < minWidth) newWidth = minWidth;
    const maxWidth = column.getMaxWidth();
    if (column.isGreaterThanMax(newWidth)) newWidth = maxWidth;
    return newWidth;
}
// packages/ag-grid-community/src/columnAutosize/columnAutosizeModule.ts
var $437b23f6a393c3bf$export$baf19ca56ec781d2 = {
    moduleName: "ColumnAutoSize",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnAutosizeService
    ],
    apiFunctions: {
        sizeColumnsToFit: $437b23f6a393c3bf$var$sizeColumnsToFit,
        autoSizeColumns: $437b23f6a393c3bf$var$autoSizeColumns,
        autoSizeAllColumns: $437b23f6a393c3bf$var$autoSizeAllColumns
    },
    dependsOn: [
        $437b23f6a393c3bf$var$AutoWidthModule
    ]
};
// packages/ag-grid-community/src/pinnedRowModel/manualPinnedRow.css-GENERATED.ts
var $437b23f6a393c3bf$var$manualPinnedRowCSS = /*css*/ `.ag-row-pinned-source{background-color:var(--ag-pinned-source-row-background-color);color:var(--ag-pinned-source-row-text-color);font-weight:var(--ag-pinned-source-row-font-weight)}.ag-row-pinned-manual{background-color:var(--ag-pinned-row-background-color);color:var(--ag-pinned-row-text-color);font-weight:var(--ag-pinned-row-font-weight)}`;
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowApi.ts
function $437b23f6a393c3bf$var$getPinnedTopRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedTopRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedBottomRowCount(beans) {
    return beans.pinnedRowModel?.getPinnedBottomRowCount() ?? 0;
}
function $437b23f6a393c3bf$var$getPinnedTopRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedTopRow(index);
}
function $437b23f6a393c3bf$var$getPinnedBottomRow(beans, index) {
    return beans.pinnedRowModel?.getPinnedBottomRow(index);
}
function $437b23f6a393c3bf$var$forEachPinnedRow(beans, floating, callback) {
    return beans.pinnedRowModel?.forEachPinnedRow(floating, callback);
}
// packages/ag-grid-community/src/pinnedRowModel/pinnedRowModule.ts
var $437b23f6a393c3bf$export$b6e84cdeabbb116a = {
    moduleName: "PinnedRow",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$d44126a5f53c99d9
    ],
    css: [
        $437b23f6a393c3bf$var$manualPinnedRowCSS
    ],
    apiFunctions: {
        getPinnedTopRowCount: $437b23f6a393c3bf$var$getPinnedTopRowCount,
        getPinnedBottomRowCount: $437b23f6a393c3bf$var$getPinnedBottomRowCount,
        getPinnedTopRow: $437b23f6a393c3bf$var$getPinnedTopRow,
        getPinnedBottomRow: $437b23f6a393c3bf$var$getPinnedBottomRow,
        forEachPinnedRow: $437b23f6a393c3bf$var$forEachPinnedRow
    },
    icons: {
        rowPin: "pin",
        rowPinTop: "pinned-top",
        rowPinBottom: "pinned-bottom",
        rowUnpin: "un-pin"
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedCellCtrl.ts
var $437b23f6a393c3bf$var$SpannedCellCtrl = class extends $437b23f6a393c3bf$var$CellCtrl {
    constructor(cellSpan, rowCtrl, beans){
        super(cellSpan.col, cellSpan.firstNode, beans, rowCtrl);
        this.cellSpan = cellSpan;
        this.SPANNED_CELL_CSS_CLASS = "ag-spanned-cell";
    }
    setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean) {
        this.eWrapper = eWrapper;
        super.setComp(comp, eCell, eWrapper, eCellWrapper, printLayout, startEditing, compBean);
        this.setAriaRowSpan();
        this.refreshAriaRowIndex();
    }
    isCellSpanning() {
        return true;
    }
    getCellSpan() {
        return this.cellSpan;
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ refreshAriaRowIndex() {
        if (this.rowNode.rowIndex == null) return;
        $437b23f6a393c3bf$export$ba731dedf9d88615(this.eGui, this.rowNode.rowIndex);
    }
    /**
   * When cell is spanning, ensure row index is also available on the cell
   */ setAriaRowSpan() {
        $437b23f6a393c3bf$var$_setAriaRowSpan(this.eGui, this.cellSpan.spannedNodes.size);
    }
    // not ideal, for tabbing need to force the focused position
    setFocusedCellPosition(cellPos) {
        this.focusedCellPosition = cellPos;
    }
    getFocusedCellPosition() {
        return this.focusedCellPosition ?? this.cellPosition;
    }
    checkCellFocused() {
        const focusedCell = this.beans.focusSvc.getFocusedCell();
        return !!focusedCell && this.cellSpan.doesSpanContain(focusedCell);
    }
    applyStaticCssClasses() {
        super.applyStaticCssClasses();
        this.comp.toggleCss(this.SPANNED_CELL_CSS_CLASS, true);
    }
    onCellFocused(event) {
        const { beans: beans } = this;
        if ($437b23f6a393c3bf$var$_isCellFocusSuppressed(beans)) {
            this.focusedCellPosition = void 0;
            return;
        }
        const cellFocused = this.isCellFocused();
        if (!cellFocused) this.focusedCellPosition = void 0;
        if (event && cellFocused) this.focusedCellPosition = {
            rowIndex: event.rowIndex,
            rowPinned: event.rowPinned,
            column: event.column
        };
        super.onCellFocused(event);
    }
    getRootElement() {
        return this.eWrapper;
    }
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowCtrl.ts
var $437b23f6a393c3bf$var$SpannedRowCtrl = class extends $437b23f6a393c3bf$var$RowCtrl {
    onRowIndexChanged() {
        super.onRowIndexChanged();
        this.getAllCellCtrls().forEach((c)=>c.refreshAriaRowIndex());
    }
    getInitialRowClasses(_rowContainerType) {
        return [
            "ag-spanned-row"
        ];
    }
    getNewCellCtrl(col) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(col, this.rowNode);
        if (!cellSpan) return;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return;
        return new $437b23f6a393c3bf$var$SpannedCellCtrl(cellSpan, this, this.beans);
    }
    isCorrectCtrlForSpan(cell) {
        const cellSpan = this.beans.rowSpanSvc?.getCellSpan(cell.column, this.rowNode);
        if (!cellSpan) return false;
        const firstRowOfSpan = cellSpan.firstNode !== this.rowNode;
        if (firstRowOfSpan) return false;
        return cell.getCellSpan() === cellSpan;
    }
    /**
   * Below overrides are explicitly disabling styling and other unwanted behaviours for spannedRowCtrl
   */ // row height should be 0 in spanned row - they're only included for purpose of aria
    onRowHeightChanged() {}
    // no styling spanned rows
    refreshFirstAndLastRowStyles() {}
    // no hover functionality for spanned rows
    addHoverFunctionality() {}
    resetHoveredStatus() {}
};
// packages/ag-grid-community/src/rendering/spanning/spannedRowRenderer.ts
var $437b23f6a393c3bf$var$SpannedRowRenderer = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "spannedRowRenderer";
        this.topCtrls = /* @__PURE__ */ new Map();
        this.bottomCtrls = /* @__PURE__ */ new Map();
        this.centerCtrls = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.addManagedEventListeners({
            displayedRowsChanged: this.createAllCtrls.bind(this)
        });
    }
    createAllCtrls() {
        this.createCtrls("top");
        this.createCtrls("bottom");
        this.createCtrls("center");
    }
    /**
   * When displayed rows or cols change, the spanned cell ctrls need to update
   */ createCtrls(ctrlsKey) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const ctrlsName = `${ctrlsKey}Ctrls`;
        const previousCtrls = this[ctrlsName];
        const previousCtrlsSize = previousCtrls.size;
        const rowCtrls = this.getAllRelevantRowControls(ctrlsKey);
        const newRowCtrls = /* @__PURE__ */ new Map();
        let hasNewSpans = false;
        for (const ctrl of rowCtrls){
            if (!ctrl.isAlive()) continue;
            rowSpanSvc?.forEachSpannedColumn(ctrl.rowNode, (col, cellSpan)=>{
                if (newRowCtrls.has(cellSpan.firstNode)) return;
                const existingCtrl = previousCtrls.get(cellSpan.firstNode);
                if (existingCtrl) {
                    newRowCtrls.set(cellSpan.firstNode, existingCtrl);
                    previousCtrls.delete(cellSpan.firstNode);
                    return;
                }
                hasNewSpans = true;
                const newCtrl = new $437b23f6a393c3bf$var$SpannedRowCtrl(cellSpan.firstNode, this.beans, false, false, false);
                newRowCtrls.set(cellSpan.firstNode, newCtrl);
            });
        }
        this[ctrlsName] = newRowCtrls;
        const sameCount = newRowCtrls.size === previousCtrlsSize;
        if (!hasNewSpans && sameCount) return;
        for (const oldCtrl of previousCtrls.values()){
            oldCtrl.destroyFirstPass(true);
            oldCtrl.destroySecondPass();
        }
        this.dispatchLocalEvent({
            type: `spannedRowsUpdated`,
            ctrlsKey: ctrlsKey
        });
    }
    // cannot use getAllRowCtrls as it returns this services row ctrls.
    getAllRelevantRowControls(ctrlsKey) {
        const { rowRenderer: rowRenderer } = this.beans;
        switch(ctrlsKey){
            case "top":
                return rowRenderer.topRowCtrls;
            case "bottom":
                return rowRenderer.bottomRowCtrls;
            case "center":
                return rowRenderer.allRowCtrls;
        }
    }
    getCellByPosition(cellPosition) {
        const { rowSpanSvc: rowSpanSvc } = this.beans;
        const cellSpan = rowSpanSvc?.getCellSpanByPosition(cellPosition);
        if (!cellSpan) return void 0;
        const ctrlsName = `${$437b23f6a393c3bf$var$_normalisePinnedValue(cellPosition.rowPinned)}Ctrls`;
        const ctrl = this[ctrlsName].get(cellSpan.firstNode);
        if (!ctrl) return void 0;
        return ctrl.getAllCellCtrls().find((cellCtrl)=>cellCtrl.column === cellPosition.column);
    }
    getCtrls(container) {
        const ctrlsName = `${container}Ctrls`;
        return [
            ...this[ctrlsName].values()
        ];
    }
    destroyRowCtrls(container) {
        const ctrlsName = `${container}Ctrls`;
        for (const ctrl of this[ctrlsName].values()){
            ctrl.destroyFirstPass(true);
            ctrl.destroySecondPass();
        }
        this[ctrlsName] = /* @__PURE__ */ new Map();
    }
    destroy() {
        super.destroy();
        this.destroyRowCtrls("top");
        this.destroyRowCtrls("bottom");
        this.destroyRowCtrls("center");
    }
};
var $437b23f6a393c3bf$var$_normalisePinnedValue = (pinned)=>{
    return pinned ?? "center";
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanCache.ts
var $437b23f6a393c3bf$var$CellSpan = class {
    constructor(col, firstNode){
        this.col = col;
        this.firstNode = firstNode;
        // used for distinguishing between types
        this.cellSpan = true;
        this.spannedNodes = /* @__PURE__ */ new Set();
        this.addSpannedNode(firstNode);
    }
    /**
   * Reset the span leaving only the head.
   * Head is used as a comparison as this is the row used to render this cell
   * Even if the row data changes, the cell will properly reflect the correct value.
   */ reset() {
        this.spannedNodes.clear();
        this.addSpannedNode(this.firstNode);
    }
    addSpannedNode(node) {
        this.spannedNodes.add(node);
        this.lastNode = node;
    }
    getLastNode() {
        return this.lastNode;
    }
    getCellHeight() {
        return this.lastNode.rowTop + this.lastNode.rowHeight - this.firstNode.rowTop - 1;
    }
    doesSpanContain(cellPosition) {
        if (cellPosition.column !== this.col) return false;
        if (cellPosition.rowPinned != this.firstNode.rowPinned) return false;
        return this.firstNode.rowIndex <= cellPosition.rowIndex && cellPosition.rowIndex <= this.lastNode.rowIndex;
    }
    /**
   * Gets the auto height value for last node in the spanned cell.
   * The first node is used to store the auto height for the cell, but the additional height for this cell
   * needs applied to the last row in the span.
   */ getLastNodeAutoHeight() {
        const autoHeight = this.firstNode.__autoHeights?.[this.col.getColId()];
        if (autoHeight == null) return void 0;
        let allButLastHeights = 0;
        this.spannedNodes.forEach((node)=>{
            if (node === this.lastNode) return;
            allButLastHeights += node.rowHeight;
        });
        return autoHeight - allButLastHeights;
    }
};
var $437b23f6a393c3bf$var$RowSpanCache = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.column = column;
    }
    buildCache(pinned) {
        const { column: column, beans: { gos: gos, pinnedRowModel: pinnedRowModel, rowModel: rowModel, valueSvc: valueSvc, pagination: pagination } } = this;
        const { colDef: colDef } = column;
        const oldMap = this[`${pinned}ValueNodeMap`];
        const newMap = /* @__PURE__ */ new Map();
        const isFullWidthCellFunc = gos.getCallback("isFullWidthRow");
        const equalsFnc = colDef.equals;
        const customCompare = colDef.spanRows;
        const isCustomCompare = typeof customCompare === "function";
        let lastNode = null;
        let spanData = null;
        let lastValue;
        const setNewHead = (node, value)=>{
            lastNode = node;
            spanData = null;
            lastValue = value;
        };
        const checkNodeForCache = (node)=>{
            const doesNodeSupportSpanning = !node.isExpandable() && !node.group && !node.detail && (isFullWidthCellFunc ? !isFullWidthCellFunc({
                rowNode: node
            }) : true);
            if (node.rowIndex == null || !doesNodeSupportSpanning) {
                setNewHead(null, null);
                return;
            }
            if (lastNode == null || node.level !== lastNode.level || // no span across groups
            node.footer || spanData && node.rowIndex - 1 !== spanData?.getLastNode().rowIndex) {
                setNewHead(node, valueSvc.getValue(column, node));
                return;
            }
            const value = valueSvc.getValue(column, node);
            if (isCustomCompare) {
                const params = $437b23f6a393c3bf$export$fcfd03fd78c6cf24(gos, {
                    valueA: lastValue,
                    nodeA: lastNode,
                    valueB: value,
                    nodeB: node,
                    column: column,
                    colDef: colDef
                });
                if (!customCompare(params)) {
                    setNewHead(node, value);
                    return;
                }
            } else if (equalsFnc ? !equalsFnc(lastValue, value) : lastValue !== value) {
                setNewHead(node, value);
                return;
            }
            if (!spanData) {
                const oldSpan = oldMap?.get(lastNode);
                if (oldSpan?.firstNode === lastNode) {
                    oldSpan.reset();
                    spanData = oldSpan;
                } else spanData = new $437b23f6a393c3bf$var$CellSpan(column, lastNode);
                newMap.set(lastNode, spanData);
            }
            spanData.addSpannedNode(node);
            newMap.set(node, spanData);
        };
        switch(pinned){
            case "center":
                rowModel.forEachDisplayedNode?.((node)=>{
                    const isNodeInPage = !pagination || pagination.isRowInPage(node.rowIndex);
                    if (!isNodeInPage) return;
                    checkNodeForCache(node);
                });
                break;
            case "top":
                pinnedRowModel?.forEachPinnedRow("top", checkNodeForCache);
                break;
            case "bottom":
                pinnedRowModel?.forEachPinnedRow("bottom", checkNodeForCache);
                break;
        }
        this[`${pinned}ValueNodeMap`] = newMap;
    }
    isCellSpanning(node) {
        return !!this.getCellSpan(node);
    }
    getCellSpan(node) {
        const map = this[`${$437b23f6a393c3bf$var$_normalisePinnedValue(node.rowPinned)}ValueNodeMap`];
        return map.get(node);
    }
};
// packages/ag-grid-community/src/rendering/spanning/rowSpanService.ts
var $437b23f6a393c3bf$var$RowSpanService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowSpanSvc";
        this.spanningColumns = /* @__PURE__ */ new Map();
        // debounced to allow spannedRowRenderer to run first, removing any old spanned rows
        this.debouncePinnedEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, true), 0);
        this.debounceModelEvent = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.dispatchCellsUpdatedEvent.bind(this, false), 0);
        this.pinnedTimeout = null;
        this.modelTimeout = null;
    }
    postConstruct() {
        const onRowDataUpdated = this.onRowDataUpdated.bind(this);
        const buildPinnedCaches = this.buildPinnedCaches.bind(this);
        this.addManagedEventListeners({
            paginationChanged: this.buildModelCaches.bind(this),
            pinnedRowDataChanged: buildPinnedCaches,
            pinnedRowsChanged: buildPinnedCaches,
            rowNodeDataChanged: onRowDataUpdated,
            cellValueChanged: onRowDataUpdated
        });
    }
    /**
   * When a new column is created with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ register(column) {
        const { gos: gos } = this.beans;
        if (!gos.get("enableCellSpan")) return;
        if (this.spanningColumns.has(column)) return;
        const cache = this.createManagedBean(new $437b23f6a393c3bf$var$RowSpanCache(column));
        this.spanningColumns.set(column, cache);
        cache.buildCache("top");
        cache.buildCache("bottom");
        cache.buildCache("center");
        this.debouncePinnedEvent();
        this.debounceModelEvent();
    }
    dispatchCellsUpdatedEvent(pinned) {
        this.dispatchLocalEvent({
            type: "spannedCellsUpdated",
            pinned: pinned
        });
    }
    /**
   * When a new column is destroyed with spanning (or spanning changes for a column)
   * @param column column that is now spanning
   */ deregister(column) {
        this.spanningColumns.delete(column);
    }
    // called when data changes, as this could be a hot path it's debounced
    // it uses timeouts instead of debounce so that it can be cancelled by `modelUpdated`
    // which is expected to run immediately (to exec before the rowRenderer)
    onRowDataUpdated({ node: node }) {
        const { spannedRowRenderer: spannedRowRenderer } = this.beans;
        if (node.rowPinned) {
            if (this.pinnedTimeout != null) return;
            this.pinnedTimeout = window.setTimeout(()=>{
                this.pinnedTimeout = null;
                this.buildPinnedCaches();
                spannedRowRenderer?.createCtrls("top");
                spannedRowRenderer?.createCtrls("bottom");
            }, 0);
            return;
        }
        if (this.modelTimeout != null) return;
        this.modelTimeout = window.setTimeout(()=>{
            this.modelTimeout = null;
            this.buildModelCaches();
            spannedRowRenderer?.createCtrls("center");
        }, 0);
    }
    buildModelCaches() {
        if (this.modelTimeout != null) clearTimeout(this.modelTimeout);
        this.spanningColumns.forEach((cache)=>cache.buildCache("center"));
        this.debounceModelEvent();
    }
    buildPinnedCaches() {
        if (this.pinnedTimeout != null) clearTimeout(this.pinnedTimeout);
        this.spanningColumns.forEach((cache)=>{
            cache.buildCache("top");
            cache.buildCache("bottom");
        });
        this.debouncePinnedEvent();
    }
    isCellSpanning(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return false;
        return cache.isCellSpanning(rowNode);
    }
    getCellSpanByPosition(position) {
        const { pinnedRowModel: pinnedRowModel, rowModel: rowModel } = this.beans;
        const col = position.column;
        const index = position.rowIndex;
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        let node;
        switch(position.rowPinned){
            case "top":
                node = pinnedRowModel?.getPinnedTopRow(index);
                break;
            case "bottom":
                node = pinnedRowModel?.getPinnedBottomRow(index);
                break;
            default:
                node = rowModel.getRow(index);
        }
        if (!node) return void 0;
        return cache.getCellSpan(node);
    }
    getCellStart(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.firstNode.rowIndex
        };
    }
    getCellEnd(position) {
        const span = this.getCellSpanByPosition(position);
        if (!span) return position;
        return {
            ...position,
            rowIndex: span.getLastNode().rowIndex
        };
    }
    /**
   * Look-up a spanned cell given a col and node as position indicators
   *
   * @param col a column to lookup a span at this position
   * @param rowNode a node that may be spanned at this position
   * @returns the CellSpan object if one exists
   */ getCellSpan(col, rowNode) {
        const cache = this.spanningColumns.get(col);
        if (!cache) return void 0;
        return cache.getCellSpan(rowNode);
    }
    forEachSpannedColumn(rowNode, callback) {
        for (const [col, cache] of this.spanningColumns)if (cache.isCellSpanning(rowNode)) {
            const spanningNode = cache.getCellSpan(rowNode);
            callback(col, spanningNode);
        }
    }
    destroy() {
        super.destroy();
        this.spanningColumns.clear();
    }
};
// packages/ag-grid-community/src/rendering/spanning/cellSpanModule.ts
var $437b23f6a393c3bf$export$b7ca1fc11bfe19c3 = {
    moduleName: "CellSpan",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowSpanService,
        $437b23f6a393c3bf$var$SpannedRowRenderer
    ]
};
// packages/ag-grid-community/src/styling/cellCustomStyleFeature.ts
var $437b23f6a393c3bf$var$CellCustomStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(cellCtrl, beans){
        super();
        this.cellCtrl = cellCtrl;
        this.staticClasses = [];
        this.beans = beans;
        this.column = cellCtrl.column;
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassRules = colDef.cellClassRules;
        const cellClassParams = this.getCellClassParams(column, colDef);
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, // if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>cellComp.toggleCss(className, true), (className)=>cellComp.toggleCss(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const column = this.column;
        const colDef = column.colDef;
        const cellStyle = colDef.cellStyle;
        if (!cellStyle) return;
        let styles;
        if (typeof cellStyle === "function") {
            const cellStyleParams = this.getCellClassParams(column, colDef);
            styles = cellStyle(cellStyleParams);
        } else styles = cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const { column: column, cellComp: cellComp } = this;
        const colDef = column.colDef;
        const cellClassParams = this.getCellClassParams(column, colDef);
        this.staticClasses.forEach((className)=>cellComp.toggleCss(className, false));
        const newStaticClasses = this.beans.cellStyles.getStaticCellClasses(colDef, cellClassParams);
        this.staticClasses = newStaticClasses;
        newStaticClasses.forEach((className)=>cellComp.toggleCss(className, true));
    }
    getCellClassParams(column, colDef) {
        const { value: value, rowNode: rowNode } = this.cellCtrl;
        return $437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.beans.gos, {
            value: value,
            data: rowNode.data,
            node: rowNode,
            colDef: colDef,
            column: column,
            rowIndex: rowNode.rowIndex
        });
    }
};
// packages/ag-grid-community/src/styling/cellStyleService.ts
var $437b23f6a393c3bf$var$CellStyleService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "cellStyles";
    }
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        $437b23f6a393c3bf$var$processClassRules(this.beans.expressionSvc, void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass: cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    createCellCustomStyleFeature(ctrl, beans) {
        return new $437b23f6a393c3bf$var$CellCustomStyleFeature(ctrl, beans);
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
// packages/ag-grid-community/src/styling/stylingModule.ts
var $437b23f6a393c3bf$export$be75c2ed74fb2144 = {
    moduleName: "CellStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$CellStyleService
    ]
};
var $437b23f6a393c3bf$export$dbb09c7a8266fd30 = {
    moduleName: "RowStyle",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowStyleService
    ]
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverApi.ts
function $437b23f6a393c3bf$var$isColumnHovered(beans, column) {
    return !!beans.colHover?.isHovered(column);
}
// packages/ag-grid-community/src/columns/columnHover/hoverFeature.ts
var $437b23f6a393c3bf$var$HoverFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
        this.destroyManagedListeners = [];
        this.enableFeature = (enabled)=>{
            const { beans: beans, gos: gos, element: element, columns: columns } = this;
            const colHover = beans.colHover;
            const active = enabled ?? !!gos.get("columnHoverHighlight");
            if (active) this.destroyManagedListeners = this.addManagedElementListeners(element, {
                mouseover: colHover.setMouseOver.bind(colHover, columns),
                mouseout: colHover.clearMouseOver.bind(colHover)
            });
            else {
                this.destroyManagedListeners.forEach((fn)=>fn());
                this.destroyManagedListeners = [];
            }
        };
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            this.enableFeature(currentValue);
        });
        this.enableFeature();
    }
    destroy() {
        super.destroy();
        this.destroyManagedListeners = null;
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverService.ts
var $437b23f6a393c3bf$var$CSS_COLUMN_HOVER = "ag-column-hover";
var $437b23f6a393c3bf$var$ColumnHoverService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "colHover";
    }
    postConstruct() {
        this.addManagedPropertyListener("columnHoverHighlight", ({ currentValue: currentValue })=>{
            if (!currentValue) this.clearMouseOver();
        });
    }
    setMouseOver(columns) {
        this.updateState(columns);
    }
    clearMouseOver() {
        this.updateState(null);
    }
    isHovered(column) {
        if (!this.gos.get("columnHoverHighlight")) return false;
        const selectedColumns = this.selectedColumns;
        return !!selectedColumns && selectedColumns.indexOf(column) >= 0;
    }
    addHeaderColumnHoverListener(compBean, comp, column) {
        const listener = ()=>{
            const isHovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", isHovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    onCellColumnHover(column, cellComp) {
        if (!cellComp) return;
        const isHovered = this.isHovered(column);
        cellComp.toggleCss($437b23f6a393c3bf$var$CSS_COLUMN_HOVER, isHovered);
    }
    addHeaderFilterColumnHoverListener(compBean, comp, column, eGui) {
        this.createHoverFeature(compBean, [
            column
        ], eGui);
        const listener = ()=>{
            const hovered = this.isHovered(column);
            comp.toggleCss("ag-column-hover", hovered);
        };
        compBean.addManagedEventListeners({
            columnHoverChanged: listener
        });
        listener();
    }
    createHoverFeature(compBean, columns, eGui) {
        compBean.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature(columns, eGui));
    }
    updateState(columns) {
        this.selectedColumns = columns;
        this.eventSvc.dispatchEvent({
            type: "columnHoverChanged"
        });
    }
};
// packages/ag-grid-community/src/columns/columnHover/columnHoverModule.ts
var $437b23f6a393c3bf$export$ca683b579c0df457 = {
    moduleName: "ColumnHover",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$ColumnHoverService
    ],
    apiFunctions: {
        isColumnHovered: $437b23f6a393c3bf$var$isColumnHovered
    }
};
// packages/ag-grid-community/src/misc/apiEvents/apiEventService.ts
var $437b23f6a393c3bf$var$ApiEventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "apiEventSvc";
        this.syncListeners = /* @__PURE__ */ new Map();
        this.asyncListeners = /* @__PURE__ */ new Map();
        this.syncGlobalListeners = /* @__PURE__ */ new Set();
        this.globalListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.wrapSvc = this.beans.frameworkOverrides.createGlobalEventListenerWrapper?.();
    }
    addEventListener(eventType, userListener) {
        const listener = this.wrapSvc?.wrap(eventType, userListener) ?? userListener;
        const async = !$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType);
        const listeners = async ? this.asyncListeners : this.syncListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventSvc.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, userListener) {
        const listener = this.wrapSvc?.unwrap(eventType, userListener) ?? userListener;
        const asyncListeners = this.asyncListeners.get(eventType);
        const hasAsync = !!asyncListeners?.delete(listener);
        if (!hasAsync) this.syncListeners.get(eventType)?.delete(listener);
        this.eventSvc.removeEventListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.wrapSvc?.wrapGlobal(userListener) ?? userListener;
        const syncListener = (eventType, event)=>{
            if ($437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        const asyncListener = (eventType, event)=>{
            if (!$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
        };
        this.globalListenerPairs.set(userListener, {
            syncListener: syncListener,
            asyncListener: asyncListener
        });
        const eventSvc = this.eventSvc;
        eventSvc.addGlobalListener(syncListener, false);
        eventSvc.addGlobalListener(asyncListener, true);
    }
    removeGlobalListener(userListener) {
        const { eventSvc: eventSvc, wrapSvc: wrapSvc, globalListenerPairs: globalListenerPairs } = this;
        const listener = wrapSvc?.unwrapGlobal(userListener) ?? userListener;
        const hasAsync = globalListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener: syncListener, asyncListener: asyncListener } = globalListenerPairs.get(listener);
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
            globalListenerPairs.delete(userListener);
        } else {
            this.syncGlobalListeners.delete(listener);
            eventSvc.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventSvc.removeEventListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        set.forEach((listener)=>this.eventSvc.removeGlobalListener(listener, async));
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncListeners, false);
        this.destroyEventListeners(this.asyncListeners, true);
        this.destroyGlobalListeners(this.syncGlobalListeners, false);
        const { globalListenerPairs: globalListenerPairs, eventSvc: eventSvc } = this;
        globalListenerPairs.forEach(({ syncListener: syncListener, asyncListener: asyncListener })=>{
            eventSvc.removeGlobalListener(syncListener, false);
            eventSvc.removeGlobalListener(asyncListener, true);
        });
        globalListenerPairs.clear();
    }
};
// packages/ag-grid-community/src/misc/apiEvents/eventApi.ts
function $437b23f6a393c3bf$var$addEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.addEventListener(eventType, listener);
}
function $437b23f6a393c3bf$var$removeEventListener(beans, eventType, listener) {
    beans.apiEventSvc?.removeEventListener(eventType, listener);
}
function $437b23f6a393c3bf$var$addGlobalListener(beans, listener) {
    beans.apiEventSvc?.addGlobalListener(listener);
}
function $437b23f6a393c3bf$var$removeGlobalListener(beans, listener) {
    beans.apiEventSvc?.removeGlobalListener(listener);
}
// packages/ag-grid-community/src/misc/apiEvents/apiEventModule.ts
var $437b23f6a393c3bf$export$d20c5df25778eac8 = {
    moduleName: "EventApi",
    version: $437b23f6a393c3bf$var$VERSION,
    apiFunctions: {
        addEventListener: $437b23f6a393c3bf$var$addEventListener,
        addGlobalListener: $437b23f6a393c3bf$var$addGlobalListener,
        removeEventListener: $437b23f6a393c3bf$var$removeEventListener,
        removeGlobalListener: $437b23f6a393c3bf$var$removeGlobalListener
    },
    beans: [
        $437b23f6a393c3bf$var$ApiEventService
    ]
};
// packages/ag-grid-community/src/tooltip/tooltip.css-GENERATED.ts
var $437b23f6a393c3bf$var$tooltipCSS = /*css*/ `.ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);white-space:normal}.ag-tooltip,.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}`;
// packages/ag-grid-community/src/tooltip/tooltipService.ts
var $437b23f6a393c3bf$var$TooltipService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "tooltipSvc";
    }
    setupHeaderTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(this.gos);
        const { column: column, eGui: eGui } = ctrl;
        const colDef = column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$6682c04fc19b3e5e(()=>eGui.querySelector(".ag-header-cell-text"));
        const tooltipCtrl = {
            getColumn: ()=>column,
            getColDef: ()=>column.getColDef(),
            getGui: ()=>eGui,
            getLocation: ()=>"header",
            getTooltipValue: ()=>{
                if (value != null) return value;
                const res = column.getColDef().headerTooltip;
                return res;
            },
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        let tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        if (tooltipFeature) {
            tooltipFeature = ctrl.createBean(tooltipFeature);
            ctrl.setRefreshFunction("tooltip", ()=>tooltipFeature.refreshTooltip());
        }
        return tooltipFeature;
    }
    setupHeaderGroupTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature);
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(this.gos);
        const { column: column, eGui: eGui } = ctrl;
        const colGroupDef = column.getColGroupDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colGroupDef?.headerGroupComponent) shouldDisplayTooltip = $437b23f6a393c3bf$export$6682c04fc19b3e5e(()=>eGui.querySelector(".ag-header-group-text"));
        const tooltipCtrl = {
            getColumn: ()=>column,
            getGui: ()=>eGui,
            getLocation: ()=>"headerGroup",
            getTooltipValue: ()=>value ?? (colGroupDef && colGroupDef.headerTooltip),
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        if (colGroupDef) tooltipCtrl.getColDef = ()=>colGroupDef;
        const tooltipFeature = this.createTooltipFeature(tooltipCtrl);
        return tooltipFeature ? ctrl.createBean(tooltipFeature) : tooltipFeature;
    }
    enableCellTooltipFeature(ctrl, value, shouldDisplayTooltip) {
        const { column: column, rowNode: rowNode } = ctrl;
        const getTooltipValue = ()=>{
            const colDef = column.getColDef();
            const data = rowNode.data;
            if (colDef.tooltipField && $437b23f6a393c3bf$export$25d27f17d3af40f7(data)) return $437b23f6a393c3bf$var$_getValueUsingField(data, colDef.tooltipField, column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter($437b23f6a393c3bf$export$fcfd03fd78c6cf24(this.gos, {
                location: "cell",
                colDef: column.getColDef(),
                column: column,
                rowIndex: ctrl.cellPosition.rowIndex,
                node: rowNode,
                data: rowNode.data,
                value: ctrl.value,
                valueFormatted: ctrl.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = $437b23f6a393c3bf$export$58660753196c7cdf(this.gos);
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !ctrl.isCellRenderer()) shouldDisplayTooltip = $437b23f6a393c3bf$export$6682c04fc19b3e5e(()=>{
            const eCell = ctrl.eGui;
            return eCell.children.length === 0 ? eCell : eCell.querySelector(".ag-cell-value");
        });
        const tooltipCtrl = {
            getColumn: ()=>column,
            getColDef: ()=>column.getColDef(),
            getRowIndex: ()=>ctrl.cellPosition.rowIndex,
            getRowNode: ()=>rowNode,
            getGui: ()=>ctrl.eGui,
            getLocation: ()=>"cell",
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            // this makes no sense, why is the cell formatted value passed to the tooltip???
            getValueFormatted: ()=>ctrl.valueFormatted,
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        return this.createTooltipFeature(tooltipCtrl, this.beans);
    }
    refreshRowTooltip(existingTooltipFeature, ctrl, value, shouldDisplayTooltip) {
        const tooltipParams = {
            getGui: ()=>ctrl.getFullWidthElement(),
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        const beans = this.beans;
        const context = beans.context;
        if (existingTooltipFeature) ctrl.destroyBean(existingTooltipFeature, context);
        const tooltipFeature = this.createTooltipFeature(tooltipParams, beans);
        return ctrl.createBean(tooltipFeature, context);
    }
    initCol(column) {
        const { colDef: colDef } = column;
        column.tooltipEnabled = $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipField) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipValueGetter) || $437b23f6a393c3bf$export$25d27f17d3af40f7(colDef.tooltipComponent);
    }
    createTooltipFeature(tooltipCtrl, beans) {
        return this.beans.registry.createDynamicBean("tooltipFeature", false, tooltipCtrl, beans);
    }
};
// packages/ag-grid-community/src/tooltip/tooltipModule.ts
var $437b23f6a393c3bf$export$d0c662c133b8814e = {
    moduleName: "Tooltip",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$TooltipService
    ],
    dynamicBeans: {
        tooltipFeature: $437b23f6a393c3bf$export$e5073a590d24815c
    },
    userComponents: {
        agTooltipComponent: $437b23f6a393c3bf$var$TooltipComponent2
    },
    dependsOn: [
        $437b23f6a393c3bf$export$da5c9bb998e6c24d
    ],
    css: [
        $437b23f6a393c3bf$var$tooltipCSS
    ]
};
// packages/ag-grid-community/src/misc/locale/localeModule.ts
var $437b23f6a393c3bf$export$77471a542fe056d = {
    moduleName: "Locale",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$export$f325e19d05d9c36d
    ]
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightService.ts
var $437b23f6a393c3bf$var$RowAutoHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.beanName = "rowAutoHeight";
        this.wasEverActive = false;
        this._debouncedCalculateRowHeights = $437b23f6a393c3bf$export$cf7e39bfb94de6e(this, this.calculateRowHeights.bind(this), 1);
    }
    /**
   * If row height has been active, request a refresh of the row heights.
   */ requestCheckAutoHeight() {
        if (!this.wasEverActive) return;
        this._debouncedCalculateRowHeights();
    }
    calculateRowHeights() {
        const { visibleCols: visibleCols, rowModel: rowModel, rowSpanSvc: rowSpanSvc, pinnedRowModel: pinnedRowModel } = this.beans;
        const displayedAutoHeightCols = visibleCols.autoHeightCols;
        let anyNodeChanged = false;
        const updateDisplayedRowHeights = (row)=>{
            const autoHeights = row.__autoHeights;
            let newRowHeight = $437b23f6a393c3bf$export$b6de5fa3decc8f7b(this.beans, row).height;
            for (const col of displayedAutoHeightCols){
                let cellHeight = autoHeights?.[col.getColId()];
                const spannedCell = rowSpanSvc?.getCellSpan(col, row);
                if (spannedCell) {
                    if (spannedCell.getLastNode() !== row) continue;
                    cellHeight = rowSpanSvc?.getCellSpan(col, row)?.getLastNodeAutoHeight();
                    if (!cellHeight) return;
                }
                if (cellHeight == null) {
                    if (this.colSpanSkipCell(col, row)) continue;
                    return;
                }
                newRowHeight = Math.max(cellHeight, newRowHeight);
            }
            if (newRowHeight !== row.rowHeight) {
                row.setRowHeight(newRowHeight);
                anyNodeChanged = true;
            }
        };
        pinnedRowModel?.forEachPinnedRow?.("top", updateDisplayedRowHeights);
        pinnedRowModel?.forEachPinnedRow?.("bottom", updateDisplayedRowHeights);
        rowModel.forEachDisplayedNode?.(updateDisplayedRowHeights);
        if (anyNodeChanged) rowModel.onRowHeightChanged?.();
    }
    /**
   * Set the cell height into the row node, and request a refresh of the row heights if there's been a change.
   * @param rowNode the node to set the auto height on
   * @param cellHeight the height to set, undefined if the cell has just been destroyed
   * @param column the column of the cell
   */ setRowAutoHeight(rowNode, cellHeight, column) {
        rowNode.__autoHeights ?? (rowNode.__autoHeights = {});
        if (cellHeight == void 0) {
            delete rowNode.__autoHeights[column.getId()];
            return;
        }
        const previousCellHeight = rowNode.__autoHeights[column.getId()];
        rowNode.__autoHeights[column.getId()] = cellHeight;
        if (previousCellHeight !== cellHeight) this.requestCheckAutoHeight();
    }
    /**
   * If using col span, then cells which have been spanned over do not need an auto height value
   * @param col the column of the cell
   * @param node the node of the cell
   * @returns whether the row needs auto height value for that column
   */ colSpanSkipCell(col, node) {
        const { colModel: colModel, colViewport: colViewport, visibleCols: visibleCols } = this.beans;
        if (!colModel.colSpanActive) return false;
        let activeColsForRow = [];
        switch(col.getPinned()){
            case "left":
                activeColsForRow = visibleCols.getLeftColsForRow(node);
                break;
            case "right":
                activeColsForRow = visibleCols.getRightColsForRow(node);
                break;
            case null:
                activeColsForRow = colViewport.getColsWithinViewport(node);
                break;
        }
        return !activeColsForRow.includes(col);
    }
    /**
   * If required, sets up observers to continuously measure changes in the cell height.
   * @param cellCtrl the cellCtrl of the cell
   * @param eCellWrapper the HTMLElement to track the height of
   * @param compBean the component bean to add the destroy/cleanup function to
   * @returns whether or not auto height has been set up on this cell
   */ setupCellAutoHeight(cellCtrl, eCellWrapper, compBean) {
        if (!cellCtrl.column.isAutoHeight() || !eCellWrapper) return false;
        this.wasEverActive = true;
        const eParentCell = eCellWrapper.parentElement;
        const { rowNode: rowNode, column: column } = cellCtrl;
        const beans = this.beans;
        const measureHeight = (timesCalled)=>{
            if (cellCtrl.editing) return;
            if (!cellCtrl.isAlive() || !compBean.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$_getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = $437b23f6a393c3bf$export$f63d0991874c6f81(beans);
                const notYetInDom = !doc || !doc.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            this.setRowAutoHeight(rowNode, autoHeight, column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = $437b23f6a393c3bf$export$9aef8476630687be(beans, eCellWrapper, listener);
        compBean.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.setRowAutoHeight(rowNode, void 0, column);
        });
        return true;
    }
    setAutoHeightActive(cols) {
        this.active = cols.list.some((col)=>col.isVisible() && col.isAutoHeight());
    }
    /**
   * Determines if the row auto height service has cells to grow.
   * @returns true if all of the rendered rows are at least as tall as their rendered cells.
   */ areRowsMeasured() {
        if (!this.active) return true;
        const rowCtrls = this.beans.rowRenderer.getAllRowCtrls();
        let renderedAutoHeightCols = null;
        for (const { rowNode: rowNode } of rowCtrls){
            if (!renderedAutoHeightCols || this.beans.colModel.colSpanActive) {
                const renderedCols = this.beans.colViewport.getColsWithinViewport(rowNode);
                renderedAutoHeightCols = renderedCols.filter((col)=>col.isAutoHeight());
            }
            if (renderedAutoHeightCols.length === 0) continue;
            if (!rowNode.__autoHeights) return false;
            for (const col of renderedAutoHeightCols){
                const cellHeight = rowNode.__autoHeights[col.getColId()];
                if (!cellHeight || rowNode.rowHeight < cellHeight) return false;
            }
        }
        return true;
    }
};
// packages/ag-grid-community/src/rendering/row/rowAutoHeightModule.ts
var $437b23f6a393c3bf$export$dd3171a7609a981f = {
    moduleName: "RowAutoHeight",
    version: $437b23f6a393c3bf$var$VERSION,
    beans: [
        $437b23f6a393c3bf$var$RowAutoHeightService
    ]
};
// packages/ag-grid-community/src/allCommunityModule.ts
var $437b23f6a393c3bf$export$526323caf9d1af13 = {
    moduleName: "AllCommunity",
    version: $437b23f6a393c3bf$var$VERSION,
    dependsOn: [
        $437b23f6a393c3bf$export$4c74201d5a94c8e5,
        $437b23f6a393c3bf$export$f744275d8b795fc2,
        $437b23f6a393c3bf$export$ca8341149bdd39bc,
        $437b23f6a393c3bf$export$798770a8f68ba4e7,
        $437b23f6a393c3bf$export$5e6636bea954ad4e,
        $437b23f6a393c3bf$export$9bc83f811986c4f2,
        $437b23f6a393c3bf$export$d1dd3475f4d98a27,
        $437b23f6a393c3bf$export$b6d3a45586965934,
        $437b23f6a393c3bf$export$ccaa44b10c75f1d,
        $437b23f6a393c3bf$export$e1b6b5aa47694f20,
        $437b23f6a393c3bf$export$e1d2707568ed81f6,
        $437b23f6a393c3bf$export$2bb59c6ee8834731,
        $437b23f6a393c3bf$export$5ce3e57cec1fecc9,
        $437b23f6a393c3bf$export$aabcd4399b0469bb,
        $437b23f6a393c3bf$export$2a2721fe06c4c013,
        $437b23f6a393c3bf$export$c992812899d813d0,
        $437b23f6a393c3bf$export$7e8079ed742f8307,
        $437b23f6a393c3bf$export$fc403e59f6fc67b,
        $437b23f6a393c3bf$export$3402149dbbda9537,
        $437b23f6a393c3bf$export$a8c763073927f695,
        $437b23f6a393c3bf$export$a57c5ed18afb0c4,
        $437b23f6a393c3bf$export$5c4abee658e86c68,
        $437b23f6a393c3bf$export$12e9d7df2a270583,
        $437b23f6a393c3bf$export$351f260d7f887abc,
        $437b23f6a393c3bf$export$b67b27f72da743ce,
        $437b23f6a393c3bf$export$baf19ca56ec781d2,
        $437b23f6a393c3bf$export$49c914873cdbe391,
        $437b23f6a393c3bf$export$b6e84cdeabbb116a,
        $437b23f6a393c3bf$export$dae0b5c1ba15d66f,
        $437b23f6a393c3bf$export$3110fedd6be63d8e,
        $437b23f6a393c3bf$export$be75c2ed74fb2144,
        $437b23f6a393c3bf$export$ca683b579c0df457,
        $437b23f6a393c3bf$export$dbb09c7a8266fd30,
        $437b23f6a393c3bf$export$d20c5df25778eac8,
        $437b23f6a393c3bf$export$d7a9d7f5c41fb970,
        $437b23f6a393c3bf$export$98e8472b11750a07,
        $437b23f6a393c3bf$export$d0c662c133b8814e,
        $437b23f6a393c3bf$export$77471a542fe056d,
        $437b23f6a393c3bf$export$dd3171a7609a981f,
        $437b23f6a393c3bf$export$b9bac28848e60126,
        $437b23f6a393c3bf$export$15323dcce1401b05,
        $437b23f6a393c3bf$export$b7ca1fc11bfe19c3
    ]
};


var $c30c6651c4c506e0$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $c30c6651c4c506e0$exports = t();
})($c30c6651c4c506e0$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});




(0, $437b23f6a393c3bf$export$dc053975cc7f6c11).registerModules([
    (0, $437b23f6a393c3bf$export$526323caf9d1af13)
]);
const $e73bf42412feb220$var$API_BASE = 'https://bot.huertomatizado.com/server';
const $e73bf42412feb220$var$API_URL = `${$e73bf42412feb220$var$API_BASE}/api/records`;
const $e73bf42412feb220$var$AUTH_URL = `${$e73bf42412feb220$var$API_BASE}/api/auth`;
const $e73bf42412feb220$var$ACCOUNTS_URL = `${$e73bf42412feb220$var$API_BASE}/api/accounts`;
const $e73bf42412feb220$var$TIPOS = [
    'Saldo_inicial',
    'Venta',
    'Compra',
    'Retiro_dueno'
];
const $e73bf42412feb220$var$CATEGORIAS = [
    'Servicios',
    'Operativo',
    'Viaticos',
    'Retiro'
];
const $e73bf42412feb220$var$CURRENCY_FORMATTER = new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC'
});
class $e73bf42412feb220$var$App {
    constructor(){
        this.rowData = [];
        this.accounts = [];
        this.currentAccountId = null;
        this.gridApi = null;
        this.editingRowId = null;
        this.isAuthenticated = false;
    }
    init() {
        $e73bf42412feb220$var$Auth.init();
        if (localStorage.getItem('app_auth') === 'true') {
            this.showMainContent();
            this.run();
        }
    }
    async run() {
        try {
            this.accounts = await $e73bf42412feb220$var$AccountsApi.fetchAll();
        } catch  {
            this.accounts = [];
        }
        if (this.accounts.length > 0) this.currentAccountId = this.accounts[0].id;
        $e73bf42412feb220$var$Tabs.render(this.accounts, this.currentAccountId);
        await this.loadRecords();
        $e73bf42412feb220$var$Events.setup();
    }
    async loadRecords() {
        try {
            this.rowData = await $e73bf42412feb220$var$RecordsApi.fetchAll(this.currentAccountId);
        } catch  {
            alert('No se pudo conectar con el servidor');
            this.rowData = [];
        }
        $e73bf42412feb220$var$Filters.init(this.rowData);
        if (this.gridApi) {
            this.gridApi.setGridOption('rowData', this.rowData);
            $e73bf42412feb220$var$Summary.update(this.rowData);
        } else {
            $e73bf42412feb220$var$Grid.init(this.rowData);
            $e73bf42412feb220$var$Summary.update(this.rowData);
        }
        // Auto-seleccionar mes actual y filtrar summary + grid
        $e73bf42412feb220$var$Filters.selectCurrentMonth();
    }
    async switchAccount(accountId) {
        this.currentAccountId = accountId;
        const account = this.accounts.find((a)=>a.id === accountId);
        $e73bf42412feb220$var$Tabs.setActive(accountId);
        $e73bf42412feb220$var$Tabs.applyColor(account?.color || '#00d1b2');
        await this.loadRecords();
    }
    showMainContent() {
        $e73bf42412feb220$var$DOM.hide('pin-screen');
        $e73bf42412feb220$var$DOM.show('main-content');
    }
}
class $e73bf42412feb220$var$DOM {
    static show(id, display = 'block') {
        const el = document.getElementById(id);
        if (el) el.style.display = display;
    }
    static hide = (id)=>this.show(id, 'none');
    static addClass(id, className) {
        const el = document.getElementById(id);
        if (el) el.classList.add(className);
    }
    static removeClass(id, className) {
        const el = document.getElementById(id);
        if (el) el.classList.remove(className);
    }
    static setText(id, text) {
        const el = document.getElementById(id);
        if (el) el.textContent = text;
    }
    static getValue(id) {
        const el = document.getElementById(id);
        return el ? el.value : '';
    }
    static setValue(id, value) {
        const el = document.getElementById(id);
        if (el) el.value = value;
    }
}
class $e73bf42412feb220$var$Formatters {
    static currency(value) {
        return $e73bf42412feb220$var$CURRENCY_FORMATTER.format(value);
    }
    static parseAmount(val) {
        if (val === null || val === undefined || val === '') return 0;
        return parseFloat(String(val).replace(/,/g, '').replace(/\s/g, '')) || 0;
    }
    static formatDate(value) {
        if (!value) return '';
        const d = new Date(value + 'T00:00:00');
        return d.toLocaleDateString('es-CR');
    }
    static moneyCell = (p)=>this.parseAmount(p.value) > 0 ? this.currency(this.parseAmount(p.value)) : '';
    static moneyStyle = ()=>({
            fontWeight: '600',
            color: '#2e7d32'
        });
    static expenseStyle = ()=>({
            fontWeight: '600',
            color: '#c62828'
        });
    static balanceStyle = (p)=>({
            fontWeight: '600',
            color: this.parseAmount(p.value) >= 0 ? '#1565c0' : '#c62828'
        });
    static saldoCell = (p)=>p.value !== '' && p.value !== null ? this.currency(this.parseAmount(p.value)) : '';
}
class $e73bf42412feb220$var$Auth {
    static init() {
        const pinInput = document.getElementById('pin-input');
        const pinSubmit = document.getElementById('btn-pin-submit');
        const requestBtn = document.getElementById('btn-request-code');
        requestBtn.addEventListener('click', async ()=>this.handleRequestCode(requestBtn, pinInput));
        pinInput.addEventListener('keypress', (e)=>{
            if (e.key === 'Enter') pinSubmit.click();
        });
        pinSubmit.addEventListener('click', async ()=>this.handlePinSubmit(pinInput, pinSubmit));
    }
    static async handleRequestCode(btn, input) {
        btn.disabled = true;
        btn.textContent = 'Enviando...';
        try {
            const result = await $e73bf42412feb220$var$AuthApi.requestCode();
            if (result.success) {
                $e73bf42412feb220$var$DOM.show('code-sent');
                $e73bf42412feb220$var$DOM.hide('pin-error');
                input.focus();
            } else {
                $e73bf42412feb220$var$DOM.setText('pin-error', result.error || 'Error al enviar PIN');
                $e73bf42412feb220$var$DOM.show('pin-error');
            }
        } catch (err) {
            $e73bf42412feb220$var$DOM.setText('pin-error', "Error de conexi\xf3n");
            $e73bf42412feb220$var$DOM.show('pin-error');
        } finally{
            btn.disabled = false;
            btn.textContent = 'Solicitar PIN';
        }
    }
    static async handlePinSubmit(input, btn) {
        const code = input.value.trim();
        if (code.length !== 6 || !/^\d+$/.test(code)) {
            $e73bf42412feb220$var$DOM.setText('pin-error', "El PIN debe tener 6 d\xedgitos");
            $e73bf42412feb220$var$DOM.show('pin-error');
            return;
        }
        btn.disabled = true;
        btn.textContent = 'Validando...';
        try {
            const valid = await $e73bf42412feb220$var$AuthApi.validatePin(code);
            if (valid) {
                localStorage.setItem('app_auth', 'true');
                $e73bf42412feb220$var$app.showMainContent();
                $e73bf42412feb220$var$app.run();
            } else {
                $e73bf42412feb220$var$DOM.setText('pin-error', 'PIN incorrecto o expirado');
                $e73bf42412feb220$var$DOM.show('pin-error');
                input.value = '';
                input.focus();
            }
        } catch (err) {
            $e73bf42412feb220$var$DOM.setText('pin-error', "Error de conexi\xf3n");
            $e73bf42412feb220$var$DOM.show('pin-error');
        } finally{
            btn.disabled = false;
            btn.textContent = 'Entrar';
        }
    }
}
class $e73bf42412feb220$var$RecordsApi {
    static async fetchAll(accountId = null) {
        const url = accountId ? `${$e73bf42412feb220$var$API_URL}?account_id=${accountId}` : $e73bf42412feb220$var$API_URL;
        const data = await this.request(url);
        return data.map(this.normalizeRecord);
    }
    static async create(record) {
        return this.normalizeRecord(await this.request($e73bf42412feb220$var$API_URL, {
            method: 'POST',
            body: JSON.stringify(record)
        }));
    }
    static async update(id, record) {
        return this.normalizeRecord(await this.request(`${$e73bf42412feb220$var$API_URL}/${id}`, {
            method: 'PUT',
            body: JSON.stringify(record)
        }));
    }
    static async delete(ids) {
        return this.request($e73bf42412feb220$var$API_URL, {
            method: 'DELETE',
            body: JSON.stringify({
                ids: ids
            })
        });
    }
    static async bulkCreate(records) {
        const data = await this.request(`${$e73bf42412feb220$var$API_URL}/bulk`, {
            method: 'POST',
            body: JSON.stringify({
                records: records
            })
        });
        return data.map(this.normalizeRecord);
    }
    static async request(url, options = {}) {
        const res = await fetch(url, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Error en la solicitud');
        }
        return res.json();
    }
    static normalizeRecord(r) {
        return {
            ...r,
            ingreso: $e73bf42412feb220$var$Formatters.parseAmount(r.ingreso),
            gasto: $e73bf42412feb220$var$Formatters.parseAmount(r.gasto),
            saldo: $e73bf42412feb220$var$Formatters.parseAmount(r.saldo)
        };
    }
}
class $e73bf42412feb220$var$AuthApi {
    static async requestCode() {
        const res = await fetch(`${$e73bf42412feb220$var$AUTH_URL}/request`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return res.json();
    }
    static async validatePin(code) {
        const res = await fetch($e73bf42412feb220$var$AUTH_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: code
            })
        });
        const data = await res.json();
        return data.authenticated === true;
    }
}
class $e73bf42412feb220$var$AccountsApi {
    static async fetchAll() {
        const res = await fetch($e73bf42412feb220$var$ACCOUNTS_URL);
        return res.json();
    }
    static async create(name, color) {
        const res = await fetch($e73bf42412feb220$var$ACCOUNTS_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name,
                color: color
            })
        });
        if (!res.ok) throw new Error('Error creando cuenta');
        return res.json();
    }
    static async update(id, name, color) {
        const res = await fetch(`${$e73bf42412feb220$var$ACCOUNTS_URL}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name,
                color: color
            })
        });
        if (!res.ok) throw new Error('Error actualizando cuenta');
        return res.json();
    }
    static async delete(id) {
        const res = await fetch(`${$e73bf42412feb220$var$ACCOUNTS_URL}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Error eliminando cuenta');
        }
        return res.json();
    }
}
class $e73bf42412feb220$var$Tabs {
    static render(accounts, activeId) {
        const container = document.getElementById('accounts-tabs');
        if (!container) return;
        container.innerHTML = '';
        accounts.forEach((acc)=>{
            const li = document.createElement('li');
            li.dataset.id = acc.id;
            if (acc.id === activeId) li.classList.add('is-active');
            const a = document.createElement('a');
            a.textContent = acc.name;
            if (acc.id === activeId) {
                a.style.borderBottomColor = acc.color;
                a.style.color = acc.color;
            }
            a.addEventListener('click', ()=>$e73bf42412feb220$var$app.switchAccount(acc.id));
            // Right-click to rename/delete
            a.addEventListener('contextmenu', (e)=>{
                e.preventDefault();
                $e73bf42412feb220$var$Tabs.openAccountMenu(acc);
            });
            li.appendChild(a);
            container.appendChild(li);
        });
        // "+" button
        const addLi = document.createElement('li');
        const addA = document.createElement('a');
        addA.innerHTML = '<strong>+</strong>';
        addA.title = 'Nueva cuenta';
        addA.addEventListener('click', ()=>$e73bf42412feb220$var$Tabs.openNewAccountModal());
        addLi.appendChild(addA);
        container.appendChild(addLi);
        // Apply color of active account
        const active = accounts.find((a)=>a.id === activeId);
        if (active) $e73bf42412feb220$var$Tabs.applyColor(active.color);
    }
    static setActive(accountId) {
        document.querySelectorAll('#accounts-tabs li').forEach((li)=>{
            const isActive = parseInt(li.dataset.id) === accountId;
            li.classList.toggle('is-active', isActive);
            const a = li.querySelector('a');
            if (a && li.dataset.id) {
                const acc = $e73bf42412feb220$var$app.accounts.find((ac)=>ac.id === parseInt(li.dataset.id));
                a.style.borderBottomColor = isActive ? acc?.color || '' : '';
                a.style.color = isActive ? acc?.color || '' : '';
            }
        });
    }
    static applyColor(color) {
        document.documentElement.style.setProperty('--account-color', color);
    }
    static openNewAccountModal() {
        $e73bf42412feb220$var$DOM.show('account-modal');
        document.getElementById('account-modal-title').textContent = 'Nueva cuenta';
        document.getElementById('account-form').reset();
        document.getElementById('account-color').value = '#00d1b2';
        $e73bf42412feb220$var$app._editingAccountId = null;
    }
    static openAccountMenu(acc) {
        const action = prompt(`Cuenta: "${acc.name}"\n\nEscribe "renombrar" o "eliminar":`);
        if (!action) return;
        if (action.toLowerCase() === 'renombrar') {
            const newName = prompt('Nuevo nombre:', acc.name);
            if (newName && newName.trim()) $e73bf42412feb220$var$AccountsApi.update(acc.id, newName.trim(), acc.color).then((updated)=>{
                const idx = $e73bf42412feb220$var$app.accounts.findIndex((a)=>a.id === acc.id);
                if (idx !== -1) $e73bf42412feb220$var$app.accounts[idx] = updated;
                $e73bf42412feb220$var$Tabs.render($e73bf42412feb220$var$app.accounts, $e73bf42412feb220$var$app.currentAccountId);
            }).catch((e)=>alert(e.message));
        } else if (action.toLowerCase() === 'eliminar') {
            if (confirm(`\xbfEliminar cuenta "${acc.name}"? Sus registros quedar\xe1n sin cuenta.`)) $e73bf42412feb220$var$AccountsApi.delete(acc.id).then(()=>{
                $e73bf42412feb220$var$app.accounts = $e73bf42412feb220$var$app.accounts.filter((a)=>a.id !== acc.id);
                if ($e73bf42412feb220$var$app.currentAccountId === acc.id) $e73bf42412feb220$var$app.currentAccountId = $e73bf42412feb220$var$app.accounts[0]?.id || null;
                $e73bf42412feb220$var$Tabs.render($e73bf42412feb220$var$app.accounts, $e73bf42412feb220$var$app.currentAccountId);
                $e73bf42412feb220$var$app.loadRecords();
            }).catch((e)=>alert(e.message));
        }
    }
    static async saveAccount() {
        const name = document.getElementById('account-name').value.trim();
        const color = document.getElementById('account-color').value;
        if (!name) {
            alert('Nombre requerido');
            return;
        }
        try {
            if ($e73bf42412feb220$var$app._editingAccountId) {
                const updated = await $e73bf42412feb220$var$AccountsApi.update($e73bf42412feb220$var$app._editingAccountId, name, color);
                const idx = $e73bf42412feb220$var$app.accounts.findIndex((a)=>a.id === $e73bf42412feb220$var$app._editingAccountId);
                if (idx !== -1) $e73bf42412feb220$var$app.accounts[idx] = updated;
            } else {
                const created = await $e73bf42412feb220$var$AccountsApi.create(name, color);
                $e73bf42412feb220$var$app.accounts.push(created);
                $e73bf42412feb220$var$app.currentAccountId = created.id;
            }
            $e73bf42412feb220$var$DOM.hide('account-modal');
            $e73bf42412feb220$var$Tabs.render($e73bf42412feb220$var$app.accounts, $e73bf42412feb220$var$app.currentAccountId);
            $e73bf42412feb220$var$app.loadRecords();
        } catch (e) {
            alert(e.message);
        }
    }
}
class $e73bf42412feb220$var$DatePickerEditor {
    init(params) {
        this.params = params;
        this.originalValue = params.value;
        this.value = params.value;
        this.container = document.createElement('div');
        this.container.className = 'date-picker-editor';
        this.input = document.createElement('input');
        this.input.type = 'date';
        this.input.value = params.value || '';
        this.input.className = 'date-picker-input';
        const btnRow = document.createElement('div');
        btnRow.className = 'date-picker-actions';
        this.applyBtn = document.createElement('button');
        this.applyBtn.textContent = 'Apply';
        this.applyBtn.className = 'button is-primary is-small';
        this.cancelBtn = document.createElement('button');
        this.cancelBtn.textContent = 'Cancel';
        this.cancelBtn.className = 'button is-light is-small';
        this.statusEl = document.createElement('span');
        this.statusEl.className = 'date-picker-status';
        this.applyBtn.addEventListener('click', ()=>this._apply());
        this.cancelBtn.addEventListener('click', ()=>params.stopEditing(true));
        btnRow.appendChild(this.applyBtn);
        btnRow.appendChild(this.cancelBtn);
        this.container.appendChild(this.input);
        this.container.appendChild(btnRow);
        this.container.appendChild(this.statusEl);
    }
    async _apply() {
        const newDate = this.input.value;
        if (!newDate) return;
        if (newDate === this.originalValue) {
            this.params.stopEditing(true);
            return;
        }
        this.applyBtn.disabled = true;
        this.applyBtn.textContent = '...';
        this.statusEl.textContent = '';
        try {
            const data = this.params.data;
            const updated = await $e73bf42412feb220$var$RecordsApi.update(data.id, {
                ...data,
                fecha: newDate
            });
            this.value = newDate;
            $e73bf42412feb220$var$Grid.updateRow(data, updated);
            this.params.stopEditing();
        } catch (err) {
            this.statusEl.textContent = "\u26A0\uFE0F Error al guardar";
            this.applyBtn.disabled = false;
            this.applyBtn.textContent = 'Apply';
        }
    }
    getGui() {
        return this.container;
    }
    getValue() {
        return this.value;
    }
    afterGuiAttached() {
        this.input.focus();
    }
    isCancelAfterEnd() {
        return true;
    }
}
const $e73bf42412feb220$var$GridColumns = {
    tipoTagMap: {
        Venta: 'tag is-success is-light',
        Compra: 'tag is-danger is-light',
        Saldo_inicial: 'tag is-info is-light',
        Retiro_dueno: 'tag is-warning is-light'
    },
    categoriaColors: {
        Servicios: {
            background: '#e0f7fa',
            color: '#006064'
        },
        Operativo: {
            background: '#e8f4fd',
            color: '#1565c0'
        },
        Viaticos: {
            background: '#fff3e0',
            color: '#e65100'
        },
        Retiro: {
            background: '#fce4ec',
            color: '#880e4f'
        }
    },
    getColumns () {
        return [
            {
                field: 'id',
                headerName: '#',
                width: 65,
                pinned: 'left',
                sortable: true,
                filter: false,
                checkboxSelection: true,
                headerCheckboxSelection: true
            },
            {
                field: 'fecha',
                headerName: 'Fecha',
                width: 120,
                sortable: true,
                filter: 'agDateColumnFilter',
                valueFormatter: (p)=>$e73bf42412feb220$var$Formatters.formatDate(p.value),
                editable: true,
                cellEditor: $e73bf42412feb220$var$DatePickerEditor,
                cellEditorPopup: true,
                cellClass: 'fecha-editable'
            },
            {
                field: 'tipo',
                headerName: 'Tipo',
                width: 140,
                sortable: true,
                filter: 'agTextColumnFilter',
                cellRenderer: (p)=>`<span class="${this.tipoTagMap[p.value] || 'tag is-light'}">${p.value || ''}</span>`
            },
            {
                field: 'categoria',
                headerName: "Categor\xeda",
                width: 130,
                sortable: true,
                filter: 'agTextColumnFilter',
                cellStyle: (p)=>this.categoriaColors[p.value] || null
            },
            {
                field: 'concepto',
                headerName: 'Concepto',
                flex: 1,
                minWidth: 180,
                sortable: true,
                filter: 'agTextColumnFilter',
                tooltipField: 'concepto'
            },
            {
                field: 'moneda',
                headerName: 'Moneda',
                width: 90,
                sortable: true,
                filter: 'agTextColumnFilter'
            },
            {
                field: 'ingreso',
                headerName: 'Ingreso',
                width: 140,
                sortable: true,
                filter: 'agNumberColumnFilter',
                type: 'rightAligned',
                valueFormatter: $e73bf42412feb220$var$Formatters.moneyCell,
                cellStyle: $e73bf42412feb220$var$Formatters.moneyStyle
            },
            {
                field: 'gasto',
                headerName: 'Gasto',
                width: 140,
                sortable: true,
                filter: 'agNumberColumnFilter',
                type: 'rightAligned',
                valueFormatter: $e73bf42412feb220$var$Formatters.moneyCell,
                cellStyle: $e73bf42412feb220$var$Formatters.expenseStyle
            },
            {
                field: 'medio_de_pago',
                headerName: 'Medio de pago',
                width: 140,
                sortable: true,
                filter: 'agTextColumnFilter'
            },
            {
                field: 'saldo',
                headerName: 'Saldo',
                width: 150,
                sortable: true,
                filter: 'agNumberColumnFilter',
                type: 'rightAligned',
                valueFormatter: $e73bf42412feb220$var$Formatters.saldoCell,
                cellStyle: $e73bf42412feb220$var$Formatters.balanceStyle
            },
            {
                headerName: 'Acciones',
                width: 110,
                sortable: false,
                filter: false,
                pinned: 'right',
                cellRenderer: (p)=>{
                    const btn = document.createElement('button');
                    btn.className = 'button is-warning is-small';
                    btn.textContent = 'Editar';
                    btn.addEventListener('click', ()=>$e73bf42412feb220$var$Modals.openEdit(p.data));
                    return btn;
                }
            }
        ];
    }
};
class $e73bf42412feb220$var$Grid {
    static init(rowData) {
        const gridDiv = document.querySelector('#myGrid');
        const gridOptions = {
            columnDefs: $e73bf42412feb220$var$GridColumns.getColumns(),
            rowData: rowData,
            getRowId: (params)=>String(params.data.id),
            rowSelection: {
                mode: 'multiRow'
            },
            defaultColDef: {
                resizable: true
            },
            animateRows: true,
            pagination: true,
            paginationPageSize: 20,
            paginationPageSizeSelector: [
                10,
                20,
                50,
                100
            ],
            enableCellTextSelection: true,
            onSelectionChanged: ()=>{
                const selected = $e73bf42412feb220$var$app.gridApi.getSelectedRows();
                document.getElementById('btn-delete-row').disabled = selected.length === 0;
            }
        };
        $e73bf42412feb220$var$app.gridApi = (0, $437b23f6a393c3bf$export$fce123c48a7b4eae)(gridDiv, gridOptions);
    }
    static updateRow(row, data) {
        const idx = $e73bf42412feb220$var$app.rowData.findIndex((r)=>r.id === row.id);
        if (idx !== -1) $e73bf42412feb220$var$app.rowData[idx] = data;
        $e73bf42412feb220$var$app.gridApi.applyTransaction({
            update: [
                data
            ]
        });
    }
    static addRows(rows) {
        $e73bf42412feb220$var$app.rowData.push(...rows);
        $e73bf42412feb220$var$app.gridApi.applyTransaction({
            add: rows
        });
    }
    static removeRows(rows) {
        const idSet = new Set(rows.map((r)=>r.id));
        $e73bf42412feb220$var$app.rowData = $e73bf42412feb220$var$app.rowData.filter((r)=>!idSet.has(r.id));
        $e73bf42412feb220$var$app.gridApi.applyTransaction({
            remove: rows
        });
    }
}
class $e73bf42412feb220$var$Modals {
    static openAdd() {
        $e73bf42412feb220$var$app.editingRowId = null;
        $e73bf42412feb220$var$DOM.setText('modal-title', 'Nuevo Registro');
        document.getElementById('record-form').reset();
        $e73bf42412feb220$var$DOM.setValue('form-fecha', new Date().toISOString().split('T')[0]);
        $e73bf42412feb220$var$DOM.setValue('form-moneda', 'CRC');
        $e73bf42412feb220$var$DOM.addClass('record-modal', 'is-active');
    }
    static openEdit(data) {
        $e73bf42412feb220$var$app.editingRowId = data.id;
        $e73bf42412feb220$var$DOM.setText('modal-title', 'Editar Registro');
        $e73bf42412feb220$var$DOM.setValue('form-fecha', data.fecha);
        $e73bf42412feb220$var$DOM.setValue('form-tipo', data.tipo);
        $e73bf42412feb220$var$DOM.setValue('form-categoria', data.categoria);
        $e73bf42412feb220$var$DOM.setValue('form-concepto', data.concepto);
        $e73bf42412feb220$var$DOM.setValue('form-moneda', data.moneda);
        $e73bf42412feb220$var$DOM.setValue('form-ingreso', data.ingreso || '');
        $e73bf42412feb220$var$DOM.setValue('form-gasto', data.gasto || '');
        $e73bf42412feb220$var$DOM.setValue('form-medio-pago', data.medio_de_pago);
        $e73bf42412feb220$var$DOM.setValue('form-saldo', data.saldo !== undefined ? data.saldo : '');
        $e73bf42412feb220$var$DOM.addClass('record-modal', 'is-active');
    }
    static close() {
        $e73bf42412feb220$var$DOM.removeClass('record-modal', 'is-active');
        $e73bf42412feb220$var$app.editingRowId = null;
    }
    static getFormData() {
        return {
            fecha: $e73bf42412feb220$var$DOM.getValue('form-fecha'),
            tipo: $e73bf42412feb220$var$DOM.getValue('form-tipo'),
            categoria: $e73bf42412feb220$var$DOM.getValue('form-categoria'),
            concepto: $e73bf42412feb220$var$DOM.getValue('form-concepto').trim(),
            moneda: $e73bf42412feb220$var$DOM.getValue('form-moneda'),
            ingreso: $e73bf42412feb220$var$Formatters.parseAmount($e73bf42412feb220$var$DOM.getValue('form-ingreso')),
            gasto: $e73bf42412feb220$var$Formatters.parseAmount($e73bf42412feb220$var$DOM.getValue('form-gasto')),
            medio_de_pago: $e73bf42412feb220$var$DOM.getValue('form-medio-pago'),
            saldo: $e73bf42412feb220$var$Formatters.parseAmount($e73bf42412feb220$var$DOM.getValue('form-saldo')),
            account_id: $e73bf42412feb220$var$app.currentAccountId
        };
    }
    static async save() {
        const form = document.getElementById('record-form');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const recordData = this.getFormData();
        try {
            if ($e73bf42412feb220$var$app.editingRowId !== null) {
                const updated = await $e73bf42412feb220$var$RecordsApi.update($e73bf42412feb220$var$app.editingRowId, recordData);
                $e73bf42412feb220$var$Grid.updateRow({
                    id: $e73bf42412feb220$var$app.editingRowId
                }, updated);
            } else {
                const created = await $e73bf42412feb220$var$RecordsApi.create(recordData);
                $e73bf42412feb220$var$Grid.addRows([
                    created
                ]);
            }
            $e73bf42412feb220$var$Summary.update($e73bf42412feb220$var$app.rowData);
            this.close();
        } catch (err) {
            const msg = err.message.toLowerCase();
            if (msg.includes('not found') || msg.includes('no encontrado') || msg.includes('404')) {
                alert("El registro ya no existe en el servidor. Por favor, recarga la p\xe1gina.");
                $e73bf42412feb220$var$app.rowData = await $e73bf42412feb220$var$RecordsApi.fetchAll();
                $e73bf42412feb220$var$app.gridApi.setGridOption('rowData', $e73bf42412feb220$var$app.rowData);
                $e73bf42412feb220$var$Summary.update($e73bf42412feb220$var$app.rowData);
            } else alert('Error al guardar: ' + err.message);
        }
    }
}
class $e73bf42412feb220$var$Actions {
    static async deleteSelected() {
        const selected = $e73bf42412feb220$var$app.gridApi.getSelectedRows();
        if (selected.length === 0) return;
        if (!confirm(`\xbfEliminar ${selected.length} registro(s)?`)) return;
        const ids = selected.map((r)=>r.id);
        try {
            await $e73bf42412feb220$var$RecordsApi.delete(ids);
            $e73bf42412feb220$var$Grid.removeRows(selected);
            $e73bf42412feb220$var$Summary.update($e73bf42412feb220$var$app.rowData);
            document.getElementById('btn-delete-row').disabled = true;
        } catch (err) {
            alert('Error al eliminar: ' + err.message);
        }
    }
    static exportCSV() {
        const exportData = $e73bf42412feb220$var$app.rowData.map(({ id: _id, created_at: _ca, ...r })=>({
                Fecha: r.fecha,
                Tipo: r.tipo,
                Categoria: r.categoria,
                Concepto: r.concepto,
                Moneda: r.moneda,
                Ingreso: r.ingreso || '',
                Gasto: r.gasto || '',
                Medio_de_pago: r.medio_de_pago,
                Saldo: r.saldo !== undefined ? r.saldo : ''
            }));
        const csv = (0, (/*@__PURE__*/$parcel$interopDefault($c30c6651c4c506e0$exports))).unparse(exportData, {
            header: true
        });
        const blob = new Blob([
            csv
        ], {
            type: 'text/csv;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `registros_${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }
    static importCSV(file) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c30c6651c4c506e0$exports))).parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async (result)=>{
                const newRows = result.data.map((row)=>({
                        fecha: row['Fecha'] || row['fecha'] || '',
                        tipo: row['Tipo'] || row['tipo'] || '',
                        categoria: row['Categoria'] || row['categoria'] || '',
                        concepto: row['Concepto'] || row['concepto'] || '',
                        moneda: row['Moneda'] || row['moneda'] || 'CRC',
                        ingreso: $e73bf42412feb220$var$Formatters.parseAmount(row['Ingreso'] || row['ingreso']),
                        gasto: $e73bf42412feb220$var$Formatters.parseAmount(row['Gasto'] || row['gasto']),
                        medio_de_pago: row['Medio_de_pago'] || row['medio_de_pago'] || '',
                        saldo: $e73bf42412feb220$var$Formatters.parseAmount(row['Saldo'] || row['saldo'])
                    }));
                try {
                    const created = await $e73bf42412feb220$var$RecordsApi.bulkCreate(newRows);
                    $e73bf42412feb220$var$Grid.addRows(created);
                    $e73bf42412feb220$var$Summary.update($e73bf42412feb220$var$app.rowData);
                } catch (err) {
                    alert('Error al importar CSV: ' + err.message);
                }
            }
        });
    }
}
class $e73bf42412feb220$var$Summary {
    static update(rowData) {
        const totalIngreso = rowData.reduce((sum, r)=>sum + $e73bf42412feb220$var$Formatters.parseAmount(r.ingreso), 0);
        const totalGasto = rowData.reduce((sum, r)=>sum + $e73bf42412feb220$var$Formatters.parseAmount(r.gasto), 0);
        const balance = totalIngreso - totalGasto;
        $e73bf42412feb220$var$DOM.setText('total-ingreso', $e73bf42412feb220$var$Formatters.currency(totalIngreso));
        $e73bf42412feb220$var$DOM.setText('total-gasto', $e73bf42412feb220$var$Formatters.currency(totalGasto));
        $e73bf42412feb220$var$DOM.setText('total-records', rowData.length);
        $e73bf42412feb220$var$DOM.setText('balance', $e73bf42412feb220$var$Formatters.currency(balance));
        const balanceEl = document.getElementById('balance');
        balanceEl.className = 'title is-4 ' + (balance >= 0 ? 'has-text-success' : 'has-text-danger');
    }
}
class $e73bf42412feb220$var$Filters {
    static init(rowData) {
        this.populateSelect('filter-tipo', $e73bf42412feb220$var$TIPOS);
        this.populateSelect('filter-categoria', $e73bf42412feb220$var$CATEGORIAS);
        this.populateMesFilter(rowData);
    }
    static populateSelect(selectId, options) {
        const select = document.getElementById(selectId);
        if (!select) return;
        select.innerHTML = '';
        options.forEach((opt)=>{
            const option = document.createElement('option');
            option.value = opt;
            option.textContent = opt;
            select.appendChild(option);
        });
    }
    static populateMesFilter(rowData) {
        const mesesUnicos = new Set();
        rowData.forEach((r)=>{
            if (r.fecha) {
                const d = new Date(r.fecha + 'T00:00:00');
                if (!isNaN(d)) {
                    const mes = d.toLocaleDateString('es-CR', {
                        month: 'short'
                    }).replace('.', '');
                    const anio = d.getFullYear().toString().slice(-2);
                    mesesUnicos.add(`${mes.toLowerCase()}-${anio}`);
                }
            }
        });
        const mesesOrder = [
            'ene',
            'feb',
            'mar',
            'abr',
            'may',
            'jun',
            'jul',
            'ago',
            'sep',
            'oct',
            'nov',
            'dic'
        ];
        const mesesOrdenados = Array.from(mesesUnicos).sort((a, b)=>{
            const [mesA, anioA] = a.split('-');
            const [mesB, anioB] = b.split('-');
            const ordenA = parseInt(anioA) * 100 + mesesOrder.indexOf(mesA);
            const ordenB = parseInt(anioB) * 100 + mesesOrder.indexOf(mesB);
            return ordenA - ordenB;
        });
        const select = document.getElementById('filter-mes');
        if (!select) return;
        select.innerHTML = '';
        // Primera opción: Todo
        const allOpt = document.createElement('option');
        allOpt.value = '';
        allOpt.textContent = 'Todo';
        select.appendChild(allOpt);
        mesesOrdenados.forEach((m)=>{
            const opt = document.createElement('option');
            opt.value = m;
            opt.textContent = m.charAt(0).toUpperCase() + m.slice(1);
            select.appendChild(opt);
        });
    }
    static selectCurrentMonth() {
        const select = document.getElementById('filter-mes');
        if (!select) return;
        const now = new Date();
        const mes = now.toLocaleDateString('es-CR', {
            month: 'short'
        }).replace('.', '').toLowerCase();
        const anio = now.getFullYear().toString().slice(-2);
        const current = `${mes}-${anio}`;
        const match = Array.from(select.options).find((o)=>o.value === current);
        if (match) {
            select.value = current;
            select.dispatchEvent(new Event('change'));
        }
    }
}
class $e73bf42412feb220$var$Events {
    static setup() {
        const qf = document.getElementById('quick-filter');
        qf.addEventListener('input', ()=>$e73bf42412feb220$var$app.gridApi.setGridOption('quickFilterText', qf.value));
        document.getElementById('btn-clear-filter').addEventListener('click', ()=>{
            qf.value = '';
            $e73bf42412feb220$var$app.gridApi.setGridOption('quickFilterText', '');
            document.getElementById('filter-tipo').value = '';
            document.getElementById('filter-categoria').value = '';
            document.getElementById('filter-mes').value = '';
            $e73bf42412feb220$var$app.gridApi.setFilterModel(null);
        });
        this.setupSelectFilter('filter-tipo', 'tipo');
        this.setupSelectFilter('filter-categoria', 'categoria');
        this.setupMesFilter();
        document.getElementById('btn-add-row').addEventListener('click', $e73bf42412feb220$var$Modals.openAdd);
        document.getElementById('btn-delete-row').addEventListener('click', $e73bf42412feb220$var$Actions.deleteSelected);
        document.getElementById('modal-close').addEventListener('click', $e73bf42412feb220$var$Modals.close);
        document.getElementById('btn-cancel-modal').addEventListener('click', $e73bf42412feb220$var$Modals.close);
        document.getElementById('btn-save-record').addEventListener('click', ()=>$e73bf42412feb220$var$Modals.save());
        document.querySelector('.modal-background').addEventListener('click', $e73bf42412feb220$var$Modals.close);
        document.getElementById('btn-export-csv').addEventListener('click', $e73bf42412feb220$var$Actions.exportCSV);
        // Account modal events
        document.getElementById('btn-save-account').addEventListener('click', ()=>$e73bf42412feb220$var$Tabs.saveAccount());
        document.getElementById('btn-cancel-account').addEventListener('click', ()=>$e73bf42412feb220$var$DOM.hide('account-modal'));
        document.getElementById('account-modal-close').addEventListener('click', ()=>$e73bf42412feb220$var$DOM.hide('account-modal'));
        document.getElementById('account-modal-bg').addEventListener('click', ()=>$e73bf42412feb220$var$DOM.hide('account-modal'));
        document.getElementById('btn-import-csv').addEventListener('click', ()=>document.getElementById('file-import').click());
        document.getElementById('file-import').addEventListener('change', (e)=>{
            if (e.target.files[0]) {
                $e73bf42412feb220$var$Actions.importCSV(e.target.files[0]);
                e.target.value = '';
            }
        });
    }
    static setupSelectFilter(selectId, field) {
        document.getElementById(selectId).addEventListener('change', (e)=>{
            if (e.target.value) $e73bf42412feb220$var$app.gridApi.setFilterModel({
                [field]: {
                    filterType: 'text',
                    type: 'equals',
                    filter: e.target.value
                }
            });
            else {
                const current = $e73bf42412feb220$var$app.gridApi.getFilterModel();
                delete current[field];
                $e73bf42412feb220$var$app.gridApi.setFilterModel(current);
            }
        });
    }
    static setupMesFilter() {
        document.getElementById('filter-mes').addEventListener('change', (e)=>{
            const mesSeleccionado = e.target.value;
            const mesesIndex = {
                ene: '01',
                feb: '02',
                mar: '03',
                abr: '04',
                may: '05',
                jun: '06',
                jul: '07',
                ago: '08',
                sep: '09',
                oct: '10',
                nov: '11',
                dic: '12'
            };
            if (mesSeleccionado) {
                const partes = mesSeleccionado.toLowerCase().split('-');
                const mes = partes[0];
                const anio = '20' + partes[1];
                const mesNum = mesesIndex[mes];
                if (mesNum) {
                    const datePrefix = `${anio}-${mesNum}`;
                    $e73bf42412feb220$var$app.gridApi.setGridOption('quickFilterText', datePrefix);
                    // Filtrar summary cards al mes seleccionado
                    const filtered = $e73bf42412feb220$var$app.rowData.filter((r)=>r.fecha && r.fecha.startsWith(datePrefix));
                    $e73bf42412feb220$var$Summary.update(filtered);
                }
            } else {
                $e73bf42412feb220$var$app.gridApi.setGridOption('quickFilterText', '');
                // Summary con todos los registros
                $e73bf42412feb220$var$Summary.update($e73bf42412feb220$var$app.rowData);
            }
        });
    }
}
const $e73bf42412feb220$var$app = new $e73bf42412feb220$var$App();
var $a99b1c90995f445f$exports = {};
$a99b1c90995f445f$exports = import.meta.resolve("czWhb");


if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register($a99b1c90995f445f$exports).catch(()=>{});
});
$e73bf42412feb220$var$app.init();


//# sourceMappingURL=app.af0a66d7.js.map
